/**
 * @file src/generated/graphql.ts
 * @exports generated GraphQL types and operations
 * @summary Generated GraphQL schema types and operations including API key purpose classification.
 */
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useFetchData } from 'src/graphql/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** GraphQL Scalar representing the Prisma Bytes type as a base64 string. */
  Byte: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AddBiometricConsentAcceptanceResponse = {
  __typename?: 'AddBiometricConsentAcceptanceResponse';
  fileId: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  addressLineOne: Scalars['String']['output'];
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  applicantDataId?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  identificationDocumentId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  passportId?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  stateIdentificationCardId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AddressTypeEnum>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type AddressCreateInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutAddressesInput>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutAddressInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutAddressInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutAddressInput>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateManyApplicantDataInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyApplicantDataInputEnvelope = {
  data: Array<AddressCreateManyApplicantDataInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateManyOrganizationInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyOrganizationInputEnvelope = {
  data: Array<AddressCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateManyUserInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateManyUserInputEnvelope = {
  data: Array<AddressCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateNestedManyWithoutApplicantDataInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutApplicantDataInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutApplicantDataInput>>;
  createMany?: InputMaybe<AddressCreateManyApplicantDataInputEnvelope>;
};

export type AddressCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<AddressCreateManyOrganizationInputEnvelope>;
};

export type AddressCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutUserInput>>;
  createMany?: InputMaybe<AddressCreateManyUserInputEnvelope>;
};

export type AddressCreateNestedOneWithoutIdentificationDocumentInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutIdentificationDocumentInput>;
  create?: InputMaybe<AddressCreateWithoutIdentificationDocumentInput>;
};

export type AddressCreateNestedOneWithoutPassportInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutPassportInput>;
  create?: InputMaybe<AddressCreateWithoutPassportInput>;
};

export type AddressCreateNestedOneWithoutStateIdentificationCardInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutStateIdentificationCardInput>;
  create?: InputMaybe<AddressCreateWithoutStateIdentificationCardInput>;
};

export type AddressCreateOrConnectWithoutApplicantDataInput = {
  create: AddressCreateWithoutApplicantDataInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutIdentificationDocumentInput = {
  create: AddressCreateWithoutIdentificationDocumentInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutOrganizationInput = {
  create: AddressCreateWithoutOrganizationInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutPassportInput = {
  create: AddressCreateWithoutPassportInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutStateIdentificationCardInput = {
  create: AddressCreateWithoutStateIdentificationCardInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutUserInput = {
  create: AddressCreateWithoutUserInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutApplicantDataInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutAddressInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutAddressInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutAddressInput>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateWithoutIdentificationDocumentInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutAddressesInput>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutAddressInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutAddressInput>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateWithoutOrganizationInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutAddressesInput>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutAddressInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutAddressInput>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateWithoutPassportInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutAddressesInput>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutAddressInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutAddressInput>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateWithoutStateIdentificationCardInput = {
  User?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutAddressesInput>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutAddressInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutAddressInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressCreateWithoutUserInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutAddressesInput>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutAddressInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutAddressInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutAddressInput>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutAddressInput>;
  type?: InputMaybe<AddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AddressListRelationFilter = {
  every?: InputMaybe<AddressWhereInput>;
  none?: InputMaybe<AddressWhereInput>;
  some?: InputMaybe<AddressWhereInput>;
};

export type AddressNullableScalarRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export type AddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  User?: InputMaybe<UserOrderByWithRelationInput>;
  addressLineOne?: InputMaybe<SortOrder>;
  addressLineTwo?: InputMaybe<SortOrderInput>;
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantDataId?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identificationDocument?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentId?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  passport?: InputMaybe<PassportOrderByWithRelationInput>;
  passportId?: InputMaybe<SortOrderInput>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum AddressScalarFieldEnum {
  AddressLineOne = 'addressLineOne',
  AddressLineTwo = 'addressLineTwo',
  ApplicantDataId = 'applicantDataId',
  City = 'city',
  Country = 'country',
  CreatedAt = 'createdAt',
  Id = 'id',
  IdentificationDocumentId = 'identificationDocumentId',
  OrganizationId = 'organizationId',
  PassportId = 'passportId',
  PostalCode = 'postalCode',
  State = 'state',
  StateIdentificationCardId = 'stateIdentificationCardId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type AddressScalarWhereInput = {
  AND?: InputMaybe<Array<AddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereInput>>;
  addressLineOne?: InputMaybe<StringFilter>;
  addressLineTwo?: InputMaybe<StringNullableFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  postalCode?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAddressTypeEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export enum AddressTypeEnum {
  Former = 'FORMER',
  Manual = 'MANUAL',
  Primary = 'PRIMARY'
}

export type AddressUpdateInput = {
  User?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutAddressesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutAddressNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutAddressNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutAddressNestedInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateManyMutationInput = {
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateManyWithWhereWithoutApplicantDataInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithWhereWithoutOrganizationInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithWhereWithoutUserInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutApplicantDataInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutApplicantDataInput>>;
  createMany?: InputMaybe<AddressCreateManyApplicantDataInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutApplicantDataInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutApplicantDataInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutApplicantDataInput>>;
};

export type AddressUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<AddressCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type AddressUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutUserInput>>;
  createMany?: InputMaybe<AddressCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AddressUpdateOneWithoutIdentificationDocumentNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutIdentificationDocumentInput>;
  create?: InputMaybe<AddressCreateWithoutIdentificationDocumentInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutIdentificationDocumentInput>;
  upsert?: InputMaybe<AddressUpsertWithoutIdentificationDocumentInput>;
};

export type AddressUpdateOneWithoutPassportNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutPassportInput>;
  create?: InputMaybe<AddressCreateWithoutPassportInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutPassportInput>;
  upsert?: InputMaybe<AddressUpsertWithoutPassportInput>;
};

export type AddressUpdateOneWithoutStateIdentificationCardNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutStateIdentificationCardInput>;
  create?: InputMaybe<AddressCreateWithoutStateIdentificationCardInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutStateIdentificationCardInput>;
  upsert?: InputMaybe<AddressUpsertWithoutStateIdentificationCardInput>;
};

export type AddressUpdateToOneWithWhereWithoutIdentificationDocumentInput = {
  data: AddressUpdateWithoutIdentificationDocumentInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutPassportInput = {
  data: AddressUpdateWithoutPassportInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutStateIdentificationCardInput = {
  data: AddressUpdateWithoutStateIdentificationCardInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateWithWhereUniqueWithoutApplicantDataInput = {
  data: AddressUpdateWithoutApplicantDataInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: AddressUpdateWithoutOrganizationInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithWhereUniqueWithoutUserInput = {
  data: AddressUpdateWithoutUserInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithoutApplicantDataInput = {
  User?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutAddressNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutAddressNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutAddressNestedInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutIdentificationDocumentInput = {
  User?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutAddressesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutAddressNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutAddressNestedInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutOrganizationInput = {
  User?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutAddressesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutAddressNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutAddressNestedInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutPassportInput = {
  User?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutAddressesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutAddressNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutAddressNestedInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutStateIdentificationCardInput = {
  User?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutAddressesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutAddressNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutAddressNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutUserInput = {
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutAddressesNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutAddressNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutAddressNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutAddressNestedInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutAddressNestedInput>;
  type?: InputMaybe<NullableEnumAddressTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpsertWithWhereUniqueWithoutApplicantDataInput = {
  create: AddressCreateWithoutApplicantDataInput;
  update: AddressUpdateWithoutApplicantDataInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: AddressCreateWithoutOrganizationInput;
  update: AddressUpdateWithoutOrganizationInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithWhereUniqueWithoutUserInput = {
  create: AddressCreateWithoutUserInput;
  update: AddressUpdateWithoutUserInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithoutIdentificationDocumentInput = {
  create: AddressCreateWithoutIdentificationDocumentInput;
  update: AddressUpdateWithoutIdentificationDocumentInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutPassportInput = {
  create: AddressCreateWithoutPassportInput;
  update: AddressUpdateWithoutPassportInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutStateIdentificationCardInput = {
  create: AddressCreateWithoutStateIdentificationCardInput;
  update: AddressUpdateWithoutStateIdentificationCardInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  User?: InputMaybe<UserNullableScalarRelationFilter>;
  addressLineOne?: InputMaybe<StringFilter>;
  addressLineTwo?: InputMaybe<StringNullableFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  postalCode?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAddressTypeEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  User?: InputMaybe<UserNullableScalarRelationFilter>;
  addressLineOne?: InputMaybe<StringFilter>;
  addressLineTwo?: InputMaybe<StringNullableFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressTypeEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int']['output'];
};

export type AggregateAppFeedback = {
  __typename?: 'AggregateAppFeedback';
  _count?: Maybe<AppFeedbackCountAggregate>;
  _max?: Maybe<AppFeedbackMaxAggregate>;
  _min?: Maybe<AppFeedbackMinAggregate>;
};

export type AggregateAuditLog = {
  __typename?: 'AggregateAuditLog';
  _count?: Maybe<AuditLogCountAggregate>;
  _max?: Maybe<AuditLogMaxAggregate>;
  _min?: Maybe<AuditLogMinAggregate>;
};

export type AggregateBeamInput = {
  __typename?: 'AggregateBeamInput';
  _count?: Maybe<BeamInputCountAggregate>;
  _max?: Maybe<BeamInputMaxAggregate>;
  _min?: Maybe<BeamInputMinAggregate>;
};

export type AggregateDisclosure = {
  __typename?: 'AggregateDisclosure';
  _count?: Maybe<DisclosureCountAggregate>;
  _max?: Maybe<DisclosureMaxAggregate>;
  _min?: Maybe<DisclosureMinAggregate>;
};

export type AggregateDispute = {
  __typename?: 'AggregateDispute';
  _count?: Maybe<DisputeCountAggregate>;
  _max?: Maybe<DisputeMaxAggregate>;
  _min?: Maybe<DisputeMinAggregate>;
};

export type AggregateJob = {
  __typename?: 'AggregateJob';
  _count?: Maybe<JobCountAggregate>;
  _max?: Maybe<JobMaxAggregate>;
  _min?: Maybe<JobMinAggregate>;
};

export type AggregateMonitoringConfiguration = {
  __typename?: 'AggregateMonitoringConfiguration';
  _avg?: Maybe<MonitoringConfigurationAvgAggregate>;
  _count?: Maybe<MonitoringConfigurationCountAggregate>;
  _max?: Maybe<MonitoringConfigurationMaxAggregate>;
  _min?: Maybe<MonitoringConfigurationMinAggregate>;
  _sum?: Maybe<MonitoringConfigurationSumAggregate>;
};

export type AggregateMonitoringCycle = {
  __typename?: 'AggregateMonitoringCycle';
  _avg?: Maybe<MonitoringCycleAvgAggregate>;
  _count?: Maybe<MonitoringCycleCountAggregate>;
  _max?: Maybe<MonitoringCycleMaxAggregate>;
  _min?: Maybe<MonitoringCycleMinAggregate>;
  _sum?: Maybe<MonitoringCycleSumAggregate>;
};

export type AggregateMonitoringDelta = {
  __typename?: 'AggregateMonitoringDelta';
  _count?: Maybe<MonitoringDeltaCountAggregate>;
  _max?: Maybe<MonitoringDeltaMaxAggregate>;
  _min?: Maybe<MonitoringDeltaMinAggregate>;
};

export type AggregateMonitoringEnrollment = {
  __typename?: 'AggregateMonitoringEnrollment';
  _count?: Maybe<MonitoringEnrollmentCountAggregate>;
  _max?: Maybe<MonitoringEnrollmentMaxAggregate>;
  _min?: Maybe<MonitoringEnrollmentMinAggregate>;
};

export type AggregateMonitoringReport = {
  __typename?: 'AggregateMonitoringReport';
  _count?: Maybe<MonitoringReportCountAggregate>;
  _max?: Maybe<MonitoringReportMaxAggregate>;
  _min?: Maybe<MonitoringReportMinAggregate>;
};

export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
};

export type AggregateOrganization = {
  __typename?: 'AggregateOrganization';
  _count?: Maybe<OrganizationCountAggregate>;
  _max?: Maybe<OrganizationMaxAggregate>;
  _min?: Maybe<OrganizationMinAggregate>;
};

export type AggregatePackageAccess = {
  __typename?: 'AggregatePackageAccess';
  _count?: Maybe<PackageAccessCountAggregate>;
  _max?: Maybe<PackageAccessMaxAggregate>;
  _min?: Maybe<PackageAccessMinAggregate>;
};

export type AggregatePackageSet = {
  __typename?: 'AggregatePackageSet';
  _avg?: Maybe<PackageSetAvgAggregate>;
  _count?: Maybe<PackageSetCountAggregate>;
  _max?: Maybe<PackageSetMaxAggregate>;
  _min?: Maybe<PackageSetMinAggregate>;
  _sum?: Maybe<PackageSetSumAggregate>;
};

export type AggregateUser = {
  __typename?: 'AggregateUser';
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
};

export type AggregateVidVoucher = {
  __typename?: 'AggregateVIDVoucher';
  _count?: Maybe<VidVoucherCountAggregate>;
  _max?: Maybe<VidVoucherMaxAggregate>;
  _min?: Maybe<VidVoucherMinAggregate>;
};

export enum ApiKeyPurpose {
  General = 'GENERAL',
  OneAndDone = 'ONE_AND_DONE'
}

export type EnumApiKeyPurposeFilter = {
  equals?: InputMaybe<ApiKeyPurpose>;
  in?: InputMaybe<Array<ApiKeyPurpose>>;
  not?: InputMaybe<NestedEnumApiKeyPurposeFilter>;
  notIn?: InputMaybe<Array<ApiKeyPurpose>>;
};

export type NestedEnumApiKeyPurposeFilter = {
  equals?: InputMaybe<ApiKeyPurpose>;
  in?: InputMaybe<Array<ApiKeyPurpose>>;
  not?: InputMaybe<NestedEnumApiKeyPurposeFilter>;
  notIn?: InputMaybe<Array<ApiKeyPurpose>>;
};

export type EnumApiKeyPurposeFieldUpdateOperationsInput = {
  set?: InputMaybe<ApiKeyPurpose>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  _count?: Maybe<ApiKeyCount>;
  apiKeyVerifications: Array<ApiKeyVerification>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  expireOnOrder: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  prefix: Scalars['String']['output'];
  purpose: ApiKeyPurpose;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<VidVoucher>;
  voucherId?: Maybe<Scalars['String']['output']>;
};


export type ApiKeyApiKeyVerificationsArgs = {
  cursor?: InputMaybe<ApiKeyVerificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyVerificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyVerificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyVerificationWhereInput>;
};


export type ApiKeyUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type ApiKeyVoucherArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type ApiKeyCount = {
  __typename?: 'ApiKeyCount';
  apiKeyVerifications: Scalars['Int']['output'];
};


export type ApiKeyCountApiKeyVerificationsArgs = {
  where?: InputMaybe<ApiKeyVerificationWhereInput>;
};

export type ApiKeyCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix: Scalars['String']['input'];
  purpose?: InputMaybe<ApiKeyPurpose>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCreateManyUserInputEnvelope = {
  data: Array<ApiKeyCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeyCreateManyVoucherInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix: Scalars['String']['input'];
  purpose?: InputMaybe<ApiKeyPurpose>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCreateManyVoucherInputEnvelope = {
  data: Array<ApiKeyCreateManyVoucherInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeyCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyUserInputEnvelope>;
};

export type ApiKeyCreateNestedManyWithoutVoucherInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutVoucherInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutVoucherInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyVoucherInputEnvelope>;
};

export type ApiKeyCreateNestedOneWithoutApiKeyVerificationsInput = {
  connect?: InputMaybe<ApiKeyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApiKeyCreateOrConnectWithoutApiKeyVerificationsInput>;
  create?: InputMaybe<ApiKeyCreateWithoutApiKeyVerificationsInput>;
};

export type ApiKeyCreateOrConnectWithoutApiKeyVerificationsInput = {
  create: ApiKeyCreateWithoutApiKeyVerificationsInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateOrConnectWithoutUserInput = {
  create: ApiKeyCreateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateOrConnectWithoutVoucherInput = {
  create: ApiKeyCreateWithoutVoucherInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateWithoutApiKeyVerificationsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix: Scalars['String']['input'];
  purpose?: InputMaybe<ApiKeyPurpose>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutApiKeysInput>;
  voucher?: InputMaybe<VidVoucherCreateNestedOneWithoutApiKeysInput>;
};

export type ApiKeyCreateWithoutUserInput = {
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutApiKeyInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix: Scalars['String']['input'];
  purpose?: InputMaybe<ApiKeyPurpose>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  voucher?: InputMaybe<VidVoucherCreateNestedOneWithoutApiKeysInput>;
};

export type ApiKeyCreateWithoutVoucherInput = {
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutApiKeyInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix: Scalars['String']['input'];
  purpose?: InputMaybe<ApiKeyPurpose>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutApiKeysInput>;
};

export type ApiKeyListRelationFilter = {
  every?: InputMaybe<ApiKeyWhereInput>;
  none?: InputMaybe<ApiKeyWhereInput>;
  some?: InputMaybe<ApiKeyWhereInput>;
};

export type ApiKeyLockResponse = {
  __typename?: 'ApiKeyLockResponse';
  apiKeyLocked?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApiKeyOrderByWithRelationInput = {
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  expireOnOrder?: InputMaybe<SortOrder>;
  expiryDate?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  locked?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrderInput>;
  prefix?: InputMaybe<SortOrder>;
  purpose?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  voucher?: InputMaybe<VidVoucherOrderByWithRelationInput>;
  voucherId?: InputMaybe<SortOrderInput>;
};

export enum ApiKeyScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  ExpireOnOrder = 'expireOnOrder',
  ExpiryDate = 'expiryDate',
  Id = 'id',
  Key = 'key',
  Locked = 'locked',
  Name = 'name',
  Permissions = 'permissions',
  Prefix = 'prefix',
  Purpose = 'purpose',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  VoucherId = 'voucherId'
}

export type ApiKeyScalarRelationFilter = {
  is?: InputMaybe<ApiKeyWhereInput>;
  isNot?: InputMaybe<ApiKeyWhereInput>;
};

export type ApiKeyScalarWhereInput = {
  AND?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expireOnOrder?: InputMaybe<BoolFilter>;
  expiryDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  locked?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<JsonNullableFilter>;
  prefix?: InputMaybe<StringFilter>;
  purpose?: InputMaybe<EnumApiKeyPurposeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  voucherId?: InputMaybe<StringNullableFilter>;
};

export type ApiKeyUpdateInput = {
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutApiKeyNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expireOnOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  locked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumApiKeyPurposeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutApiKeysNestedInput>;
  voucher?: InputMaybe<VidVoucherUpdateOneWithoutApiKeysNestedInput>;
};

export type ApiKeyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expireOnOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  locked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumApiKeyPurposeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateManyWithWhereWithoutUserInput = {
  data: ApiKeyUpdateManyMutationInput;
  where: ApiKeyScalarWhereInput;
};

export type ApiKeyUpdateManyWithWhereWithoutVoucherInput = {
  data: ApiKeyUpdateManyMutationInput;
  where: ApiKeyScalarWhereInput;
};

export type ApiKeyUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiKeyUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ApiKeyUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ApiKeyUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ApiKeyUpdateManyWithoutVoucherNestedInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutVoucherInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutVoucherInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyVoucherInputEnvelope>;
  delete?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiKeyUpdateWithWhereUniqueWithoutVoucherInput>>;
  updateMany?: InputMaybe<Array<ApiKeyUpdateManyWithWhereWithoutVoucherInput>>;
  upsert?: InputMaybe<Array<ApiKeyUpsertWithWhereUniqueWithoutVoucherInput>>;
};

export type ApiKeyUpdateOneRequiredWithoutApiKeyVerificationsNestedInput = {
  connect?: InputMaybe<ApiKeyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApiKeyCreateOrConnectWithoutApiKeyVerificationsInput>;
  create?: InputMaybe<ApiKeyCreateWithoutApiKeyVerificationsInput>;
  update?: InputMaybe<ApiKeyUpdateToOneWithWhereWithoutApiKeyVerificationsInput>;
  upsert?: InputMaybe<ApiKeyUpsertWithoutApiKeyVerificationsInput>;
};

export type ApiKeyUpdateToOneWithWhereWithoutApiKeyVerificationsInput = {
  data: ApiKeyUpdateWithoutApiKeyVerificationsInput;
  where?: InputMaybe<ApiKeyWhereInput>;
};

export type ApiKeyUpdateWithWhereUniqueWithoutUserInput = {
  data: ApiKeyUpdateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpdateWithWhereUniqueWithoutVoucherInput = {
  data: ApiKeyUpdateWithoutVoucherInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpdateWithoutApiKeyVerificationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expireOnOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  locked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumApiKeyPurposeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutApiKeysNestedInput>;
  voucher?: InputMaybe<VidVoucherUpdateOneWithoutApiKeysNestedInput>;
};

export type ApiKeyUpdateWithoutUserInput = {
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutApiKeyNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expireOnOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  locked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumApiKeyPurposeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voucher?: InputMaybe<VidVoucherUpdateOneWithoutApiKeysNestedInput>;
};

export type ApiKeyUpdateWithoutVoucherInput = {
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutApiKeyNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  expireOnOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  locked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  prefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<EnumApiKeyPurposeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutApiKeysNestedInput>;
};

export type ApiKeyUpsertWithWhereUniqueWithoutUserInput = {
  create: ApiKeyCreateWithoutUserInput;
  update: ApiKeyUpdateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpsertWithWhereUniqueWithoutVoucherInput = {
  create: ApiKeyCreateWithoutVoucherInput;
  update: ApiKeyUpdateWithoutVoucherInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpsertWithoutApiKeyVerificationsInput = {
  create: ApiKeyCreateWithoutApiKeyVerificationsInput;
  update: ApiKeyUpdateWithoutApiKeyVerificationsInput;
  where?: InputMaybe<ApiKeyWhereInput>;
};

export type ApiKeyVerification = {
  __typename?: 'ApiKeyVerification';
  apiKeyId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  status: ApiKeyVerificationStatusEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type ApiKeyVerificationCreateManyApiKeyInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status: ApiKeyVerificationStatusEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type ApiKeyVerificationCreateManyApiKeyInputEnvelope = {
  data: Array<ApiKeyVerificationCreateManyApiKeyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeyVerificationCreateManyUserInput = {
  apiKeyId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status: ApiKeyVerificationStatusEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApiKeyVerificationCreateManyUserInputEnvelope = {
  data: Array<ApiKeyVerificationCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeyVerificationCreateNestedManyWithoutApiKeyInput = {
  connect?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyVerificationCreateOrConnectWithoutApiKeyInput>>;
  create?: InputMaybe<Array<ApiKeyVerificationCreateWithoutApiKeyInput>>;
  createMany?: InputMaybe<ApiKeyVerificationCreateManyApiKeyInputEnvelope>;
};

export type ApiKeyVerificationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyVerificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApiKeyVerificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApiKeyVerificationCreateManyUserInputEnvelope>;
};

export type ApiKeyVerificationCreateOrConnectWithoutApiKeyInput = {
  create: ApiKeyVerificationCreateWithoutApiKeyInput;
  where: ApiKeyVerificationWhereUniqueInput;
};

export type ApiKeyVerificationCreateOrConnectWithoutUserInput = {
  create: ApiKeyVerificationCreateWithoutUserInput;
  where: ApiKeyVerificationWhereUniqueInput;
};

export type ApiKeyVerificationCreateWithoutApiKeyInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status: ApiKeyVerificationStatusEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutApiKeyVerificationsInput;
};

export type ApiKeyVerificationCreateWithoutUserInput = {
  apiKey: ApiKeyCreateNestedOneWithoutApiKeyVerificationsInput;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status: ApiKeyVerificationStatusEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApiKeyVerificationListRelationFilter = {
  every?: InputMaybe<ApiKeyVerificationWhereInput>;
  none?: InputMaybe<ApiKeyVerificationWhereInput>;
  some?: InputMaybe<ApiKeyVerificationWhereInput>;
};

export type ApiKeyVerificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApiKeyVerificationOrderByWithRelationInput = {
  apiKey?: InputMaybe<ApiKeyOrderByWithRelationInput>;
  apiKeyId?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ApiKeyVerificationScalarFieldEnum {
  ApiKeyId = 'apiKeyId',
  Code = 'code',
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ApiKeyVerificationScalarWhereInput = {
  AND?: InputMaybe<Array<ApiKeyVerificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyVerificationScalarWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyVerificationScalarWhereInput>>;
  apiKeyId?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumApiKeyVerificationStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum ApiKeyVerificationStatusEnum {
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type ApiKeyVerificationUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiKeyVerificationStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApiKeyVerificationUpdateManyWithWhereWithoutApiKeyInput = {
  data: ApiKeyVerificationUpdateManyMutationInput;
  where: ApiKeyVerificationScalarWhereInput;
};

export type ApiKeyVerificationUpdateManyWithWhereWithoutUserInput = {
  data: ApiKeyVerificationUpdateManyMutationInput;
  where: ApiKeyVerificationScalarWhereInput;
};

export type ApiKeyVerificationUpdateManyWithoutApiKeyNestedInput = {
  connect?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyVerificationCreateOrConnectWithoutApiKeyInput>>;
  create?: InputMaybe<Array<ApiKeyVerificationCreateWithoutApiKeyInput>>;
  createMany?: InputMaybe<ApiKeyVerificationCreateManyApiKeyInputEnvelope>;
  delete?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiKeyVerificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiKeyVerificationUpdateWithWhereUniqueWithoutApiKeyInput>>;
  updateMany?: InputMaybe<Array<ApiKeyVerificationUpdateManyWithWhereWithoutApiKeyInput>>;
  upsert?: InputMaybe<Array<ApiKeyVerificationUpsertWithWhereUniqueWithoutApiKeyInput>>;
};

export type ApiKeyVerificationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyVerificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApiKeyVerificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApiKeyVerificationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiKeyVerificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiKeyVerificationWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiKeyVerificationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ApiKeyVerificationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ApiKeyVerificationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ApiKeyVerificationUpdateWithWhereUniqueWithoutApiKeyInput = {
  data: ApiKeyVerificationUpdateWithoutApiKeyInput;
  where: ApiKeyVerificationWhereUniqueInput;
};

export type ApiKeyVerificationUpdateWithWhereUniqueWithoutUserInput = {
  data: ApiKeyVerificationUpdateWithoutUserInput;
  where: ApiKeyVerificationWhereUniqueInput;
};

export type ApiKeyVerificationUpdateWithoutApiKeyInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiKeyVerificationStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutApiKeyVerificationsNestedInput>;
};

export type ApiKeyVerificationUpdateWithoutUserInput = {
  apiKey?: InputMaybe<ApiKeyUpdateOneRequiredWithoutApiKeyVerificationsNestedInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiKeyVerificationStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApiKeyVerificationUpsertWithWhereUniqueWithoutApiKeyInput = {
  create: ApiKeyVerificationCreateWithoutApiKeyInput;
  update: ApiKeyVerificationUpdateWithoutApiKeyInput;
  where: ApiKeyVerificationWhereUniqueInput;
};

export type ApiKeyVerificationUpsertWithWhereUniqueWithoutUserInput = {
  create: ApiKeyVerificationCreateWithoutUserInput;
  update: ApiKeyVerificationUpdateWithoutUserInput;
  where: ApiKeyVerificationWhereUniqueInput;
};

export type ApiKeyVerificationWhereInput = {
  AND?: InputMaybe<Array<ApiKeyVerificationWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyVerificationWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyVerificationWhereInput>>;
  apiKey?: InputMaybe<ApiKeyScalarRelationFilter>;
  apiKeyId?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumApiKeyVerificationStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ApiKeyVerificationWhereUniqueInput = {
  AND?: InputMaybe<Array<ApiKeyVerificationWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyVerificationWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyVerificationWhereInput>>;
  apiKey?: InputMaybe<ApiKeyScalarRelationFilter>;
  apiKeyId?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumApiKeyVerificationStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ApiKeyWhereInput = {
  AND?: InputMaybe<Array<ApiKeyWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyWhereInput>>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expireOnOrder?: InputMaybe<BoolFilter>;
  expiryDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  locked?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<JsonNullableFilter>;
  prefix?: InputMaybe<StringFilter>;
  purpose?: InputMaybe<EnumApiKeyPurposeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  voucher?: InputMaybe<VidVoucherNullableScalarRelationFilter>;
  voucherId?: InputMaybe<StringNullableFilter>;
};

export type ApiKeyWhereUniqueInput = {
  AND?: InputMaybe<Array<ApiKeyWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyWhereInput>>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expireOnOrder?: InputMaybe<BoolFilter>;
  expiryDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<JsonNullableFilter>;
  prefix?: InputMaybe<StringFilter>;
  purpose?: InputMaybe<EnumApiKeyPurposeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  voucher?: InputMaybe<VidVoucherNullableScalarRelationFilter>;
  voucherId?: InputMaybe<StringNullableFilter>;
};

export type AppFeedback = {
  __typename?: 'AppFeedback';
  appVersion: Scalars['String']['output'];
  browser?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deviceType: DeviceTypeEnum;
  feedback: Scalars['String']['output'];
  id: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  status: AppFeedbackStatusEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type AppFeedbackOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type AppFeedbackCountAggregate = {
  __typename?: 'AppFeedbackCountAggregate';
  _all: Scalars['Int']['output'];
  appVersion: Scalars['Int']['output'];
  browser: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deviceType: Scalars['Int']['output'];
  feedback: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  os: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type AppFeedbackCreateInput = {
  appVersion: Scalars['String']['input'];
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceType: DeviceTypeEnum;
  feedback: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutAppFeedbackInput>;
  os?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AppFeedbackStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutAppFeedbacksInput;
};

export type AppFeedbackCreateManyUserInput = {
  appVersion: Scalars['String']['input'];
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceType: DeviceTypeEnum;
  feedback: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AppFeedbackStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AppFeedbackCreateManyUserInputEnvelope = {
  data: Array<AppFeedbackCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppFeedbackCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AppFeedbackWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AppFeedbackCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AppFeedbackCreateWithoutUserInput>>;
  createMany?: InputMaybe<AppFeedbackCreateManyUserInputEnvelope>;
};

export type AppFeedbackCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<AppFeedbackWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AppFeedbackCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<AppFeedbackCreateWithoutOrderInput>;
};

export type AppFeedbackCreateOrConnectWithoutOrderInput = {
  create: AppFeedbackCreateWithoutOrderInput;
  where: AppFeedbackWhereUniqueInput;
};

export type AppFeedbackCreateOrConnectWithoutUserInput = {
  create: AppFeedbackCreateWithoutUserInput;
  where: AppFeedbackWhereUniqueInput;
};

export type AppFeedbackCreateWithoutOrderInput = {
  appVersion: Scalars['String']['input'];
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceType: DeviceTypeEnum;
  feedback: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AppFeedbackStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutAppFeedbacksInput;
};

export type AppFeedbackCreateWithoutUserInput = {
  appVersion: Scalars['String']['input'];
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceType: DeviceTypeEnum;
  feedback: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutAppFeedbackInput>;
  os?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AppFeedbackStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type AppFeedbackListRelationFilter = {
  every?: InputMaybe<AppFeedbackWhereInput>;
  none?: InputMaybe<AppFeedbackWhereInput>;
  some?: InputMaybe<AppFeedbackWhereInput>;
};

export type AppFeedbackMaxAggregate = {
  __typename?: 'AppFeedbackMaxAggregate';
  appVersion?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deviceType?: Maybe<DeviceTypeEnum>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AppFeedbackStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AppFeedbackMinAggregate = {
  __typename?: 'AppFeedbackMinAggregate';
  appVersion?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deviceType?: Maybe<DeviceTypeEnum>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AppFeedbackStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AppFeedbackNullableScalarRelationFilter = {
  is?: InputMaybe<AppFeedbackWhereInput>;
  isNot?: InputMaybe<AppFeedbackWhereInput>;
};

export type AppFeedbackOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AppFeedbackOrderByWithRelationInput = {
  appVersion?: InputMaybe<SortOrder>;
  browser?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrder>;
  feedback?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  os?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum AppFeedbackScalarFieldEnum {
  AppVersion = 'appVersion',
  Browser = 'browser',
  CreatedAt = 'createdAt',
  DeviceType = 'deviceType',
  Feedback = 'feedback',
  Id = 'id',
  OrderId = 'orderId',
  Os = 'os',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type AppFeedbackScalarWhereInput = {
  AND?: InputMaybe<Array<AppFeedbackScalarWhereInput>>;
  NOT?: InputMaybe<Array<AppFeedbackScalarWhereInput>>;
  OR?: InputMaybe<Array<AppFeedbackScalarWhereInput>>;
  appVersion?: InputMaybe<StringFilter>;
  browser?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFilter>;
  feedback?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  os?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum AppFeedbackStatusEnum {
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Reviewed = 'REVIEWED'
}

export type AppFeedbackUpdateInput = {
  appVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  browser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFieldUpdateOperationsInput>;
  feedback?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutAppFeedbackNestedInput>;
  os?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAppFeedbacksNestedInput>;
};

export type AppFeedbackUpdateManyMutationInput = {
  appVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  browser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFieldUpdateOperationsInput>;
  feedback?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  os?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AppFeedbackUpdateManyWithWhereWithoutUserInput = {
  data: AppFeedbackUpdateManyMutationInput;
  where: AppFeedbackScalarWhereInput;
};

export type AppFeedbackUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AppFeedbackWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AppFeedbackCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AppFeedbackCreateWithoutUserInput>>;
  createMany?: InputMaybe<AppFeedbackCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AppFeedbackWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AppFeedbackScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AppFeedbackWhereUniqueInput>>;
  set?: InputMaybe<Array<AppFeedbackWhereUniqueInput>>;
  update?: InputMaybe<Array<AppFeedbackUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AppFeedbackUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AppFeedbackUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AppFeedbackUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<AppFeedbackWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AppFeedbackCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<AppFeedbackCreateWithoutOrderInput>;
  delete?: InputMaybe<AppFeedbackWhereInput>;
  disconnect?: InputMaybe<AppFeedbackWhereInput>;
  update?: InputMaybe<AppFeedbackUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<AppFeedbackUpsertWithoutOrderInput>;
};

export type AppFeedbackUpdateToOneWithWhereWithoutOrderInput = {
  data: AppFeedbackUpdateWithoutOrderInput;
  where?: InputMaybe<AppFeedbackWhereInput>;
};

export type AppFeedbackUpdateWithWhereUniqueWithoutUserInput = {
  data: AppFeedbackUpdateWithoutUserInput;
  where: AppFeedbackWhereUniqueInput;
};

export type AppFeedbackUpdateWithoutOrderInput = {
  appVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  browser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFieldUpdateOperationsInput>;
  feedback?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  os?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAppFeedbacksNestedInput>;
};

export type AppFeedbackUpdateWithoutUserInput = {
  appVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  browser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFieldUpdateOperationsInput>;
  feedback?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutAppFeedbackNestedInput>;
  os?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AppFeedbackUpsertWithWhereUniqueWithoutUserInput = {
  create: AppFeedbackCreateWithoutUserInput;
  update: AppFeedbackUpdateWithoutUserInput;
  where: AppFeedbackWhereUniqueInput;
};

export type AppFeedbackUpsertWithoutOrderInput = {
  create: AppFeedbackCreateWithoutOrderInput;
  update: AppFeedbackUpdateWithoutOrderInput;
  where?: InputMaybe<AppFeedbackWhereInput>;
};

export type AppFeedbackWhereInput = {
  AND?: InputMaybe<Array<AppFeedbackWhereInput>>;
  NOT?: InputMaybe<Array<AppFeedbackWhereInput>>;
  OR?: InputMaybe<Array<AppFeedbackWhereInput>>;
  appVersion?: InputMaybe<StringFilter>;
  browser?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFilter>;
  feedback?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  os?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AppFeedbackWhereUniqueInput = {
  AND?: InputMaybe<Array<AppFeedbackWhereInput>>;
  NOT?: InputMaybe<Array<AppFeedbackWhereInput>>;
  OR?: InputMaybe<Array<AppFeedbackWhereInput>>;
  appVersion?: InputMaybe<StringFilter>;
  browser?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumFilter>;
  feedback?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumAppFeedbackStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ApplicantData = {
  __typename?: 'ApplicantData';
  _count?: Maybe<ApplicantDataCount>;
  addresses: Array<Address>;
  applicantIDCard?: Maybe<ApplicantIdCard>;
  applicantIDCardId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationDocument?: Maybe<IdentificationDocument>;
  legacySSN: Scalars['String']['output'];
  names: Array<Name>;
  order: Order;
  orderId: Scalars['String']['output'];
  passport?: Maybe<Passport>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reportableIdVerificationResult?: Maybe<ReportableIdVerificationResult>;
  ssn?: Maybe<HighlySensitiveIdentifier>;
  stateIdentificationCard?: Maybe<StateIdentificationCard>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type ApplicantDataAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type ApplicantDataApplicantIdCardArgs = {
  where?: InputMaybe<ApplicantIdCardWhereInput>;
};


export type ApplicantDataIdentificationDocumentArgs = {
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type ApplicantDataNamesArgs = {
  cursor?: InputMaybe<NameWhereUniqueInput>;
  distinct?: InputMaybe<Array<NameScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NameOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NameWhereInput>;
};


export type ApplicantDataPassportArgs = {
  where?: InputMaybe<PassportWhereInput>;
};


export type ApplicantDataReportableIdVerificationResultArgs = {
  where?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};


export type ApplicantDataSsnArgs = {
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};


export type ApplicantDataStateIdentificationCardArgs = {
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type ApplicantDataCount = {
  __typename?: 'ApplicantDataCount';
  addresses: Scalars['Int']['output'];
  names: Scalars['Int']['output'];
};


export type ApplicantDataCountAddressesArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type ApplicantDataCountNamesArgs = {
  where?: InputMaybe<NameWhereInput>;
};

export type ApplicantDataCreateInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateManyInput = {
  applicantIDCardId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacySSN: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutAddressesInput>;
};

export type ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutIdentificationDocumentInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutIdentificationDocumentInput>;
};

export type ApplicantDataCreateNestedOneWithoutNamesInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutNamesInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutNamesInput>;
};

export type ApplicantDataCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutOrderInput>;
};

export type ApplicantDataCreateNestedOneWithoutPassportInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutPassportInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutPassportInput>;
};

export type ApplicantDataCreateNestedOneWithoutReportableIdVerificationResultInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutReportableIdVerificationResultInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutReportableIdVerificationResultInput>;
};

export type ApplicantDataCreateNestedOneWithoutSsnInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutSsnInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutSsnInput>;
};

export type ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutStateIdentificationCardInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutStateIdentificationCardInput>;
};

export type ApplicantDataCreateOrConnectWithoutAddressesInput = {
  create: ApplicantDataCreateWithoutAddressesInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutIdentificationDocumentInput = {
  create: ApplicantDataCreateWithoutIdentificationDocumentInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutNamesInput = {
  create: ApplicantDataCreateWithoutNamesInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutOrderInput = {
  create: ApplicantDataCreateWithoutOrderInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutPassportInput = {
  create: ApplicantDataCreateWithoutPassportInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutReportableIdVerificationResultInput = {
  create: ApplicantDataCreateWithoutReportableIdVerificationResultInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutSsnInput = {
  create: ApplicantDataCreateWithoutSsnInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateOrConnectWithoutStateIdentificationCardInput = {
  create: ApplicantDataCreateWithoutStateIdentificationCardInput;
  where: ApplicantDataWhereUniqueInput;
};

export type ApplicantDataCreateWithoutAddressesInput = {
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutIdentificationDocumentInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutNamesInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutOrderInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutPassportInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutReportableIdVerificationResultInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutSsnInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataCreateWithoutStateIdentificationCardInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutApplicantDataInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardCreateNestedOneWithoutApplicantDataInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutApplicantDataInput>;
  legacySSN: Scalars['String']['input'];
  names?: InputMaybe<NameCreateNestedManyWithoutApplicantDataInput>;
  order: OrderCreateNestedOneWithoutApplicantDataInput;
  passport?: InputMaybe<PassportCreateNestedOneWithoutApplicantDataInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantDataNullableScalarRelationFilter = {
  is?: InputMaybe<ApplicantDataWhereInput>;
  isNot?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataOrderByWithRelationInput = {
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardOrderByWithRelationInput>;
  applicantIDCardId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identificationDocument?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  legacySSN?: InputMaybe<SortOrder>;
  names?: InputMaybe<NameOrderByRelationAggregateInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  passport?: InputMaybe<PassportOrderByWithRelationInput>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultOrderByWithRelationInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierOrderByWithRelationInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ApplicantDataUpdateInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateOneWithoutAddressesNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutAddressesInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutAddressesInput>;
};

export type ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutIdentificationDocumentInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutIdentificationDocumentInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutIdentificationDocumentInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutIdentificationDocumentInput>;
};

export type ApplicantDataUpdateOneWithoutNamesNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutNamesInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutNamesInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutNamesInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutNamesInput>;
};

export type ApplicantDataUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutOrderInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutOrderInput>;
};

export type ApplicantDataUpdateOneWithoutPassportNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutPassportInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutPassportInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutPassportInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutPassportInput>;
};

export type ApplicantDataUpdateOneWithoutReportableIdVerificationResultNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutReportableIdVerificationResultInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutReportableIdVerificationResultInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutReportableIdVerificationResultInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutReportableIdVerificationResultInput>;
};

export type ApplicantDataUpdateOneWithoutSsnNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutSsnInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutSsnInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutSsnInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutSsnInput>;
};

export type ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput = {
  connect?: InputMaybe<ApplicantDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantDataCreateOrConnectWithoutStateIdentificationCardInput>;
  create?: InputMaybe<ApplicantDataCreateWithoutStateIdentificationCardInput>;
  delete?: InputMaybe<ApplicantDataWhereInput>;
  disconnect?: InputMaybe<ApplicantDataWhereInput>;
  update?: InputMaybe<ApplicantDataUpdateToOneWithWhereWithoutStateIdentificationCardInput>;
  upsert?: InputMaybe<ApplicantDataUpsertWithoutStateIdentificationCardInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutAddressesInput = {
  data: ApplicantDataUpdateWithoutAddressesInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutIdentificationDocumentInput = {
  data: ApplicantDataUpdateWithoutIdentificationDocumentInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutNamesInput = {
  data: ApplicantDataUpdateWithoutNamesInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutOrderInput = {
  data: ApplicantDataUpdateWithoutOrderInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutPassportInput = {
  data: ApplicantDataUpdateWithoutPassportInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutReportableIdVerificationResultInput = {
  data: ApplicantDataUpdateWithoutReportableIdVerificationResultInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutSsnInput = {
  data: ApplicantDataUpdateWithoutSsnInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateToOneWithWhereWithoutStateIdentificationCardInput = {
  data: ApplicantDataUpdateWithoutStateIdentificationCardInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpdateWithoutAddressesInput = {
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutIdentificationDocumentInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutNamesInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutOrderInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutPassportInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutReportableIdVerificationResultInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutSsnInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpdateWithoutStateIdentificationCardInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutApplicantDataNestedInput>;
  applicantIDCard?: InputMaybe<ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput>;
  legacySSN?: InputMaybe<StringFieldUpdateOperationsInput>;
  names?: InputMaybe<NameUpdateManyWithoutApplicantDataNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutApplicantDataNestedInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutApplicantDataNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantDataUpsertWithoutAddressesInput = {
  create: ApplicantDataCreateWithoutAddressesInput;
  update: ApplicantDataUpdateWithoutAddressesInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutIdentificationDocumentInput = {
  create: ApplicantDataCreateWithoutIdentificationDocumentInput;
  update: ApplicantDataUpdateWithoutIdentificationDocumentInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutNamesInput = {
  create: ApplicantDataCreateWithoutNamesInput;
  update: ApplicantDataUpdateWithoutNamesInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutOrderInput = {
  create: ApplicantDataCreateWithoutOrderInput;
  update: ApplicantDataUpdateWithoutOrderInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutPassportInput = {
  create: ApplicantDataCreateWithoutPassportInput;
  update: ApplicantDataUpdateWithoutPassportInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutReportableIdVerificationResultInput = {
  create: ApplicantDataCreateWithoutReportableIdVerificationResultInput;
  update: ApplicantDataUpdateWithoutReportableIdVerificationResultInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutSsnInput = {
  create: ApplicantDataCreateWithoutSsnInput;
  update: ApplicantDataUpdateWithoutSsnInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataUpsertWithoutStateIdentificationCardInput = {
  create: ApplicantDataCreateWithoutStateIdentificationCardInput;
  update: ApplicantDataUpdateWithoutStateIdentificationCardInput;
  where?: InputMaybe<ApplicantDataWhereInput>;
};

export type ApplicantDataWhereInput = {
  AND?: InputMaybe<Array<ApplicantDataWhereInput>>;
  NOT?: InputMaybe<Array<ApplicantDataWhereInput>>;
  OR?: InputMaybe<Array<ApplicantDataWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  applicantIDCard?: InputMaybe<ApplicantIdCardNullableScalarRelationFilter>;
  applicantIDCardId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  legacySSN?: InputMaybe<StringFilter>;
  names?: InputMaybe<NameListRelationFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultNullableScalarRelationFilter>;
  ssn?: InputMaybe<HighlySensitiveIdentifierNullableScalarRelationFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ApplicantDataWhereUniqueInput = {
  AND?: InputMaybe<Array<ApplicantDataWhereInput>>;
  NOT?: InputMaybe<Array<ApplicantDataWhereInput>>;
  OR?: InputMaybe<Array<ApplicantDataWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  applicantIDCard?: InputMaybe<ApplicantIdCardNullableScalarRelationFilter>;
  applicantIDCardId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  legacySSN?: InputMaybe<StringFilter>;
  names?: InputMaybe<NameListRelationFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultNullableScalarRelationFilter>;
  ssn?: InputMaybe<HighlySensitiveIdentifierNullableScalarRelationFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ApplicantIdCard = {
  __typename?: 'ApplicantIDCard';
  county: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ApplicantIdCardCreateNestedOneWithoutApplicantDataInput = {
  connect?: InputMaybe<ApplicantIdCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantIdCardCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<ApplicantIdCardCreateWithoutApplicantDataInput>;
};

export type ApplicantIdCardCreateOrConnectWithoutApplicantDataInput = {
  create: ApplicantIdCardCreateWithoutApplicantDataInput;
  where: ApplicantIdCardWhereUniqueInput;
};

export type ApplicantIdCardCreateWithoutApplicantDataInput = {
  county: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ApplicantIdCardNullableScalarRelationFilter = {
  is?: InputMaybe<ApplicantIdCardWhereInput>;
  isNot?: InputMaybe<ApplicantIdCardWhereInput>;
};

export type ApplicantIdCardOrderByWithRelationInput = {
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  county?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ApplicantIdCardUpdateOneWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<ApplicantIdCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApplicantIdCardCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<ApplicantIdCardCreateWithoutApplicantDataInput>;
  delete?: InputMaybe<ApplicantIdCardWhereInput>;
  disconnect?: InputMaybe<ApplicantIdCardWhereInput>;
  update?: InputMaybe<ApplicantIdCardUpdateToOneWithWhereWithoutApplicantDataInput>;
  upsert?: InputMaybe<ApplicantIdCardUpsertWithoutApplicantDataInput>;
};

export type ApplicantIdCardUpdateToOneWithWhereWithoutApplicantDataInput = {
  data: ApplicantIdCardUpdateWithoutApplicantDataInput;
  where?: InputMaybe<ApplicantIdCardWhereInput>;
};

export type ApplicantIdCardUpdateWithoutApplicantDataInput = {
  county?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ApplicantIdCardUpsertWithoutApplicantDataInput = {
  create: ApplicantIdCardCreateWithoutApplicantDataInput;
  update: ApplicantIdCardUpdateWithoutApplicantDataInput;
  where?: InputMaybe<ApplicantIdCardWhereInput>;
};

export type ApplicantIdCardWhereInput = {
  AND?: InputMaybe<Array<ApplicantIdCardWhereInput>>;
  NOT?: InputMaybe<Array<ApplicantIdCardWhereInput>>;
  OR?: InputMaybe<Array<ApplicantIdCardWhereInput>>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  county?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ApplicantIdCardWhereUniqueInput = {
  AND?: InputMaybe<Array<ApplicantIdCardWhereInput>>;
  NOT?: InputMaybe<Array<ApplicantIdCardWhereInput>>;
  OR?: InputMaybe<Array<ApplicantIdCardWhereInput>>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  county?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  number?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AttachmentEnum {
  Letter_613 = 'LETTER_613',
  LetterAa = 'LETTER_AA',
  LetterPaa = 'LETTER_PAA'
}

export type AuditLog = {
  __typename?: 'AuditLog';
  actionContent: Scalars['JSON']['output'];
  date: Scalars['DateTimeISO']['output'];
  expiry?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  performerId: Scalars['String']['output'];
  performerType: PerformerTypes;
  reason: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceType: SourceTypes;
};


export type AuditLogOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};

export type AuditLogCountAggregate = {
  __typename?: 'AuditLogCountAggregate';
  _all: Scalars['Int']['output'];
  actionContent: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  expiry: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  meta: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  performerId: Scalars['Int']['output'];
  performerType: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
  sourceType: Scalars['Int']['output'];
};

export type AuditLogCreateManyOrganizationInput = {
  actionContent: Scalars['JSON']['input'];
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expiry?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  performerId: Scalars['String']['input'];
  performerType?: InputMaybe<PerformerTypes>;
  reason: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceType?: InputMaybe<SourceTypes>;
};

export type AuditLogCreateManyOrganizationInputEnvelope = {
  data: Array<AuditLogCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditLogCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditLogCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<AuditLogCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<AuditLogCreateManyOrganizationInputEnvelope>;
};

export type AuditLogCreateOrConnectWithoutOrganizationInput = {
  create: AuditLogCreateWithoutOrganizationInput;
  where: AuditLogWhereUniqueInput;
};

export type AuditLogCreateWithoutOrganizationInput = {
  actionContent: Scalars['JSON']['input'];
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expiry?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  performerId: Scalars['String']['input'];
  performerType?: InputMaybe<PerformerTypes>;
  reason: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceType?: InputMaybe<SourceTypes>;
};

export type AuditLogListRelationFilter = {
  every?: InputMaybe<AuditLogWhereInput>;
  none?: InputMaybe<AuditLogWhereInput>;
  some?: InputMaybe<AuditLogWhereInput>;
};

export type AuditLogMaxAggregate = {
  __typename?: 'AuditLogMaxAggregate';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  expiry?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  performerId?: Maybe<Scalars['String']['output']>;
  performerType?: Maybe<PerformerTypes>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<SourceTypes>;
};

export type AuditLogMinAggregate = {
  __typename?: 'AuditLogMinAggregate';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
  expiry?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  performerId?: Maybe<Scalars['String']['output']>;
  performerType?: Maybe<PerformerTypes>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<SourceTypes>;
};

export type AuditLogOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AuditLogOrderByWithRelationInput = {
  actionContent?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  expiry?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  meta?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  performerId?: InputMaybe<SortOrder>;
  performerType?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  sourceType?: InputMaybe<SortOrder>;
};

export enum AuditLogScalarFieldEnum {
  ActionContent = 'actionContent',
  Date = 'date',
  Expiry = 'expiry',
  Id = 'id',
  Meta = 'meta',
  OrganizationId = 'organizationId',
  PerformerId = 'performerId',
  PerformerType = 'performerType',
  Reason = 'reason',
  Source = 'source',
  SourceType = 'sourceType'
}

export type AuditLogScalarWhereInput = {
  AND?: InputMaybe<Array<AuditLogScalarWhereInput>>;
  NOT?: InputMaybe<Array<AuditLogScalarWhereInput>>;
  OR?: InputMaybe<Array<AuditLogScalarWhereInput>>;
  actionContent?: InputMaybe<JsonFilter>;
  date?: InputMaybe<DateTimeFilter>;
  expiry?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  meta?: InputMaybe<JsonNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  performerId?: InputMaybe<StringFilter>;
  performerType?: InputMaybe<EnumPerformerTypesFilter>;
  reason?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  sourceType?: InputMaybe<EnumSourceTypesFilter>;
};

export type AuditLogUpdateManyMutationInput = {
  actionContent?: InputMaybe<Scalars['JSON']['input']>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiry?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  performerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  performerType?: InputMaybe<EnumPerformerTypesFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  source?: InputMaybe<StringFieldUpdateOperationsInput>;
  sourceType?: InputMaybe<EnumSourceTypesFieldUpdateOperationsInput>;
};

export type AuditLogUpdateManyWithWhereWithoutOrganizationInput = {
  data: AuditLogUpdateManyMutationInput;
  where: AuditLogScalarWhereInput;
};

export type AuditLogUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuditLogCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<AuditLogCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<AuditLogCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuditLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  set?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  update?: InputMaybe<Array<AuditLogUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<AuditLogUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<AuditLogUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type AuditLogUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: AuditLogUpdateWithoutOrganizationInput;
  where: AuditLogWhereUniqueInput;
};

export type AuditLogUpdateWithoutOrganizationInput = {
  actionContent?: InputMaybe<Scalars['JSON']['input']>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiry?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  performerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  performerType?: InputMaybe<EnumPerformerTypesFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  source?: InputMaybe<StringFieldUpdateOperationsInput>;
  sourceType?: InputMaybe<EnumSourceTypesFieldUpdateOperationsInput>;
};

export type AuditLogUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: AuditLogCreateWithoutOrganizationInput;
  update: AuditLogUpdateWithoutOrganizationInput;
  where: AuditLogWhereUniqueInput;
};

export type AuditLogWhereInput = {
  AND?: InputMaybe<Array<AuditLogWhereInput>>;
  NOT?: InputMaybe<Array<AuditLogWhereInput>>;
  OR?: InputMaybe<Array<AuditLogWhereInput>>;
  actionContent?: InputMaybe<JsonFilter>;
  date?: InputMaybe<DateTimeFilter>;
  expiry?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  meta?: InputMaybe<JsonNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  performerId?: InputMaybe<StringFilter>;
  performerType?: InputMaybe<EnumPerformerTypesFilter>;
  reason?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  sourceType?: InputMaybe<EnumSourceTypesFilter>;
};

export type AuditLogWhereUniqueInput = {
  AND?: InputMaybe<Array<AuditLogWhereInput>>;
  NOT?: InputMaybe<Array<AuditLogWhereInput>>;
  OR?: InputMaybe<Array<AuditLogWhereInput>>;
  actionContent?: InputMaybe<JsonFilter>;
  date?: InputMaybe<DateTimeFilter>;
  expiry?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<JsonNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  performerId?: InputMaybe<StringFilter>;
  performerType?: InputMaybe<EnumPerformerTypesFilter>;
  reason?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  sourceType?: InputMaybe<EnumSourceTypesFilter>;
};

export type Beam = {
  __typename?: 'Beam';
  _count?: Maybe<BeamCount>;
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  credentialTypes: Array<CredentialType>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inputTypes: Array<BeamInputType>;
  latestInputType?: Maybe<BeamInputType>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  outputs: Array<BeamOutput>;
  passTypes: Array<PassType>;
  processor: ProcessorEnum;
  processorConfig?: Maybe<Scalars['JSON']['output']>;
  source: BeamDataSourceEnum;
  type: BeamTypeEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type BeamCredentialTypesArgs = {
  cursor?: InputMaybe<CredentialTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CredentialTypeWhereInput>;
};


export type BeamInputTypesArgs = {
  cursor?: InputMaybe<BeamInputTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputTypeWhereInput>;
};


export type BeamOutputsArgs = {
  cursor?: InputMaybe<BeamOutputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamOutputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOutputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type BeamPassTypesArgs = {
  cursor?: InputMaybe<PassTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassTypeWhereInput>;
};

export type BeamCount = {
  __typename?: 'BeamCount';
  credentialTypes: Scalars['Int']['output'];
  inputTypes: Scalars['Int']['output'];
  outputs: Scalars['Int']['output'];
  passTypes: Scalars['Int']['output'];
};


export type BeamCountCredentialTypesArgs = {
  where?: InputMaybe<CredentialTypeWhereInput>;
};


export type BeamCountInputTypesArgs = {
  where?: InputMaybe<BeamInputTypeWhereInput>;
};


export type BeamCountOutputsArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type BeamCountPassTypesArgs = {
  where?: InputMaybe<PassTypeWhereInput>;
};

export type BeamCreateInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentialTypes?: InputMaybe<CredentialTypeCreateNestedManyWithoutBeamInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputTypes?: InputMaybe<BeamInputTypeCreateNestedManyWithoutBeamInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutBeamInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutBeamsInput>;
  processor?: InputMaybe<ProcessorEnum>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<BeamDataSourceEnum>;
  type?: InputMaybe<BeamTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamCreateNestedManyWithoutPassTypesInput = {
  connect?: InputMaybe<Array<BeamWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamCreateOrConnectWithoutPassTypesInput>>;
  create?: InputMaybe<Array<BeamCreateWithoutPassTypesInput>>;
};

export type BeamCreateNestedOneWithoutCredentialTypesInput = {
  connect?: InputMaybe<BeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamCreateOrConnectWithoutCredentialTypesInput>;
  create?: InputMaybe<BeamCreateWithoutCredentialTypesInput>;
};

export type BeamCreateNestedOneWithoutInputTypesInput = {
  connect?: InputMaybe<BeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamCreateOrConnectWithoutInputTypesInput>;
  create?: InputMaybe<BeamCreateWithoutInputTypesInput>;
};

export type BeamCreateNestedOneWithoutOutputsInput = {
  connect?: InputMaybe<BeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamCreateOrConnectWithoutOutputsInput>;
  create?: InputMaybe<BeamCreateWithoutOutputsInput>;
};

export type BeamCreateOrConnectWithoutCredentialTypesInput = {
  create: BeamCreateWithoutCredentialTypesInput;
  where: BeamWhereUniqueInput;
};

export type BeamCreateOrConnectWithoutInputTypesInput = {
  create: BeamCreateWithoutInputTypesInput;
  where: BeamWhereUniqueInput;
};

export type BeamCreateOrConnectWithoutOutputsInput = {
  create: BeamCreateWithoutOutputsInput;
  where: BeamWhereUniqueInput;
};

export type BeamCreateOrConnectWithoutPassTypesInput = {
  create: BeamCreateWithoutPassTypesInput;
  where: BeamWhereUniqueInput;
};

export type BeamCreateWithoutCredentialTypesInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputTypes?: InputMaybe<BeamInputTypeCreateNestedManyWithoutBeamInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutBeamInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutBeamsInput>;
  processor?: InputMaybe<ProcessorEnum>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<BeamDataSourceEnum>;
  type?: InputMaybe<BeamTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamCreateWithoutInputTypesInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentialTypes?: InputMaybe<CredentialTypeCreateNestedManyWithoutBeamInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutBeamInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutBeamsInput>;
  processor?: InputMaybe<ProcessorEnum>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<BeamDataSourceEnum>;
  type?: InputMaybe<BeamTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamCreateWithoutOutputsInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentialTypes?: InputMaybe<CredentialTypeCreateNestedManyWithoutBeamInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputTypes?: InputMaybe<BeamInputTypeCreateNestedManyWithoutBeamInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutBeamsInput>;
  processor?: InputMaybe<ProcessorEnum>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<BeamDataSourceEnum>;
  type?: InputMaybe<BeamTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamCreateWithoutPassTypesInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentialTypes?: InputMaybe<CredentialTypeCreateNestedManyWithoutBeamInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputTypes?: InputMaybe<BeamInputTypeCreateNestedManyWithoutBeamInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutBeamInput>;
  processor?: InputMaybe<ProcessorEnum>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<BeamDataSourceEnum>;
  type?: InputMaybe<BeamTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export enum BeamDataSourceEnum {
  System = 'SYSTEM',
  User = 'USER'
}

export type BeamInput = {
  __typename?: 'BeamInput';
  _count?: Maybe<BeamInputCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  credential?: Maybe<Credential>;
  data: Scalars['JSON']['output'];
  files: Array<File>;
  hsi: Array<HighlySensitiveIdentifier>;
  id: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  output?: Maybe<BeamOutput>;
  pass?: Maybe<Pass>;
  passId?: Maybe<Scalars['String']['output']>;
  runs: Array<BeamRun>;
  type: BeamInputType;
  typeId: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type BeamInputCredentialArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type BeamInputFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type BeamInputHsiArgs = {
  cursor?: InputMaybe<HighlySensitiveIdentifierWhereUniqueInput>;
  distinct?: InputMaybe<Array<HighlySensitiveIdentifierScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<HighlySensitiveIdentifierOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};


export type BeamInputOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type BeamInputOutputArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type BeamInputPassArgs = {
  where?: InputMaybe<PassWhereInput>;
};


export type BeamInputRunsArgs = {
  cursor?: InputMaybe<BeamRunWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamRunScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamRunOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamRunWhereInput>;
};

export type BeamInputCount = {
  __typename?: 'BeamInputCount';
  files: Scalars['Int']['output'];
  hsi: Scalars['Int']['output'];
  runs: Scalars['Int']['output'];
};


export type BeamInputCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type BeamInputCountHsiArgs = {
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};


export type BeamInputCountRunsArgs = {
  where?: InputMaybe<BeamRunWhereInput>;
};

export type BeamInputCountAggregate = {
  __typename?: 'BeamInputCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  passId: Scalars['Int']['output'];
  typeId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type BeamInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  passId?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BeamInputCreateManyOrderInputEnvelope = {
  data: Array<BeamInputCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamInputCreateManyPassInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  typeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BeamInputCreateManyPassInputEnvelope = {
  data: Array<BeamInputCreateManyPassInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamInputCreateManyTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  passId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type BeamInputCreateManyTypeInputEnvelope = {
  data: Array<BeamInputCreateManyTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamInputCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  passId?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
};

export type BeamInputCreateManyUserInputEnvelope = {
  data: Array<BeamInputCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamInputCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutOrderInput>>;
  createMany?: InputMaybe<BeamInputCreateManyOrderInputEnvelope>;
};

export type BeamInputCreateNestedManyWithoutPassInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutPassInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutPassInput>>;
  createMany?: InputMaybe<BeamInputCreateManyPassInputEnvelope>;
};

export type BeamInputCreateNestedManyWithoutTypeInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutTypeInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutTypeInput>>;
  createMany?: InputMaybe<BeamInputCreateManyTypeInputEnvelope>;
};

export type BeamInputCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutUserInput>>;
  createMany?: InputMaybe<BeamInputCreateManyUserInputEnvelope>;
};

export type BeamInputCreateNestedOneWithoutCredentialInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<BeamInputCreateWithoutCredentialInput>;
};

export type BeamInputCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<BeamInputCreateWithoutFilesInput>;
};

export type BeamInputCreateNestedOneWithoutHsiInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutHsiInput>;
  create?: InputMaybe<BeamInputCreateWithoutHsiInput>;
};

export type BeamInputCreateNestedOneWithoutOutputInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutOutputInput>;
  create?: InputMaybe<BeamInputCreateWithoutOutputInput>;
};

export type BeamInputCreateNestedOneWithoutRunsInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutRunsInput>;
  create?: InputMaybe<BeamInputCreateWithoutRunsInput>;
};

export type BeamInputCreateOrConnectWithoutCredentialInput = {
  create: BeamInputCreateWithoutCredentialInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutFilesInput = {
  create: BeamInputCreateWithoutFilesInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutHsiInput = {
  create: BeamInputCreateWithoutHsiInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutOrderInput = {
  create: BeamInputCreateWithoutOrderInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutOutputInput = {
  create: BeamInputCreateWithoutOutputInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutPassInput = {
  create: BeamInputCreateWithoutPassInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutRunsInput = {
  create: BeamInputCreateWithoutRunsInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutTypeInput = {
  create: BeamInputCreateWithoutTypeInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateOrConnectWithoutUserInput = {
  create: BeamInputCreateWithoutUserInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputCreateWithoutCredentialInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutFilesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutHsiInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutOutputInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutPassInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutRunsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  user: UserCreateNestedOneWithoutBeamInputInput;
};

export type BeamInputCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutInputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamInputInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamInputsInput>;
  organizationId: Scalars['String']['input'];
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutInputInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutInputsInput>;
  runs?: InputMaybe<BeamRunCreateNestedManyWithoutInputInput>;
  type: BeamInputTypeCreateNestedOneWithoutInputsInput;
};

export type BeamInputListRelationFilter = {
  every?: InputMaybe<BeamInputWhereInput>;
  none?: InputMaybe<BeamInputWhereInput>;
  some?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputMaxAggregate = {
  __typename?: 'BeamInputMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  passId?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type BeamInputMinAggregate = {
  __typename?: 'BeamInputMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  passId?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type BeamInputNullableScalarRelationFilter = {
  is?: InputMaybe<BeamInputWhereInput>;
  isNot?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BeamInputOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  data?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  organizationId?: InputMaybe<SortOrder>;
  output?: InputMaybe<BeamOutputOrderByWithRelationInput>;
  pass?: InputMaybe<PassOrderByWithRelationInput>;
  passId?: InputMaybe<SortOrderInput>;
  runs?: InputMaybe<BeamRunOrderByRelationAggregateInput>;
  type?: InputMaybe<BeamInputTypeOrderByWithRelationInput>;
  typeId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum BeamInputScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  OrderId = 'orderId',
  OrganizationId = 'organizationId',
  PassId = 'passId',
  TypeId = 'typeId',
  UserId = 'userId'
}

export type BeamInputScalarRelationFilter = {
  is?: InputMaybe<BeamInputWhereInput>;
  isNot?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputScalarWhereInput = {
  AND?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  OR?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  typeId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BeamInputType = {
  __typename?: 'BeamInputType';
  _count?: Maybe<BeamInputTypeCount>;
  beam: Beam;
  beamId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  inputs: Array<BeamInput>;
  organizationId: Scalars['String']['output'];
  schema: Scalars['JSON']['output'];
  slug: Scalars['String']['output'];
  uiSchema?: Maybe<Scalars['JSON']['output']>;
  version: Scalars['String']['output'];
};


export type BeamInputTypeInputsArgs = {
  cursor?: InputMaybe<BeamInputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputTypeCount = {
  __typename?: 'BeamInputTypeCount';
  inputs: Scalars['Int']['output'];
};


export type BeamInputTypeCountInputsArgs = {
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputTypeCreateInput = {
  beam: BeamCreateNestedOneWithoutInputTypesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutTypeInput>;
  organizationId: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version: Scalars['String']['input'];
};

export type BeamInputTypeCreateManyBeamInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version: Scalars['String']['input'];
};

export type BeamInputTypeCreateManyBeamInputEnvelope = {
  data: Array<BeamInputTypeCreateManyBeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamInputTypeCreateNestedManyWithoutBeamInput = {
  connect?: InputMaybe<Array<BeamInputTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputTypeCreateOrConnectWithoutBeamInput>>;
  create?: InputMaybe<Array<BeamInputTypeCreateWithoutBeamInput>>;
  createMany?: InputMaybe<BeamInputTypeCreateManyBeamInputEnvelope>;
};

export type BeamInputTypeCreateNestedOneWithoutInputsInput = {
  connect?: InputMaybe<BeamInputTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputTypeCreateOrConnectWithoutInputsInput>;
  create?: InputMaybe<BeamInputTypeCreateWithoutInputsInput>;
};

export type BeamInputTypeCreateOrConnectWithoutBeamInput = {
  create: BeamInputTypeCreateWithoutBeamInput;
  where: BeamInputTypeWhereUniqueInput;
};

export type BeamInputTypeCreateOrConnectWithoutInputsInput = {
  create: BeamInputTypeCreateWithoutInputsInput;
  where: BeamInputTypeWhereUniqueInput;
};

export type BeamInputTypeCreateWithoutBeamInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutTypeInput>;
  organizationId: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version: Scalars['String']['input'];
};

export type BeamInputTypeCreateWithoutInputsInput = {
  beam: BeamCreateNestedOneWithoutInputTypesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version: Scalars['String']['input'];
};

export type BeamInputTypeListRelationFilter = {
  every?: InputMaybe<BeamInputTypeWhereInput>;
  none?: InputMaybe<BeamInputTypeWhereInput>;
  some?: InputMaybe<BeamInputTypeWhereInput>;
};

export type BeamInputTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BeamInputTypeOrderByWithRelationInput = {
  beam?: InputMaybe<BeamOrderByWithRelationInput>;
  beamId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inputs?: InputMaybe<BeamInputOrderByRelationAggregateInput>;
  organizationId?: InputMaybe<SortOrder>;
  schema?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  uiSchema?: InputMaybe<SortOrderInput>;
  version?: InputMaybe<SortOrder>;
};

export enum BeamInputTypeScalarFieldEnum {
  BeamId = 'beamId',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  Schema = 'schema',
  Slug = 'slug',
  UiSchema = 'uiSchema',
  Version = 'version'
}

export type BeamInputTypeScalarRelationFilter = {
  is?: InputMaybe<BeamInputTypeWhereInput>;
  isNot?: InputMaybe<BeamInputTypeWhereInput>;
};

export type BeamInputTypeScalarWhereInput = {
  AND?: InputMaybe<Array<BeamInputTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeamInputTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<BeamInputTypeScalarWhereInput>>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  schema?: InputMaybe<JsonFilter>;
  slug?: InputMaybe<StringFilter>;
  uiSchema?: InputMaybe<JsonNullableFilter>;
  version?: InputMaybe<StringFilter>;
};

export type BeamInputTypeSlugVersionCompoundUniqueInput = {
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type BeamInputTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BeamInputTypeUpdateManyWithWhereWithoutBeamInput = {
  data: BeamInputTypeUpdateManyMutationInput;
  where: BeamInputTypeScalarWhereInput;
};

export type BeamInputTypeUpdateManyWithoutBeamNestedInput = {
  connect?: InputMaybe<Array<BeamInputTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputTypeCreateOrConnectWithoutBeamInput>>;
  create?: InputMaybe<Array<BeamInputTypeCreateWithoutBeamInput>>;
  createMany?: InputMaybe<BeamInputTypeCreateManyBeamInputEnvelope>;
  delete?: InputMaybe<Array<BeamInputTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamInputTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamInputTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamInputTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamInputTypeUpdateWithWhereUniqueWithoutBeamInput>>;
  updateMany?: InputMaybe<Array<BeamInputTypeUpdateManyWithWhereWithoutBeamInput>>;
  upsert?: InputMaybe<Array<BeamInputTypeUpsertWithWhereUniqueWithoutBeamInput>>;
};

export type BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput = {
  connect?: InputMaybe<BeamInputTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputTypeCreateOrConnectWithoutInputsInput>;
  create?: InputMaybe<BeamInputTypeCreateWithoutInputsInput>;
  update?: InputMaybe<BeamInputTypeUpdateToOneWithWhereWithoutInputsInput>;
  upsert?: InputMaybe<BeamInputTypeUpsertWithoutInputsInput>;
};

export type BeamInputTypeUpdateToOneWithWhereWithoutInputsInput = {
  data: BeamInputTypeUpdateWithoutInputsInput;
  where?: InputMaybe<BeamInputTypeWhereInput>;
};

export type BeamInputTypeUpdateWithWhereUniqueWithoutBeamInput = {
  data: BeamInputTypeUpdateWithoutBeamInput;
  where: BeamInputTypeWhereUniqueInput;
};

export type BeamInputTypeUpdateWithoutBeamInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputs?: InputMaybe<BeamInputUpdateManyWithoutTypeNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BeamInputTypeUpdateWithoutInputsInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutInputTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  uiSchema?: InputMaybe<Scalars['JSON']['input']>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BeamInputTypeUpsertWithWhereUniqueWithoutBeamInput = {
  create: BeamInputTypeCreateWithoutBeamInput;
  update: BeamInputTypeUpdateWithoutBeamInput;
  where: BeamInputTypeWhereUniqueInput;
};

export type BeamInputTypeUpsertWithoutInputsInput = {
  create: BeamInputTypeCreateWithoutInputsInput;
  update: BeamInputTypeUpdateWithoutInputsInput;
  where?: InputMaybe<BeamInputTypeWhereInput>;
};

export type BeamInputTypeWhereInput = {
  AND?: InputMaybe<Array<BeamInputTypeWhereInput>>;
  NOT?: InputMaybe<Array<BeamInputTypeWhereInput>>;
  OR?: InputMaybe<Array<BeamInputTypeWhereInput>>;
  beam?: InputMaybe<BeamScalarRelationFilter>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  inputs?: InputMaybe<BeamInputListRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  schema?: InputMaybe<JsonFilter>;
  slug?: InputMaybe<StringFilter>;
  uiSchema?: InputMaybe<JsonNullableFilter>;
  version?: InputMaybe<StringFilter>;
};

export type BeamInputTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<BeamInputTypeWhereInput>>;
  NOT?: InputMaybe<Array<BeamInputTypeWhereInput>>;
  OR?: InputMaybe<Array<BeamInputTypeWhereInput>>;
  beam?: InputMaybe<BeamScalarRelationFilter>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputListRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  schema?: InputMaybe<JsonFilter>;
  slug?: InputMaybe<StringFilter>;
  slug_version?: InputMaybe<BeamInputTypeSlugVersionCompoundUniqueInput>;
  uiSchema?: InputMaybe<JsonNullableFilter>;
  version?: InputMaybe<StringFilter>;
};

export type BeamInputUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BeamInputUpdateManyWithWhereWithoutOrderInput = {
  data: BeamInputUpdateManyMutationInput;
  where: BeamInputScalarWhereInput;
};

export type BeamInputUpdateManyWithWhereWithoutPassInput = {
  data: BeamInputUpdateManyMutationInput;
  where: BeamInputScalarWhereInput;
};

export type BeamInputUpdateManyWithWhereWithoutTypeInput = {
  data: BeamInputUpdateManyMutationInput;
  where: BeamInputScalarWhereInput;
};

export type BeamInputUpdateManyWithWhereWithoutUserInput = {
  data: BeamInputUpdateManyMutationInput;
  where: BeamInputScalarWhereInput;
};

export type BeamInputUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutOrderInput>>;
  createMany?: InputMaybe<BeamInputCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamInputUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<BeamInputUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<BeamInputUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type BeamInputUpdateManyWithoutPassNestedInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutPassInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutPassInput>>;
  createMany?: InputMaybe<BeamInputCreateManyPassInputEnvelope>;
  delete?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamInputUpdateWithWhereUniqueWithoutPassInput>>;
  updateMany?: InputMaybe<Array<BeamInputUpdateManyWithWhereWithoutPassInput>>;
  upsert?: InputMaybe<Array<BeamInputUpsertWithWhereUniqueWithoutPassInput>>;
};

export type BeamInputUpdateManyWithoutTypeNestedInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutTypeInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutTypeInput>>;
  createMany?: InputMaybe<BeamInputCreateManyTypeInputEnvelope>;
  delete?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamInputUpdateWithWhereUniqueWithoutTypeInput>>;
  updateMany?: InputMaybe<Array<BeamInputUpdateManyWithWhereWithoutTypeInput>>;
  upsert?: InputMaybe<Array<BeamInputUpsertWithWhereUniqueWithoutTypeInput>>;
};

export type BeamInputUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamInputCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BeamInputCreateWithoutUserInput>>;
  createMany?: InputMaybe<BeamInputCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamInputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamInputUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<BeamInputUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<BeamInputUpsertWithWhereUniqueWithoutUserInput>>;
};

export type BeamInputUpdateOneRequiredWithoutCredentialNestedInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<BeamInputCreateWithoutCredentialInput>;
  update?: InputMaybe<BeamInputUpdateToOneWithWhereWithoutCredentialInput>;
  upsert?: InputMaybe<BeamInputUpsertWithoutCredentialInput>;
};

export type BeamInputUpdateOneRequiredWithoutOutputNestedInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutOutputInput>;
  create?: InputMaybe<BeamInputCreateWithoutOutputInput>;
  update?: InputMaybe<BeamInputUpdateToOneWithWhereWithoutOutputInput>;
  upsert?: InputMaybe<BeamInputUpsertWithoutOutputInput>;
};

export type BeamInputUpdateOneRequiredWithoutRunsNestedInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutRunsInput>;
  create?: InputMaybe<BeamInputCreateWithoutRunsInput>;
  update?: InputMaybe<BeamInputUpdateToOneWithWhereWithoutRunsInput>;
  upsert?: InputMaybe<BeamInputUpsertWithoutRunsInput>;
};

export type BeamInputUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<BeamInputCreateWithoutFilesInput>;
  delete?: InputMaybe<BeamInputWhereInput>;
  disconnect?: InputMaybe<BeamInputWhereInput>;
  update?: InputMaybe<BeamInputUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<BeamInputUpsertWithoutFilesInput>;
};

export type BeamInputUpdateOneWithoutHsiNestedInput = {
  connect?: InputMaybe<BeamInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamInputCreateOrConnectWithoutHsiInput>;
  create?: InputMaybe<BeamInputCreateWithoutHsiInput>;
  delete?: InputMaybe<BeamInputWhereInput>;
  disconnect?: InputMaybe<BeamInputWhereInput>;
  update?: InputMaybe<BeamInputUpdateToOneWithWhereWithoutHsiInput>;
  upsert?: InputMaybe<BeamInputUpsertWithoutHsiInput>;
};

export type BeamInputUpdateToOneWithWhereWithoutCredentialInput = {
  data: BeamInputUpdateWithoutCredentialInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpdateToOneWithWhereWithoutFilesInput = {
  data: BeamInputUpdateWithoutFilesInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpdateToOneWithWhereWithoutHsiInput = {
  data: BeamInputUpdateWithoutHsiInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpdateToOneWithWhereWithoutOutputInput = {
  data: BeamInputUpdateWithoutOutputInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpdateToOneWithWhereWithoutRunsInput = {
  data: BeamInputUpdateWithoutRunsInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpdateWithWhereUniqueWithoutOrderInput = {
  data: BeamInputUpdateWithoutOrderInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpdateWithWhereUniqueWithoutPassInput = {
  data: BeamInputUpdateWithoutPassInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpdateWithWhereUniqueWithoutTypeInput = {
  data: BeamInputUpdateWithoutTypeInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpdateWithWhereUniqueWithoutUserInput = {
  data: BeamInputUpdateWithoutUserInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpdateWithoutCredentialInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutFilesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutHsiInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutOutputInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutPassInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutRunsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutTypeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamInputNestedInput>;
};

export type BeamInputUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutInputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamInputNestedInput>;
  hsi?: InputMaybe<HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamInputsNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutInputNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutInputsNestedInput>;
  runs?: InputMaybe<BeamRunUpdateManyWithoutInputNestedInput>;
  type?: InputMaybe<BeamInputTypeUpdateOneRequiredWithoutInputsNestedInput>;
};

export type BeamInputUpsertWithWhereUniqueWithoutOrderInput = {
  create: BeamInputCreateWithoutOrderInput;
  update: BeamInputUpdateWithoutOrderInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpsertWithWhereUniqueWithoutPassInput = {
  create: BeamInputCreateWithoutPassInput;
  update: BeamInputUpdateWithoutPassInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpsertWithWhereUniqueWithoutTypeInput = {
  create: BeamInputCreateWithoutTypeInput;
  update: BeamInputUpdateWithoutTypeInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpsertWithWhereUniqueWithoutUserInput = {
  create: BeamInputCreateWithoutUserInput;
  update: BeamInputUpdateWithoutUserInput;
  where: BeamInputWhereUniqueInput;
};

export type BeamInputUpsertWithoutCredentialInput = {
  create: BeamInputCreateWithoutCredentialInput;
  update: BeamInputUpdateWithoutCredentialInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpsertWithoutFilesInput = {
  create: BeamInputCreateWithoutFilesInput;
  update: BeamInputUpdateWithoutFilesInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpsertWithoutHsiInput = {
  create: BeamInputCreateWithoutHsiInput;
  update: BeamInputUpdateWithoutHsiInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpsertWithoutOutputInput = {
  create: BeamInputCreateWithoutOutputInput;
  update: BeamInputUpdateWithoutOutputInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputUpsertWithoutRunsInput = {
  create: BeamInputCreateWithoutRunsInput;
  update: BeamInputUpdateWithoutRunsInput;
  where?: InputMaybe<BeamInputWhereInput>;
};

export type BeamInputWhereInput = {
  AND?: InputMaybe<Array<BeamInputWhereInput>>;
  NOT?: InputMaybe<Array<BeamInputWhereInput>>;
  OR?: InputMaybe<Array<BeamInputWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialNullableScalarRelationFilter>;
  data?: InputMaybe<JsonFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  hsi?: InputMaybe<HighlySensitiveIdentifierListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  output?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  pass?: InputMaybe<PassNullableScalarRelationFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  runs?: InputMaybe<BeamRunListRelationFilter>;
  type?: InputMaybe<BeamInputTypeScalarRelationFilter>;
  typeId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BeamInputWhereUniqueInput = {
  AND?: InputMaybe<Array<BeamInputWhereInput>>;
  NOT?: InputMaybe<Array<BeamInputWhereInput>>;
  OR?: InputMaybe<Array<BeamInputWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialNullableScalarRelationFilter>;
  data?: InputMaybe<JsonFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  hsi?: InputMaybe<HighlySensitiveIdentifierListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  output?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  pass?: InputMaybe<PassNullableScalarRelationFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  runs?: InputMaybe<BeamRunListRelationFilter>;
  type?: InputMaybe<BeamInputTypeScalarRelationFilter>;
  typeId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BeamListRelationFilter = {
  every?: InputMaybe<BeamWhereInput>;
  none?: InputMaybe<BeamWhereInput>;
  some?: InputMaybe<BeamWhereInput>;
};

export type BeamOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BeamOrderByWithRelationInput = {
  config?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  credentialTypes?: InputMaybe<CredentialTypeOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inputTypes?: InputMaybe<BeamInputTypeOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrder>;
  outputs?: InputMaybe<BeamOutputOrderByRelationAggregateInput>;
  passTypes?: InputMaybe<PassTypeOrderByRelationAggregateInput>;
  processor?: InputMaybe<SortOrder>;
  processorConfig?: InputMaybe<SortOrderInput>;
  source?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BeamOutput = {
  __typename?: 'BeamOutput';
  _count?: Maybe<BeamOutputCount>;
  beam: Beam;
  beamId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  credential?: Maybe<Credential>;
  data: Scalars['JSON']['output'];
  files: Array<File>;
  id: Scalars['String']['output'];
  input: BeamInput;
  inputId: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  pass?: Maybe<Pass>;
  passId?: Maybe<Scalars['String']['output']>;
  run: BeamRun;
  runId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};


export type BeamOutputCredentialArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type BeamOutputFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type BeamOutputOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type BeamOutputPassArgs = {
  where?: InputMaybe<PassWhereInput>;
};

export type BeamOutputCount = {
  __typename?: 'BeamOutputCount';
  files: Scalars['Int']['output'];
};


export type BeamOutputCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type BeamOutputCreateManyBeamInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  passId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type BeamOutputCreateManyBeamInputEnvelope = {
  data: Array<BeamOutputCreateManyBeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamOutputCreateManyOrderInput = {
  beamId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  passId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type BeamOutputCreateManyOrderInputEnvelope = {
  data: Array<BeamOutputCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamOutputCreateManyOrganizationInput = {
  beamId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type BeamOutputCreateManyOrganizationInputEnvelope = {
  data: Array<BeamOutputCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamOutputCreateManyPassInput = {
  beamId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type BeamOutputCreateManyPassInputEnvelope = {
  data: Array<BeamOutputCreateManyPassInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamOutputCreateManyUserInput = {
  beamId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  passId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamOutputCreateManyUserInputEnvelope = {
  data: Array<BeamOutputCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamOutputCreateNestedManyWithoutBeamInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutBeamInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutBeamInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyBeamInputEnvelope>;
};

export type BeamOutputCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutOrderInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyOrderInputEnvelope>;
};

export type BeamOutputCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyOrganizationInputEnvelope>;
};

export type BeamOutputCreateNestedManyWithoutPassInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutPassInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutPassInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyPassInputEnvelope>;
};

export type BeamOutputCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutUserInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyUserInputEnvelope>;
};

export type BeamOutputCreateNestedOneWithoutCredentialInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<BeamOutputCreateWithoutCredentialInput>;
};

export type BeamOutputCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<BeamOutputCreateWithoutFilesInput>;
};

export type BeamOutputCreateNestedOneWithoutInputInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutInputInput>;
  create?: InputMaybe<BeamOutputCreateWithoutInputInput>;
};

export type BeamOutputCreateNestedOneWithoutRunInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutRunInput>;
  create?: InputMaybe<BeamOutputCreateWithoutRunInput>;
};

export type BeamOutputCreateOrConnectWithoutBeamInput = {
  create: BeamOutputCreateWithoutBeamInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutCredentialInput = {
  create: BeamOutputCreateWithoutCredentialInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutFilesInput = {
  create: BeamOutputCreateWithoutFilesInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutInputInput = {
  create: BeamOutputCreateWithoutInputInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutOrderInput = {
  create: BeamOutputCreateWithoutOrderInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutOrganizationInput = {
  create: BeamOutputCreateWithoutOrganizationInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutPassInput = {
  create: BeamOutputCreateWithoutPassInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutRunInput = {
  create: BeamOutputCreateWithoutRunInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateOrConnectWithoutUserInput = {
  create: BeamOutputCreateWithoutUserInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputCreateWithoutBeamInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutCredentialInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutFilesInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutInputInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutOrderInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutOrganizationInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutPassInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutRunInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBeamOutputsInput;
};

export type BeamOutputCreateWithoutUserInput = {
  beam: BeamCreateNestedOneWithoutOutputsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutOutputInput>;
  data: Scalars['JSON']['input'];
  files?: InputMaybe<FileCreateNestedManyWithoutBeamOutputInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutOutputInput;
  order?: InputMaybe<OrderCreateNestedOneWithoutBeamOutputsInput>;
  organization: OrganizationCreateNestedOneWithoutBeamOutputsInput;
  pass?: InputMaybe<PassCreateNestedOneWithoutOutputsInput>;
  run: BeamRunCreateNestedOneWithoutOutputInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamOutputListRelationFilter = {
  every?: InputMaybe<BeamOutputWhereInput>;
  none?: InputMaybe<BeamOutputWhereInput>;
  some?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputNullableScalarRelationFilter = {
  is?: InputMaybe<BeamOutputWhereInput>;
  isNot?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BeamOutputOrderByWithRelationInput = {
  beam?: InputMaybe<BeamOrderByWithRelationInput>;
  beamId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  data?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  input?: InputMaybe<BeamInputOrderByWithRelationInput>;
  inputId?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  pass?: InputMaybe<PassOrderByWithRelationInput>;
  passId?: InputMaybe<SortOrderInput>;
  run?: InputMaybe<BeamRunOrderByWithRelationInput>;
  runId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum BeamOutputScalarFieldEnum {
  BeamId = 'beamId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  InputId = 'inputId',
  OrderId = 'orderId',
  OrganizationId = 'organizationId',
  PassId = 'passId',
  RunId = 'runId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type BeamOutputScalarWhereInput = {
  AND?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  OR?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  inputId?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  runId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BeamOutputUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamOutputUpdateManyWithWhereWithoutBeamInput = {
  data: BeamOutputUpdateManyMutationInput;
  where: BeamOutputScalarWhereInput;
};

export type BeamOutputUpdateManyWithWhereWithoutOrderInput = {
  data: BeamOutputUpdateManyMutationInput;
  where: BeamOutputScalarWhereInput;
};

export type BeamOutputUpdateManyWithWhereWithoutOrganizationInput = {
  data: BeamOutputUpdateManyMutationInput;
  where: BeamOutputScalarWhereInput;
};

export type BeamOutputUpdateManyWithWhereWithoutPassInput = {
  data: BeamOutputUpdateManyMutationInput;
  where: BeamOutputScalarWhereInput;
};

export type BeamOutputUpdateManyWithWhereWithoutUserInput = {
  data: BeamOutputUpdateManyMutationInput;
  where: BeamOutputScalarWhereInput;
};

export type BeamOutputUpdateManyWithoutBeamNestedInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutBeamInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutBeamInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyBeamInputEnvelope>;
  delete?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamOutputUpdateWithWhereUniqueWithoutBeamInput>>;
  updateMany?: InputMaybe<Array<BeamOutputUpdateManyWithWhereWithoutBeamInput>>;
  upsert?: InputMaybe<Array<BeamOutputUpsertWithWhereUniqueWithoutBeamInput>>;
};

export type BeamOutputUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutOrderInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamOutputUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<BeamOutputUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<BeamOutputUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type BeamOutputUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamOutputUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<BeamOutputUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<BeamOutputUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type BeamOutputUpdateManyWithoutPassNestedInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutPassInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutPassInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyPassInputEnvelope>;
  delete?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamOutputUpdateWithWhereUniqueWithoutPassInput>>;
  updateMany?: InputMaybe<Array<BeamOutputUpdateManyWithWhereWithoutPassInput>>;
  upsert?: InputMaybe<Array<BeamOutputUpsertWithWhereUniqueWithoutPassInput>>;
};

export type BeamOutputUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamOutputCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BeamOutputCreateWithoutUserInput>>;
  createMany?: InputMaybe<BeamOutputCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamOutputUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<BeamOutputUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<BeamOutputUpsertWithWhereUniqueWithoutUserInput>>;
};

export type BeamOutputUpdateOneWithoutCredentialNestedInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<BeamOutputCreateWithoutCredentialInput>;
  delete?: InputMaybe<BeamOutputWhereInput>;
  disconnect?: InputMaybe<BeamOutputWhereInput>;
  update?: InputMaybe<BeamOutputUpdateToOneWithWhereWithoutCredentialInput>;
  upsert?: InputMaybe<BeamOutputUpsertWithoutCredentialInput>;
};

export type BeamOutputUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<BeamOutputCreateWithoutFilesInput>;
  delete?: InputMaybe<BeamOutputWhereInput>;
  disconnect?: InputMaybe<BeamOutputWhereInput>;
  update?: InputMaybe<BeamOutputUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<BeamOutputUpsertWithoutFilesInput>;
};

export type BeamOutputUpdateOneWithoutInputNestedInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutInputInput>;
  create?: InputMaybe<BeamOutputCreateWithoutInputInput>;
  delete?: InputMaybe<BeamOutputWhereInput>;
  disconnect?: InputMaybe<BeamOutputWhereInput>;
  update?: InputMaybe<BeamOutputUpdateToOneWithWhereWithoutInputInput>;
  upsert?: InputMaybe<BeamOutputUpsertWithoutInputInput>;
};

export type BeamOutputUpdateOneWithoutRunNestedInput = {
  connect?: InputMaybe<BeamOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamOutputCreateOrConnectWithoutRunInput>;
  create?: InputMaybe<BeamOutputCreateWithoutRunInput>;
  delete?: InputMaybe<BeamOutputWhereInput>;
  disconnect?: InputMaybe<BeamOutputWhereInput>;
  update?: InputMaybe<BeamOutputUpdateToOneWithWhereWithoutRunInput>;
  upsert?: InputMaybe<BeamOutputUpsertWithoutRunInput>;
};

export type BeamOutputUpdateToOneWithWhereWithoutCredentialInput = {
  data: BeamOutputUpdateWithoutCredentialInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpdateToOneWithWhereWithoutFilesInput = {
  data: BeamOutputUpdateWithoutFilesInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpdateToOneWithWhereWithoutInputInput = {
  data: BeamOutputUpdateWithoutInputInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpdateToOneWithWhereWithoutRunInput = {
  data: BeamOutputUpdateWithoutRunInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpdateWithWhereUniqueWithoutBeamInput = {
  data: BeamOutputUpdateWithoutBeamInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpdateWithWhereUniqueWithoutOrderInput = {
  data: BeamOutputUpdateWithoutOrderInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: BeamOutputUpdateWithoutOrganizationInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpdateWithWhereUniqueWithoutPassInput = {
  data: BeamOutputUpdateWithoutPassInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpdateWithWhereUniqueWithoutUserInput = {
  data: BeamOutputUpdateWithoutUserInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpdateWithoutBeamInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutCredentialInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutFilesInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutInputInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutOrderInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutOrganizationInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutPassInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutRunInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBeamOutputsNestedInput>;
};

export type BeamOutputUpdateWithoutUserInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutOutputsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutOutputNestedInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  files?: InputMaybe<FileUpdateManyWithoutBeamOutputNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutOutputNestedInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBeamOutputsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutOutputsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneRequiredWithoutOutputNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamOutputUpsertWithWhereUniqueWithoutBeamInput = {
  create: BeamOutputCreateWithoutBeamInput;
  update: BeamOutputUpdateWithoutBeamInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpsertWithWhereUniqueWithoutOrderInput = {
  create: BeamOutputCreateWithoutOrderInput;
  update: BeamOutputUpdateWithoutOrderInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: BeamOutputCreateWithoutOrganizationInput;
  update: BeamOutputUpdateWithoutOrganizationInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpsertWithWhereUniqueWithoutPassInput = {
  create: BeamOutputCreateWithoutPassInput;
  update: BeamOutputUpdateWithoutPassInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpsertWithWhereUniqueWithoutUserInput = {
  create: BeamOutputCreateWithoutUserInput;
  update: BeamOutputUpdateWithoutUserInput;
  where: BeamOutputWhereUniqueInput;
};

export type BeamOutputUpsertWithoutCredentialInput = {
  create: BeamOutputCreateWithoutCredentialInput;
  update: BeamOutputUpdateWithoutCredentialInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpsertWithoutFilesInput = {
  create: BeamOutputCreateWithoutFilesInput;
  update: BeamOutputUpdateWithoutFilesInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpsertWithoutInputInput = {
  create: BeamOutputCreateWithoutInputInput;
  update: BeamOutputUpdateWithoutInputInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputUpsertWithoutRunInput = {
  create: BeamOutputCreateWithoutRunInput;
  update: BeamOutputUpdateWithoutRunInput;
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type BeamOutputWhereInput = {
  AND?: InputMaybe<Array<BeamOutputWhereInput>>;
  NOT?: InputMaybe<Array<BeamOutputWhereInput>>;
  OR?: InputMaybe<Array<BeamOutputWhereInput>>;
  beam?: InputMaybe<BeamScalarRelationFilter>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialNullableScalarRelationFilter>;
  data?: InputMaybe<JsonFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  input?: InputMaybe<BeamInputScalarRelationFilter>;
  inputId?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  pass?: InputMaybe<PassNullableScalarRelationFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  run?: InputMaybe<BeamRunScalarRelationFilter>;
  runId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BeamOutputWhereUniqueInput = {
  AND?: InputMaybe<Array<BeamOutputWhereInput>>;
  NOT?: InputMaybe<Array<BeamOutputWhereInput>>;
  OR?: InputMaybe<Array<BeamOutputWhereInput>>;
  beam?: InputMaybe<BeamScalarRelationFilter>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialNullableScalarRelationFilter>;
  data?: InputMaybe<JsonFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<BeamInputScalarRelationFilter>;
  inputId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  pass?: InputMaybe<PassNullableScalarRelationFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  run?: InputMaybe<BeamRunScalarRelationFilter>;
  runId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BeamRun = {
  __typename?: 'BeamRun';
  clientReference?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  credentialId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  inputId: Scalars['String']['output'];
  integrationJob?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  status: BeamRunStatusEnum;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BeamRunCreateManyInputInput = {
  clientReference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationJob?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<BeamRunStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamRunCreateManyInputInputEnvelope = {
  data: Array<BeamRunCreateManyInputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BeamRunCreateNestedManyWithoutInputInput = {
  connect?: InputMaybe<Array<BeamRunWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamRunCreateOrConnectWithoutInputInput>>;
  create?: InputMaybe<Array<BeamRunCreateWithoutInputInput>>;
  createMany?: InputMaybe<BeamRunCreateManyInputInputEnvelope>;
};

export type BeamRunCreateNestedOneWithoutCredentialInput = {
  connect?: InputMaybe<BeamRunWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamRunCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<BeamRunCreateWithoutCredentialInput>;
};

export type BeamRunCreateNestedOneWithoutOutputInput = {
  connect?: InputMaybe<BeamRunWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamRunCreateOrConnectWithoutOutputInput>;
  create?: InputMaybe<BeamRunCreateWithoutOutputInput>;
};

export type BeamRunCreateOrConnectWithoutCredentialInput = {
  create: BeamRunCreateWithoutCredentialInput;
  where: BeamRunWhereUniqueInput;
};

export type BeamRunCreateOrConnectWithoutInputInput = {
  create: BeamRunCreateWithoutInputInput;
  where: BeamRunWhereUniqueInput;
};

export type BeamRunCreateOrConnectWithoutOutputInput = {
  create: BeamRunCreateWithoutOutputInput;
  where: BeamRunWhereUniqueInput;
};

export type BeamRunCreateWithoutCredentialInput = {
  clientReference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutRunsInput;
  integrationJob?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutRunInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<BeamRunStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamRunCreateWithoutInputInput = {
  clientReference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutRunInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationJob?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutRunInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<BeamRunStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamRunCreateWithoutOutputInput = {
  clientReference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutRunInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutRunsInput;
  integrationJob?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<BeamRunStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BeamRunListRelationFilter = {
  every?: InputMaybe<BeamRunWhereInput>;
  none?: InputMaybe<BeamRunWhereInput>;
  some?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunNullableScalarRelationFilter = {
  is?: InputMaybe<BeamRunWhereInput>;
  isNot?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BeamRunOrderByWithRelationInput = {
  clientReference?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  credentialId?: InputMaybe<SortOrderInput>;
  error?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  input?: InputMaybe<BeamInputOrderByWithRelationInput>;
  inputId?: InputMaybe<SortOrder>;
  integrationJob?: InputMaybe<SortOrderInput>;
  output?: InputMaybe<BeamOutputOrderByWithRelationInput>;
  result?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum BeamRunScalarFieldEnum {
  ClientReference = 'clientReference',
  CreatedAt = 'createdAt',
  CredentialId = 'credentialId',
  Error = 'error',
  Id = 'id',
  InputId = 'inputId',
  IntegrationJob = 'integrationJob',
  Result = 'result',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type BeamRunScalarRelationFilter = {
  is?: InputMaybe<BeamRunWhereInput>;
  isNot?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunScalarWhereInput = {
  AND?: InputMaybe<Array<BeamRunScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeamRunScalarWhereInput>>;
  OR?: InputMaybe<Array<BeamRunScalarWhereInput>>;
  clientReference?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialId?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inputId?: InputMaybe<StringFilter>;
  integrationJob?: InputMaybe<StringNullableFilter>;
  result?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumBeamRunStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum BeamRunStatusEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type BeamRunUpdateInput = {
  clientReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutRunNestedInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutRunsNestedInput>;
  integrationJob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutRunNestedInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumBeamRunStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamRunUpdateManyMutationInput = {
  clientReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationJob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumBeamRunStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamRunUpdateManyWithWhereWithoutInputInput = {
  data: BeamRunUpdateManyMutationInput;
  where: BeamRunScalarWhereInput;
};

export type BeamRunUpdateManyWithoutInputNestedInput = {
  connect?: InputMaybe<Array<BeamRunWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamRunCreateOrConnectWithoutInputInput>>;
  create?: InputMaybe<Array<BeamRunCreateWithoutInputInput>>;
  createMany?: InputMaybe<BeamRunCreateManyInputInputEnvelope>;
  delete?: InputMaybe<Array<BeamRunWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamRunScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamRunWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamRunWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamRunUpdateWithWhereUniqueWithoutInputInput>>;
  updateMany?: InputMaybe<Array<BeamRunUpdateManyWithWhereWithoutInputInput>>;
  upsert?: InputMaybe<Array<BeamRunUpsertWithWhereUniqueWithoutInputInput>>;
};

export type BeamRunUpdateOneRequiredWithoutOutputNestedInput = {
  connect?: InputMaybe<BeamRunWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamRunCreateOrConnectWithoutOutputInput>;
  create?: InputMaybe<BeamRunCreateWithoutOutputInput>;
  update?: InputMaybe<BeamRunUpdateToOneWithWhereWithoutOutputInput>;
  upsert?: InputMaybe<BeamRunUpsertWithoutOutputInput>;
};

export type BeamRunUpdateOneWithoutCredentialNestedInput = {
  connect?: InputMaybe<BeamRunWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamRunCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<BeamRunCreateWithoutCredentialInput>;
  delete?: InputMaybe<BeamRunWhereInput>;
  disconnect?: InputMaybe<BeamRunWhereInput>;
  update?: InputMaybe<BeamRunUpdateToOneWithWhereWithoutCredentialInput>;
  upsert?: InputMaybe<BeamRunUpsertWithoutCredentialInput>;
};

export type BeamRunUpdateToOneWithWhereWithoutCredentialInput = {
  data: BeamRunUpdateWithoutCredentialInput;
  where?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunUpdateToOneWithWhereWithoutOutputInput = {
  data: BeamRunUpdateWithoutOutputInput;
  where?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunUpdateWithWhereUniqueWithoutInputInput = {
  data: BeamRunUpdateWithoutInputInput;
  where: BeamRunWhereUniqueInput;
};

export type BeamRunUpdateWithoutCredentialInput = {
  clientReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutRunsNestedInput>;
  integrationJob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutRunNestedInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumBeamRunStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamRunUpdateWithoutInputInput = {
  clientReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutRunNestedInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationJob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutRunNestedInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumBeamRunStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamRunUpdateWithoutOutputInput = {
  clientReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutRunNestedInput>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutRunsNestedInput>;
  integrationJob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumBeamRunStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type BeamRunUpsertWithWhereUniqueWithoutInputInput = {
  create: BeamRunCreateWithoutInputInput;
  update: BeamRunUpdateWithoutInputInput;
  where: BeamRunWhereUniqueInput;
};

export type BeamRunUpsertWithoutCredentialInput = {
  create: BeamRunCreateWithoutCredentialInput;
  update: BeamRunUpdateWithoutCredentialInput;
  where?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunUpsertWithoutOutputInput = {
  create: BeamRunCreateWithoutOutputInput;
  update: BeamRunUpdateWithoutOutputInput;
  where?: InputMaybe<BeamRunWhereInput>;
};

export type BeamRunWhereInput = {
  AND?: InputMaybe<Array<BeamRunWhereInput>>;
  NOT?: InputMaybe<Array<BeamRunWhereInput>>;
  OR?: InputMaybe<Array<BeamRunWhereInput>>;
  clientReference?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialNullableScalarRelationFilter>;
  credentialId?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  input?: InputMaybe<BeamInputScalarRelationFilter>;
  inputId?: InputMaybe<StringFilter>;
  integrationJob?: InputMaybe<StringNullableFilter>;
  output?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  result?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumBeamRunStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type BeamRunWhereUniqueInput = {
  AND?: InputMaybe<Array<BeamRunWhereInput>>;
  NOT?: InputMaybe<Array<BeamRunWhereInput>>;
  OR?: InputMaybe<Array<BeamRunWhereInput>>;
  clientReference?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialNullableScalarRelationFilter>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<BeamInputScalarRelationFilter>;
  inputId?: InputMaybe<StringFilter>;
  integrationJob?: InputMaybe<StringNullableFilter>;
  output?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  result?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumBeamRunStatusEnumFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum BeamScalarFieldEnum {
  Config = 'config',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  OrganizationId = 'organizationId',
  Processor = 'processor',
  ProcessorConfig = 'processorConfig',
  Source = 'source',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type BeamScalarRelationFilter = {
  is?: InputMaybe<BeamWhereInput>;
  isNot?: InputMaybe<BeamWhereInput>;
};

export type BeamScalarWhereInput = {
  AND?: InputMaybe<Array<BeamScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeamScalarWhereInput>>;
  OR?: InputMaybe<Array<BeamScalarWhereInput>>;
  config?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  processor?: InputMaybe<EnumProcessorEnumFilter>;
  processorConfig?: InputMaybe<JsonNullableFilter>;
  source?: InputMaybe<EnumBeamDataSourceEnumFilter>;
  type?: InputMaybe<EnumBeamTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BeamTypeCreateInput = {
  credentialSchema: Scalars['JSON']['input'];
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export enum BeamTypeEnum {
  BackgroundCheck = 'BACKGROUND_CHECK',
  IdVerification = 'ID_VERIFICATION',
  Other = 'OTHER'
}

export type BeamUpdateInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentialTypes?: InputMaybe<CredentialTypeUpdateManyWithoutBeamNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputTypes?: InputMaybe<BeamInputTypeUpdateManyWithoutBeamNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutBeamNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutBeamsNestedInput>;
  processor?: InputMaybe<EnumProcessorEnumFieldUpdateOperationsInput>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EnumBeamDataSourceEnumFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBeamTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BeamUpdateManyMutationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  processor?: InputMaybe<EnumProcessorEnumFieldUpdateOperationsInput>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EnumBeamDataSourceEnumFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBeamTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BeamUpdateManyWithWhereWithoutPassTypesInput = {
  data: BeamUpdateManyMutationInput;
  where: BeamScalarWhereInput;
};

export type BeamUpdateManyWithoutPassTypesNestedInput = {
  connect?: InputMaybe<Array<BeamWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BeamCreateOrConnectWithoutPassTypesInput>>;
  create?: InputMaybe<Array<BeamCreateWithoutPassTypesInput>>;
  delete?: InputMaybe<Array<BeamWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeamScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeamWhereUniqueInput>>;
  set?: InputMaybe<Array<BeamWhereUniqueInput>>;
  update?: InputMaybe<Array<BeamUpdateWithWhereUniqueWithoutPassTypesInput>>;
  updateMany?: InputMaybe<Array<BeamUpdateManyWithWhereWithoutPassTypesInput>>;
  upsert?: InputMaybe<Array<BeamUpsertWithWhereUniqueWithoutPassTypesInput>>;
};

export type BeamUpdateOneRequiredWithoutCredentialTypesNestedInput = {
  connect?: InputMaybe<BeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamCreateOrConnectWithoutCredentialTypesInput>;
  create?: InputMaybe<BeamCreateWithoutCredentialTypesInput>;
  update?: InputMaybe<BeamUpdateToOneWithWhereWithoutCredentialTypesInput>;
  upsert?: InputMaybe<BeamUpsertWithoutCredentialTypesInput>;
};

export type BeamUpdateOneRequiredWithoutInputTypesNestedInput = {
  connect?: InputMaybe<BeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamCreateOrConnectWithoutInputTypesInput>;
  create?: InputMaybe<BeamCreateWithoutInputTypesInput>;
  update?: InputMaybe<BeamUpdateToOneWithWhereWithoutInputTypesInput>;
  upsert?: InputMaybe<BeamUpsertWithoutInputTypesInput>;
};

export type BeamUpdateOneRequiredWithoutOutputsNestedInput = {
  connect?: InputMaybe<BeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BeamCreateOrConnectWithoutOutputsInput>;
  create?: InputMaybe<BeamCreateWithoutOutputsInput>;
  update?: InputMaybe<BeamUpdateToOneWithWhereWithoutOutputsInput>;
  upsert?: InputMaybe<BeamUpsertWithoutOutputsInput>;
};

export type BeamUpdateToOneWithWhereWithoutCredentialTypesInput = {
  data: BeamUpdateWithoutCredentialTypesInput;
  where?: InputMaybe<BeamWhereInput>;
};

export type BeamUpdateToOneWithWhereWithoutInputTypesInput = {
  data: BeamUpdateWithoutInputTypesInput;
  where?: InputMaybe<BeamWhereInput>;
};

export type BeamUpdateToOneWithWhereWithoutOutputsInput = {
  data: BeamUpdateWithoutOutputsInput;
  where?: InputMaybe<BeamWhereInput>;
};

export type BeamUpdateWithWhereUniqueWithoutPassTypesInput = {
  data: BeamUpdateWithoutPassTypesInput;
  where: BeamWhereUniqueInput;
};

export type BeamUpdateWithoutCredentialTypesInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputTypes?: InputMaybe<BeamInputTypeUpdateManyWithoutBeamNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutBeamNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutBeamsNestedInput>;
  processor?: InputMaybe<EnumProcessorEnumFieldUpdateOperationsInput>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EnumBeamDataSourceEnumFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBeamTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BeamUpdateWithoutInputTypesInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentialTypes?: InputMaybe<CredentialTypeUpdateManyWithoutBeamNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutBeamNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutBeamsNestedInput>;
  processor?: InputMaybe<EnumProcessorEnumFieldUpdateOperationsInput>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EnumBeamDataSourceEnumFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBeamTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BeamUpdateWithoutOutputsInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentialTypes?: InputMaybe<CredentialTypeUpdateManyWithoutBeamNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputTypes?: InputMaybe<BeamInputTypeUpdateManyWithoutBeamNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutBeamsNestedInput>;
  processor?: InputMaybe<EnumProcessorEnumFieldUpdateOperationsInput>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EnumBeamDataSourceEnumFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBeamTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BeamUpdateWithoutPassTypesInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentialTypes?: InputMaybe<CredentialTypeUpdateManyWithoutBeamNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputTypes?: InputMaybe<BeamInputTypeUpdateManyWithoutBeamNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutBeamNestedInput>;
  processor?: InputMaybe<EnumProcessorEnumFieldUpdateOperationsInput>;
  processorConfig?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<EnumBeamDataSourceEnumFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumBeamTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BeamUpsertWithWhereUniqueWithoutPassTypesInput = {
  create: BeamCreateWithoutPassTypesInput;
  update: BeamUpdateWithoutPassTypesInput;
  where: BeamWhereUniqueInput;
};

export type BeamUpsertWithoutCredentialTypesInput = {
  create: BeamCreateWithoutCredentialTypesInput;
  update: BeamUpdateWithoutCredentialTypesInput;
  where?: InputMaybe<BeamWhereInput>;
};

export type BeamUpsertWithoutInputTypesInput = {
  create: BeamCreateWithoutInputTypesInput;
  update: BeamUpdateWithoutInputTypesInput;
  where?: InputMaybe<BeamWhereInput>;
};

export type BeamUpsertWithoutOutputsInput = {
  create: BeamCreateWithoutOutputsInput;
  update: BeamUpdateWithoutOutputsInput;
  where?: InputMaybe<BeamWhereInput>;
};

export type BeamWhereInput = {
  AND?: InputMaybe<Array<BeamWhereInput>>;
  NOT?: InputMaybe<Array<BeamWhereInput>>;
  OR?: InputMaybe<Array<BeamWhereInput>>;
  config?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialTypes?: InputMaybe<CredentialTypeListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  inputTypes?: InputMaybe<BeamInputTypeListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  outputs?: InputMaybe<BeamOutputListRelationFilter>;
  passTypes?: InputMaybe<PassTypeListRelationFilter>;
  processor?: InputMaybe<EnumProcessorEnumFilter>;
  processorConfig?: InputMaybe<JsonNullableFilter>;
  source?: InputMaybe<EnumBeamDataSourceEnumFilter>;
  type?: InputMaybe<EnumBeamTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BeamWhereUniqueInput = {
  AND?: InputMaybe<Array<BeamWhereInput>>;
  NOT?: InputMaybe<Array<BeamWhereInput>>;
  OR?: InputMaybe<Array<BeamWhereInput>>;
  config?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialTypes?: InputMaybe<CredentialTypeListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputTypes?: InputMaybe<BeamInputTypeListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  outputs?: InputMaybe<BeamOutputListRelationFilter>;
  passTypes?: InputMaybe<PassTypeListRelationFilter>;
  processor?: InputMaybe<EnumProcessorEnumFilter>;
  processorConfig?: InputMaybe<JsonNullableFilter>;
  source?: InputMaybe<EnumBeamDataSourceEnumFilter>;
  type?: InputMaybe<EnumBeamTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BiometricConsentAcceptance = {
  __typename?: 'BiometricConsentAcceptance';
  createdAt: Scalars['DateTimeISO']['output'];
  disclosure: Disclosure;
  disclosureId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  minorConsentAccepted: Scalars['Boolean']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type BiometricConsentAcceptanceOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type BiometricConsentAcceptancePdfArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type BiometricConsentAcceptanceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosure: DisclosureCreateNestedOneWithoutBiometricConsentAcceptancesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBiometricConsentAcceptancesInput;
};

export type BiometricConsentAcceptanceCreateManyDisclosureInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type BiometricConsentAcceptanceCreateManyDisclosureInputEnvelope = {
  data: Array<BiometricConsentAcceptanceCreateManyDisclosureInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BiometricConsentAcceptanceCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BiometricConsentAcceptanceCreateManyUserInputEnvelope = {
  data: Array<BiometricConsentAcceptanceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BiometricConsentAcceptanceCreateNestedManyWithoutDisclosureInput = {
  connect?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BiometricConsentAcceptanceCreateOrConnectWithoutDisclosureInput>>;
  create?: InputMaybe<Array<BiometricConsentAcceptanceCreateWithoutDisclosureInput>>;
  createMany?: InputMaybe<BiometricConsentAcceptanceCreateManyDisclosureInputEnvelope>;
};

export type BiometricConsentAcceptanceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BiometricConsentAcceptanceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BiometricConsentAcceptanceCreateWithoutUserInput>>;
  createMany?: InputMaybe<BiometricConsentAcceptanceCreateManyUserInputEnvelope>;
};

export type BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BiometricConsentAcceptanceCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<BiometricConsentAcceptanceCreateWithoutOrderInput>;
};

export type BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput = {
  connect?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BiometricConsentAcceptanceCreateOrConnectWithoutPdfInput>;
  create?: InputMaybe<BiometricConsentAcceptanceCreateWithoutPdfInput>;
};

export type BiometricConsentAcceptanceCreateOrConnectWithoutDisclosureInput = {
  create: BiometricConsentAcceptanceCreateWithoutDisclosureInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceCreateOrConnectWithoutOrderInput = {
  create: BiometricConsentAcceptanceCreateWithoutOrderInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceCreateOrConnectWithoutPdfInput = {
  create: BiometricConsentAcceptanceCreateWithoutPdfInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceCreateOrConnectWithoutUserInput = {
  create: BiometricConsentAcceptanceCreateWithoutUserInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceCreateWithoutDisclosureInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBiometricConsentAcceptancesInput;
};

export type BiometricConsentAcceptanceCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosure: DisclosureCreateNestedOneWithoutBiometricConsentAcceptancesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBiometricConsentAcceptancesInput;
};

export type BiometricConsentAcceptanceCreateWithoutPdfInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosure: DisclosureCreateNestedOneWithoutBiometricConsentAcceptancesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutBiometricConsentAcceptancesInput;
};

export type BiometricConsentAcceptanceCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosure: DisclosureCreateNestedOneWithoutBiometricConsentAcceptancesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutBiometricConsentAcceptanceInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type BiometricConsentAcceptanceListRelationFilter = {
  every?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  none?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  some?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};

export type BiometricConsentAcceptanceNullableScalarRelationFilter = {
  is?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  isNot?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};

export type BiometricConsentAcceptanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BiometricConsentAcceptanceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  disclosure?: InputMaybe<DisclosureOrderByWithRelationInput>;
  disclosureId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  minorConsentAccepted?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  pdf?: InputMaybe<FileOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum BiometricConsentAcceptanceScalarFieldEnum {
  CreatedAt = 'createdAt',
  DisclosureId = 'disclosureId',
  Id = 'id',
  MinorConsentAccepted = 'minorConsentAccepted',
  OrderId = 'orderId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type BiometricConsentAcceptanceScalarWhereInput = {
  AND?: InputMaybe<Array<BiometricConsentAcceptanceScalarWhereInput>>;
  NOT?: InputMaybe<Array<BiometricConsentAcceptanceScalarWhereInput>>;
  OR?: InputMaybe<Array<BiometricConsentAcceptanceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosureId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  minorConsentAccepted?: InputMaybe<BoolFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BiometricConsentAcceptanceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  minorConsentAccepted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BiometricConsentAcceptanceUpdateManyWithWhereWithoutDisclosureInput = {
  data: BiometricConsentAcceptanceUpdateManyMutationInput;
  where: BiometricConsentAcceptanceScalarWhereInput;
};

export type BiometricConsentAcceptanceUpdateManyWithWhereWithoutUserInput = {
  data: BiometricConsentAcceptanceUpdateManyMutationInput;
  where: BiometricConsentAcceptanceScalarWhereInput;
};

export type BiometricConsentAcceptanceUpdateManyWithoutDisclosureNestedInput = {
  connect?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BiometricConsentAcceptanceCreateOrConnectWithoutDisclosureInput>>;
  create?: InputMaybe<Array<BiometricConsentAcceptanceCreateWithoutDisclosureInput>>;
  createMany?: InputMaybe<BiometricConsentAcceptanceCreateManyDisclosureInputEnvelope>;
  delete?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BiometricConsentAcceptanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  set?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  update?: InputMaybe<Array<BiometricConsentAcceptanceUpdateWithWhereUniqueWithoutDisclosureInput>>;
  updateMany?: InputMaybe<Array<BiometricConsentAcceptanceUpdateManyWithWhereWithoutDisclosureInput>>;
  upsert?: InputMaybe<Array<BiometricConsentAcceptanceUpsertWithWhereUniqueWithoutDisclosureInput>>;
};

export type BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BiometricConsentAcceptanceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<BiometricConsentAcceptanceCreateWithoutUserInput>>;
  createMany?: InputMaybe<BiometricConsentAcceptanceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BiometricConsentAcceptanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  set?: InputMaybe<Array<BiometricConsentAcceptanceWhereUniqueInput>>;
  update?: InputMaybe<Array<BiometricConsentAcceptanceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<BiometricConsentAcceptanceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<BiometricConsentAcceptanceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BiometricConsentAcceptanceCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<BiometricConsentAcceptanceCreateWithoutOrderInput>;
  delete?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  disconnect?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  update?: InputMaybe<BiometricConsentAcceptanceUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<BiometricConsentAcceptanceUpsertWithoutOrderInput>;
};

export type BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput = {
  connect?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BiometricConsentAcceptanceCreateOrConnectWithoutPdfInput>;
  create?: InputMaybe<BiometricConsentAcceptanceCreateWithoutPdfInput>;
  delete?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  disconnect?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
  update?: InputMaybe<BiometricConsentAcceptanceUpdateToOneWithWhereWithoutPdfInput>;
  upsert?: InputMaybe<BiometricConsentAcceptanceUpsertWithoutPdfInput>;
};

export type BiometricConsentAcceptanceUpdateToOneWithWhereWithoutOrderInput = {
  data: BiometricConsentAcceptanceUpdateWithoutOrderInput;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};

export type BiometricConsentAcceptanceUpdateToOneWithWhereWithoutPdfInput = {
  data: BiometricConsentAcceptanceUpdateWithoutPdfInput;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};

export type BiometricConsentAcceptanceUpdateWithWhereUniqueWithoutDisclosureInput = {
  data: BiometricConsentAcceptanceUpdateWithoutDisclosureInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceUpdateWithWhereUniqueWithoutUserInput = {
  data: BiometricConsentAcceptanceUpdateWithoutUserInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceUpdateWithoutDisclosureInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  minorConsentAccepted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBiometricConsentAcceptanceNestedInput>;
  pdf?: InputMaybe<FileUpdateOneWithoutBiometricConsentAcceptanceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput>;
};

export type BiometricConsentAcceptanceUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosure?: InputMaybe<DisclosureUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  minorConsentAccepted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  pdf?: InputMaybe<FileUpdateOneWithoutBiometricConsentAcceptanceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput>;
};

export type BiometricConsentAcceptanceUpdateWithoutPdfInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosure?: InputMaybe<DisclosureUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  minorConsentAccepted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBiometricConsentAcceptanceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput>;
};

export type BiometricConsentAcceptanceUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosure?: InputMaybe<DisclosureUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  minorConsentAccepted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutBiometricConsentAcceptanceNestedInput>;
  pdf?: InputMaybe<FileUpdateOneWithoutBiometricConsentAcceptanceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BiometricConsentAcceptanceUpsertWithWhereUniqueWithoutDisclosureInput = {
  create: BiometricConsentAcceptanceCreateWithoutDisclosureInput;
  update: BiometricConsentAcceptanceUpdateWithoutDisclosureInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceUpsertWithWhereUniqueWithoutUserInput = {
  create: BiometricConsentAcceptanceCreateWithoutUserInput;
  update: BiometricConsentAcceptanceUpdateWithoutUserInput;
  where: BiometricConsentAcceptanceWhereUniqueInput;
};

export type BiometricConsentAcceptanceUpsertWithoutOrderInput = {
  create: BiometricConsentAcceptanceCreateWithoutOrderInput;
  update: BiometricConsentAcceptanceUpdateWithoutOrderInput;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};

export type BiometricConsentAcceptanceUpsertWithoutPdfInput = {
  create: BiometricConsentAcceptanceCreateWithoutPdfInput;
  update: BiometricConsentAcceptanceUpdateWithoutPdfInput;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};

export type BiometricConsentAcceptanceWhereInput = {
  AND?: InputMaybe<Array<BiometricConsentAcceptanceWhereInput>>;
  NOT?: InputMaybe<Array<BiometricConsentAcceptanceWhereInput>>;
  OR?: InputMaybe<Array<BiometricConsentAcceptanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosure?: InputMaybe<DisclosureScalarRelationFilter>;
  disclosureId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  minorConsentAccepted?: InputMaybe<BoolFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  pdf?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BiometricConsentAcceptanceWhereUniqueInput = {
  AND?: InputMaybe<Array<BiometricConsentAcceptanceWhereInput>>;
  NOT?: InputMaybe<Array<BiometricConsentAcceptanceWhereInput>>;
  OR?: InputMaybe<Array<BiometricConsentAcceptanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosure?: InputMaybe<DisclosureScalarRelationFilter>;
  disclosureId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  minorConsentAccepted?: InputMaybe<BoolFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BytesFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Byte']['input']>;
};

export type BytesFilter = {
  equals?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<Scalars['Byte']['input']>>;
  not?: InputMaybe<NestedBytesFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']['input']>>;
};

export type BytesNullableFilter = {
  equals?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<Scalars['Byte']['input']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']['input']>>;
};

export type CheckEmailVerifiedResponse = {
  __typename?: 'CheckEmailVerifiedResponse';
  email?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type ComplianceLetter = {
  __typename?: 'ComplianceLetter';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  lastViewedDate?: Maybe<Scalars['DateTimeISO']['output']>;
  name: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  sentDate: Scalars['DateTimeISO']['output'];
  type: AttachmentEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ComplianceLetterCreateManyOrderInput = {
  createdAt: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastViewedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  sentDate: Scalars['DateTimeISO']['input'];
  type: AttachmentEnum;
  updatedAt: Scalars['DateTimeISO']['input'];
};

export type ComplianceLetterCreateManyOrderInputEnvelope = {
  data: Array<ComplianceLetterCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplianceLetterCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ComplianceLetterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ComplianceLetterCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ComplianceLetterCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ComplianceLetterCreateManyOrderInputEnvelope>;
};

export type ComplianceLetterCreateOrConnectWithoutOrderInput = {
  create: ComplianceLetterCreateWithoutOrderInput;
  where: ComplianceLetterWhereUniqueInput;
};

export type ComplianceLetterCreateWithoutOrderInput = {
  createdAt: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastViewedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  sentDate: Scalars['DateTimeISO']['input'];
  type: AttachmentEnum;
  updatedAt: Scalars['DateTimeISO']['input'];
};

export type ComplianceLetterListRelationFilter = {
  every?: InputMaybe<ComplianceLetterWhereInput>;
  none?: InputMaybe<ComplianceLetterWhereInput>;
  some?: InputMaybe<ComplianceLetterWhereInput>;
};

export type ComplianceLetterOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ComplianceLetterOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastViewedDate?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  sentDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ComplianceLetterScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LastViewedDate = 'lastViewedDate',
  Name = 'name',
  OrderId = 'orderId',
  SentDate = 'sentDate',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type ComplianceLetterScalarWhereInput = {
  AND?: InputMaybe<Array<ComplianceLetterScalarWhereInput>>;
  NOT?: InputMaybe<Array<ComplianceLetterScalarWhereInput>>;
  OR?: InputMaybe<Array<ComplianceLetterScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lastViewedDate?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  sentDate?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<EnumAttachmentEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ComplianceLetterUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastViewedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sentDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAttachmentEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ComplianceLetterUpdateManyWithWhereWithoutOrderInput = {
  data: ComplianceLetterUpdateManyMutationInput;
  where: ComplianceLetterScalarWhereInput;
};

export type ComplianceLetterUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ComplianceLetterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ComplianceLetterCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ComplianceLetterCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ComplianceLetterCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ComplianceLetterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ComplianceLetterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ComplianceLetterWhereUniqueInput>>;
  set?: InputMaybe<Array<ComplianceLetterWhereUniqueInput>>;
  update?: InputMaybe<Array<ComplianceLetterUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ComplianceLetterUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ComplianceLetterUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ComplianceLetterUpdateWithWhereUniqueWithoutOrderInput = {
  data: ComplianceLetterUpdateWithoutOrderInput;
  where: ComplianceLetterWhereUniqueInput;
};

export type ComplianceLetterUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastViewedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sentDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAttachmentEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ComplianceLetterUpsertWithWhereUniqueWithoutOrderInput = {
  create: ComplianceLetterCreateWithoutOrderInput;
  update: ComplianceLetterUpdateWithoutOrderInput;
  where: ComplianceLetterWhereUniqueInput;
};

export type ComplianceLetterWhereInput = {
  AND?: InputMaybe<Array<ComplianceLetterWhereInput>>;
  NOT?: InputMaybe<Array<ComplianceLetterWhereInput>>;
  OR?: InputMaybe<Array<ComplianceLetterWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lastViewedDate?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  sentDate?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<EnumAttachmentEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ComplianceLetterWhereUniqueInput = {
  AND?: InputMaybe<Array<ComplianceLetterWhereInput>>;
  NOT?: InputMaybe<Array<ComplianceLetterWhereInput>>;
  OR?: InputMaybe<Array<ComplianceLetterWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastViewedDate?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  sentDate?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<EnumAttachmentEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ContactInformationInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInformationOutput = {
  __typename?: 'ContactInformationOutput';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  primaryContactMethod?: Maybe<UserPrimaryContactEnum>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type CreateIdentityRecheckOrderInput = {
  biometricConsentAcceptanceId: Scalars['String']['input'];
  data: ExtendedOrderCreateInput;
  orderFrom?: InputMaybe<Platform>;
  selfieFileId: Scalars['String']['input'];
};

export type CreateManyVidVoucherRes = {
  __typename?: 'CreateManyVidVoucherRes';
  data: Array<CreateOneVidVoucherRes>;
  errors?: Maybe<Array<InviteErrorResponse>>;
};

export type CreateOneVidVoucherInput = {
  contactInformation: ContactInformationInput;
  deliveryMethod: VIdInviteDeliveryMethodEnum;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<VoucherOrigin>;
  packageId: Scalars['String']['input'];
  passTypeId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOneVidVoucherRes = {
  __typename?: 'CreateOneVidVoucherRes';
  inviteData: InviteDataOutputRes;
  inviteExpiry: Scalars['String']['output'];
  inviteId: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  vIDInviteUrl: Scalars['String']['output'];
  vIDQRCode: Scalars['String']['output'];
  vIDShortCode: Scalars['String']['output'];
};

export type CreateOneVidWebVoucherRes = {
  __typename?: 'CreateOneVidWebVoucherRes';
  inviteData: InviteDataOutputRes;
  inviteExpiry: Scalars['String']['output'];
  inviteId: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  vIDInviteUrl: Scalars['String']['output'];
  vIDQRCode: Scalars['String']['output'];
  vIDShortCode: Scalars['String']['output'];
  vIDWebUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateSupportTicketResponse = {
  __typename?: 'CreateSupportTicketResponse';
  success: Scalars['Boolean']['output'];
  ticketId?: Maybe<Scalars['String']['output']>;
};

export type Credential = {
  __typename?: 'Credential';
  _count?: Maybe<CredentialCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  input: BeamInput;
  inputId: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  output?: Maybe<BeamOutput>;
  outputId?: Maybe<Scalars['String']['output']>;
  pass?: Maybe<Pass>;
  passId?: Maybe<Scalars['String']['output']>;
  run?: Maybe<BeamRun>;
  status?: Maybe<CredentialStatus>;
  type: CredentialType;
  typeId: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
  walletShares: Array<WalletShare>;
};


export type CredentialOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type CredentialOutputArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type CredentialPassArgs = {
  where?: InputMaybe<PassWhereInput>;
};


export type CredentialRunArgs = {
  where?: InputMaybe<BeamRunWhereInput>;
};


export type CredentialStatusArgs = {
  where?: InputMaybe<CredentialStatusWhereInput>;
};


export type CredentialWalletSharesArgs = {
  cursor?: InputMaybe<WalletShareWhereUniqueInput>;
  distinct?: InputMaybe<Array<WalletShareScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WalletShareOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WalletShareWhereInput>;
};

export type CredentialCount = {
  __typename?: 'CredentialCount';
  walletShares: Scalars['Int']['output'];
};


export type CredentialCountWalletSharesArgs = {
  where?: InputMaybe<WalletShareWhereInput>;
};

export type CredentialCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  outputId?: InputMaybe<Scalars['String']['input']>;
  passId?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CredentialCreateManyOrganizationInputEnvelope = {
  data: Array<CredentialCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialCreateManyPassInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  outputId?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CredentialCreateManyPassInputEnvelope = {
  data: Array<CredentialCreateManyPassInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialCreateManyTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  outputId?: InputMaybe<Scalars['String']['input']>;
  passId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CredentialCreateManyTypeInputEnvelope = {
  data: Array<CredentialCreateManyTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  outputId?: InputMaybe<Scalars['String']['input']>;
  passId?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
};

export type CredentialCreateManyUserInputEnvelope = {
  data: Array<CredentialCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<CredentialCreateManyOrganizationInputEnvelope>;
};

export type CredentialCreateNestedManyWithoutPassInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutPassInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutPassInput>>;
  createMany?: InputMaybe<CredentialCreateManyPassInputEnvelope>;
};

export type CredentialCreateNestedManyWithoutTypeInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutTypeInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutTypeInput>>;
  createMany?: InputMaybe<CredentialCreateManyTypeInputEnvelope>;
};

export type CredentialCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutUserInput>>;
  createMany?: InputMaybe<CredentialCreateManyUserInputEnvelope>;
};

export type CredentialCreateNestedOneWithoutInputInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutInputInput>;
  create?: InputMaybe<CredentialCreateWithoutInputInput>;
};

export type CredentialCreateNestedOneWithoutOutputInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutOutputInput>;
  create?: InputMaybe<CredentialCreateWithoutOutputInput>;
};

export type CredentialCreateNestedOneWithoutRunInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutRunInput>;
  create?: InputMaybe<CredentialCreateWithoutRunInput>;
};

export type CredentialCreateNestedOneWithoutStatusInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutStatusInput>;
  create?: InputMaybe<CredentialCreateWithoutStatusInput>;
};

export type CredentialCreateNestedOneWithoutWalletSharesInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutWalletSharesInput>;
  create?: InputMaybe<CredentialCreateWithoutWalletSharesInput>;
};

export type CredentialCreateOrConnectWithoutInputInput = {
  create: CredentialCreateWithoutInputInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutOrganizationInput = {
  create: CredentialCreateWithoutOrganizationInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutOutputInput = {
  create: CredentialCreateWithoutOutputInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutPassInput = {
  create: CredentialCreateWithoutPassInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutRunInput = {
  create: CredentialCreateWithoutRunInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutStatusInput = {
  create: CredentialCreateWithoutStatusInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutTypeInput = {
  create: CredentialCreateWithoutTypeInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutUserInput = {
  create: CredentialCreateWithoutUserInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutWalletSharesInput = {
  create: CredentialCreateWithoutWalletSharesInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateWithoutInputInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutOutputInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutPassInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutRunInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutStatusInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  user: UserCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutCredentialInput>;
};

export type CredentialCreateWithoutWalletSharesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  input: BeamInputCreateNestedOneWithoutCredentialInput;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCredentialsInput>;
  output?: InputMaybe<BeamOutputCreateNestedOneWithoutCredentialInput>;
  pass?: InputMaybe<PassCreateNestedOneWithoutCredentialsInput>;
  run?: InputMaybe<BeamRunCreateNestedOneWithoutCredentialInput>;
  status?: InputMaybe<CredentialStatusCreateNestedOneWithoutCredentialInput>;
  type: CredentialTypeCreateNestedOneWithoutCredentialsInput;
  user: UserCreateNestedOneWithoutCredentialsInput;
};

export type CredentialListRelationFilter = {
  every?: InputMaybe<CredentialWhereInput>;
  none?: InputMaybe<CredentialWhereInput>;
  some?: InputMaybe<CredentialWhereInput>;
};

export type CredentialNullableScalarRelationFilter = {
  is?: InputMaybe<CredentialWhereInput>;
  isNot?: InputMaybe<CredentialWhereInput>;
};

export type CredentialOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CredentialOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  input?: InputMaybe<BeamInputOrderByWithRelationInput>;
  inputId?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  output?: InputMaybe<BeamOutputOrderByWithRelationInput>;
  outputId?: InputMaybe<SortOrderInput>;
  pass?: InputMaybe<PassOrderByWithRelationInput>;
  passId?: InputMaybe<SortOrderInput>;
  run?: InputMaybe<BeamRunOrderByWithRelationInput>;
  status?: InputMaybe<CredentialStatusOrderByWithRelationInput>;
  type?: InputMaybe<CredentialTypeOrderByWithRelationInput>;
  typeId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  walletShares?: InputMaybe<WalletShareOrderByRelationAggregateInput>;
};

export enum CredentialScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  InputId = 'inputId',
  OrganizationId = 'organizationId',
  OutputId = 'outputId',
  PassId = 'passId',
  TypeId = 'typeId',
  UserId = 'userId'
}

export type CredentialScalarRelationFilter = {
  is?: InputMaybe<CredentialWhereInput>;
  isNot?: InputMaybe<CredentialWhereInput>;
};

export type CredentialScalarWhereInput = {
  AND?: InputMaybe<Array<CredentialScalarWhereInput>>;
  NOT?: InputMaybe<Array<CredentialScalarWhereInput>>;
  OR?: InputMaybe<Array<CredentialScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  inputId?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  outputId?: InputMaybe<StringNullableFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  typeId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CredentialStatus = {
  __typename?: 'CredentialStatus';
  createdAt: Scalars['DateTimeISO']['output'];
  credential: Credential;
  credentialId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  value: CredentialStatusEnum;
};

export type CredentialStatusCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential: CredentialCreateNestedOneWithoutStatusInput;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value: CredentialStatusEnum;
};

export type CredentialStatusCreateNestedOneWithoutCredentialInput = {
  connect?: InputMaybe<CredentialStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialStatusCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<CredentialStatusCreateWithoutCredentialInput>;
};

export type CredentialStatusCreateOrConnectWithoutCredentialInput = {
  create: CredentialStatusCreateWithoutCredentialInput;
  where: CredentialStatusWhereUniqueInput;
};

export type CredentialStatusCreateWithoutCredentialInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value: CredentialStatusEnum;
};

export enum CredentialStatusEnum {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type CredentialStatusNullableScalarRelationFilter = {
  is?: InputMaybe<CredentialStatusWhereInput>;
  isNot?: InputMaybe<CredentialStatusWhereInput>;
};

export type CredentialStatusOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  credentialId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type CredentialStatusUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneRequiredWithoutStatusNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<EnumCredentialStatusEnumFieldUpdateOperationsInput>;
};

export type CredentialStatusUpdateOneWithoutCredentialNestedInput = {
  connect?: InputMaybe<CredentialStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialStatusCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<CredentialStatusCreateWithoutCredentialInput>;
  delete?: InputMaybe<CredentialStatusWhereInput>;
  disconnect?: InputMaybe<CredentialStatusWhereInput>;
  update?: InputMaybe<CredentialStatusUpdateToOneWithWhereWithoutCredentialInput>;
  upsert?: InputMaybe<CredentialStatusUpsertWithoutCredentialInput>;
};

export type CredentialStatusUpdateToOneWithWhereWithoutCredentialInput = {
  data: CredentialStatusUpdateWithoutCredentialInput;
  where?: InputMaybe<CredentialStatusWhereInput>;
};

export type CredentialStatusUpdateWithoutCredentialInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<EnumCredentialStatusEnumFieldUpdateOperationsInput>;
};

export type CredentialStatusUpsertWithoutCredentialInput = {
  create: CredentialStatusCreateWithoutCredentialInput;
  update: CredentialStatusUpdateWithoutCredentialInput;
  where?: InputMaybe<CredentialStatusWhereInput>;
};

export type CredentialStatusWhereInput = {
  AND?: InputMaybe<Array<CredentialStatusWhereInput>>;
  NOT?: InputMaybe<Array<CredentialStatusWhereInput>>;
  OR?: InputMaybe<Array<CredentialStatusWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialScalarRelationFilter>;
  credentialId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<EnumCredentialStatusEnumFilter>;
};

export type CredentialStatusWhereUniqueInput = {
  AND?: InputMaybe<Array<CredentialStatusWhereInput>>;
  NOT?: InputMaybe<Array<CredentialStatusWhereInput>>;
  OR?: InputMaybe<Array<CredentialStatusWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialScalarRelationFilter>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<EnumCredentialStatusEnumFilter>;
};

export type CredentialType = {
  __typename?: 'CredentialType';
  _count?: Maybe<CredentialTypeCount>;
  beam: Beam;
  beamId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  credentials: Array<Credential>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  schema: Scalars['JSON']['output'];
  slug: Scalars['String']['output'];
  version: Scalars['String']['output'];
};


export type CredentialTypeCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialTypeCount = {
  __typename?: 'CredentialTypeCount';
  credentials: Scalars['Int']['output'];
};


export type CredentialTypeCountCredentialsArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialTypeCreateInput = {
  beam: BeamCreateNestedOneWithoutCredentialTypesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutTypeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CredentialTypeCreateManyBeamInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CredentialTypeCreateManyBeamInputEnvelope = {
  data: Array<CredentialTypeCreateManyBeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialTypeCreateNestedManyWithoutBeamInput = {
  connect?: InputMaybe<Array<CredentialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialTypeCreateOrConnectWithoutBeamInput>>;
  create?: InputMaybe<Array<CredentialTypeCreateWithoutBeamInput>>;
  createMany?: InputMaybe<CredentialTypeCreateManyBeamInputEnvelope>;
};

export type CredentialTypeCreateNestedOneWithoutCredentialsInput = {
  connect?: InputMaybe<CredentialTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialTypeCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<CredentialTypeCreateWithoutCredentialsInput>;
};

export type CredentialTypeCreateOrConnectWithoutBeamInput = {
  create: CredentialTypeCreateWithoutBeamInput;
  where: CredentialTypeWhereUniqueInput;
};

export type CredentialTypeCreateOrConnectWithoutCredentialsInput = {
  create: CredentialTypeCreateWithoutCredentialsInput;
  where: CredentialTypeWhereUniqueInput;
};

export type CredentialTypeCreateWithoutBeamInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutTypeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CredentialTypeCreateWithoutCredentialsInput = {
  beam: BeamCreateNestedOneWithoutCredentialTypesInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CredentialTypeListRelationFilter = {
  every?: InputMaybe<CredentialTypeWhereInput>;
  none?: InputMaybe<CredentialTypeWhereInput>;
  some?: InputMaybe<CredentialTypeWhereInput>;
};

export type CredentialTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CredentialTypeOrderByWithRelationInput = {
  beam?: InputMaybe<BeamOrderByWithRelationInput>;
  beamId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credentials?: InputMaybe<CredentialOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrderInput>;
  schema?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export enum CredentialTypeScalarFieldEnum {
  BeamId = 'beamId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  OrganizationId = 'organizationId',
  Schema = 'schema',
  Slug = 'slug',
  Version = 'version'
}

export type CredentialTypeScalarRelationFilter = {
  is?: InputMaybe<CredentialTypeWhereInput>;
  isNot?: InputMaybe<CredentialTypeWhereInput>;
};

export type CredentialTypeScalarWhereInput = {
  AND?: InputMaybe<Array<CredentialTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<CredentialTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<CredentialTypeScalarWhereInput>>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  schema?: InputMaybe<JsonFilter>;
  slug?: InputMaybe<StringFilter>;
  version?: InputMaybe<StringFilter>;
};

export type CredentialTypeSlugVersionCompoundUniqueInput = {
  slug: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CredentialTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CredentialTypeUpdateManyWithWhereWithoutBeamInput = {
  data: CredentialTypeUpdateManyMutationInput;
  where: CredentialTypeScalarWhereInput;
};

export type CredentialTypeUpdateManyWithoutBeamNestedInput = {
  connect?: InputMaybe<Array<CredentialTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialTypeCreateOrConnectWithoutBeamInput>>;
  create?: InputMaybe<Array<CredentialTypeCreateWithoutBeamInput>>;
  createMany?: InputMaybe<CredentialTypeCreateManyBeamInputEnvelope>;
  delete?: InputMaybe<Array<CredentialTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialTypeUpdateWithWhereUniqueWithoutBeamInput>>;
  updateMany?: InputMaybe<Array<CredentialTypeUpdateManyWithWhereWithoutBeamInput>>;
  upsert?: InputMaybe<Array<CredentialTypeUpsertWithWhereUniqueWithoutBeamInput>>;
};

export type CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput = {
  connect?: InputMaybe<CredentialTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialTypeCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<CredentialTypeCreateWithoutCredentialsInput>;
  update?: InputMaybe<CredentialTypeUpdateToOneWithWhereWithoutCredentialsInput>;
  upsert?: InputMaybe<CredentialTypeUpsertWithoutCredentialsInput>;
};

export type CredentialTypeUpdateToOneWithWhereWithoutCredentialsInput = {
  data: CredentialTypeUpdateWithoutCredentialsInput;
  where?: InputMaybe<CredentialTypeWhereInput>;
};

export type CredentialTypeUpdateWithWhereUniqueWithoutBeamInput = {
  data: CredentialTypeUpdateWithoutBeamInput;
  where: CredentialTypeWhereUniqueInput;
};

export type CredentialTypeUpdateWithoutBeamInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CredentialTypeUpdateWithoutCredentialsInput = {
  beam?: InputMaybe<BeamUpdateOneRequiredWithoutCredentialTypesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CredentialTypeUpsertWithWhereUniqueWithoutBeamInput = {
  create: CredentialTypeCreateWithoutBeamInput;
  update: CredentialTypeUpdateWithoutBeamInput;
  where: CredentialTypeWhereUniqueInput;
};

export type CredentialTypeUpsertWithoutCredentialsInput = {
  create: CredentialTypeCreateWithoutCredentialsInput;
  update: CredentialTypeUpdateWithoutCredentialsInput;
  where?: InputMaybe<CredentialTypeWhereInput>;
};

export type CredentialTypeWhereInput = {
  AND?: InputMaybe<Array<CredentialTypeWhereInput>>;
  NOT?: InputMaybe<Array<CredentialTypeWhereInput>>;
  OR?: InputMaybe<Array<CredentialTypeWhereInput>>;
  beam?: InputMaybe<BeamScalarRelationFilter>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  schema?: InputMaybe<JsonFilter>;
  slug?: InputMaybe<StringFilter>;
  version?: InputMaybe<StringFilter>;
};

export type CredentialTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<CredentialTypeWhereInput>>;
  NOT?: InputMaybe<Array<CredentialTypeWhereInput>>;
  OR?: InputMaybe<Array<CredentialTypeWhereInput>>;
  beam?: InputMaybe<BeamScalarRelationFilter>;
  beamId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  schema?: InputMaybe<JsonFilter>;
  slug?: InputMaybe<StringFilter>;
  slug_version?: InputMaybe<CredentialTypeSlugVersionCompoundUniqueInput>;
  version?: InputMaybe<StringFilter>;
};

export type CredentialUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CredentialUpdateManyWithWhereWithoutOrganizationInput = {
  data: CredentialUpdateManyMutationInput;
  where: CredentialScalarWhereInput;
};

export type CredentialUpdateManyWithWhereWithoutPassInput = {
  data: CredentialUpdateManyMutationInput;
  where: CredentialScalarWhereInput;
};

export type CredentialUpdateManyWithWhereWithoutTypeInput = {
  data: CredentialUpdateManyMutationInput;
  where: CredentialScalarWhereInput;
};

export type CredentialUpdateManyWithWhereWithoutUserInput = {
  data: CredentialUpdateManyMutationInput;
  where: CredentialScalarWhereInput;
};

export type CredentialUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<CredentialCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<CredentialUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CredentialUpdateManyWithoutPassNestedInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutPassInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutPassInput>>;
  createMany?: InputMaybe<CredentialCreateManyPassInputEnvelope>;
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialUpdateWithWhereUniqueWithoutPassInput>>;
  updateMany?: InputMaybe<Array<CredentialUpdateManyWithWhereWithoutPassInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertWithWhereUniqueWithoutPassInput>>;
};

export type CredentialUpdateManyWithoutTypeNestedInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutTypeInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutTypeInput>>;
  createMany?: InputMaybe<CredentialCreateManyTypeInputEnvelope>;
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialUpdateWithWhereUniqueWithoutTypeInput>>;
  updateMany?: InputMaybe<Array<CredentialUpdateManyWithWhereWithoutTypeInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertWithWhereUniqueWithoutTypeInput>>;
};

export type CredentialUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutUserInput>>;
  createMany?: InputMaybe<CredentialCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CredentialUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CredentialUpdateOneRequiredWithoutStatusNestedInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutStatusInput>;
  create?: InputMaybe<CredentialCreateWithoutStatusInput>;
  update?: InputMaybe<CredentialUpdateToOneWithWhereWithoutStatusInput>;
  upsert?: InputMaybe<CredentialUpsertWithoutStatusInput>;
};

export type CredentialUpdateOneRequiredWithoutWalletSharesNestedInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutWalletSharesInput>;
  create?: InputMaybe<CredentialCreateWithoutWalletSharesInput>;
  update?: InputMaybe<CredentialUpdateToOneWithWhereWithoutWalletSharesInput>;
  upsert?: InputMaybe<CredentialUpsertWithoutWalletSharesInput>;
};

export type CredentialUpdateOneWithoutInputNestedInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutInputInput>;
  create?: InputMaybe<CredentialCreateWithoutInputInput>;
  delete?: InputMaybe<CredentialWhereInput>;
  disconnect?: InputMaybe<CredentialWhereInput>;
  update?: InputMaybe<CredentialUpdateToOneWithWhereWithoutInputInput>;
  upsert?: InputMaybe<CredentialUpsertWithoutInputInput>;
};

export type CredentialUpdateOneWithoutOutputNestedInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutOutputInput>;
  create?: InputMaybe<CredentialCreateWithoutOutputInput>;
  delete?: InputMaybe<CredentialWhereInput>;
  disconnect?: InputMaybe<CredentialWhereInput>;
  update?: InputMaybe<CredentialUpdateToOneWithWhereWithoutOutputInput>;
  upsert?: InputMaybe<CredentialUpsertWithoutOutputInput>;
};

export type CredentialUpdateOneWithoutRunNestedInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutRunInput>;
  create?: InputMaybe<CredentialCreateWithoutRunInput>;
  delete?: InputMaybe<CredentialWhereInput>;
  disconnect?: InputMaybe<CredentialWhereInput>;
  update?: InputMaybe<CredentialUpdateToOneWithWhereWithoutRunInput>;
  upsert?: InputMaybe<CredentialUpsertWithoutRunInput>;
};

export type CredentialUpdateToOneWithWhereWithoutInputInput = {
  data: CredentialUpdateWithoutInputInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpdateToOneWithWhereWithoutOutputInput = {
  data: CredentialUpdateWithoutOutputInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpdateToOneWithWhereWithoutRunInput = {
  data: CredentialUpdateWithoutRunInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpdateToOneWithWhereWithoutStatusInput = {
  data: CredentialUpdateWithoutStatusInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpdateToOneWithWhereWithoutWalletSharesInput = {
  data: CredentialUpdateWithoutWalletSharesInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CredentialUpdateWithoutOrganizationInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpdateWithWhereUniqueWithoutPassInput = {
  data: CredentialUpdateWithoutPassInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpdateWithWhereUniqueWithoutTypeInput = {
  data: CredentialUpdateWithoutTypeInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpdateWithWhereUniqueWithoutUserInput = {
  data: CredentialUpdateWithoutUserInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpdateWithoutInputInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutOutputInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutPassInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutRunInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutStatusInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutTypeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutWalletSharesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<BeamInputUpdateOneRequiredWithoutCredentialNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCredentialsNestedInput>;
  output?: InputMaybe<BeamOutputUpdateOneWithoutCredentialNestedInput>;
  pass?: InputMaybe<PassUpdateOneWithoutCredentialsNestedInput>;
  run?: InputMaybe<BeamRunUpdateOneWithoutCredentialNestedInput>;
  status?: InputMaybe<CredentialStatusUpdateOneWithoutCredentialNestedInput>;
  type?: InputMaybe<CredentialTypeUpdateOneRequiredWithoutCredentialsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialsNestedInput>;
};

export type CredentialUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CredentialCreateWithoutOrganizationInput;
  update: CredentialUpdateWithoutOrganizationInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpsertWithWhereUniqueWithoutPassInput = {
  create: CredentialCreateWithoutPassInput;
  update: CredentialUpdateWithoutPassInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpsertWithWhereUniqueWithoutTypeInput = {
  create: CredentialCreateWithoutTypeInput;
  update: CredentialUpdateWithoutTypeInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpsertWithWhereUniqueWithoutUserInput = {
  create: CredentialCreateWithoutUserInput;
  update: CredentialUpdateWithoutUserInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpsertWithoutInputInput = {
  create: CredentialCreateWithoutInputInput;
  update: CredentialUpdateWithoutInputInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpsertWithoutOutputInput = {
  create: CredentialCreateWithoutOutputInput;
  update: CredentialUpdateWithoutOutputInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpsertWithoutRunInput = {
  create: CredentialCreateWithoutRunInput;
  update: CredentialUpdateWithoutRunInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpsertWithoutStatusInput = {
  create: CredentialCreateWithoutStatusInput;
  update: CredentialUpdateWithoutStatusInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialUpsertWithoutWalletSharesInput = {
  create: CredentialCreateWithoutWalletSharesInput;
  update: CredentialUpdateWithoutWalletSharesInput;
  where?: InputMaybe<CredentialWhereInput>;
};

export type CredentialWhereInput = {
  AND?: InputMaybe<Array<CredentialWhereInput>>;
  NOT?: InputMaybe<Array<CredentialWhereInput>>;
  OR?: InputMaybe<Array<CredentialWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  input?: InputMaybe<BeamInputScalarRelationFilter>;
  inputId?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  output?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  outputId?: InputMaybe<StringNullableFilter>;
  pass?: InputMaybe<PassNullableScalarRelationFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  run?: InputMaybe<BeamRunNullableScalarRelationFilter>;
  status?: InputMaybe<CredentialStatusNullableScalarRelationFilter>;
  type?: InputMaybe<CredentialTypeScalarRelationFilter>;
  typeId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  walletShares?: InputMaybe<WalletShareListRelationFilter>;
};

export type CredentialWhereUniqueInput = {
  AND?: InputMaybe<Array<CredentialWhereInput>>;
  NOT?: InputMaybe<Array<CredentialWhereInput>>;
  OR?: InputMaybe<Array<CredentialWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<BeamInputScalarRelationFilter>;
  inputId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  output?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  outputId?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<PassNullableScalarRelationFilter>;
  passId?: InputMaybe<StringNullableFilter>;
  run?: InputMaybe<BeamRunNullableScalarRelationFilter>;
  status?: InputMaybe<CredentialStatusNullableScalarRelationFilter>;
  type?: InputMaybe<CredentialTypeScalarRelationFilter>;
  typeId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
  walletShares?: InputMaybe<WalletShareListRelationFilter>;
};

export enum CurrencyMultiplierEnum {
  FourDecimals = 'FOUR_DECIMALS',
  SixDecimals = 'SIX_DECIMALS',
  TwoDecimals = 'TWO_DECIMALS',
  ZeroDecimals = 'ZERO_DECIMALS'
}

export enum CurrencyTypeEnum {
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export enum DeviceTypeEnum {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB',
  WebMobile = 'WEB_MOBILE'
}

export type Disclosure = {
  __typename?: 'Disclosure';
  _count?: Maybe<DisclosureCount>;
  biometricConsentAcceptances: Array<BiometricConsentAcceptance>;
  createdAt: Scalars['DateTimeISO']['output'];
  disclosureAcceptances: Array<DisclosureAcceptance>;
  id: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<LocationTypeEnum>;
  name: Scalars['String']['output'];
  organizations: Array<Organization>;
  packageSets: Array<PackageSet>;
  text: Scalars['String']['output'];
  type: DisclosureTypeEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type DisclosureBiometricConsentAcceptancesArgs = {
  cursor?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<BiometricConsentAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BiometricConsentAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type DisclosureDisclosureAcceptancesArgs = {
  cursor?: InputMaybe<DisclosureAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type DisclosureOrganizationsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type DisclosurePackageSetsArgs = {
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageSetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type DisclosureAcceptance = {
  __typename?: 'DisclosureAcceptance';
  _count?: Maybe<DisclosureAcceptanceCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  disclosures: Array<Disclosure>;
  id: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<File>;
  signatureSvg: Scalars['Byte']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type DisclosureAcceptanceDisclosuresArgs = {
  cursor?: InputMaybe<DisclosureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureWhereInput>;
};


export type DisclosureAcceptanceOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type DisclosureAcceptancePdfArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type DisclosureAcceptanceArgs = {
  disclosureIds: Array<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  signatureSvg: Scalars['String']['input'];
};

export type DisclosureAcceptanceCount = {
  __typename?: 'DisclosureAcceptanceCount';
  disclosures: Scalars['Int']['output'];
};


export type DisclosureAcceptanceCountDisclosuresArgs = {
  where?: InputMaybe<DisclosureWhereInput>;
};

export type DisclosureAcceptanceCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  signatureSvg: Scalars['Byte']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type DisclosureAcceptanceCreateManyOrderInputEnvelope = {
  data: Array<DisclosureAcceptanceCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisclosureAcceptanceCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  signatureSvg: Scalars['Byte']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureAcceptanceCreateManyUserInputEnvelope = {
  data: Array<DisclosureAcceptanceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisclosureAcceptanceCreateNestedManyWithoutDisclosuresInput = {
  connect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureAcceptanceCreateOrConnectWithoutDisclosuresInput>>;
  create?: InputMaybe<Array<DisclosureAcceptanceCreateWithoutDisclosuresInput>>;
};

export type DisclosureAcceptanceCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureAcceptanceCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<DisclosureAcceptanceCreateWithoutOrderInput>>;
  createMany?: InputMaybe<DisclosureAcceptanceCreateManyOrderInputEnvelope>;
};

export type DisclosureAcceptanceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureAcceptanceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DisclosureAcceptanceCreateWithoutUserInput>>;
  createMany?: InputMaybe<DisclosureAcceptanceCreateManyUserInputEnvelope>;
};

export type DisclosureAcceptanceCreateNestedOneWithoutPdfInput = {
  connect?: InputMaybe<DisclosureAcceptanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DisclosureAcceptanceCreateOrConnectWithoutPdfInput>;
  create?: InputMaybe<DisclosureAcceptanceCreateWithoutPdfInput>;
};

export type DisclosureAcceptanceCreateOrConnectWithoutDisclosuresInput = {
  create: DisclosureAcceptanceCreateWithoutDisclosuresInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceCreateOrConnectWithoutOrderInput = {
  create: DisclosureAcceptanceCreateWithoutOrderInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceCreateOrConnectWithoutPdfInput = {
  create: DisclosureAcceptanceCreateWithoutPdfInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceCreateOrConnectWithoutUserInput = {
  create: DisclosureAcceptanceCreateWithoutUserInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceCreateWithoutDisclosuresInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutDisclosureAcceptancesInput>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutDisclosureAcceptanceInput>;
  signatureSvg: Scalars['Byte']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutDisclosureAcceptancesInput;
};

export type DisclosureAcceptanceCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutDisclosureAcceptancesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutDisclosureAcceptanceInput>;
  signatureSvg: Scalars['Byte']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutDisclosureAcceptancesInput;
};

export type DisclosureAcceptanceCreateWithoutPdfInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutDisclosureAcceptancesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutDisclosureAcceptancesInput>;
  signatureSvg: Scalars['Byte']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutDisclosureAcceptancesInput;
};

export type DisclosureAcceptanceCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutDisclosureAcceptancesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutDisclosureAcceptancesInput>;
  pdf?: InputMaybe<FileCreateNestedOneWithoutDisclosureAcceptanceInput>;
  signatureSvg: Scalars['Byte']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureAcceptanceListRelationFilter = {
  every?: InputMaybe<DisclosureAcceptanceWhereInput>;
  none?: InputMaybe<DisclosureAcceptanceWhereInput>;
  some?: InputMaybe<DisclosureAcceptanceWhereInput>;
};

export type DisclosureAcceptanceNullableScalarRelationFilter = {
  is?: InputMaybe<DisclosureAcceptanceWhereInput>;
  isNot?: InputMaybe<DisclosureAcceptanceWhereInput>;
};

export type DisclosureAcceptanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DisclosureAcceptanceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  disclosures?: InputMaybe<DisclosureOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  pdf?: InputMaybe<FileOrderByWithRelationInput>;
  signatureSvg?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum DisclosureAcceptanceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrderId = 'orderId',
  SignatureSvg = 'signatureSvg',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type DisclosureAcceptanceScalarWhereInput = {
  AND?: InputMaybe<Array<DisclosureAcceptanceScalarWhereInput>>;
  NOT?: InputMaybe<Array<DisclosureAcceptanceScalarWhereInput>>;
  OR?: InputMaybe<Array<DisclosureAcceptanceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  signatureSvg?: InputMaybe<BytesFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DisclosureAcceptanceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  signatureSvg?: InputMaybe<BytesFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureAcceptanceUpdateManyWithWhereWithoutDisclosuresInput = {
  data: DisclosureAcceptanceUpdateManyMutationInput;
  where: DisclosureAcceptanceScalarWhereInput;
};

export type DisclosureAcceptanceUpdateManyWithWhereWithoutOrderInput = {
  data: DisclosureAcceptanceUpdateManyMutationInput;
  where: DisclosureAcceptanceScalarWhereInput;
};

export type DisclosureAcceptanceUpdateManyWithWhereWithoutUserInput = {
  data: DisclosureAcceptanceUpdateManyMutationInput;
  where: DisclosureAcceptanceScalarWhereInput;
};

export type DisclosureAcceptanceUpdateManyWithoutDisclosuresNestedInput = {
  connect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureAcceptanceCreateOrConnectWithoutDisclosuresInput>>;
  create?: InputMaybe<Array<DisclosureAcceptanceCreateWithoutDisclosuresInput>>;
  delete?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisclosureAcceptanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  set?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  update?: InputMaybe<Array<DisclosureAcceptanceUpdateWithWhereUniqueWithoutDisclosuresInput>>;
  updateMany?: InputMaybe<Array<DisclosureAcceptanceUpdateManyWithWhereWithoutDisclosuresInput>>;
  upsert?: InputMaybe<Array<DisclosureAcceptanceUpsertWithWhereUniqueWithoutDisclosuresInput>>;
};

export type DisclosureAcceptanceUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureAcceptanceCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<DisclosureAcceptanceCreateWithoutOrderInput>>;
  createMany?: InputMaybe<DisclosureAcceptanceCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisclosureAcceptanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  set?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  update?: InputMaybe<Array<DisclosureAcceptanceUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<DisclosureAcceptanceUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<DisclosureAcceptanceUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type DisclosureAcceptanceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureAcceptanceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DisclosureAcceptanceCreateWithoutUserInput>>;
  createMany?: InputMaybe<DisclosureAcceptanceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisclosureAcceptanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  set?: InputMaybe<Array<DisclosureAcceptanceWhereUniqueInput>>;
  update?: InputMaybe<Array<DisclosureAcceptanceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<DisclosureAcceptanceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<DisclosureAcceptanceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type DisclosureAcceptanceUpdateOneWithoutPdfNestedInput = {
  connect?: InputMaybe<DisclosureAcceptanceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DisclosureAcceptanceCreateOrConnectWithoutPdfInput>;
  create?: InputMaybe<DisclosureAcceptanceCreateWithoutPdfInput>;
  delete?: InputMaybe<DisclosureAcceptanceWhereInput>;
  disconnect?: InputMaybe<DisclosureAcceptanceWhereInput>;
  update?: InputMaybe<DisclosureAcceptanceUpdateToOneWithWhereWithoutPdfInput>;
  upsert?: InputMaybe<DisclosureAcceptanceUpsertWithoutPdfInput>;
};

export type DisclosureAcceptanceUpdateToOneWithWhereWithoutPdfInput = {
  data: DisclosureAcceptanceUpdateWithoutPdfInput;
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};

export type DisclosureAcceptanceUpdateWithWhereUniqueWithoutDisclosuresInput = {
  data: DisclosureAcceptanceUpdateWithoutDisclosuresInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceUpdateWithWhereUniqueWithoutOrderInput = {
  data: DisclosureAcceptanceUpdateWithoutOrderInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceUpdateWithWhereUniqueWithoutUserInput = {
  data: DisclosureAcceptanceUpdateWithoutUserInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceUpdateWithoutDisclosuresInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutDisclosureAcceptancesNestedInput>;
  pdf?: InputMaybe<FileUpdateOneWithoutDisclosureAcceptanceNestedInput>;
  signatureSvg?: InputMaybe<BytesFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDisclosureAcceptancesNestedInput>;
};

export type DisclosureAcceptanceUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutDisclosureAcceptancesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pdf?: InputMaybe<FileUpdateOneWithoutDisclosureAcceptanceNestedInput>;
  signatureSvg?: InputMaybe<BytesFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDisclosureAcceptancesNestedInput>;
};

export type DisclosureAcceptanceUpdateWithoutPdfInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutDisclosureAcceptancesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutDisclosureAcceptancesNestedInput>;
  signatureSvg?: InputMaybe<BytesFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDisclosureAcceptancesNestedInput>;
};

export type DisclosureAcceptanceUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutDisclosureAcceptancesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutDisclosureAcceptancesNestedInput>;
  pdf?: InputMaybe<FileUpdateOneWithoutDisclosureAcceptanceNestedInput>;
  signatureSvg?: InputMaybe<BytesFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureAcceptanceUpsertWithWhereUniqueWithoutDisclosuresInput = {
  create: DisclosureAcceptanceCreateWithoutDisclosuresInput;
  update: DisclosureAcceptanceUpdateWithoutDisclosuresInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceUpsertWithWhereUniqueWithoutOrderInput = {
  create: DisclosureAcceptanceCreateWithoutOrderInput;
  update: DisclosureAcceptanceUpdateWithoutOrderInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceUpsertWithWhereUniqueWithoutUserInput = {
  create: DisclosureAcceptanceCreateWithoutUserInput;
  update: DisclosureAcceptanceUpdateWithoutUserInput;
  where: DisclosureAcceptanceWhereUniqueInput;
};

export type DisclosureAcceptanceUpsertWithoutPdfInput = {
  create: DisclosureAcceptanceCreateWithoutPdfInput;
  update: DisclosureAcceptanceUpdateWithoutPdfInput;
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};

export type DisclosureAcceptanceWhereInput = {
  AND?: InputMaybe<Array<DisclosureAcceptanceWhereInput>>;
  NOT?: InputMaybe<Array<DisclosureAcceptanceWhereInput>>;
  OR?: InputMaybe<Array<DisclosureAcceptanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosures?: InputMaybe<DisclosureListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  pdf?: InputMaybe<FileNullableScalarRelationFilter>;
  signatureSvg?: InputMaybe<BytesFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DisclosureAcceptanceWhereUniqueInput = {
  AND?: InputMaybe<Array<DisclosureAcceptanceWhereInput>>;
  NOT?: InputMaybe<Array<DisclosureAcceptanceWhereInput>>;
  OR?: InputMaybe<Array<DisclosureAcceptanceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosures?: InputMaybe<DisclosureListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<FileNullableScalarRelationFilter>;
  signatureSvg?: InputMaybe<BytesFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DisclosureAddress = {
  addressLineOne: Scalars['String']['input'];
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type DisclosureCount = {
  __typename?: 'DisclosureCount';
  biometricConsentAcceptances: Scalars['Int']['output'];
  disclosureAcceptances: Scalars['Int']['output'];
  organizations: Scalars['Int']['output'];
  packageSets: Scalars['Int']['output'];
};


export type DisclosureCountBiometricConsentAcceptancesArgs = {
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type DisclosureCountDisclosureAcceptancesArgs = {
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type DisclosureCountOrganizationsArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type DisclosureCountPackageSetsArgs = {
  where?: InputMaybe<PackageSetWhereInput>;
};

export type DisclosureCountAggregate = {
  __typename?: 'DisclosureCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  location: Scalars['Int']['output'];
  locationType: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DisclosureCreateInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutDisclosureInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutDisclosuresInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  name: Scalars['String']['input'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutDisclosuresInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutDisclosuresInput>;
  text: Scalars['String']['input'];
  type: DisclosureTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureCreateNestedManyWithoutDisclosureAcceptancesInput = {
  connect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureCreateOrConnectWithoutDisclosureAcceptancesInput>>;
  create?: InputMaybe<Array<DisclosureCreateWithoutDisclosureAcceptancesInput>>;
};

export type DisclosureCreateNestedManyWithoutOrganizationsInput = {
  connect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<DisclosureCreateWithoutOrganizationsInput>>;
};

export type DisclosureCreateNestedManyWithoutPackageSetsInput = {
  connect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<DisclosureCreateWithoutPackageSetsInput>>;
};

export type DisclosureCreateNestedOneWithoutBiometricConsentAcceptancesInput = {
  connect?: InputMaybe<DisclosureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DisclosureCreateOrConnectWithoutBiometricConsentAcceptancesInput>;
  create?: InputMaybe<DisclosureCreateWithoutBiometricConsentAcceptancesInput>;
};

export type DisclosureCreateOrConnectWithoutBiometricConsentAcceptancesInput = {
  create: DisclosureCreateWithoutBiometricConsentAcceptancesInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureCreateOrConnectWithoutDisclosureAcceptancesInput = {
  create: DisclosureCreateWithoutDisclosureAcceptancesInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureCreateOrConnectWithoutOrganizationsInput = {
  create: DisclosureCreateWithoutOrganizationsInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureCreateOrConnectWithoutPackageSetsInput = {
  create: DisclosureCreateWithoutPackageSetsInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureCreateWithoutBiometricConsentAcceptancesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutDisclosuresInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  name: Scalars['String']['input'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutDisclosuresInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutDisclosuresInput>;
  text: Scalars['String']['input'];
  type: DisclosureTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureCreateWithoutDisclosureAcceptancesInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutDisclosureInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  name: Scalars['String']['input'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutDisclosuresInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutDisclosuresInput>;
  text: Scalars['String']['input'];
  type: DisclosureTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureCreateWithoutOrganizationsInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutDisclosureInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutDisclosuresInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  name: Scalars['String']['input'];
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutDisclosuresInput>;
  text: Scalars['String']['input'];
  type: DisclosureTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureCreateWithoutPackageSetsInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutDisclosureInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutDisclosuresInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<LocationTypeEnum>;
  name: Scalars['String']['input'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutDisclosuresInput>;
  text: Scalars['String']['input'];
  type: DisclosureTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisclosureListRelationFilter = {
  every?: InputMaybe<DisclosureWhereInput>;
  none?: InputMaybe<DisclosureWhereInput>;
  some?: InputMaybe<DisclosureWhereInput>;
};

export type DisclosureMaxAggregate = {
  __typename?: 'DisclosureMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<LocationTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DisclosureTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DisclosureMinAggregate = {
  __typename?: 'DisclosureMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<LocationTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DisclosureTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DisclosureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DisclosureOrderByWithRelationInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<SortOrderInput>;
  locationType?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  organizations?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  packageSets?: InputMaybe<PackageSetOrderByRelationAggregateInput>;
  text?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DisclosureScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Location = 'location',
  LocationType = 'locationType',
  Name = 'name',
  Text = 'text',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type DisclosureScalarRelationFilter = {
  is?: InputMaybe<DisclosureWhereInput>;
  isNot?: InputMaybe<DisclosureWhereInput>;
};

export type DisclosureScalarWhereInput = {
  AND?: InputMaybe<Array<DisclosureScalarWhereInput>>;
  NOT?: InputMaybe<Array<DisclosureScalarWhereInput>>;
  OR?: InputMaybe<Array<DisclosureScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  locationType?: InputMaybe<EnumLocationTypeEnumNullableFilter>;
  name?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumDisclosureTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DisclosureTypeEnum {
  Biometric = 'BIOMETRIC',
  Cra = 'CRA',
  Custom = 'CUSTOM',
  General = 'GENERAL',
  LocationBased = 'LOCATION_BASED',
  Organization = 'ORGANIZATION',
  Package = 'PACKAGE'
}

export type DisclosureUpdateInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutDisclosureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutDisclosuresNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<NullableEnumLocationTypeEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutDisclosuresNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutDisclosuresNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDisclosureTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<NullableEnumLocationTypeEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDisclosureTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureUpdateManyWithWhereWithoutDisclosureAcceptancesInput = {
  data: DisclosureUpdateManyMutationInput;
  where: DisclosureScalarWhereInput;
};

export type DisclosureUpdateManyWithWhereWithoutOrganizationsInput = {
  data: DisclosureUpdateManyMutationInput;
  where: DisclosureScalarWhereInput;
};

export type DisclosureUpdateManyWithWhereWithoutPackageSetsInput = {
  data: DisclosureUpdateManyMutationInput;
  where: DisclosureScalarWhereInput;
};

export type DisclosureUpdateManyWithoutDisclosureAcceptancesNestedInput = {
  connect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureCreateOrConnectWithoutDisclosureAcceptancesInput>>;
  create?: InputMaybe<Array<DisclosureCreateWithoutDisclosureAcceptancesInput>>;
  delete?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisclosureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  set?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  update?: InputMaybe<Array<DisclosureUpdateWithWhereUniqueWithoutDisclosureAcceptancesInput>>;
  updateMany?: InputMaybe<Array<DisclosureUpdateManyWithWhereWithoutDisclosureAcceptancesInput>>;
  upsert?: InputMaybe<Array<DisclosureUpsertWithWhereUniqueWithoutDisclosureAcceptancesInput>>;
};

export type DisclosureUpdateManyWithoutOrganizationsNestedInput = {
  connect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<DisclosureCreateWithoutOrganizationsInput>>;
  delete?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisclosureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  set?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  update?: InputMaybe<Array<DisclosureUpdateWithWhereUniqueWithoutOrganizationsInput>>;
  updateMany?: InputMaybe<Array<DisclosureUpdateManyWithWhereWithoutOrganizationsInput>>;
  upsert?: InputMaybe<Array<DisclosureUpsertWithWhereUniqueWithoutOrganizationsInput>>;
};

export type DisclosureUpdateManyWithoutPackageSetsNestedInput = {
  connect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisclosureCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<DisclosureCreateWithoutPackageSetsInput>>;
  delete?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisclosureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  set?: InputMaybe<Array<DisclosureWhereUniqueInput>>;
  update?: InputMaybe<Array<DisclosureUpdateWithWhereUniqueWithoutPackageSetsInput>>;
  updateMany?: InputMaybe<Array<DisclosureUpdateManyWithWhereWithoutPackageSetsInput>>;
  upsert?: InputMaybe<Array<DisclosureUpsertWithWhereUniqueWithoutPackageSetsInput>>;
};

export type DisclosureUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput = {
  connect?: InputMaybe<DisclosureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DisclosureCreateOrConnectWithoutBiometricConsentAcceptancesInput>;
  create?: InputMaybe<DisclosureCreateWithoutBiometricConsentAcceptancesInput>;
  update?: InputMaybe<DisclosureUpdateToOneWithWhereWithoutBiometricConsentAcceptancesInput>;
  upsert?: InputMaybe<DisclosureUpsertWithoutBiometricConsentAcceptancesInput>;
};

export type DisclosureUpdateToOneWithWhereWithoutBiometricConsentAcceptancesInput = {
  data: DisclosureUpdateWithoutBiometricConsentAcceptancesInput;
  where?: InputMaybe<DisclosureWhereInput>;
};

export type DisclosureUpdateWithWhereUniqueWithoutDisclosureAcceptancesInput = {
  data: DisclosureUpdateWithoutDisclosureAcceptancesInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureUpdateWithWhereUniqueWithoutOrganizationsInput = {
  data: DisclosureUpdateWithoutOrganizationsInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureUpdateWithWhereUniqueWithoutPackageSetsInput = {
  data: DisclosureUpdateWithoutPackageSetsInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureUpdateWithoutBiometricConsentAcceptancesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutDisclosuresNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<NullableEnumLocationTypeEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutDisclosuresNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutDisclosuresNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDisclosureTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureUpdateWithoutDisclosureAcceptancesInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutDisclosureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<NullableEnumLocationTypeEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutDisclosuresNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutDisclosuresNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDisclosureTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureUpdateWithoutOrganizationsInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutDisclosureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutDisclosuresNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<NullableEnumLocationTypeEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutDisclosuresNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDisclosureTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureUpdateWithoutPackageSetsInput = {
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutDisclosureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutDisclosuresNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locationType?: InputMaybe<NullableEnumLocationTypeEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutDisclosuresNestedInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDisclosureTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisclosureUpsertWithWhereUniqueWithoutDisclosureAcceptancesInput = {
  create: DisclosureCreateWithoutDisclosureAcceptancesInput;
  update: DisclosureUpdateWithoutDisclosureAcceptancesInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureUpsertWithWhereUniqueWithoutOrganizationsInput = {
  create: DisclosureCreateWithoutOrganizationsInput;
  update: DisclosureUpdateWithoutOrganizationsInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureUpsertWithWhereUniqueWithoutPackageSetsInput = {
  create: DisclosureCreateWithoutPackageSetsInput;
  update: DisclosureUpdateWithoutPackageSetsInput;
  where: DisclosureWhereUniqueInput;
};

export type DisclosureUpsertWithoutBiometricConsentAcceptancesInput = {
  create: DisclosureCreateWithoutBiometricConsentAcceptancesInput;
  update: DisclosureUpdateWithoutBiometricConsentAcceptancesInput;
  where?: InputMaybe<DisclosureWhereInput>;
};

export type DisclosureWhereInput = {
  AND?: InputMaybe<Array<DisclosureWhereInput>>;
  NOT?: InputMaybe<Array<DisclosureWhereInput>>;
  OR?: InputMaybe<Array<DisclosureWhereInput>>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  locationType?: InputMaybe<EnumLocationTypeEnumNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  text?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumDisclosureTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DisclosureWhereUniqueInput = {
  AND?: InputMaybe<Array<DisclosureWhereInput>>;
  NOT?: InputMaybe<Array<DisclosureWhereInput>>;
  OR?: InputMaybe<Array<DisclosureWhereInput>>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<StringNullableFilter>;
  locationType?: InputMaybe<EnumLocationTypeEnumNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  text?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumDisclosureTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DisenrollmentSource {
  AutoDisqualification = 'AUTO_DISQUALIFICATION',
  ClientRequest = 'CLIENT_REQUEST',
  LegalRequirement = 'LEGAL_REQUIREMENT',
  ManualOverride = 'MANUAL_OVERRIDE',
  ProductExpiration = 'PRODUCT_EXPIRATION'
}

export type DispatchedSearch = {
  __typename?: 'DispatchedSearch';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  monitoringReport?: Maybe<MonitoringReport>;
  monitoringReportId?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  requestedSearch: RequestedSearch;
  requestedSearchId: Scalars['String']['output'];
  searchType: SearchType;
  searchTypeId: Scalars['String']['output'];
  status: SearchStatusTypeEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type DispatchedSearchMonitoringReportArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type DispatchedSearchCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutDispatchedSearchesInput>;
  order: OrderCreateNestedOneWithoutDispatchedSearchesInput;
  requestedSearch: RequestedSearchCreateNestedOneWithoutDispatchedSearchesInput;
  searchType: SearchTypeCreateNestedOneWithoutDispatchedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateManyMonitoringReportInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orderId: Scalars['String']['input'];
  requestedSearchId: Scalars['String']['input'];
  searchTypeId: Scalars['String']['input'];
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateManyMonitoringReportInputEnvelope = {
  data: Array<DispatchedSearchCreateManyMonitoringReportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchedSearchCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  requestedSearchId: Scalars['String']['input'];
  searchTypeId: Scalars['String']['input'];
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateManyOrderInputEnvelope = {
  data: Array<DispatchedSearchCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchedSearchCreateManyRequestedSearchInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  searchTypeId: Scalars['String']['input'];
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateManyRequestedSearchInputEnvelope = {
  data: Array<DispatchedSearchCreateManyRequestedSearchInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchedSearchCreateManySearchTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  requestedSearchId: Scalars['String']['input'];
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateManySearchTypeInputEnvelope = {
  data: Array<DispatchedSearchCreateManySearchTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchedSearchCreateNestedManyWithoutMonitoringReportInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManyMonitoringReportInputEnvelope>;
};

export type DispatchedSearchCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutOrderInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManyOrderInputEnvelope>;
};

export type DispatchedSearchCreateNestedManyWithoutRequestedSearchInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutRequestedSearchInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutRequestedSearchInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManyRequestedSearchInputEnvelope>;
};

export type DispatchedSearchCreateNestedManyWithoutSearchTypeInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutSearchTypeInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutSearchTypeInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManySearchTypeInputEnvelope>;
};

export type DispatchedSearchCreateOrConnectWithoutMonitoringReportInput = {
  create: DispatchedSearchCreateWithoutMonitoringReportInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchCreateOrConnectWithoutOrderInput = {
  create: DispatchedSearchCreateWithoutOrderInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchCreateOrConnectWithoutRequestedSearchInput = {
  create: DispatchedSearchCreateWithoutRequestedSearchInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchCreateOrConnectWithoutSearchTypeInput = {
  create: DispatchedSearchCreateWithoutSearchTypeInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchCreateWithoutMonitoringReportInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutDispatchedSearchesInput;
  requestedSearch: RequestedSearchCreateNestedOneWithoutDispatchedSearchesInput;
  searchType: SearchTypeCreateNestedOneWithoutDispatchedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutDispatchedSearchesInput>;
  requestedSearch: RequestedSearchCreateNestedOneWithoutDispatchedSearchesInput;
  searchType: SearchTypeCreateNestedOneWithoutDispatchedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateWithoutRequestedSearchInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutDispatchedSearchesInput>;
  order: OrderCreateNestedOneWithoutDispatchedSearchesInput;
  searchType: SearchTypeCreateNestedOneWithoutDispatchedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchCreateWithoutSearchTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutDispatchedSearchesInput>;
  order: OrderCreateNestedOneWithoutDispatchedSearchesInput;
  requestedSearch: RequestedSearchCreateNestedOneWithoutDispatchedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DispatchedSearchListRelationFilter = {
  every?: InputMaybe<DispatchedSearchWhereInput>;
  none?: InputMaybe<DispatchedSearchWhereInput>;
  some?: InputMaybe<DispatchedSearchWhereInput>;
};

export type DispatchedSearchOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DispatchedSearchOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  monitoringReport?: InputMaybe<MonitoringReportOrderByWithRelationInput>;
  monitoringReportId?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  requestedSearch?: InputMaybe<RequestedSearchOrderByWithRelationInput>;
  requestedSearchId?: InputMaybe<SortOrder>;
  searchType?: InputMaybe<SearchTypeOrderByWithRelationInput>;
  searchTypeId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DispatchedSearchScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  MonitoringReportId = 'monitoringReportId',
  OrderId = 'orderId',
  RequestedSearchId = 'requestedSearchId',
  SearchTypeId = 'searchTypeId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type DispatchedSearchScalarWhereInput = {
  AND?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  NOT?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  OR?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<StringFilter>;
  requestedSearchId?: InputMaybe<StringFilter>;
  searchTypeId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DispatchedSearchUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutDispatchedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DispatchedSearchUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DispatchedSearchUpdateManyWithWhereWithoutMonitoringReportInput = {
  data: DispatchedSearchUpdateManyMutationInput;
  where: DispatchedSearchScalarWhereInput;
};

export type DispatchedSearchUpdateManyWithWhereWithoutOrderInput = {
  data: DispatchedSearchUpdateManyMutationInput;
  where: DispatchedSearchScalarWhereInput;
};

export type DispatchedSearchUpdateManyWithWhereWithoutRequestedSearchInput = {
  data: DispatchedSearchUpdateManyMutationInput;
  where: DispatchedSearchScalarWhereInput;
};

export type DispatchedSearchUpdateManyWithWhereWithoutSearchTypeInput = {
  data: DispatchedSearchUpdateManyMutationInput;
  where: DispatchedSearchScalarWhereInput;
};

export type DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManyMonitoringReportInputEnvelope>;
  delete?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<DispatchedSearchUpdateWithWhereUniqueWithoutMonitoringReportInput>>;
  updateMany?: InputMaybe<Array<DispatchedSearchUpdateManyWithWhereWithoutMonitoringReportInput>>;
  upsert?: InputMaybe<Array<DispatchedSearchUpsertWithWhereUniqueWithoutMonitoringReportInput>>;
};

export type DispatchedSearchUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutOrderInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<DispatchedSearchUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<DispatchedSearchUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<DispatchedSearchUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type DispatchedSearchUpdateManyWithoutRequestedSearchNestedInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutRequestedSearchInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutRequestedSearchInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManyRequestedSearchInputEnvelope>;
  delete?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<DispatchedSearchUpdateWithWhereUniqueWithoutRequestedSearchInput>>;
  updateMany?: InputMaybe<Array<DispatchedSearchUpdateManyWithWhereWithoutRequestedSearchInput>>;
  upsert?: InputMaybe<Array<DispatchedSearchUpsertWithWhereUniqueWithoutRequestedSearchInput>>;
};

export type DispatchedSearchUpdateManyWithoutSearchTypeNestedInput = {
  connect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DispatchedSearchCreateOrConnectWithoutSearchTypeInput>>;
  create?: InputMaybe<Array<DispatchedSearchCreateWithoutSearchTypeInput>>;
  createMany?: InputMaybe<DispatchedSearchCreateManySearchTypeInputEnvelope>;
  delete?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DispatchedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<DispatchedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<DispatchedSearchUpdateWithWhereUniqueWithoutSearchTypeInput>>;
  updateMany?: InputMaybe<Array<DispatchedSearchUpdateManyWithWhereWithoutSearchTypeInput>>;
  upsert?: InputMaybe<Array<DispatchedSearchUpsertWithWhereUniqueWithoutSearchTypeInput>>;
};

export type DispatchedSearchUpdateWithWhereUniqueWithoutMonitoringReportInput = {
  data: DispatchedSearchUpdateWithoutMonitoringReportInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpdateWithWhereUniqueWithoutOrderInput = {
  data: DispatchedSearchUpdateWithoutOrderInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpdateWithWhereUniqueWithoutRequestedSearchInput = {
  data: DispatchedSearchUpdateWithoutRequestedSearchInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpdateWithWhereUniqueWithoutSearchTypeInput = {
  data: DispatchedSearchUpdateWithoutSearchTypeInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpdateWithoutMonitoringReportInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DispatchedSearchUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutDispatchedSearchesNestedInput>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DispatchedSearchUpdateWithoutRequestedSearchInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutDispatchedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DispatchedSearchUpdateWithoutSearchTypeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutDispatchedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneRequiredWithoutDispatchedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DispatchedSearchUpsertWithWhereUniqueWithoutMonitoringReportInput = {
  create: DispatchedSearchCreateWithoutMonitoringReportInput;
  update: DispatchedSearchUpdateWithoutMonitoringReportInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpsertWithWhereUniqueWithoutOrderInput = {
  create: DispatchedSearchCreateWithoutOrderInput;
  update: DispatchedSearchUpdateWithoutOrderInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpsertWithWhereUniqueWithoutRequestedSearchInput = {
  create: DispatchedSearchCreateWithoutRequestedSearchInput;
  update: DispatchedSearchUpdateWithoutRequestedSearchInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchUpsertWithWhereUniqueWithoutSearchTypeInput = {
  create: DispatchedSearchCreateWithoutSearchTypeInput;
  update: DispatchedSearchUpdateWithoutSearchTypeInput;
  where: DispatchedSearchWhereUniqueInput;
};

export type DispatchedSearchWhereInput = {
  AND?: InputMaybe<Array<DispatchedSearchWhereInput>>;
  NOT?: InputMaybe<Array<DispatchedSearchWhereInput>>;
  OR?: InputMaybe<Array<DispatchedSearchWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  requestedSearch?: InputMaybe<RequestedSearchScalarRelationFilter>;
  requestedSearchId?: InputMaybe<StringFilter>;
  searchType?: InputMaybe<SearchTypeScalarRelationFilter>;
  searchTypeId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DispatchedSearchWhereUniqueInput = {
  AND?: InputMaybe<Array<DispatchedSearchWhereInput>>;
  NOT?: InputMaybe<Array<DispatchedSearchWhereInput>>;
  OR?: InputMaybe<Array<DispatchedSearchWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  requestedSearch?: InputMaybe<RequestedSearchScalarRelationFilter>;
  requestedSearchId?: InputMaybe<StringFilter>;
  searchType?: InputMaybe<SearchTypeScalarRelationFilter>;
  searchTypeId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Dispute = {
  __typename?: 'Dispute';
  _count?: Maybe<DisputeCount>;
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerName: Scalars['String']['output'];
  consumerPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last4Ssn?: Maybe<Scalars['String']['output']>;
  monitoringEnrollment?: Maybe<MonitoringEnrollment>;
  monitoringEnrollmentId?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  reason: DisputeReasonEnum;
  report?: Maybe<File>;
  reportId?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<DisputeResolution>;
  resolutionOutcome?: Maybe<DisputeResolutionOutcomeEnum>;
  specificItem?: Maybe<Scalars['String']['output']>;
  status: DisputeStatusEnum;
  submittedBy?: Maybe<User>;
  submittedById?: Maybe<Scalars['String']['output']>;
  supportingDocuments: Array<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type DisputeMonitoringEnrollmentArgs = {
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type DisputeReportArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type DisputeSubmittedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type DisputeSupportingDocumentsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};

export type DisputeCount = {
  __typename?: 'DisputeCount';
  supportingDocuments: Scalars['Int']['output'];
};


export type DisputeCountSupportingDocumentsArgs = {
  where?: InputMaybe<FileWhereInput>;
};

export type DisputeCountAggregate = {
  __typename?: 'DisputeCountAggregate';
  _all: Scalars['Int']['output'];
  consumerEmail: Scalars['Int']['output'];
  consumerName: Scalars['Int']['output'];
  consumerPhone: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dob: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last4Ssn: Scalars['Int']['output'];
  monitoringEnrollmentId: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  reportId: Scalars['Int']['output'];
  resolutionOutcome: Scalars['Int']['output'];
  specificItem: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  submittedById: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DisputeCreateInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentCreateNestedOneWithoutDisputesInput>;
  order: OrderCreateNestedOneWithoutDisputesInput;
  reason: DisputeReasonEnum;
  report?: InputMaybe<FileCreateNestedOneWithoutDisputesInput>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedBy?: InputMaybe<UserCreateNestedOneWithoutDisputesInput>;
  supportingDocuments?: InputMaybe<FileCreateNestedManyWithoutDisputeSupportingDocumentInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateManyMonitoringEnrollmentInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: DisputeReasonEnum;
  reportId?: InputMaybe<Scalars['String']['input']>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedById?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateManyMonitoringEnrollmentInputEnvelope = {
  data: Array<DisputeCreateManyMonitoringEnrollmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeCreateManyOrderInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  reason: DisputeReasonEnum;
  reportId?: InputMaybe<Scalars['String']['input']>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedById?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateManyOrderInputEnvelope = {
  data: Array<DisputeCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeCreateManyReportInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: DisputeReasonEnum;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedById?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateManyReportInputEnvelope = {
  data: Array<DisputeCreateManyReportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeCreateManySubmittedByInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollmentId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: DisputeReasonEnum;
  reportId?: InputMaybe<Scalars['String']['input']>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateManySubmittedByInputEnvelope = {
  data: Array<DisputeCreateManySubmittedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisputeCreateNestedManyWithoutMonitoringEnrollmentInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutMonitoringEnrollmentInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutMonitoringEnrollmentInput>>;
  createMany?: InputMaybe<DisputeCreateManyMonitoringEnrollmentInputEnvelope>;
};

export type DisputeCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutOrderInput>>;
  createMany?: InputMaybe<DisputeCreateManyOrderInputEnvelope>;
};

export type DisputeCreateNestedManyWithoutReportInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutReportInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutReportInput>>;
  createMany?: InputMaybe<DisputeCreateManyReportInputEnvelope>;
};

export type DisputeCreateNestedManyWithoutSubmittedByInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutSubmittedByInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutSubmittedByInput>>;
  createMany?: InputMaybe<DisputeCreateManySubmittedByInputEnvelope>;
};

export type DisputeCreateNestedOneWithoutSupportingDocumentsInput = {
  connect?: InputMaybe<DisputeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DisputeCreateOrConnectWithoutSupportingDocumentsInput>;
  create?: InputMaybe<DisputeCreateWithoutSupportingDocumentsInput>;
};

export type DisputeCreateOrConnectWithoutMonitoringEnrollmentInput = {
  create: DisputeCreateWithoutMonitoringEnrollmentInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeCreateOrConnectWithoutOrderInput = {
  create: DisputeCreateWithoutOrderInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeCreateOrConnectWithoutReportInput = {
  create: DisputeCreateWithoutReportInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeCreateOrConnectWithoutSubmittedByInput = {
  create: DisputeCreateWithoutSubmittedByInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeCreateOrConnectWithoutSupportingDocumentsInput = {
  create: DisputeCreateWithoutSupportingDocumentsInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeCreateWithoutMonitoringEnrollmentInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutDisputesInput;
  reason: DisputeReasonEnum;
  report?: InputMaybe<FileCreateNestedOneWithoutDisputesInput>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedBy?: InputMaybe<UserCreateNestedOneWithoutDisputesInput>;
  supportingDocuments?: InputMaybe<FileCreateNestedManyWithoutDisputeSupportingDocumentInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateWithoutOrderInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentCreateNestedOneWithoutDisputesInput>;
  reason: DisputeReasonEnum;
  report?: InputMaybe<FileCreateNestedOneWithoutDisputesInput>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedBy?: InputMaybe<UserCreateNestedOneWithoutDisputesInput>;
  supportingDocuments?: InputMaybe<FileCreateNestedManyWithoutDisputeSupportingDocumentInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateWithoutReportInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentCreateNestedOneWithoutDisputesInput>;
  order: OrderCreateNestedOneWithoutDisputesInput;
  reason: DisputeReasonEnum;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedBy?: InputMaybe<UserCreateNestedOneWithoutDisputesInput>;
  supportingDocuments?: InputMaybe<FileCreateNestedManyWithoutDisputeSupportingDocumentInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateWithoutSubmittedByInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentCreateNestedOneWithoutDisputesInput>;
  order: OrderCreateNestedOneWithoutDisputesInput;
  reason: DisputeReasonEnum;
  report?: InputMaybe<FileCreateNestedOneWithoutDisputesInput>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  supportingDocuments?: InputMaybe<FileCreateNestedManyWithoutDisputeSupportingDocumentInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeCreateWithoutSupportingDocumentsInput = {
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerName: Scalars['String']['input'];
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentCreateNestedOneWithoutDisputesInput>;
  order: OrderCreateNestedOneWithoutDisputesInput;
  reason: DisputeReasonEnum;
  report?: InputMaybe<FileCreateNestedOneWithoutDisputesInput>;
  resolutionOutcome?: InputMaybe<DisputeResolutionOutcomeEnum>;
  specificItem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusEnum>;
  submittedBy?: InputMaybe<UserCreateNestedOneWithoutDisputesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DisputeListRelationFilter = {
  every?: InputMaybe<DisputeWhereInput>;
  none?: InputMaybe<DisputeWhereInput>;
  some?: InputMaybe<DisputeWhereInput>;
};

export type DisputeMaxAggregate = {
  __typename?: 'DisputeMaxAggregate';
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerName?: Maybe<Scalars['String']['output']>;
  consumerPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last4Ssn?: Maybe<Scalars['String']['output']>;
  monitoringEnrollmentId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<DisputeReasonEnum>;
  reportId?: Maybe<Scalars['String']['output']>;
  resolutionOutcome?: Maybe<DisputeResolutionOutcomeEnum>;
  specificItem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DisputeStatusEnum>;
  submittedById?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DisputeMinAggregate = {
  __typename?: 'DisputeMinAggregate';
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerName?: Maybe<Scalars['String']['output']>;
  consumerPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last4Ssn?: Maybe<Scalars['String']['output']>;
  monitoringEnrollmentId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<DisputeReasonEnum>;
  reportId?: Maybe<Scalars['String']['output']>;
  resolutionOutcome?: Maybe<DisputeResolutionOutcomeEnum>;
  specificItem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DisputeStatusEnum>;
  submittedById?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DisputeNullableScalarRelationFilter = {
  is?: InputMaybe<DisputeWhereInput>;
  isNot?: InputMaybe<DisputeWhereInput>;
};

export type DisputeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DisputeOrderByWithRelationInput = {
  consumerEmail?: InputMaybe<SortOrderInput>;
  consumerName?: InputMaybe<SortOrder>;
  consumerPhone?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dob?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  last4Ssn?: InputMaybe<SortOrderInput>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentOrderByWithRelationInput>;
  monitoringEnrollmentId?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  report?: InputMaybe<FileOrderByWithRelationInput>;
  reportId?: InputMaybe<SortOrderInput>;
  resolutionOutcome?: InputMaybe<SortOrderInput>;
  specificItem?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  submittedBy?: InputMaybe<UserOrderByWithRelationInput>;
  submittedById?: InputMaybe<SortOrderInput>;
  supportingDocuments?: InputMaybe<FileOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DisputeReasonEnum {
  ClarificationOnCriminalRecords = 'CLARIFICATION_ON_CRIMINAL_RECORDS',
  ClarificationOnInformation = 'CLARIFICATION_ON_INFORMATION',
  DismissedOrExpunged = 'DISMISSED_OR_EXPUNGED',
  InaccurateInformation = 'INACCURATE_INFORMATION',
  InaccurateRecords = 'INACCURATE_RECORDS',
  NotMyInformation = 'NOT_MY_INFORMATION',
  NotMyRecords = 'NOT_MY_RECORDS',
  Other = 'OTHER',
  VictimOfHumanTrafficking = 'VICTIM_OF_HUMAN_TRAFFICKING'
}

export type DisputeResolution = {
  __typename?: 'DisputeResolution';
  changes: Array<DisputeResolutionChange>;
  disputeId: Scalars['String']['output'];
  outcome?: Maybe<DisputeResolutionOutcomeEnum>;
  resolvedAt: Scalars['String']['output'];
};

export type DisputeResolutionChange = {
  __typename?: 'DisputeResolutionChange';
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  op: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export enum DisputeResolutionOutcomeEnum {
  ResultsChanged = 'RESULTS_CHANGED',
  ResultsUnchanged = 'RESULTS_UNCHANGED'
}

export enum DisputeScalarFieldEnum {
  ConsumerEmail = 'consumerEmail',
  ConsumerName = 'consumerName',
  ConsumerPhone = 'consumerPhone',
  CreatedAt = 'createdAt',
  Description = 'description',
  Dob = 'dob',
  Id = 'id',
  Last4Ssn = 'last4Ssn',
  MonitoringEnrollmentId = 'monitoringEnrollmentId',
  OrderId = 'orderId',
  Reason = 'reason',
  ReportId = 'reportId',
  ResolutionOutcome = 'resolutionOutcome',
  SpecificItem = 'specificItem',
  Status = 'status',
  SubmittedById = 'submittedById',
  UpdatedAt = 'updatedAt'
}

export type DisputeScalarWhereInput = {
  AND?: InputMaybe<Array<DisputeScalarWhereInput>>;
  NOT?: InputMaybe<Array<DisputeScalarWhereInput>>;
  OR?: InputMaybe<Array<DisputeScalarWhereInput>>;
  consumerEmail?: InputMaybe<StringNullableFilter>;
  consumerName?: InputMaybe<StringFilter>;
  consumerPhone?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dob?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  last4Ssn?: InputMaybe<StringNullableFilter>;
  monitoringEnrollmentId?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<EnumDisputeReasonEnumFilter>;
  reportId?: InputMaybe<StringNullableFilter>;
  resolutionOutcome?: InputMaybe<EnumDisputeResolutionOutcomeEnumNullableFilter>;
  specificItem?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDisputeStatusEnumFilter>;
  submittedById?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DisputeStatusEnum {
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type DisputeUpdateInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentUpdateOneWithoutDisputesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDisputesNestedInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  report?: InputMaybe<FileUpdateOneWithoutDisputesNestedInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  submittedBy?: InputMaybe<UserUpdateOneWithoutDisputesNestedInput>;
  supportingDocuments?: InputMaybe<FileUpdateManyWithoutDisputeSupportingDocumentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpdateManyMutationInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpdateManyWithWhereWithoutMonitoringEnrollmentInput = {
  data: DisputeUpdateManyMutationInput;
  where: DisputeScalarWhereInput;
};

export type DisputeUpdateManyWithWhereWithoutOrderInput = {
  data: DisputeUpdateManyMutationInput;
  where: DisputeScalarWhereInput;
};

export type DisputeUpdateManyWithWhereWithoutReportInput = {
  data: DisputeUpdateManyMutationInput;
  where: DisputeScalarWhereInput;
};

export type DisputeUpdateManyWithWhereWithoutSubmittedByInput = {
  data: DisputeUpdateManyMutationInput;
  where: DisputeScalarWhereInput;
};

export type DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutMonitoringEnrollmentInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutMonitoringEnrollmentInput>>;
  createMany?: InputMaybe<DisputeCreateManyMonitoringEnrollmentInputEnvelope>;
  delete?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisputeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  set?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  update?: InputMaybe<Array<DisputeUpdateWithWhereUniqueWithoutMonitoringEnrollmentInput>>;
  updateMany?: InputMaybe<Array<DisputeUpdateManyWithWhereWithoutMonitoringEnrollmentInput>>;
  upsert?: InputMaybe<Array<DisputeUpsertWithWhereUniqueWithoutMonitoringEnrollmentInput>>;
};

export type DisputeUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutOrderInput>>;
  createMany?: InputMaybe<DisputeCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisputeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  set?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  update?: InputMaybe<Array<DisputeUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<DisputeUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<DisputeUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type DisputeUpdateManyWithoutReportNestedInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutReportInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutReportInput>>;
  createMany?: InputMaybe<DisputeCreateManyReportInputEnvelope>;
  delete?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisputeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  set?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  update?: InputMaybe<Array<DisputeUpdateWithWhereUniqueWithoutReportInput>>;
  updateMany?: InputMaybe<Array<DisputeUpdateManyWithWhereWithoutReportInput>>;
  upsert?: InputMaybe<Array<DisputeUpsertWithWhereUniqueWithoutReportInput>>;
};

export type DisputeUpdateManyWithoutSubmittedByNestedInput = {
  connect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DisputeCreateOrConnectWithoutSubmittedByInput>>;
  create?: InputMaybe<Array<DisputeCreateWithoutSubmittedByInput>>;
  createMany?: InputMaybe<DisputeCreateManySubmittedByInputEnvelope>;
  delete?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DisputeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  set?: InputMaybe<Array<DisputeWhereUniqueInput>>;
  update?: InputMaybe<Array<DisputeUpdateWithWhereUniqueWithoutSubmittedByInput>>;
  updateMany?: InputMaybe<Array<DisputeUpdateManyWithWhereWithoutSubmittedByInput>>;
  upsert?: InputMaybe<Array<DisputeUpsertWithWhereUniqueWithoutSubmittedByInput>>;
};

export type DisputeUpdateOneWithoutSupportingDocumentsNestedInput = {
  connect?: InputMaybe<DisputeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DisputeCreateOrConnectWithoutSupportingDocumentsInput>;
  create?: InputMaybe<DisputeCreateWithoutSupportingDocumentsInput>;
  delete?: InputMaybe<DisputeWhereInput>;
  disconnect?: InputMaybe<DisputeWhereInput>;
  update?: InputMaybe<DisputeUpdateToOneWithWhereWithoutSupportingDocumentsInput>;
  upsert?: InputMaybe<DisputeUpsertWithoutSupportingDocumentsInput>;
};

export type DisputeUpdateToOneWithWhereWithoutSupportingDocumentsInput = {
  data: DisputeUpdateWithoutSupportingDocumentsInput;
  where?: InputMaybe<DisputeWhereInput>;
};

export type DisputeUpdateWithWhereUniqueWithoutMonitoringEnrollmentInput = {
  data: DisputeUpdateWithoutMonitoringEnrollmentInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpdateWithWhereUniqueWithoutOrderInput = {
  data: DisputeUpdateWithoutOrderInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpdateWithWhereUniqueWithoutReportInput = {
  data: DisputeUpdateWithoutReportInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpdateWithWhereUniqueWithoutSubmittedByInput = {
  data: DisputeUpdateWithoutSubmittedByInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpdateWithoutMonitoringEnrollmentInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDisputesNestedInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  report?: InputMaybe<FileUpdateOneWithoutDisputesNestedInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  submittedBy?: InputMaybe<UserUpdateOneWithoutDisputesNestedInput>;
  supportingDocuments?: InputMaybe<FileUpdateManyWithoutDisputeSupportingDocumentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpdateWithoutOrderInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentUpdateOneWithoutDisputesNestedInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  report?: InputMaybe<FileUpdateOneWithoutDisputesNestedInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  submittedBy?: InputMaybe<UserUpdateOneWithoutDisputesNestedInput>;
  supportingDocuments?: InputMaybe<FileUpdateManyWithoutDisputeSupportingDocumentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpdateWithoutReportInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentUpdateOneWithoutDisputesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDisputesNestedInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  submittedBy?: InputMaybe<UserUpdateOneWithoutDisputesNestedInput>;
  supportingDocuments?: InputMaybe<FileUpdateManyWithoutDisputeSupportingDocumentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpdateWithoutSubmittedByInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentUpdateOneWithoutDisputesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDisputesNestedInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  report?: InputMaybe<FileUpdateOneWithoutDisputesNestedInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  supportingDocuments?: InputMaybe<FileUpdateManyWithoutDisputeSupportingDocumentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpdateWithoutSupportingDocumentsInput = {
  consumerEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consumerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  consumerPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4Ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentUpdateOneWithoutDisputesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutDisputesNestedInput>;
  reason?: InputMaybe<EnumDisputeReasonEnumFieldUpdateOperationsInput>;
  report?: InputMaybe<FileUpdateOneWithoutDisputesNestedInput>;
  resolutionOutcome?: InputMaybe<NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput>;
  specificItem?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDisputeStatusEnumFieldUpdateOperationsInput>;
  submittedBy?: InputMaybe<UserUpdateOneWithoutDisputesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DisputeUpsertWithWhereUniqueWithoutMonitoringEnrollmentInput = {
  create: DisputeCreateWithoutMonitoringEnrollmentInput;
  update: DisputeUpdateWithoutMonitoringEnrollmentInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpsertWithWhereUniqueWithoutOrderInput = {
  create: DisputeCreateWithoutOrderInput;
  update: DisputeUpdateWithoutOrderInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpsertWithWhereUniqueWithoutReportInput = {
  create: DisputeCreateWithoutReportInput;
  update: DisputeUpdateWithoutReportInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpsertWithWhereUniqueWithoutSubmittedByInput = {
  create: DisputeCreateWithoutSubmittedByInput;
  update: DisputeUpdateWithoutSubmittedByInput;
  where: DisputeWhereUniqueInput;
};

export type DisputeUpsertWithoutSupportingDocumentsInput = {
  create: DisputeCreateWithoutSupportingDocumentsInput;
  update: DisputeUpdateWithoutSupportingDocumentsInput;
  where?: InputMaybe<DisputeWhereInput>;
};

export type DisputeWhereInput = {
  AND?: InputMaybe<Array<DisputeWhereInput>>;
  NOT?: InputMaybe<Array<DisputeWhereInput>>;
  OR?: InputMaybe<Array<DisputeWhereInput>>;
  consumerEmail?: InputMaybe<StringNullableFilter>;
  consumerName?: InputMaybe<StringFilter>;
  consumerPhone?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dob?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  last4Ssn?: InputMaybe<StringNullableFilter>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentNullableScalarRelationFilter>;
  monitoringEnrollmentId?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<EnumDisputeReasonEnumFilter>;
  report?: InputMaybe<FileNullableScalarRelationFilter>;
  reportId?: InputMaybe<StringNullableFilter>;
  resolutionOutcome?: InputMaybe<EnumDisputeResolutionOutcomeEnumNullableFilter>;
  specificItem?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDisputeStatusEnumFilter>;
  submittedBy?: InputMaybe<UserNullableScalarRelationFilter>;
  submittedById?: InputMaybe<StringNullableFilter>;
  supportingDocuments?: InputMaybe<FileListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DisputeWhereUniqueInput = {
  AND?: InputMaybe<Array<DisputeWhereInput>>;
  NOT?: InputMaybe<Array<DisputeWhereInput>>;
  OR?: InputMaybe<Array<DisputeWhereInput>>;
  consumerEmail?: InputMaybe<StringNullableFilter>;
  consumerName?: InputMaybe<StringFilter>;
  consumerPhone?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dob?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4Ssn?: InputMaybe<StringNullableFilter>;
  monitoringEnrollment?: InputMaybe<MonitoringEnrollmentNullableScalarRelationFilter>;
  monitoringEnrollmentId?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<EnumDisputeReasonEnumFilter>;
  report?: InputMaybe<FileNullableScalarRelationFilter>;
  reportId?: InputMaybe<StringNullableFilter>;
  resolutionOutcome?: InputMaybe<EnumDisputeResolutionOutcomeEnumNullableFilter>;
  specificItem?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDisputeStatusEnumFilter>;
  submittedBy?: InputMaybe<UserNullableScalarRelationFilter>;
  submittedById?: InputMaybe<StringNullableFilter>;
  supportingDocuments?: InputMaybe<FileListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnumAddressTypeEnumNullableFilter = {
  equals?: InputMaybe<AddressTypeEnum>;
  in?: InputMaybe<Array<AddressTypeEnum>>;
  not?: InputMaybe<NestedEnumAddressTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<AddressTypeEnum>>;
};

export type EnumApiKeyVerificationStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ApiKeyVerificationStatusEnum>;
};

export type EnumApiKeyVerificationStatusEnumFilter = {
  equals?: InputMaybe<ApiKeyVerificationStatusEnum>;
  in?: InputMaybe<Array<ApiKeyVerificationStatusEnum>>;
  not?: InputMaybe<NestedEnumApiKeyVerificationStatusEnumFilter>;
  notIn?: InputMaybe<Array<ApiKeyVerificationStatusEnum>>;
};

export type EnumAppFeedbackStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AppFeedbackStatusEnum>;
};

export type EnumAppFeedbackStatusEnumFilter = {
  equals?: InputMaybe<AppFeedbackStatusEnum>;
  in?: InputMaybe<Array<AppFeedbackStatusEnum>>;
  not?: InputMaybe<NestedEnumAppFeedbackStatusEnumFilter>;
  notIn?: InputMaybe<Array<AppFeedbackStatusEnum>>;
};

export type EnumAttachmentEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AttachmentEnum>;
};

export type EnumAttachmentEnumFilter = {
  equals?: InputMaybe<AttachmentEnum>;
  in?: InputMaybe<Array<AttachmentEnum>>;
  not?: InputMaybe<NestedEnumAttachmentEnumFilter>;
  notIn?: InputMaybe<Array<AttachmentEnum>>;
};

export type EnumBeamDataSourceEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<BeamDataSourceEnum>;
};

export type EnumBeamDataSourceEnumFilter = {
  equals?: InputMaybe<BeamDataSourceEnum>;
  in?: InputMaybe<Array<BeamDataSourceEnum>>;
  not?: InputMaybe<NestedEnumBeamDataSourceEnumFilter>;
  notIn?: InputMaybe<Array<BeamDataSourceEnum>>;
};

export type EnumBeamRunStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<BeamRunStatusEnum>;
};

export type EnumBeamRunStatusEnumFilter = {
  equals?: InputMaybe<BeamRunStatusEnum>;
  in?: InputMaybe<Array<BeamRunStatusEnum>>;
  not?: InputMaybe<NestedEnumBeamRunStatusEnumFilter>;
  notIn?: InputMaybe<Array<BeamRunStatusEnum>>;
};

export type EnumBeamTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<BeamTypeEnum>;
};

export type EnumBeamTypeEnumFilter = {
  equals?: InputMaybe<BeamTypeEnum>;
  in?: InputMaybe<Array<BeamTypeEnum>>;
  not?: InputMaybe<NestedEnumBeamTypeEnumFilter>;
  notIn?: InputMaybe<Array<BeamTypeEnum>>;
};

export type EnumCredentialStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<CredentialStatusEnum>;
};

export type EnumCredentialStatusEnumFilter = {
  equals?: InputMaybe<CredentialStatusEnum>;
  in?: InputMaybe<Array<CredentialStatusEnum>>;
  not?: InputMaybe<NestedEnumCredentialStatusEnumFilter>;
  notIn?: InputMaybe<Array<CredentialStatusEnum>>;
};

export type EnumCurrencyMultiplierEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<CurrencyMultiplierEnum>;
};

export type EnumCurrencyMultiplierEnumFilter = {
  equals?: InputMaybe<CurrencyMultiplierEnum>;
  in?: InputMaybe<Array<CurrencyMultiplierEnum>>;
  not?: InputMaybe<NestedEnumCurrencyMultiplierEnumFilter>;
  notIn?: InputMaybe<Array<CurrencyMultiplierEnum>>;
};

export type EnumCurrencyTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<CurrencyTypeEnum>;
};

export type EnumCurrencyTypeEnumFilter = {
  equals?: InputMaybe<CurrencyTypeEnum>;
  in?: InputMaybe<Array<CurrencyTypeEnum>>;
  not?: InputMaybe<NestedEnumCurrencyTypeEnumFilter>;
  notIn?: InputMaybe<Array<CurrencyTypeEnum>>;
};

export type EnumDeviceTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DeviceTypeEnum>;
};

export type EnumDeviceTypeEnumFilter = {
  equals?: InputMaybe<DeviceTypeEnum>;
  in?: InputMaybe<Array<DeviceTypeEnum>>;
  not?: InputMaybe<NestedEnumDeviceTypeEnumFilter>;
  notIn?: InputMaybe<Array<DeviceTypeEnum>>;
};

export type EnumDeviceTypeEnumNullableFilter = {
  equals?: InputMaybe<DeviceTypeEnum>;
  in?: InputMaybe<Array<DeviceTypeEnum>>;
  not?: InputMaybe<NestedEnumDeviceTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<DeviceTypeEnum>>;
};

export type EnumDeviceTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDeviceTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumDeviceTypeEnumNullableFilter>;
  equals?: InputMaybe<DeviceTypeEnum>;
  in?: InputMaybe<Array<DeviceTypeEnum>>;
  not?: InputMaybe<NestedEnumDeviceTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DeviceTypeEnum>>;
};

export type EnumDisclosureTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DisclosureTypeEnum>;
};

export type EnumDisclosureTypeEnumFilter = {
  equals?: InputMaybe<DisclosureTypeEnum>;
  in?: InputMaybe<Array<DisclosureTypeEnum>>;
  not?: InputMaybe<NestedEnumDisclosureTypeEnumFilter>;
  notIn?: InputMaybe<Array<DisclosureTypeEnum>>;
};

export type EnumDisenrollmentSourceNullableFilter = {
  equals?: InputMaybe<DisenrollmentSource>;
  in?: InputMaybe<Array<DisenrollmentSource>>;
  not?: InputMaybe<NestedEnumDisenrollmentSourceNullableFilter>;
  notIn?: InputMaybe<Array<DisenrollmentSource>>;
};

export type EnumDisputeReasonEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DisputeReasonEnum>;
};

export type EnumDisputeReasonEnumFilter = {
  equals?: InputMaybe<DisputeReasonEnum>;
  in?: InputMaybe<Array<DisputeReasonEnum>>;
  not?: InputMaybe<NestedEnumDisputeReasonEnumFilter>;
  notIn?: InputMaybe<Array<DisputeReasonEnum>>;
};

export type EnumDisputeResolutionOutcomeEnumNullableFilter = {
  equals?: InputMaybe<DisputeResolutionOutcomeEnum>;
  in?: InputMaybe<Array<DisputeResolutionOutcomeEnum>>;
  not?: InputMaybe<NestedEnumDisputeResolutionOutcomeEnumNullableFilter>;
  notIn?: InputMaybe<Array<DisputeResolutionOutcomeEnum>>;
};

export type EnumDisputeStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DisputeStatusEnum>;
};

export type EnumDisputeStatusEnumFilter = {
  equals?: InputMaybe<DisputeStatusEnum>;
  in?: InputMaybe<Array<DisputeStatusEnum>>;
  not?: InputMaybe<NestedEnumDisputeStatusEnumFilter>;
  notIn?: InputMaybe<Array<DisputeStatusEnum>>;
};

export type EnumFilePurposeTypeEnumNullableFilter = {
  equals?: InputMaybe<FilePurposeTypeEnum>;
  in?: InputMaybe<Array<FilePurposeTypeEnum>>;
  not?: InputMaybe<NestedEnumFilePurposeTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<FilePurposeTypeEnum>>;
};

export type EnumHighlySensitiveIdentifierTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<HighlySensitiveIdentifierType>;
};

export type EnumHighlySensitiveIdentifierTypeFilter = {
  equals?: InputMaybe<HighlySensitiveIdentifierType>;
  in?: InputMaybe<Array<HighlySensitiveIdentifierType>>;
  not?: InputMaybe<NestedEnumHighlySensitiveIdentifierTypeFilter>;
  notIn?: InputMaybe<Array<HighlySensitiveIdentifierType>>;
};

export type EnumIdCaptureMethodNullableFilter = {
  equals?: InputMaybe<IdCaptureMethod>;
  in?: InputMaybe<Array<IdCaptureMethod>>;
  not?: InputMaybe<NestedEnumIdCaptureMethodNullableFilter>;
  notIn?: InputMaybe<Array<IdCaptureMethod>>;
};

export type EnumIdCardRotationEnumNullableFilter = {
  equals?: InputMaybe<IdCardRotationEnum>;
  in?: InputMaybe<Array<IdCardRotationEnum>>;
  not?: InputMaybe<NestedEnumIdCardRotationEnumNullableFilter>;
  notIn?: InputMaybe<Array<IdCardRotationEnum>>;
};

export type EnumIdVerificationModelEnumNullableFilter = {
  equals?: InputMaybe<IdVerificationModelEnum>;
  in?: InputMaybe<Array<IdVerificationModelEnum>>;
  not?: InputMaybe<NestedEnumIdVerificationModelEnumNullableFilter>;
  notIn?: InputMaybe<Array<IdVerificationModelEnum>>;
};

export type EnumIdVerificationResultCheckEnumNullableFilter = {
  equals?: InputMaybe<IdVerificationResultCheckEnum>;
  in?: InputMaybe<Array<IdVerificationResultCheckEnum>>;
  not?: InputMaybe<NestedEnumIdVerificationResultCheckEnumNullableFilter>;
  notIn?: InputMaybe<Array<IdVerificationResultCheckEnum>>;
};

export type EnumIdentifierTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<IdentifierType>;
};

export type EnumIdentifierTypeFilter = {
  equals?: InputMaybe<IdentifierType>;
  in?: InputMaybe<Array<IdentifierType>>;
  not?: InputMaybe<NestedEnumIdentifierTypeFilter>;
  notIn?: InputMaybe<Array<IdentifierType>>;
};

export type EnumJobStatusEnumNullableFilter = {
  equals?: InputMaybe<JobStatusEnum>;
  in?: InputMaybe<Array<JobStatusEnum>>;
  not?: InputMaybe<NestedEnumJobStatusEnumNullableFilter>;
  notIn?: InputMaybe<Array<JobStatusEnum>>;
};

export type EnumJobStatusEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumJobStatusEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumJobStatusEnumNullableFilter>;
  equals?: InputMaybe<JobStatusEnum>;
  in?: InputMaybe<Array<JobStatusEnum>>;
  not?: InputMaybe<NestedEnumJobStatusEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<JobStatusEnum>>;
};

export type EnumLocationTypeEnumNullableFilter = {
  equals?: InputMaybe<LocationTypeEnum>;
  in?: InputMaybe<Array<LocationTypeEnum>>;
  not?: InputMaybe<NestedEnumLocationTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<LocationTypeEnum>>;
};

export type EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringEnrollmentStatus>;
};

export type EnumMonitoringEnrollmentStatusFilter = {
  equals?: InputMaybe<MonitoringEnrollmentStatus>;
  in?: InputMaybe<Array<MonitoringEnrollmentStatus>>;
  not?: InputMaybe<NestedEnumMonitoringEnrollmentStatusFilter>;
  notIn?: InputMaybe<Array<MonitoringEnrollmentStatus>>;
};

export type EnumMonitoringEnrollmentStrategyFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringEnrollmentStrategy>;
};

export type EnumMonitoringEnrollmentStrategyFilter = {
  equals?: InputMaybe<MonitoringEnrollmentStrategy>;
  in?: InputMaybe<Array<MonitoringEnrollmentStrategy>>;
  not?: InputMaybe<NestedEnumMonitoringEnrollmentStrategyFilter>;
  notIn?: InputMaybe<Array<MonitoringEnrollmentStrategy>>;
};

export type EnumMonitoringFrequencyFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringFrequency>;
};

export type EnumMonitoringFrequencyFilter = {
  equals?: InputMaybe<MonitoringFrequency>;
  in?: InputMaybe<Array<MonitoringFrequency>>;
  not?: InputMaybe<NestedEnumMonitoringFrequencyFilter>;
  notIn?: InputMaybe<Array<MonitoringFrequency>>;
};

export type EnumMonitoringProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringProvider>;
};

export type EnumMonitoringProviderFilter = {
  equals?: InputMaybe<MonitoringProvider>;
  in?: InputMaybe<Array<MonitoringProvider>>;
  not?: InputMaybe<NestedEnumMonitoringProviderFilter>;
  notIn?: InputMaybe<Array<MonitoringProvider>>;
};

export type EnumMonitoringReportReviewOutcomeNullableFilter = {
  equals?: InputMaybe<MonitoringReportReviewOutcome>;
  in?: InputMaybe<Array<MonitoringReportReviewOutcome>>;
  not?: InputMaybe<NestedEnumMonitoringReportReviewOutcomeNullableFilter>;
  notIn?: InputMaybe<Array<MonitoringReportReviewOutcome>>;
};

export type EnumMonitoringReportReviewStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringReportReviewStatus>;
};

export type EnumMonitoringReportReviewStatusFilter = {
  equals?: InputMaybe<MonitoringReportReviewStatus>;
  in?: InputMaybe<Array<MonitoringReportReviewStatus>>;
  not?: InputMaybe<NestedEnumMonitoringReportReviewStatusFilter>;
  notIn?: InputMaybe<Array<MonitoringReportReviewStatus>>;
};

export type EnumMonitoringReportScoreNullableFilter = {
  equals?: InputMaybe<MonitoringReportScore>;
  in?: InputMaybe<Array<MonitoringReportScore>>;
  not?: InputMaybe<NestedEnumMonitoringReportScoreNullableFilter>;
  notIn?: InputMaybe<Array<MonitoringReportScore>>;
};

export type EnumMonitoringReviewStrategyFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringReviewStrategy>;
};

export type EnumMonitoringReviewStrategyFilter = {
  equals?: InputMaybe<MonitoringReviewStrategy>;
  in?: InputMaybe<Array<MonitoringReviewStrategy>>;
  not?: InputMaybe<NestedEnumMonitoringReviewStrategyFilter>;
  notIn?: InputMaybe<Array<MonitoringReviewStrategy>>;
};

export type EnumMonitoringSecondaryVerificationProviderNullableFilter = {
  equals?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  in?: InputMaybe<Array<MonitoringSecondaryVerificationProvider>>;
  not?: InputMaybe<NestedEnumMonitoringSecondaryVerificationProviderNullableFilter>;
  notIn?: InputMaybe<Array<MonitoringSecondaryVerificationProvider>>;
};

export type EnumNameTypeEnumNullableFilter = {
  equals?: InputMaybe<NameTypeEnum>;
  in?: InputMaybe<Array<NameTypeEnum>>;
  not?: InputMaybe<NestedEnumNameTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<NameTypeEnum>>;
};

export type EnumOrderAlertEnumNullableFilter = {
  equals?: InputMaybe<OrderAlertEnum>;
  in?: InputMaybe<Array<OrderAlertEnum>>;
  not?: InputMaybe<NestedEnumOrderAlertEnumNullableFilter>;
  notIn?: InputMaybe<Array<OrderAlertEnum>>;
};

export type EnumOrderDeliveryMethodNullableFilter = {
  equals?: InputMaybe<OrderDeliveryMethod>;
  in?: InputMaybe<Array<OrderDeliveryMethod>>;
  not?: InputMaybe<NestedEnumOrderDeliveryMethodNullableFilter>;
  notIn?: InputMaybe<Array<OrderDeliveryMethod>>;
};

export type EnumOrderScoreEnumNullableFilter = {
  equals?: InputMaybe<OrderScoreEnum>;
  in?: InputMaybe<Array<OrderScoreEnum>>;
  not?: InputMaybe<NestedEnumOrderScoreEnumNullableFilter>;
  notIn?: InputMaybe<Array<OrderScoreEnum>>;
};

export type EnumOrderStatusEnumNullableFilter = {
  equals?: InputMaybe<OrderStatusEnum>;
  in?: InputMaybe<Array<OrderStatusEnum>>;
  not?: InputMaybe<NestedEnumOrderStatusEnumNullableFilter>;
  notIn?: InputMaybe<Array<OrderStatusEnum>>;
};

export type EnumOrgRelationTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<OrgRelationTypeEnum>;
};

export type EnumOrgRelationTypeEnumFilter = {
  equals?: InputMaybe<OrgRelationTypeEnum>;
  in?: InputMaybe<Array<OrgRelationTypeEnum>>;
  not?: InputMaybe<NestedEnumOrgRelationTypeEnumFilter>;
  notIn?: InputMaybe<Array<OrgRelationTypeEnum>>;
};

export type EnumPerformerTypesFieldUpdateOperationsInput = {
  set?: InputMaybe<PerformerTypes>;
};

export type EnumPerformerTypesFilter = {
  equals?: InputMaybe<PerformerTypes>;
  in?: InputMaybe<Array<PerformerTypes>>;
  not?: InputMaybe<NestedEnumPerformerTypesFilter>;
  notIn?: InputMaybe<Array<PerformerTypes>>;
};

export type EnumProcessorEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ProcessorEnum>;
};

export type EnumProcessorEnumFilter = {
  equals?: InputMaybe<ProcessorEnum>;
  in?: InputMaybe<Array<ProcessorEnum>>;
  not?: InputMaybe<NestedEnumProcessorEnumFilter>;
  notIn?: InputMaybe<Array<ProcessorEnum>>;
};

export type EnumResultAlertTypeEnumNullableFilter = {
  equals?: InputMaybe<ResultAlertTypeEnum>;
  in?: InputMaybe<Array<ResultAlertTypeEnum>>;
  not?: InputMaybe<NestedEnumResultAlertTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<ResultAlertTypeEnum>>;
};

export type EnumResultSearchTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ResultSearchType>;
};

export type EnumResultSearchTypeFilter = {
  equals?: InputMaybe<ResultSearchType>;
  in?: InputMaybe<Array<ResultSearchType>>;
  not?: InputMaybe<NestedEnumResultSearchTypeFilter>;
  notIn?: InputMaybe<Array<ResultSearchType>>;
};

export type EnumResultSearchTypeNullableFilter = {
  equals?: InputMaybe<ResultSearchType>;
  in?: InputMaybe<Array<ResultSearchType>>;
  not?: InputMaybe<NestedEnumResultSearchTypeNullableFilter>;
  notIn?: InputMaybe<Array<ResultSearchType>>;
};

export type EnumResultStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ResultStatusEnum>;
};

export type EnumResultStatusEnumFilter = {
  equals?: InputMaybe<ResultStatusEnum>;
  in?: InputMaybe<Array<ResultStatusEnum>>;
  not?: InputMaybe<NestedEnumResultStatusEnumFilter>;
  notIn?: InputMaybe<Array<ResultStatusEnum>>;
};

export type EnumSearchStatusTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<SearchStatusTypeEnum>;
};

export type EnumSearchStatusTypeEnumFilter = {
  equals?: InputMaybe<SearchStatusTypeEnum>;
  in?: InputMaybe<Array<SearchStatusTypeEnum>>;
  not?: InputMaybe<NestedEnumSearchStatusTypeEnumFilter>;
  notIn?: InputMaybe<Array<SearchStatusTypeEnum>>;
};

export type EnumSourceTypesFieldUpdateOperationsInput = {
  set?: InputMaybe<SourceTypes>;
};

export type EnumSourceTypesFilter = {
  equals?: InputMaybe<SourceTypes>;
  in?: InputMaybe<Array<SourceTypes>>;
  not?: InputMaybe<NestedEnumSourceTypesFilter>;
  notIn?: InputMaybe<Array<SourceTypes>>;
};

export type EnumUserPrimaryContactEnumNullableFilter = {
  equals?: InputMaybe<UserPrimaryContactEnum>;
  in?: InputMaybe<Array<UserPrimaryContactEnum>>;
  not?: InputMaybe<NestedEnumUserPrimaryContactEnumNullableFilter>;
  notIn?: InputMaybe<Array<UserPrimaryContactEnum>>;
};

export type EnumVoucherOriginNullableFilter = {
  equals?: InputMaybe<VoucherOrigin>;
  in?: InputMaybe<Array<VoucherOrigin>>;
  not?: InputMaybe<NestedEnumVoucherOriginNullableFilter>;
  notIn?: InputMaybe<Array<VoucherOrigin>>;
};

export type EnumVoucherStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<VoucherStatusEnum>;
};

export type EnumVoucherStatusEnumFilter = {
  equals?: InputMaybe<VoucherStatusEnum>;
  in?: InputMaybe<Array<VoucherStatusEnum>>;
  not?: InputMaybe<NestedEnumVoucherStatusEnumFilter>;
  notIn?: InputMaybe<Array<VoucherStatusEnum>>;
};

export type ExtendedOrderCreateInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type File = {
  __typename?: 'File';
  _count?: Maybe<FileCount>;
  backIdUser?: Maybe<User>;
  backIdUserId?: Maybe<Scalars['String']['output']>;
  beamInput?: Maybe<BeamInput>;
  beamInputId?: Maybe<Scalars['String']['output']>;
  beamOutput?: Maybe<BeamOutput>;
  beamOutputId?: Maybe<Scalars['String']['output']>;
  biometricConsentAcceptance?: Maybe<BiometricConsentAcceptance>;
  biometricConsentAcceptanceId?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disclosureAcceptance?: Maybe<DisclosureAcceptance>;
  disclosureAcceptanceId?: Maybe<Scalars['String']['output']>;
  disputeSupportingDocument?: Maybe<Dispute>;
  disputeSupportingDocumentId?: Maybe<Scalars['String']['output']>;
  disputes: Array<Dispute>;
  frontIdUser?: Maybe<User>;
  frontIdUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationDocumentBack?: Maybe<IdentificationDocument>;
  identificationDocumentBackId?: Maybe<Scalars['String']['output']>;
  identificationDocumentExtract?: Maybe<IdentificationDocument>;
  identificationDocumentExtractId?: Maybe<Scalars['String']['output']>;
  identificationDocumentFront?: Maybe<IdentificationDocument>;
  identificationDocumentFrontId?: Maybe<Scalars['String']['output']>;
  identificationDocumentSelfie?: Maybe<IdentificationDocument>;
  identificationDocumentSelfieId?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  monitoringReport?: Maybe<MonitoringReport>;
  monitoringReportId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationHorizontalLogo?: Maybe<Organization>;
  organizationLogo?: Maybe<Organization>;
  passportBack?: Maybe<Passport>;
  passportBackId?: Maybe<Scalars['String']['output']>;
  passportCardSelfie?: Maybe<Passport>;
  passportCardSelfieId?: Maybe<Scalars['String']['output']>;
  passportExtractPhoto?: Maybe<Passport>;
  passportExtractPhotoId?: Maybe<Scalars['String']['output']>;
  passportFront?: Maybe<Passport>;
  passportFrontId?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<FilePurposeTypeEnum>;
  region?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Result>;
  resultId?: Maybe<Scalars['String']['output']>;
  selfieUser?: Maybe<User>;
  selfieUserId?: Maybe<Scalars['String']['output']>;
  stateIdentificationCardBack?: Maybe<StateIdentificationCard>;
  stateIdentificationCardBackId?: Maybe<Scalars['String']['output']>;
  stateIdentificationCardExtract?: Maybe<StateIdentificationCard>;
  stateIdentificationCardExtractId?: Maybe<Scalars['String']['output']>;
  stateIdentificationCardFront?: Maybe<StateIdentificationCard>;
  stateIdentificationCardFrontId?: Maybe<Scalars['String']['output']>;
  stateIdentificationCardSelfie?: Maybe<StateIdentificationCard>;
  stateIdentificationCardSelfieId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  url: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type FileBackIdUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileBeamInputArgs = {
  where?: InputMaybe<BeamInputWhereInput>;
};


export type FileBeamOutputArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type FileBiometricConsentAcceptanceArgs = {
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type FileDisclosureAcceptanceArgs = {
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type FileDisputeSupportingDocumentArgs = {
  where?: InputMaybe<DisputeWhereInput>;
};


export type FileDisputesArgs = {
  cursor?: InputMaybe<DisputeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisputeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisputeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type FileFrontIdUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileIdentificationDocumentBackArgs = {
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type FileIdentificationDocumentExtractArgs = {
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type FileIdentificationDocumentFrontArgs = {
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type FileIdentificationDocumentSelfieArgs = {
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type FileMonitoringReportArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};


export type FileOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type FileOrganizationHorizontalLogoArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type FileOrganizationLogoArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type FilePassportBackArgs = {
  where?: InputMaybe<PassportWhereInput>;
};


export type FilePassportCardSelfieArgs = {
  where?: InputMaybe<PassportWhereInput>;
};


export type FilePassportExtractPhotoArgs = {
  where?: InputMaybe<PassportWhereInput>;
};


export type FilePassportFrontArgs = {
  where?: InputMaybe<PassportWhereInput>;
};


export type FileResultArgs = {
  where?: InputMaybe<ResultWhereInput>;
};


export type FileSelfieUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type FileStateIdentificationCardBackArgs = {
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};


export type FileStateIdentificationCardExtractArgs = {
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};


export type FileStateIdentificationCardFrontArgs = {
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};


export type FileStateIdentificationCardSelfieArgs = {
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};


export type FileUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type FileCount = {
  __typename?: 'FileCount';
  disputes: Scalars['Int']['output'];
};


export type FileCountDisputesArgs = {
  where?: InputMaybe<DisputeWhereInput>;
};

export type FileCreateInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateManyBeamInputInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamOutputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyBeamInputInputEnvelope = {
  data: Array<FileCreateManyBeamInputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyBeamOutputInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyBeamOutputInputEnvelope = {
  data: Array<FileCreateManyBeamOutputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyDisputeSupportingDocumentInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<Scalars['String']['input']>;
  beamOutputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyDisputeSupportingDocumentInputEnvelope = {
  data: Array<FileCreateManyDisputeSupportingDocumentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyMonitoringReportInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<Scalars['String']['input']>;
  beamOutputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyMonitoringReportInputEnvelope = {
  data: Array<FileCreateManyMonitoringReportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyOrderInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<Scalars['String']['input']>;
  beamOutputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyOrderInputEnvelope = {
  data: Array<FileCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyResultInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<Scalars['String']['input']>;
  beamOutputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyResultInputEnvelope = {
  data: Array<FileCreateManyResultInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyUserInput = {
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<Scalars['String']['input']>;
  beamOutputId?: InputMaybe<Scalars['String']['input']>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FileCreateManyUserInputEnvelope = {
  data: Array<FileCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateNestedManyWithoutBeamInputInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutBeamInputInput>>;
  create?: InputMaybe<Array<FileCreateWithoutBeamInputInput>>;
  createMany?: InputMaybe<FileCreateManyBeamInputInputEnvelope>;
};

export type FileCreateNestedManyWithoutBeamOutputInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutBeamOutputInput>>;
  create?: InputMaybe<Array<FileCreateWithoutBeamOutputInput>>;
  createMany?: InputMaybe<FileCreateManyBeamOutputInputEnvelope>;
};

export type FileCreateNestedManyWithoutDisputeSupportingDocumentInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutDisputeSupportingDocumentInput>>;
  create?: InputMaybe<Array<FileCreateWithoutDisputeSupportingDocumentInput>>;
  createMany?: InputMaybe<FileCreateManyDisputeSupportingDocumentInputEnvelope>;
};

export type FileCreateNestedManyWithoutMonitoringReportInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<FileCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<FileCreateManyMonitoringReportInputEnvelope>;
};

export type FileCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderInput>>;
  createMany?: InputMaybe<FileCreateManyOrderInputEnvelope>;
};

export type FileCreateNestedManyWithoutResultInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutResultInput>>;
  create?: InputMaybe<Array<FileCreateWithoutResultInput>>;
  createMany?: InputMaybe<FileCreateManyResultInputEnvelope>;
};

export type FileCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserInput>>;
  createMany?: InputMaybe<FileCreateManyUserInputEnvelope>;
};

export type FileCreateNestedOneWithoutBackIdUserInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutBackIdUserInput>;
  create?: InputMaybe<FileCreateWithoutBackIdUserInput>;
};

export type FileCreateNestedOneWithoutBiometricConsentAcceptanceInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutBiometricConsentAcceptanceInput>;
  create?: InputMaybe<FileCreateWithoutBiometricConsentAcceptanceInput>;
};

export type FileCreateNestedOneWithoutDisclosureAcceptanceInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutDisclosureAcceptanceInput>;
  create?: InputMaybe<FileCreateWithoutDisclosureAcceptanceInput>;
};

export type FileCreateNestedOneWithoutDisputesInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<FileCreateWithoutDisputesInput>;
};

export type FileCreateNestedOneWithoutFrontIdUserInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutFrontIdUserInput>;
  create?: InputMaybe<FileCreateWithoutFrontIdUserInput>;
};

export type FileCreateNestedOneWithoutIdentificationDocumentBackInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentBackInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentBackInput>;
};

export type FileCreateNestedOneWithoutIdentificationDocumentExtractInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentExtractInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentExtractInput>;
};

export type FileCreateNestedOneWithoutIdentificationDocumentFrontInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentFrontInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentFrontInput>;
};

export type FileCreateNestedOneWithoutIdentificationDocumentSelfieInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentSelfieInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentSelfieInput>;
};

export type FileCreateNestedOneWithoutOrganizationHorizontalLogoInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutOrganizationHorizontalLogoInput>;
  create?: InputMaybe<FileCreateWithoutOrganizationHorizontalLogoInput>;
};

export type FileCreateNestedOneWithoutOrganizationLogoInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutOrganizationLogoInput>;
  create?: InputMaybe<FileCreateWithoutOrganizationLogoInput>;
};

export type FileCreateNestedOneWithoutPassportBackInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportBackInput>;
  create?: InputMaybe<FileCreateWithoutPassportBackInput>;
};

export type FileCreateNestedOneWithoutPassportCardSelfieInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportCardSelfieInput>;
  create?: InputMaybe<FileCreateWithoutPassportCardSelfieInput>;
};

export type FileCreateNestedOneWithoutPassportExtractPhotoInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportExtractPhotoInput>;
  create?: InputMaybe<FileCreateWithoutPassportExtractPhotoInput>;
};

export type FileCreateNestedOneWithoutPassportFrontInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportFrontInput>;
  create?: InputMaybe<FileCreateWithoutPassportFrontInput>;
};

export type FileCreateNestedOneWithoutSelfieUserInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutSelfieUserInput>;
  create?: InputMaybe<FileCreateWithoutSelfieUserInput>;
};

export type FileCreateNestedOneWithoutStateIdentificationCardBackInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardBackInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardBackInput>;
};

export type FileCreateNestedOneWithoutStateIdentificationCardExtractInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardExtractInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardExtractInput>;
};

export type FileCreateNestedOneWithoutStateIdentificationCardFrontInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardFrontInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardFrontInput>;
};

export type FileCreateNestedOneWithoutStateIdentificationCardSelfieInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardSelfieInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardSelfieInput>;
};

export type FileCreateOrConnectWithoutBackIdUserInput = {
  create: FileCreateWithoutBackIdUserInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutBeamInputInput = {
  create: FileCreateWithoutBeamInputInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutBeamOutputInput = {
  create: FileCreateWithoutBeamOutputInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutBiometricConsentAcceptanceInput = {
  create: FileCreateWithoutBiometricConsentAcceptanceInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutDisclosureAcceptanceInput = {
  create: FileCreateWithoutDisclosureAcceptanceInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutDisputeSupportingDocumentInput = {
  create: FileCreateWithoutDisputeSupportingDocumentInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutDisputesInput = {
  create: FileCreateWithoutDisputesInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutFrontIdUserInput = {
  create: FileCreateWithoutFrontIdUserInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutIdentificationDocumentBackInput = {
  create: FileCreateWithoutIdentificationDocumentBackInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutIdentificationDocumentExtractInput = {
  create: FileCreateWithoutIdentificationDocumentExtractInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutIdentificationDocumentFrontInput = {
  create: FileCreateWithoutIdentificationDocumentFrontInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutIdentificationDocumentSelfieInput = {
  create: FileCreateWithoutIdentificationDocumentSelfieInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutMonitoringReportInput = {
  create: FileCreateWithoutMonitoringReportInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrderInput = {
  create: FileCreateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrganizationHorizontalLogoInput = {
  create: FileCreateWithoutOrganizationHorizontalLogoInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrganizationLogoInput = {
  create: FileCreateWithoutOrganizationLogoInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutPassportBackInput = {
  create: FileCreateWithoutPassportBackInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutPassportCardSelfieInput = {
  create: FileCreateWithoutPassportCardSelfieInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutPassportExtractPhotoInput = {
  create: FileCreateWithoutPassportExtractPhotoInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutPassportFrontInput = {
  create: FileCreateWithoutPassportFrontInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutResultInput = {
  create: FileCreateWithoutResultInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutSelfieUserInput = {
  create: FileCreateWithoutSelfieUserInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutStateIdentificationCardBackInput = {
  create: FileCreateWithoutStateIdentificationCardBackInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutStateIdentificationCardExtractInput = {
  create: FileCreateWithoutStateIdentificationCardExtractInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutStateIdentificationCardFrontInput = {
  create: FileCreateWithoutStateIdentificationCardFrontInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutStateIdentificationCardSelfieInput = {
  create: FileCreateWithoutStateIdentificationCardSelfieInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserInput = {
  create: FileCreateWithoutUserInput;
  where: FileWhereUniqueInput;
};

export type FileCreateWithoutBackIdUserInput = {
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutBeamInputInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutBeamOutputInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutBiometricConsentAcceptanceInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutDisclosureAcceptanceInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutDisputeSupportingDocumentInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutDisputesInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutFrontIdUserInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutIdentificationDocumentBackInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutIdentificationDocumentExtractInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutIdentificationDocumentFrontInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutIdentificationDocumentSelfieInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutMonitoringReportInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutOrderInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutOrganizationHorizontalLogoInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutOrganizationLogoInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutPassportBackInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutPassportCardSelfieInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutPassportExtractPhotoInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutPassportFrontInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutResultInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutSelfieUserInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutStateIdentificationCardBackInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutStateIdentificationCardExtractInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutStateIdentificationCardFrontInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutStateIdentificationCardSelfieInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutUserInput = {
  backIdUser?: InputMaybe<UserCreateNestedOneWithoutBackIdInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedOneWithoutFilesInput>;
  beamOutput?: InputMaybe<BeamOutputCreateNestedOneWithoutFilesInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutPdfInput>;
  bucket?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceCreateNestedOneWithoutPdfInput>;
  disputeSupportingDocument?: InputMaybe<DisputeCreateNestedOneWithoutSupportingDocumentsInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutReportInput>;
  frontIdUser?: InputMaybe<UserCreateNestedOneWithoutFrontIdInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutBackImageInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutFrontImageInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutSelfieImageInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutPdfsInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationCreateNestedOneWithoutHorizontalLogoInput>;
  organizationLogo?: InputMaybe<OrganizationCreateNestedOneWithoutLogoInput>;
  passportBack?: InputMaybe<PassportCreateNestedOneWithoutBackImageInput>;
  passportCardSelfie?: InputMaybe<PassportCreateNestedOneWithoutSelfieImageInput>;
  passportExtractPhoto?: InputMaybe<PassportCreateNestedOneWithoutExtractedPhotoInput>;
  passportFront?: InputMaybe<PassportCreateNestedOneWithoutFrontImageInput>;
  purpose?: InputMaybe<FilePurposeTypeEnum>;
  region?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<ResultCreateNestedOneWithoutAttachmentsInput>;
  selfieUser?: InputMaybe<UserCreateNestedOneWithoutSelfieInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutBackImageInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutFrontImageInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutSelfieImageInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type FileListRelationFilter = {
  every?: InputMaybe<FileWhereInput>;
  none?: InputMaybe<FileWhereInput>;
  some?: InputMaybe<FileWhereInput>;
};

export type FileNullableScalarRelationFilter = {
  is?: InputMaybe<FileWhereInput>;
  isNot?: InputMaybe<FileWhereInput>;
};

export type FileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FileOrderByWithRelationInput = {
  backIdUser?: InputMaybe<UserOrderByWithRelationInput>;
  backIdUserId?: InputMaybe<SortOrderInput>;
  beamInput?: InputMaybe<BeamInputOrderByWithRelationInput>;
  beamInputId?: InputMaybe<SortOrderInput>;
  beamOutput?: InputMaybe<BeamOutputOrderByWithRelationInput>;
  beamOutputId?: InputMaybe<SortOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceOrderByWithRelationInput>;
  biometricConsentAcceptanceId?: InputMaybe<SortOrderInput>;
  bucket?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceOrderByWithRelationInput>;
  disclosureAcceptanceId?: InputMaybe<SortOrderInput>;
  disputeSupportingDocument?: InputMaybe<DisputeOrderByWithRelationInput>;
  disputeSupportingDocumentId?: InputMaybe<SortOrderInput>;
  disputes?: InputMaybe<DisputeOrderByRelationAggregateInput>;
  frontIdUser?: InputMaybe<UserOrderByWithRelationInput>;
  frontIdUserId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentBackId?: InputMaybe<SortOrderInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentExtractId?: InputMaybe<SortOrderInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentFrontId?: InputMaybe<SortOrderInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentSelfieId?: InputMaybe<SortOrderInput>;
  isActive?: InputMaybe<SortOrderInput>;
  key?: InputMaybe<SortOrderInput>;
  monitoringReport?: InputMaybe<MonitoringReportOrderByWithRelationInput>;
  monitoringReportId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationLogo?: InputMaybe<OrganizationOrderByWithRelationInput>;
  passportBack?: InputMaybe<PassportOrderByWithRelationInput>;
  passportBackId?: InputMaybe<SortOrderInput>;
  passportCardSelfie?: InputMaybe<PassportOrderByWithRelationInput>;
  passportCardSelfieId?: InputMaybe<SortOrderInput>;
  passportExtractPhoto?: InputMaybe<PassportOrderByWithRelationInput>;
  passportExtractPhotoId?: InputMaybe<SortOrderInput>;
  passportFront?: InputMaybe<PassportOrderByWithRelationInput>;
  passportFrontId?: InputMaybe<SortOrderInput>;
  purpose?: InputMaybe<SortOrderInput>;
  region?: InputMaybe<SortOrderInput>;
  result?: InputMaybe<ResultOrderByWithRelationInput>;
  resultId?: InputMaybe<SortOrderInput>;
  selfieUser?: InputMaybe<UserOrderByWithRelationInput>;
  selfieUserId?: InputMaybe<SortOrderInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardBackId?: InputMaybe<SortOrderInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardExtractId?: InputMaybe<SortOrderInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardFrontId?: InputMaybe<SortOrderInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardSelfieId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum FilePurposeTypeEnum {
  Attachment = 'ATTACHMENT',
  BiometricConsent = 'BIOMETRIC_CONSENT',
  CriminalReport = 'CRIMINAL_REPORT',
  MonitoringReport = 'MONITORING_REPORT',
  Signature = 'SIGNATURE',
  StateIdCard = 'STATE_ID_CARD',
  TazworksBackgroundReport = 'TAZWORKS_BACKGROUND_REPORT'
}

export enum FileScalarFieldEnum {
  BackIdUserId = 'backIdUserId',
  BeamInputId = 'beamInputId',
  BeamOutputId = 'beamOutputId',
  BiometricConsentAcceptanceId = 'biometricConsentAcceptanceId',
  Bucket = 'bucket',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  DisclosureAcceptanceId = 'disclosureAcceptanceId',
  DisputeSupportingDocumentId = 'disputeSupportingDocumentId',
  FrontIdUserId = 'frontIdUserId',
  Id = 'id',
  IdentificationDocumentBackId = 'identificationDocumentBackId',
  IdentificationDocumentExtractId = 'identificationDocumentExtractId',
  IdentificationDocumentFrontId = 'identificationDocumentFrontId',
  IdentificationDocumentSelfieId = 'identificationDocumentSelfieId',
  IsActive = 'isActive',
  Key = 'key',
  MonitoringReportId = 'monitoringReportId',
  Name = 'name',
  OrderId = 'orderId',
  PassportBackId = 'passportBackId',
  PassportCardSelfieId = 'passportCardSelfieId',
  PassportExtractPhotoId = 'passportExtractPhotoId',
  PassportFrontId = 'passportFrontId',
  Purpose = 'purpose',
  Region = 'region',
  ResultId = 'resultId',
  SelfieUserId = 'selfieUserId',
  StateIdentificationCardBackId = 'stateIdentificationCardBackId',
  StateIdentificationCardExtractId = 'stateIdentificationCardExtractId',
  StateIdentificationCardFrontId = 'stateIdentificationCardFrontId',
  StateIdentificationCardSelfieId = 'stateIdentificationCardSelfieId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type FileScalarWhereInput = {
  AND?: InputMaybe<Array<FileScalarWhereInput>>;
  NOT?: InputMaybe<Array<FileScalarWhereInput>>;
  OR?: InputMaybe<Array<FileScalarWhereInput>>;
  backIdUserId?: InputMaybe<StringNullableFilter>;
  beamInputId?: InputMaybe<StringNullableFilter>;
  beamOutputId?: InputMaybe<StringNullableFilter>;
  biometricConsentAcceptanceId?: InputMaybe<StringNullableFilter>;
  bucket?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclosureAcceptanceId?: InputMaybe<StringNullableFilter>;
  disputeSupportingDocumentId?: InputMaybe<StringNullableFilter>;
  frontIdUserId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocumentBackId?: InputMaybe<StringNullableFilter>;
  identificationDocumentExtractId?: InputMaybe<StringNullableFilter>;
  identificationDocumentFrontId?: InputMaybe<StringNullableFilter>;
  identificationDocumentSelfieId?: InputMaybe<StringNullableFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  key?: InputMaybe<StringNullableFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  passportBackId?: InputMaybe<StringNullableFilter>;
  passportCardSelfieId?: InputMaybe<StringNullableFilter>;
  passportExtractPhotoId?: InputMaybe<StringNullableFilter>;
  passportFrontId?: InputMaybe<StringNullableFilter>;
  purpose?: InputMaybe<EnumFilePurposeTypeEnumNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  resultId?: InputMaybe<StringNullableFilter>;
  selfieUserId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardBackId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardExtractId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardFrontId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardSelfieId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type FileUpdateInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateManyMutationInput = {
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FileUpdateManyWithWhereWithoutBeamInputInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutBeamOutputInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutDisputeSupportingDocumentInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutMonitoringReportInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutOrderInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutResultInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutUserInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithoutBeamInputNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutBeamInputInput>>;
  create?: InputMaybe<Array<FileCreateWithoutBeamInputInput>>;
  createMany?: InputMaybe<FileCreateManyBeamInputInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutBeamInputInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutBeamInputInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutBeamInputInput>>;
};

export type FileUpdateManyWithoutBeamOutputNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutBeamOutputInput>>;
  create?: InputMaybe<Array<FileCreateWithoutBeamOutputInput>>;
  createMany?: InputMaybe<FileCreateManyBeamOutputInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutBeamOutputInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutBeamOutputInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutBeamOutputInput>>;
};

export type FileUpdateManyWithoutDisputeSupportingDocumentNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutDisputeSupportingDocumentInput>>;
  create?: InputMaybe<Array<FileCreateWithoutDisputeSupportingDocumentInput>>;
  createMany?: InputMaybe<FileCreateManyDisputeSupportingDocumentInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutDisputeSupportingDocumentInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutDisputeSupportingDocumentInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutDisputeSupportingDocumentInput>>;
};

export type FileUpdateManyWithoutMonitoringReportNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<FileCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<FileCreateManyMonitoringReportInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutMonitoringReportInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutMonitoringReportInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutMonitoringReportInput>>;
};

export type FileUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderInput>>;
  createMany?: InputMaybe<FileCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type FileUpdateManyWithoutResultNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutResultInput>>;
  create?: InputMaybe<Array<FileCreateWithoutResultInput>>;
  createMany?: InputMaybe<FileCreateManyResultInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutResultInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutResultInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutResultInput>>;
};

export type FileUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserInput>>;
  createMany?: InputMaybe<FileCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutUserInput>>;
};

export type FileUpdateOneWithoutBackIdUserNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutBackIdUserInput>;
  create?: InputMaybe<FileCreateWithoutBackIdUserInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutBackIdUserInput>;
  upsert?: InputMaybe<FileUpsertWithoutBackIdUserInput>;
};

export type FileUpdateOneWithoutBiometricConsentAcceptanceNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutBiometricConsentAcceptanceInput>;
  create?: InputMaybe<FileCreateWithoutBiometricConsentAcceptanceInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutBiometricConsentAcceptanceInput>;
  upsert?: InputMaybe<FileUpsertWithoutBiometricConsentAcceptanceInput>;
};

export type FileUpdateOneWithoutDisclosureAcceptanceNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutDisclosureAcceptanceInput>;
  create?: InputMaybe<FileCreateWithoutDisclosureAcceptanceInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutDisclosureAcceptanceInput>;
  upsert?: InputMaybe<FileUpsertWithoutDisclosureAcceptanceInput>;
};

export type FileUpdateOneWithoutDisputesNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<FileCreateWithoutDisputesInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutDisputesInput>;
  upsert?: InputMaybe<FileUpsertWithoutDisputesInput>;
};

export type FileUpdateOneWithoutFrontIdUserNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutFrontIdUserInput>;
  create?: InputMaybe<FileCreateWithoutFrontIdUserInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutFrontIdUserInput>;
  upsert?: InputMaybe<FileUpsertWithoutFrontIdUserInput>;
};

export type FileUpdateOneWithoutIdentificationDocumentBackNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentBackInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentBackInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutIdentificationDocumentBackInput>;
  upsert?: InputMaybe<FileUpsertWithoutIdentificationDocumentBackInput>;
};

export type FileUpdateOneWithoutIdentificationDocumentExtractNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentExtractInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentExtractInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutIdentificationDocumentExtractInput>;
  upsert?: InputMaybe<FileUpsertWithoutIdentificationDocumentExtractInput>;
};

export type FileUpdateOneWithoutIdentificationDocumentFrontNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentFrontInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentFrontInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutIdentificationDocumentFrontInput>;
  upsert?: InputMaybe<FileUpsertWithoutIdentificationDocumentFrontInput>;
};

export type FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutIdentificationDocumentSelfieInput>;
  create?: InputMaybe<FileCreateWithoutIdentificationDocumentSelfieInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutIdentificationDocumentSelfieInput>;
  upsert?: InputMaybe<FileUpsertWithoutIdentificationDocumentSelfieInput>;
};

export type FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutOrganizationHorizontalLogoInput>;
  create?: InputMaybe<FileCreateWithoutOrganizationHorizontalLogoInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutOrganizationHorizontalLogoInput>;
  upsert?: InputMaybe<FileUpsertWithoutOrganizationHorizontalLogoInput>;
};

export type FileUpdateOneWithoutOrganizationLogoNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutOrganizationLogoInput>;
  create?: InputMaybe<FileCreateWithoutOrganizationLogoInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutOrganizationLogoInput>;
  upsert?: InputMaybe<FileUpsertWithoutOrganizationLogoInput>;
};

export type FileUpdateOneWithoutPassportBackNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportBackInput>;
  create?: InputMaybe<FileCreateWithoutPassportBackInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutPassportBackInput>;
  upsert?: InputMaybe<FileUpsertWithoutPassportBackInput>;
};

export type FileUpdateOneWithoutPassportCardSelfieNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportCardSelfieInput>;
  create?: InputMaybe<FileCreateWithoutPassportCardSelfieInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutPassportCardSelfieInput>;
  upsert?: InputMaybe<FileUpsertWithoutPassportCardSelfieInput>;
};

export type FileUpdateOneWithoutPassportExtractPhotoNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportExtractPhotoInput>;
  create?: InputMaybe<FileCreateWithoutPassportExtractPhotoInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutPassportExtractPhotoInput>;
  upsert?: InputMaybe<FileUpsertWithoutPassportExtractPhotoInput>;
};

export type FileUpdateOneWithoutPassportFrontNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPassportFrontInput>;
  create?: InputMaybe<FileCreateWithoutPassportFrontInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutPassportFrontInput>;
  upsert?: InputMaybe<FileUpsertWithoutPassportFrontInput>;
};

export type FileUpdateOneWithoutSelfieUserNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutSelfieUserInput>;
  create?: InputMaybe<FileCreateWithoutSelfieUserInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutSelfieUserInput>;
  upsert?: InputMaybe<FileUpsertWithoutSelfieUserInput>;
};

export type FileUpdateOneWithoutStateIdentificationCardBackNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardBackInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardBackInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutStateIdentificationCardBackInput>;
  upsert?: InputMaybe<FileUpsertWithoutStateIdentificationCardBackInput>;
};

export type FileUpdateOneWithoutStateIdentificationCardExtractNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardExtractInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardExtractInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutStateIdentificationCardExtractInput>;
  upsert?: InputMaybe<FileUpsertWithoutStateIdentificationCardExtractInput>;
};

export type FileUpdateOneWithoutStateIdentificationCardFrontNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardFrontInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardFrontInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutStateIdentificationCardFrontInput>;
  upsert?: InputMaybe<FileUpsertWithoutStateIdentificationCardFrontInput>;
};

export type FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutStateIdentificationCardSelfieInput>;
  create?: InputMaybe<FileCreateWithoutStateIdentificationCardSelfieInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutStateIdentificationCardSelfieInput>;
  upsert?: InputMaybe<FileUpsertWithoutStateIdentificationCardSelfieInput>;
};

export type FileUpdateToOneWithWhereWithoutBackIdUserInput = {
  data: FileUpdateWithoutBackIdUserInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutBiometricConsentAcceptanceInput = {
  data: FileUpdateWithoutBiometricConsentAcceptanceInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutDisclosureAcceptanceInput = {
  data: FileUpdateWithoutDisclosureAcceptanceInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutDisputesInput = {
  data: FileUpdateWithoutDisputesInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutFrontIdUserInput = {
  data: FileUpdateWithoutFrontIdUserInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutIdentificationDocumentBackInput = {
  data: FileUpdateWithoutIdentificationDocumentBackInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutIdentificationDocumentExtractInput = {
  data: FileUpdateWithoutIdentificationDocumentExtractInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutIdentificationDocumentFrontInput = {
  data: FileUpdateWithoutIdentificationDocumentFrontInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutIdentificationDocumentSelfieInput = {
  data: FileUpdateWithoutIdentificationDocumentSelfieInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutOrganizationHorizontalLogoInput = {
  data: FileUpdateWithoutOrganizationHorizontalLogoInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutOrganizationLogoInput = {
  data: FileUpdateWithoutOrganizationLogoInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutPassportBackInput = {
  data: FileUpdateWithoutPassportBackInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutPassportCardSelfieInput = {
  data: FileUpdateWithoutPassportCardSelfieInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutPassportExtractPhotoInput = {
  data: FileUpdateWithoutPassportExtractPhotoInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutPassportFrontInput = {
  data: FileUpdateWithoutPassportFrontInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutSelfieUserInput = {
  data: FileUpdateWithoutSelfieUserInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutStateIdentificationCardBackInput = {
  data: FileUpdateWithoutStateIdentificationCardBackInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutStateIdentificationCardExtractInput = {
  data: FileUpdateWithoutStateIdentificationCardExtractInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutStateIdentificationCardFrontInput = {
  data: FileUpdateWithoutStateIdentificationCardFrontInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutStateIdentificationCardSelfieInput = {
  data: FileUpdateWithoutStateIdentificationCardSelfieInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateWithWhereUniqueWithoutBeamInputInput = {
  data: FileUpdateWithoutBeamInputInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutBeamOutputInput = {
  data: FileUpdateWithoutBeamOutputInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutDisputeSupportingDocumentInput = {
  data: FileUpdateWithoutDisputeSupportingDocumentInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutMonitoringReportInput = {
  data: FileUpdateWithoutMonitoringReportInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutOrderInput = {
  data: FileUpdateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutResultInput = {
  data: FileUpdateWithoutResultInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutUserInput = {
  data: FileUpdateWithoutUserInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithoutBackIdUserInput = {
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutBeamInputInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutBeamOutputInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutBiometricConsentAcceptanceInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutDisclosureAcceptanceInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutDisputeSupportingDocumentInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutDisputesInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutFrontIdUserInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutIdentificationDocumentBackInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutIdentificationDocumentExtractInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutIdentificationDocumentFrontInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutIdentificationDocumentSelfieInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutMonitoringReportInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutOrderInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutOrganizationHorizontalLogoInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutOrganizationLogoInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutPassportBackInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutPassportCardSelfieInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutPassportExtractPhotoInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutPassportFrontInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutResultInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutSelfieUserInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutStateIdentificationCardBackInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutStateIdentificationCardExtractInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutStateIdentificationCardFrontInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutStateIdentificationCardSelfieInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutUserInput = {
  backIdUser?: InputMaybe<UserUpdateOneWithoutBackIdNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateOneWithoutFilesNestedInput>;
  beamOutput?: InputMaybe<BeamOutputUpdateOneWithoutFilesNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutPdfNestedInput>;
  bucket?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceUpdateOneWithoutPdfNestedInput>;
  disputeSupportingDocument?: InputMaybe<DisputeUpdateOneWithoutSupportingDocumentsNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutReportNestedInput>;
  frontIdUser?: InputMaybe<UserUpdateOneWithoutFrontIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentUpdateOneWithoutBackImageNestedInput>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentUpdateOneWithoutFrontImageNestedInput>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  key?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutPdfsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  organizationHorizontalLogo?: InputMaybe<OrganizationUpdateOneWithoutHorizontalLogoNestedInput>;
  organizationLogo?: InputMaybe<OrganizationUpdateOneWithoutLogoNestedInput>;
  passportBack?: InputMaybe<PassportUpdateOneWithoutBackImageNestedInput>;
  passportCardSelfie?: InputMaybe<PassportUpdateOneWithoutSelfieImageNestedInput>;
  passportExtractPhoto?: InputMaybe<PassportUpdateOneWithoutExtractedPhotoNestedInput>;
  passportFront?: InputMaybe<PassportUpdateOneWithoutFrontImageNestedInput>;
  purpose?: InputMaybe<NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  result?: InputMaybe<ResultUpdateOneWithoutAttachmentsNestedInput>;
  selfieUser?: InputMaybe<UserUpdateOneWithoutSelfieNestedInput>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardUpdateOneWithoutBackImageNestedInput>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardUpdateOneWithoutFrontImageNestedInput>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FileUpsertWithWhereUniqueWithoutBeamInputInput = {
  create: FileCreateWithoutBeamInputInput;
  update: FileUpdateWithoutBeamInputInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutBeamOutputInput = {
  create: FileCreateWithoutBeamOutputInput;
  update: FileUpdateWithoutBeamOutputInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutDisputeSupportingDocumentInput = {
  create: FileCreateWithoutDisputeSupportingDocumentInput;
  update: FileUpdateWithoutDisputeSupportingDocumentInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutMonitoringReportInput = {
  create: FileCreateWithoutMonitoringReportInput;
  update: FileUpdateWithoutMonitoringReportInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutOrderInput = {
  create: FileCreateWithoutOrderInput;
  update: FileUpdateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutResultInput = {
  create: FileCreateWithoutResultInput;
  update: FileUpdateWithoutResultInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutUserInput = {
  create: FileCreateWithoutUserInput;
  update: FileUpdateWithoutUserInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithoutBackIdUserInput = {
  create: FileCreateWithoutBackIdUserInput;
  update: FileUpdateWithoutBackIdUserInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutBiometricConsentAcceptanceInput = {
  create: FileCreateWithoutBiometricConsentAcceptanceInput;
  update: FileUpdateWithoutBiometricConsentAcceptanceInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutDisclosureAcceptanceInput = {
  create: FileCreateWithoutDisclosureAcceptanceInput;
  update: FileUpdateWithoutDisclosureAcceptanceInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutDisputesInput = {
  create: FileCreateWithoutDisputesInput;
  update: FileUpdateWithoutDisputesInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutFrontIdUserInput = {
  create: FileCreateWithoutFrontIdUserInput;
  update: FileUpdateWithoutFrontIdUserInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutIdentificationDocumentBackInput = {
  create: FileCreateWithoutIdentificationDocumentBackInput;
  update: FileUpdateWithoutIdentificationDocumentBackInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutIdentificationDocumentExtractInput = {
  create: FileCreateWithoutIdentificationDocumentExtractInput;
  update: FileUpdateWithoutIdentificationDocumentExtractInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutIdentificationDocumentFrontInput = {
  create: FileCreateWithoutIdentificationDocumentFrontInput;
  update: FileUpdateWithoutIdentificationDocumentFrontInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutIdentificationDocumentSelfieInput = {
  create: FileCreateWithoutIdentificationDocumentSelfieInput;
  update: FileUpdateWithoutIdentificationDocumentSelfieInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutOrganizationHorizontalLogoInput = {
  create: FileCreateWithoutOrganizationHorizontalLogoInput;
  update: FileUpdateWithoutOrganizationHorizontalLogoInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutOrganizationLogoInput = {
  create: FileCreateWithoutOrganizationLogoInput;
  update: FileUpdateWithoutOrganizationLogoInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutPassportBackInput = {
  create: FileCreateWithoutPassportBackInput;
  update: FileUpdateWithoutPassportBackInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutPassportCardSelfieInput = {
  create: FileCreateWithoutPassportCardSelfieInput;
  update: FileUpdateWithoutPassportCardSelfieInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutPassportExtractPhotoInput = {
  create: FileCreateWithoutPassportExtractPhotoInput;
  update: FileUpdateWithoutPassportExtractPhotoInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutPassportFrontInput = {
  create: FileCreateWithoutPassportFrontInput;
  update: FileUpdateWithoutPassportFrontInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutSelfieUserInput = {
  create: FileCreateWithoutSelfieUserInput;
  update: FileUpdateWithoutSelfieUserInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutStateIdentificationCardBackInput = {
  create: FileCreateWithoutStateIdentificationCardBackInput;
  update: FileUpdateWithoutStateIdentificationCardBackInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutStateIdentificationCardExtractInput = {
  create: FileCreateWithoutStateIdentificationCardExtractInput;
  update: FileUpdateWithoutStateIdentificationCardExtractInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutStateIdentificationCardFrontInput = {
  create: FileCreateWithoutStateIdentificationCardFrontInput;
  update: FileUpdateWithoutStateIdentificationCardFrontInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutStateIdentificationCardSelfieInput = {
  create: FileCreateWithoutStateIdentificationCardSelfieInput;
  update: FileUpdateWithoutStateIdentificationCardSelfieInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileWhereInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  backIdUser?: InputMaybe<UserNullableScalarRelationFilter>;
  backIdUserId?: InputMaybe<StringNullableFilter>;
  beamInput?: InputMaybe<BeamInputNullableScalarRelationFilter>;
  beamInputId?: InputMaybe<StringNullableFilter>;
  beamOutput?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  beamOutputId?: InputMaybe<StringNullableFilter>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceNullableScalarRelationFilter>;
  biometricConsentAcceptanceId?: InputMaybe<StringNullableFilter>;
  bucket?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceNullableScalarRelationFilter>;
  disclosureAcceptanceId?: InputMaybe<StringNullableFilter>;
  disputeSupportingDocument?: InputMaybe<DisputeNullableScalarRelationFilter>;
  disputeSupportingDocumentId?: InputMaybe<StringNullableFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  frontIdUser?: InputMaybe<UserNullableScalarRelationFilter>;
  frontIdUserId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentBackId?: InputMaybe<StringNullableFilter>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentExtractId?: InputMaybe<StringNullableFilter>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentFrontId?: InputMaybe<StringNullableFilter>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentSelfieId?: InputMaybe<StringNullableFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  key?: InputMaybe<StringNullableFilter>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationHorizontalLogo?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationLogo?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  passportBack?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportBackId?: InputMaybe<StringNullableFilter>;
  passportCardSelfie?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportCardSelfieId?: InputMaybe<StringNullableFilter>;
  passportExtractPhoto?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportExtractPhotoId?: InputMaybe<StringNullableFilter>;
  passportFront?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportFrontId?: InputMaybe<StringNullableFilter>;
  purpose?: InputMaybe<EnumFilePurposeTypeEnumNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  result?: InputMaybe<ResultNullableScalarRelationFilter>;
  resultId?: InputMaybe<StringNullableFilter>;
  selfieUser?: InputMaybe<UserNullableScalarRelationFilter>;
  selfieUserId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardBackId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardExtractId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardFrontId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardSelfieId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type FileWhereUniqueInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  backIdUser?: InputMaybe<UserNullableScalarRelationFilter>;
  backIdUserId?: InputMaybe<Scalars['String']['input']>;
  beamInput?: InputMaybe<BeamInputNullableScalarRelationFilter>;
  beamInputId?: InputMaybe<StringNullableFilter>;
  beamOutput?: InputMaybe<BeamOutputNullableScalarRelationFilter>;
  beamOutputId?: InputMaybe<StringNullableFilter>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceNullableScalarRelationFilter>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  bucket?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclosureAcceptance?: InputMaybe<DisclosureAcceptanceNullableScalarRelationFilter>;
  disclosureAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  disputeSupportingDocument?: InputMaybe<DisputeNullableScalarRelationFilter>;
  disputeSupportingDocumentId?: InputMaybe<StringNullableFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  frontIdUser?: InputMaybe<UserNullableScalarRelationFilter>;
  frontIdUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentBack?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentBackId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentExtract?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentExtractId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentFront?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentFrontId?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentSelfie?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentSelfieId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolNullableFilter>;
  key?: InputMaybe<StringNullableFilter>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationHorizontalLogo?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationLogo?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  passportBack?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportBackId?: InputMaybe<Scalars['String']['input']>;
  passportCardSelfie?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  passportExtractPhoto?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportExtractPhotoId?: InputMaybe<Scalars['String']['input']>;
  passportFront?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportFrontId?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<EnumFilePurposeTypeEnumNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  result?: InputMaybe<ResultNullableScalarRelationFilter>;
  resultId?: InputMaybe<StringNullableFilter>;
  selfieUser?: InputMaybe<UserNullableScalarRelationFilter>;
  selfieUserId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardBack?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardBackId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardExtract?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardExtractId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardFront?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardFrontId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardSelfie?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardSelfieId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GenerateApiKeyResponse = {
  __typename?: 'GenerateApiKeyResponse';
  _count?: Maybe<ApiKeyCount>;
  apiKey: Scalars['String']['output'];
  apiKeyVerifications: Array<ApiKeyVerification>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  expireOnOrder: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  prefix: Scalars['String']['output'];
  purpose: ApiKeyPurpose;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<VidVoucher>;
  voucherId?: Maybe<Scalars['String']['output']>;
};


export type GenerateApiKeyResponseApiKeyVerificationsArgs = {
  cursor?: InputMaybe<ApiKeyVerificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyVerificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyVerificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyVerificationWhereInput>;
};


export type GenerateApiKeyResponseUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type GenerateApiKeyResponseVoucherArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type GenerateMonitoringReportPdfResponse = {
  __typename?: 'GenerateMonitoringReportPdfResponse';
  message: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type GenerateShortUrlResponse = {
  __typename?: 'GenerateShortUrlResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type GenerateSignedDisclosurePdfResponse = {
  __typename?: 'GenerateSignedDisclosurePdfResponse';
  pdfId: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
};

export type GenerateVidReportPdfResponse = {
  __typename?: 'GenerateVIDReportPdfResponse';
  pdfId: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
};

export type GetVoucherStatusResponse = {
  __typename?: 'GetVoucherStatusResponse';
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  onSubmitReturnUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type HighlySensitiveIdentifier = {
  __typename?: 'HighlySensitiveIdentifier';
  _count?: Maybe<HighlySensitiveIdentifierCount>;
  applicantDataId?: Maybe<Scalars['String']['output']>;
  beamInputId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type: HighlySensitiveIdentifierType;
  userId?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type HighlySensitiveIdentifierCount = {
  __typename?: 'HighlySensitiveIdentifierCount';
  requestedSearches: Scalars['Int']['output'];
};


export type HighlySensitiveIdentifierCountRequestedSearchesArgs = {
  where?: InputMaybe<RequestedSearchWhereInput>;
};

export type HighlySensitiveIdentifierCreateInput = {
  BeamInput?: InputMaybe<BeamInputCreateNestedOneWithoutHsiInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutSsnInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSsnInput>;
  type: HighlySensitiveIdentifierType;
  user?: InputMaybe<UserCreateNestedOneWithoutSsnInput>;
  value: Scalars['String']['input'];
};

export type HighlySensitiveIdentifierCreateManyBeamInputInput = {
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: HighlySensitiveIdentifierType;
  userId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type HighlySensitiveIdentifierCreateManyBeamInputInputEnvelope = {
  data: Array<HighlySensitiveIdentifierCreateManyBeamInputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HighlySensitiveIdentifierCreateNestedManyWithoutBeamInputInput = {
  connect?: InputMaybe<Array<HighlySensitiveIdentifierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<HighlySensitiveIdentifierCreateOrConnectWithoutBeamInputInput>>;
  create?: InputMaybe<Array<HighlySensitiveIdentifierCreateWithoutBeamInputInput>>;
  createMany?: InputMaybe<HighlySensitiveIdentifierCreateManyBeamInputInputEnvelope>;
};

export type HighlySensitiveIdentifierCreateNestedOneWithoutApplicantDataInput = {
  connect?: InputMaybe<HighlySensitiveIdentifierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HighlySensitiveIdentifierCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<HighlySensitiveIdentifierCreateWithoutApplicantDataInput>;
};

export type HighlySensitiveIdentifierCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<HighlySensitiveIdentifierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HighlySensitiveIdentifierCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<HighlySensitiveIdentifierCreateWithoutUserInput>;
};

export type HighlySensitiveIdentifierCreateOrConnectWithoutApplicantDataInput = {
  create: HighlySensitiveIdentifierCreateWithoutApplicantDataInput;
  where: HighlySensitiveIdentifierWhereUniqueInput;
};

export type HighlySensitiveIdentifierCreateOrConnectWithoutBeamInputInput = {
  create: HighlySensitiveIdentifierCreateWithoutBeamInputInput;
  where: HighlySensitiveIdentifierWhereUniqueInput;
};

export type HighlySensitiveIdentifierCreateOrConnectWithoutUserInput = {
  create: HighlySensitiveIdentifierCreateWithoutUserInput;
  where: HighlySensitiveIdentifierWhereUniqueInput;
};

export type HighlySensitiveIdentifierCreateWithoutApplicantDataInput = {
  BeamInput?: InputMaybe<BeamInputCreateNestedOneWithoutHsiInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSsnInput>;
  type: HighlySensitiveIdentifierType;
  user?: InputMaybe<UserCreateNestedOneWithoutSsnInput>;
  value: Scalars['String']['input'];
};

export type HighlySensitiveIdentifierCreateWithoutBeamInputInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutSsnInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSsnInput>;
  type: HighlySensitiveIdentifierType;
  user?: InputMaybe<UserCreateNestedOneWithoutSsnInput>;
  value: Scalars['String']['input'];
};

export type HighlySensitiveIdentifierCreateWithoutUserInput = {
  BeamInput?: InputMaybe<BeamInputCreateNestedOneWithoutHsiInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutSsnInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSsnInput>;
  type: HighlySensitiveIdentifierType;
  value: Scalars['String']['input'];
};

export type HighlySensitiveIdentifierListRelationFilter = {
  every?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  none?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  some?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};

export type HighlySensitiveIdentifierNullableScalarRelationFilter = {
  is?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  isNot?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};

export type HighlySensitiveIdentifierOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type HighlySensitiveIdentifierOrderByWithRelationInput = {
  BeamInput?: InputMaybe<BeamInputOrderByWithRelationInput>;
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantDataId?: InputMaybe<SortOrderInput>;
  beamInputId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  requestedSearches?: InputMaybe<RequestedSearchOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  value?: InputMaybe<SortOrder>;
};

export enum HighlySensitiveIdentifierScalarFieldEnum {
  ApplicantDataId = 'applicantDataId',
  BeamInputId = 'beamInputId',
  Id = 'id',
  Type = 'type',
  UserId = 'userId',
  Value = 'value'
}

export type HighlySensitiveIdentifierScalarWhereInput = {
  AND?: InputMaybe<Array<HighlySensitiveIdentifierScalarWhereInput>>;
  NOT?: InputMaybe<Array<HighlySensitiveIdentifierScalarWhereInput>>;
  OR?: InputMaybe<Array<HighlySensitiveIdentifierScalarWhereInput>>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  beamInputId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<StringFilter>;
};

export enum HighlySensitiveIdentifierType {
  Passport = 'PASSPORT',
  Ssn = 'SSN'
}

export type HighlySensitiveIdentifierUpdateInput = {
  BeamInput?: InputMaybe<BeamInputUpdateOneWithoutHsiNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutSsnNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSsnNestedInput>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutSsnNestedInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HighlySensitiveIdentifierUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HighlySensitiveIdentifierUpdateManyWithWhereWithoutBeamInputInput = {
  data: HighlySensitiveIdentifierUpdateManyMutationInput;
  where: HighlySensitiveIdentifierScalarWhereInput;
};

export type HighlySensitiveIdentifierUpdateManyWithoutBeamInputNestedInput = {
  connect?: InputMaybe<Array<HighlySensitiveIdentifierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<HighlySensitiveIdentifierCreateOrConnectWithoutBeamInputInput>>;
  create?: InputMaybe<Array<HighlySensitiveIdentifierCreateWithoutBeamInputInput>>;
  createMany?: InputMaybe<HighlySensitiveIdentifierCreateManyBeamInputInputEnvelope>;
  delete?: InputMaybe<Array<HighlySensitiveIdentifierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<HighlySensitiveIdentifierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<HighlySensitiveIdentifierWhereUniqueInput>>;
  set?: InputMaybe<Array<HighlySensitiveIdentifierWhereUniqueInput>>;
  update?: InputMaybe<Array<HighlySensitiveIdentifierUpdateWithWhereUniqueWithoutBeamInputInput>>;
  updateMany?: InputMaybe<Array<HighlySensitiveIdentifierUpdateManyWithWhereWithoutBeamInputInput>>;
  upsert?: InputMaybe<Array<HighlySensitiveIdentifierUpsertWithWhereUniqueWithoutBeamInputInput>>;
};

export type HighlySensitiveIdentifierUpdateOneWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<HighlySensitiveIdentifierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HighlySensitiveIdentifierCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<HighlySensitiveIdentifierCreateWithoutApplicantDataInput>;
  delete?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  disconnect?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  update?: InputMaybe<HighlySensitiveIdentifierUpdateToOneWithWhereWithoutApplicantDataInput>;
  upsert?: InputMaybe<HighlySensitiveIdentifierUpsertWithoutApplicantDataInput>;
};

export type HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<HighlySensitiveIdentifierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HighlySensitiveIdentifierCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<HighlySensitiveIdentifierCreateWithoutUserInput>;
  delete?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  disconnect?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
  update?: InputMaybe<HighlySensitiveIdentifierUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<HighlySensitiveIdentifierUpsertWithoutUserInput>;
};

export type HighlySensitiveIdentifierUpdateToOneWithWhereWithoutApplicantDataInput = {
  data: HighlySensitiveIdentifierUpdateWithoutApplicantDataInput;
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};

export type HighlySensitiveIdentifierUpdateToOneWithWhereWithoutUserInput = {
  data: HighlySensitiveIdentifierUpdateWithoutUserInput;
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};

export type HighlySensitiveIdentifierUpdateWithWhereUniqueWithoutBeamInputInput = {
  data: HighlySensitiveIdentifierUpdateWithoutBeamInputInput;
  where: HighlySensitiveIdentifierWhereUniqueInput;
};

export type HighlySensitiveIdentifierUpdateWithoutApplicantDataInput = {
  BeamInput?: InputMaybe<BeamInputUpdateOneWithoutHsiNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSsnNestedInput>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutSsnNestedInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HighlySensitiveIdentifierUpdateWithoutBeamInputInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutSsnNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSsnNestedInput>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutSsnNestedInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HighlySensitiveIdentifierUpdateWithoutUserInput = {
  BeamInput?: InputMaybe<BeamInputUpdateOneWithoutHsiNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutSsnNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSsnNestedInput>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HighlySensitiveIdentifierUpsertWithWhereUniqueWithoutBeamInputInput = {
  create: HighlySensitiveIdentifierCreateWithoutBeamInputInput;
  update: HighlySensitiveIdentifierUpdateWithoutBeamInputInput;
  where: HighlySensitiveIdentifierWhereUniqueInput;
};

export type HighlySensitiveIdentifierUpsertWithoutApplicantDataInput = {
  create: HighlySensitiveIdentifierCreateWithoutApplicantDataInput;
  update: HighlySensitiveIdentifierUpdateWithoutApplicantDataInput;
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};

export type HighlySensitiveIdentifierUpsertWithoutUserInput = {
  create: HighlySensitiveIdentifierCreateWithoutUserInput;
  update: HighlySensitiveIdentifierUpdateWithoutUserInput;
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};

export type HighlySensitiveIdentifierWhereInput = {
  AND?: InputMaybe<Array<HighlySensitiveIdentifierWhereInput>>;
  BeamInput?: InputMaybe<BeamInputNullableScalarRelationFilter>;
  NOT?: InputMaybe<Array<HighlySensitiveIdentifierWhereInput>>;
  OR?: InputMaybe<Array<HighlySensitiveIdentifierWhereInput>>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  beamInputId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<StringFilter>;
};

export type HighlySensitiveIdentifierWhereUniqueInput = {
  AND?: InputMaybe<Array<HighlySensitiveIdentifierWhereInput>>;
  BeamInput?: InputMaybe<BeamInputNullableScalarRelationFilter>;
  NOT?: InputMaybe<Array<HighlySensitiveIdentifierWhereInput>>;
  OR?: InputMaybe<Array<HighlySensitiveIdentifierWhereInput>>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  beamInputId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  type?: InputMaybe<EnumHighlySensitiveIdentifierTypeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<StringFilter>;
};

export enum IdCaptureMethod {
  Auto = 'auto',
  FileUpload = 'fileUpload',
  Manual = 'manual',
  NativeCamera = 'nativeCamera',
  RemoteCaptureAuto = 'remoteCaptureAuto',
  RemoteCaptureManual = 'remoteCaptureManual'
}

export enum IdCardRotationEnum {
  Clockwise_90 = 'CLOCKWISE_90',
  CounterClockwise_90 = 'COUNTER_CLOCKWISE_90',
  UpsideDown = 'UPSIDE_DOWN',
  Zero = 'ZERO'
}

export enum IdVerificationModelEnum {
  Merlin = 'MERLIN',
  Remus = 'REMUS'
}

export type IdVerificationResult = {
  __typename?: 'IdVerificationResult';
  additionalPersonalIdNumberFormat?: Maybe<IdVerificationResultCheckEnum>;
  addressMatch?: Maybe<IdVerificationResultCheckEnum>;
  backCardRotation?: Maybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['output'];
  certainty: Scalars['String']['output'];
  classEfectiveDateFormat?: Maybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: Maybe<IdVerificationResultCheckEnum>;
  createdAt: Scalars['DateTimeISO']['output'];
  dataBarcodeAnomalyContent?: Maybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: Maybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: Maybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: Maybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: Maybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: Maybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: Maybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: Maybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: Maybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: Maybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: Maybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: Maybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: Maybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: Maybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: Maybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: Maybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: Maybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: Maybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: Maybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: Maybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: Maybe<IdVerificationResultCheckEnum>;
  documentExpired?: Maybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: Maybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: Maybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: Maybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: Maybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: Maybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: Maybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: Maybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: Maybe<IdVerificationResultCheckEnum>;
  documentVersion?: Maybe<IdVerificationResultCheckEnum>;
  employerMatch?: Maybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: Maybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: Maybe<Scalars['JSON']['output']>;
  frontCardRotation?: Maybe<IdCardRotationEnum>;
  fullNameMatch?: Maybe<IdVerificationResultCheckEnum>;
  id: Scalars['String']['output'];
  identificationDocumentId?: Maybe<Scalars['String']['output']>;
  imageQualityBlur?: Maybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: Maybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: Maybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: Maybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: Maybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: Maybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: Maybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: Maybe<Scalars['JSON']['output']>;
  messages?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<IdVerificationModelEnum>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  mrzCheckDigits?: Maybe<IdVerificationResultCheckEnum>;
  mrzParsed?: Maybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: Maybe<IdVerificationResultCheckEnum>;
  overall?: Maybe<IdVerificationResultCheckEnum>;
  passportId?: Maybe<Scalars['String']['output']>;
  personalIdNumberFormat?: Maybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: Maybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: Maybe<IdVerificationResultCheckEnum>;
  professionMatch?: Maybe<IdVerificationResultCheckEnum>;
  raceMatch?: Maybe<IdVerificationResultCheckEnum>;
  religionFormat?: Maybe<IdVerificationResultCheckEnum>;
  religionMatch?: Maybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: Maybe<IdVerificationResultCheckEnum>;
  sexFormat?: Maybe<IdVerificationResultCheckEnum>;
  stateIdentificationCardId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  visualOverall?: Maybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: Maybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: Maybe<IdVerificationResultCheckEnum>;
};

export enum IdVerificationResultCheckEnum {
  Fail = 'FAIL',
  Pass = 'PASS'
}

export type IdVerificationResultCreateManyIdentificationDocumentInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  addressMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  backCardRotation?: InputMaybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['input'];
  certainty: Scalars['String']['input'];
  classEfectiveDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataBarcodeAnomalyContent?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: InputMaybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentExpired?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentVersion?: InputMaybe<IdVerificationResultCheckEnum>;
  employerMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<IdCardRotationEnum>;
  fullNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageQualityBlur?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<IdVerificationModelEnum>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  mrzCheckDigits?: InputMaybe<IdVerificationResultCheckEnum>;
  mrzParsed?: InputMaybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  overall?: InputMaybe<IdVerificationResultCheckEnum>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  personalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  professionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  raceMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  religionFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  religionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  sexFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  visualOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: InputMaybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type IdVerificationResultCreateManyIdentificationDocumentInputEnvelope = {
  data: Array<IdVerificationResultCreateManyIdentificationDocumentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdVerificationResultCreateManyPassportInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  addressMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  backCardRotation?: InputMaybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['input'];
  certainty: Scalars['String']['input'];
  classEfectiveDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataBarcodeAnomalyContent?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: InputMaybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentExpired?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentVersion?: InputMaybe<IdVerificationResultCheckEnum>;
  employerMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<IdCardRotationEnum>;
  fullNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  imageQualityBlur?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<IdVerificationModelEnum>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  mrzCheckDigits?: InputMaybe<IdVerificationResultCheckEnum>;
  mrzParsed?: InputMaybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  overall?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  professionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  raceMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  religionFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  religionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  sexFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  visualOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: InputMaybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type IdVerificationResultCreateManyPassportInputEnvelope = {
  data: Array<IdVerificationResultCreateManyPassportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdVerificationResultCreateManyStateIdentificationCardInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  addressMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  backCardRotation?: InputMaybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['input'];
  certainty: Scalars['String']['input'];
  classEfectiveDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataBarcodeAnomalyContent?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: InputMaybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentExpired?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentVersion?: InputMaybe<IdVerificationResultCheckEnum>;
  employerMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<IdCardRotationEnum>;
  fullNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  imageQualityBlur?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<IdVerificationModelEnum>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  mrzCheckDigits?: InputMaybe<IdVerificationResultCheckEnum>;
  mrzParsed?: InputMaybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  overall?: InputMaybe<IdVerificationResultCheckEnum>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  personalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  professionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  raceMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  religionFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  religionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  sexFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  visualOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: InputMaybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type IdVerificationResultCreateManyStateIdentificationCardInputEnvelope = {
  data: Array<IdVerificationResultCreateManyStateIdentificationCardInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput = {
  connect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdVerificationResultCreateOrConnectWithoutIdentificationDocumentInput>>;
  create?: InputMaybe<Array<IdVerificationResultCreateWithoutIdentificationDocumentInput>>;
  createMany?: InputMaybe<IdVerificationResultCreateManyIdentificationDocumentInputEnvelope>;
};

export type IdVerificationResultCreateNestedManyWithoutPassportInput = {
  connect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdVerificationResultCreateOrConnectWithoutPassportInput>>;
  create?: InputMaybe<Array<IdVerificationResultCreateWithoutPassportInput>>;
  createMany?: InputMaybe<IdVerificationResultCreateManyPassportInputEnvelope>;
};

export type IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput = {
  connect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdVerificationResultCreateOrConnectWithoutStateIdentificationCardInput>>;
  create?: InputMaybe<Array<IdVerificationResultCreateWithoutStateIdentificationCardInput>>;
  createMany?: InputMaybe<IdVerificationResultCreateManyStateIdentificationCardInputEnvelope>;
};

export type IdVerificationResultCreateOrConnectWithoutIdentificationDocumentInput = {
  create: IdVerificationResultCreateWithoutIdentificationDocumentInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultCreateOrConnectWithoutPassportInput = {
  create: IdVerificationResultCreateWithoutPassportInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultCreateOrConnectWithoutStateIdentificationCardInput = {
  create: IdVerificationResultCreateWithoutStateIdentificationCardInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultCreateWithoutIdentificationDocumentInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  addressMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  backCardRotation?: InputMaybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['input'];
  certainty: Scalars['String']['input'];
  classEfectiveDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataBarcodeAnomalyContent?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: InputMaybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentExpired?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentVersion?: InputMaybe<IdVerificationResultCheckEnum>;
  employerMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<IdCardRotationEnum>;
  fullNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageQualityBlur?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<IdVerificationModelEnum>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  mrzCheckDigits?: InputMaybe<IdVerificationResultCheckEnum>;
  mrzParsed?: InputMaybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  overall?: InputMaybe<IdVerificationResultCheckEnum>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutIdVerificationResultInput>;
  personalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  professionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  raceMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  religionFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  religionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  sexFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutIdVerificationResultInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  visualOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: InputMaybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type IdVerificationResultCreateWithoutPassportInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  addressMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  backCardRotation?: InputMaybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['input'];
  certainty: Scalars['String']['input'];
  classEfectiveDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataBarcodeAnomalyContent?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: InputMaybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentExpired?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentVersion?: InputMaybe<IdVerificationResultCheckEnum>;
  employerMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<IdCardRotationEnum>;
  fullNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutIdVerificationResultInput>;
  imageQualityBlur?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<IdVerificationModelEnum>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  mrzCheckDigits?: InputMaybe<IdVerificationResultCheckEnum>;
  mrzParsed?: InputMaybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  overall?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  professionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  raceMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  religionFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  religionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  sexFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutIdVerificationResultInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  visualOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: InputMaybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type IdVerificationResultCreateWithoutStateIdentificationCardInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  addressMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  backCardRotation?: InputMaybe<IdCardRotationEnum>;
  blob: Scalars['JSON']['input'];
  certainty: Scalars['String']['input'];
  classEfectiveDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  classExpiryDateFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataBarcodeAnomalyContent?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataBarcodeAnomalyRead?: InputMaybe<IdVerificationResultCheckEnum>;
  dataFormatOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataIntegrity?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDateOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicDocumentNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicMRZOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataLogicPersonalIdNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataMatchOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousNumber?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  dataSuspiciousSampleString?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfExpiryMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueInPastCheck?: InputMaybe<IdVerificationResultCheckEnum>;
  dateOfIssueMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentExpired?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessHandPresence?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessPhotocopy?: InputMaybe<IdVerificationResultCheckEnum>;
  documentLivenessScreen?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  documentVersion?: InputMaybe<IdVerificationResultCheckEnum>;
  employerMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  firstNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<IdCardRotationEnum>;
  fullNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutIdVerificationResultInput>;
  imageQualityBlur?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityClarity?: InputMaybe<IdVerificationResultCheckEnum>;
  imageQualityOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  issueAuthorityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  lastNameMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  maritalStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<IdVerificationModelEnum>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  mrzCheckDigits?: InputMaybe<IdVerificationResultCheckEnum>;
  mrzParsed?: InputMaybe<IdVerificationResultCheckEnum>;
  nationalityFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  overall?: InputMaybe<IdVerificationResultCheckEnum>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutIdVerificationResultInput>;
  personalIdNumberFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  personalIdNumberMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  placeOfBirthMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  professionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  raceMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  religionFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  religionMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  residentialStatusMatch?: InputMaybe<IdVerificationResultCheckEnum>;
  sexFormat?: InputMaybe<IdVerificationResultCheckEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  visualOverall?: InputMaybe<IdVerificationResultCheckEnum>;
  visualPhotoForgery?: InputMaybe<IdVerificationResultCheckEnum>;
  visualSecurityFeatures?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type IdVerificationResultListRelationFilter = {
  every?: InputMaybe<IdVerificationResultWhereInput>;
  none?: InputMaybe<IdVerificationResultWhereInput>;
  some?: InputMaybe<IdVerificationResultWhereInput>;
};

export type IdVerificationResultOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IdVerificationResultOrderByWithRelationInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<SortOrderInput>;
  addressMatch?: InputMaybe<SortOrderInput>;
  backCardRotation?: InputMaybe<SortOrderInput>;
  blob?: InputMaybe<SortOrder>;
  certainty?: InputMaybe<SortOrder>;
  classEfectiveDateFormat?: InputMaybe<SortOrderInput>;
  classExpiryDateFormat?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataBarcodeAnomalyContent?: InputMaybe<SortOrderInput>;
  dataBarcodeAnomalyOverall?: InputMaybe<SortOrderInput>;
  dataBarcodeAnomalyRead?: InputMaybe<SortOrderInput>;
  dataFormatOverall?: InputMaybe<SortOrderInput>;
  dataIntegrity?: InputMaybe<SortOrderInput>;
  dataLogicDateOverall?: InputMaybe<SortOrderInput>;
  dataLogicDocumentNumber?: InputMaybe<SortOrderInput>;
  dataLogicMRZOverall?: InputMaybe<SortOrderInput>;
  dataLogicOverall?: InputMaybe<SortOrderInput>;
  dataLogicPersonalIdNumber?: InputMaybe<SortOrderInput>;
  dataMatchOverall?: InputMaybe<SortOrderInput>;
  dataOverall?: InputMaybe<SortOrderInput>;
  dataSuspiciousNumber?: InputMaybe<SortOrderInput>;
  dataSuspiciousOverall?: InputMaybe<SortOrderInput>;
  dataSuspiciousSampleString?: InputMaybe<SortOrderInput>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<SortOrderInput>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<SortOrderInput>;
  dateOfBirthFormat?: InputMaybe<SortOrderInput>;
  dateOfBirthInPastCheck?: InputMaybe<SortOrderInput>;
  dateOfBirthMatch?: InputMaybe<SortOrderInput>;
  dateOfExpiryFormat?: InputMaybe<SortOrderInput>;
  dateOfExpiryMatch?: InputMaybe<SortOrderInput>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<SortOrderInput>;
  dateOfIssueFormat?: InputMaybe<SortOrderInput>;
  dateOfIssueInPastCheck?: InputMaybe<SortOrderInput>;
  dateOfIssueMatch?: InputMaybe<SortOrderInput>;
  documentAdditionalNumberFormat?: InputMaybe<SortOrderInput>;
  documentAdditionalNumberMatch?: InputMaybe<SortOrderInput>;
  documentExpired?: InputMaybe<SortOrderInput>;
  documentLivenessHandPresence?: InputMaybe<SortOrderInput>;
  documentLivenessOverall?: InputMaybe<SortOrderInput>;
  documentLivenessPhotocopy?: InputMaybe<SortOrderInput>;
  documentLivenessScreen?: InputMaybe<SortOrderInput>;
  documentNumberFormat?: InputMaybe<SortOrderInput>;
  documentNumberMatch?: InputMaybe<SortOrderInput>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<SortOrderInput>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<SortOrderInput>;
  documentVersion?: InputMaybe<SortOrderInput>;
  employerMatch?: InputMaybe<SortOrderInput>;
  firstNameMatch?: InputMaybe<SortOrderInput>;
  formatCheckDetail?: InputMaybe<SortOrderInput>;
  frontCardRotation?: InputMaybe<SortOrderInput>;
  fullNameMatch?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identificationDocument?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentId?: InputMaybe<SortOrderInput>;
  imageQualityBlur?: InputMaybe<SortOrderInput>;
  imageQualityClarity?: InputMaybe<SortOrderInput>;
  imageQualityOverall?: InputMaybe<SortOrderInput>;
  issueAuthorityFormat?: InputMaybe<SortOrderInput>;
  lastNameMatch?: InputMaybe<SortOrderInput>;
  maritalStatusFormat?: InputMaybe<SortOrderInput>;
  maritalStatusMatch?: InputMaybe<SortOrderInput>;
  matchCheckDetail?: InputMaybe<SortOrderInput>;
  messages?: InputMaybe<SortOrderInput>;
  model?: InputMaybe<SortOrderInput>;
  modelVersion?: InputMaybe<SortOrderInput>;
  mrzCheckDigits?: InputMaybe<SortOrderInput>;
  mrzParsed?: InputMaybe<SortOrderInput>;
  nationalityFormat?: InputMaybe<SortOrderInput>;
  overall?: InputMaybe<SortOrderInput>;
  passport?: InputMaybe<PassportOrderByWithRelationInput>;
  passportId?: InputMaybe<SortOrderInput>;
  personalIdNumberFormat?: InputMaybe<SortOrderInput>;
  personalIdNumberMatch?: InputMaybe<SortOrderInput>;
  placeOfBirthMatch?: InputMaybe<SortOrderInput>;
  professionMatch?: InputMaybe<SortOrderInput>;
  raceMatch?: InputMaybe<SortOrderInput>;
  religionFormat?: InputMaybe<SortOrderInput>;
  religionMatch?: InputMaybe<SortOrderInput>;
  residentialStatusMatch?: InputMaybe<SortOrderInput>;
  sexFormat?: InputMaybe<SortOrderInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  visualOverall?: InputMaybe<SortOrderInput>;
  visualPhotoForgery?: InputMaybe<SortOrderInput>;
  visualSecurityFeatures?: InputMaybe<SortOrderInput>;
};

export enum IdVerificationResultScalarFieldEnum {
  AdditionalPersonalIdNumberFormat = 'additionalPersonalIdNumberFormat',
  AddressMatch = 'addressMatch',
  BackCardRotation = 'backCardRotation',
  Blob = 'blob',
  Certainty = 'certainty',
  ClassEfectiveDateFormat = 'classEfectiveDateFormat',
  ClassExpiryDateFormat = 'classExpiryDateFormat',
  CreatedAt = 'createdAt',
  DataBarcodeAnomalyContent = 'dataBarcodeAnomalyContent',
  DataBarcodeAnomalyOverall = 'dataBarcodeAnomalyOverall',
  DataBarcodeAnomalyRead = 'dataBarcodeAnomalyRead',
  DataFormatOverall = 'dataFormatOverall',
  DataIntegrity = 'dataIntegrity',
  DataLogicDateOverall = 'dataLogicDateOverall',
  DataLogicDocumentNumber = 'dataLogicDocumentNumber',
  DataLogicMrzOverall = 'dataLogicMRZOverall',
  DataLogicOverall = 'dataLogicOverall',
  DataLogicPersonalIdNumber = 'dataLogicPersonalIdNumber',
  DataMatchOverall = 'dataMatchOverall',
  DataOverall = 'dataOverall',
  DataSuspiciousNumber = 'dataSuspiciousNumber',
  DataSuspiciousOverall = 'dataSuspiciousOverall',
  DataSuspiciousSampleString = 'dataSuspiciousSampleString',
  DateOfBirthBeforeDateOfExpiryCheck = 'dateOfBirthBeforeDateOfExpiryCheck',
  DateOfBirthBeforeDateOfIssueCheck = 'dateOfBirthBeforeDateOfIssueCheck',
  DateOfBirthFormat = 'dateOfBirthFormat',
  DateOfBirthInPastCheck = 'dateOfBirthInPastCheck',
  DateOfBirthMatch = 'dateOfBirthMatch',
  DateOfExpiryFormat = 'dateOfExpiryFormat',
  DateOfExpiryMatch = 'dateOfExpiryMatch',
  DateOfIssueBeforeDateOfExpiryCheck = 'dateOfIssueBeforeDateOfExpiryCheck',
  DateOfIssueFormat = 'dateOfIssueFormat',
  DateOfIssueInPastCheck = 'dateOfIssueInPastCheck',
  DateOfIssueMatch = 'dateOfIssueMatch',
  DocumentAdditionalNumberFormat = 'documentAdditionalNumberFormat',
  DocumentAdditionalNumberMatch = 'documentAdditionalNumberMatch',
  DocumentExpired = 'documentExpired',
  DocumentLivenessHandPresence = 'documentLivenessHandPresence',
  DocumentLivenessOverall = 'documentLivenessOverall',
  DocumentLivenessPhotocopy = 'documentLivenessPhotocopy',
  DocumentLivenessScreen = 'documentLivenessScreen',
  DocumentNumberFormat = 'documentNumberFormat',
  DocumentNumberMatch = 'documentNumberMatch',
  DocumentOptionalAdditionalNumberFormat = 'documentOptionalAdditionalNumberFormat',
  DocumentOptionalAdditionalNumberMatch = 'documentOptionalAdditionalNumberMatch',
  DocumentVersion = 'documentVersion',
  EmployerMatch = 'employerMatch',
  FirstNameMatch = 'firstNameMatch',
  FormatCheckDetail = 'formatCheckDetail',
  FrontCardRotation = 'frontCardRotation',
  FullNameMatch = 'fullNameMatch',
  Id = 'id',
  IdentificationDocumentId = 'identificationDocumentId',
  ImageQualityBlur = 'imageQualityBlur',
  ImageQualityClarity = 'imageQualityClarity',
  ImageQualityOverall = 'imageQualityOverall',
  IssueAuthorityFormat = 'issueAuthorityFormat',
  LastNameMatch = 'lastNameMatch',
  MaritalStatusFormat = 'maritalStatusFormat',
  MaritalStatusMatch = 'maritalStatusMatch',
  MatchCheckDetail = 'matchCheckDetail',
  Messages = 'messages',
  Model = 'model',
  ModelVersion = 'modelVersion',
  MrzCheckDigits = 'mrzCheckDigits',
  MrzParsed = 'mrzParsed',
  NationalityFormat = 'nationalityFormat',
  Overall = 'overall',
  PassportId = 'passportId',
  PersonalIdNumberFormat = 'personalIdNumberFormat',
  PersonalIdNumberMatch = 'personalIdNumberMatch',
  PlaceOfBirthMatch = 'placeOfBirthMatch',
  ProfessionMatch = 'professionMatch',
  RaceMatch = 'raceMatch',
  ReligionFormat = 'religionFormat',
  ReligionMatch = 'religionMatch',
  ResidentialStatusMatch = 'residentialStatusMatch',
  SexFormat = 'sexFormat',
  StateIdentificationCardId = 'stateIdentificationCardId',
  UpdatedAt = 'updatedAt',
  VisualOverall = 'visualOverall',
  VisualPhotoForgery = 'visualPhotoForgery',
  VisualSecurityFeatures = 'visualSecurityFeatures'
}

export type IdVerificationResultScalarWhereInput = {
  AND?: InputMaybe<Array<IdVerificationResultScalarWhereInput>>;
  NOT?: InputMaybe<Array<IdVerificationResultScalarWhereInput>>;
  OR?: InputMaybe<Array<IdVerificationResultScalarWhereInput>>;
  additionalPersonalIdNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  addressMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  backCardRotation?: InputMaybe<EnumIdCardRotationEnumNullableFilter>;
  blob?: InputMaybe<JsonFilter>;
  certainty?: InputMaybe<StringFilter>;
  classEfectiveDateFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  classExpiryDateFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataBarcodeAnomalyContent?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataBarcodeAnomalyOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataBarcodeAnomalyRead?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataFormatOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataIntegrity?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicDateOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicDocumentNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicMRZOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicPersonalIdNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataMatchOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousSampleString?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthInPastCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfExpiryFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfExpiryMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueInPastCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentAdditionalNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentAdditionalNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentExpired?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessHandPresence?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessPhotocopy?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessScreen?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentVersion?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  employerMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  firstNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  formatCheckDetail?: InputMaybe<JsonNullableFilter>;
  frontCardRotation?: InputMaybe<EnumIdCardRotationEnumNullableFilter>;
  fullNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  imageQualityBlur?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  imageQualityClarity?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  imageQualityOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  issueAuthorityFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  lastNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  maritalStatusFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  maritalStatusMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  matchCheckDetail?: InputMaybe<JsonNullableFilter>;
  messages?: InputMaybe<JsonNullableFilter>;
  model?: InputMaybe<EnumIdVerificationModelEnumNullableFilter>;
  modelVersion?: InputMaybe<StringNullableFilter>;
  mrzCheckDigits?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  mrzParsed?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  nationalityFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  overall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  personalIdNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  personalIdNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  placeOfBirthMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  professionMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  raceMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  religionFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  religionMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  residentialStatusMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  sexFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visualOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  visualPhotoForgery?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  visualSecurityFeatures?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
};

export type IdVerificationResultUpdateManyMutationInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  addressMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  backCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  certainty?: InputMaybe<StringFieldUpdateOperationsInput>;
  classEfectiveDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  classExpiryDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataBarcodeAnomalyContent?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyRead?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataFormatOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataIntegrity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDateOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDocumentNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicMRZOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicPersonalIdNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataMatchOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousSampleString?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentExpired?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessHandPresence?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessPhotocopy?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessScreen?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentVersion?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  employerMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  firstNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  fullNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageQualityBlur?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityClarity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  issueAuthorityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  lastNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<NullableEnumIdVerificationModelEnumFieldUpdateOperationsInput>;
  modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mrzCheckDigits?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  mrzParsed?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  nationalityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  overall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  personalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  personalIdNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  placeOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  professionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  raceMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  residentialStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  sexFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visualOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualPhotoForgery?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualSecurityFeatures?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
};

export type IdVerificationResultUpdateManyWithWhereWithoutIdentificationDocumentInput = {
  data: IdVerificationResultUpdateManyMutationInput;
  where: IdVerificationResultScalarWhereInput;
};

export type IdVerificationResultUpdateManyWithWhereWithoutPassportInput = {
  data: IdVerificationResultUpdateManyMutationInput;
  where: IdVerificationResultScalarWhereInput;
};

export type IdVerificationResultUpdateManyWithWhereWithoutStateIdentificationCardInput = {
  data: IdVerificationResultUpdateManyMutationInput;
  where: IdVerificationResultScalarWhereInput;
};

export type IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput = {
  connect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdVerificationResultCreateOrConnectWithoutIdentificationDocumentInput>>;
  create?: InputMaybe<Array<IdVerificationResultCreateWithoutIdentificationDocumentInput>>;
  createMany?: InputMaybe<IdVerificationResultCreateManyIdentificationDocumentInputEnvelope>;
  delete?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IdVerificationResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  set?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  update?: InputMaybe<Array<IdVerificationResultUpdateWithWhereUniqueWithoutIdentificationDocumentInput>>;
  updateMany?: InputMaybe<Array<IdVerificationResultUpdateManyWithWhereWithoutIdentificationDocumentInput>>;
  upsert?: InputMaybe<Array<IdVerificationResultUpsertWithWhereUniqueWithoutIdentificationDocumentInput>>;
};

export type IdVerificationResultUpdateManyWithoutPassportNestedInput = {
  connect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdVerificationResultCreateOrConnectWithoutPassportInput>>;
  create?: InputMaybe<Array<IdVerificationResultCreateWithoutPassportInput>>;
  createMany?: InputMaybe<IdVerificationResultCreateManyPassportInputEnvelope>;
  delete?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IdVerificationResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  set?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  update?: InputMaybe<Array<IdVerificationResultUpdateWithWhereUniqueWithoutPassportInput>>;
  updateMany?: InputMaybe<Array<IdVerificationResultUpdateManyWithWhereWithoutPassportInput>>;
  upsert?: InputMaybe<Array<IdVerificationResultUpsertWithWhereUniqueWithoutPassportInput>>;
};

export type IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput = {
  connect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdVerificationResultCreateOrConnectWithoutStateIdentificationCardInput>>;
  create?: InputMaybe<Array<IdVerificationResultCreateWithoutStateIdentificationCardInput>>;
  createMany?: InputMaybe<IdVerificationResultCreateManyStateIdentificationCardInputEnvelope>;
  delete?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IdVerificationResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  set?: InputMaybe<Array<IdVerificationResultWhereUniqueInput>>;
  update?: InputMaybe<Array<IdVerificationResultUpdateWithWhereUniqueWithoutStateIdentificationCardInput>>;
  updateMany?: InputMaybe<Array<IdVerificationResultUpdateManyWithWhereWithoutStateIdentificationCardInput>>;
  upsert?: InputMaybe<Array<IdVerificationResultUpsertWithWhereUniqueWithoutStateIdentificationCardInput>>;
};

export type IdVerificationResultUpdateWithWhereUniqueWithoutIdentificationDocumentInput = {
  data: IdVerificationResultUpdateWithoutIdentificationDocumentInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultUpdateWithWhereUniqueWithoutPassportInput = {
  data: IdVerificationResultUpdateWithoutPassportInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultUpdateWithWhereUniqueWithoutStateIdentificationCardInput = {
  data: IdVerificationResultUpdateWithoutStateIdentificationCardInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultUpdateWithoutIdentificationDocumentInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  addressMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  backCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  certainty?: InputMaybe<StringFieldUpdateOperationsInput>;
  classEfectiveDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  classExpiryDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataBarcodeAnomalyContent?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyRead?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataFormatOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataIntegrity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDateOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDocumentNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicMRZOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicPersonalIdNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataMatchOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousSampleString?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentExpired?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessHandPresence?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessPhotocopy?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessScreen?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentVersion?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  employerMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  firstNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  fullNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageQualityBlur?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityClarity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  issueAuthorityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  lastNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<NullableEnumIdVerificationModelEnumFieldUpdateOperationsInput>;
  modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mrzCheckDigits?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  mrzParsed?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  nationalityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  overall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutIdVerificationResultNestedInput>;
  personalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  personalIdNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  placeOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  professionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  raceMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  residentialStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  sexFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutIdVerificationResultNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visualOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualPhotoForgery?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualSecurityFeatures?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
};

export type IdVerificationResultUpdateWithoutPassportInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  addressMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  backCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  certainty?: InputMaybe<StringFieldUpdateOperationsInput>;
  classEfectiveDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  classExpiryDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataBarcodeAnomalyContent?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyRead?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataFormatOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataIntegrity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDateOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDocumentNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicMRZOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicPersonalIdNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataMatchOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousSampleString?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentExpired?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessHandPresence?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessPhotocopy?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessScreen?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentVersion?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  employerMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  firstNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  fullNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutIdVerificationResultNestedInput>;
  imageQualityBlur?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityClarity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  issueAuthorityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  lastNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<NullableEnumIdVerificationModelEnumFieldUpdateOperationsInput>;
  modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mrzCheckDigits?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  mrzParsed?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  nationalityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  overall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  personalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  personalIdNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  placeOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  professionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  raceMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  residentialStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  sexFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutIdVerificationResultNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visualOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualPhotoForgery?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualSecurityFeatures?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
};

export type IdVerificationResultUpdateWithoutStateIdentificationCardInput = {
  additionalPersonalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  addressMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  backCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  certainty?: InputMaybe<StringFieldUpdateOperationsInput>;
  classEfectiveDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  classExpiryDateFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataBarcodeAnomalyContent?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataBarcodeAnomalyRead?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataFormatOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataIntegrity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDateOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicDocumentNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicMRZOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataLogicPersonalIdNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataMatchOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousNumber?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dataSuspiciousSampleString?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfExpiryMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueInPastCheck?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  dateOfIssueMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentExpired?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessHandPresence?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessPhotocopy?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentLivenessScreen?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  documentVersion?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  employerMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  firstNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  formatCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  frontCardRotation?: InputMaybe<NullableEnumIdCardRotationEnumFieldUpdateOperationsInput>;
  fullNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutIdVerificationResultNestedInput>;
  imageQualityBlur?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityClarity?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  imageQualityOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  issueAuthorityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  lastNameMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  maritalStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  matchCheckDetail?: InputMaybe<Scalars['JSON']['input']>;
  messages?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<NullableEnumIdVerificationModelEnumFieldUpdateOperationsInput>;
  modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mrzCheckDigits?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  mrzParsed?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  nationalityFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  overall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutIdVerificationResultNestedInput>;
  personalIdNumberFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  personalIdNumberMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  placeOfBirthMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  professionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  raceMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  religionMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  residentialStatusMatch?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  sexFormat?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visualOverall?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualPhotoForgery?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
  visualSecurityFeatures?: InputMaybe<NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput>;
};

export type IdVerificationResultUpsertWithWhereUniqueWithoutIdentificationDocumentInput = {
  create: IdVerificationResultCreateWithoutIdentificationDocumentInput;
  update: IdVerificationResultUpdateWithoutIdentificationDocumentInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultUpsertWithWhereUniqueWithoutPassportInput = {
  create: IdVerificationResultCreateWithoutPassportInput;
  update: IdVerificationResultUpdateWithoutPassportInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultUpsertWithWhereUniqueWithoutStateIdentificationCardInput = {
  create: IdVerificationResultCreateWithoutStateIdentificationCardInput;
  update: IdVerificationResultUpdateWithoutStateIdentificationCardInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultWhereInput = {
  AND?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  NOT?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  OR?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  additionalPersonalIdNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  addressMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  backCardRotation?: InputMaybe<EnumIdCardRotationEnumNullableFilter>;
  blob?: InputMaybe<JsonFilter>;
  certainty?: InputMaybe<StringFilter>;
  classEfectiveDateFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  classExpiryDateFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataBarcodeAnomalyContent?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataBarcodeAnomalyOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataBarcodeAnomalyRead?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataFormatOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataIntegrity?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicDateOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicDocumentNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicMRZOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicPersonalIdNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataMatchOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousSampleString?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthInPastCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfExpiryFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfExpiryMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueInPastCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentAdditionalNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentAdditionalNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentExpired?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessHandPresence?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessPhotocopy?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessScreen?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentVersion?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  employerMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  firstNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  formatCheckDetail?: InputMaybe<JsonNullableFilter>;
  frontCardRotation?: InputMaybe<EnumIdCardRotationEnumNullableFilter>;
  fullNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  imageQualityBlur?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  imageQualityClarity?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  imageQualityOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  issueAuthorityFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  lastNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  maritalStatusFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  maritalStatusMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  matchCheckDetail?: InputMaybe<JsonNullableFilter>;
  messages?: InputMaybe<JsonNullableFilter>;
  model?: InputMaybe<EnumIdVerificationModelEnumNullableFilter>;
  modelVersion?: InputMaybe<StringNullableFilter>;
  mrzCheckDigits?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  mrzParsed?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  nationalityFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  overall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  personalIdNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  personalIdNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  placeOfBirthMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  professionMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  raceMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  religionFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  religionMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  residentialStatusMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  sexFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visualOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  visualPhotoForgery?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  visualSecurityFeatures?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
};

export type IdVerificationResultWhereUniqueInput = {
  AND?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  NOT?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  OR?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  additionalPersonalIdNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  addressMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  backCardRotation?: InputMaybe<EnumIdCardRotationEnumNullableFilter>;
  blob?: InputMaybe<JsonFilter>;
  certainty?: InputMaybe<StringFilter>;
  classEfectiveDateFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  classExpiryDateFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataBarcodeAnomalyContent?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataBarcodeAnomalyOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataBarcodeAnomalyRead?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataFormatOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataIntegrity?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicDateOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicDocumentNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicMRZOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataLogicPersonalIdNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataMatchOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousNumber?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dataSuspiciousSampleString?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthBeforeDateOfExpiryCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthBeforeDateOfIssueCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthInPastCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfBirthMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfExpiryFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfExpiryMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueBeforeDateOfExpiryCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueInPastCheck?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  dateOfIssueMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentAdditionalNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentAdditionalNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentExpired?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessHandPresence?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessPhotocopy?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentLivenessScreen?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentOptionalAdditionalNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentOptionalAdditionalNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  documentVersion?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  employerMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  firstNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  formatCheckDetail?: InputMaybe<JsonNullableFilter>;
  frontCardRotation?: InputMaybe<EnumIdCardRotationEnumNullableFilter>;
  fullNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  imageQualityBlur?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  imageQualityClarity?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  imageQualityOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  issueAuthorityFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  lastNameMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  maritalStatusFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  maritalStatusMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  matchCheckDetail?: InputMaybe<JsonNullableFilter>;
  messages?: InputMaybe<JsonNullableFilter>;
  model?: InputMaybe<EnumIdVerificationModelEnumNullableFilter>;
  modelVersion?: InputMaybe<StringNullableFilter>;
  mrzCheckDigits?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  mrzParsed?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  nationalityFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  overall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  personalIdNumberFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  personalIdNumberMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  placeOfBirthMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  professionMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  raceMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  religionFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  religionMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  residentialStatusMatch?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  sexFormat?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visualOverall?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  visualPhotoForgery?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
  visualSecurityFeatures?: InputMaybe<EnumIdVerificationResultCheckEnumNullableFilter>;
};

export type IdentificationDocument = {
  __typename?: 'IdentificationDocument';
  _count?: Maybe<IdentificationDocumentCount>;
  address?: Maybe<Address>;
  applicantData?: Maybe<ApplicantData>;
  applicantDataId?: Maybe<Scalars['String']['output']>;
  backImage?: Maybe<File>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  extractedPhoto?: Maybe<File>;
  frontImage?: Maybe<File>;
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idVerificationResult: Array<IdVerificationResult>;
  issueDate: Scalars['String']['output'];
  manualIdEntry?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  nationality?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  selfieImage?: Maybe<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type IdentificationDocumentAddressArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type IdentificationDocumentApplicantDataArgs = {
  where?: InputMaybe<ApplicantDataWhereInput>;
};


export type IdentificationDocumentBackImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type IdentificationDocumentExtractedPhotoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type IdentificationDocumentFrontImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type IdentificationDocumentIdVerificationResultArgs = {
  cursor?: InputMaybe<IdVerificationResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<IdVerificationResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IdVerificationResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IdVerificationResultWhereInput>;
};


export type IdentificationDocumentNameArgs = {
  where?: InputMaybe<NameWhereInput>;
};


export type IdentificationDocumentSelfieImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type IdentificationDocumentUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type IdentificationDocumentCount = {
  __typename?: 'IdentificationDocumentCount';
  idVerificationResult: Scalars['Int']['output'];
};


export type IdentificationDocumentCountIdVerificationResultArgs = {
  where?: InputMaybe<IdVerificationResultWhereInput>;
};

export type IdentificationDocumentCreateInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateManyUserInput = {
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IdentificationDocumentCreateManyUserInputEnvelope = {
  data: Array<IdentificationDocumentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentificationDocumentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<IdentificationDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdentificationDocumentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<IdentificationDocumentCreateWithoutUserInput>>;
  createMany?: InputMaybe<IdentificationDocumentCreateManyUserInputEnvelope>;
};

export type IdentificationDocumentCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutAddressInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutApplicantDataInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutApplicantDataInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutBackImageInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutBackImageInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutBackImageInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutExtractedPhotoInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutExtractedPhotoInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutExtractedPhotoInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutFrontImageInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutFrontImageInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutFrontImageInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutIdVerificationResultInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutIdVerificationResultInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutIdVerificationResultInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutNameInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutNameInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutNameInput>;
};

export type IdentificationDocumentCreateNestedOneWithoutSelfieImageInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutSelfieImageInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutSelfieImageInput>;
};

export type IdentificationDocumentCreateOrConnectWithoutAddressInput = {
  create: IdentificationDocumentCreateWithoutAddressInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutApplicantDataInput = {
  create: IdentificationDocumentCreateWithoutApplicantDataInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutBackImageInput = {
  create: IdentificationDocumentCreateWithoutBackImageInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutExtractedPhotoInput = {
  create: IdentificationDocumentCreateWithoutExtractedPhotoInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutFrontImageInput = {
  create: IdentificationDocumentCreateWithoutFrontImageInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutIdVerificationResultInput = {
  create: IdentificationDocumentCreateWithoutIdVerificationResultInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutNameInput = {
  create: IdentificationDocumentCreateWithoutNameInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutSelfieImageInput = {
  create: IdentificationDocumentCreateWithoutSelfieImageInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateOrConnectWithoutUserInput = {
  create: IdentificationDocumentCreateWithoutUserInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentCreateWithoutAddressInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutApplicantDataInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutBackImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutExtractedPhotoInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutFrontImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutIdVerificationResultInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutNameInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutSelfieImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutIdentificationDocumentsInput>;
};

export type IdentificationDocumentCreateWithoutUserInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutIdentificationDocumentInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutIdentificationDocumentInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutIdentificationDocumentInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutIdentificationDocumentInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutIdentificationDocumentSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type IdentificationDocumentListRelationFilter = {
  every?: InputMaybe<IdentificationDocumentWhereInput>;
  none?: InputMaybe<IdentificationDocumentWhereInput>;
  some?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentNullableScalarRelationFilter = {
  is?: InputMaybe<IdentificationDocumentWhereInput>;
  isNot?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IdentificationDocumentOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantDataId?: InputMaybe<SortOrderInput>;
  backImage?: InputMaybe<FileOrderByWithRelationInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  documentType?: InputMaybe<SortOrder>;
  expiryDate?: InputMaybe<SortOrder>;
  extractedPhoto?: InputMaybe<FileOrderByWithRelationInput>;
  frontImage?: InputMaybe<FileOrderByWithRelationInput>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idVerificationResult?: InputMaybe<IdVerificationResultOrderByRelationAggregateInput>;
  issueDate?: InputMaybe<SortOrder>;
  manualIdEntry?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<NameOrderByWithRelationInput>;
  nationality?: InputMaybe<SortOrderInput>;
  number?: InputMaybe<SortOrder>;
  placeOfBirth?: InputMaybe<SortOrderInput>;
  selfieImage?: InputMaybe<FileOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum IdentificationDocumentScalarFieldEnum {
  ApplicantDataId = 'applicantDataId',
  Country = 'country',
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DocumentType = 'documentType',
  ExpiryDate = 'expiryDate',
  Gender = 'gender',
  Id = 'id',
  IssueDate = 'issueDate',
  ManualIdEntry = 'manualIdEntry',
  Nationality = 'nationality',
  Number = 'number',
  PlaceOfBirth = 'placeOfBirth',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type IdentificationDocumentScalarWhereInput = {
  AND?: InputMaybe<Array<IdentificationDocumentScalarWhereInput>>;
  NOT?: InputMaybe<Array<IdentificationDocumentScalarWhereInput>>;
  OR?: InputMaybe<Array<IdentificationDocumentScalarWhereInput>>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  issueDate?: InputMaybe<StringFilter>;
  manualIdEntry?: InputMaybe<BoolNullableFilter>;
  nationality?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringFilter>;
  placeOfBirth?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type IdentificationDocumentUpdateInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateManyMutationInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IdentificationDocumentUpdateManyWithWhereWithoutUserInput = {
  data: IdentificationDocumentUpdateManyMutationInput;
  where: IdentificationDocumentScalarWhereInput;
};

export type IdentificationDocumentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<IdentificationDocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdentificationDocumentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<IdentificationDocumentCreateWithoutUserInput>>;
  createMany?: InputMaybe<IdentificationDocumentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<IdentificationDocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IdentificationDocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IdentificationDocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<IdentificationDocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<IdentificationDocumentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<IdentificationDocumentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<IdentificationDocumentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type IdentificationDocumentUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutAddressInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutAddressInput>;
};

export type IdentificationDocumentUpdateOneWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutApplicantDataInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutApplicantDataInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutApplicantDataInput>;
};

export type IdentificationDocumentUpdateOneWithoutBackImageNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutBackImageInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutBackImageInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutBackImageInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutBackImageInput>;
};

export type IdentificationDocumentUpdateOneWithoutExtractedPhotoNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutExtractedPhotoInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutExtractedPhotoInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutExtractedPhotoInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutExtractedPhotoInput>;
};

export type IdentificationDocumentUpdateOneWithoutFrontImageNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutFrontImageInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutFrontImageInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutFrontImageInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutFrontImageInput>;
};

export type IdentificationDocumentUpdateOneWithoutIdVerificationResultNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutIdVerificationResultInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutIdVerificationResultInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutIdVerificationResultInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutIdVerificationResultInput>;
};

export type IdentificationDocumentUpdateOneWithoutNameNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutNameInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutNameInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutNameInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutNameInput>;
};

export type IdentificationDocumentUpdateOneWithoutSelfieImageNestedInput = {
  connect?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdentificationDocumentCreateOrConnectWithoutSelfieImageInput>;
  create?: InputMaybe<IdentificationDocumentCreateWithoutSelfieImageInput>;
  delete?: InputMaybe<IdentificationDocumentWhereInput>;
  disconnect?: InputMaybe<IdentificationDocumentWhereInput>;
  update?: InputMaybe<IdentificationDocumentUpdateToOneWithWhereWithoutSelfieImageInput>;
  upsert?: InputMaybe<IdentificationDocumentUpsertWithoutSelfieImageInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutAddressInput = {
  data: IdentificationDocumentUpdateWithoutAddressInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutApplicantDataInput = {
  data: IdentificationDocumentUpdateWithoutApplicantDataInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutBackImageInput = {
  data: IdentificationDocumentUpdateWithoutBackImageInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutExtractedPhotoInput = {
  data: IdentificationDocumentUpdateWithoutExtractedPhotoInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutFrontImageInput = {
  data: IdentificationDocumentUpdateWithoutFrontImageInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutIdVerificationResultInput = {
  data: IdentificationDocumentUpdateWithoutIdVerificationResultInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutNameInput = {
  data: IdentificationDocumentUpdateWithoutNameInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateToOneWithWhereWithoutSelfieImageInput = {
  data: IdentificationDocumentUpdateWithoutSelfieImageInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpdateWithWhereUniqueWithoutUserInput = {
  data: IdentificationDocumentUpdateWithoutUserInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentUpdateWithoutAddressInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutApplicantDataInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutBackImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutExtractedPhotoInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutFrontImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutIdVerificationResultInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutNameInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutSelfieImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutIdentificationDocumentsNestedInput>;
};

export type IdentificationDocumentUpdateWithoutUserInput = {
  address?: InputMaybe<AddressUpdateOneWithoutIdentificationDocumentNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutIdentificationDocumentNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutIdentificationDocumentNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutIdentificationDocumentNestedInput>;
  nationality?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutIdentificationDocumentSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type IdentificationDocumentUpsertWithWhereUniqueWithoutUserInput = {
  create: IdentificationDocumentCreateWithoutUserInput;
  update: IdentificationDocumentUpdateWithoutUserInput;
  where: IdentificationDocumentWhereUniqueInput;
};

export type IdentificationDocumentUpsertWithoutAddressInput = {
  create: IdentificationDocumentCreateWithoutAddressInput;
  update: IdentificationDocumentUpdateWithoutAddressInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutApplicantDataInput = {
  create: IdentificationDocumentCreateWithoutApplicantDataInput;
  update: IdentificationDocumentUpdateWithoutApplicantDataInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutBackImageInput = {
  create: IdentificationDocumentCreateWithoutBackImageInput;
  update: IdentificationDocumentUpdateWithoutBackImageInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutExtractedPhotoInput = {
  create: IdentificationDocumentCreateWithoutExtractedPhotoInput;
  update: IdentificationDocumentUpdateWithoutExtractedPhotoInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutFrontImageInput = {
  create: IdentificationDocumentCreateWithoutFrontImageInput;
  update: IdentificationDocumentUpdateWithoutFrontImageInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutIdVerificationResultInput = {
  create: IdentificationDocumentCreateWithoutIdVerificationResultInput;
  update: IdentificationDocumentUpdateWithoutIdVerificationResultInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutNameInput = {
  create: IdentificationDocumentCreateWithoutNameInput;
  update: IdentificationDocumentUpdateWithoutNameInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentUpsertWithoutSelfieImageInput = {
  create: IdentificationDocumentCreateWithoutSelfieImageInput;
  update: IdentificationDocumentUpdateWithoutSelfieImageInput;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};

export type IdentificationDocumentWhereInput = {
  AND?: InputMaybe<Array<IdentificationDocumentWhereInput>>;
  NOT?: InputMaybe<Array<IdentificationDocumentWhereInput>>;
  OR?: InputMaybe<Array<IdentificationDocumentWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  backImage?: InputMaybe<FileNullableScalarRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  extractedPhoto?: InputMaybe<FileNullableScalarRelationFilter>;
  frontImage?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  idVerificationResult?: InputMaybe<IdVerificationResultListRelationFilter>;
  issueDate?: InputMaybe<StringFilter>;
  manualIdEntry?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<NameNullableScalarRelationFilter>;
  nationality?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringFilter>;
  placeOfBirth?: InputMaybe<StringNullableFilter>;
  selfieImage?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type IdentificationDocumentWhereUniqueInput = {
  AND?: InputMaybe<Array<IdentificationDocumentWhereInput>>;
  NOT?: InputMaybe<Array<IdentificationDocumentWhereInput>>;
  OR?: InputMaybe<Array<IdentificationDocumentWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  backImage?: InputMaybe<FileNullableScalarRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  extractedPhoto?: InputMaybe<FileNullableScalarRelationFilter>;
  frontImage?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultListRelationFilter>;
  issueDate?: InputMaybe<StringFilter>;
  manualIdEntry?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<NameNullableScalarRelationFilter>;
  nationality?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringFilter>;
  placeOfBirth?: InputMaybe<StringNullableFilter>;
  selfieImage?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type Identifier = {
  __typename?: 'Identifier';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  type: IdentifierType;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type IdentifierCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  type: IdentifierType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value: Scalars['String']['input'];
};

export type IdentifierCreateManyUserInputEnvelope = {
  data: Array<IdentifierCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentifierCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<IdentifierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdentifierCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<IdentifierCreateWithoutUserInput>>;
  createMany?: InputMaybe<IdentifierCreateManyUserInputEnvelope>;
};

export type IdentifierCreateOrConnectWithoutUserInput = {
  create: IdentifierCreateWithoutUserInput;
  where: IdentifierWhereUniqueInput;
};

export type IdentifierCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  type: IdentifierType;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value: Scalars['String']['input'];
};

export type IdentifierListRelationFilter = {
  every?: InputMaybe<IdentifierWhereInput>;
  none?: InputMaybe<IdentifierWhereInput>;
  some?: InputMaybe<IdentifierWhereInput>;
};

export type IdentifierOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IdentifierOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPrimary?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  value?: InputMaybe<SortOrder>;
};

export enum IdentifierScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsPrimary = 'isPrimary',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  Value = 'value'
}

export type IdentifierScalarWhereInput = {
  AND?: InputMaybe<Array<IdentifierScalarWhereInput>>;
  NOT?: InputMaybe<Array<IdentifierScalarWhereInput>>;
  OR?: InputMaybe<Array<IdentifierScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPrimary?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumIdentifierTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<StringFilter>;
};

export enum IdentifierType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type IdentifierUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumIdentifierTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IdentifierUpdateManyWithWhereWithoutUserInput = {
  data: IdentifierUpdateManyMutationInput;
  where: IdentifierScalarWhereInput;
};

export type IdentifierUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<IdentifierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IdentifierCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<IdentifierCreateWithoutUserInput>>;
  createMany?: InputMaybe<IdentifierCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<IdentifierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IdentifierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IdentifierWhereUniqueInput>>;
  set?: InputMaybe<Array<IdentifierWhereUniqueInput>>;
  update?: InputMaybe<Array<IdentifierUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<IdentifierUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<IdentifierUpsertWithWhereUniqueWithoutUserInput>>;
};

export type IdentifierUpdateWithWhereUniqueWithoutUserInput = {
  data: IdentifierUpdateWithoutUserInput;
  where: IdentifierWhereUniqueInput;
};

export type IdentifierUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumIdentifierTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type IdentifierUpsertWithWhereUniqueWithoutUserInput = {
  create: IdentifierCreateWithoutUserInput;
  update: IdentifierUpdateWithoutUserInput;
  where: IdentifierWhereUniqueInput;
};

export type IdentifierWhereInput = {
  AND?: InputMaybe<Array<IdentifierWhereInput>>;
  NOT?: InputMaybe<Array<IdentifierWhereInput>>;
  OR?: InputMaybe<Array<IdentifierWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPrimary?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumIdentifierTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<StringFilter>;
};

export type IdentifierWhereUniqueInput = {
  AND?: InputMaybe<Array<IdentifierWhereInput>>;
  NOT?: InputMaybe<Array<IdentifierWhereInput>>;
  OR?: InputMaybe<Array<IdentifierWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumIdentifierTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Invite = {
  __typename?: 'Invite';
  _count?: Maybe<InviteCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  redeemedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  redeemedBy?: Maybe<User>;
  redeemedById?: Maybe<Scalars['String']['output']>;
  requireCaptcha: Scalars['Boolean']['output'];
  sender: User;
  senderId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  vidVoucherId?: Maybe<Scalars['String']['output']>;
  vidVouchers: Array<VidVoucher>;
};


export type InviteRedeemedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type InviteVidVouchersArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  distinct?: InputMaybe<Array<VidVoucherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type InviteCount = {
  __typename?: 'InviteCount';
  vidVouchers: Scalars['Int']['output'];
};


export type InviteCountVidVouchersArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type InviteCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  redeemedById?: InputMaybe<Scalars['String']['input']>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  senderId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
};

export type InviteCreateManyOrganizationInputEnvelope = {
  data: Array<InviteCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteCreateManyRedeemedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  senderId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
};

export type InviteCreateManyRedeemedByInputEnvelope = {
  data: Array<InviteCreateManyRedeemedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteCreateManySenderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  redeemedById?: InputMaybe<Scalars['String']['input']>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
};

export type InviteCreateManySenderInputEnvelope = {
  data: Array<InviteCreateManySenderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InviteCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<InviteCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<InviteCreateManyOrganizationInputEnvelope>;
};

export type InviteCreateNestedManyWithoutRedeemedByInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InviteCreateOrConnectWithoutRedeemedByInput>>;
  create?: InputMaybe<Array<InviteCreateWithoutRedeemedByInput>>;
  createMany?: InputMaybe<InviteCreateManyRedeemedByInputEnvelope>;
};

export type InviteCreateNestedManyWithoutSenderInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InviteCreateOrConnectWithoutSenderInput>>;
  create?: InputMaybe<Array<InviteCreateWithoutSenderInput>>;
  createMany?: InputMaybe<InviteCreateManySenderInputEnvelope>;
};

export type InviteCreateNestedOneWithoutVidVouchersInput = {
  connect?: InputMaybe<InviteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InviteCreateOrConnectWithoutVidVouchersInput>;
  create?: InputMaybe<InviteCreateWithoutVidVouchersInput>;
};

export type InviteCreateOrConnectWithoutOrganizationInput = {
  create: InviteCreateWithoutOrganizationInput;
  where: InviteWhereUniqueInput;
};

export type InviteCreateOrConnectWithoutRedeemedByInput = {
  create: InviteCreateWithoutRedeemedByInput;
  where: InviteWhereUniqueInput;
};

export type InviteCreateOrConnectWithoutSenderInput = {
  create: InviteCreateWithoutSenderInput;
  where: InviteWhereUniqueInput;
};

export type InviteCreateOrConnectWithoutVidVouchersInput = {
  create: InviteCreateWithoutVidVouchersInput;
  where: InviteWhereUniqueInput;
};

export type InviteCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  redeemedBy?: InputMaybe<UserCreateNestedOneWithoutRedeemedInvitesInput>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  sender: UserCreateNestedOneWithoutSentInvitesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
  vidVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutInviteInput>;
};

export type InviteCreateWithoutRedeemedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutInvitesInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  sender: UserCreateNestedOneWithoutSentInvitesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
  vidVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutInviteInput>;
};

export type InviteCreateWithoutSenderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutInvitesInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  redeemedBy?: InputMaybe<UserCreateNestedOneWithoutRedeemedInvitesInput>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
  vidVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutInviteInput>;
};

export type InviteCreateWithoutVidVouchersInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutInvitesInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redeemedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  redeemedBy?: InputMaybe<UserCreateNestedOneWithoutRedeemedInvitesInput>;
  requireCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  sender: UserCreateNestedOneWithoutSentInvitesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vidVoucherId?: InputMaybe<Scalars['String']['input']>;
};

export type InviteDataOutputRes = {
  __typename?: 'InviteDataOutputRes';
  contactInformation: ContactInformationOutput;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type InviteErrorResponse = {
  __typename?: 'InviteErrorResponse';
  email: Scalars['String']['output'];
  error: Scalars['String']['output'];
};

export type InviteExport = {
  __typename?: 'InviteExport';
  createdAt: Scalars['DateTimeISO']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  rows: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type InviteListRelationFilter = {
  every?: InputMaybe<InviteWhereInput>;
  none?: InputMaybe<InviteWhereInput>;
  some?: InputMaybe<InviteWhereInput>;
};

export type InviteNullableScalarRelationFilter = {
  is?: InputMaybe<InviteWhereInput>;
  isNot?: InputMaybe<InviteWhereInput>;
};

export type InviteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InviteOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  redeemedAt?: InputMaybe<SortOrderInput>;
  redeemedBy?: InputMaybe<UserOrderByWithRelationInput>;
  redeemedById?: InputMaybe<SortOrderInput>;
  requireCaptcha?: InputMaybe<SortOrder>;
  sender?: InputMaybe<UserOrderByWithRelationInput>;
  senderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vidVoucherId?: InputMaybe<SortOrderInput>;
  vidVouchers?: InputMaybe<VidVoucherOrderByRelationAggregateInput>;
};

export type InviteRes = {
  __typename?: 'InviteRes';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  redeemedAt?: Maybe<Scalars['String']['output']>;
  redeemedById?: Maybe<Scalars['String']['output']>;
  senderId: Scalars['String']['output'];
  vidVoucherId?: Maybe<Scalars['String']['output']>;
};

export enum InviteScalarFieldEnum {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  OrganizationId = 'organizationId',
  PhoneNumber = 'phoneNumber',
  RedeemedAt = 'redeemedAt',
  RedeemedById = 'redeemedById',
  RequireCaptcha = 'requireCaptcha',
  SenderId = 'senderId',
  UpdatedAt = 'updatedAt',
  VidVoucherId = 'vidVoucherId'
}

export type InviteScalarWhereInput = {
  AND?: InputMaybe<Array<InviteScalarWhereInput>>;
  NOT?: InputMaybe<Array<InviteScalarWhereInput>>;
  OR?: InputMaybe<Array<InviteScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  redeemedAt?: InputMaybe<DateTimeNullableFilter>;
  redeemedById?: InputMaybe<StringNullableFilter>;
  requireCaptcha?: InputMaybe<BoolFilter>;
  senderId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vidVoucherId?: InputMaybe<StringNullableFilter>;
};

export type InviteUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  redeemedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireCaptcha?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vidVoucherId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type InviteUpdateManyWithWhereWithoutOrganizationInput = {
  data: InviteUpdateManyMutationInput;
  where: InviteScalarWhereInput;
};

export type InviteUpdateManyWithWhereWithoutRedeemedByInput = {
  data: InviteUpdateManyMutationInput;
  where: InviteScalarWhereInput;
};

export type InviteUpdateManyWithWhereWithoutSenderInput = {
  data: InviteUpdateManyMutationInput;
  where: InviteScalarWhereInput;
};

export type InviteUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InviteCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<InviteCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<InviteCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<InviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  set?: InputMaybe<Array<InviteWhereUniqueInput>>;
  update?: InputMaybe<Array<InviteUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<InviteUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<InviteUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type InviteUpdateManyWithoutRedeemedByNestedInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InviteCreateOrConnectWithoutRedeemedByInput>>;
  create?: InputMaybe<Array<InviteCreateWithoutRedeemedByInput>>;
  createMany?: InputMaybe<InviteCreateManyRedeemedByInputEnvelope>;
  delete?: InputMaybe<Array<InviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  set?: InputMaybe<Array<InviteWhereUniqueInput>>;
  update?: InputMaybe<Array<InviteUpdateWithWhereUniqueWithoutRedeemedByInput>>;
  updateMany?: InputMaybe<Array<InviteUpdateManyWithWhereWithoutRedeemedByInput>>;
  upsert?: InputMaybe<Array<InviteUpsertWithWhereUniqueWithoutRedeemedByInput>>;
};

export type InviteUpdateManyWithoutSenderNestedInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InviteCreateOrConnectWithoutSenderInput>>;
  create?: InputMaybe<Array<InviteCreateWithoutSenderInput>>;
  createMany?: InputMaybe<InviteCreateManySenderInputEnvelope>;
  delete?: InputMaybe<Array<InviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  set?: InputMaybe<Array<InviteWhereUniqueInput>>;
  update?: InputMaybe<Array<InviteUpdateWithWhereUniqueWithoutSenderInput>>;
  updateMany?: InputMaybe<Array<InviteUpdateManyWithWhereWithoutSenderInput>>;
  upsert?: InputMaybe<Array<InviteUpsertWithWhereUniqueWithoutSenderInput>>;
};

export type InviteUpdateOneWithoutVidVouchersNestedInput = {
  connect?: InputMaybe<InviteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InviteCreateOrConnectWithoutVidVouchersInput>;
  create?: InputMaybe<InviteCreateWithoutVidVouchersInput>;
  delete?: InputMaybe<InviteWhereInput>;
  disconnect?: InputMaybe<InviteWhereInput>;
  update?: InputMaybe<InviteUpdateToOneWithWhereWithoutVidVouchersInput>;
  upsert?: InputMaybe<InviteUpsertWithoutVidVouchersInput>;
};

export type InviteUpdateToOneWithWhereWithoutVidVouchersInput = {
  data: InviteUpdateWithoutVidVouchersInput;
  where?: InputMaybe<InviteWhereInput>;
};

export type InviteUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: InviteUpdateWithoutOrganizationInput;
  where: InviteWhereUniqueInput;
};

export type InviteUpdateWithWhereUniqueWithoutRedeemedByInput = {
  data: InviteUpdateWithoutRedeemedByInput;
  where: InviteWhereUniqueInput;
};

export type InviteUpdateWithWhereUniqueWithoutSenderInput = {
  data: InviteUpdateWithoutSenderInput;
  where: InviteWhereUniqueInput;
};

export type InviteUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  redeemedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  redeemedBy?: InputMaybe<UserUpdateOneWithoutRedeemedInvitesNestedInput>;
  requireCaptcha?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sender?: InputMaybe<UserUpdateOneRequiredWithoutSentInvitesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vidVoucherId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vidVouchers?: InputMaybe<VidVoucherUpdateManyWithoutInviteNestedInput>;
};

export type InviteUpdateWithoutRedeemedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutInvitesNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  redeemedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requireCaptcha?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sender?: InputMaybe<UserUpdateOneRequiredWithoutSentInvitesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vidVoucherId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vidVouchers?: InputMaybe<VidVoucherUpdateManyWithoutInviteNestedInput>;
};

export type InviteUpdateWithoutSenderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutInvitesNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  redeemedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  redeemedBy?: InputMaybe<UserUpdateOneWithoutRedeemedInvitesNestedInput>;
  requireCaptcha?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vidVoucherId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vidVouchers?: InputMaybe<VidVoucherUpdateManyWithoutInviteNestedInput>;
};

export type InviteUpdateWithoutVidVouchersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutInvitesNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  redeemedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  redeemedBy?: InputMaybe<UserUpdateOneWithoutRedeemedInvitesNestedInput>;
  requireCaptcha?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sender?: InputMaybe<UserUpdateOneRequiredWithoutSentInvitesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vidVoucherId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type InviteUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: InviteCreateWithoutOrganizationInput;
  update: InviteUpdateWithoutOrganizationInput;
  where: InviteWhereUniqueInput;
};

export type InviteUpsertWithWhereUniqueWithoutRedeemedByInput = {
  create: InviteCreateWithoutRedeemedByInput;
  update: InviteUpdateWithoutRedeemedByInput;
  where: InviteWhereUniqueInput;
};

export type InviteUpsertWithWhereUniqueWithoutSenderInput = {
  create: InviteCreateWithoutSenderInput;
  update: InviteUpdateWithoutSenderInput;
  where: InviteWhereUniqueInput;
};

export type InviteUpsertWithoutVidVouchersInput = {
  create: InviteCreateWithoutVidVouchersInput;
  update: InviteUpdateWithoutVidVouchersInput;
  where?: InputMaybe<InviteWhereInput>;
};

export type InviteWhereInput = {
  AND?: InputMaybe<Array<InviteWhereInput>>;
  NOT?: InputMaybe<Array<InviteWhereInput>>;
  OR?: InputMaybe<Array<InviteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  redeemedAt?: InputMaybe<DateTimeNullableFilter>;
  redeemedBy?: InputMaybe<UserNullableScalarRelationFilter>;
  redeemedById?: InputMaybe<StringNullableFilter>;
  requireCaptcha?: InputMaybe<BoolFilter>;
  sender?: InputMaybe<UserScalarRelationFilter>;
  senderId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vidVoucherId?: InputMaybe<StringNullableFilter>;
  vidVouchers?: InputMaybe<VidVoucherListRelationFilter>;
};

export type InviteWhereUniqueInput = {
  AND?: InputMaybe<Array<InviteWhereInput>>;
  NOT?: InputMaybe<Array<InviteWhereInput>>;
  OR?: InputMaybe<Array<InviteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  redeemedAt?: InputMaybe<DateTimeNullableFilter>;
  redeemedBy?: InputMaybe<UserNullableScalarRelationFilter>;
  redeemedById?: InputMaybe<StringNullableFilter>;
  requireCaptcha?: InputMaybe<BoolFilter>;
  sender?: InputMaybe<UserScalarRelationFilter>;
  senderId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vidVoucherId?: InputMaybe<StringNullableFilter>;
  vidVouchers?: InputMaybe<VidVoucherListRelationFilter>;
};

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['DateTimeISO']['output'];
  deviceType?: Maybe<DeviceTypeEnum>;
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  payload: Scalars['JSON']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  runsAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status?: Maybe<JobStatusEnum>;
  task: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type JobUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type JobCountAggregate = {
  __typename?: 'JobCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deviceType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastError: Scalars['Int']['output'];
  payload: Scalars['Int']['output'];
  result: Scalars['Int']['output'];
  runsAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  task: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type JobCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastError?: InputMaybe<SortOrder>;
  payload?: InputMaybe<SortOrder>;
  result?: InputMaybe<SortOrder>;
  runsAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  task?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type JobCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['JSON']['input'];
  result?: InputMaybe<Scalars['JSON']['input']>;
  runsAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<JobStatusEnum>;
  task?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type JobCreateManyUserInputEnvelope = {
  data: Array<JobCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<JobWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JobCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<JobCreateWithoutUserInput>>;
  createMany?: InputMaybe<JobCreateManyUserInputEnvelope>;
};

export type JobCreateOrConnectWithoutUserInput = {
  create: JobCreateWithoutUserInput;
  where: JobWhereUniqueInput;
};

export type JobCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['JSON']['input'];
  result?: InputMaybe<Scalars['JSON']['input']>;
  runsAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<JobStatusEnum>;
  task?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type JobGroupBy = {
  __typename?: 'JobGroupBy';
  _count?: Maybe<JobCountAggregate>;
  _max?: Maybe<JobMaxAggregate>;
  _min?: Maybe<JobMinAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  deviceType?: Maybe<DeviceTypeEnum>;
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  payload: Scalars['JSON']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  runsAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status?: Maybe<JobStatusEnum>;
  task: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type JobListRelationFilter = {
  every?: InputMaybe<JobWhereInput>;
  none?: InputMaybe<JobWhereInput>;
  some?: InputMaybe<JobWhereInput>;
};

export type JobMaxAggregate = {
  __typename?: 'JobMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deviceType?: Maybe<DeviceTypeEnum>;
  id?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  runsAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status?: Maybe<JobStatusEnum>;
  task?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type JobMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastError?: InputMaybe<SortOrder>;
  runsAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  task?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type JobMinAggregate = {
  __typename?: 'JobMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deviceType?: Maybe<DeviceTypeEnum>;
  id?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  runsAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status?: Maybe<JobStatusEnum>;
  task?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type JobMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastError?: InputMaybe<SortOrder>;
  runsAt?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  task?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type JobOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type JobOrderByWithAggregationInput = {
  _count?: InputMaybe<JobCountOrderByAggregateInput>;
  _max?: InputMaybe<JobMaxOrderByAggregateInput>;
  _min?: InputMaybe<JobMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastError?: InputMaybe<SortOrderInput>;
  payload?: InputMaybe<SortOrder>;
  result?: InputMaybe<SortOrderInput>;
  runsAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  task?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrderInput>;
};

export type JobOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastError?: InputMaybe<SortOrderInput>;
  payload?: InputMaybe<SortOrder>;
  result?: InputMaybe<SortOrderInput>;
  runsAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  task?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum JobScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeviceType = 'deviceType',
  Id = 'id',
  LastError = 'lastError',
  Payload = 'payload',
  Result = 'result',
  RunsAt = 'runsAt',
  Status = 'status',
  Task = 'task',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type JobScalarWhereInput = {
  AND?: InputMaybe<Array<JobScalarWhereInput>>;
  NOT?: InputMaybe<Array<JobScalarWhereInput>>;
  OR?: InputMaybe<Array<JobScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastError?: InputMaybe<StringNullableFilter>;
  payload?: InputMaybe<JsonFilter>;
  result?: InputMaybe<JsonNullableFilter>;
  runsAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumJobStatusEnumNullableFilter>;
  task?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type JobScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<JobScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<JobScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<JobScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  lastError?: InputMaybe<StringNullableWithAggregatesFilter>;
  payload?: InputMaybe<JsonWithAggregatesFilter>;
  result?: InputMaybe<JsonNullableWithAggregatesFilter>;
  runsAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumJobStatusEnumNullableWithAggregatesFilter>;
  task?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum JobStatusEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type JobUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastError?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  runsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumJobStatusEnumFieldUpdateOperationsInput>;
  task?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type JobUpdateManyWithWhereWithoutUserInput = {
  data: JobUpdateManyMutationInput;
  where: JobScalarWhereInput;
};

export type JobUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<JobWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JobCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<JobCreateWithoutUserInput>>;
  createMany?: InputMaybe<JobCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<JobWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<JobScalarWhereInput>>;
  disconnect?: InputMaybe<Array<JobWhereUniqueInput>>;
  set?: InputMaybe<Array<JobWhereUniqueInput>>;
  update?: InputMaybe<Array<JobUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<JobUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<JobUpsertWithWhereUniqueWithoutUserInput>>;
};

export type JobUpdateWithWhereUniqueWithoutUserInput = {
  data: JobUpdateWithoutUserInput;
  where: JobWhereUniqueInput;
};

export type JobUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastError?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  runsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumJobStatusEnumFieldUpdateOperationsInput>;
  task?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type JobUpsertWithWhereUniqueWithoutUserInput = {
  create: JobCreateWithoutUserInput;
  update: JobUpdateWithoutUserInput;
  where: JobWhereUniqueInput;
};

export type JobWhereInput = {
  AND?: InputMaybe<Array<JobWhereInput>>;
  NOT?: InputMaybe<Array<JobWhereInput>>;
  OR?: InputMaybe<Array<JobWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastError?: InputMaybe<StringNullableFilter>;
  payload?: InputMaybe<JsonFilter>;
  result?: InputMaybe<JsonNullableFilter>;
  runsAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumJobStatusEnumNullableFilter>;
  task?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type JobWhereUniqueInput = {
  AND?: InputMaybe<Array<JobWhereInput>>;
  NOT?: InputMaybe<Array<JobWhereInput>>;
  OR?: InputMaybe<Array<JobWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastError?: InputMaybe<StringNullableFilter>;
  payload?: InputMaybe<JsonFilter>;
  result?: InputMaybe<JsonNullableFilter>;
  runsAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumJobStatusEnumNullableFilter>;
  task?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyCredential = {
  __typename?: 'LegacyCredential';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  validatorHash?: Maybe<Scalars['String']['output']>;
  validatorLink: Scalars['String']['output'];
};


export type LegacyCredentialUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type LegacyCredentialCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validatorHash?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyCredentialCreateManyUserInputEnvelope = {
  data: Array<LegacyCredentialCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegacyCredentialCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<LegacyCredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LegacyCredentialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LegacyCredentialCreateWithoutUserInput>>;
  createMany?: InputMaybe<LegacyCredentialCreateManyUserInputEnvelope>;
};

export type LegacyCredentialCreateOrConnectWithoutUserInput = {
  create: LegacyCredentialCreateWithoutUserInput;
  where: LegacyCredentialWhereUniqueInput;
};

export type LegacyCredentialCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  validatorHash?: InputMaybe<Scalars['String']['input']>;
};

export type LegacyCredentialListRelationFilter = {
  every?: InputMaybe<LegacyCredentialWhereInput>;
  none?: InputMaybe<LegacyCredentialWhereInput>;
  some?: InputMaybe<LegacyCredentialWhereInput>;
};

export type LegacyCredentialOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LegacyCredentialOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrderInput>;
  expiresAt?: InputMaybe<SortOrderInput>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organizationId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  validatorHash?: InputMaybe<SortOrderInput>;
};

export enum LegacyCredentialScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  ExpiresAt = 'expiresAt',
  Hidden = 'hidden',
  Id = 'id',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  ValidatorHash = 'validatorHash'
}

export type LegacyCredentialScalarWhereInput = {
  AND?: InputMaybe<Array<LegacyCredentialScalarWhereInput>>;
  NOT?: InputMaybe<Array<LegacyCredentialScalarWhereInput>>;
  OR?: InputMaybe<Array<LegacyCredentialScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  hidden?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  validatorHash?: InputMaybe<StringNullableFilter>;
};

export type LegacyCredentialUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutLegacyCredentialsNestedInput>;
  validatorHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LegacyCredentialUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validatorHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LegacyCredentialUpdateManyWithWhereWithoutUserInput = {
  data: LegacyCredentialUpdateManyMutationInput;
  where: LegacyCredentialScalarWhereInput;
};

export type LegacyCredentialUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<LegacyCredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LegacyCredentialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LegacyCredentialCreateWithoutUserInput>>;
  createMany?: InputMaybe<LegacyCredentialCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<LegacyCredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LegacyCredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LegacyCredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<LegacyCredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<LegacyCredentialUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<LegacyCredentialUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<LegacyCredentialUpsertWithWhereUniqueWithoutUserInput>>;
};

export type LegacyCredentialUpdateWithWhereUniqueWithoutUserInput = {
  data: LegacyCredentialUpdateWithoutUserInput;
  where: LegacyCredentialWhereUniqueInput;
};

export type LegacyCredentialUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  validatorHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LegacyCredentialUpsertWithWhereUniqueWithoutUserInput = {
  create: LegacyCredentialCreateWithoutUserInput;
  update: LegacyCredentialUpdateWithoutUserInput;
  where: LegacyCredentialWhereUniqueInput;
};

export type LegacyCredentialWhereInput = {
  AND?: InputMaybe<Array<LegacyCredentialWhereInput>>;
  NOT?: InputMaybe<Array<LegacyCredentialWhereInput>>;
  OR?: InputMaybe<Array<LegacyCredentialWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  hidden?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  validatorHash?: InputMaybe<StringNullableFilter>;
};

export type LegacyCredentialWhereUniqueInput = {
  AND?: InputMaybe<Array<LegacyCredentialWhereInput>>;
  NOT?: InputMaybe<Array<LegacyCredentialWhereInput>>;
  OR?: InputMaybe<Array<LegacyCredentialWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  hidden?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  validatorHash?: InputMaybe<StringNullableFilter>;
};

export enum LocationTypeEnum {
  City = 'CITY',
  County = 'COUNTY',
  State = 'STATE'
}

export type MonitoringConfiguration = {
  __typename?: 'MonitoringConfiguration';
  _count?: Maybe<MonitoringConfigurationCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  disputePeriodDays: Scalars['Int']['output'];
  enrollmentStrategy: MonitoringEnrollmentStrategy;
  enrollments: Array<MonitoringEnrollment>;
  expirationPeriodDays?: Maybe<Scalars['Int']['output']>;
  expiresOn?: Maybe<Scalars['DateTimeISO']['output']>;
  frequency: MonitoringFrequency;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  needsSecondaryVerification: Scalars['Boolean']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  packageSet: PackageSet;
  packageSetId: Scalars['String']['output'];
  provider: MonitoringProvider;
  providerMetadata?: Maybe<Scalars['JSON']['output']>;
  reviewStrategy: MonitoringReviewStrategy;
  secondaryVerificationProvider?: Maybe<MonitoringSecondaryVerificationProvider>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type MonitoringConfigurationEnrollmentsArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringEnrollmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringConfigurationAvgAggregate = {
  __typename?: 'MonitoringConfigurationAvgAggregate';
  disputePeriodDays?: Maybe<Scalars['Float']['output']>;
  expirationPeriodDays?: Maybe<Scalars['Float']['output']>;
};

export type MonitoringConfigurationCount = {
  __typename?: 'MonitoringConfigurationCount';
  enrollments: Scalars['Int']['output'];
};


export type MonitoringConfigurationCountEnrollmentsArgs = {
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringConfigurationCountAggregate = {
  __typename?: 'MonitoringConfigurationCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  disputePeriodDays: Scalars['Int']['output'];
  enrollmentStrategy: Scalars['Int']['output'];
  expirationPeriodDays: Scalars['Int']['output'];
  expiresOn: Scalars['Int']['output'];
  frequency: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  needsSecondaryVerification: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  packageSetId: Scalars['Int']['output'];
  provider: Scalars['Int']['output'];
  providerMetadata: Scalars['Int']['output'];
  reviewStrategy: Scalars['Int']['output'];
  secondaryVerificationProvider: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MonitoringConfigurationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  enrollmentStrategy: MonitoringEnrollmentStrategy;
  enrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutConfigurationInput>;
  expirationPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  expiresOn?: InputMaybe<Scalars['DateTimeISO']['input']>;
  frequency?: InputMaybe<MonitoringFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  needsSecondaryVerification?: InputMaybe<Scalars['Boolean']['input']>;
  organization: OrganizationCreateNestedOneWithoutMonitoringConfigurationsInput;
  packageSet: PackageSetCreateNestedOneWithoutMonitoringConfigurationInput;
  provider?: InputMaybe<MonitoringProvider>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy: MonitoringReviewStrategy;
  secondaryVerificationProvider?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringConfigurationCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  enrollmentStrategy: MonitoringEnrollmentStrategy;
  expirationPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  expiresOn?: InputMaybe<Scalars['DateTimeISO']['input']>;
  frequency?: InputMaybe<MonitoringFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  needsSecondaryVerification?: InputMaybe<Scalars['Boolean']['input']>;
  packageSetId: Scalars['String']['input'];
  provider?: InputMaybe<MonitoringProvider>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy: MonitoringReviewStrategy;
  secondaryVerificationProvider?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringConfigurationCreateManyOrganizationInputEnvelope = {
  data: Array<MonitoringConfigurationCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringConfigurationCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<MonitoringConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringConfigurationCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<MonitoringConfigurationCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<MonitoringConfigurationCreateManyOrganizationInputEnvelope>;
};

export type MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput = {
  connect?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringConfigurationCreateOrConnectWithoutEnrollmentsInput>;
  create?: InputMaybe<MonitoringConfigurationCreateWithoutEnrollmentsInput>;
};

export type MonitoringConfigurationCreateNestedOneWithoutPackageSetInput = {
  connect?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringConfigurationCreateOrConnectWithoutPackageSetInput>;
  create?: InputMaybe<MonitoringConfigurationCreateWithoutPackageSetInput>;
};

export type MonitoringConfigurationCreateOrConnectWithoutEnrollmentsInput = {
  create: MonitoringConfigurationCreateWithoutEnrollmentsInput;
  where: MonitoringConfigurationWhereUniqueInput;
};

export type MonitoringConfigurationCreateOrConnectWithoutOrganizationInput = {
  create: MonitoringConfigurationCreateWithoutOrganizationInput;
  where: MonitoringConfigurationWhereUniqueInput;
};

export type MonitoringConfigurationCreateOrConnectWithoutPackageSetInput = {
  create: MonitoringConfigurationCreateWithoutPackageSetInput;
  where: MonitoringConfigurationWhereUniqueInput;
};

export type MonitoringConfigurationCreateWithoutEnrollmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  enrollmentStrategy: MonitoringEnrollmentStrategy;
  expirationPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  expiresOn?: InputMaybe<Scalars['DateTimeISO']['input']>;
  frequency?: InputMaybe<MonitoringFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  needsSecondaryVerification?: InputMaybe<Scalars['Boolean']['input']>;
  organization: OrganizationCreateNestedOneWithoutMonitoringConfigurationsInput;
  packageSet: PackageSetCreateNestedOneWithoutMonitoringConfigurationInput;
  provider?: InputMaybe<MonitoringProvider>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy: MonitoringReviewStrategy;
  secondaryVerificationProvider?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringConfigurationCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  enrollmentStrategy: MonitoringEnrollmentStrategy;
  enrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutConfigurationInput>;
  expirationPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  expiresOn?: InputMaybe<Scalars['DateTimeISO']['input']>;
  frequency?: InputMaybe<MonitoringFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  needsSecondaryVerification?: InputMaybe<Scalars['Boolean']['input']>;
  packageSet: PackageSetCreateNestedOneWithoutMonitoringConfigurationInput;
  provider?: InputMaybe<MonitoringProvider>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy: MonitoringReviewStrategy;
  secondaryVerificationProvider?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringConfigurationCreateWithoutPackageSetInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  enrollmentStrategy: MonitoringEnrollmentStrategy;
  enrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutConfigurationInput>;
  expirationPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  expiresOn?: InputMaybe<Scalars['DateTimeISO']['input']>;
  frequency?: InputMaybe<MonitoringFrequency>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  needsSecondaryVerification?: InputMaybe<Scalars['Boolean']['input']>;
  organization: OrganizationCreateNestedOneWithoutMonitoringConfigurationsInput;
  provider?: InputMaybe<MonitoringProvider>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy: MonitoringReviewStrategy;
  secondaryVerificationProvider?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringConfigurationListRelationFilter = {
  every?: InputMaybe<MonitoringConfigurationWhereInput>;
  none?: InputMaybe<MonitoringConfigurationWhereInput>;
  some?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationMaxAggregate = {
  __typename?: 'MonitoringConfigurationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disputePeriodDays?: Maybe<Scalars['Int']['output']>;
  enrollmentStrategy?: Maybe<MonitoringEnrollmentStrategy>;
  expirationPeriodDays?: Maybe<Scalars['Int']['output']>;
  expiresOn?: Maybe<Scalars['DateTimeISO']['output']>;
  frequency?: Maybe<MonitoringFrequency>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsSecondaryVerification?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSetId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<MonitoringProvider>;
  reviewStrategy?: Maybe<MonitoringReviewStrategy>;
  secondaryVerificationProvider?: Maybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringConfigurationMinAggregate = {
  __typename?: 'MonitoringConfigurationMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disputePeriodDays?: Maybe<Scalars['Int']['output']>;
  enrollmentStrategy?: Maybe<MonitoringEnrollmentStrategy>;
  expirationPeriodDays?: Maybe<Scalars['Int']['output']>;
  expiresOn?: Maybe<Scalars['DateTimeISO']['output']>;
  frequency?: Maybe<MonitoringFrequency>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsSecondaryVerification?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSetId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<MonitoringProvider>;
  reviewStrategy?: Maybe<MonitoringReviewStrategy>;
  secondaryVerificationProvider?: Maybe<MonitoringSecondaryVerificationProvider>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringConfigurationNullableScalarRelationFilter = {
  is?: InputMaybe<MonitoringConfigurationWhereInput>;
  isNot?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MonitoringConfigurationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  disputePeriodDays?: InputMaybe<SortOrder>;
  enrollmentStrategy?: InputMaybe<SortOrder>;
  enrollments?: InputMaybe<MonitoringEnrollmentOrderByRelationAggregateInput>;
  expirationPeriodDays?: InputMaybe<SortOrderInput>;
  expiresOn?: InputMaybe<SortOrderInput>;
  frequency?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  needsSecondaryVerification?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  packageSet?: InputMaybe<PackageSetOrderByWithRelationInput>;
  packageSetId?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  providerMetadata?: InputMaybe<SortOrderInput>;
  reviewStrategy?: InputMaybe<SortOrder>;
  secondaryVerificationProvider?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MonitoringConfigurationScalarFieldEnum {
  CreatedAt = 'createdAt',
  DisputePeriodDays = 'disputePeriodDays',
  EnrollmentStrategy = 'enrollmentStrategy',
  ExpirationPeriodDays = 'expirationPeriodDays',
  ExpiresOn = 'expiresOn',
  Frequency = 'frequency',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  NeedsSecondaryVerification = 'needsSecondaryVerification',
  OrganizationId = 'organizationId',
  PackageSetId = 'packageSetId',
  Provider = 'provider',
  ProviderMetadata = 'providerMetadata',
  ReviewStrategy = 'reviewStrategy',
  SecondaryVerificationProvider = 'secondaryVerificationProvider',
  UpdatedAt = 'updatedAt'
}

export type MonitoringConfigurationScalarRelationFilter = {
  is?: InputMaybe<MonitoringConfigurationWhereInput>;
  isNot?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationScalarWhereInput = {
  AND?: InputMaybe<Array<MonitoringConfigurationScalarWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringConfigurationScalarWhereInput>>;
  OR?: InputMaybe<Array<MonitoringConfigurationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disputePeriodDays?: InputMaybe<IntFilter>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFilter>;
  expirationPeriodDays?: InputMaybe<IntNullableFilter>;
  expiresOn?: InputMaybe<DateTimeNullableFilter>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  needsSecondaryVerification?: InputMaybe<BoolFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumMonitoringProviderFilter>;
  providerMetadata?: InputMaybe<JsonNullableFilter>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFilter>;
  secondaryVerificationProvider?: InputMaybe<EnumMonitoringSecondaryVerificationProviderNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringConfigurationSumAggregate = {
  __typename?: 'MonitoringConfigurationSumAggregate';
  disputePeriodDays?: Maybe<Scalars['Int']['output']>;
  expirationPeriodDays?: Maybe<Scalars['Int']['output']>;
};

export type MonitoringConfigurationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disputePeriodDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFieldUpdateOperationsInput>;
  enrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutConfigurationNestedInput>;
  expirationPeriodDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  expiresOn?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  needsSecondaryVerification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringConfigurationsNestedInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutMonitoringConfigurationNestedInput>;
  provider?: InputMaybe<EnumMonitoringProviderFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFieldUpdateOperationsInput>;
  secondaryVerificationProvider?: InputMaybe<NullableEnumMonitoringSecondaryVerificationProviderFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringConfigurationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disputePeriodDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFieldUpdateOperationsInput>;
  expirationPeriodDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  expiresOn?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  needsSecondaryVerification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  provider?: InputMaybe<EnumMonitoringProviderFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFieldUpdateOperationsInput>;
  secondaryVerificationProvider?: InputMaybe<NullableEnumMonitoringSecondaryVerificationProviderFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringConfigurationUpdateManyWithWhereWithoutOrganizationInput = {
  data: MonitoringConfigurationUpdateManyMutationInput;
  where: MonitoringConfigurationScalarWhereInput;
};

export type MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<MonitoringConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringConfigurationCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<MonitoringConfigurationCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<MonitoringConfigurationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringConfigurationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringConfigurationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringConfigurationWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringConfigurationWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringConfigurationUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<MonitoringConfigurationUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<MonitoringConfigurationUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput = {
  connect?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringConfigurationCreateOrConnectWithoutEnrollmentsInput>;
  create?: InputMaybe<MonitoringConfigurationCreateWithoutEnrollmentsInput>;
  update?: InputMaybe<MonitoringConfigurationUpdateToOneWithWhereWithoutEnrollmentsInput>;
  upsert?: InputMaybe<MonitoringConfigurationUpsertWithoutEnrollmentsInput>;
};

export type MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput = {
  connect?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringConfigurationCreateOrConnectWithoutPackageSetInput>;
  create?: InputMaybe<MonitoringConfigurationCreateWithoutPackageSetInput>;
  delete?: InputMaybe<MonitoringConfigurationWhereInput>;
  disconnect?: InputMaybe<MonitoringConfigurationWhereInput>;
  update?: InputMaybe<MonitoringConfigurationUpdateToOneWithWhereWithoutPackageSetInput>;
  upsert?: InputMaybe<MonitoringConfigurationUpsertWithoutPackageSetInput>;
};

export type MonitoringConfigurationUpdateToOneWithWhereWithoutEnrollmentsInput = {
  data: MonitoringConfigurationUpdateWithoutEnrollmentsInput;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationUpdateToOneWithWhereWithoutPackageSetInput = {
  data: MonitoringConfigurationUpdateWithoutPackageSetInput;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: MonitoringConfigurationUpdateWithoutOrganizationInput;
  where: MonitoringConfigurationWhereUniqueInput;
};

export type MonitoringConfigurationUpdateWithoutEnrollmentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disputePeriodDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFieldUpdateOperationsInput>;
  expirationPeriodDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  expiresOn?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  needsSecondaryVerification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringConfigurationsNestedInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutMonitoringConfigurationNestedInput>;
  provider?: InputMaybe<EnumMonitoringProviderFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFieldUpdateOperationsInput>;
  secondaryVerificationProvider?: InputMaybe<NullableEnumMonitoringSecondaryVerificationProviderFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringConfigurationUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disputePeriodDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFieldUpdateOperationsInput>;
  enrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutConfigurationNestedInput>;
  expirationPeriodDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  expiresOn?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  needsSecondaryVerification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutMonitoringConfigurationNestedInput>;
  provider?: InputMaybe<EnumMonitoringProviderFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFieldUpdateOperationsInput>;
  secondaryVerificationProvider?: InputMaybe<NullableEnumMonitoringSecondaryVerificationProviderFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringConfigurationUpdateWithoutPackageSetInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disputePeriodDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFieldUpdateOperationsInput>;
  enrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutConfigurationNestedInput>;
  expirationPeriodDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  expiresOn?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  needsSecondaryVerification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringConfigurationsNestedInput>;
  provider?: InputMaybe<EnumMonitoringProviderFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFieldUpdateOperationsInput>;
  secondaryVerificationProvider?: InputMaybe<NullableEnumMonitoringSecondaryVerificationProviderFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringConfigurationUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: MonitoringConfigurationCreateWithoutOrganizationInput;
  update: MonitoringConfigurationUpdateWithoutOrganizationInput;
  where: MonitoringConfigurationWhereUniqueInput;
};

export type MonitoringConfigurationUpsertWithoutEnrollmentsInput = {
  create: MonitoringConfigurationCreateWithoutEnrollmentsInput;
  update: MonitoringConfigurationUpdateWithoutEnrollmentsInput;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationUpsertWithoutPackageSetInput = {
  create: MonitoringConfigurationCreateWithoutPackageSetInput;
  update: MonitoringConfigurationUpdateWithoutPackageSetInput;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};

export type MonitoringConfigurationWhereInput = {
  AND?: InputMaybe<Array<MonitoringConfigurationWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringConfigurationWhereInput>>;
  OR?: InputMaybe<Array<MonitoringConfigurationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disputePeriodDays?: InputMaybe<IntFilter>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFilter>;
  enrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  expirationPeriodDays?: InputMaybe<IntNullableFilter>;
  expiresOn?: InputMaybe<DateTimeNullableFilter>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  needsSecondaryVerification?: InputMaybe<BoolFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSet?: InputMaybe<PackageSetScalarRelationFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<EnumMonitoringProviderFilter>;
  providerMetadata?: InputMaybe<JsonNullableFilter>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFilter>;
  secondaryVerificationProvider?: InputMaybe<EnumMonitoringSecondaryVerificationProviderNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringConfigurationWhereUniqueInput = {
  AND?: InputMaybe<Array<MonitoringConfigurationWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringConfigurationWhereInput>>;
  OR?: InputMaybe<Array<MonitoringConfigurationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disputePeriodDays?: InputMaybe<IntFilter>;
  enrollmentStrategy?: InputMaybe<EnumMonitoringEnrollmentStrategyFilter>;
  enrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  expirationPeriodDays?: InputMaybe<IntNullableFilter>;
  expiresOn?: InputMaybe<DateTimeNullableFilter>;
  frequency?: InputMaybe<EnumMonitoringFrequencyFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  needsSecondaryVerification?: InputMaybe<BoolFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSet?: InputMaybe<PackageSetScalarRelationFilter>;
  packageSetId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<EnumMonitoringProviderFilter>;
  providerMetadata?: InputMaybe<JsonNullableFilter>;
  reviewStrategy?: InputMaybe<EnumMonitoringReviewStrategyFilter>;
  secondaryVerificationProvider?: InputMaybe<EnumMonitoringSecondaryVerificationProviderNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringCycle = {
  __typename?: 'MonitoringCycle';
  _count?: Maybe<MonitoringCycleCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  cycleNumber: Scalars['Int']['output'];
  deltas: Array<MonitoringDelta>;
  endDate: Scalars['DateTimeISO']['output'];
  enrollment: MonitoringEnrollment;
  enrollmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  receivedAt: Scalars['DateTimeISO']['output'];
  report?: Maybe<MonitoringReport>;
  startDate: Scalars['DateTimeISO']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type MonitoringCycleDeltasArgs = {
  cursor?: InputMaybe<MonitoringDeltaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringDeltaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringDeltaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type MonitoringCycleReportArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringCycleAvgAggregate = {
  __typename?: 'MonitoringCycleAvgAggregate';
  cycleNumber?: Maybe<Scalars['Float']['output']>;
};

export type MonitoringCycleCount = {
  __typename?: 'MonitoringCycleCount';
  deltas: Scalars['Int']['output'];
};


export type MonitoringCycleCountDeltasArgs = {
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};

export type MonitoringCycleCountAggregate = {
  __typename?: 'MonitoringCycleCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  cycleNumber: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  enrollmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  processedAt: Scalars['Int']['output'];
  receivedAt: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MonitoringCycleCreateManyEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycleNumber: Scalars['Int']['input'];
  endDate: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  receivedAt: Scalars['DateTimeISO']['input'];
  startDate: Scalars['DateTimeISO']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringCycleCreateManyEnrollmentInputEnvelope = {
  data: Array<MonitoringCycleCreateManyEnrollmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringCycleCreateNestedManyWithoutEnrollmentInput = {
  connect?: InputMaybe<Array<MonitoringCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringCycleCreateOrConnectWithoutEnrollmentInput>>;
  create?: InputMaybe<Array<MonitoringCycleCreateWithoutEnrollmentInput>>;
  createMany?: InputMaybe<MonitoringCycleCreateManyEnrollmentInputEnvelope>;
};

export type MonitoringCycleCreateNestedOneWithoutDeltasInput = {
  connect?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringCycleCreateOrConnectWithoutDeltasInput>;
  create?: InputMaybe<MonitoringCycleCreateWithoutDeltasInput>;
};

export type MonitoringCycleCreateNestedOneWithoutReportInput = {
  connect?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringCycleCreateOrConnectWithoutReportInput>;
  create?: InputMaybe<MonitoringCycleCreateWithoutReportInput>;
};

export type MonitoringCycleCreateOrConnectWithoutDeltasInput = {
  create: MonitoringCycleCreateWithoutDeltasInput;
  where: MonitoringCycleWhereUniqueInput;
};

export type MonitoringCycleCreateOrConnectWithoutEnrollmentInput = {
  create: MonitoringCycleCreateWithoutEnrollmentInput;
  where: MonitoringCycleWhereUniqueInput;
};

export type MonitoringCycleCreateOrConnectWithoutReportInput = {
  create: MonitoringCycleCreateWithoutReportInput;
  where: MonitoringCycleWhereUniqueInput;
};

export type MonitoringCycleCreateWithoutDeltasInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycleNumber: Scalars['Int']['input'];
  endDate: Scalars['DateTimeISO']['input'];
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutCyclesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  receivedAt: Scalars['DateTimeISO']['input'];
  report?: InputMaybe<MonitoringReportCreateNestedOneWithoutCycleInput>;
  startDate: Scalars['DateTimeISO']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringCycleCreateWithoutEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycleNumber: Scalars['Int']['input'];
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutCycleInput>;
  endDate: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  receivedAt: Scalars['DateTimeISO']['input'];
  report?: InputMaybe<MonitoringReportCreateNestedOneWithoutCycleInput>;
  startDate: Scalars['DateTimeISO']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringCycleCreateWithoutReportInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycleNumber: Scalars['Int']['input'];
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutCycleInput>;
  endDate: Scalars['DateTimeISO']['input'];
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutCyclesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  receivedAt: Scalars['DateTimeISO']['input'];
  startDate: Scalars['DateTimeISO']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringCycleEnrollmentIdCycleNumberCompoundUniqueInput = {
  cycleNumber: Scalars['Int']['input'];
  enrollmentId: Scalars['String']['input'];
};

export type MonitoringCycleListRelationFilter = {
  every?: InputMaybe<MonitoringCycleWhereInput>;
  none?: InputMaybe<MonitoringCycleWhereInput>;
  some?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleMaxAggregate = {
  __typename?: 'MonitoringCycleMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTimeISO']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  receivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringCycleMinAggregate = {
  __typename?: 'MonitoringCycleMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cycleNumber?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTimeISO']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  receivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringCycleNullableScalarRelationFilter = {
  is?: InputMaybe<MonitoringCycleWhereInput>;
  isNot?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MonitoringCycleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycleNumber?: InputMaybe<SortOrder>;
  deltas?: InputMaybe<MonitoringDeltaOrderByRelationAggregateInput>;
  endDate?: InputMaybe<SortOrder>;
  enrollment?: InputMaybe<MonitoringEnrollmentOrderByWithRelationInput>;
  enrollmentId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  processedAt?: InputMaybe<SortOrderInput>;
  receivedAt?: InputMaybe<SortOrder>;
  report?: InputMaybe<MonitoringReportOrderByWithRelationInput>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MonitoringCycleScalarFieldEnum {
  CreatedAt = 'createdAt',
  CycleNumber = 'cycleNumber',
  EndDate = 'endDate',
  EnrollmentId = 'enrollmentId',
  Id = 'id',
  Metadata = 'metadata',
  ProcessedAt = 'processedAt',
  ReceivedAt = 'receivedAt',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type MonitoringCycleScalarRelationFilter = {
  is?: InputMaybe<MonitoringCycleWhereInput>;
  isNot?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleScalarWhereInput = {
  AND?: InputMaybe<Array<MonitoringCycleScalarWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringCycleScalarWhereInput>>;
  OR?: InputMaybe<Array<MonitoringCycleScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleNumber?: InputMaybe<IntFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  receivedAt?: InputMaybe<DateTimeFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringCycleSumAggregate = {
  __typename?: 'MonitoringCycleSumAggregate';
  cycleNumber?: Maybe<Scalars['Int']['output']>;
};

export type MonitoringCycleUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  receivedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringCycleUpdateManyWithWhereWithoutEnrollmentInput = {
  data: MonitoringCycleUpdateManyMutationInput;
  where: MonitoringCycleScalarWhereInput;
};

export type MonitoringCycleUpdateManyWithoutEnrollmentNestedInput = {
  connect?: InputMaybe<Array<MonitoringCycleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringCycleCreateOrConnectWithoutEnrollmentInput>>;
  create?: InputMaybe<Array<MonitoringCycleCreateWithoutEnrollmentInput>>;
  createMany?: InputMaybe<MonitoringCycleCreateManyEnrollmentInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringCycleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringCycleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringCycleWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringCycleWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringCycleUpdateWithWhereUniqueWithoutEnrollmentInput>>;
  updateMany?: InputMaybe<Array<MonitoringCycleUpdateManyWithWhereWithoutEnrollmentInput>>;
  upsert?: InputMaybe<Array<MonitoringCycleUpsertWithWhereUniqueWithoutEnrollmentInput>>;
};

export type MonitoringCycleUpdateOneRequiredWithoutReportNestedInput = {
  connect?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringCycleCreateOrConnectWithoutReportInput>;
  create?: InputMaybe<MonitoringCycleCreateWithoutReportInput>;
  update?: InputMaybe<MonitoringCycleUpdateToOneWithWhereWithoutReportInput>;
  upsert?: InputMaybe<MonitoringCycleUpsertWithoutReportInput>;
};

export type MonitoringCycleUpdateOneWithoutDeltasNestedInput = {
  connect?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringCycleCreateOrConnectWithoutDeltasInput>;
  create?: InputMaybe<MonitoringCycleCreateWithoutDeltasInput>;
  delete?: InputMaybe<MonitoringCycleWhereInput>;
  disconnect?: InputMaybe<MonitoringCycleWhereInput>;
  update?: InputMaybe<MonitoringCycleUpdateToOneWithWhereWithoutDeltasInput>;
  upsert?: InputMaybe<MonitoringCycleUpsertWithoutDeltasInput>;
};

export type MonitoringCycleUpdateToOneWithWhereWithoutDeltasInput = {
  data: MonitoringCycleUpdateWithoutDeltasInput;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleUpdateToOneWithWhereWithoutReportInput = {
  data: MonitoringCycleUpdateWithoutReportInput;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleUpdateWithWhereUniqueWithoutEnrollmentInput = {
  data: MonitoringCycleUpdateWithoutEnrollmentInput;
  where: MonitoringCycleWhereUniqueInput;
};

export type MonitoringCycleUpdateWithoutDeltasInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutCyclesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  receivedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  report?: InputMaybe<MonitoringReportUpdateOneWithoutCycleNestedInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringCycleUpdateWithoutEnrollmentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutCycleNestedInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  receivedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  report?: InputMaybe<MonitoringReportUpdateOneWithoutCycleNestedInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringCycleUpdateWithoutReportInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycleNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutCycleNestedInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutCyclesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  receivedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringCycleUpsertWithWhereUniqueWithoutEnrollmentInput = {
  create: MonitoringCycleCreateWithoutEnrollmentInput;
  update: MonitoringCycleUpdateWithoutEnrollmentInput;
  where: MonitoringCycleWhereUniqueInput;
};

export type MonitoringCycleUpsertWithoutDeltasInput = {
  create: MonitoringCycleCreateWithoutDeltasInput;
  update: MonitoringCycleUpdateWithoutDeltasInput;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleUpsertWithoutReportInput = {
  create: MonitoringCycleCreateWithoutReportInput;
  update: MonitoringCycleUpdateWithoutReportInput;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};

export type MonitoringCycleWhereInput = {
  AND?: InputMaybe<Array<MonitoringCycleWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringCycleWhereInput>>;
  OR?: InputMaybe<Array<MonitoringCycleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleNumber?: InputMaybe<IntFilter>;
  deltas?: InputMaybe<MonitoringDeltaListRelationFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  enrollment?: InputMaybe<MonitoringEnrollmentScalarRelationFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  receivedAt?: InputMaybe<DateTimeFilter>;
  report?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringCycleWhereUniqueInput = {
  AND?: InputMaybe<Array<MonitoringCycleWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringCycleWhereInput>>;
  OR?: InputMaybe<Array<MonitoringCycleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleNumber?: InputMaybe<IntFilter>;
  deltas?: InputMaybe<MonitoringDeltaListRelationFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  enrollment?: InputMaybe<MonitoringEnrollmentScalarRelationFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  enrollmentId_cycleNumber?: InputMaybe<MonitoringCycleEnrollmentIdCycleNumberCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  receivedAt?: InputMaybe<DateTimeFilter>;
  report?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringDelta = {
  __typename?: 'MonitoringDelta';
  createdAt: Scalars['DateTimeISO']['output'];
  cycle?: Maybe<MonitoringCycle>;
  cycleId?: Maybe<Scalars['String']['output']>;
  enrollment: MonitoringEnrollment;
  enrollmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  normalized: Scalars['JSON']['output'];
  providerRequestId: Scalars['String']['output'];
  rawData: Scalars['JSON']['output'];
  report?: Maybe<MonitoringReport>;
  reportId?: Maybe<Scalars['String']['output']>;
  searchType: ResultSearchType;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type MonitoringDeltaCycleArgs = {
  where?: InputMaybe<MonitoringCycleWhereInput>;
};


export type MonitoringDeltaReportArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringDeltaCountAggregate = {
  __typename?: 'MonitoringDeltaCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  cycleId: Scalars['Int']['output'];
  enrollmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  normalized: Scalars['Int']['output'];
  providerRequestId: Scalars['Int']['output'];
  rawData: Scalars['Int']['output'];
  reportId: Scalars['Int']['output'];
  searchType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MonitoringDeltaCreateManyCycleInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  normalized: Scalars['JSON']['input'];
  providerRequestId: Scalars['String']['input'];
  rawData: Scalars['JSON']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<ResultSearchType>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringDeltaCreateManyCycleInputEnvelope = {
  data: Array<MonitoringDeltaCreateManyCycleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringDeltaCreateManyEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized: Scalars['JSON']['input'];
  providerRequestId: Scalars['String']['input'];
  rawData: Scalars['JSON']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<ResultSearchType>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringDeltaCreateManyEnrollmentInputEnvelope = {
  data: Array<MonitoringDeltaCreateManyEnrollmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringDeltaCreateManyReportInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycleId?: InputMaybe<Scalars['String']['input']>;
  enrollmentId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  normalized: Scalars['JSON']['input'];
  providerRequestId: Scalars['String']['input'];
  rawData: Scalars['JSON']['input'];
  searchType?: InputMaybe<ResultSearchType>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringDeltaCreateManyReportInputEnvelope = {
  data: Array<MonitoringDeltaCreateManyReportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringDeltaCreateNestedManyWithoutCycleInput = {
  connect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringDeltaCreateOrConnectWithoutCycleInput>>;
  create?: InputMaybe<Array<MonitoringDeltaCreateWithoutCycleInput>>;
  createMany?: InputMaybe<MonitoringDeltaCreateManyCycleInputEnvelope>;
};

export type MonitoringDeltaCreateNestedManyWithoutEnrollmentInput = {
  connect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringDeltaCreateOrConnectWithoutEnrollmentInput>>;
  create?: InputMaybe<Array<MonitoringDeltaCreateWithoutEnrollmentInput>>;
  createMany?: InputMaybe<MonitoringDeltaCreateManyEnrollmentInputEnvelope>;
};

export type MonitoringDeltaCreateNestedManyWithoutReportInput = {
  connect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringDeltaCreateOrConnectWithoutReportInput>>;
  create?: InputMaybe<Array<MonitoringDeltaCreateWithoutReportInput>>;
  createMany?: InputMaybe<MonitoringDeltaCreateManyReportInputEnvelope>;
};

export type MonitoringDeltaCreateOrConnectWithoutCycleInput = {
  create: MonitoringDeltaCreateWithoutCycleInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaCreateOrConnectWithoutEnrollmentInput = {
  create: MonitoringDeltaCreateWithoutEnrollmentInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaCreateOrConnectWithoutReportInput = {
  create: MonitoringDeltaCreateWithoutReportInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaCreateWithoutCycleInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutDeltasInput;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized: Scalars['JSON']['input'];
  providerRequestId: Scalars['String']['input'];
  rawData: Scalars['JSON']['input'];
  report?: InputMaybe<MonitoringReportCreateNestedOneWithoutDeltasInput>;
  searchType?: InputMaybe<ResultSearchType>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringDeltaCreateWithoutEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycle?: InputMaybe<MonitoringCycleCreateNestedOneWithoutDeltasInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized: Scalars['JSON']['input'];
  providerRequestId: Scalars['String']['input'];
  rawData: Scalars['JSON']['input'];
  report?: InputMaybe<MonitoringReportCreateNestedOneWithoutDeltasInput>;
  searchType?: InputMaybe<ResultSearchType>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringDeltaCreateWithoutReportInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycle?: InputMaybe<MonitoringCycleCreateNestedOneWithoutDeltasInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutDeltasInput;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized: Scalars['JSON']['input'];
  providerRequestId: Scalars['String']['input'];
  rawData: Scalars['JSON']['input'];
  searchType?: InputMaybe<ResultSearchType>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringDeltaEnrollmentIdProviderRequestIdSearchTypeCompoundUniqueInput = {
  enrollmentId: Scalars['String']['input'];
  providerRequestId: Scalars['String']['input'];
  searchType: ResultSearchType;
};

export type MonitoringDeltaListRelationFilter = {
  every?: InputMaybe<MonitoringDeltaWhereInput>;
  none?: InputMaybe<MonitoringDeltaWhereInput>;
  some?: InputMaybe<MonitoringDeltaWhereInput>;
};

export type MonitoringDeltaMaxAggregate = {
  __typename?: 'MonitoringDeltaMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  providerRequestId?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<ResultSearchType>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringDeltaMinAggregate = {
  __typename?: 'MonitoringDeltaMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  providerRequestId?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  searchType?: Maybe<ResultSearchType>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringDeltaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MonitoringDeltaOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  cycle?: InputMaybe<MonitoringCycleOrderByWithRelationInput>;
  cycleId?: InputMaybe<SortOrderInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentOrderByWithRelationInput>;
  enrollmentId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  normalized?: InputMaybe<SortOrder>;
  providerRequestId?: InputMaybe<SortOrder>;
  rawData?: InputMaybe<SortOrder>;
  report?: InputMaybe<MonitoringReportOrderByWithRelationInput>;
  reportId?: InputMaybe<SortOrderInput>;
  searchType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MonitoringDeltaScalarFieldEnum {
  CreatedAt = 'createdAt',
  CycleId = 'cycleId',
  EnrollmentId = 'enrollmentId',
  Id = 'id',
  Normalized = 'normalized',
  ProviderRequestId = 'providerRequestId',
  RawData = 'rawData',
  ReportId = 'reportId',
  SearchType = 'searchType',
  UpdatedAt = 'updatedAt'
}

export type MonitoringDeltaScalarWhereInput = {
  AND?: InputMaybe<Array<MonitoringDeltaScalarWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringDeltaScalarWhereInput>>;
  OR?: InputMaybe<Array<MonitoringDeltaScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycleId?: InputMaybe<StringNullableFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  normalized?: InputMaybe<JsonFilter>;
  providerRequestId?: InputMaybe<StringFilter>;
  rawData?: InputMaybe<JsonFilter>;
  reportId?: InputMaybe<StringNullableFilter>;
  searchType?: InputMaybe<EnumResultSearchTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringDeltaUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  providerRequestId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawData?: InputMaybe<Scalars['JSON']['input']>;
  searchType?: InputMaybe<EnumResultSearchTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringDeltaUpdateManyWithWhereWithoutCycleInput = {
  data: MonitoringDeltaUpdateManyMutationInput;
  where: MonitoringDeltaScalarWhereInput;
};

export type MonitoringDeltaUpdateManyWithWhereWithoutEnrollmentInput = {
  data: MonitoringDeltaUpdateManyMutationInput;
  where: MonitoringDeltaScalarWhereInput;
};

export type MonitoringDeltaUpdateManyWithWhereWithoutReportInput = {
  data: MonitoringDeltaUpdateManyMutationInput;
  where: MonitoringDeltaScalarWhereInput;
};

export type MonitoringDeltaUpdateManyWithoutCycleNestedInput = {
  connect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringDeltaCreateOrConnectWithoutCycleInput>>;
  create?: InputMaybe<Array<MonitoringDeltaCreateWithoutCycleInput>>;
  createMany?: InputMaybe<MonitoringDeltaCreateManyCycleInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringDeltaScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringDeltaUpdateWithWhereUniqueWithoutCycleInput>>;
  updateMany?: InputMaybe<Array<MonitoringDeltaUpdateManyWithWhereWithoutCycleInput>>;
  upsert?: InputMaybe<Array<MonitoringDeltaUpsertWithWhereUniqueWithoutCycleInput>>;
};

export type MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput = {
  connect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringDeltaCreateOrConnectWithoutEnrollmentInput>>;
  create?: InputMaybe<Array<MonitoringDeltaCreateWithoutEnrollmentInput>>;
  createMany?: InputMaybe<MonitoringDeltaCreateManyEnrollmentInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringDeltaScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringDeltaUpdateWithWhereUniqueWithoutEnrollmentInput>>;
  updateMany?: InputMaybe<Array<MonitoringDeltaUpdateManyWithWhereWithoutEnrollmentInput>>;
  upsert?: InputMaybe<Array<MonitoringDeltaUpsertWithWhereUniqueWithoutEnrollmentInput>>;
};

export type MonitoringDeltaUpdateManyWithoutReportNestedInput = {
  connect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringDeltaCreateOrConnectWithoutReportInput>>;
  create?: InputMaybe<Array<MonitoringDeltaCreateWithoutReportInput>>;
  createMany?: InputMaybe<MonitoringDeltaCreateManyReportInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringDeltaScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringDeltaWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringDeltaUpdateWithWhereUniqueWithoutReportInput>>;
  updateMany?: InputMaybe<Array<MonitoringDeltaUpdateManyWithWhereWithoutReportInput>>;
  upsert?: InputMaybe<Array<MonitoringDeltaUpsertWithWhereUniqueWithoutReportInput>>;
};

export type MonitoringDeltaUpdateWithWhereUniqueWithoutCycleInput = {
  data: MonitoringDeltaUpdateWithoutCycleInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaUpdateWithWhereUniqueWithoutEnrollmentInput = {
  data: MonitoringDeltaUpdateWithoutEnrollmentInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaUpdateWithWhereUniqueWithoutReportInput = {
  data: MonitoringDeltaUpdateWithoutReportInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaUpdateWithoutCycleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutDeltasNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  providerRequestId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawData?: InputMaybe<Scalars['JSON']['input']>;
  report?: InputMaybe<MonitoringReportUpdateOneWithoutDeltasNestedInput>;
  searchType?: InputMaybe<EnumResultSearchTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringDeltaUpdateWithoutEnrollmentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneWithoutDeltasNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  providerRequestId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawData?: InputMaybe<Scalars['JSON']['input']>;
  report?: InputMaybe<MonitoringReportUpdateOneWithoutDeltasNestedInput>;
  searchType?: InputMaybe<EnumResultSearchTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringDeltaUpdateWithoutReportInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneWithoutDeltasNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutDeltasNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  providerRequestId?: InputMaybe<StringFieldUpdateOperationsInput>;
  rawData?: InputMaybe<Scalars['JSON']['input']>;
  searchType?: InputMaybe<EnumResultSearchTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringDeltaUpsertWithWhereUniqueWithoutCycleInput = {
  create: MonitoringDeltaCreateWithoutCycleInput;
  update: MonitoringDeltaUpdateWithoutCycleInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaUpsertWithWhereUniqueWithoutEnrollmentInput = {
  create: MonitoringDeltaCreateWithoutEnrollmentInput;
  update: MonitoringDeltaUpdateWithoutEnrollmentInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaUpsertWithWhereUniqueWithoutReportInput = {
  create: MonitoringDeltaCreateWithoutReportInput;
  update: MonitoringDeltaUpdateWithoutReportInput;
  where: MonitoringDeltaWhereUniqueInput;
};

export type MonitoringDeltaWhereInput = {
  AND?: InputMaybe<Array<MonitoringDeltaWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringDeltaWhereInput>>;
  OR?: InputMaybe<Array<MonitoringDeltaWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycle?: InputMaybe<MonitoringCycleNullableScalarRelationFilter>;
  cycleId?: InputMaybe<StringNullableFilter>;
  enrollment?: InputMaybe<MonitoringEnrollmentScalarRelationFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  normalized?: InputMaybe<JsonFilter>;
  providerRequestId?: InputMaybe<StringFilter>;
  rawData?: InputMaybe<JsonFilter>;
  report?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  reportId?: InputMaybe<StringNullableFilter>;
  searchType?: InputMaybe<EnumResultSearchTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringDeltaWhereUniqueInput = {
  AND?: InputMaybe<Array<MonitoringDeltaWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringDeltaWhereInput>>;
  OR?: InputMaybe<Array<MonitoringDeltaWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycle?: InputMaybe<MonitoringCycleNullableScalarRelationFilter>;
  cycleId?: InputMaybe<StringNullableFilter>;
  enrollment?: InputMaybe<MonitoringEnrollmentScalarRelationFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  enrollmentId_providerRequestId_searchType?: InputMaybe<MonitoringDeltaEnrollmentIdProviderRequestIdSearchTypeCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<JsonFilter>;
  providerRequestId?: InputMaybe<StringFilter>;
  rawData?: InputMaybe<JsonFilter>;
  report?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  reportId?: InputMaybe<StringNullableFilter>;
  searchType?: InputMaybe<EnumResultSearchTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringEnrollment = {
  __typename?: 'MonitoringEnrollment';
  _count?: Maybe<MonitoringEnrollmentCount>;
  configuration: MonitoringConfiguration;
  configurationId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  cycles: Array<MonitoringCycle>;
  deltas: Array<MonitoringDelta>;
  disenrolledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrollmentReason?: Maybe<Scalars['String']['output']>;
  disenrollmentRequestedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrollmentRequestedBy?: Maybe<User>;
  disenrollmentRequestedById?: Maybe<Scalars['String']['output']>;
  disenrollmentSource?: Maybe<DisenrollmentSource>;
  disputeDeadline?: Maybe<Scalars['DateTimeISO']['output']>;
  disputes: Array<Dispute>;
  enrolledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['output'];
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  providerEnrollmentId: Scalars['String']['output'];
  providerMetadata?: Maybe<Scalars['JSON']['output']>;
  reports: Array<MonitoringReport>;
  status: MonitoringEnrollmentStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type MonitoringEnrollmentCyclesArgs = {
  cursor?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringCycleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringCycleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};


export type MonitoringEnrollmentDeltasArgs = {
  cursor?: InputMaybe<MonitoringDeltaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringDeltaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringDeltaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type MonitoringEnrollmentDisenrollmentRequestedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type MonitoringEnrollmentDisputesArgs = {
  cursor?: InputMaybe<DisputeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisputeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisputeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type MonitoringEnrollmentReportsArgs = {
  cursor?: InputMaybe<MonitoringReportWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringReportScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringEnrollmentCount = {
  __typename?: 'MonitoringEnrollmentCount';
  cycles: Scalars['Int']['output'];
  deltas: Scalars['Int']['output'];
  disputes: Scalars['Int']['output'];
  reports: Scalars['Int']['output'];
};


export type MonitoringEnrollmentCountCyclesArgs = {
  where?: InputMaybe<MonitoringCycleWhereInput>;
};


export type MonitoringEnrollmentCountDeltasArgs = {
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type MonitoringEnrollmentCountDisputesArgs = {
  where?: InputMaybe<DisputeWhereInput>;
};


export type MonitoringEnrollmentCountReportsArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringEnrollmentCountAggregate = {
  __typename?: 'MonitoringEnrollmentCountAggregate';
  _all: Scalars['Int']['output'];
  configurationId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  disenrolledAt: Scalars['Int']['output'];
  disenrollmentReason: Scalars['Int']['output'];
  disenrollmentRequestedAt: Scalars['Int']['output'];
  disenrollmentRequestedById: Scalars['Int']['output'];
  disenrollmentSource: Scalars['Int']['output'];
  disputeDeadline: Scalars['Int']['output'];
  enrolledAt: Scalars['Int']['output'];
  enrollmentRequestedAt: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  providerEnrollmentId: Scalars['Int']['output'];
  providerMetadata: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type MonitoringEnrollmentCreateManyConfigurationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedById?: InputMaybe<Scalars['String']['input']>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type MonitoringEnrollmentCreateManyConfigurationInputEnvelope = {
  data: Array<MonitoringEnrollmentCreateManyConfigurationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringEnrollmentCreateManyDisenrollmentRequestedByInput = {
  configurationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type MonitoringEnrollmentCreateManyDisenrollmentRequestedByInputEnvelope = {
  data: Array<MonitoringEnrollmentCreateManyDisenrollmentRequestedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringEnrollmentCreateManyOrderInput = {
  configurationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedById?: InputMaybe<Scalars['String']['input']>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type MonitoringEnrollmentCreateManyOrderInputEnvelope = {
  data: Array<MonitoringEnrollmentCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringEnrollmentCreateManyOrganizationInput = {
  configurationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedById?: InputMaybe<Scalars['String']['input']>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type MonitoringEnrollmentCreateManyOrganizationInputEnvelope = {
  data: Array<MonitoringEnrollmentCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringEnrollmentCreateManyUserInput = {
  configurationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedById?: InputMaybe<Scalars['String']['input']>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringEnrollmentCreateManyUserInputEnvelope = {
  data: Array<MonitoringEnrollmentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringEnrollmentCreateNestedManyWithoutConfigurationInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutConfigurationInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutConfigurationInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyConfigurationInputEnvelope>;
};

export type MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutDisenrollmentRequestedByInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutDisenrollmentRequestedByInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyDisenrollmentRequestedByInputEnvelope>;
};

export type MonitoringEnrollmentCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyOrderInputEnvelope>;
};

export type MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyOrganizationInputEnvelope>;
};

export type MonitoringEnrollmentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutUserInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyUserInputEnvelope>;
};

export type MonitoringEnrollmentCreateNestedOneWithoutCyclesInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutCyclesInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutCyclesInput>;
};

export type MonitoringEnrollmentCreateNestedOneWithoutDeltasInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutDeltasInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutDeltasInput>;
};

export type MonitoringEnrollmentCreateNestedOneWithoutDisputesInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutDisputesInput>;
};

export type MonitoringEnrollmentCreateNestedOneWithoutReportsInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutReportsInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutReportsInput>;
};

export type MonitoringEnrollmentCreateOrConnectWithoutConfigurationInput = {
  create: MonitoringEnrollmentCreateWithoutConfigurationInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutCyclesInput = {
  create: MonitoringEnrollmentCreateWithoutCyclesInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutDeltasInput = {
  create: MonitoringEnrollmentCreateWithoutDeltasInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutDisenrollmentRequestedByInput = {
  create: MonitoringEnrollmentCreateWithoutDisenrollmentRequestedByInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutDisputesInput = {
  create: MonitoringEnrollmentCreateWithoutDisputesInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutOrderInput = {
  create: MonitoringEnrollmentCreateWithoutOrderInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutOrganizationInput = {
  create: MonitoringEnrollmentCreateWithoutOrganizationInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutReportsInput = {
  create: MonitoringEnrollmentCreateWithoutReportsInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateOrConnectWithoutUserInput = {
  create: MonitoringEnrollmentCreateWithoutUserInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentCreateWithoutConfigurationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutCyclesInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutDeltasInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutDisenrollmentRequestedByInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutDisputesInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutOrderInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutOrganizationInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutReportsInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutMonitoringEnrollmentsInput;
};

export type MonitoringEnrollmentCreateWithoutUserInput = {
  configuration: MonitoringConfigurationCreateNestedOneWithoutEnrollmentsInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  cycles?: InputMaybe<MonitoringCycleCreateNestedManyWithoutEnrollmentInput>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutEnrollmentInput>;
  disenrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentReason?: InputMaybe<Scalars['String']['input']>;
  disenrollmentRequestedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disenrollmentRequestedBy?: InputMaybe<UserCreateNestedOneWithoutRequestedDisenrollmentsInput>;
  disenrollmentSource?: InputMaybe<DisenrollmentSource>;
  disputeDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutMonitoringEnrollmentInput>;
  enrolledAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enrollmentRequestedAt: Scalars['DateTimeISO']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutMonitoringEnrollmentsInput;
  organization: OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput;
  providerEnrollmentId: Scalars['String']['input'];
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportCreateNestedManyWithoutEnrollmentInput>;
  status: MonitoringEnrollmentStatus;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringEnrollmentListRelationFilter = {
  every?: InputMaybe<MonitoringEnrollmentWhereInput>;
  none?: InputMaybe<MonitoringEnrollmentWhereInput>;
  some?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentMaxAggregate = {
  __typename?: 'MonitoringEnrollmentMaxAggregate';
  configurationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrolledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrollmentReason?: Maybe<Scalars['String']['output']>;
  disenrollmentRequestedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrollmentRequestedById?: Maybe<Scalars['String']['output']>;
  disenrollmentSource?: Maybe<DisenrollmentSource>;
  disputeDeadline?: Maybe<Scalars['DateTimeISO']['output']>;
  enrolledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enrollmentRequestedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  providerEnrollmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MonitoringEnrollmentStatus>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MonitoringEnrollmentMinAggregate = {
  __typename?: 'MonitoringEnrollmentMinAggregate';
  configurationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrolledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrollmentReason?: Maybe<Scalars['String']['output']>;
  disenrollmentRequestedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disenrollmentRequestedById?: Maybe<Scalars['String']['output']>;
  disenrollmentSource?: Maybe<DisenrollmentSource>;
  disputeDeadline?: Maybe<Scalars['DateTimeISO']['output']>;
  enrolledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enrollmentRequestedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  providerEnrollmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MonitoringEnrollmentStatus>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MonitoringEnrollmentNullableScalarRelationFilter = {
  is?: InputMaybe<MonitoringEnrollmentWhereInput>;
  isNot?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MonitoringEnrollmentOrderByWithRelationInput = {
  configuration?: InputMaybe<MonitoringConfigurationOrderByWithRelationInput>;
  configurationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cycles?: InputMaybe<MonitoringCycleOrderByRelationAggregateInput>;
  deltas?: InputMaybe<MonitoringDeltaOrderByRelationAggregateInput>;
  disenrolledAt?: InputMaybe<SortOrderInput>;
  disenrollmentReason?: InputMaybe<SortOrderInput>;
  disenrollmentRequestedAt?: InputMaybe<SortOrderInput>;
  disenrollmentRequestedBy?: InputMaybe<UserOrderByWithRelationInput>;
  disenrollmentRequestedById?: InputMaybe<SortOrderInput>;
  disenrollmentSource?: InputMaybe<SortOrderInput>;
  disputeDeadline?: InputMaybe<SortOrderInput>;
  disputes?: InputMaybe<DisputeOrderByRelationAggregateInput>;
  enrolledAt?: InputMaybe<SortOrderInput>;
  enrollmentRequestedAt?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  providerEnrollmentId?: InputMaybe<SortOrder>;
  providerMetadata?: InputMaybe<SortOrderInput>;
  reports?: InputMaybe<MonitoringReportOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum MonitoringEnrollmentScalarFieldEnum {
  ConfigurationId = 'configurationId',
  CreatedAt = 'createdAt',
  DisenrolledAt = 'disenrolledAt',
  DisenrollmentReason = 'disenrollmentReason',
  DisenrollmentRequestedAt = 'disenrollmentRequestedAt',
  DisenrollmentRequestedById = 'disenrollmentRequestedById',
  DisenrollmentSource = 'disenrollmentSource',
  DisputeDeadline = 'disputeDeadline',
  EnrolledAt = 'enrolledAt',
  EnrollmentRequestedAt = 'enrollmentRequestedAt',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  OrderId = 'orderId',
  OrganizationId = 'organizationId',
  ProviderEnrollmentId = 'providerEnrollmentId',
  ProviderMetadata = 'providerMetadata',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type MonitoringEnrollmentScalarRelationFilter = {
  is?: InputMaybe<MonitoringEnrollmentWhereInput>;
  isNot?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentScalarWhereInput = {
  AND?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  OR?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  configurationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disenrolledAt?: InputMaybe<DateTimeNullableFilter>;
  disenrollmentReason?: InputMaybe<StringNullableFilter>;
  disenrollmentRequestedAt?: InputMaybe<DateTimeNullableFilter>;
  disenrollmentRequestedById?: InputMaybe<StringNullableFilter>;
  disenrollmentSource?: InputMaybe<EnumDisenrollmentSourceNullableFilter>;
  disputeDeadline?: InputMaybe<DateTimeNullableFilter>;
  enrolledAt?: InputMaybe<DateTimeNullableFilter>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  providerEnrollmentId?: InputMaybe<StringFilter>;
  providerMetadata?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum MonitoringEnrollmentStatus {
  Disenrolled = 'DISENROLLED',
  DisenrollmentError = 'DISENROLLMENT_ERROR',
  DisenrollmentPending = 'DISENROLLMENT_PENDING',
  DisenrollmentRequested = 'DISENROLLMENT_REQUESTED',
  EnrolledConfirmationRequested = 'ENROLLED_CONFIRMATION_REQUESTED',
  EnrolledConfirmationReviewAwaiting = 'ENROLLED_CONFIRMATION_REVIEW_AWAITING',
  EnrolledDeltaAwaiting = 'ENROLLED_DELTA_AWAITING',
  EnrolledDeltaReviewAwaiting = 'ENROLLED_DELTA_REVIEW_AWAITING',
  EnrollmentPending = 'ENROLLMENT_PENDING',
  EnrollmentRequested = 'ENROLLMENT_REQUESTED'
}

export enum MonitoringEnrollmentStrategy {
  AdhocClientDecision = 'ADHOC_CLIENT_DECISION',
  Always = 'ALWAYS',
  AutoClientDecision = 'AUTO_CLIENT_DECISION'
}

export type MonitoringEnrollmentUpdateInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringEnrollmentUpdateManyWithWhereWithoutConfigurationInput = {
  data: MonitoringEnrollmentUpdateManyMutationInput;
  where: MonitoringEnrollmentScalarWhereInput;
};

export type MonitoringEnrollmentUpdateManyWithWhereWithoutDisenrollmentRequestedByInput = {
  data: MonitoringEnrollmentUpdateManyMutationInput;
  where: MonitoringEnrollmentScalarWhereInput;
};

export type MonitoringEnrollmentUpdateManyWithWhereWithoutOrderInput = {
  data: MonitoringEnrollmentUpdateManyMutationInput;
  where: MonitoringEnrollmentScalarWhereInput;
};

export type MonitoringEnrollmentUpdateManyWithWhereWithoutOrganizationInput = {
  data: MonitoringEnrollmentUpdateManyMutationInput;
  where: MonitoringEnrollmentScalarWhereInput;
};

export type MonitoringEnrollmentUpdateManyWithWhereWithoutUserInput = {
  data: MonitoringEnrollmentUpdateManyMutationInput;
  where: MonitoringEnrollmentScalarWhereInput;
};

export type MonitoringEnrollmentUpdateManyWithoutConfigurationNestedInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutConfigurationInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutConfigurationInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyConfigurationInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringEnrollmentUpdateWithWhereUniqueWithoutConfigurationInput>>;
  updateMany?: InputMaybe<Array<MonitoringEnrollmentUpdateManyWithWhereWithoutConfigurationInput>>;
  upsert?: InputMaybe<Array<MonitoringEnrollmentUpsertWithWhereUniqueWithoutConfigurationInput>>;
};

export type MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutDisenrollmentRequestedByInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutDisenrollmentRequestedByInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyDisenrollmentRequestedByInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringEnrollmentUpdateWithWhereUniqueWithoutDisenrollmentRequestedByInput>>;
  updateMany?: InputMaybe<Array<MonitoringEnrollmentUpdateManyWithWhereWithoutDisenrollmentRequestedByInput>>;
  upsert?: InputMaybe<Array<MonitoringEnrollmentUpsertWithWhereUniqueWithoutDisenrollmentRequestedByInput>>;
};

export type MonitoringEnrollmentUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringEnrollmentUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<MonitoringEnrollmentUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<MonitoringEnrollmentUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringEnrollmentUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<MonitoringEnrollmentUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<MonitoringEnrollmentUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type MonitoringEnrollmentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringEnrollmentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MonitoringEnrollmentCreateWithoutUserInput>>;
  createMany?: InputMaybe<MonitoringEnrollmentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringEnrollmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringEnrollmentWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringEnrollmentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<MonitoringEnrollmentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<MonitoringEnrollmentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type MonitoringEnrollmentUpdateOneRequiredWithoutCyclesNestedInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutCyclesInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutCyclesInput>;
  update?: InputMaybe<MonitoringEnrollmentUpdateToOneWithWhereWithoutCyclesInput>;
  upsert?: InputMaybe<MonitoringEnrollmentUpsertWithoutCyclesInput>;
};

export type MonitoringEnrollmentUpdateOneRequiredWithoutDeltasNestedInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutDeltasInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutDeltasInput>;
  update?: InputMaybe<MonitoringEnrollmentUpdateToOneWithWhereWithoutDeltasInput>;
  upsert?: InputMaybe<MonitoringEnrollmentUpsertWithoutDeltasInput>;
};

export type MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutReportsInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutReportsInput>;
  update?: InputMaybe<MonitoringEnrollmentUpdateToOneWithWhereWithoutReportsInput>;
  upsert?: InputMaybe<MonitoringEnrollmentUpsertWithoutReportsInput>;
};

export type MonitoringEnrollmentUpdateOneWithoutDisputesNestedInput = {
  connect?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringEnrollmentCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<MonitoringEnrollmentCreateWithoutDisputesInput>;
  delete?: InputMaybe<MonitoringEnrollmentWhereInput>;
  disconnect?: InputMaybe<MonitoringEnrollmentWhereInput>;
  update?: InputMaybe<MonitoringEnrollmentUpdateToOneWithWhereWithoutDisputesInput>;
  upsert?: InputMaybe<MonitoringEnrollmentUpsertWithoutDisputesInput>;
};

export type MonitoringEnrollmentUpdateToOneWithWhereWithoutCyclesInput = {
  data: MonitoringEnrollmentUpdateWithoutCyclesInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpdateToOneWithWhereWithoutDeltasInput = {
  data: MonitoringEnrollmentUpdateWithoutDeltasInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpdateToOneWithWhereWithoutDisputesInput = {
  data: MonitoringEnrollmentUpdateWithoutDisputesInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpdateToOneWithWhereWithoutReportsInput = {
  data: MonitoringEnrollmentUpdateWithoutReportsInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpdateWithWhereUniqueWithoutConfigurationInput = {
  data: MonitoringEnrollmentUpdateWithoutConfigurationInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpdateWithWhereUniqueWithoutDisenrollmentRequestedByInput = {
  data: MonitoringEnrollmentUpdateWithoutDisenrollmentRequestedByInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpdateWithWhereUniqueWithoutOrderInput = {
  data: MonitoringEnrollmentUpdateWithoutOrderInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: MonitoringEnrollmentUpdateWithoutOrganizationInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpdateWithWhereUniqueWithoutUserInput = {
  data: MonitoringEnrollmentUpdateWithoutUserInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpdateWithoutConfigurationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutCyclesInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutDeltasInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutDisenrollmentRequestedByInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutDisputesInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutOrderInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutOrganizationInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutReportsInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
};

export type MonitoringEnrollmentUpdateWithoutUserInput = {
  configuration?: InputMaybe<MonitoringConfigurationUpdateOneRequiredWithoutEnrollmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cycles?: InputMaybe<MonitoringCycleUpdateManyWithoutEnrollmentNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutEnrollmentNestedInput>;
  disenrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disenrollmentRequestedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disenrollmentRequestedBy?: InputMaybe<UserUpdateOneWithoutRequestedDisenrollmentsNestedInput>;
  disenrollmentSource?: InputMaybe<NullableEnumDisenrollmentSourceFieldUpdateOperationsInput>;
  disputeDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutMonitoringEnrollmentNestedInput>;
  enrolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput>;
  providerEnrollmentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  reports?: InputMaybe<MonitoringReportUpdateManyWithoutEnrollmentNestedInput>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringEnrollmentUpsertWithWhereUniqueWithoutConfigurationInput = {
  create: MonitoringEnrollmentCreateWithoutConfigurationInput;
  update: MonitoringEnrollmentUpdateWithoutConfigurationInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpsertWithWhereUniqueWithoutDisenrollmentRequestedByInput = {
  create: MonitoringEnrollmentCreateWithoutDisenrollmentRequestedByInput;
  update: MonitoringEnrollmentUpdateWithoutDisenrollmentRequestedByInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpsertWithWhereUniqueWithoutOrderInput = {
  create: MonitoringEnrollmentCreateWithoutOrderInput;
  update: MonitoringEnrollmentUpdateWithoutOrderInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: MonitoringEnrollmentCreateWithoutOrganizationInput;
  update: MonitoringEnrollmentUpdateWithoutOrganizationInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpsertWithWhereUniqueWithoutUserInput = {
  create: MonitoringEnrollmentCreateWithoutUserInput;
  update: MonitoringEnrollmentUpdateWithoutUserInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};

export type MonitoringEnrollmentUpsertWithoutCyclesInput = {
  create: MonitoringEnrollmentCreateWithoutCyclesInput;
  update: MonitoringEnrollmentUpdateWithoutCyclesInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpsertWithoutDeltasInput = {
  create: MonitoringEnrollmentCreateWithoutDeltasInput;
  update: MonitoringEnrollmentUpdateWithoutDeltasInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpsertWithoutDisputesInput = {
  create: MonitoringEnrollmentCreateWithoutDisputesInput;
  update: MonitoringEnrollmentUpdateWithoutDisputesInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentUpsertWithoutReportsInput = {
  create: MonitoringEnrollmentCreateWithoutReportsInput;
  update: MonitoringEnrollmentUpdateWithoutReportsInput;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};

export type MonitoringEnrollmentWhereInput = {
  AND?: InputMaybe<Array<MonitoringEnrollmentWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringEnrollmentWhereInput>>;
  OR?: InputMaybe<Array<MonitoringEnrollmentWhereInput>>;
  configuration?: InputMaybe<MonitoringConfigurationScalarRelationFilter>;
  configurationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycles?: InputMaybe<MonitoringCycleListRelationFilter>;
  deltas?: InputMaybe<MonitoringDeltaListRelationFilter>;
  disenrolledAt?: InputMaybe<DateTimeNullableFilter>;
  disenrollmentReason?: InputMaybe<StringNullableFilter>;
  disenrollmentRequestedAt?: InputMaybe<DateTimeNullableFilter>;
  disenrollmentRequestedBy?: InputMaybe<UserNullableScalarRelationFilter>;
  disenrollmentRequestedById?: InputMaybe<StringNullableFilter>;
  disenrollmentSource?: InputMaybe<EnumDisenrollmentSourceNullableFilter>;
  disputeDeadline?: InputMaybe<DateTimeNullableFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  enrolledAt?: InputMaybe<DateTimeNullableFilter>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  providerEnrollmentId?: InputMaybe<StringFilter>;
  providerMetadata?: InputMaybe<JsonNullableFilter>;
  reports?: InputMaybe<MonitoringReportListRelationFilter>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MonitoringEnrollmentWhereUniqueInput = {
  AND?: InputMaybe<Array<MonitoringEnrollmentWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringEnrollmentWhereInput>>;
  OR?: InputMaybe<Array<MonitoringEnrollmentWhereInput>>;
  configuration?: InputMaybe<MonitoringConfigurationScalarRelationFilter>;
  configurationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cycles?: InputMaybe<MonitoringCycleListRelationFilter>;
  deltas?: InputMaybe<MonitoringDeltaListRelationFilter>;
  disenrolledAt?: InputMaybe<DateTimeNullableFilter>;
  disenrollmentReason?: InputMaybe<StringNullableFilter>;
  disenrollmentRequestedAt?: InputMaybe<DateTimeNullableFilter>;
  disenrollmentRequestedBy?: InputMaybe<UserNullableScalarRelationFilter>;
  disenrollmentRequestedById?: InputMaybe<StringNullableFilter>;
  disenrollmentSource?: InputMaybe<EnumDisenrollmentSourceNullableFilter>;
  disputeDeadline?: InputMaybe<DateTimeNullableFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  enrolledAt?: InputMaybe<DateTimeNullableFilter>;
  enrollmentRequestedAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  providerEnrollmentId?: InputMaybe<StringFilter>;
  providerMetadata?: InputMaybe<JsonNullableFilter>;
  reports?: InputMaybe<MonitoringReportListRelationFilter>;
  status?: InputMaybe<EnumMonitoringEnrollmentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum MonitoringFrequency {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY'
}

export enum MonitoringProvider {
  Cleara = 'CLEARA'
}

export type MonitoringReport = {
  __typename?: 'MonitoringReport';
  _count?: Maybe<MonitoringReportCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  customScore?: Maybe<Scalars['String']['output']>;
  cycle: MonitoringCycle;
  cycleId: Scalars['String']['output'];
  deltas: Array<MonitoringDelta>;
  dispatchedSearches: Array<DispatchedSearch>;
  enrollment: MonitoringEnrollment;
  enrollmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  normalized?: Maybe<Scalars['JSON']['output']>;
  outcome?: Maybe<MonitoringReportReviewOutcome>;
  pdfs: Array<File>;
  providerFullReport?: Maybe<Scalars['JSON']['output']>;
  providerFullReportNormalized?: Maybe<Scalars['JSON']['output']>;
  requestedSearches: Array<RequestedSearch>;
  results: Array<Result>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  score?: Maybe<MonitoringReportScore>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type MonitoringReportDeltasArgs = {
  cursor?: InputMaybe<MonitoringDeltaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringDeltaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringDeltaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type MonitoringReportDispatchedSearchesArgs = {
  cursor?: InputMaybe<DispatchedSearchWhereUniqueInput>;
  distinct?: InputMaybe<Array<DispatchedSearchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DispatchedSearchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type MonitoringReportPdfsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type MonitoringReportRequestedSearchesArgs = {
  cursor?: InputMaybe<RequestedSearchWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequestedSearchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequestedSearchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type MonitoringReportResultsArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResultWhereInput>;
};

export type MonitoringReportCount = {
  __typename?: 'MonitoringReportCount';
  deltas: Scalars['Int']['output'];
  dispatchedSearches: Scalars['Int']['output'];
  pdfs: Scalars['Int']['output'];
  requestedSearches: Scalars['Int']['output'];
  results: Scalars['Int']['output'];
};


export type MonitoringReportCountDeltasArgs = {
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type MonitoringReportCountDispatchedSearchesArgs = {
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type MonitoringReportCountPdfsArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type MonitoringReportCountRequestedSearchesArgs = {
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type MonitoringReportCountResultsArgs = {
  where?: InputMaybe<ResultWhereInput>;
};

export type MonitoringReportCountAggregate = {
  __typename?: 'MonitoringReportCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customScore: Scalars['Int']['output'];
  cycleId: Scalars['Int']['output'];
  enrollmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalNotes: Scalars['Int']['output'];
  normalized: Scalars['Int']['output'];
  outcome: Scalars['Int']['output'];
  providerFullReport: Scalars['Int']['output'];
  providerFullReportNormalized: Scalars['Int']['output'];
  reviewNotes: Scalars['Int']['output'];
  reviewStatus: Scalars['Int']['output'];
  reviewedAt: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MonitoringReportCreateManyEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycleId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateManyEnrollmentInputEnvelope = {
  data: Array<MonitoringReportCreateManyEnrollmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MonitoringReportCreateNestedManyWithoutEnrollmentInput = {
  connect?: InputMaybe<Array<MonitoringReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringReportCreateOrConnectWithoutEnrollmentInput>>;
  create?: InputMaybe<Array<MonitoringReportCreateWithoutEnrollmentInput>>;
  createMany?: InputMaybe<MonitoringReportCreateManyEnrollmentInputEnvelope>;
};

export type MonitoringReportCreateNestedOneWithoutCycleInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutCycleInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutCycleInput>;
};

export type MonitoringReportCreateNestedOneWithoutDeltasInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutDeltasInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutDeltasInput>;
};

export type MonitoringReportCreateNestedOneWithoutDispatchedSearchesInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutDispatchedSearchesInput>;
};

export type MonitoringReportCreateNestedOneWithoutPdfsInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutPdfsInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutPdfsInput>;
};

export type MonitoringReportCreateNestedOneWithoutRequestedSearchesInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutRequestedSearchesInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutRequestedSearchesInput>;
};

export type MonitoringReportCreateNestedOneWithoutResultsInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutResultsInput>;
};

export type MonitoringReportCreateOrConnectWithoutCycleInput = {
  create: MonitoringReportCreateWithoutCycleInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateOrConnectWithoutDeltasInput = {
  create: MonitoringReportCreateWithoutDeltasInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateOrConnectWithoutDispatchedSearchesInput = {
  create: MonitoringReportCreateWithoutDispatchedSearchesInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateOrConnectWithoutEnrollmentInput = {
  create: MonitoringReportCreateWithoutEnrollmentInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateOrConnectWithoutPdfsInput = {
  create: MonitoringReportCreateWithoutPdfsInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateOrConnectWithoutRequestedSearchesInput = {
  create: MonitoringReportCreateWithoutRequestedSearchesInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateOrConnectWithoutResultsInput = {
  create: MonitoringReportCreateWithoutResultsInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportCreateWithoutCycleInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutReportInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutMonitoringReportInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutReportsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  pdfs?: InputMaybe<FileCreateNestedManyWithoutMonitoringReportInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutMonitoringReportInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateWithoutDeltasInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycle: MonitoringCycleCreateNestedOneWithoutReportInput;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutMonitoringReportInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutReportsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  pdfs?: InputMaybe<FileCreateNestedManyWithoutMonitoringReportInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutMonitoringReportInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateWithoutDispatchedSearchesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycle: MonitoringCycleCreateNestedOneWithoutReportInput;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutReportInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutReportsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  pdfs?: InputMaybe<FileCreateNestedManyWithoutMonitoringReportInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutMonitoringReportInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateWithoutEnrollmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycle: MonitoringCycleCreateNestedOneWithoutReportInput;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutReportInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutMonitoringReportInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  pdfs?: InputMaybe<FileCreateNestedManyWithoutMonitoringReportInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutMonitoringReportInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateWithoutPdfsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycle: MonitoringCycleCreateNestedOneWithoutReportInput;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutReportInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutMonitoringReportInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutReportsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutMonitoringReportInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateWithoutRequestedSearchesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycle: MonitoringCycleCreateNestedOneWithoutReportInput;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutReportInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutMonitoringReportInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutReportsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  pdfs?: InputMaybe<FileCreateNestedManyWithoutMonitoringReportInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  results?: InputMaybe<ResultCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportCreateWithoutResultsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  cycle: MonitoringCycleCreateNestedOneWithoutReportInput;
  deltas?: InputMaybe<MonitoringDeltaCreateNestedManyWithoutReportInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutMonitoringReportInput>;
  enrollment: MonitoringEnrollmentCreateNestedOneWithoutReportsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<MonitoringReportReviewOutcome>;
  pdfs?: InputMaybe<FileCreateNestedManyWithoutMonitoringReportInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutMonitoringReportInput>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewStatus: MonitoringReportReviewStatus;
  reviewedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<MonitoringReportScore>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MonitoringReportListRelationFilter = {
  every?: InputMaybe<MonitoringReportWhereInput>;
  none?: InputMaybe<MonitoringReportWhereInput>;
  some?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportMaxAggregate = {
  __typename?: 'MonitoringReportMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customScore?: Maybe<Scalars['String']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<MonitoringReportReviewOutcome>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewStatus?: Maybe<MonitoringReportReviewStatus>;
  reviewedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  score?: Maybe<MonitoringReportScore>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringReportMinAggregate = {
  __typename?: 'MonitoringReportMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  customScore?: Maybe<Scalars['String']['output']>;
  cycleId?: Maybe<Scalars['String']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<MonitoringReportReviewOutcome>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewStatus?: Maybe<MonitoringReportReviewStatus>;
  reviewedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  score?: Maybe<MonitoringReportScore>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MonitoringReportNullableScalarRelationFilter = {
  is?: InputMaybe<MonitoringReportWhereInput>;
  isNot?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MonitoringReportOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customScore?: InputMaybe<SortOrderInput>;
  cycle?: InputMaybe<MonitoringCycleOrderByWithRelationInput>;
  cycleId?: InputMaybe<SortOrder>;
  deltas?: InputMaybe<MonitoringDeltaOrderByRelationAggregateInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchOrderByRelationAggregateInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentOrderByWithRelationInput>;
  enrollmentId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalNotes?: InputMaybe<SortOrderInput>;
  normalized?: InputMaybe<SortOrderInput>;
  outcome?: InputMaybe<SortOrderInput>;
  pdfs?: InputMaybe<FileOrderByRelationAggregateInput>;
  providerFullReport?: InputMaybe<SortOrderInput>;
  providerFullReportNormalized?: InputMaybe<SortOrderInput>;
  requestedSearches?: InputMaybe<RequestedSearchOrderByRelationAggregateInput>;
  results?: InputMaybe<ResultOrderByRelationAggregateInput>;
  reviewNotes?: InputMaybe<SortOrderInput>;
  reviewStatus?: InputMaybe<SortOrder>;
  reviewedAt?: InputMaybe<SortOrderInput>;
  score?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MonitoringReportReviewOutcome {
  Clear = 'CLEAR',
  PendingDisqualified = 'PENDING_DISQUALIFIED'
}

export enum MonitoringReportReviewStatus {
  Completed = 'COMPLETED',
  ConfirmationReceived = 'CONFIRMATION_RECEIVED',
  ConfirmationRequested = 'CONFIRMATION_REQUESTED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum MonitoringReportScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomScore = 'customScore',
  CycleId = 'cycleId',
  EnrollmentId = 'enrollmentId',
  Id = 'id',
  InternalNotes = 'internalNotes',
  Normalized = 'normalized',
  Outcome = 'outcome',
  ProviderFullReport = 'providerFullReport',
  ProviderFullReportNormalized = 'providerFullReportNormalized',
  ReviewNotes = 'reviewNotes',
  ReviewStatus = 'reviewStatus',
  ReviewedAt = 'reviewedAt',
  Score = 'score',
  UpdatedAt = 'updatedAt'
}

export type MonitoringReportScalarWhereInput = {
  AND?: InputMaybe<Array<MonitoringReportScalarWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringReportScalarWhereInput>>;
  OR?: InputMaybe<Array<MonitoringReportScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customScore?: InputMaybe<StringNullableFilter>;
  cycleId?: InputMaybe<StringFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  internalNotes?: InputMaybe<StringNullableFilter>;
  normalized?: InputMaybe<JsonNullableFilter>;
  outcome?: InputMaybe<EnumMonitoringReportReviewOutcomeNullableFilter>;
  providerFullReport?: InputMaybe<JsonNullableFilter>;
  providerFullReportNormalized?: InputMaybe<JsonNullableFilter>;
  reviewNotes?: InputMaybe<StringNullableFilter>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  score?: InputMaybe<EnumMonitoringReportScoreNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum MonitoringReportScore {
  AlertsFound = 'ALERTS_FOUND',
  NoAlertsFound = 'NO_ALERTS_FOUND',
  ReviewRequired = 'REVIEW_REQUIRED'
}

export type MonitoringReportUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateManyWithWhereWithoutEnrollmentInput = {
  data: MonitoringReportUpdateManyMutationInput;
  where: MonitoringReportScalarWhereInput;
};

export type MonitoringReportUpdateManyWithoutEnrollmentNestedInput = {
  connect?: InputMaybe<Array<MonitoringReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MonitoringReportCreateOrConnectWithoutEnrollmentInput>>;
  create?: InputMaybe<Array<MonitoringReportCreateWithoutEnrollmentInput>>;
  createMany?: InputMaybe<MonitoringReportCreateManyEnrollmentInputEnvelope>;
  delete?: InputMaybe<Array<MonitoringReportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MonitoringReportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MonitoringReportWhereUniqueInput>>;
  set?: InputMaybe<Array<MonitoringReportWhereUniqueInput>>;
  update?: InputMaybe<Array<MonitoringReportUpdateWithWhereUniqueWithoutEnrollmentInput>>;
  updateMany?: InputMaybe<Array<MonitoringReportUpdateManyWithWhereWithoutEnrollmentInput>>;
  upsert?: InputMaybe<Array<MonitoringReportUpsertWithWhereUniqueWithoutEnrollmentInput>>;
};

export type MonitoringReportUpdateOneWithoutCycleNestedInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutCycleInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutCycleInput>;
  delete?: InputMaybe<MonitoringReportWhereInput>;
  disconnect?: InputMaybe<MonitoringReportWhereInput>;
  update?: InputMaybe<MonitoringReportUpdateToOneWithWhereWithoutCycleInput>;
  upsert?: InputMaybe<MonitoringReportUpsertWithoutCycleInput>;
};

export type MonitoringReportUpdateOneWithoutDeltasNestedInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutDeltasInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutDeltasInput>;
  delete?: InputMaybe<MonitoringReportWhereInput>;
  disconnect?: InputMaybe<MonitoringReportWhereInput>;
  update?: InputMaybe<MonitoringReportUpdateToOneWithWhereWithoutDeltasInput>;
  upsert?: InputMaybe<MonitoringReportUpsertWithoutDeltasInput>;
};

export type MonitoringReportUpdateOneWithoutDispatchedSearchesNestedInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutDispatchedSearchesInput>;
  delete?: InputMaybe<MonitoringReportWhereInput>;
  disconnect?: InputMaybe<MonitoringReportWhereInput>;
  update?: InputMaybe<MonitoringReportUpdateToOneWithWhereWithoutDispatchedSearchesInput>;
  upsert?: InputMaybe<MonitoringReportUpsertWithoutDispatchedSearchesInput>;
};

export type MonitoringReportUpdateOneWithoutPdfsNestedInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutPdfsInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutPdfsInput>;
  delete?: InputMaybe<MonitoringReportWhereInput>;
  disconnect?: InputMaybe<MonitoringReportWhereInput>;
  update?: InputMaybe<MonitoringReportUpdateToOneWithWhereWithoutPdfsInput>;
  upsert?: InputMaybe<MonitoringReportUpsertWithoutPdfsInput>;
};

export type MonitoringReportUpdateOneWithoutRequestedSearchesNestedInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutRequestedSearchesInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutRequestedSearchesInput>;
  delete?: InputMaybe<MonitoringReportWhereInput>;
  disconnect?: InputMaybe<MonitoringReportWhereInput>;
  update?: InputMaybe<MonitoringReportUpdateToOneWithWhereWithoutRequestedSearchesInput>;
  upsert?: InputMaybe<MonitoringReportUpsertWithoutRequestedSearchesInput>;
};

export type MonitoringReportUpdateOneWithoutResultsNestedInput = {
  connect?: InputMaybe<MonitoringReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MonitoringReportCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<MonitoringReportCreateWithoutResultsInput>;
  delete?: InputMaybe<MonitoringReportWhereInput>;
  disconnect?: InputMaybe<MonitoringReportWhereInput>;
  update?: InputMaybe<MonitoringReportUpdateToOneWithWhereWithoutResultsInput>;
  upsert?: InputMaybe<MonitoringReportUpsertWithoutResultsInput>;
};

export type MonitoringReportUpdateToOneWithWhereWithoutCycleInput = {
  data: MonitoringReportUpdateWithoutCycleInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpdateToOneWithWhereWithoutDeltasInput = {
  data: MonitoringReportUpdateWithoutDeltasInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpdateToOneWithWhereWithoutDispatchedSearchesInput = {
  data: MonitoringReportUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpdateToOneWithWhereWithoutPdfsInput = {
  data: MonitoringReportUpdateWithoutPdfsInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpdateToOneWithWhereWithoutRequestedSearchesInput = {
  data: MonitoringReportUpdateWithoutRequestedSearchesInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpdateToOneWithWhereWithoutResultsInput = {
  data: MonitoringReportUpdateWithoutResultsInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpdateWithWhereUniqueWithoutEnrollmentInput = {
  data: MonitoringReportUpdateWithoutEnrollmentInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportUpdateWithoutCycleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateWithoutDeltasInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateWithoutDispatchedSearchesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateWithoutEnrollmentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateWithoutPdfsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateWithoutRequestedSearchesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  results?: InputMaybe<ResultUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpdateWithoutResultsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cycle?: InputMaybe<MonitoringCycleUpdateOneRequiredWithoutReportNestedInput>;
  deltas?: InputMaybe<MonitoringDeltaUpdateManyWithoutReportNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  enrollment?: InputMaybe<MonitoringEnrollmentUpdateOneRequiredWithoutReportsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  outcome?: InputMaybe<NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput>;
  pdfs?: InputMaybe<FileUpdateManyWithoutMonitoringReportNestedInput>;
  providerFullReport?: InputMaybe<Scalars['JSON']['input']>;
  providerFullReportNormalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutMonitoringReportNestedInput>;
  reviewNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFieldUpdateOperationsInput>;
  reviewedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumMonitoringReportScoreFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MonitoringReportUpsertWithWhereUniqueWithoutEnrollmentInput = {
  create: MonitoringReportCreateWithoutEnrollmentInput;
  update: MonitoringReportUpdateWithoutEnrollmentInput;
  where: MonitoringReportWhereUniqueInput;
};

export type MonitoringReportUpsertWithoutCycleInput = {
  create: MonitoringReportCreateWithoutCycleInput;
  update: MonitoringReportUpdateWithoutCycleInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpsertWithoutDeltasInput = {
  create: MonitoringReportCreateWithoutDeltasInput;
  update: MonitoringReportUpdateWithoutDeltasInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpsertWithoutDispatchedSearchesInput = {
  create: MonitoringReportCreateWithoutDispatchedSearchesInput;
  update: MonitoringReportUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpsertWithoutPdfsInput = {
  create: MonitoringReportCreateWithoutPdfsInput;
  update: MonitoringReportUpdateWithoutPdfsInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpsertWithoutRequestedSearchesInput = {
  create: MonitoringReportCreateWithoutRequestedSearchesInput;
  update: MonitoringReportUpdateWithoutRequestedSearchesInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportUpsertWithoutResultsInput = {
  create: MonitoringReportCreateWithoutResultsInput;
  update: MonitoringReportUpdateWithoutResultsInput;
  where?: InputMaybe<MonitoringReportWhereInput>;
};

export type MonitoringReportWhereInput = {
  AND?: InputMaybe<Array<MonitoringReportWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringReportWhereInput>>;
  OR?: InputMaybe<Array<MonitoringReportWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customScore?: InputMaybe<StringNullableFilter>;
  cycle?: InputMaybe<MonitoringCycleScalarRelationFilter>;
  cycleId?: InputMaybe<StringFilter>;
  deltas?: InputMaybe<MonitoringDeltaListRelationFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  enrollment?: InputMaybe<MonitoringEnrollmentScalarRelationFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  internalNotes?: InputMaybe<StringNullableFilter>;
  normalized?: InputMaybe<JsonNullableFilter>;
  outcome?: InputMaybe<EnumMonitoringReportReviewOutcomeNullableFilter>;
  pdfs?: InputMaybe<FileListRelationFilter>;
  providerFullReport?: InputMaybe<JsonNullableFilter>;
  providerFullReportNormalized?: InputMaybe<JsonNullableFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  results?: InputMaybe<ResultListRelationFilter>;
  reviewNotes?: InputMaybe<StringNullableFilter>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  score?: InputMaybe<EnumMonitoringReportScoreNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MonitoringReportWhereUniqueInput = {
  AND?: InputMaybe<Array<MonitoringReportWhereInput>>;
  NOT?: InputMaybe<Array<MonitoringReportWhereInput>>;
  OR?: InputMaybe<Array<MonitoringReportWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customScore?: InputMaybe<StringNullableFilter>;
  cycle?: InputMaybe<MonitoringCycleScalarRelationFilter>;
  cycleId?: InputMaybe<Scalars['String']['input']>;
  deltas?: InputMaybe<MonitoringDeltaListRelationFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  enrollment?: InputMaybe<MonitoringEnrollmentScalarRelationFilter>;
  enrollmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<StringNullableFilter>;
  normalized?: InputMaybe<JsonNullableFilter>;
  outcome?: InputMaybe<EnumMonitoringReportReviewOutcomeNullableFilter>;
  pdfs?: InputMaybe<FileListRelationFilter>;
  providerFullReport?: InputMaybe<JsonNullableFilter>;
  providerFullReportNormalized?: InputMaybe<JsonNullableFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  results?: InputMaybe<ResultListRelationFilter>;
  reviewNotes?: InputMaybe<StringNullableFilter>;
  reviewStatus?: InputMaybe<EnumMonitoringReportReviewStatusFilter>;
  reviewedAt?: InputMaybe<DateTimeNullableFilter>;
  score?: InputMaybe<EnumMonitoringReportScoreNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum MonitoringReviewStrategy {
  AutoApprove = 'AUTO_APPROVE',
  HumanReviewRequired = 'HUMAN_REVIEW_REQUIRED'
}

export enum MonitoringSecondaryVerificationProvider {
  Cleara = 'CLEARA',
  Tazworks = 'TAZWORKS'
}

export type MultipleSignedUrlFileInputV2 = {
  fileId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite?: Maybe<InviteRes>;
  addBiometricConsentAcceptance: AddBiometricConsentAcceptanceResponse;
  addSecondaryEmail?: Maybe<SimpleResponse>;
  changePrimaryEmail?: Maybe<SimpleResponse>;
  createBeam: Beam;
  createDemoCredential: LegacyCredential;
  createDisclosureAcceptance: DisclosureAcceptance;
  createIdentityRecheckOrder: Order;
  createManyApplicantData: AffectedRowsOutput;
  createManyOrder: StatusResponse;
  createManyPackageAccess: AffectedRowsOutput;
  createManyVIDVoucher?: Maybe<CreateManyVidVoucherRes>;
  createMultipleUploadSignedURL: Array<SignedUrlResponseV2>;
  createOneAddress: Address;
  createOneAppFeedback: AppFeedback;
  createOneApplicantData: ApplicantData;
  createOneBeam: Beam;
  createOneBeamInput: BeamInput;
  createOneBeamInputType: BeamInputType;
  createOneBiometricConsentAcceptance: BiometricConsentAcceptance;
  createOneCredential: Credential;
  createOneCredentialStatus: CredentialStatus;
  createOneCredentialType: CredentialType;
  createOneDisclosure: Disclosure;
  createOneDispatchedSearch: DispatchedSearch;
  createOneDispute: Dispute;
  createOneFile: File;
  createOneHighlySensitiveIdentifier: HighlySensitiveIdentifier;
  createOneIdentificationDocument: IdentificationDocument;
  createOneMonitoringConfiguration: MonitoringConfiguration;
  createOneName: Name;
  createOneOrderNote: OrderNote;
  createOneOrganization: Organization;
  createOneOrganizationRelation: OrganizationRelation;
  createOnePackageAccess: PackageAccess;
  createOnePackageSet: PackageSet;
  createOnePass: Pass;
  createOnePassType: PassType;
  createOnePassport: Passport;
  createOneReportableIdVerificationResult: ReportableIdVerificationResult;
  createOneRequestedSearch: RequestedSearch;
  createOneResult: Result;
  createOneResultRevision: ResultRevision;
  createOneRoleAssignment: RoleAssignment;
  createOneSecret: Secret;
  createOneStateIdentificationCard: StateIdentificationCard;
  createOneSynapseCaseFormation: SynapseCaseFormation;
  createOneSynapseWorkflow: SynapseWorkflow;
  createOneVIDVoucher?: Maybe<CreateOneVidVoucherRes>;
  createOneVIDWebVoucher?: Maybe<CreateOneVidWebVoucherRes>;
  createOneVendorConfiguration: VendorConfiguration;
  createOneWebhook: Webhook;
  createOrder: Order;
  createRegistrationPortalInvite?: Maybe<RegistrationPortalInvite>;
  createReportableResults: StatusResponse;
  createSupportTicket: CreateSupportTicketResponse;
  createUploadSignedURL: SignedUrlResponseV2;
  deleteManyBeamInput: AffectedRowsOutput;
  deleteManyDispatchedSearch: AffectedRowsOutput;
  deleteManyOrder: StatusResponse;
  deleteManyPackageAccess: AffectedRowsOutput;
  deleteManyRequestedSearch: AffectedRowsOutput;
  deleteManyResult: AffectedRowsOutput;
  deleteOneAddress?: Maybe<Address>;
  deleteOneApiKey?: Maybe<ApiKey>;
  deleteOneApplicantData?: Maybe<ApplicantData>;
  deleteOneBeam?: Maybe<Beam>;
  deleteOneBeamInput?: Maybe<BeamInput>;
  deleteOneDisclosure?: Maybe<Disclosure>;
  deleteOneDispatchedSearch?: Maybe<DispatchedSearch>;
  deleteOneFile?: Maybe<File>;
  deleteOneHighlySensitiveIdentifier?: Maybe<HighlySensitiveIdentifier>;
  deleteOneIdentificationDocument?: Maybe<IdentificationDocument>;
  deleteOneName?: Maybe<Name>;
  deleteOneOrder?: Maybe<Order>;
  deleteOneOrderNote?: Maybe<OrderNote>;
  deleteOneOrganization?: Maybe<Organization>;
  deleteOneOrganizationRelation?: Maybe<OrganizationRelation>;
  deleteOnePackageAccess?: Maybe<PackageAccess>;
  deleteOnePassType?: Maybe<PassType>;
  deleteOnePassport?: Maybe<Passport>;
  deleteOneReportableIdVerificationResult?: Maybe<ReportableIdVerificationResult>;
  deleteOneRequestedSearch?: Maybe<RequestedSearch>;
  deleteOneResult?: Maybe<Result>;
  deleteOneSecret?: Maybe<Secret>;
  deleteOneStateIdentificationCard?: Maybe<StateIdentificationCard>;
  deleteOneSynapseCaseFormation?: Maybe<SynapseCaseFormation>;
  deleteOneSynapseWorkflow?: Maybe<SynapseWorkflow>;
  deleteOneVIDVoucher?: Maybe<VidVoucher>;
  deleteOneVendorConfiguration?: Maybe<VendorConfiguration>;
  deleteOneWebhook?: Maybe<Webhook>;
  deleteOrder: Order;
  deleteSecondaryEmail?: Maybe<SimpleResponse>;
  doesUserExist: Scalars['Boolean']['output'];
  downloadInviteExport: Scalars['String']['output'];
  extractBeamDataFromImage?: Maybe<Scalars['JSON']['output']>;
  generateApiKey: GenerateApiKeyResponse;
  generateMonitoringReportPdf: GenerateMonitoringReportPdfResponse;
  generateVIDReportPdf: GenerateVidReportPdfResponse;
  generateVIDWebShortUrl?: Maybe<GenerateShortUrlResponse>;
  optOutVoucher?: Maybe<VidVoucher>;
  reinstateVoucher?: Maybe<VidVoucher>;
  requestInviteExport: Scalars['String']['output'];
  requestMonitoringConfirmationReport: RequestMonitoringConfirmationReportResponse;
  sendApiKeyUnlockVerificationEmail: ApiKeyLockResponse;
  startVidFlow: VidVoucher;
  updateManyApplicantData: AffectedRowsOutput;
  updateManyName: AffectedRowsOutput;
  updateManyOrder: AffectedRowsOutput;
  updateOneAddress?: Maybe<Address>;
  updateOneApiKey?: Maybe<ApiKey>;
  updateOneAppFeedback?: Maybe<AppFeedback>;
  updateOneApplicantData?: Maybe<ApplicantData>;
  updateOneBeam?: Maybe<Beam>;
  updateOneBeamInput?: Maybe<BeamInput>;
  updateOneBeamRun?: Maybe<BeamRun>;
  updateOneCredential?: Maybe<Credential>;
  updateOneCredentialStatus?: Maybe<CredentialStatus>;
  updateOneDisclosure?: Maybe<Disclosure>;
  updateOneDispatchedSearch?: Maybe<DispatchedSearch>;
  updateOneDispute?: Maybe<Dispute>;
  updateOneFile?: Maybe<File>;
  updateOneHighlySensitiveIdentifier?: Maybe<HighlySensitiveIdentifier>;
  updateOneIdentificationDocument?: Maybe<IdentificationDocument>;
  updateOneLegacyCredential?: Maybe<LegacyCredential>;
  updateOneMonitoringConfiguration?: Maybe<MonitoringConfiguration>;
  updateOneMonitoringEnrollment?: Maybe<MonitoringEnrollment>;
  updateOneMonitoringReport?: Maybe<MonitoringReport>;
  updateOneName?: Maybe<Name>;
  updateOneOrder?: Maybe<Order>;
  updateOneOrderNote?: Maybe<OrderNote>;
  updateOneOrganization?: Maybe<Organization>;
  updateOnePackageAccess?: Maybe<PackageAccess>;
  updateOnePackageSet?: Maybe<PackageSet>;
  updateOnePassType?: Maybe<PassType>;
  updateOnePassport?: Maybe<Passport>;
  updateOneReportableIdVerificationResult?: Maybe<ReportableIdVerificationResult>;
  updateOneResult?: Maybe<Result>;
  updateOneSecret?: Maybe<Secret>;
  updateOneStateIdentificationCard?: Maybe<StateIdentificationCard>;
  updateOneSynapseCaseFormation?: Maybe<SynapseCaseFormation>;
  updateOneSynapseWorkflow?: Maybe<SynapseWorkflow>;
  updateOneUser?: Maybe<User>;
  updateOneVIDVoucher?: Maybe<VidVoucher>;
  updateOneVendorConfiguration?: Maybe<VendorConfiguration>;
  updateOneWebhook?: Maybe<Webhook>;
  updateOrder: Order;
  updatePushToken: StatusResponse;
  updateSecondaryEmail?: Maybe<SimpleResponse>;
  updateUser: User;
  updateUserPermissions: UserPermissionsResult;
  updateVoucherEmail?: Maybe<UpdateVoucherEmailRes>;
  upsertOneAddress: Address;
  upsertOneApplicantData: ApplicantData;
  upsertOneName: Name;
  verifyApiKeyUnlock: ApiKeyLockResponse;
};


export type MutationAcceptInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationAddBiometricConsentAcceptanceArgs = {
  biometricConsentAcceptanceId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationAddSecondaryEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChangePrimaryEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateBeamArgs = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  data: BeamTypeCreateInput;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDemoCredentialArgs = {
  credentialName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationCreateDisclosureAcceptanceArgs = {
  data: DisclosureAcceptanceArgs;
};


export type MutationCreateIdentityRecheckOrderArgs = {
  input: CreateIdentityRecheckOrderInput;
};


export type MutationCreateManyApplicantDataArgs = {
  data: Array<ApplicantDataCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyOrderArgs = {
  applicants: Array<Scalars['JSON']['input']>;
  deliveryMethod: OrderDeliveryMethod;
  orderFrom?: InputMaybe<Platform>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationCreateManyPackageAccessArgs = {
  data: Array<PackageAccessCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateManyVidVoucherArgs = {
  data: Array<CreateOneVidVoucherInput>;
};


export type MutationCreateMultipleUploadSignedUrlArgs = {
  files: Array<MultipleSignedUrlFileInputV2>;
};


export type MutationCreateOneAddressArgs = {
  data: AddressCreateInput;
};


export type MutationCreateOneAppFeedbackArgs = {
  data: AppFeedbackCreateInput;
};


export type MutationCreateOneApplicantDataArgs = {
  data: ApplicantDataCreateInput;
};


export type MutationCreateOneBeamArgs = {
  data: BeamCreateInput;
};


export type MutationCreateOneBeamInputArgs = {
  data: BeamInputCreateInput;
};


export type MutationCreateOneBeamInputTypeArgs = {
  data: BeamInputTypeCreateInput;
};


export type MutationCreateOneBiometricConsentAcceptanceArgs = {
  data: BiometricConsentAcceptanceCreateInput;
};


export type MutationCreateOneCredentialArgs = {
  data: CredentialCreateInput;
};


export type MutationCreateOneCredentialStatusArgs = {
  data: CredentialStatusCreateInput;
};


export type MutationCreateOneCredentialTypeArgs = {
  data: CredentialTypeCreateInput;
};


export type MutationCreateOneDisclosureArgs = {
  data: DisclosureCreateInput;
};


export type MutationCreateOneDispatchedSearchArgs = {
  data: DispatchedSearchCreateInput;
};


export type MutationCreateOneDisputeArgs = {
  data: DisputeCreateInput;
};


export type MutationCreateOneFileArgs = {
  data: FileCreateInput;
};


export type MutationCreateOneHighlySensitiveIdentifierArgs = {
  data: HighlySensitiveIdentifierCreateInput;
};


export type MutationCreateOneIdentificationDocumentArgs = {
  data: IdentificationDocumentCreateInput;
};


export type MutationCreateOneMonitoringConfigurationArgs = {
  data: MonitoringConfigurationCreateInput;
};


export type MutationCreateOneNameArgs = {
  data: NameCreateInput;
};


export type MutationCreateOneOrderNoteArgs = {
  data: OrderNoteCreateInput;
};


export type MutationCreateOneOrganizationArgs = {
  data: OrganizationCreateInput;
};


export type MutationCreateOneOrganizationRelationArgs = {
  data: OrganizationRelationCreateInput;
};


export type MutationCreateOnePackageAccessArgs = {
  data: PackageAccessCreateInput;
};


export type MutationCreateOnePackageSetArgs = {
  data: PackageSetCreateInput;
};


export type MutationCreateOnePassArgs = {
  data: PassCreateInput;
};


export type MutationCreateOnePassTypeArgs = {
  data: PassTypeCreateInput;
};


export type MutationCreateOnePassportArgs = {
  data: PassportCreateInput;
};


export type MutationCreateOneReportableIdVerificationResultArgs = {
  data: ReportableIdVerificationResultCreateInput;
};


export type MutationCreateOneRequestedSearchArgs = {
  data: RequestedSearchCreateInput;
};


export type MutationCreateOneResultArgs = {
  data: ResultCreateInput;
};


export type MutationCreateOneResultRevisionArgs = {
  data: ResultRevisionCreateInput;
};


export type MutationCreateOneRoleAssignmentArgs = {
  data: RoleAssignmentCreateInput;
};


export type MutationCreateOneSecretArgs = {
  data: SecretCreateInput;
};


export type MutationCreateOneStateIdentificationCardArgs = {
  data: StateIdentificationCardCreateInput;
};


export type MutationCreateOneSynapseCaseFormationArgs = {
  data: SynapseCaseFormationCreateInput;
};


export type MutationCreateOneSynapseWorkflowArgs = {
  data: SynapseWorkflowCreateInput;
};


export type MutationCreateOneVidVoucherArgs = {
  data: CreateOneVidVoucherInput;
};


export type MutationCreateOneVidWebVoucherArgs = {
  data: CreateOneVidVoucherInput;
};


export type MutationCreateOneVendorConfigurationArgs = {
  data: VendorConfigurationCreateInput;
};


export type MutationCreateOneWebhookArgs = {
  data: WebhookCreateInput;
};


export type MutationCreateOrderArgs = {
  beamData?: InputMaybe<Array<OrderBeamData>>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  data: ExtendedOrderCreateInput;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentModel?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  orderFrom?: InputMaybe<Platform>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRegistrationPortalInviteArgs = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<VIdInviteDeliveryMethodEnum>;
  email: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationCreateReportableResultsArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationCreateSupportTicketArgs = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<SupportTicketPurpose>;
};


export type MutationCreateUploadSignedUrlArgs = {
  fileId: Scalars['String']['input'];
};


export type MutationDeleteManyBeamInputArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};


export type MutationDeleteManyDispatchedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type MutationDeleteManyOrderArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteManyPackageAccessArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type MutationDeleteManyRequestedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type MutationDeleteManyResultArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type MutationDeleteOneAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type MutationDeleteOneApiKeyArgs = {
  where: ApiKeyWhereUniqueInput;
};


export type MutationDeleteOneApplicantDataArgs = {
  where: ApplicantDataWhereUniqueInput;
};


export type MutationDeleteOneBeamArgs = {
  where: BeamWhereUniqueInput;
};


export type MutationDeleteOneBeamInputArgs = {
  where: BeamInputWhereUniqueInput;
};


export type MutationDeleteOneDisclosureArgs = {
  where: DisclosureWhereUniqueInput;
};


export type MutationDeleteOneDispatchedSearchArgs = {
  where: DispatchedSearchWhereUniqueInput;
};


export type MutationDeleteOneFileArgs = {
  where: FileWhereUniqueInput;
};


export type MutationDeleteOneHighlySensitiveIdentifierArgs = {
  where: HighlySensitiveIdentifierWhereUniqueInput;
};


export type MutationDeleteOneIdentificationDocumentArgs = {
  where: IdentificationDocumentWhereUniqueInput;
};


export type MutationDeleteOneNameArgs = {
  where: NameWhereUniqueInput;
};


export type MutationDeleteOneOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeleteOneOrderNoteArgs = {
  where: OrderNoteWhereUniqueInput;
};


export type MutationDeleteOneOrganizationArgs = {
  where: OrganizationWhereUniqueInput;
};


export type MutationDeleteOneOrganizationRelationArgs = {
  where: OrganizationRelationWhereUniqueInput;
};


export type MutationDeleteOnePackageAccessArgs = {
  where: PackageAccessWhereUniqueInput;
};


export type MutationDeleteOnePassTypeArgs = {
  where: PassTypeWhereUniqueInput;
};


export type MutationDeleteOnePassportArgs = {
  where: PassportWhereUniqueInput;
};


export type MutationDeleteOneReportableIdVerificationResultArgs = {
  where: ReportableIdVerificationResultWhereUniqueInput;
};


export type MutationDeleteOneRequestedSearchArgs = {
  where: RequestedSearchWhereUniqueInput;
};


export type MutationDeleteOneResultArgs = {
  where: ResultWhereUniqueInput;
};


export type MutationDeleteOneSecretArgs = {
  where: SecretWhereUniqueInput;
};


export type MutationDeleteOneStateIdentificationCardArgs = {
  where: StateIdentificationCardWhereUniqueInput;
};


export type MutationDeleteOneSynapseCaseFormationArgs = {
  where: SynapseCaseFormationWhereUniqueInput;
};


export type MutationDeleteOneSynapseWorkflowArgs = {
  where: SynapseWorkflowWhereUniqueInput;
};


export type MutationDeleteOneVidVoucherArgs = {
  where: VidVoucherWhereUniqueInput;
};


export type MutationDeleteOneVendorConfigurationArgs = {
  where: VendorConfigurationWhereUniqueInput;
};


export type MutationDeleteOneWebhookArgs = {
  where: WebhookWhereUniqueInput;
};


export type MutationDeleteOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeleteSecondaryEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDoesUserExistArgs = {
  email: Scalars['String']['input'];
};


export type MutationDownloadInviteExportArgs = {
  id: Scalars['String']['input'];
};


export type MutationExtractBeamDataFromImageArgs = {
  backImageUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputTypeId: Scalars['String']['input'];
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateApiKeyArgs = {
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateMonitoringReportPdfArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationGenerateVidReportPdfArgs = {
  resultId: Scalars['String']['input'];
};


export type MutationGenerateVidWebShortUrlArgs = {
  url: Scalars['String']['input'];
};


export type MutationOptOutVoucherArgs = {
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  voucherId: Scalars['String']['input'];
};


export type MutationReinstateVoucherArgs = {
  voucherId: Scalars['String']['input'];
};


export type MutationRequestInviteExportArgs = {
  includeOrganization: Scalars['Boolean']['input'];
  orderBy: Array<VidVoucherOrderByWithRelationInput>;
  requestId: Scalars['String']['input'];
  where: VidVoucherWhereInput;
};


export type MutationRequestMonitoringConfirmationReportArgs = {
  county?: InputMaybe<Scalars['String']['input']>;
  fipsCode?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendApiKeyUnlockVerificationEmailArgs = {
  apiKey: Scalars['String']['input'];
};


export type MutationStartVidFlowArgs = {
  voucherId: Scalars['String']['input'];
};


export type MutationUpdateManyApplicantDataArgs = {
  data: ApplicantDataUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApplicantDataWhereInput>;
};


export type MutationUpdateManyNameArgs = {
  data: NameUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NameWhereInput>;
};


export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationUpdateOneAddressArgs = {
  data: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpdateOneApiKeyArgs = {
  data: ApiKeyUpdateInput;
  where: ApiKeyWhereUniqueInput;
};


export type MutationUpdateOneAppFeedbackArgs = {
  data: AppFeedbackUpdateInput;
  where: AppFeedbackWhereUniqueInput;
};


export type MutationUpdateOneApplicantDataArgs = {
  data: ApplicantDataUpdateInput;
  where: ApplicantDataWhereUniqueInput;
};


export type MutationUpdateOneBeamArgs = {
  data: BeamUpdateInput;
  where: BeamWhereUniqueInput;
};


export type MutationUpdateOneBeamInputArgs = {
  data: BeamInputUpdateInput;
  where: BeamInputWhereUniqueInput;
};


export type MutationUpdateOneBeamRunArgs = {
  data: BeamRunUpdateInput;
  where: BeamRunWhereUniqueInput;
};


export type MutationUpdateOneCredentialArgs = {
  data: CredentialUpdateInput;
  where: CredentialWhereUniqueInput;
};


export type MutationUpdateOneCredentialStatusArgs = {
  data: CredentialStatusUpdateInput;
  where: CredentialStatusWhereUniqueInput;
};


export type MutationUpdateOneDisclosureArgs = {
  data: DisclosureUpdateInput;
  where: DisclosureWhereUniqueInput;
};


export type MutationUpdateOneDispatchedSearchArgs = {
  data: DispatchedSearchUpdateInput;
  where: DispatchedSearchWhereUniqueInput;
};


export type MutationUpdateOneDisputeArgs = {
  data: DisputeUpdateInput;
  where: DisputeWhereUniqueInput;
};


export type MutationUpdateOneFileArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpdateOneHighlySensitiveIdentifierArgs = {
  data: HighlySensitiveIdentifierUpdateInput;
  where: HighlySensitiveIdentifierWhereUniqueInput;
};


export type MutationUpdateOneIdentificationDocumentArgs = {
  data: IdentificationDocumentUpdateInput;
  where: IdentificationDocumentWhereUniqueInput;
};


export type MutationUpdateOneLegacyCredentialArgs = {
  data: LegacyCredentialUpdateInput;
  where: LegacyCredentialWhereUniqueInput;
};


export type MutationUpdateOneMonitoringConfigurationArgs = {
  data: MonitoringConfigurationUpdateInput;
  where: MonitoringConfigurationWhereUniqueInput;
};


export type MutationUpdateOneMonitoringEnrollmentArgs = {
  data: MonitoringEnrollmentUpdateInput;
  where: MonitoringEnrollmentWhereUniqueInput;
};


export type MutationUpdateOneMonitoringReportArgs = {
  data: MonitoringReportUpdateInput;
  where: MonitoringReportWhereUniqueInput;
};


export type MutationUpdateOneNameArgs = {
  data: NameUpdateInput;
  where: NameWhereUniqueInput;
};


export type MutationUpdateOneOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOneOrderNoteArgs = {
  data: OrderNoteUpdateInput;
  where: OrderNoteWhereUniqueInput;
};


export type MutationUpdateOneOrganizationArgs = {
  data: OrganizationUpdateInput;
  where: OrganizationWhereUniqueInput;
};


export type MutationUpdateOnePackageAccessArgs = {
  data: PackageAccessUpdateInput;
  where: PackageAccessWhereUniqueInput;
};


export type MutationUpdateOnePackageSetArgs = {
  data: PackageSetUpdateInput;
  where: PackageSetWhereUniqueInput;
};


export type MutationUpdateOnePassTypeArgs = {
  data: PassTypeUpdateInput;
  where: PassTypeWhereUniqueInput;
};


export type MutationUpdateOnePassportArgs = {
  data: PassportUpdateInput;
  where: PassportWhereUniqueInput;
};


export type MutationUpdateOneReportableIdVerificationResultArgs = {
  data: ReportableIdVerificationResultUpdateInput;
  where: ReportableIdVerificationResultWhereUniqueInput;
};


export type MutationUpdateOneResultArgs = {
  data: ResultUpdateInput;
  where: ResultWhereUniqueInput;
};


export type MutationUpdateOneSecretArgs = {
  data: SecretUpdateInput;
  where: SecretWhereUniqueInput;
};


export type MutationUpdateOneStateIdentificationCardArgs = {
  data: StateIdentificationCardUpdateInput;
  where: StateIdentificationCardWhereUniqueInput;
};


export type MutationUpdateOneSynapseCaseFormationArgs = {
  data: SynapseCaseFormationUpdateInput;
  where: SynapseCaseFormationWhereUniqueInput;
};


export type MutationUpdateOneSynapseWorkflowArgs = {
  data: SynapseWorkflowUpdateInput;
  where: SynapseWorkflowWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneVidVoucherArgs = {
  data: VidVoucherUpdateInput;
  where: VidVoucherWhereUniqueInput;
};


export type MutationUpdateOneVendorConfigurationArgs = {
  data: VendorConfigurationUpdateInput;
  where: VendorConfigurationWhereUniqueInput;
};


export type MutationUpdateOneWebhookArgs = {
  data: WebhookUpdateInput;
  where: WebhookWhereUniqueInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdatePushTokenArgs = {
  pushToken: Scalars['String']['input'];
};


export type MutationUpdateSecondaryEmailArgs = {
  newEmail: Scalars['String']['input'];
  oldEmail: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserPermissionsArgs = {
  input: UserPermissionsInput;
};


export type MutationUpdateVoucherEmailArgs = {
  newEmail: Scalars['String']['input'];
  voucherId: Scalars['String']['input'];
};


export type MutationUpsertOneAddressArgs = {
  create: AddressCreateInput;
  update: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpsertOneApplicantDataArgs = {
  create: ApplicantDataCreateInput;
  update: ApplicantDataUpdateInput;
  where: ApplicantDataWhereUniqueInput;
};


export type MutationUpsertOneNameArgs = {
  create: NameCreateInput;
  update: NameUpdateInput;
  where: NameWhereUniqueInput;
};


export type MutationVerifyApiKeyUnlockArgs = {
  apiKey: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type Name = {
  __typename?: 'Name';
  applicantDataId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasMiddleName?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  identificationDocumentId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  passportId?: Maybe<Scalars['String']['output']>;
  stateIdentificationCardId?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  type?: Maybe<NameTypeEnum>;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type NameCreateInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutNamesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutNameInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutNameInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutNameInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNamesInput>;
};

export type NameCreateManyApplicantDataInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NameCreateManyApplicantDataInputEnvelope = {
  data: Array<NameCreateManyApplicantDataInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NameCreateManyUserInput = {
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NameCreateManyUserInputEnvelope = {
  data: Array<NameCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NameCreateNestedManyWithoutApplicantDataInput = {
  connect?: InputMaybe<Array<NameWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NameCreateOrConnectWithoutApplicantDataInput>>;
  create?: InputMaybe<Array<NameCreateWithoutApplicantDataInput>>;
  createMany?: InputMaybe<NameCreateManyApplicantDataInputEnvelope>;
};

export type NameCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<NameWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NameCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NameCreateWithoutUserInput>>;
  createMany?: InputMaybe<NameCreateManyUserInputEnvelope>;
};

export type NameCreateNestedOneWithoutIdentificationDocumentInput = {
  connect?: InputMaybe<NameWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NameCreateOrConnectWithoutIdentificationDocumentInput>;
  create?: InputMaybe<NameCreateWithoutIdentificationDocumentInput>;
};

export type NameCreateNestedOneWithoutPassportInput = {
  connect?: InputMaybe<NameWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NameCreateOrConnectWithoutPassportInput>;
  create?: InputMaybe<NameCreateWithoutPassportInput>;
};

export type NameCreateNestedOneWithoutStateIdentificationCardInput = {
  connect?: InputMaybe<NameWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NameCreateOrConnectWithoutStateIdentificationCardInput>;
  create?: InputMaybe<NameCreateWithoutStateIdentificationCardInput>;
};

export type NameCreateOrConnectWithoutApplicantDataInput = {
  create: NameCreateWithoutApplicantDataInput;
  where: NameWhereUniqueInput;
};

export type NameCreateOrConnectWithoutIdentificationDocumentInput = {
  create: NameCreateWithoutIdentificationDocumentInput;
  where: NameWhereUniqueInput;
};

export type NameCreateOrConnectWithoutPassportInput = {
  create: NameCreateWithoutPassportInput;
  where: NameWhereUniqueInput;
};

export type NameCreateOrConnectWithoutStateIdentificationCardInput = {
  create: NameCreateWithoutStateIdentificationCardInput;
  where: NameWhereUniqueInput;
};

export type NameCreateOrConnectWithoutUserInput = {
  create: NameCreateWithoutUserInput;
  where: NameWhereUniqueInput;
};

export type NameCreateWithoutApplicantDataInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutNameInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutNameInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutNameInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNamesInput>;
};

export type NameCreateWithoutIdentificationDocumentInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutNamesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutNameInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutNameInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNamesInput>;
};

export type NameCreateWithoutPassportInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutNamesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutNameInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutNameInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNamesInput>;
};

export type NameCreateWithoutStateIdentificationCardInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutNamesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutNameInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutNameInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutNamesInput>;
};

export type NameCreateWithoutUserInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutNamesInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentCreateNestedOneWithoutNameInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<PassportCreateNestedOneWithoutNameInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardCreateNestedOneWithoutNameInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NameTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NameListRelationFilter = {
  every?: InputMaybe<NameWhereInput>;
  none?: InputMaybe<NameWhereInput>;
  some?: InputMaybe<NameWhereInput>;
};

export type NameNullableScalarRelationFilter = {
  is?: InputMaybe<NameWhereInput>;
  isNot?: InputMaybe<NameWhereInput>;
};

export type NameOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NameOrderByWithRelationInput = {
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantDataId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  hasMiddleName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identificationDocument?: InputMaybe<IdentificationDocumentOrderByWithRelationInput>;
  identificationDocumentId?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  middleName?: InputMaybe<SortOrderInput>;
  passport?: InputMaybe<PassportOrderByWithRelationInput>;
  passportId?: InputMaybe<SortOrderInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardOrderByWithRelationInput>;
  stateIdentificationCardId?: InputMaybe<SortOrderInput>;
  suffix?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum NameScalarFieldEnum {
  ApplicantDataId = 'applicantDataId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  FirstName = 'firstName',
  HasMiddleName = 'hasMiddleName',
  Id = 'id',
  IdentificationDocumentId = 'identificationDocumentId',
  LastName = 'lastName',
  MiddleName = 'middleName',
  PassportId = 'passportId',
  StateIdentificationCardId = 'stateIdentificationCardId',
  Suffix = 'suffix',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type NameScalarWhereInput = {
  AND?: InputMaybe<Array<NameScalarWhereInput>>;
  NOT?: InputMaybe<Array<NameScalarWhereInput>>;
  OR?: InputMaybe<Array<NameScalarWhereInput>>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hasMiddleName?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  middleName?: InputMaybe<StringNullableFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  suffix?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumNameTypeEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export enum NameTypeEnum {
  Alias = 'ALIAS',
  Manual = 'MANUAL',
  Primary = 'PRIMARY'
}

export type NameUpdateInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutNamesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutNameNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutNameNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutNameNestedInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNamesNestedInput>;
};

export type NameUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NameUpdateManyWithWhereWithoutApplicantDataInput = {
  data: NameUpdateManyMutationInput;
  where: NameScalarWhereInput;
};

export type NameUpdateManyWithWhereWithoutUserInput = {
  data: NameUpdateManyMutationInput;
  where: NameScalarWhereInput;
};

export type NameUpdateManyWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<Array<NameWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NameCreateOrConnectWithoutApplicantDataInput>>;
  create?: InputMaybe<Array<NameCreateWithoutApplicantDataInput>>;
  createMany?: InputMaybe<NameCreateManyApplicantDataInputEnvelope>;
  delete?: InputMaybe<Array<NameWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NameScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NameWhereUniqueInput>>;
  set?: InputMaybe<Array<NameWhereUniqueInput>>;
  update?: InputMaybe<Array<NameUpdateWithWhereUniqueWithoutApplicantDataInput>>;
  updateMany?: InputMaybe<Array<NameUpdateManyWithWhereWithoutApplicantDataInput>>;
  upsert?: InputMaybe<Array<NameUpsertWithWhereUniqueWithoutApplicantDataInput>>;
};

export type NameUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<NameWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NameCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NameCreateWithoutUserInput>>;
  createMany?: InputMaybe<NameCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<NameWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NameScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NameWhereUniqueInput>>;
  set?: InputMaybe<Array<NameWhereUniqueInput>>;
  update?: InputMaybe<Array<NameUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<NameUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<NameUpsertWithWhereUniqueWithoutUserInput>>;
};

export type NameUpdateOneWithoutIdentificationDocumentNestedInput = {
  connect?: InputMaybe<NameWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NameCreateOrConnectWithoutIdentificationDocumentInput>;
  create?: InputMaybe<NameCreateWithoutIdentificationDocumentInput>;
  delete?: InputMaybe<NameWhereInput>;
  disconnect?: InputMaybe<NameWhereInput>;
  update?: InputMaybe<NameUpdateToOneWithWhereWithoutIdentificationDocumentInput>;
  upsert?: InputMaybe<NameUpsertWithoutIdentificationDocumentInput>;
};

export type NameUpdateOneWithoutPassportNestedInput = {
  connect?: InputMaybe<NameWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NameCreateOrConnectWithoutPassportInput>;
  create?: InputMaybe<NameCreateWithoutPassportInput>;
  delete?: InputMaybe<NameWhereInput>;
  disconnect?: InputMaybe<NameWhereInput>;
  update?: InputMaybe<NameUpdateToOneWithWhereWithoutPassportInput>;
  upsert?: InputMaybe<NameUpsertWithoutPassportInput>;
};

export type NameUpdateOneWithoutStateIdentificationCardNestedInput = {
  connect?: InputMaybe<NameWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NameCreateOrConnectWithoutStateIdentificationCardInput>;
  create?: InputMaybe<NameCreateWithoutStateIdentificationCardInput>;
  delete?: InputMaybe<NameWhereInput>;
  disconnect?: InputMaybe<NameWhereInput>;
  update?: InputMaybe<NameUpdateToOneWithWhereWithoutStateIdentificationCardInput>;
  upsert?: InputMaybe<NameUpsertWithoutStateIdentificationCardInput>;
};

export type NameUpdateToOneWithWhereWithoutIdentificationDocumentInput = {
  data: NameUpdateWithoutIdentificationDocumentInput;
  where?: InputMaybe<NameWhereInput>;
};

export type NameUpdateToOneWithWhereWithoutPassportInput = {
  data: NameUpdateWithoutPassportInput;
  where?: InputMaybe<NameWhereInput>;
};

export type NameUpdateToOneWithWhereWithoutStateIdentificationCardInput = {
  data: NameUpdateWithoutStateIdentificationCardInput;
  where?: InputMaybe<NameWhereInput>;
};

export type NameUpdateWithWhereUniqueWithoutApplicantDataInput = {
  data: NameUpdateWithoutApplicantDataInput;
  where: NameWhereUniqueInput;
};

export type NameUpdateWithWhereUniqueWithoutUserInput = {
  data: NameUpdateWithoutUserInput;
  where: NameWhereUniqueInput;
};

export type NameUpdateWithoutApplicantDataInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutNameNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutNameNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutNameNestedInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNamesNestedInput>;
};

export type NameUpdateWithoutIdentificationDocumentInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutNamesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutNameNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutNameNestedInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNamesNestedInput>;
};

export type NameUpdateWithoutPassportInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutNamesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutNameNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutNameNestedInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNamesNestedInput>;
};

export type NameUpdateWithoutStateIdentificationCardInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutNamesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutNameNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutNameNestedInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNamesNestedInput>;
};

export type NameUpdateWithoutUserInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutNamesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasMiddleName?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocument?: InputMaybe<IdentificationDocumentUpdateOneWithoutNameNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  passport?: InputMaybe<PassportUpdateOneWithoutNameNestedInput>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardUpdateOneWithoutNameNestedInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNameTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NameUpsertWithWhereUniqueWithoutApplicantDataInput = {
  create: NameCreateWithoutApplicantDataInput;
  update: NameUpdateWithoutApplicantDataInput;
  where: NameWhereUniqueInput;
};

export type NameUpsertWithWhereUniqueWithoutUserInput = {
  create: NameCreateWithoutUserInput;
  update: NameUpdateWithoutUserInput;
  where: NameWhereUniqueInput;
};

export type NameUpsertWithoutIdentificationDocumentInput = {
  create: NameCreateWithoutIdentificationDocumentInput;
  update: NameUpdateWithoutIdentificationDocumentInput;
  where?: InputMaybe<NameWhereInput>;
};

export type NameUpsertWithoutPassportInput = {
  create: NameCreateWithoutPassportInput;
  update: NameUpdateWithoutPassportInput;
  where?: InputMaybe<NameWhereInput>;
};

export type NameUpsertWithoutStateIdentificationCardInput = {
  create: NameCreateWithoutStateIdentificationCardInput;
  update: NameUpdateWithoutStateIdentificationCardInput;
  where?: InputMaybe<NameWhereInput>;
};

export type NameWhereInput = {
  AND?: InputMaybe<Array<NameWhereInput>>;
  NOT?: InputMaybe<Array<NameWhereInput>>;
  OR?: InputMaybe<Array<NameWhereInput>>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hasMiddleName?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentId?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  middleName?: InputMaybe<StringNullableFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportId?: InputMaybe<StringNullableFilter>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardId?: InputMaybe<StringNullableFilter>;
  suffix?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumNameTypeEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type NameWhereUniqueInput = {
  AND?: InputMaybe<Array<NameWhereInput>>;
  NOT?: InputMaybe<Array<NameWhereInput>>;
  OR?: InputMaybe<Array<NameWhereInput>>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hasMiddleName?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocument?: InputMaybe<IdentificationDocumentNullableScalarRelationFilter>;
  identificationDocumentId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  middleName?: InputMaybe<StringNullableFilter>;
  passport?: InputMaybe<PassportNullableScalarRelationFilter>;
  passportId?: InputMaybe<Scalars['String']['input']>;
  stateIdentificationCard?: InputMaybe<StateIdentificationCardNullableScalarRelationFilter>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumNameTypeEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBytesFilter = {
  equals?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<Scalars['Byte']['input']>>;
  not?: InputMaybe<NestedBytesFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']['input']>>;
};

export type NestedBytesNullableFilter = {
  equals?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<Scalars['Byte']['input']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']['input']>>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedEnumAddressTypeEnumNullableFilter = {
  equals?: InputMaybe<AddressTypeEnum>;
  in?: InputMaybe<Array<AddressTypeEnum>>;
  not?: InputMaybe<NestedEnumAddressTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<AddressTypeEnum>>;
};

export type NestedEnumApiKeyVerificationStatusEnumFilter = {
  equals?: InputMaybe<ApiKeyVerificationStatusEnum>;
  in?: InputMaybe<Array<ApiKeyVerificationStatusEnum>>;
  not?: InputMaybe<NestedEnumApiKeyVerificationStatusEnumFilter>;
  notIn?: InputMaybe<Array<ApiKeyVerificationStatusEnum>>;
};

export type NestedEnumAppFeedbackStatusEnumFilter = {
  equals?: InputMaybe<AppFeedbackStatusEnum>;
  in?: InputMaybe<Array<AppFeedbackStatusEnum>>;
  not?: InputMaybe<NestedEnumAppFeedbackStatusEnumFilter>;
  notIn?: InputMaybe<Array<AppFeedbackStatusEnum>>;
};

export type NestedEnumAttachmentEnumFilter = {
  equals?: InputMaybe<AttachmentEnum>;
  in?: InputMaybe<Array<AttachmentEnum>>;
  not?: InputMaybe<NestedEnumAttachmentEnumFilter>;
  notIn?: InputMaybe<Array<AttachmentEnum>>;
};

export type NestedEnumBeamDataSourceEnumFilter = {
  equals?: InputMaybe<BeamDataSourceEnum>;
  in?: InputMaybe<Array<BeamDataSourceEnum>>;
  not?: InputMaybe<NestedEnumBeamDataSourceEnumFilter>;
  notIn?: InputMaybe<Array<BeamDataSourceEnum>>;
};

export type NestedEnumBeamRunStatusEnumFilter = {
  equals?: InputMaybe<BeamRunStatusEnum>;
  in?: InputMaybe<Array<BeamRunStatusEnum>>;
  not?: InputMaybe<NestedEnumBeamRunStatusEnumFilter>;
  notIn?: InputMaybe<Array<BeamRunStatusEnum>>;
};

export type NestedEnumBeamTypeEnumFilter = {
  equals?: InputMaybe<BeamTypeEnum>;
  in?: InputMaybe<Array<BeamTypeEnum>>;
  not?: InputMaybe<NestedEnumBeamTypeEnumFilter>;
  notIn?: InputMaybe<Array<BeamTypeEnum>>;
};

export type NestedEnumCredentialStatusEnumFilter = {
  equals?: InputMaybe<CredentialStatusEnum>;
  in?: InputMaybe<Array<CredentialStatusEnum>>;
  not?: InputMaybe<NestedEnumCredentialStatusEnumFilter>;
  notIn?: InputMaybe<Array<CredentialStatusEnum>>;
};

export type NestedEnumCurrencyMultiplierEnumFilter = {
  equals?: InputMaybe<CurrencyMultiplierEnum>;
  in?: InputMaybe<Array<CurrencyMultiplierEnum>>;
  not?: InputMaybe<NestedEnumCurrencyMultiplierEnumFilter>;
  notIn?: InputMaybe<Array<CurrencyMultiplierEnum>>;
};

export type NestedEnumCurrencyTypeEnumFilter = {
  equals?: InputMaybe<CurrencyTypeEnum>;
  in?: InputMaybe<Array<CurrencyTypeEnum>>;
  not?: InputMaybe<NestedEnumCurrencyTypeEnumFilter>;
  notIn?: InputMaybe<Array<CurrencyTypeEnum>>;
};

export type NestedEnumDeviceTypeEnumFilter = {
  equals?: InputMaybe<DeviceTypeEnum>;
  in?: InputMaybe<Array<DeviceTypeEnum>>;
  not?: InputMaybe<NestedEnumDeviceTypeEnumFilter>;
  notIn?: InputMaybe<Array<DeviceTypeEnum>>;
};

export type NestedEnumDeviceTypeEnumNullableFilter = {
  equals?: InputMaybe<DeviceTypeEnum>;
  in?: InputMaybe<Array<DeviceTypeEnum>>;
  not?: InputMaybe<NestedEnumDeviceTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<DeviceTypeEnum>>;
};

export type NestedEnumDeviceTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDeviceTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumDeviceTypeEnumNullableFilter>;
  equals?: InputMaybe<DeviceTypeEnum>;
  in?: InputMaybe<Array<DeviceTypeEnum>>;
  not?: InputMaybe<NestedEnumDeviceTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DeviceTypeEnum>>;
};

export type NestedEnumDisclosureTypeEnumFilter = {
  equals?: InputMaybe<DisclosureTypeEnum>;
  in?: InputMaybe<Array<DisclosureTypeEnum>>;
  not?: InputMaybe<NestedEnumDisclosureTypeEnumFilter>;
  notIn?: InputMaybe<Array<DisclosureTypeEnum>>;
};

export type NestedEnumDisenrollmentSourceNullableFilter = {
  equals?: InputMaybe<DisenrollmentSource>;
  in?: InputMaybe<Array<DisenrollmentSource>>;
  not?: InputMaybe<NestedEnumDisenrollmentSourceNullableFilter>;
  notIn?: InputMaybe<Array<DisenrollmentSource>>;
};

export type NestedEnumDisputeReasonEnumFilter = {
  equals?: InputMaybe<DisputeReasonEnum>;
  in?: InputMaybe<Array<DisputeReasonEnum>>;
  not?: InputMaybe<NestedEnumDisputeReasonEnumFilter>;
  notIn?: InputMaybe<Array<DisputeReasonEnum>>;
};

export type NestedEnumDisputeResolutionOutcomeEnumNullableFilter = {
  equals?: InputMaybe<DisputeResolutionOutcomeEnum>;
  in?: InputMaybe<Array<DisputeResolutionOutcomeEnum>>;
  not?: InputMaybe<NestedEnumDisputeResolutionOutcomeEnumNullableFilter>;
  notIn?: InputMaybe<Array<DisputeResolutionOutcomeEnum>>;
};

export type NestedEnumDisputeStatusEnumFilter = {
  equals?: InputMaybe<DisputeStatusEnum>;
  in?: InputMaybe<Array<DisputeStatusEnum>>;
  not?: InputMaybe<NestedEnumDisputeStatusEnumFilter>;
  notIn?: InputMaybe<Array<DisputeStatusEnum>>;
};

export type NestedEnumFilePurposeTypeEnumNullableFilter = {
  equals?: InputMaybe<FilePurposeTypeEnum>;
  in?: InputMaybe<Array<FilePurposeTypeEnum>>;
  not?: InputMaybe<NestedEnumFilePurposeTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<FilePurposeTypeEnum>>;
};

export type NestedEnumHighlySensitiveIdentifierTypeFilter = {
  equals?: InputMaybe<HighlySensitiveIdentifierType>;
  in?: InputMaybe<Array<HighlySensitiveIdentifierType>>;
  not?: InputMaybe<NestedEnumHighlySensitiveIdentifierTypeFilter>;
  notIn?: InputMaybe<Array<HighlySensitiveIdentifierType>>;
};

export type NestedEnumIdCaptureMethodNullableFilter = {
  equals?: InputMaybe<IdCaptureMethod>;
  in?: InputMaybe<Array<IdCaptureMethod>>;
  not?: InputMaybe<NestedEnumIdCaptureMethodNullableFilter>;
  notIn?: InputMaybe<Array<IdCaptureMethod>>;
};

export type NestedEnumIdCardRotationEnumNullableFilter = {
  equals?: InputMaybe<IdCardRotationEnum>;
  in?: InputMaybe<Array<IdCardRotationEnum>>;
  not?: InputMaybe<NestedEnumIdCardRotationEnumNullableFilter>;
  notIn?: InputMaybe<Array<IdCardRotationEnum>>;
};

export type NestedEnumIdVerificationModelEnumNullableFilter = {
  equals?: InputMaybe<IdVerificationModelEnum>;
  in?: InputMaybe<Array<IdVerificationModelEnum>>;
  not?: InputMaybe<NestedEnumIdVerificationModelEnumNullableFilter>;
  notIn?: InputMaybe<Array<IdVerificationModelEnum>>;
};

export type NestedEnumIdVerificationResultCheckEnumNullableFilter = {
  equals?: InputMaybe<IdVerificationResultCheckEnum>;
  in?: InputMaybe<Array<IdVerificationResultCheckEnum>>;
  not?: InputMaybe<NestedEnumIdVerificationResultCheckEnumNullableFilter>;
  notIn?: InputMaybe<Array<IdVerificationResultCheckEnum>>;
};

export type NestedEnumIdentifierTypeFilter = {
  equals?: InputMaybe<IdentifierType>;
  in?: InputMaybe<Array<IdentifierType>>;
  not?: InputMaybe<NestedEnumIdentifierTypeFilter>;
  notIn?: InputMaybe<Array<IdentifierType>>;
};

export type NestedEnumJobStatusEnumNullableFilter = {
  equals?: InputMaybe<JobStatusEnum>;
  in?: InputMaybe<Array<JobStatusEnum>>;
  not?: InputMaybe<NestedEnumJobStatusEnumNullableFilter>;
  notIn?: InputMaybe<Array<JobStatusEnum>>;
};

export type NestedEnumJobStatusEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumJobStatusEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumJobStatusEnumNullableFilter>;
  equals?: InputMaybe<JobStatusEnum>;
  in?: InputMaybe<Array<JobStatusEnum>>;
  not?: InputMaybe<NestedEnumJobStatusEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<JobStatusEnum>>;
};

export type NestedEnumLocationTypeEnumNullableFilter = {
  equals?: InputMaybe<LocationTypeEnum>;
  in?: InputMaybe<Array<LocationTypeEnum>>;
  not?: InputMaybe<NestedEnumLocationTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<LocationTypeEnum>>;
};

export type NestedEnumMonitoringEnrollmentStatusFilter = {
  equals?: InputMaybe<MonitoringEnrollmentStatus>;
  in?: InputMaybe<Array<MonitoringEnrollmentStatus>>;
  not?: InputMaybe<NestedEnumMonitoringEnrollmentStatusFilter>;
  notIn?: InputMaybe<Array<MonitoringEnrollmentStatus>>;
};

export type NestedEnumMonitoringEnrollmentStrategyFilter = {
  equals?: InputMaybe<MonitoringEnrollmentStrategy>;
  in?: InputMaybe<Array<MonitoringEnrollmentStrategy>>;
  not?: InputMaybe<NestedEnumMonitoringEnrollmentStrategyFilter>;
  notIn?: InputMaybe<Array<MonitoringEnrollmentStrategy>>;
};

export type NestedEnumMonitoringFrequencyFilter = {
  equals?: InputMaybe<MonitoringFrequency>;
  in?: InputMaybe<Array<MonitoringFrequency>>;
  not?: InputMaybe<NestedEnumMonitoringFrequencyFilter>;
  notIn?: InputMaybe<Array<MonitoringFrequency>>;
};

export type NestedEnumMonitoringProviderFilter = {
  equals?: InputMaybe<MonitoringProvider>;
  in?: InputMaybe<Array<MonitoringProvider>>;
  not?: InputMaybe<NestedEnumMonitoringProviderFilter>;
  notIn?: InputMaybe<Array<MonitoringProvider>>;
};

export type NestedEnumMonitoringReportReviewOutcomeNullableFilter = {
  equals?: InputMaybe<MonitoringReportReviewOutcome>;
  in?: InputMaybe<Array<MonitoringReportReviewOutcome>>;
  not?: InputMaybe<NestedEnumMonitoringReportReviewOutcomeNullableFilter>;
  notIn?: InputMaybe<Array<MonitoringReportReviewOutcome>>;
};

export type NestedEnumMonitoringReportReviewStatusFilter = {
  equals?: InputMaybe<MonitoringReportReviewStatus>;
  in?: InputMaybe<Array<MonitoringReportReviewStatus>>;
  not?: InputMaybe<NestedEnumMonitoringReportReviewStatusFilter>;
  notIn?: InputMaybe<Array<MonitoringReportReviewStatus>>;
};

export type NestedEnumMonitoringReportScoreNullableFilter = {
  equals?: InputMaybe<MonitoringReportScore>;
  in?: InputMaybe<Array<MonitoringReportScore>>;
  not?: InputMaybe<NestedEnumMonitoringReportScoreNullableFilter>;
  notIn?: InputMaybe<Array<MonitoringReportScore>>;
};

export type NestedEnumMonitoringReviewStrategyFilter = {
  equals?: InputMaybe<MonitoringReviewStrategy>;
  in?: InputMaybe<Array<MonitoringReviewStrategy>>;
  not?: InputMaybe<NestedEnumMonitoringReviewStrategyFilter>;
  notIn?: InputMaybe<Array<MonitoringReviewStrategy>>;
};

export type NestedEnumMonitoringSecondaryVerificationProviderNullableFilter = {
  equals?: InputMaybe<MonitoringSecondaryVerificationProvider>;
  in?: InputMaybe<Array<MonitoringSecondaryVerificationProvider>>;
  not?: InputMaybe<NestedEnumMonitoringSecondaryVerificationProviderNullableFilter>;
  notIn?: InputMaybe<Array<MonitoringSecondaryVerificationProvider>>;
};

export type NestedEnumNameTypeEnumNullableFilter = {
  equals?: InputMaybe<NameTypeEnum>;
  in?: InputMaybe<Array<NameTypeEnum>>;
  not?: InputMaybe<NestedEnumNameTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<NameTypeEnum>>;
};

export type NestedEnumOrderAlertEnumNullableFilter = {
  equals?: InputMaybe<OrderAlertEnum>;
  in?: InputMaybe<Array<OrderAlertEnum>>;
  not?: InputMaybe<NestedEnumOrderAlertEnumNullableFilter>;
  notIn?: InputMaybe<Array<OrderAlertEnum>>;
};

export type NestedEnumOrderDeliveryMethodNullableFilter = {
  equals?: InputMaybe<OrderDeliveryMethod>;
  in?: InputMaybe<Array<OrderDeliveryMethod>>;
  not?: InputMaybe<NestedEnumOrderDeliveryMethodNullableFilter>;
  notIn?: InputMaybe<Array<OrderDeliveryMethod>>;
};

export type NestedEnumOrderScoreEnumNullableFilter = {
  equals?: InputMaybe<OrderScoreEnum>;
  in?: InputMaybe<Array<OrderScoreEnum>>;
  not?: InputMaybe<NestedEnumOrderScoreEnumNullableFilter>;
  notIn?: InputMaybe<Array<OrderScoreEnum>>;
};

export type NestedEnumOrderStatusEnumNullableFilter = {
  equals?: InputMaybe<OrderStatusEnum>;
  in?: InputMaybe<Array<OrderStatusEnum>>;
  not?: InputMaybe<NestedEnumOrderStatusEnumNullableFilter>;
  notIn?: InputMaybe<Array<OrderStatusEnum>>;
};

export type NestedEnumOrgRelationTypeEnumFilter = {
  equals?: InputMaybe<OrgRelationTypeEnum>;
  in?: InputMaybe<Array<OrgRelationTypeEnum>>;
  not?: InputMaybe<NestedEnumOrgRelationTypeEnumFilter>;
  notIn?: InputMaybe<Array<OrgRelationTypeEnum>>;
};

export type NestedEnumPerformerTypesFilter = {
  equals?: InputMaybe<PerformerTypes>;
  in?: InputMaybe<Array<PerformerTypes>>;
  not?: InputMaybe<NestedEnumPerformerTypesFilter>;
  notIn?: InputMaybe<Array<PerformerTypes>>;
};

export type NestedEnumProcessorEnumFilter = {
  equals?: InputMaybe<ProcessorEnum>;
  in?: InputMaybe<Array<ProcessorEnum>>;
  not?: InputMaybe<NestedEnumProcessorEnumFilter>;
  notIn?: InputMaybe<Array<ProcessorEnum>>;
};

export type NestedEnumResultAlertTypeEnumNullableFilter = {
  equals?: InputMaybe<ResultAlertTypeEnum>;
  in?: InputMaybe<Array<ResultAlertTypeEnum>>;
  not?: InputMaybe<NestedEnumResultAlertTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<ResultAlertTypeEnum>>;
};

export type NestedEnumResultSearchTypeFilter = {
  equals?: InputMaybe<ResultSearchType>;
  in?: InputMaybe<Array<ResultSearchType>>;
  not?: InputMaybe<NestedEnumResultSearchTypeFilter>;
  notIn?: InputMaybe<Array<ResultSearchType>>;
};

export type NestedEnumResultSearchTypeNullableFilter = {
  equals?: InputMaybe<ResultSearchType>;
  in?: InputMaybe<Array<ResultSearchType>>;
  not?: InputMaybe<NestedEnumResultSearchTypeNullableFilter>;
  notIn?: InputMaybe<Array<ResultSearchType>>;
};

export type NestedEnumResultStatusEnumFilter = {
  equals?: InputMaybe<ResultStatusEnum>;
  in?: InputMaybe<Array<ResultStatusEnum>>;
  not?: InputMaybe<NestedEnumResultStatusEnumFilter>;
  notIn?: InputMaybe<Array<ResultStatusEnum>>;
};

export type NestedEnumSearchStatusTypeEnumFilter = {
  equals?: InputMaybe<SearchStatusTypeEnum>;
  in?: InputMaybe<Array<SearchStatusTypeEnum>>;
  not?: InputMaybe<NestedEnumSearchStatusTypeEnumFilter>;
  notIn?: InputMaybe<Array<SearchStatusTypeEnum>>;
};

export type NestedEnumSourceTypesFilter = {
  equals?: InputMaybe<SourceTypes>;
  in?: InputMaybe<Array<SourceTypes>>;
  not?: InputMaybe<NestedEnumSourceTypesFilter>;
  notIn?: InputMaybe<Array<SourceTypes>>;
};

export type NestedEnumUserPrimaryContactEnumNullableFilter = {
  equals?: InputMaybe<UserPrimaryContactEnum>;
  in?: InputMaybe<Array<UserPrimaryContactEnum>>;
  not?: InputMaybe<NestedEnumUserPrimaryContactEnumNullableFilter>;
  notIn?: InputMaybe<Array<UserPrimaryContactEnum>>;
};

export type NestedEnumVoucherOriginNullableFilter = {
  equals?: InputMaybe<VoucherOrigin>;
  in?: InputMaybe<Array<VoucherOrigin>>;
  not?: InputMaybe<NestedEnumVoucherOriginNullableFilter>;
  notIn?: InputMaybe<Array<VoucherOrigin>>;
};

export type NestedEnumVoucherStatusEnumFilter = {
  equals?: InputMaybe<VoucherStatusEnum>;
  in?: InputMaybe<Array<VoucherStatusEnum>>;
  not?: InputMaybe<NestedEnumVoucherStatusEnumFilter>;
  notIn?: InputMaybe<Array<VoucherStatusEnum>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableBytesFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Byte']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type NullableEnumAddressTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AddressTypeEnum>;
};

export type NullableEnumDeviceTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DeviceTypeEnum>;
};

export type NullableEnumDisenrollmentSourceFieldUpdateOperationsInput = {
  set?: InputMaybe<DisenrollmentSource>;
};

export type NullableEnumDisputeResolutionOutcomeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DisputeResolutionOutcomeEnum>;
};

export type NullableEnumFilePurposeTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<FilePurposeTypeEnum>;
};

export type NullableEnumIdCaptureMethodFieldUpdateOperationsInput = {
  set?: InputMaybe<IdCaptureMethod>;
};

export type NullableEnumIdCardRotationEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<IdCardRotationEnum>;
};

export type NullableEnumIdVerificationModelEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<IdVerificationModelEnum>;
};

export type NullableEnumIdVerificationResultCheckEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<IdVerificationResultCheckEnum>;
};

export type NullableEnumJobStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<JobStatusEnum>;
};

export type NullableEnumLocationTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<LocationTypeEnum>;
};

export type NullableEnumMonitoringReportReviewOutcomeFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringReportReviewOutcome>;
};

export type NullableEnumMonitoringReportScoreFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringReportScore>;
};

export type NullableEnumMonitoringSecondaryVerificationProviderFieldUpdateOperationsInput = {
  set?: InputMaybe<MonitoringSecondaryVerificationProvider>;
};

export type NullableEnumNameTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<NameTypeEnum>;
};

export type NullableEnumOrderAlertEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderAlertEnum>;
};

export type NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderDeliveryMethod>;
};

export type NullableEnumOrderScoreEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderScoreEnum>;
};

export type NullableEnumOrderStatusEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderStatusEnum>;
};

export type NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ResultAlertTypeEnum>;
};

export type NullableEnumResultSearchTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ResultSearchType>;
};

export type NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<UserPrimaryContactEnum>;
};

export type NullableEnumVoucherOriginFieldUpdateOperationsInput = {
  set?: InputMaybe<VoucherOrigin>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Order = {
  __typename?: 'Order';
  _count?: Maybe<OrderCount>;
  additionalMetadata?: Maybe<Scalars['JSON']['output']>;
  alert?: Maybe<OrderAlertEnum>;
  amount: Scalars['Float']['output'];
  appFeedback?: Maybe<AppFeedback>;
  applicantData?: Maybe<ApplicantData>;
  backgroundReportUrl?: Maybe<Scalars['String']['output']>;
  beamInputs: Array<BeamInput>;
  beamOutputs: Array<BeamOutput>;
  biometricConsentAcceptance?: Maybe<BiometricConsentAcceptance>;
  captureMethod?: Maybe<IdCaptureMethod>;
  complianceLetters: Array<ComplianceLetter>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  customScore?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deliveryMethod?: Maybe<OrderDeliveryMethod>;
  deviceType?: Maybe<DeviceTypeEnum>;
  disclosureAcceptances: Array<DisclosureAcceptance>;
  dispatchedSearches: Array<DispatchedSearch>;
  disputes: Array<Dispute>;
  fileNumber: Scalars['String']['output'];
  files: Array<File>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  internalMetadata?: Maybe<Scalars['JSON']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  ipMetadata?: Maybe<Scalars['JSON']['output']>;
  monitoringEnrollments: Array<MonitoringEnrollment>;
  notes: Array<OrderNote>;
  optOut: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSets: Array<PackageSet>;
  paid: Scalars['Boolean']['output'];
  parentOrganizationId?: Maybe<Scalars['String']['output']>;
  postbackWebhookUrl?: Maybe<Scalars['String']['output']>;
  reportCompletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  reportableIdVerificationResult?: Maybe<ReportableIdVerificationResult>;
  reportableResults?: Maybe<Scalars['JSON']['output']>;
  reportedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  requestedSearches: Array<RequestedSearch>;
  results: Array<Result>;
  score?: Maybe<OrderScoreEnum>;
  status?: Maybe<OrderStatusEnum>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  vIDVoucher?: Maybe<VidVoucher>;
  webhook?: Maybe<Webhook>;
  webhookId?: Maybe<Scalars['String']['output']>;
};


export type OrderAppFeedbackArgs = {
  where?: InputMaybe<AppFeedbackWhereInput>;
};


export type OrderApplicantDataArgs = {
  where?: InputMaybe<ApplicantDataWhereInput>;
};


export type OrderBeamInputsArgs = {
  cursor?: InputMaybe<BeamInputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};


export type OrderBeamOutputsArgs = {
  cursor?: InputMaybe<BeamOutputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamOutputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOutputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type OrderBiometricConsentAcceptanceArgs = {
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type OrderComplianceLettersArgs = {
  cursor?: InputMaybe<ComplianceLetterWhereUniqueInput>;
  distinct?: InputMaybe<Array<ComplianceLetterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ComplianceLetterOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ComplianceLetterWhereInput>;
};


export type OrderCreatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type OrderDisclosureAcceptancesArgs = {
  cursor?: InputMaybe<DisclosureAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type OrderDispatchedSearchesArgs = {
  cursor?: InputMaybe<DispatchedSearchWhereUniqueInput>;
  distinct?: InputMaybe<Array<DispatchedSearchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DispatchedSearchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type OrderDisputesArgs = {
  cursor?: InputMaybe<DisputeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisputeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisputeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type OrderFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type OrderMonitoringEnrollmentsArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringEnrollmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type OrderNotesArgs = {
  cursor?: InputMaybe<OrderNoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderNoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderNoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderNoteWhereInput>;
};


export type OrderOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type OrderPackageSetsArgs = {
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageSetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageSetWhereInput>;
};


export type OrderReportableIdVerificationResultArgs = {
  where?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};


export type OrderRequestedSearchesArgs = {
  cursor?: InputMaybe<RequestedSearchWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequestedSearchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequestedSearchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type OrderResultsArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type OrderUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type OrderVIdVoucherArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type OrderWebhookArgs = {
  where?: InputMaybe<WebhookWhereInput>;
};

export enum OrderAlertEnum {
  AlertsFound = 'ALERTS_FOUND',
  NoAlertsFound = 'NO_ALERTS_FOUND'
}

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type OrderBeamData = {
  beamId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderCount = {
  __typename?: 'OrderCount';
  beamInputs: Scalars['Int']['output'];
  beamOutputs: Scalars['Int']['output'];
  complianceLetters: Scalars['Int']['output'];
  disclosureAcceptances: Scalars['Int']['output'];
  dispatchedSearches: Scalars['Int']['output'];
  disputes: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  monitoringEnrollments: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  packageSets: Scalars['Int']['output'];
  requestedSearches: Scalars['Int']['output'];
  results: Scalars['Int']['output'];
};


export type OrderCountBeamInputsArgs = {
  where?: InputMaybe<BeamInputWhereInput>;
};


export type OrderCountBeamOutputsArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type OrderCountComplianceLettersArgs = {
  where?: InputMaybe<ComplianceLetterWhereInput>;
};


export type OrderCountDisclosureAcceptancesArgs = {
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type OrderCountDispatchedSearchesArgs = {
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type OrderCountDisputesArgs = {
  where?: InputMaybe<DisputeWhereInput>;
};


export type OrderCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type OrderCountMonitoringEnrollmentsArgs = {
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type OrderCountNotesArgs = {
  where?: InputMaybe<OrderNoteWhereInput>;
};


export type OrderCountPackageSetsArgs = {
  where?: InputMaybe<PackageSetWhereInput>;
};


export type OrderCountRequestedSearchesArgs = {
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type OrderCountResultsArgs = {
  where?: InputMaybe<ResultWhereInput>;
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int']['output'];
  additionalMetadata: Scalars['Int']['output'];
  alert: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  backgroundReportUrl: Scalars['Int']['output'];
  captureMethod: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdById: Scalars['Int']['output'];
  customScore: Scalars['Int']['output'];
  deleted: Scalars['Int']['output'];
  deliveryMethod: Scalars['Int']['output'];
  deviceType: Scalars['Int']['output'];
  fileNumber: Scalars['Int']['output'];
  flagged: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  internalMetadata: Scalars['Int']['output'];
  ipAddress: Scalars['Int']['output'];
  ipMetadata: Scalars['Int']['output'];
  optOut: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
  parentOrganizationId: Scalars['Int']['output'];
  postbackWebhookUrl: Scalars['Int']['output'];
  reportCompletedAt: Scalars['Int']['output'];
  reportableResults: Scalars['Int']['output'];
  reportedAt: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  webhookId: Scalars['Int']['output'];
};

export type OrderCreateManyCreatedByInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  webhookId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCreateManyCreatedByInputEnvelope = {
  data: Array<OrderCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyOrganizationInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  webhookId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCreateManyOrganizationInputEnvelope = {
  data: Array<OrderCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyUserInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  webhookId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCreateManyUserInputEnvelope = {
  data: Array<OrderCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyWebhookInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCreateManyWebhookInputEnvelope = {
  data: Array<OrderCreateManyWebhookInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrderCreateManyCreatedByInputEnvelope>;
};

export type OrderCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<OrderCreateManyOrganizationInputEnvelope>;
};

export type OrderCreateNestedManyWithoutPackageSetsInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutPackageSetsInput>>;
};

export type OrderCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderCreateManyUserInputEnvelope>;
};

export type OrderCreateNestedManyWithoutWebhookInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutWebhookInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutWebhookInput>>;
  createMany?: InputMaybe<OrderCreateManyWebhookInputEnvelope>;
};

export type OrderCreateNestedOneWithoutAppFeedbackInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutAppFeedbackInput>;
  create?: InputMaybe<OrderCreateWithoutAppFeedbackInput>;
};

export type OrderCreateNestedOneWithoutApplicantDataInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<OrderCreateWithoutApplicantDataInput>;
};

export type OrderCreateNestedOneWithoutBeamInputsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutBeamInputsInput>;
  create?: InputMaybe<OrderCreateWithoutBeamInputsInput>;
};

export type OrderCreateNestedOneWithoutBeamOutputsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutBeamOutputsInput>;
  create?: InputMaybe<OrderCreateWithoutBeamOutputsInput>;
};

export type OrderCreateNestedOneWithoutBiometricConsentAcceptanceInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutBiometricConsentAcceptanceInput>;
  create?: InputMaybe<OrderCreateWithoutBiometricConsentAcceptanceInput>;
};

export type OrderCreateNestedOneWithoutDisclosureAcceptancesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDisclosureAcceptancesInput>;
  create?: InputMaybe<OrderCreateWithoutDisclosureAcceptancesInput>;
};

export type OrderCreateNestedOneWithoutDispatchedSearchesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<OrderCreateWithoutDispatchedSearchesInput>;
};

export type OrderCreateNestedOneWithoutDisputesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<OrderCreateWithoutDisputesInput>;
};

export type OrderCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<OrderCreateWithoutFilesInput>;
};

export type OrderCreateNestedOneWithoutMonitoringEnrollmentsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutMonitoringEnrollmentsInput>;
  create?: InputMaybe<OrderCreateWithoutMonitoringEnrollmentsInput>;
};

export type OrderCreateNestedOneWithoutNotesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutNotesInput>;
  create?: InputMaybe<OrderCreateWithoutNotesInput>;
};

export type OrderCreateNestedOneWithoutReportableIdVerificationResultInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutReportableIdVerificationResultInput>;
  create?: InputMaybe<OrderCreateWithoutReportableIdVerificationResultInput>;
};

export type OrderCreateNestedOneWithoutRequestedSearchesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutRequestedSearchesInput>;
  create?: InputMaybe<OrderCreateWithoutRequestedSearchesInput>;
};

export type OrderCreateNestedOneWithoutResultsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<OrderCreateWithoutResultsInput>;
};

export type OrderCreateNestedOneWithoutVidVoucherInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutVidVoucherInput>;
  create?: InputMaybe<OrderCreateWithoutVidVoucherInput>;
};

export type OrderCreateOrConnectWithoutAppFeedbackInput = {
  create: OrderCreateWithoutAppFeedbackInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutApplicantDataInput = {
  create: OrderCreateWithoutApplicantDataInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutBeamInputsInput = {
  create: OrderCreateWithoutBeamInputsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutBeamOutputsInput = {
  create: OrderCreateWithoutBeamOutputsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutBiometricConsentAcceptanceInput = {
  create: OrderCreateWithoutBiometricConsentAcceptanceInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCreatedByInput = {
  create: OrderCreateWithoutCreatedByInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutDisclosureAcceptancesInput = {
  create: OrderCreateWithoutDisclosureAcceptancesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutDispatchedSearchesInput = {
  create: OrderCreateWithoutDispatchedSearchesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutDisputesInput = {
  create: OrderCreateWithoutDisputesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutFilesInput = {
  create: OrderCreateWithoutFilesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutMonitoringEnrollmentsInput = {
  create: OrderCreateWithoutMonitoringEnrollmentsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutNotesInput = {
  create: OrderCreateWithoutNotesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutOrganizationInput = {
  create: OrderCreateWithoutOrganizationInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPackageSetsInput = {
  create: OrderCreateWithoutPackageSetsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutReportableIdVerificationResultInput = {
  create: OrderCreateWithoutReportableIdVerificationResultInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutRequestedSearchesInput = {
  create: OrderCreateWithoutRequestedSearchesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutResultsInput = {
  create: OrderCreateWithoutResultsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutUserInput = {
  create: OrderCreateWithoutUserInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutVidVoucherInput = {
  create: OrderCreateWithoutVidVoucherInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutWebhookInput = {
  create: OrderCreateWithoutWebhookInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutAppFeedbackInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutApplicantDataInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutBeamInputsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutBeamOutputsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutBiometricConsentAcceptanceInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutCreatedByInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutDisclosureAcceptancesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutDispatchedSearchesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutDisputesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutFilesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutMonitoringEnrollmentsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutNotesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutOrganizationInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutPackageSetsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutReportableIdVerificationResultInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutRequestedSearchesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutResultsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutUserInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutVidVoucherInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  webhook?: InputMaybe<WebhookCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutWebhookInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<OrderAlertEnum>;
  amount: Scalars['Float']['input'];
  appFeedback?: InputMaybe<AppFeedbackCreateNestedOneWithoutOrderInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutOrderInput>;
  backgroundReportUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputs?: InputMaybe<BeamInputCreateNestedManyWithoutOrderInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrderInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceCreateNestedOneWithoutOrderInput>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  complianceLetters?: InputMaybe<ComplianceLetterCreateNestedManyWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrdersInput>;
  customScore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMethod?: InputMaybe<OrderDeliveryMethod>;
  deviceType?: InputMaybe<DeviceTypeEnum>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutOrderInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutOrderInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutOrderInput>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrderInput>;
  notes?: InputMaybe<OrderNoteCreateNestedManyWithoutOrderInput>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutOrdersInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrdersInput>;
  paid: Scalars['Boolean']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  reportCompletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultCreateNestedOneWithoutOrderInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutOrderInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutOrderInput>;
  score?: InputMaybe<OrderScoreEnum>;
  status?: InputMaybe<OrderStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMyOrdersInput>;
  vIDVoucher?: InputMaybe<VidVoucherCreateNestedOneWithoutOrderInput>;
};

export enum OrderDeliveryMethod {
  RapidRequest = 'rapidRequest',
  Standard = 'standard',
  VIdWeb = 'vIDWeb',
  VidScreen = 'vidScreen'
}

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderListSearchDateRangeInput = {
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderListSearchFilterInput = {
  alert?: InputMaybe<OrderAlertEnum>;
  craId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<OrderListSearchDateRangeInput>;
  deviceType?: InputMaybe<Array<DeviceTypeEnum>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  packageSetId?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Array<OrderScoreEnum>>;
  showOnlyManualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<OrderStatusEnum>>;
};

export type OrderListSearchOrderByInput = {
  direction: SortOrder;
  field: OrderListSearchSortField;
};

export type OrderListSearchResult = {
  __typename?: 'OrderListSearchResult';
  orders: Array<Order>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum OrderListSearchSortField {
  Alert = 'ALERT',
  CreatedAt = 'CREATED_AT',
  DeviceType = 'DEVICE_TYPE',
  FileNumber = 'FILE_NUMBER',
  Score = 'SCORE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  alert?: Maybe<OrderAlertEnum>;
  amount?: Maybe<Scalars['Float']['output']>;
  backgroundReportUrl?: Maybe<Scalars['String']['output']>;
  captureMethod?: Maybe<IdCaptureMethod>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  customScore?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deliveryMethod?: Maybe<OrderDeliveryMethod>;
  deviceType?: Maybe<DeviceTypeEnum>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  optOut?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  parentOrganizationId?: Maybe<Scalars['String']['output']>;
  postbackWebhookUrl?: Maybe<Scalars['String']['output']>;
  reportCompletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  reportedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  score?: Maybe<OrderScoreEnum>;
  status?: Maybe<OrderStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  alert?: Maybe<OrderAlertEnum>;
  amount?: Maybe<Scalars['Float']['output']>;
  backgroundReportUrl?: Maybe<Scalars['String']['output']>;
  captureMethod?: Maybe<IdCaptureMethod>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  customScore?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deliveryMethod?: Maybe<OrderDeliveryMethod>;
  deviceType?: Maybe<DeviceTypeEnum>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  optOut?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  parentOrganizationId?: Maybe<Scalars['String']['output']>;
  postbackWebhookUrl?: Maybe<Scalars['String']['output']>;
  reportCompletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  reportedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  score?: Maybe<OrderScoreEnum>;
  status?: Maybe<OrderStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['String']['output']>;
};

export type OrderNote = {
  __typename?: 'OrderNote';
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type OrderNoteCreatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type OrderNoteCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutOrderNotesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutNotesInput;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderNoteCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orderId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderNoteCreateManyCreatedByInputEnvelope = {
  data: Array<OrderNoteCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNoteCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderNoteCreateManyOrderInputEnvelope = {
  data: Array<OrderNoteCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNoteCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNoteCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrderNoteCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrderNoteCreateManyCreatedByInputEnvelope>;
};

export type OrderNoteCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNoteCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderNoteCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderNoteCreateManyOrderInputEnvelope>;
};

export type OrderNoteCreateOrConnectWithoutCreatedByInput = {
  create: OrderNoteCreateWithoutCreatedByInput;
  where: OrderNoteWhereUniqueInput;
};

export type OrderNoteCreateOrConnectWithoutOrderInput = {
  create: OrderNoteCreateWithoutOrderInput;
  where: OrderNoteWhereUniqueInput;
};

export type OrderNoteCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutNotesInput;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderNoteCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutOrderNotesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderNoteListRelationFilter = {
  every?: InputMaybe<OrderNoteWhereInput>;
  none?: InputMaybe<OrderNoteWhereInput>;
  some?: InputMaybe<OrderNoteWhereInput>;
};

export type OrderNoteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderNoteOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrderInput>;
  message?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum OrderNoteScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  Id = 'id',
  IsActive = 'isActive',
  Message = 'message',
  Metadata = 'metadata',
  OrderId = 'orderId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type OrderNoteScalarWhereInput = {
  AND?: InputMaybe<Array<OrderNoteScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderNoteScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderNoteScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  message?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  orderId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderNoteUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutOrderNotesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutNotesNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderNoteUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderNoteUpdateManyWithWhereWithoutCreatedByInput = {
  data: OrderNoteUpdateManyMutationInput;
  where: OrderNoteScalarWhereInput;
};

export type OrderNoteUpdateManyWithWhereWithoutOrderInput = {
  data: OrderNoteUpdateManyMutationInput;
  where: OrderNoteScalarWhereInput;
};

export type OrderNoteUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNoteCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrderNoteCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrderNoteCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderNoteUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<OrderNoteUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<OrderNoteUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type OrderNoteUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderNoteCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderNoteCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderNoteCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderNoteUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderNoteUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderNoteUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderNoteUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: OrderNoteUpdateWithoutCreatedByInput;
  where: OrderNoteWhereUniqueInput;
};

export type OrderNoteUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderNoteUpdateWithoutOrderInput;
  where: OrderNoteWhereUniqueInput;
};

export type OrderNoteUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutNotesNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderNoteUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutOrderNotesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderNoteUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: OrderNoteCreateWithoutCreatedByInput;
  update: OrderNoteUpdateWithoutCreatedByInput;
  where: OrderNoteWhereUniqueInput;
};

export type OrderNoteUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderNoteCreateWithoutOrderInput;
  update: OrderNoteUpdateWithoutOrderInput;
  where: OrderNoteWhereUniqueInput;
};

export type OrderNoteWhereInput = {
  AND?: InputMaybe<Array<OrderNoteWhereInput>>;
  NOT?: InputMaybe<Array<OrderNoteWhereInput>>;
  OR?: InputMaybe<Array<OrderNoteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  message?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderNoteWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderNoteWhereInput>>;
  NOT?: InputMaybe<Array<OrderNoteWhereInput>>;
  OR?: InputMaybe<Array<OrderNoteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolNullableFilter>;
  message?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderNullableScalarRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  additionalMetadata?: InputMaybe<SortOrderInput>;
  alert?: InputMaybe<SortOrderInput>;
  amount?: InputMaybe<SortOrder>;
  appFeedback?: InputMaybe<AppFeedbackOrderByWithRelationInput>;
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  backgroundReportUrl?: InputMaybe<SortOrderInput>;
  beamInputs?: InputMaybe<BeamInputOrderByRelationAggregateInput>;
  beamOutputs?: InputMaybe<BeamOutputOrderByRelationAggregateInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceOrderByWithRelationInput>;
  captureMethod?: InputMaybe<SortOrderInput>;
  complianceLetters?: InputMaybe<ComplianceLetterOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  customScore?: InputMaybe<SortOrderInput>;
  deleted?: InputMaybe<SortOrderInput>;
  deliveryMethod?: InputMaybe<SortOrderInput>;
  deviceType?: InputMaybe<SortOrderInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceOrderByRelationAggregateInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchOrderByRelationAggregateInput>;
  disputes?: InputMaybe<DisputeOrderByRelationAggregateInput>;
  fileNumber?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  flagged?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  internalMetadata?: InputMaybe<SortOrderInput>;
  ipAddress?: InputMaybe<SortOrderInput>;
  ipMetadata?: InputMaybe<SortOrderInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentOrderByRelationAggregateInput>;
  notes?: InputMaybe<OrderNoteOrderByRelationAggregateInput>;
  optOut?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  packageSets?: InputMaybe<PackageSetOrderByRelationAggregateInput>;
  paid?: InputMaybe<SortOrder>;
  parentOrganizationId?: InputMaybe<SortOrderInput>;
  postbackWebhookUrl?: InputMaybe<SortOrderInput>;
  reportCompletedAt?: InputMaybe<SortOrderInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultOrderByWithRelationInput>;
  reportableResults?: InputMaybe<SortOrderInput>;
  reportedAt?: InputMaybe<SortOrderInput>;
  requestedSearches?: InputMaybe<RequestedSearchOrderByRelationAggregateInput>;
  results?: InputMaybe<ResultOrderByRelationAggregateInput>;
  score?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  vIDVoucher?: InputMaybe<VidVoucherOrderByWithRelationInput>;
  webhook?: InputMaybe<WebhookOrderByWithRelationInput>;
  webhookId?: InputMaybe<SortOrderInput>;
};

export enum OrderScalarFieldEnum {
  AdditionalMetadata = 'additionalMetadata',
  Alert = 'alert',
  Amount = 'amount',
  BackgroundReportUrl = 'backgroundReportUrl',
  CaptureMethod = 'captureMethod',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  CustomScore = 'customScore',
  Deleted = 'deleted',
  DeliveryMethod = 'deliveryMethod',
  DeviceType = 'deviceType',
  FileNumber = 'fileNumber',
  Flagged = 'flagged',
  Id = 'id',
  InternalMetadata = 'internalMetadata',
  IpAddress = 'ipAddress',
  IpMetadata = 'ipMetadata',
  OptOut = 'optOut',
  OrganizationId = 'organizationId',
  Paid = 'paid',
  ParentOrganizationId = 'parentOrganizationId',
  PostbackWebhookUrl = 'postbackWebhookUrl',
  ReportCompletedAt = 'reportCompletedAt',
  ReportableResults = 'reportableResults',
  ReportedAt = 'reportedAt',
  Score = 'score',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WebhookId = 'webhookId'
}

export type OrderScalarRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  additionalMetadata?: InputMaybe<JsonNullableFilter>;
  alert?: InputMaybe<EnumOrderAlertEnumNullableFilter>;
  amount?: InputMaybe<FloatFilter>;
  backgroundReportUrl?: InputMaybe<StringNullableFilter>;
  captureMethod?: InputMaybe<EnumIdCaptureMethodNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  customScore?: InputMaybe<StringNullableFilter>;
  deleted?: InputMaybe<BoolNullableFilter>;
  deliveryMethod?: InputMaybe<EnumOrderDeliveryMethodNullableFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableFilter>;
  fileNumber?: InputMaybe<StringFilter>;
  flagged?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalMetadata?: InputMaybe<JsonNullableFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  ipMetadata?: InputMaybe<JsonNullableFilter>;
  optOut?: InputMaybe<BoolFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  paid?: InputMaybe<BoolFilter>;
  parentOrganizationId?: InputMaybe<StringNullableFilter>;
  postbackWebhookUrl?: InputMaybe<StringNullableFilter>;
  reportCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  reportableResults?: InputMaybe<JsonNullableFilter>;
  reportedAt?: InputMaybe<DateTimeNullableFilter>;
  score?: InputMaybe<EnumOrderScoreEnumNullableFilter>;
  status?: InputMaybe<EnumOrderStatusEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  webhookId?: InputMaybe<StringNullableFilter>;
};

export enum OrderScoreEnum {
  AdverseAction = 'ADVERSE_ACTION',
  AlertsFound = 'ALERTS_FOUND',
  ClientReview = 'CLIENT_REVIEW',
  IdNotVerified = 'ID_NOT_VERIFIED',
  IdVerified = 'ID_VERIFIED',
  NoAlerts = 'NO_ALERTS',
  NoDrugTest = 'NO_DRUG_TEST',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  PreAdverse = 'PRE_ADVERSE',
  ReviewPass = 'REVIEW_PASS',
  ReviewRequired = 'REVIEW_REQUIRED',
  ScreeningAlert = 'SCREENING_ALERT',
  ScreeningClear = 'SCREENING_CLEAR',
  ScreeningNoAlert = 'SCREENING_NO_ALERT',
  ScreeningPending = 'SCREENING_PENDING',
  Withdrawn = 'WITHDRAWN'
}

export enum OrderStatusEnum {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  InDispute = 'IN_DISPUTE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type OrderUpdateInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateManyMutationInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutCreatedByInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutOrganizationInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutPackageSetsInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutUserInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutWebhookInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrderCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type OrderUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<OrderCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type OrderUpdateManyWithoutPackageSetsNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutPackageSetsInput>>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutPackageSetsInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutPackageSetsInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutPackageSetsInput>>;
};

export type OrderUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutUserInput>>;
};

export type OrderUpdateManyWithoutWebhookNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutWebhookInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutWebhookInput>>;
  createMany?: InputMaybe<OrderCreateManyWebhookInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutWebhookInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutWebhookInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutWebhookInput>>;
};

export type OrderUpdateOneRequiredWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<OrderCreateWithoutApplicantDataInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutApplicantDataInput>;
  upsert?: InputMaybe<OrderUpsertWithoutApplicantDataInput>;
};

export type OrderUpdateOneRequiredWithoutDispatchedSearchesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<OrderCreateWithoutDispatchedSearchesInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutDispatchedSearchesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutDispatchedSearchesInput>;
};

export type OrderUpdateOneRequiredWithoutDisputesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<OrderCreateWithoutDisputesInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutDisputesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutDisputesInput>;
};

export type OrderUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutMonitoringEnrollmentsInput>;
  create?: InputMaybe<OrderCreateWithoutMonitoringEnrollmentsInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutMonitoringEnrollmentsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutMonitoringEnrollmentsInput>;
};

export type OrderUpdateOneRequiredWithoutNotesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutNotesInput>;
  create?: InputMaybe<OrderCreateWithoutNotesInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutNotesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutNotesInput>;
};

export type OrderUpdateOneRequiredWithoutReportableIdVerificationResultNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutReportableIdVerificationResultInput>;
  create?: InputMaybe<OrderCreateWithoutReportableIdVerificationResultInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutReportableIdVerificationResultInput>;
  upsert?: InputMaybe<OrderUpsertWithoutReportableIdVerificationResultInput>;
};

export type OrderUpdateOneRequiredWithoutRequestedSearchesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutRequestedSearchesInput>;
  create?: InputMaybe<OrderCreateWithoutRequestedSearchesInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutRequestedSearchesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutRequestedSearchesInput>;
};

export type OrderUpdateOneWithoutAppFeedbackNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutAppFeedbackInput>;
  create?: InputMaybe<OrderCreateWithoutAppFeedbackInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutAppFeedbackInput>;
  upsert?: InputMaybe<OrderUpsertWithoutAppFeedbackInput>;
};

export type OrderUpdateOneWithoutBeamInputsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutBeamInputsInput>;
  create?: InputMaybe<OrderCreateWithoutBeamInputsInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutBeamInputsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutBeamInputsInput>;
};

export type OrderUpdateOneWithoutBeamOutputsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutBeamOutputsInput>;
  create?: InputMaybe<OrderCreateWithoutBeamOutputsInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutBeamOutputsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutBeamOutputsInput>;
};

export type OrderUpdateOneWithoutBiometricConsentAcceptanceNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutBiometricConsentAcceptanceInput>;
  create?: InputMaybe<OrderCreateWithoutBiometricConsentAcceptanceInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutBiometricConsentAcceptanceInput>;
  upsert?: InputMaybe<OrderUpsertWithoutBiometricConsentAcceptanceInput>;
};

export type OrderUpdateOneWithoutDisclosureAcceptancesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDisclosureAcceptancesInput>;
  create?: InputMaybe<OrderCreateWithoutDisclosureAcceptancesInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutDisclosureAcceptancesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutDisclosureAcceptancesInput>;
};

export type OrderUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<OrderCreateWithoutFilesInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutFilesInput>;
};

export type OrderUpdateOneWithoutResultsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<OrderCreateWithoutResultsInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutResultsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutResultsInput>;
};

export type OrderUpdateOneWithoutVidVoucherNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutVidVoucherInput>;
  create?: InputMaybe<OrderCreateWithoutVidVoucherInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutVidVoucherInput>;
  upsert?: InputMaybe<OrderUpsertWithoutVidVoucherInput>;
};

export type OrderUpdateToOneWithWhereWithoutAppFeedbackInput = {
  data: OrderUpdateWithoutAppFeedbackInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutApplicantDataInput = {
  data: OrderUpdateWithoutApplicantDataInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutBeamInputsInput = {
  data: OrderUpdateWithoutBeamInputsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutBeamOutputsInput = {
  data: OrderUpdateWithoutBeamOutputsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutBiometricConsentAcceptanceInput = {
  data: OrderUpdateWithoutBiometricConsentAcceptanceInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutDisclosureAcceptancesInput = {
  data: OrderUpdateWithoutDisclosureAcceptancesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutDispatchedSearchesInput = {
  data: OrderUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutDisputesInput = {
  data: OrderUpdateWithoutDisputesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutFilesInput = {
  data: OrderUpdateWithoutFilesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutMonitoringEnrollmentsInput = {
  data: OrderUpdateWithoutMonitoringEnrollmentsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutNotesInput = {
  data: OrderUpdateWithoutNotesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutReportableIdVerificationResultInput = {
  data: OrderUpdateWithoutReportableIdVerificationResultInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutRequestedSearchesInput = {
  data: OrderUpdateWithoutRequestedSearchesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutResultsInput = {
  data: OrderUpdateWithoutResultsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutVidVoucherInput = {
  data: OrderUpdateWithoutVidVoucherInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: OrderUpdateWithoutCreatedByInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: OrderUpdateWithoutOrganizationInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutPackageSetsInput = {
  data: OrderUpdateWithoutPackageSetsInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutUserInput = {
  data: OrderUpdateWithoutUserInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutWebhookInput = {
  data: OrderUpdateWithoutWebhookInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutAppFeedbackInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutApplicantDataInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutBeamInputsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutBeamOutputsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutBiometricConsentAcceptanceInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutCreatedByInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutDisclosureAcceptancesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutDispatchedSearchesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutDisputesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutFilesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutMonitoringEnrollmentsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutNotesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutOrganizationInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutPackageSetsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutReportableIdVerificationResultInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutRequestedSearchesInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutResultsInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutUserInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutVidVoucherInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  webhook?: InputMaybe<WebhookUpdateOneWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutWebhookInput = {
  additionalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  alert?: InputMaybe<NullableEnumOrderAlertEnumFieldUpdateOperationsInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  appFeedback?: InputMaybe<AppFeedbackUpdateOneWithoutOrderNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutOrderNestedInput>;
  backgroundReportUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  beamInputs?: InputMaybe<BeamInputUpdateManyWithoutOrderNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrderNestedInput>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceUpdateOneWithoutOrderNestedInput>;
  captureMethod?: InputMaybe<NullableEnumIdCaptureMethodFieldUpdateOperationsInput>;
  complianceLetters?: InputMaybe<ComplianceLetterUpdateManyWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrdersNestedInput>;
  customScore?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deleted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  deliveryMethod?: InputMaybe<NullableEnumOrderDeliveryMethodFieldUpdateOperationsInput>;
  deviceType?: InputMaybe<NullableEnumDeviceTypeEnumFieldUpdateOperationsInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutOrderNestedInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutOrderNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutOrderNestedInput>;
  fileNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  flagged?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalMetadata?: InputMaybe<Scalars['JSON']['input']>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipMetadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrderNestedInput>;
  notes?: InputMaybe<OrderNoteUpdateManyWithoutOrderNestedInput>;
  optOut?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutOrdersNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrdersNestedInput>;
  paid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parentOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportCompletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput>;
  reportableResults?: InputMaybe<Scalars['JSON']['input']>;
  reportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutOrderNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutOrderNestedInput>;
  score?: InputMaybe<NullableEnumOrderScoreEnumFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutMyOrdersNestedInput>;
  vIDVoucher?: InputMaybe<VidVoucherUpdateOneWithoutOrderNestedInput>;
};

export type OrderUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: OrderCreateWithoutCreatedByInput;
  update: OrderUpdateWithoutCreatedByInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: OrderCreateWithoutOrganizationInput;
  update: OrderUpdateWithoutOrganizationInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutPackageSetsInput = {
  create: OrderCreateWithoutPackageSetsInput;
  update: OrderUpdateWithoutPackageSetsInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutUserInput = {
  create: OrderCreateWithoutUserInput;
  update: OrderUpdateWithoutUserInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutWebhookInput = {
  create: OrderCreateWithoutWebhookInput;
  update: OrderUpdateWithoutWebhookInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithoutAppFeedbackInput = {
  create: OrderCreateWithoutAppFeedbackInput;
  update: OrderUpdateWithoutAppFeedbackInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutApplicantDataInput = {
  create: OrderCreateWithoutApplicantDataInput;
  update: OrderUpdateWithoutApplicantDataInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutBeamInputsInput = {
  create: OrderCreateWithoutBeamInputsInput;
  update: OrderUpdateWithoutBeamInputsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutBeamOutputsInput = {
  create: OrderCreateWithoutBeamOutputsInput;
  update: OrderUpdateWithoutBeamOutputsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutBiometricConsentAcceptanceInput = {
  create: OrderCreateWithoutBiometricConsentAcceptanceInput;
  update: OrderUpdateWithoutBiometricConsentAcceptanceInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutDisclosureAcceptancesInput = {
  create: OrderCreateWithoutDisclosureAcceptancesInput;
  update: OrderUpdateWithoutDisclosureAcceptancesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutDispatchedSearchesInput = {
  create: OrderCreateWithoutDispatchedSearchesInput;
  update: OrderUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutDisputesInput = {
  create: OrderCreateWithoutDisputesInput;
  update: OrderUpdateWithoutDisputesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutFilesInput = {
  create: OrderCreateWithoutFilesInput;
  update: OrderUpdateWithoutFilesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutMonitoringEnrollmentsInput = {
  create: OrderCreateWithoutMonitoringEnrollmentsInput;
  update: OrderUpdateWithoutMonitoringEnrollmentsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutNotesInput = {
  create: OrderCreateWithoutNotesInput;
  update: OrderUpdateWithoutNotesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutReportableIdVerificationResultInput = {
  create: OrderCreateWithoutReportableIdVerificationResultInput;
  update: OrderUpdateWithoutReportableIdVerificationResultInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutRequestedSearchesInput = {
  create: OrderCreateWithoutRequestedSearchesInput;
  update: OrderUpdateWithoutRequestedSearchesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutResultsInput = {
  create: OrderCreateWithoutResultsInput;
  update: OrderUpdateWithoutResultsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutVidVoucherInput = {
  create: OrderCreateWithoutVidVoucherInput;
  update: OrderUpdateWithoutVidVoucherInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  additionalMetadata?: InputMaybe<JsonNullableFilter>;
  alert?: InputMaybe<EnumOrderAlertEnumNullableFilter>;
  amount?: InputMaybe<FloatFilter>;
  appFeedback?: InputMaybe<AppFeedbackNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  backgroundReportUrl?: InputMaybe<StringNullableFilter>;
  beamInputs?: InputMaybe<BeamInputListRelationFilter>;
  beamOutputs?: InputMaybe<BeamOutputListRelationFilter>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceNullableScalarRelationFilter>;
  captureMethod?: InputMaybe<EnumIdCaptureMethodNullableFilter>;
  complianceLetters?: InputMaybe<ComplianceLetterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  customScore?: InputMaybe<StringNullableFilter>;
  deleted?: InputMaybe<BoolNullableFilter>;
  deliveryMethod?: InputMaybe<EnumOrderDeliveryMethodNullableFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableFilter>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceListRelationFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  fileNumber?: InputMaybe<StringFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  flagged?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalMetadata?: InputMaybe<JsonNullableFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  ipMetadata?: InputMaybe<JsonNullableFilter>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  notes?: InputMaybe<OrderNoteListRelationFilter>;
  optOut?: InputMaybe<BoolFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  paid?: InputMaybe<BoolFilter>;
  parentOrganizationId?: InputMaybe<StringNullableFilter>;
  postbackWebhookUrl?: InputMaybe<StringNullableFilter>;
  reportCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultNullableScalarRelationFilter>;
  reportableResults?: InputMaybe<JsonNullableFilter>;
  reportedAt?: InputMaybe<DateTimeNullableFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  results?: InputMaybe<ResultListRelationFilter>;
  score?: InputMaybe<EnumOrderScoreEnumNullableFilter>;
  status?: InputMaybe<EnumOrderStatusEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  vIDVoucher?: InputMaybe<VidVoucherNullableScalarRelationFilter>;
  webhook?: InputMaybe<WebhookNullableScalarRelationFilter>;
  webhookId?: InputMaybe<StringNullableFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  additionalMetadata?: InputMaybe<JsonNullableFilter>;
  alert?: InputMaybe<EnumOrderAlertEnumNullableFilter>;
  amount?: InputMaybe<FloatFilter>;
  appFeedback?: InputMaybe<AppFeedbackNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  backgroundReportUrl?: InputMaybe<StringNullableFilter>;
  beamInputs?: InputMaybe<BeamInputListRelationFilter>;
  beamOutputs?: InputMaybe<BeamOutputListRelationFilter>;
  biometricConsentAcceptance?: InputMaybe<BiometricConsentAcceptanceNullableScalarRelationFilter>;
  captureMethod?: InputMaybe<EnumIdCaptureMethodNullableFilter>;
  complianceLetters?: InputMaybe<ComplianceLetterListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  customScore?: InputMaybe<StringNullableFilter>;
  deleted?: InputMaybe<BoolNullableFilter>;
  deliveryMethod?: InputMaybe<EnumOrderDeliveryMethodNullableFilter>;
  deviceType?: InputMaybe<EnumDeviceTypeEnumNullableFilter>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceListRelationFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileListRelationFilter>;
  flagged?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalMetadata?: InputMaybe<JsonNullableFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  ipMetadata?: InputMaybe<JsonNullableFilter>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  notes?: InputMaybe<OrderNoteListRelationFilter>;
  optOut?: InputMaybe<BoolFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  paid?: InputMaybe<BoolFilter>;
  parentOrganizationId?: InputMaybe<StringNullableFilter>;
  postbackWebhookUrl?: InputMaybe<StringNullableFilter>;
  reportCompletedAt?: InputMaybe<DateTimeNullableFilter>;
  reportableIdVerificationResult?: InputMaybe<ReportableIdVerificationResultNullableScalarRelationFilter>;
  reportableResults?: InputMaybe<JsonNullableFilter>;
  reportedAt?: InputMaybe<DateTimeNullableFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  results?: InputMaybe<ResultListRelationFilter>;
  score?: InputMaybe<EnumOrderScoreEnumNullableFilter>;
  status?: InputMaybe<EnumOrderStatusEnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  vIDVoucher?: InputMaybe<VidVoucherNullableScalarRelationFilter>;
  webhook?: InputMaybe<WebhookNullableScalarRelationFilter>;
  webhookId?: InputMaybe<StringNullableFilter>;
};

export enum OrgRelationTypeEnum {
  Cra = 'CRA'
}

export type Organization = {
  __typename?: 'Organization';
  _count?: Maybe<OrganizationCount>;
  address: Array<Address>;
  affiliateOrgTo: Array<OrganizationRelation>;
  auditLogs: Array<AuditLog>;
  beamOutputs: Array<BeamOutput>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  credentials: Array<Credential>;
  dateOnboarded?: Maybe<Scalars['DateTimeISO']['output']>;
  delegateWebhooksToCra: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  disclosures: Array<Disclosure>;
  enableCraDisputeOnBehalfOfApplicant: Scalars['Boolean']['output'];
  enableDisputes: Scalars['Boolean']['output'];
  enableSupport?: Maybe<Scalars['Boolean']['output']>;
  hexColor?: Maybe<Scalars['String']['output']>;
  horizontalLogo?: Maybe<File>;
  horizontalLogoId?: Maybe<Scalars['String']['output']>;
  horizontalLogoUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invites: Array<Invite>;
  legalName: Scalars['String']['output'];
  logo?: Maybe<File>;
  logoId?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  members: Array<User>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  monitoringConfigurations: Array<MonitoringConfiguration>;
  monitoringEnrollments: Array<MonitoringEnrollment>;
  name: Scalars['String']['output'];
  orders: Array<Order>;
  packageAccesses: Array<PackageAccess>;
  packageSets: Array<PackageSet>;
  parentOrganization?: Maybe<Organization>;
  parentOrganizationId?: Maybe<Scalars['String']['output']>;
  passTypes: Array<PassType>;
  primaryOrgFor: Array<OrganizationRelation>;
  roleAssignment: Array<RoleAssignment>;
  secrets: Array<Secret>;
  shortName: Scalars['String']['output'];
  staticSiteEnabled: Scalars['Boolean']['output'];
  subOrganizations: Array<Organization>;
  synapseCaseFormation?: Maybe<SynapseCaseFormation>;
  synapseWorkflow: Array<SynapseWorkflow>;
  updatedAt: Scalars['DateTimeISO']['output'];
  vendorConfigurations: Array<VendorConfiguration>;
  webhooks: Array<Webhook>;
  website?: Maybe<Scalars['String']['output']>;
};


export type OrganizationAddressArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type OrganizationAffiliateOrgToArgs = {
  cursor?: InputMaybe<OrganizationRelationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationRelationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationRelationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationRelationWhereInput>;
};


export type OrganizationAuditLogsArgs = {
  cursor?: InputMaybe<AuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type OrganizationBeamOutputsArgs = {
  cursor?: InputMaybe<BeamOutputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamOutputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOutputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type OrganizationCreatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type OrganizationCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type OrganizationDisclosuresArgs = {
  cursor?: InputMaybe<DisclosureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureWhereInput>;
};


export type OrganizationHorizontalLogoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type OrganizationInvitesArgs = {
  cursor?: InputMaybe<InviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<InviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type OrganizationLogoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type OrganizationMembersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type OrganizationMonitoringConfigurationsArgs = {
  cursor?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};


export type OrganizationMonitoringEnrollmentsArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringEnrollmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type OrganizationOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type OrganizationPackageAccessesArgs = {
  cursor?: InputMaybe<PackageAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type OrganizationPackageSetsArgs = {
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageSetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageSetWhereInput>;
};


export type OrganizationParentOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type OrganizationPassTypesArgs = {
  cursor?: InputMaybe<PassTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassTypeWhereInput>;
};


export type OrganizationPrimaryOrgForArgs = {
  cursor?: InputMaybe<OrganizationRelationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationRelationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationRelationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationRelationWhereInput>;
};


export type OrganizationRoleAssignmentArgs = {
  cursor?: InputMaybe<RoleAssignmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleAssignmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleAssignmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleAssignmentWhereInput>;
};


export type OrganizationSecretsArgs = {
  cursor?: InputMaybe<SecretWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecretScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecretOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SecretWhereInput>;
};


export type OrganizationSubOrganizationsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type OrganizationSynapseCaseFormationArgs = {
  where?: InputMaybe<SynapseCaseFormationWhereInput>;
};


export type OrganizationSynapseWorkflowArgs = {
  cursor?: InputMaybe<SynapseWorkflowWhereUniqueInput>;
  distinct?: InputMaybe<Array<SynapseWorkflowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SynapseWorkflowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SynapseWorkflowWhereInput>;
};


export type OrganizationVendorConfigurationsArgs = {
  cursor?: InputMaybe<VendorConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VendorConfigurationWhereInput>;
};


export type OrganizationWebhooksArgs = {
  cursor?: InputMaybe<WebhookWhereUniqueInput>;
  distinct?: InputMaybe<Array<WebhookScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WebhookOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookWhereInput>;
};

export type OrganizationCount = {
  __typename?: 'OrganizationCount';
  address: Scalars['Int']['output'];
  affiliateOrgTo: Scalars['Int']['output'];
  auditLogs: Scalars['Int']['output'];
  beamOutputs: Scalars['Int']['output'];
  credentials: Scalars['Int']['output'];
  disclosures: Scalars['Int']['output'];
  invites: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  monitoringConfigurations: Scalars['Int']['output'];
  monitoringEnrollments: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  packageAccesses: Scalars['Int']['output'];
  packageSets: Scalars['Int']['output'];
  passTypes: Scalars['Int']['output'];
  primaryOrgFor: Scalars['Int']['output'];
  roleAssignment: Scalars['Int']['output'];
  secrets: Scalars['Int']['output'];
  subOrganizations: Scalars['Int']['output'];
  synapseWorkflow: Scalars['Int']['output'];
  vendorConfigurations: Scalars['Int']['output'];
  webhooks: Scalars['Int']['output'];
};


export type OrganizationCountAddressArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type OrganizationCountAffiliateOrgToArgs = {
  where?: InputMaybe<OrganizationRelationWhereInput>;
};


export type OrganizationCountAuditLogsArgs = {
  where?: InputMaybe<AuditLogWhereInput>;
};


export type OrganizationCountBeamOutputsArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type OrganizationCountCredentialsArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type OrganizationCountDisclosuresArgs = {
  where?: InputMaybe<DisclosureWhereInput>;
};


export type OrganizationCountInvitesArgs = {
  where?: InputMaybe<InviteWhereInput>;
};


export type OrganizationCountMembersArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type OrganizationCountMonitoringConfigurationsArgs = {
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};


export type OrganizationCountMonitoringEnrollmentsArgs = {
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type OrganizationCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type OrganizationCountPackageAccessesArgs = {
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type OrganizationCountPackageSetsArgs = {
  where?: InputMaybe<PackageSetWhereInput>;
};


export type OrganizationCountPassTypesArgs = {
  where?: InputMaybe<PassTypeWhereInput>;
};


export type OrganizationCountPrimaryOrgForArgs = {
  where?: InputMaybe<OrganizationRelationWhereInput>;
};


export type OrganizationCountRoleAssignmentArgs = {
  where?: InputMaybe<RoleAssignmentWhereInput>;
};


export type OrganizationCountSecretsArgs = {
  where?: InputMaybe<SecretWhereInput>;
};


export type OrganizationCountSubOrganizationsArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type OrganizationCountSynapseWorkflowArgs = {
  where?: InputMaybe<SynapseWorkflowWhereInput>;
};


export type OrganizationCountVendorConfigurationsArgs = {
  where?: InputMaybe<VendorConfigurationWhereInput>;
};


export type OrganizationCountWebhooksArgs = {
  where?: InputMaybe<WebhookWhereInput>;
};

export type OrganizationCountAggregate = {
  __typename?: 'OrganizationCountAggregate';
  _all: Scalars['Int']['output'];
  contactEmail: Scalars['Int']['output'];
  contactName: Scalars['Int']['output'];
  contactPhone: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdById: Scalars['Int']['output'];
  dateOnboarded: Scalars['Int']['output'];
  delegateWebhooksToCra: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  enableCraDisputeOnBehalfOfApplicant: Scalars['Int']['output'];
  enableDisputes: Scalars['Int']['output'];
  enableSupport: Scalars['Int']['output'];
  hexColor: Scalars['Int']['output'];
  horizontalLogoId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  legalName: Scalars['Int']['output'];
  logoId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  parentOrganizationId: Scalars['Int']['output'];
  shortName: Scalars['Int']['output'];
  staticSiteEnabled: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
};

export type OrganizationCreateInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateManyCreatedByInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogoId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  parentOrganizationId?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateManyCreatedByInputEnvelope = {
  data: Array<OrganizationCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationCreateManyParentOrganizationInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogoId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateManyParentOrganizationInputEnvelope = {
  data: Array<OrganizationCreateManyParentOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrganizationCreateManyCreatedByInputEnvelope>;
};

export type OrganizationCreateNestedManyWithoutDisclosuresInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutDisclosuresInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutDisclosuresInput>>;
};

export type OrganizationCreateNestedManyWithoutMembersInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutMembersInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutMembersInput>>;
};

export type OrganizationCreateNestedManyWithoutParentOrganizationInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutParentOrganizationInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutParentOrganizationInput>>;
  createMany?: InputMaybe<OrganizationCreateManyParentOrganizationInputEnvelope>;
};

export type OrganizationCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<OrganizationCreateWithoutAddressInput>;
};

export type OrganizationCreateNestedOneWithoutAffiliateOrgToInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAffiliateOrgToInput>;
  create?: InputMaybe<OrganizationCreateWithoutAffiliateOrgToInput>;
};

export type OrganizationCreateNestedOneWithoutBeamOutputsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutBeamOutputsInput>;
  create?: InputMaybe<OrganizationCreateWithoutBeamOutputsInput>;
};

export type OrganizationCreateNestedOneWithoutCredentialsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCredentialsInput>;
};

export type OrganizationCreateNestedOneWithoutHorizontalLogoInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutHorizontalLogoInput>;
  create?: InputMaybe<OrganizationCreateWithoutHorizontalLogoInput>;
};

export type OrganizationCreateNestedOneWithoutInvitesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutInvitesInput>;
  create?: InputMaybe<OrganizationCreateWithoutInvitesInput>;
};

export type OrganizationCreateNestedOneWithoutLogoInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutLogoInput>;
  create?: InputMaybe<OrganizationCreateWithoutLogoInput>;
};

export type OrganizationCreateNestedOneWithoutMonitoringConfigurationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutMonitoringConfigurationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutMonitoringConfigurationsInput>;
};

export type OrganizationCreateNestedOneWithoutMonitoringEnrollmentsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutMonitoringEnrollmentsInput>;
  create?: InputMaybe<OrganizationCreateWithoutMonitoringEnrollmentsInput>;
};

export type OrganizationCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<OrganizationCreateWithoutOrdersInput>;
};

export type OrganizationCreateNestedOneWithoutPackageAccessesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPackageAccessesInput>;
  create?: InputMaybe<OrganizationCreateWithoutPackageAccessesInput>;
};

export type OrganizationCreateNestedOneWithoutPackageSetsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPackageSetsInput>;
  create?: InputMaybe<OrganizationCreateWithoutPackageSetsInput>;
};

export type OrganizationCreateNestedOneWithoutPassTypesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPassTypesInput>;
  create?: InputMaybe<OrganizationCreateWithoutPassTypesInput>;
};

export type OrganizationCreateNestedOneWithoutPrimaryOrgForInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPrimaryOrgForInput>;
  create?: InputMaybe<OrganizationCreateWithoutPrimaryOrgForInput>;
};

export type OrganizationCreateNestedOneWithoutRoleAssignmentInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutRoleAssignmentInput>;
  create?: InputMaybe<OrganizationCreateWithoutRoleAssignmentInput>;
};

export type OrganizationCreateNestedOneWithoutSecretsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSecretsInput>;
  create?: InputMaybe<OrganizationCreateWithoutSecretsInput>;
};

export type OrganizationCreateNestedOneWithoutSubOrganizationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSubOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutSubOrganizationsInput>;
};

export type OrganizationCreateNestedOneWithoutSynapseCaseFormationInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSynapseCaseFormationInput>;
  create?: InputMaybe<OrganizationCreateWithoutSynapseCaseFormationInput>;
};

export type OrganizationCreateNestedOneWithoutSynapseWorkflowInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSynapseWorkflowInput>;
  create?: InputMaybe<OrganizationCreateWithoutSynapseWorkflowInput>;
};

export type OrganizationCreateNestedOneWithoutVendorConfigurationsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVendorConfigurationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutVendorConfigurationsInput>;
};

export type OrganizationCreateNestedOneWithoutWebhooksInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutWebhooksInput>;
  create?: InputMaybe<OrganizationCreateWithoutWebhooksInput>;
};

export type OrganizationCreateOrConnectWithoutAddressInput = {
  create: OrganizationCreateWithoutAddressInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutAffiliateOrgToInput = {
  create: OrganizationCreateWithoutAffiliateOrgToInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutBeamOutputsInput = {
  create: OrganizationCreateWithoutBeamOutputsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCreatedByInput = {
  create: OrganizationCreateWithoutCreatedByInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCredentialsInput = {
  create: OrganizationCreateWithoutCredentialsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDisclosuresInput = {
  create: OrganizationCreateWithoutDisclosuresInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutHorizontalLogoInput = {
  create: OrganizationCreateWithoutHorizontalLogoInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutInvitesInput = {
  create: OrganizationCreateWithoutInvitesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutLogoInput = {
  create: OrganizationCreateWithoutLogoInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutMembersInput = {
  create: OrganizationCreateWithoutMembersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutMonitoringConfigurationsInput = {
  create: OrganizationCreateWithoutMonitoringConfigurationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutMonitoringEnrollmentsInput = {
  create: OrganizationCreateWithoutMonitoringEnrollmentsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutOrdersInput = {
  create: OrganizationCreateWithoutOrdersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPackageAccessesInput = {
  create: OrganizationCreateWithoutPackageAccessesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPackageSetsInput = {
  create: OrganizationCreateWithoutPackageSetsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutParentOrganizationInput = {
  create: OrganizationCreateWithoutParentOrganizationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPassTypesInput = {
  create: OrganizationCreateWithoutPassTypesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutPrimaryOrgForInput = {
  create: OrganizationCreateWithoutPrimaryOrgForInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutRoleAssignmentInput = {
  create: OrganizationCreateWithoutRoleAssignmentInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSecretsInput = {
  create: OrganizationCreateWithoutSecretsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSubOrganizationsInput = {
  create: OrganizationCreateWithoutSubOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSynapseCaseFormationInput = {
  create: OrganizationCreateWithoutSynapseCaseFormationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutSynapseWorkflowInput = {
  create: OrganizationCreateWithoutSynapseWorkflowInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutVendorConfigurationsInput = {
  create: OrganizationCreateWithoutVendorConfigurationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutWebhooksInput = {
  create: OrganizationCreateWithoutWebhooksInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateWithoutAddressInput = {
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutAffiliateOrgToInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutBeamOutputsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCreatedByInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutCredentialsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutDisclosuresInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutHorizontalLogoInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutInvitesInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutLogoInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutMembersInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutMonitoringConfigurationsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutMonitoringEnrollmentsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutOrdersInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPackageAccessesInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPackageSetsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutParentOrganizationInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPassTypesInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutPrimaryOrgForInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutRoleAssignmentInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSecretsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSubOrganizationsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSynapseCaseFormationInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutSynapseWorkflowInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutVendorConfigurationsInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  webhooks?: InputMaybe<WebhookCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreateWithoutWebhooksInput = {
  address?: InputMaybe<AddressCreateNestedManyWithoutOrganizationInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutOrganizationInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutOrganizationInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedOrganizationsInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutOrganizationInput>;
  dateOnboarded?: InputMaybe<Scalars['DateTimeISO']['input']>;
  delegateWebhooksToCra?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutOrganizationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  enableDisputes?: InputMaybe<Scalars['Boolean']['input']>;
  enableSupport?: InputMaybe<Scalars['Boolean']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  horizontalLogo?: InputMaybe<FileCreateNestedOneWithoutOrganizationHorizontalLogoInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutOrganizationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<FileCreateNestedOneWithoutOrganizationLogoInput>;
  members?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationCreateNestedManyWithoutOrganizationInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutOrganizationInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutOrganizationInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutOrganizationInput>;
  parentOrganization?: InputMaybe<OrganizationCreateNestedOneWithoutSubOrganizationsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutOrganizationInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutOrganizationInput>;
  secrets?: InputMaybe<SecretCreateNestedManyWithoutOrganizationInput>;
  shortName: Scalars['String']['input'];
  staticSiteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutParentOrganizationInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationCreateNestedOneWithoutOrganizationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowCreateNestedManyWithoutOrganizationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutOrganizationInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationListRelationFilter = {
  every?: InputMaybe<OrganizationWhereInput>;
  none?: InputMaybe<OrganizationWhereInput>;
  some?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationMaxAggregate = {
  __typename?: 'OrganizationMaxAggregate';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  dateOnboarded?: Maybe<Scalars['DateTimeISO']['output']>;
  delegateWebhooksToCra?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enableCraDisputeOnBehalfOfApplicant?: Maybe<Scalars['Boolean']['output']>;
  enableDisputes?: Maybe<Scalars['Boolean']['output']>;
  enableSupport?: Maybe<Scalars['Boolean']['output']>;
  hexColor?: Maybe<Scalars['String']['output']>;
  horizontalLogoId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  logoId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentOrganizationId?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  staticSiteEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMinAggregate = {
  __typename?: 'OrganizationMinAggregate';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  dateOnboarded?: Maybe<Scalars['DateTimeISO']['output']>;
  delegateWebhooksToCra?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enableCraDisputeOnBehalfOfApplicant?: Maybe<Scalars['Boolean']['output']>;
  enableDisputes?: Maybe<Scalars['Boolean']['output']>;
  enableSupport?: Maybe<Scalars['Boolean']['output']>;
  hexColor?: Maybe<Scalars['String']['output']>;
  horizontalLogoId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  logoId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentOrganizationId?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  staticSiteEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationNullableScalarRelationFilter = {
  is?: InputMaybe<OrganizationWhereInput>;
  isNot?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrganizationOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByRelationAggregateInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationOrderByRelationAggregateInput>;
  auditLogs?: InputMaybe<AuditLogOrderByRelationAggregateInput>;
  beamOutputs?: InputMaybe<BeamOutputOrderByRelationAggregateInput>;
  contactEmail?: InputMaybe<SortOrderInput>;
  contactName?: InputMaybe<SortOrderInput>;
  contactPhone?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  credentials?: InputMaybe<CredentialOrderByRelationAggregateInput>;
  dateOnboarded?: InputMaybe<SortOrderInput>;
  delegateWebhooksToCra?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  disclosures?: InputMaybe<DisclosureOrderByRelationAggregateInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<SortOrder>;
  enableDisputes?: InputMaybe<SortOrder>;
  enableSupport?: InputMaybe<SortOrderInput>;
  hexColor?: InputMaybe<SortOrderInput>;
  horizontalLogo?: InputMaybe<FileOrderByWithRelationInput>;
  horizontalLogoId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invites?: InputMaybe<InviteOrderByRelationAggregateInput>;
  legalName?: InputMaybe<SortOrder>;
  logo?: InputMaybe<FileOrderByWithRelationInput>;
  logoId?: InputMaybe<SortOrderInput>;
  members?: InputMaybe<UserOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationOrderByRelationAggregateInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  packageAccesses?: InputMaybe<PackageAccessOrderByRelationAggregateInput>;
  packageSets?: InputMaybe<PackageSetOrderByRelationAggregateInput>;
  parentOrganization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  parentOrganizationId?: InputMaybe<SortOrderInput>;
  passTypes?: InputMaybe<PassTypeOrderByRelationAggregateInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationOrderByRelationAggregateInput>;
  roleAssignment?: InputMaybe<RoleAssignmentOrderByRelationAggregateInput>;
  secrets?: InputMaybe<SecretOrderByRelationAggregateInput>;
  shortName?: InputMaybe<SortOrder>;
  staticSiteEnabled?: InputMaybe<SortOrder>;
  subOrganizations?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationOrderByWithRelationInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendorConfigurations?: InputMaybe<VendorConfigurationOrderByRelationAggregateInput>;
  webhooks?: InputMaybe<WebhookOrderByRelationAggregateInput>;
  website?: InputMaybe<SortOrderInput>;
};

export type OrganizationRelation = {
  __typename?: 'OrganizationRelation';
  affiliateOrg: Organization;
  affiliateOrgId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  primaryOrg: Organization;
  primaryOrgId: Scalars['String']['output'];
  type: OrgRelationTypeEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationRelationAffiliateOrgIdPrimaryOrgIdCompoundUniqueInput = {
  affiliateOrgId: Scalars['String']['input'];
  primaryOrgId: Scalars['String']['input'];
};

export type OrganizationRelationCreateInput = {
  affiliateOrg: OrganizationCreateNestedOneWithoutAffiliateOrgToInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  primaryOrg: OrganizationCreateNestedOneWithoutPrimaryOrgForInput;
  type: OrgRelationTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganizationRelationCreateManyAffiliateOrgInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  primaryOrgId: Scalars['String']['input'];
  type: OrgRelationTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganizationRelationCreateManyAffiliateOrgInputEnvelope = {
  data: Array<OrganizationRelationCreateManyAffiliateOrgInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationRelationCreateManyPrimaryOrgInput = {
  affiliateOrgId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: OrgRelationTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganizationRelationCreateManyPrimaryOrgInputEnvelope = {
  data: Array<OrganizationRelationCreateManyPrimaryOrgInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationRelationCreateNestedManyWithoutAffiliateOrgInput = {
  connect?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationRelationCreateOrConnectWithoutAffiliateOrgInput>>;
  create?: InputMaybe<Array<OrganizationRelationCreateWithoutAffiliateOrgInput>>;
  createMany?: InputMaybe<OrganizationRelationCreateManyAffiliateOrgInputEnvelope>;
};

export type OrganizationRelationCreateNestedManyWithoutPrimaryOrgInput = {
  connect?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationRelationCreateOrConnectWithoutPrimaryOrgInput>>;
  create?: InputMaybe<Array<OrganizationRelationCreateWithoutPrimaryOrgInput>>;
  createMany?: InputMaybe<OrganizationRelationCreateManyPrimaryOrgInputEnvelope>;
};

export type OrganizationRelationCreateOrConnectWithoutAffiliateOrgInput = {
  create: OrganizationRelationCreateWithoutAffiliateOrgInput;
  where: OrganizationRelationWhereUniqueInput;
};

export type OrganizationRelationCreateOrConnectWithoutPrimaryOrgInput = {
  create: OrganizationRelationCreateWithoutPrimaryOrgInput;
  where: OrganizationRelationWhereUniqueInput;
};

export type OrganizationRelationCreateWithoutAffiliateOrgInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  primaryOrg: OrganizationCreateNestedOneWithoutPrimaryOrgForInput;
  type: OrgRelationTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganizationRelationCreateWithoutPrimaryOrgInput = {
  affiliateOrg: OrganizationCreateNestedOneWithoutAffiliateOrgToInput;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: OrgRelationTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrganizationRelationListRelationFilter = {
  every?: InputMaybe<OrganizationRelationWhereInput>;
  none?: InputMaybe<OrganizationRelationWhereInput>;
  some?: InputMaybe<OrganizationRelationWhereInput>;
};

export type OrganizationRelationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrganizationRelationOrderByWithRelationInput = {
  affiliateOrg?: InputMaybe<OrganizationOrderByWithRelationInput>;
  affiliateOrgId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  primaryOrg?: InputMaybe<OrganizationOrderByWithRelationInput>;
  primaryOrgId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrganizationRelationPrimaryOrgIdAffiliateOrgIdCompoundUniqueInput = {
  affiliateOrgId: Scalars['String']['input'];
  primaryOrgId: Scalars['String']['input'];
};

export enum OrganizationRelationScalarFieldEnum {
  AffiliateOrgId = 'affiliateOrgId',
  CreatedAt = 'createdAt',
  Id = 'id',
  PrimaryOrgId = 'primaryOrgId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type OrganizationRelationScalarWhereInput = {
  AND?: InputMaybe<Array<OrganizationRelationScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationRelationScalarWhereInput>>;
  OR?: InputMaybe<Array<OrganizationRelationScalarWhereInput>>;
  affiliateOrgId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  primaryOrgId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumOrgRelationTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrganizationRelationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrgRelationTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganizationRelationUpdateManyWithWhereWithoutAffiliateOrgInput = {
  data: OrganizationRelationUpdateManyMutationInput;
  where: OrganizationRelationScalarWhereInput;
};

export type OrganizationRelationUpdateManyWithWhereWithoutPrimaryOrgInput = {
  data: OrganizationRelationUpdateManyMutationInput;
  where: OrganizationRelationScalarWhereInput;
};

export type OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput = {
  connect?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationRelationCreateOrConnectWithoutAffiliateOrgInput>>;
  create?: InputMaybe<Array<OrganizationRelationCreateWithoutAffiliateOrgInput>>;
  createMany?: InputMaybe<OrganizationRelationCreateManyAffiliateOrgInputEnvelope>;
  delete?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationRelationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationRelationUpdateWithWhereUniqueWithoutAffiliateOrgInput>>;
  updateMany?: InputMaybe<Array<OrganizationRelationUpdateManyWithWhereWithoutAffiliateOrgInput>>;
  upsert?: InputMaybe<Array<OrganizationRelationUpsertWithWhereUniqueWithoutAffiliateOrgInput>>;
};

export type OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput = {
  connect?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationRelationCreateOrConnectWithoutPrimaryOrgInput>>;
  create?: InputMaybe<Array<OrganizationRelationCreateWithoutPrimaryOrgInput>>;
  createMany?: InputMaybe<OrganizationRelationCreateManyPrimaryOrgInputEnvelope>;
  delete?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationRelationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationRelationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationRelationUpdateWithWhereUniqueWithoutPrimaryOrgInput>>;
  updateMany?: InputMaybe<Array<OrganizationRelationUpdateManyWithWhereWithoutPrimaryOrgInput>>;
  upsert?: InputMaybe<Array<OrganizationRelationUpsertWithWhereUniqueWithoutPrimaryOrgInput>>;
};

export type OrganizationRelationUpdateWithWhereUniqueWithoutAffiliateOrgInput = {
  data: OrganizationRelationUpdateWithoutAffiliateOrgInput;
  where: OrganizationRelationWhereUniqueInput;
};

export type OrganizationRelationUpdateWithWhereUniqueWithoutPrimaryOrgInput = {
  data: OrganizationRelationUpdateWithoutPrimaryOrgInput;
  where: OrganizationRelationWhereUniqueInput;
};

export type OrganizationRelationUpdateWithoutAffiliateOrgInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  primaryOrg?: InputMaybe<OrganizationUpdateOneRequiredWithoutPrimaryOrgForNestedInput>;
  type?: InputMaybe<EnumOrgRelationTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganizationRelationUpdateWithoutPrimaryOrgInput = {
  affiliateOrg?: InputMaybe<OrganizationUpdateOneRequiredWithoutAffiliateOrgToNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrgRelationTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrganizationRelationUpsertWithWhereUniqueWithoutAffiliateOrgInput = {
  create: OrganizationRelationCreateWithoutAffiliateOrgInput;
  update: OrganizationRelationUpdateWithoutAffiliateOrgInput;
  where: OrganizationRelationWhereUniqueInput;
};

export type OrganizationRelationUpsertWithWhereUniqueWithoutPrimaryOrgInput = {
  create: OrganizationRelationCreateWithoutPrimaryOrgInput;
  update: OrganizationRelationUpdateWithoutPrimaryOrgInput;
  where: OrganizationRelationWhereUniqueInput;
};

export type OrganizationRelationWhereInput = {
  AND?: InputMaybe<Array<OrganizationRelationWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationRelationWhereInput>>;
  OR?: InputMaybe<Array<OrganizationRelationWhereInput>>;
  affiliateOrg?: InputMaybe<OrganizationScalarRelationFilter>;
  affiliateOrgId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  primaryOrg?: InputMaybe<OrganizationScalarRelationFilter>;
  primaryOrgId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumOrgRelationTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrganizationRelationWhereUniqueInput = {
  AND?: InputMaybe<Array<OrganizationRelationWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationRelationWhereInput>>;
  OR?: InputMaybe<Array<OrganizationRelationWhereInput>>;
  affiliateOrg?: InputMaybe<OrganizationScalarRelationFilter>;
  affiliateOrgId?: InputMaybe<StringFilter>;
  affiliateOrgId_primaryOrgId?: InputMaybe<OrganizationRelationAffiliateOrgIdPrimaryOrgIdCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  primaryOrg?: InputMaybe<OrganizationScalarRelationFilter>;
  primaryOrgId?: InputMaybe<StringFilter>;
  primaryOrgId_affiliateOrgId?: InputMaybe<OrganizationRelationPrimaryOrgIdAffiliateOrgIdCompoundUniqueInput>;
  type?: InputMaybe<EnumOrgRelationTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrganizationRes = {
  __typename?: 'OrganizationRes';
  craAccentColor?: Maybe<Scalars['String']['output']>;
  craContactEmail?: Maybe<Scalars['String']['output']>;
  craHorizontalLogoUrl?: Maybe<Scalars['String']['output']>;
  craLogoUrl?: Maybe<Scalars['String']['output']>;
  craName?: Maybe<Scalars['String']['output']>;
  enableCraDisputeOnBehalfOfApplicant: Scalars['Boolean']['output'];
  enableDisputes: Scalars['Boolean']['output'];
  enableSupport?: Maybe<Scalars['Boolean']['output']>;
  hexColor?: Maybe<Scalars['String']['output']>;
  horizontalLogoUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  useCraBranding: Scalars['Boolean']['output'];
};

export enum OrganizationScalarFieldEnum {
  ContactEmail = 'contactEmail',
  ContactName = 'contactName',
  ContactPhone = 'contactPhone',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  DateOnboarded = 'dateOnboarded',
  DelegateWebhooksToCra = 'delegateWebhooksToCra',
  DeletedAt = 'deletedAt',
  EnableCraDisputeOnBehalfOfApplicant = 'enableCraDisputeOnBehalfOfApplicant',
  EnableDisputes = 'enableDisputes',
  EnableSupport = 'enableSupport',
  HexColor = 'hexColor',
  HorizontalLogoId = 'horizontalLogoId',
  Id = 'id',
  LegalName = 'legalName',
  LogoId = 'logoId',
  Metadata = 'metadata',
  Name = 'name',
  ParentOrganizationId = 'parentOrganizationId',
  ShortName = 'shortName',
  StaticSiteEnabled = 'staticSiteEnabled',
  UpdatedAt = 'updatedAt',
  Website = 'website'
}

export type OrganizationScalarRelationFilter = {
  is?: InputMaybe<OrganizationWhereInput>;
  isNot?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationScalarWhereInput = {
  AND?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  OR?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  contactEmail?: InputMaybe<StringNullableFilter>;
  contactName?: InputMaybe<StringNullableFilter>;
  contactPhone?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  dateOnboarded?: InputMaybe<DateTimeNullableFilter>;
  delegateWebhooksToCra?: InputMaybe<BoolFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFilter>;
  enableDisputes?: InputMaybe<BoolFilter>;
  enableSupport?: InputMaybe<BoolNullableFilter>;
  hexColor?: InputMaybe<StringNullableFilter>;
  horizontalLogoId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legalName?: InputMaybe<StringFilter>;
  logoId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  parentOrganizationId?: InputMaybe<StringNullableFilter>;
  shortName?: InputMaybe<StringFilter>;
  staticSiteEnabled?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type OrganizationUpdateInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateManyMutationInput = {
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateManyWithWhereWithoutCreatedByInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutDisclosuresInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutMembersInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutParentOrganizationInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<OrganizationCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type OrganizationUpdateManyWithoutDisclosuresNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutDisclosuresInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutDisclosuresInput>>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutDisclosuresInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutDisclosuresInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutDisclosuresInput>>;
};

export type OrganizationUpdateManyWithoutMembersNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutMembersInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutMembersInput>>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutMembersInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutMembersInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutMembersInput>>;
};

export type OrganizationUpdateManyWithoutParentOrganizationNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutParentOrganizationInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutParentOrganizationInput>>;
  createMany?: InputMaybe<OrganizationCreateManyParentOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutParentOrganizationInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutParentOrganizationInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutParentOrganizationInput>>;
};

export type OrganizationUpdateOneRequiredWithoutAffiliateOrgToNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAffiliateOrgToInput>;
  create?: InputMaybe<OrganizationCreateWithoutAffiliateOrgToInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutAffiliateOrgToInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutAffiliateOrgToInput>;
};

export type OrganizationUpdateOneRequiredWithoutBeamOutputsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutBeamOutputsInput>;
  create?: InputMaybe<OrganizationCreateWithoutBeamOutputsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutBeamOutputsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutBeamOutputsInput>;
};

export type OrganizationUpdateOneRequiredWithoutInvitesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutInvitesInput>;
  create?: InputMaybe<OrganizationCreateWithoutInvitesInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutInvitesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutInvitesInput>;
};

export type OrganizationUpdateOneRequiredWithoutMonitoringConfigurationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutMonitoringConfigurationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutMonitoringConfigurationsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutMonitoringConfigurationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutMonitoringConfigurationsInput>;
};

export type OrganizationUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutMonitoringEnrollmentsInput>;
  create?: InputMaybe<OrganizationCreateWithoutMonitoringEnrollmentsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutMonitoringEnrollmentsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutMonitoringEnrollmentsInput>;
};

export type OrganizationUpdateOneRequiredWithoutPackageAccessesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPackageAccessesInput>;
  create?: InputMaybe<OrganizationCreateWithoutPackageAccessesInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPackageAccessesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPackageAccessesInput>;
};

export type OrganizationUpdateOneRequiredWithoutPassTypesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPassTypesInput>;
  create?: InputMaybe<OrganizationCreateWithoutPassTypesInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPassTypesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPassTypesInput>;
};

export type OrganizationUpdateOneRequiredWithoutPrimaryOrgForNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPrimaryOrgForInput>;
  create?: InputMaybe<OrganizationCreateWithoutPrimaryOrgForInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPrimaryOrgForInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPrimaryOrgForInput>;
};

export type OrganizationUpdateOneRequiredWithoutSynapseCaseFormationNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSynapseCaseFormationInput>;
  create?: InputMaybe<OrganizationCreateWithoutSynapseCaseFormationInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutSynapseCaseFormationInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutSynapseCaseFormationInput>;
};

export type OrganizationUpdateOneRequiredWithoutSynapseWorkflowNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSynapseWorkflowInput>;
  create?: InputMaybe<OrganizationCreateWithoutSynapseWorkflowInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutSynapseWorkflowInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutSynapseWorkflowInput>;
};

export type OrganizationUpdateOneRequiredWithoutVendorConfigurationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutVendorConfigurationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutVendorConfigurationsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutVendorConfigurationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutVendorConfigurationsInput>;
};

export type OrganizationUpdateOneRequiredWithoutWebhooksNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutWebhooksInput>;
  create?: InputMaybe<OrganizationCreateWithoutWebhooksInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutWebhooksInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutWebhooksInput>;
};

export type OrganizationUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<OrganizationCreateWithoutAddressInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutAddressInput>;
};

export type OrganizationUpdateOneWithoutCredentialsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCredentialsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCredentialsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCredentialsInput>;
};

export type OrganizationUpdateOneWithoutHorizontalLogoNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutHorizontalLogoInput>;
  create?: InputMaybe<OrganizationCreateWithoutHorizontalLogoInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutHorizontalLogoInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutHorizontalLogoInput>;
};

export type OrganizationUpdateOneWithoutLogoNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutLogoInput>;
  create?: InputMaybe<OrganizationCreateWithoutLogoInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutLogoInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutLogoInput>;
};

export type OrganizationUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<OrganizationCreateWithoutOrdersInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutOrdersInput>;
};

export type OrganizationUpdateOneWithoutPackageSetsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutPackageSetsInput>;
  create?: InputMaybe<OrganizationCreateWithoutPackageSetsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutPackageSetsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutPackageSetsInput>;
};

export type OrganizationUpdateOneWithoutRoleAssignmentNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutRoleAssignmentInput>;
  create?: InputMaybe<OrganizationCreateWithoutRoleAssignmentInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutRoleAssignmentInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutRoleAssignmentInput>;
};

export type OrganizationUpdateOneWithoutSecretsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSecretsInput>;
  create?: InputMaybe<OrganizationCreateWithoutSecretsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutSecretsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutSecretsInput>;
};

export type OrganizationUpdateOneWithoutSubOrganizationsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutSubOrganizationsInput>;
  create?: InputMaybe<OrganizationCreateWithoutSubOrganizationsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutSubOrganizationsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutSubOrganizationsInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutAddressInput = {
  data: OrganizationUpdateWithoutAddressInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutAffiliateOrgToInput = {
  data: OrganizationUpdateWithoutAffiliateOrgToInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutBeamOutputsInput = {
  data: OrganizationUpdateWithoutBeamOutputsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCredentialsInput = {
  data: OrganizationUpdateWithoutCredentialsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutHorizontalLogoInput = {
  data: OrganizationUpdateWithoutHorizontalLogoInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutInvitesInput = {
  data: OrganizationUpdateWithoutInvitesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutLogoInput = {
  data: OrganizationUpdateWithoutLogoInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutMonitoringConfigurationsInput = {
  data: OrganizationUpdateWithoutMonitoringConfigurationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutMonitoringEnrollmentsInput = {
  data: OrganizationUpdateWithoutMonitoringEnrollmentsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutOrdersInput = {
  data: OrganizationUpdateWithoutOrdersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPackageAccessesInput = {
  data: OrganizationUpdateWithoutPackageAccessesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPackageSetsInput = {
  data: OrganizationUpdateWithoutPackageSetsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPassTypesInput = {
  data: OrganizationUpdateWithoutPassTypesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutPrimaryOrgForInput = {
  data: OrganizationUpdateWithoutPrimaryOrgForInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutRoleAssignmentInput = {
  data: OrganizationUpdateWithoutRoleAssignmentInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutSecretsInput = {
  data: OrganizationUpdateWithoutSecretsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutSubOrganizationsInput = {
  data: OrganizationUpdateWithoutSubOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutSynapseCaseFormationInput = {
  data: OrganizationUpdateWithoutSynapseCaseFormationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutSynapseWorkflowInput = {
  data: OrganizationUpdateWithoutSynapseWorkflowInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutVendorConfigurationsInput = {
  data: OrganizationUpdateWithoutVendorConfigurationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutWebhooksInput = {
  data: OrganizationUpdateWithoutWebhooksInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: OrganizationUpdateWithoutCreatedByInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutDisclosuresInput = {
  data: OrganizationUpdateWithoutDisclosuresInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutMembersInput = {
  data: OrganizationUpdateWithoutMembersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutParentOrganizationInput = {
  data: OrganizationUpdateWithoutParentOrganizationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithoutAddressInput = {
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutAffiliateOrgToInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutBeamOutputsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCreatedByInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutCredentialsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutDisclosuresInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutHorizontalLogoInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutInvitesInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutLogoInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutMembersInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutMonitoringConfigurationsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutMonitoringEnrollmentsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutOrdersInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPackageAccessesInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPackageSetsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutParentOrganizationInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPassTypesInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutPrimaryOrgForInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutRoleAssignmentInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSecretsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSubOrganizationsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSynapseCaseFormationInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutSynapseWorkflowInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutVendorConfigurationsInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  webhooks?: InputMaybe<WebhookUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpdateWithoutWebhooksInput = {
  address?: InputMaybe<AddressUpdateManyWithoutOrganizationNestedInput>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationUpdateManyWithoutAffiliateOrgNestedInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutOrganizationNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutOrganizationNestedInput>;
  contactEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  contactPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedOrganizationsNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutOrganizationNestedInput>;
  dateOnboarded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  delegateWebhooksToCra?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutOrganizationsNestedInput>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableDisputes?: InputMaybe<BoolFieldUpdateOperationsInput>;
  enableSupport?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hexColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  horizontalLogo?: InputMaybe<FileUpdateOneWithoutOrganizationHorizontalLogoNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invites?: InputMaybe<InviteUpdateManyWithoutOrganizationNestedInput>;
  legalName?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<FileUpdateOneWithoutOrganizationLogoNestedInput>;
  members?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationUpdateManyWithoutOrganizationNestedInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutOrganizationNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutOrganizationNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutOrganizationNestedInput>;
  parentOrganization?: InputMaybe<OrganizationUpdateOneWithoutSubOrganizationsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutOrganizationNestedInput>;
  primaryOrgFor?: InputMaybe<OrganizationRelationUpdateManyWithoutPrimaryOrgNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutOrganizationNestedInput>;
  secrets?: InputMaybe<SecretUpdateManyWithoutOrganizationNestedInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  staticSiteEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subOrganizations?: InputMaybe<OrganizationUpdateManyWithoutParentOrganizationNestedInput>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowUpdateManyWithoutOrganizationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutOrganizationNestedInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrganizationUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: OrganizationCreateWithoutCreatedByInput;
  update: OrganizationUpdateWithoutCreatedByInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutDisclosuresInput = {
  create: OrganizationCreateWithoutDisclosuresInput;
  update: OrganizationUpdateWithoutDisclosuresInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutMembersInput = {
  create: OrganizationCreateWithoutMembersInput;
  update: OrganizationUpdateWithoutMembersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutParentOrganizationInput = {
  create: OrganizationCreateWithoutParentOrganizationInput;
  update: OrganizationUpdateWithoutParentOrganizationInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithoutAddressInput = {
  create: OrganizationCreateWithoutAddressInput;
  update: OrganizationUpdateWithoutAddressInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutAffiliateOrgToInput = {
  create: OrganizationCreateWithoutAffiliateOrgToInput;
  update: OrganizationUpdateWithoutAffiliateOrgToInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutBeamOutputsInput = {
  create: OrganizationCreateWithoutBeamOutputsInput;
  update: OrganizationUpdateWithoutBeamOutputsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCredentialsInput = {
  create: OrganizationCreateWithoutCredentialsInput;
  update: OrganizationUpdateWithoutCredentialsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutHorizontalLogoInput = {
  create: OrganizationCreateWithoutHorizontalLogoInput;
  update: OrganizationUpdateWithoutHorizontalLogoInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutInvitesInput = {
  create: OrganizationCreateWithoutInvitesInput;
  update: OrganizationUpdateWithoutInvitesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutLogoInput = {
  create: OrganizationCreateWithoutLogoInput;
  update: OrganizationUpdateWithoutLogoInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutMonitoringConfigurationsInput = {
  create: OrganizationCreateWithoutMonitoringConfigurationsInput;
  update: OrganizationUpdateWithoutMonitoringConfigurationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutMonitoringEnrollmentsInput = {
  create: OrganizationCreateWithoutMonitoringEnrollmentsInput;
  update: OrganizationUpdateWithoutMonitoringEnrollmentsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutOrdersInput = {
  create: OrganizationCreateWithoutOrdersInput;
  update: OrganizationUpdateWithoutOrdersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPackageAccessesInput = {
  create: OrganizationCreateWithoutPackageAccessesInput;
  update: OrganizationUpdateWithoutPackageAccessesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPackageSetsInput = {
  create: OrganizationCreateWithoutPackageSetsInput;
  update: OrganizationUpdateWithoutPackageSetsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPassTypesInput = {
  create: OrganizationCreateWithoutPassTypesInput;
  update: OrganizationUpdateWithoutPassTypesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutPrimaryOrgForInput = {
  create: OrganizationCreateWithoutPrimaryOrgForInput;
  update: OrganizationUpdateWithoutPrimaryOrgForInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutRoleAssignmentInput = {
  create: OrganizationCreateWithoutRoleAssignmentInput;
  update: OrganizationUpdateWithoutRoleAssignmentInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutSecretsInput = {
  create: OrganizationCreateWithoutSecretsInput;
  update: OrganizationUpdateWithoutSecretsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutSubOrganizationsInput = {
  create: OrganizationCreateWithoutSubOrganizationsInput;
  update: OrganizationUpdateWithoutSubOrganizationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutSynapseCaseFormationInput = {
  create: OrganizationCreateWithoutSynapseCaseFormationInput;
  update: OrganizationUpdateWithoutSynapseCaseFormationInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutSynapseWorkflowInput = {
  create: OrganizationCreateWithoutSynapseWorkflowInput;
  update: OrganizationUpdateWithoutSynapseWorkflowInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutVendorConfigurationsInput = {
  create: OrganizationCreateWithoutVendorConfigurationsInput;
  update: OrganizationUpdateWithoutVendorConfigurationsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutWebhooksInput = {
  create: OrganizationCreateWithoutWebhooksInput;
  update: OrganizationUpdateWithoutWebhooksInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationWhereInput = {
  AND?: InputMaybe<Array<OrganizationWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationWhereInput>>;
  OR?: InputMaybe<Array<OrganizationWhereInput>>;
  address?: InputMaybe<AddressListRelationFilter>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationListRelationFilter>;
  auditLogs?: InputMaybe<AuditLogListRelationFilter>;
  beamOutputs?: InputMaybe<BeamOutputListRelationFilter>;
  contactEmail?: InputMaybe<StringNullableFilter>;
  contactName?: InputMaybe<StringNullableFilter>;
  contactPhone?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  dateOnboarded?: InputMaybe<DateTimeNullableFilter>;
  delegateWebhooksToCra?: InputMaybe<BoolFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclosures?: InputMaybe<DisclosureListRelationFilter>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFilter>;
  enableDisputes?: InputMaybe<BoolFilter>;
  enableSupport?: InputMaybe<BoolNullableFilter>;
  hexColor?: InputMaybe<StringNullableFilter>;
  horizontalLogo?: InputMaybe<FileNullableScalarRelationFilter>;
  horizontalLogoId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invites?: InputMaybe<InviteListRelationFilter>;
  legalName?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileNullableScalarRelationFilter>;
  logoId?: InputMaybe<StringNullableFilter>;
  members?: InputMaybe<UserListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationListRelationFilter>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  packageAccesses?: InputMaybe<PackageAccessListRelationFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  parentOrganization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  parentOrganizationId?: InputMaybe<StringNullableFilter>;
  passTypes?: InputMaybe<PassTypeListRelationFilter>;
  primaryOrgFor?: InputMaybe<OrganizationRelationListRelationFilter>;
  roleAssignment?: InputMaybe<RoleAssignmentListRelationFilter>;
  secrets?: InputMaybe<SecretListRelationFilter>;
  shortName?: InputMaybe<StringFilter>;
  staticSiteEnabled?: InputMaybe<BoolFilter>;
  subOrganizations?: InputMaybe<OrganizationListRelationFilter>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationNullableScalarRelationFilter>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorConfigurations?: InputMaybe<VendorConfigurationListRelationFilter>;
  webhooks?: InputMaybe<WebhookListRelationFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type OrganizationWhereUniqueInput = {
  AND?: InputMaybe<Array<OrganizationWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationWhereInput>>;
  OR?: InputMaybe<Array<OrganizationWhereInput>>;
  address?: InputMaybe<AddressListRelationFilter>;
  affiliateOrgTo?: InputMaybe<OrganizationRelationListRelationFilter>;
  auditLogs?: InputMaybe<AuditLogListRelationFilter>;
  beamOutputs?: InputMaybe<BeamOutputListRelationFilter>;
  contactEmail?: InputMaybe<StringNullableFilter>;
  contactName?: InputMaybe<StringNullableFilter>;
  contactPhone?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  dateOnboarded?: InputMaybe<DateTimeNullableFilter>;
  delegateWebhooksToCra?: InputMaybe<BoolFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  disclosures?: InputMaybe<DisclosureListRelationFilter>;
  enableCraDisputeOnBehalfOfApplicant?: InputMaybe<BoolFilter>;
  enableDisputes?: InputMaybe<BoolFilter>;
  enableSupport?: InputMaybe<BoolNullableFilter>;
  hexColor?: InputMaybe<StringNullableFilter>;
  horizontalLogo?: InputMaybe<FileNullableScalarRelationFilter>;
  horizontalLogoId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invites?: InputMaybe<InviteListRelationFilter>;
  legalName?: InputMaybe<StringFilter>;
  logo?: InputMaybe<FileNullableScalarRelationFilter>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<UserListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringConfigurations?: InputMaybe<MonitoringConfigurationListRelationFilter>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  packageAccesses?: InputMaybe<PackageAccessListRelationFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  parentOrganization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  parentOrganizationId?: InputMaybe<StringNullableFilter>;
  passTypes?: InputMaybe<PassTypeListRelationFilter>;
  primaryOrgFor?: InputMaybe<OrganizationRelationListRelationFilter>;
  roleAssignment?: InputMaybe<RoleAssignmentListRelationFilter>;
  secrets?: InputMaybe<SecretListRelationFilter>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  staticSiteEnabled?: InputMaybe<BoolFilter>;
  subOrganizations?: InputMaybe<OrganizationListRelationFilter>;
  synapseCaseFormation?: InputMaybe<SynapseCaseFormationNullableScalarRelationFilter>;
  synapseWorkflow?: InputMaybe<SynapseWorkflowListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorConfigurations?: InputMaybe<VendorConfigurationListRelationFilter>;
  webhooks?: InputMaybe<WebhookListRelationFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type PackageAccess = {
  __typename?: 'PackageAccess';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  packageSet: PackageSet;
  packageSetId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PackageAccessCountAggregate = {
  __typename?: 'PackageAccessCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  packageSetId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PackageAccessCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutPackageAccessesInput;
  packageSet: PackageSetCreateNestedOneWithoutPackageAccessesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageAccessCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageSetId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageAccessCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  packageSetId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageAccessCreateManyOrganizationInputEnvelope = {
  data: Array<PackageAccessCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageAccessCreateManyPackageSetInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageAccessCreateManyPackageSetInputEnvelope = {
  data: Array<PackageAccessCreateManyPackageSetInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageAccessCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageAccessCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<PackageAccessCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<PackageAccessCreateManyOrganizationInputEnvelope>;
};

export type PackageAccessCreateNestedManyWithoutPackageSetInput = {
  connect?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageAccessCreateOrConnectWithoutPackageSetInput>>;
  create?: InputMaybe<Array<PackageAccessCreateWithoutPackageSetInput>>;
  createMany?: InputMaybe<PackageAccessCreateManyPackageSetInputEnvelope>;
};

export type PackageAccessCreateOrConnectWithoutOrganizationInput = {
  create: PackageAccessCreateWithoutOrganizationInput;
  where: PackageAccessWhereUniqueInput;
};

export type PackageAccessCreateOrConnectWithoutPackageSetInput = {
  create: PackageAccessCreateWithoutPackageSetInput;
  where: PackageAccessWhereUniqueInput;
};

export type PackageAccessCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  packageSet: PackageSetCreateNestedOneWithoutPackageAccessesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageAccessCreateWithoutPackageSetInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutPackageAccessesInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageAccessListRelationFilter = {
  every?: InputMaybe<PackageAccessWhereInput>;
  none?: InputMaybe<PackageAccessWhereInput>;
  some?: InputMaybe<PackageAccessWhereInput>;
};

export type PackageAccessMaxAggregate = {
  __typename?: 'PackageAccessMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSetId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PackageAccessMinAggregate = {
  __typename?: 'PackageAccessMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSetId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PackageAccessOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PackageAccessOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  packageSet?: InputMaybe<PackageSetOrderByWithRelationInput>;
  packageSetId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PackageAccessPackageSetIdOrganizationIdCompoundUniqueInput = {
  organizationId: Scalars['String']['input'];
  packageSetId: Scalars['String']['input'];
};

export enum PackageAccessScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  PackageSetId = 'packageSetId',
  UpdatedAt = 'updatedAt'
}

export type PackageAccessScalarWhereInput = {
  AND?: InputMaybe<Array<PackageAccessScalarWhereInput>>;
  NOT?: InputMaybe<Array<PackageAccessScalarWhereInput>>;
  OR?: InputMaybe<Array<PackageAccessScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PackageAccessUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPackageAccessesNestedInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutPackageAccessesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageAccessUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageAccessUpdateManyWithWhereWithoutOrganizationInput = {
  data: PackageAccessUpdateManyMutationInput;
  where: PackageAccessScalarWhereInput;
};

export type PackageAccessUpdateManyWithWhereWithoutPackageSetInput = {
  data: PackageAccessUpdateManyMutationInput;
  where: PackageAccessScalarWhereInput;
};

export type PackageAccessUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageAccessCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<PackageAccessCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<PackageAccessCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageAccessUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<PackageAccessUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<PackageAccessUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type PackageAccessUpdateManyWithoutPackageSetNestedInput = {
  connect?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageAccessCreateOrConnectWithoutPackageSetInput>>;
  create?: InputMaybe<Array<PackageAccessCreateWithoutPackageSetInput>>;
  createMany?: InputMaybe<PackageAccessCreateManyPackageSetInputEnvelope>;
  delete?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageAccessUpdateWithWhereUniqueWithoutPackageSetInput>>;
  updateMany?: InputMaybe<Array<PackageAccessUpdateManyWithWhereWithoutPackageSetInput>>;
  upsert?: InputMaybe<Array<PackageAccessUpsertWithWhereUniqueWithoutPackageSetInput>>;
};

export type PackageAccessUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: PackageAccessUpdateWithoutOrganizationInput;
  where: PackageAccessWhereUniqueInput;
};

export type PackageAccessUpdateWithWhereUniqueWithoutPackageSetInput = {
  data: PackageAccessUpdateWithoutPackageSetInput;
  where: PackageAccessWhereUniqueInput;
};

export type PackageAccessUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutPackageAccessesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageAccessUpdateWithoutPackageSetInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPackageAccessesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageAccessUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: PackageAccessCreateWithoutOrganizationInput;
  update: PackageAccessUpdateWithoutOrganizationInput;
  where: PackageAccessWhereUniqueInput;
};

export type PackageAccessUpsertWithWhereUniqueWithoutPackageSetInput = {
  create: PackageAccessCreateWithoutPackageSetInput;
  update: PackageAccessUpdateWithoutPackageSetInput;
  where: PackageAccessWhereUniqueInput;
};

export type PackageAccessWhereInput = {
  AND?: InputMaybe<Array<PackageAccessWhereInput>>;
  NOT?: InputMaybe<Array<PackageAccessWhereInput>>;
  OR?: InputMaybe<Array<PackageAccessWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSet?: InputMaybe<PackageSetScalarRelationFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PackageAccessWhereUniqueInput = {
  AND?: InputMaybe<Array<PackageAccessWhereInput>>;
  NOT?: InputMaybe<Array<PackageAccessWhereInput>>;
  OR?: InputMaybe<Array<PackageAccessWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSet?: InputMaybe<PackageSetScalarRelationFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  packageSetId_organizationId?: InputMaybe<PackageAccessPackageSetIdOrganizationIdCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PackageSet = {
  __typename?: 'PackageSet';
  _count?: Maybe<PackageSetCount>;
  allowEmbeddedRegistrationPortal?: Maybe<Scalars['Boolean']['output']>;
  amount: Scalars['Int']['output'];
  amountPrecision: CurrencyMultiplierEnum;
  collectSSN?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyTypeEnum;
  description?: Maybe<Scalars['String']['output']>;
  disclosures: Array<Disclosure>;
  id: Scalars['String']['output'];
  idExpiryByDate?: Maybe<Scalars['DateTimeISO']['output']>;
  idExpiryByMonths?: Maybe<Scalars['Int']['output']>;
  inviteExpiringPeriod?: Maybe<Scalars['Int']['output']>;
  inviteReminderPeriod?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  monitoringConfiguration?: Maybe<MonitoringConfiguration>;
  name: Scalars['String']['output'];
  oneAndDone?: Maybe<Scalars['Boolean']['output']>;
  orders: Array<Order>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageAccesses: Array<PackageAccess>;
  packageSetType?: Maybe<PackageSetType>;
  packageSetTypeId?: Maybe<Scalars['String']['output']>;
  passTypes: Array<PassType>;
  postbackWebhookUrl?: Maybe<Scalars['String']['output']>;
  searchTypes: Array<SearchType>;
  sendInviteReminders?: Maybe<Scalars['Boolean']['output']>;
  shortName: Scalars['String']['output'];
  showDisclosures?: Maybe<Scalars['Boolean']['output']>;
  skipNameVerification?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  usePassiveLiveness?: Maybe<Scalars['Boolean']['output']>;
  useSampleId?: Maybe<Scalars['Boolean']['output']>;
  vIDVouchers: Array<VidVoucher>;
  vendorConfigurations: Array<VendorConfiguration>;
};


export type PackageSetDisclosuresArgs = {
  cursor?: InputMaybe<DisclosureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureWhereInput>;
};


export type PackageSetMonitoringConfigurationArgs = {
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};


export type PackageSetOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type PackageSetOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type PackageSetPackageAccessesArgs = {
  cursor?: InputMaybe<PackageAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type PackageSetPackageSetTypeArgs = {
  where?: InputMaybe<PackageSetTypeWhereInput>;
};


export type PackageSetPassTypesArgs = {
  cursor?: InputMaybe<PassTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassTypeWhereInput>;
};


export type PackageSetSearchTypesArgs = {
  cursor?: InputMaybe<SearchTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<SearchTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SearchTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchTypeWhereInput>;
};


export type PackageSetVIdVouchersArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  distinct?: InputMaybe<Array<VidVoucherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type PackageSetVendorConfigurationsArgs = {
  cursor?: InputMaybe<VendorConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VendorConfigurationWhereInput>;
};

export type PackageSetAvgAggregate = {
  __typename?: 'PackageSetAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
  idExpiryByMonths?: Maybe<Scalars['Float']['output']>;
  inviteExpiringPeriod?: Maybe<Scalars['Float']['output']>;
  inviteReminderPeriod?: Maybe<Scalars['Float']['output']>;
};

export type PackageSetCount = {
  __typename?: 'PackageSetCount';
  disclosures: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  packageAccesses: Scalars['Int']['output'];
  passTypes: Scalars['Int']['output'];
  searchTypes: Scalars['Int']['output'];
  vIDVouchers: Scalars['Int']['output'];
  vendorConfigurations: Scalars['Int']['output'];
};


export type PackageSetCountDisclosuresArgs = {
  where?: InputMaybe<DisclosureWhereInput>;
};


export type PackageSetCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type PackageSetCountPackageAccessesArgs = {
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type PackageSetCountPassTypesArgs = {
  where?: InputMaybe<PassTypeWhereInput>;
};


export type PackageSetCountSearchTypesArgs = {
  where?: InputMaybe<SearchTypeWhereInput>;
};


export type PackageSetCountVIdVouchersArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type PackageSetCountVendorConfigurationsArgs = {
  where?: InputMaybe<VendorConfigurationWhereInput>;
};

export type PackageSetCountAggregate = {
  __typename?: 'PackageSetCountAggregate';
  _all: Scalars['Int']['output'];
  allowEmbeddedRegistrationPortal: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  amountPrecision: Scalars['Int']['output'];
  collectSSN: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  currency: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  idExpiryByDate: Scalars['Int']['output'];
  idExpiryByMonths: Scalars['Int']['output'];
  inviteExpiringPeriod: Scalars['Int']['output'];
  inviteReminderPeriod: Scalars['Int']['output'];
  isActive: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  oneAndDone: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  packageSetTypeId: Scalars['Int']['output'];
  postbackWebhookUrl: Scalars['Int']['output'];
  sendInviteReminders: Scalars['Int']['output'];
  shortName: Scalars['Int']['output'];
  showDisclosures: Scalars['Int']['output'];
  skipNameVerification: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  usePassiveLiveness: Scalars['Int']['output'];
  useSampleId: Scalars['Int']['output'];
};

export type PackageSetCreateInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateManyOrganizationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  packageSetTypeId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageSetCreateManyOrganizationInputEnvelope = {
  data: Array<PackageSetCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageSetCreateManyPackageSetTypeInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageSetCreateManyPackageSetTypeInputEnvelope = {
  data: Array<PackageSetCreateManyPackageSetTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageSetCreateNestedManyWithoutDisclosuresInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutDisclosuresInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutDisclosuresInput>>;
};

export type PackageSetCreateNestedManyWithoutOrdersInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutOrdersInput>>;
};

export type PackageSetCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<PackageSetCreateManyOrganizationInputEnvelope>;
};

export type PackageSetCreateNestedManyWithoutPackageSetTypeInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutPackageSetTypeInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutPackageSetTypeInput>>;
  createMany?: InputMaybe<PackageSetCreateManyPackageSetTypeInputEnvelope>;
};

export type PackageSetCreateNestedManyWithoutPassTypesInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutPassTypesInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutPassTypesInput>>;
};

export type PackageSetCreateNestedManyWithoutSearchTypesInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutSearchTypesInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutSearchTypesInput>>;
};

export type PackageSetCreateNestedOneWithoutMonitoringConfigurationInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutMonitoringConfigurationInput>;
  create?: InputMaybe<PackageSetCreateWithoutMonitoringConfigurationInput>;
};

export type PackageSetCreateNestedOneWithoutPackageAccessesInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutPackageAccessesInput>;
  create?: InputMaybe<PackageSetCreateWithoutPackageAccessesInput>;
};

export type PackageSetCreateNestedOneWithoutVidVouchersInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutVidVouchersInput>;
  create?: InputMaybe<PackageSetCreateWithoutVidVouchersInput>;
};

export type PackageSetCreateNestedOneWithoutVendorConfigurationsInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutVendorConfigurationsInput>;
  create?: InputMaybe<PackageSetCreateWithoutVendorConfigurationsInput>;
};

export type PackageSetCreateOrConnectWithoutDisclosuresInput = {
  create: PackageSetCreateWithoutDisclosuresInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutMonitoringConfigurationInput = {
  create: PackageSetCreateWithoutMonitoringConfigurationInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutOrdersInput = {
  create: PackageSetCreateWithoutOrdersInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutOrganizationInput = {
  create: PackageSetCreateWithoutOrganizationInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutPackageAccessesInput = {
  create: PackageSetCreateWithoutPackageAccessesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutPackageSetTypeInput = {
  create: PackageSetCreateWithoutPackageSetTypeInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutPassTypesInput = {
  create: PackageSetCreateWithoutPassTypesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutSearchTypesInput = {
  create: PackageSetCreateWithoutSearchTypesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutVidVouchersInput = {
  create: PackageSetCreateWithoutVidVouchersInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateOrConnectWithoutVendorConfigurationsInput = {
  create: PackageSetCreateWithoutVendorConfigurationsInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetCreateWithoutDisclosuresInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutMonitoringConfigurationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutOrdersInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutOrganizationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutPackageAccessesInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutPackageSetTypeInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutPassTypesInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutSearchTypesInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutVidVouchersInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutPackageInput>;
};

export type PackageSetCreateWithoutVendorConfigurationsInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountPrecision?: InputMaybe<CurrencyMultiplierEnum>;
  collectSSN?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  currency?: InputMaybe<CurrencyTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosures?: InputMaybe<DisclosureCreateNestedManyWithoutPackageSetsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  idExpiryByMonths?: InputMaybe<Scalars['Int']['input']>;
  inviteExpiringPeriod?: InputMaybe<Scalars['Int']['input']>;
  inviteReminderPeriod?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationCreateNestedOneWithoutPackageSetInput>;
  name: Scalars['String']['input'];
  oneAndDone?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutPackageSetsInput>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutPackageSetsInput>;
  packageAccesses?: InputMaybe<PackageAccessCreateNestedManyWithoutPackageSetInput>;
  packageSetType?: InputMaybe<PackageSetTypeCreateNestedOneWithoutPackageSetsInput>;
  passTypes?: InputMaybe<PassTypeCreateNestedManyWithoutPackageSetsInput>;
  postbackWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetsInput>;
  sendInviteReminders?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  showDisclosures?: InputMaybe<Scalars['Boolean']['input']>;
  skipNameVerification?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  usePassiveLiveness?: InputMaybe<Scalars['Boolean']['input']>;
  useSampleId?: InputMaybe<Scalars['Boolean']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPackageSetInput>;
};

export type PackageSetListRelationFilter = {
  every?: InputMaybe<PackageSetWhereInput>;
  none?: InputMaybe<PackageSetWhereInput>;
  some?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetMaxAggregate = {
  __typename?: 'PackageSetMaxAggregate';
  allowEmbeddedRegistrationPortal?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  amountPrecision?: Maybe<CurrencyMultiplierEnum>;
  collectSSN?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  currency?: Maybe<CurrencyTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idExpiryByDate?: Maybe<Scalars['DateTimeISO']['output']>;
  idExpiryByMonths?: Maybe<Scalars['Int']['output']>;
  inviteExpiringPeriod?: Maybe<Scalars['Int']['output']>;
  inviteReminderPeriod?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oneAndDone?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSetTypeId?: Maybe<Scalars['String']['output']>;
  postbackWebhookUrl?: Maybe<Scalars['String']['output']>;
  sendInviteReminders?: Maybe<Scalars['Boolean']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  showDisclosures?: Maybe<Scalars['Boolean']['output']>;
  skipNameVerification?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  usePassiveLiveness?: Maybe<Scalars['Boolean']['output']>;
  useSampleId?: Maybe<Scalars['Boolean']['output']>;
};

export type PackageSetMinAggregate = {
  __typename?: 'PackageSetMinAggregate';
  allowEmbeddedRegistrationPortal?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  amountPrecision?: Maybe<CurrencyMultiplierEnum>;
  collectSSN?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  currency?: Maybe<CurrencyTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idExpiryByDate?: Maybe<Scalars['DateTimeISO']['output']>;
  idExpiryByMonths?: Maybe<Scalars['Int']['output']>;
  inviteExpiringPeriod?: Maybe<Scalars['Int']['output']>;
  inviteReminderPeriod?: Maybe<Scalars['Int']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oneAndDone?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  packageSetTypeId?: Maybe<Scalars['String']['output']>;
  postbackWebhookUrl?: Maybe<Scalars['String']['output']>;
  sendInviteReminders?: Maybe<Scalars['Boolean']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  showDisclosures?: Maybe<Scalars['Boolean']['output']>;
  skipNameVerification?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  usePassiveLiveness?: Maybe<Scalars['Boolean']['output']>;
  useSampleId?: Maybe<Scalars['Boolean']['output']>;
};

export type PackageSetNameOrganizationIdCompoundUniqueInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type PackageSetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PackageSetOrderByWithRelationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<SortOrderInput>;
  amount?: InputMaybe<SortOrder>;
  amountPrecision?: InputMaybe<SortOrder>;
  collectSSN?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  disclosures?: InputMaybe<DisclosureOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  idExpiryByDate?: InputMaybe<SortOrderInput>;
  idExpiryByMonths?: InputMaybe<SortOrderInput>;
  inviteExpiringPeriod?: InputMaybe<SortOrderInput>;
  inviteReminderPeriod?: InputMaybe<SortOrderInput>;
  isActive?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationOrderByWithRelationInput>;
  name?: InputMaybe<SortOrder>;
  oneAndDone?: InputMaybe<SortOrderInput>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  packageAccesses?: InputMaybe<PackageAccessOrderByRelationAggregateInput>;
  packageSetType?: InputMaybe<PackageSetTypeOrderByWithRelationInput>;
  packageSetTypeId?: InputMaybe<SortOrderInput>;
  passTypes?: InputMaybe<PassTypeOrderByRelationAggregateInput>;
  postbackWebhookUrl?: InputMaybe<SortOrderInput>;
  searchTypes?: InputMaybe<SearchTypeOrderByRelationAggregateInput>;
  sendInviteReminders?: InputMaybe<SortOrderInput>;
  shortName?: InputMaybe<SortOrder>;
  showDisclosures?: InputMaybe<SortOrderInput>;
  skipNameVerification?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  usePassiveLiveness?: InputMaybe<SortOrderInput>;
  useSampleId?: InputMaybe<SortOrderInput>;
  vIDVouchers?: InputMaybe<VidVoucherOrderByRelationAggregateInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationOrderByRelationAggregateInput>;
};

export enum PackageSetScalarFieldEnum {
  AllowEmbeddedRegistrationPortal = 'allowEmbeddedRegistrationPortal',
  Amount = 'amount',
  AmountPrecision = 'amountPrecision',
  CollectSsn = 'collectSSN',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Description = 'description',
  Id = 'id',
  IdExpiryByDate = 'idExpiryByDate',
  IdExpiryByMonths = 'idExpiryByMonths',
  InviteExpiringPeriod = 'inviteExpiringPeriod',
  InviteReminderPeriod = 'inviteReminderPeriod',
  IsActive = 'isActive',
  Metadata = 'metadata',
  Name = 'name',
  OneAndDone = 'oneAndDone',
  OrganizationId = 'organizationId',
  PackageSetTypeId = 'packageSetTypeId',
  PostbackWebhookUrl = 'postbackWebhookUrl',
  SendInviteReminders = 'sendInviteReminders',
  ShortName = 'shortName',
  ShowDisclosures = 'showDisclosures',
  SkipNameVerification = 'skipNameVerification',
  UpdatedAt = 'updatedAt',
  UsePassiveLiveness = 'usePassiveLiveness',
  UseSampleId = 'useSampleId'
}

export type PackageSetScalarRelationFilter = {
  is?: InputMaybe<PackageSetWhereInput>;
  isNot?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetScalarWhereInput = {
  AND?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  NOT?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  OR?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  allowEmbeddedRegistrationPortal?: InputMaybe<BoolNullableFilter>;
  amount?: InputMaybe<IntFilter>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFilter>;
  collectSSN?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  idExpiryByDate?: InputMaybe<DateTimeNullableFilter>;
  idExpiryByMonths?: InputMaybe<IntNullableFilter>;
  inviteExpiringPeriod?: InputMaybe<IntNullableFilter>;
  inviteReminderPeriod?: InputMaybe<IntNullableFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  oneAndDone?: InputMaybe<BoolNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  packageSetTypeId?: InputMaybe<StringNullableFilter>;
  postbackWebhookUrl?: InputMaybe<StringNullableFilter>;
  sendInviteReminders?: InputMaybe<BoolNullableFilter>;
  shortName?: InputMaybe<StringFilter>;
  showDisclosures?: InputMaybe<BoolNullableFilter>;
  skipNameVerification?: InputMaybe<BoolNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usePassiveLiveness?: InputMaybe<BoolNullableFilter>;
  useSampleId?: InputMaybe<BoolNullableFilter>;
};

export type PackageSetShortNameOrganizationIdCompoundUniqueInput = {
  organizationId: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
};

export type PackageSetSumAggregate = {
  __typename?: 'PackageSetSumAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  idExpiryByMonths?: Maybe<Scalars['Int']['output']>;
  inviteExpiringPeriod?: Maybe<Scalars['Int']['output']>;
  inviteReminderPeriod?: Maybe<Scalars['Int']['output']>;
};

export type PackageSetType = {
  __typename?: 'PackageSetType';
  _count?: Maybe<PackageSetTypeCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PackageSetTypeCount = {
  __typename?: 'PackageSetTypeCount';
  packageSets: Scalars['Int']['output'];
  searchTypes: Scalars['Int']['output'];
};


export type PackageSetTypeCountPackageSetsArgs = {
  where?: InputMaybe<PackageSetWhereInput>;
};


export type PackageSetTypeCountSearchTypesArgs = {
  where?: InputMaybe<SearchTypeWhereInput>;
};

export type PackageSetTypeCreateNestedManyWithoutSearchTypesInput = {
  connect?: InputMaybe<Array<PackageSetTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetTypeCreateOrConnectWithoutSearchTypesInput>>;
  create?: InputMaybe<Array<PackageSetTypeCreateWithoutSearchTypesInput>>;
};

export type PackageSetTypeCreateNestedOneWithoutPackageSetsInput = {
  connect?: InputMaybe<PackageSetTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetTypeCreateOrConnectWithoutPackageSetsInput>;
  create?: InputMaybe<PackageSetTypeCreateWithoutPackageSetsInput>;
};

export type PackageSetTypeCreateOrConnectWithoutPackageSetsInput = {
  create: PackageSetTypeCreateWithoutPackageSetsInput;
  where: PackageSetTypeWhereUniqueInput;
};

export type PackageSetTypeCreateOrConnectWithoutSearchTypesInput = {
  create: PackageSetTypeCreateWithoutSearchTypesInput;
  where: PackageSetTypeWhereUniqueInput;
};

export type PackageSetTypeCreateWithoutPackageSetsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  searchTypes?: InputMaybe<SearchTypeCreateNestedManyWithoutPackageSetTypesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageSetTypeCreateWithoutSearchTypesInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutPackageSetTypeInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PackageSetTypeListRelationFilter = {
  every?: InputMaybe<PackageSetTypeWhereInput>;
  none?: InputMaybe<PackageSetTypeWhereInput>;
  some?: InputMaybe<PackageSetTypeWhereInput>;
};

export type PackageSetTypeNullableScalarRelationFilter = {
  is?: InputMaybe<PackageSetTypeWhereInput>;
  isNot?: InputMaybe<PackageSetTypeWhereInput>;
};

export type PackageSetTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PackageSetTypeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  packageSets?: InputMaybe<PackageSetOrderByRelationAggregateInput>;
  searchTypes?: InputMaybe<SearchTypeOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PackageSetTypeScalarWhereInput = {
  AND?: InputMaybe<Array<PackageSetTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<PackageSetTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<PackageSetTypeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PackageSetTypeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageSetTypeUpdateManyWithWhereWithoutSearchTypesInput = {
  data: PackageSetTypeUpdateManyMutationInput;
  where: PackageSetTypeScalarWhereInput;
};

export type PackageSetTypeUpdateManyWithoutSearchTypesNestedInput = {
  connect?: InputMaybe<Array<PackageSetTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetTypeCreateOrConnectWithoutSearchTypesInput>>;
  create?: InputMaybe<Array<PackageSetTypeCreateWithoutSearchTypesInput>>;
  delete?: InputMaybe<Array<PackageSetTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetTypeUpdateWithWhereUniqueWithoutSearchTypesInput>>;
  updateMany?: InputMaybe<Array<PackageSetTypeUpdateManyWithWhereWithoutSearchTypesInput>>;
  upsert?: InputMaybe<Array<PackageSetTypeUpsertWithWhereUniqueWithoutSearchTypesInput>>;
};

export type PackageSetTypeUpdateOneWithoutPackageSetsNestedInput = {
  connect?: InputMaybe<PackageSetTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetTypeCreateOrConnectWithoutPackageSetsInput>;
  create?: InputMaybe<PackageSetTypeCreateWithoutPackageSetsInput>;
  delete?: InputMaybe<PackageSetTypeWhereInput>;
  disconnect?: InputMaybe<PackageSetTypeWhereInput>;
  update?: InputMaybe<PackageSetTypeUpdateToOneWithWhereWithoutPackageSetsInput>;
  upsert?: InputMaybe<PackageSetTypeUpsertWithoutPackageSetsInput>;
};

export type PackageSetTypeUpdateToOneWithWhereWithoutPackageSetsInput = {
  data: PackageSetTypeUpdateWithoutPackageSetsInput;
  where?: InputMaybe<PackageSetTypeWhereInput>;
};

export type PackageSetTypeUpdateWithWhereUniqueWithoutSearchTypesInput = {
  data: PackageSetTypeUpdateWithoutSearchTypesInput;
  where: PackageSetTypeWhereUniqueInput;
};

export type PackageSetTypeUpdateWithoutPackageSetsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetTypesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageSetTypeUpdateWithoutSearchTypesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutPackageSetTypeNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PackageSetTypeUpsertWithWhereUniqueWithoutSearchTypesInput = {
  create: PackageSetTypeCreateWithoutSearchTypesInput;
  update: PackageSetTypeUpdateWithoutSearchTypesInput;
  where: PackageSetTypeWhereUniqueInput;
};

export type PackageSetTypeUpsertWithoutPackageSetsInput = {
  create: PackageSetTypeCreateWithoutPackageSetsInput;
  update: PackageSetTypeUpdateWithoutPackageSetsInput;
  where?: InputMaybe<PackageSetTypeWhereInput>;
};

export type PackageSetTypeWhereInput = {
  AND?: InputMaybe<Array<PackageSetTypeWhereInput>>;
  NOT?: InputMaybe<Array<PackageSetTypeWhereInput>>;
  OR?: InputMaybe<Array<PackageSetTypeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  searchTypes?: InputMaybe<SearchTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PackageSetTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<PackageSetTypeWhereInput>>;
  NOT?: InputMaybe<Array<PackageSetTypeWhereInput>>;
  OR?: InputMaybe<Array<PackageSetTypeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  searchTypes?: InputMaybe<SearchTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PackageSetUpdateInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateManyMutationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type PackageSetUpdateManyWithWhereWithoutDisclosuresInput = {
  data: PackageSetUpdateManyMutationInput;
  where: PackageSetScalarWhereInput;
};

export type PackageSetUpdateManyWithWhereWithoutOrdersInput = {
  data: PackageSetUpdateManyMutationInput;
  where: PackageSetScalarWhereInput;
};

export type PackageSetUpdateManyWithWhereWithoutOrganizationInput = {
  data: PackageSetUpdateManyMutationInput;
  where: PackageSetScalarWhereInput;
};

export type PackageSetUpdateManyWithWhereWithoutPackageSetTypeInput = {
  data: PackageSetUpdateManyMutationInput;
  where: PackageSetScalarWhereInput;
};

export type PackageSetUpdateManyWithWhereWithoutPassTypesInput = {
  data: PackageSetUpdateManyMutationInput;
  where: PackageSetScalarWhereInput;
};

export type PackageSetUpdateManyWithWhereWithoutSearchTypesInput = {
  data: PackageSetUpdateManyMutationInput;
  where: PackageSetScalarWhereInput;
};

export type PackageSetUpdateManyWithoutDisclosuresNestedInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutDisclosuresInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutDisclosuresInput>>;
  delete?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetUpdateWithWhereUniqueWithoutDisclosuresInput>>;
  updateMany?: InputMaybe<Array<PackageSetUpdateManyWithWhereWithoutDisclosuresInput>>;
  upsert?: InputMaybe<Array<PackageSetUpsertWithWhereUniqueWithoutDisclosuresInput>>;
};

export type PackageSetUpdateManyWithoutOrdersNestedInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutOrdersInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutOrdersInput>>;
  delete?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetUpdateWithWhereUniqueWithoutOrdersInput>>;
  updateMany?: InputMaybe<Array<PackageSetUpdateManyWithWhereWithoutOrdersInput>>;
  upsert?: InputMaybe<Array<PackageSetUpsertWithWhereUniqueWithoutOrdersInput>>;
};

export type PackageSetUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<PackageSetCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<PackageSetUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<PackageSetUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type PackageSetUpdateManyWithoutPackageSetTypeNestedInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutPackageSetTypeInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutPackageSetTypeInput>>;
  createMany?: InputMaybe<PackageSetCreateManyPackageSetTypeInputEnvelope>;
  delete?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetUpdateWithWhereUniqueWithoutPackageSetTypeInput>>;
  updateMany?: InputMaybe<Array<PackageSetUpdateManyWithWhereWithoutPackageSetTypeInput>>;
  upsert?: InputMaybe<Array<PackageSetUpsertWithWhereUniqueWithoutPackageSetTypeInput>>;
};

export type PackageSetUpdateManyWithoutPassTypesNestedInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutPassTypesInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutPassTypesInput>>;
  delete?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetUpdateWithWhereUniqueWithoutPassTypesInput>>;
  updateMany?: InputMaybe<Array<PackageSetUpdateManyWithWhereWithoutPassTypesInput>>;
  upsert?: InputMaybe<Array<PackageSetUpsertWithWhereUniqueWithoutPassTypesInput>>;
};

export type PackageSetUpdateManyWithoutSearchTypesNestedInput = {
  connect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PackageSetCreateOrConnectWithoutSearchTypesInput>>;
  create?: InputMaybe<Array<PackageSetCreateWithoutSearchTypesInput>>;
  delete?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PackageSetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  set?: InputMaybe<Array<PackageSetWhereUniqueInput>>;
  update?: InputMaybe<Array<PackageSetUpdateWithWhereUniqueWithoutSearchTypesInput>>;
  updateMany?: InputMaybe<Array<PackageSetUpdateManyWithWhereWithoutSearchTypesInput>>;
  upsert?: InputMaybe<Array<PackageSetUpsertWithWhereUniqueWithoutSearchTypesInput>>;
};

export type PackageSetUpdateOneRequiredWithoutMonitoringConfigurationNestedInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutMonitoringConfigurationInput>;
  create?: InputMaybe<PackageSetCreateWithoutMonitoringConfigurationInput>;
  update?: InputMaybe<PackageSetUpdateToOneWithWhereWithoutMonitoringConfigurationInput>;
  upsert?: InputMaybe<PackageSetUpsertWithoutMonitoringConfigurationInput>;
};

export type PackageSetUpdateOneRequiredWithoutPackageAccessesNestedInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutPackageAccessesInput>;
  create?: InputMaybe<PackageSetCreateWithoutPackageAccessesInput>;
  update?: InputMaybe<PackageSetUpdateToOneWithWhereWithoutPackageAccessesInput>;
  upsert?: InputMaybe<PackageSetUpsertWithoutPackageAccessesInput>;
};

export type PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutVidVouchersInput>;
  create?: InputMaybe<PackageSetCreateWithoutVidVouchersInput>;
  update?: InputMaybe<PackageSetUpdateToOneWithWhereWithoutVidVouchersInput>;
  upsert?: InputMaybe<PackageSetUpsertWithoutVidVouchersInput>;
};

export type PackageSetUpdateOneRequiredWithoutVendorConfigurationsNestedInput = {
  connect?: InputMaybe<PackageSetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PackageSetCreateOrConnectWithoutVendorConfigurationsInput>;
  create?: InputMaybe<PackageSetCreateWithoutVendorConfigurationsInput>;
  update?: InputMaybe<PackageSetUpdateToOneWithWhereWithoutVendorConfigurationsInput>;
  upsert?: InputMaybe<PackageSetUpsertWithoutVendorConfigurationsInput>;
};

export type PackageSetUpdateToOneWithWhereWithoutMonitoringConfigurationInput = {
  data: PackageSetUpdateWithoutMonitoringConfigurationInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpdateToOneWithWhereWithoutPackageAccessesInput = {
  data: PackageSetUpdateWithoutPackageAccessesInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpdateToOneWithWhereWithoutVidVouchersInput = {
  data: PackageSetUpdateWithoutVidVouchersInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpdateToOneWithWhereWithoutVendorConfigurationsInput = {
  data: PackageSetUpdateWithoutVendorConfigurationsInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpdateWithWhereUniqueWithoutDisclosuresInput = {
  data: PackageSetUpdateWithoutDisclosuresInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpdateWithWhereUniqueWithoutOrdersInput = {
  data: PackageSetUpdateWithoutOrdersInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: PackageSetUpdateWithoutOrganizationInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpdateWithWhereUniqueWithoutPackageSetTypeInput = {
  data: PackageSetUpdateWithoutPackageSetTypeInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpdateWithWhereUniqueWithoutPassTypesInput = {
  data: PackageSetUpdateWithoutPassTypesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpdateWithWhereUniqueWithoutSearchTypesInput = {
  data: PackageSetUpdateWithoutSearchTypesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpdateWithoutDisclosuresInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutMonitoringConfigurationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutOrdersInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutOrganizationInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutPackageAccessesInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutPackageSetTypeInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutPassTypesInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutSearchTypesInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutVidVouchersInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutPackageNestedInput>;
};

export type PackageSetUpdateWithoutVendorConfigurationsInput = {
  allowEmbeddedRegistrationPortal?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFieldUpdateOperationsInput>;
  collectSSN?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disclosures?: InputMaybe<DisclosureUpdateManyWithoutPackageSetsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idExpiryByDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  idExpiryByMonths?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteExpiringPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  inviteReminderPeriod?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationUpdateOneWithoutPackageSetNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  oneAndDone?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPackageSetsNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutPackageSetsNestedInput>;
  packageAccesses?: InputMaybe<PackageAccessUpdateManyWithoutPackageSetNestedInput>;
  packageSetType?: InputMaybe<PackageSetTypeUpdateOneWithoutPackageSetsNestedInput>;
  passTypes?: InputMaybe<PassTypeUpdateManyWithoutPackageSetsNestedInput>;
  postbackWebhookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchTypes?: InputMaybe<SearchTypeUpdateManyWithoutPackageSetsNestedInput>;
  sendInviteReminders?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showDisclosures?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  skipNameVerification?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usePassiveLiveness?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useSampleId?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutPackageSetNestedInput>;
};

export type PackageSetUpsertWithWhereUniqueWithoutDisclosuresInput = {
  create: PackageSetCreateWithoutDisclosuresInput;
  update: PackageSetUpdateWithoutDisclosuresInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpsertWithWhereUniqueWithoutOrdersInput = {
  create: PackageSetCreateWithoutOrdersInput;
  update: PackageSetUpdateWithoutOrdersInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: PackageSetCreateWithoutOrganizationInput;
  update: PackageSetUpdateWithoutOrganizationInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpsertWithWhereUniqueWithoutPackageSetTypeInput = {
  create: PackageSetCreateWithoutPackageSetTypeInput;
  update: PackageSetUpdateWithoutPackageSetTypeInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpsertWithWhereUniqueWithoutPassTypesInput = {
  create: PackageSetCreateWithoutPassTypesInput;
  update: PackageSetUpdateWithoutPassTypesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpsertWithWhereUniqueWithoutSearchTypesInput = {
  create: PackageSetCreateWithoutSearchTypesInput;
  update: PackageSetUpdateWithoutSearchTypesInput;
  where: PackageSetWhereUniqueInput;
};

export type PackageSetUpsertWithoutMonitoringConfigurationInput = {
  create: PackageSetCreateWithoutMonitoringConfigurationInput;
  update: PackageSetUpdateWithoutMonitoringConfigurationInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpsertWithoutPackageAccessesInput = {
  create: PackageSetCreateWithoutPackageAccessesInput;
  update: PackageSetUpdateWithoutPackageAccessesInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpsertWithoutVidVouchersInput = {
  create: PackageSetCreateWithoutVidVouchersInput;
  update: PackageSetUpdateWithoutVidVouchersInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetUpsertWithoutVendorConfigurationsInput = {
  create: PackageSetCreateWithoutVendorConfigurationsInput;
  update: PackageSetUpdateWithoutVendorConfigurationsInput;
  where?: InputMaybe<PackageSetWhereInput>;
};

export type PackageSetWhereInput = {
  AND?: InputMaybe<Array<PackageSetWhereInput>>;
  NOT?: InputMaybe<Array<PackageSetWhereInput>>;
  OR?: InputMaybe<Array<PackageSetWhereInput>>;
  allowEmbeddedRegistrationPortal?: InputMaybe<BoolNullableFilter>;
  amount?: InputMaybe<IntFilter>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFilter>;
  collectSSN?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFilter>;
  description?: InputMaybe<StringNullableFilter>;
  disclosures?: InputMaybe<DisclosureListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  idExpiryByDate?: InputMaybe<DateTimeNullableFilter>;
  idExpiryByMonths?: InputMaybe<IntNullableFilter>;
  inviteExpiringPeriod?: InputMaybe<IntNullableFilter>;
  inviteReminderPeriod?: InputMaybe<IntNullableFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationNullableScalarRelationFilter>;
  name?: InputMaybe<StringFilter>;
  oneAndDone?: InputMaybe<BoolNullableFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  packageAccesses?: InputMaybe<PackageAccessListRelationFilter>;
  packageSetType?: InputMaybe<PackageSetTypeNullableScalarRelationFilter>;
  packageSetTypeId?: InputMaybe<StringNullableFilter>;
  passTypes?: InputMaybe<PassTypeListRelationFilter>;
  postbackWebhookUrl?: InputMaybe<StringNullableFilter>;
  searchTypes?: InputMaybe<SearchTypeListRelationFilter>;
  sendInviteReminders?: InputMaybe<BoolNullableFilter>;
  shortName?: InputMaybe<StringFilter>;
  showDisclosures?: InputMaybe<BoolNullableFilter>;
  skipNameVerification?: InputMaybe<BoolNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usePassiveLiveness?: InputMaybe<BoolNullableFilter>;
  useSampleId?: InputMaybe<BoolNullableFilter>;
  vIDVouchers?: InputMaybe<VidVoucherListRelationFilter>;
  vendorConfigurations?: InputMaybe<VendorConfigurationListRelationFilter>;
};

export type PackageSetWhereUniqueInput = {
  AND?: InputMaybe<Array<PackageSetWhereInput>>;
  NOT?: InputMaybe<Array<PackageSetWhereInput>>;
  OR?: InputMaybe<Array<PackageSetWhereInput>>;
  allowEmbeddedRegistrationPortal?: InputMaybe<BoolNullableFilter>;
  amount?: InputMaybe<IntFilter>;
  amountPrecision?: InputMaybe<EnumCurrencyMultiplierEnumFilter>;
  collectSSN?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<EnumCurrencyTypeEnumFilter>;
  description?: InputMaybe<StringNullableFilter>;
  disclosures?: InputMaybe<DisclosureListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idExpiryByDate?: InputMaybe<DateTimeNullableFilter>;
  idExpiryByMonths?: InputMaybe<IntNullableFilter>;
  inviteExpiringPeriod?: InputMaybe<IntNullableFilter>;
  inviteReminderPeriod?: InputMaybe<IntNullableFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  monitoringConfiguration?: InputMaybe<MonitoringConfigurationNullableScalarRelationFilter>;
  name?: InputMaybe<StringFilter>;
  name_organizationId?: InputMaybe<PackageSetNameOrganizationIdCompoundUniqueInput>;
  oneAndDone?: InputMaybe<BoolNullableFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  packageAccesses?: InputMaybe<PackageAccessListRelationFilter>;
  packageSetType?: InputMaybe<PackageSetTypeNullableScalarRelationFilter>;
  packageSetTypeId?: InputMaybe<StringNullableFilter>;
  passTypes?: InputMaybe<PassTypeListRelationFilter>;
  postbackWebhookUrl?: InputMaybe<StringNullableFilter>;
  searchTypes?: InputMaybe<SearchTypeListRelationFilter>;
  sendInviteReminders?: InputMaybe<BoolNullableFilter>;
  shortName?: InputMaybe<StringFilter>;
  shortName_organizationId?: InputMaybe<PackageSetShortNameOrganizationIdCompoundUniqueInput>;
  showDisclosures?: InputMaybe<BoolNullableFilter>;
  skipNameVerification?: InputMaybe<BoolNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usePassiveLiveness?: InputMaybe<BoolNullableFilter>;
  useSampleId?: InputMaybe<BoolNullableFilter>;
  vIDVouchers?: InputMaybe<VidVoucherListRelationFilter>;
  vendorConfigurations?: InputMaybe<VendorConfigurationListRelationFilter>;
};

export type Pass = {
  __typename?: 'Pass';
  _count?: Maybe<PassCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  credentials: Array<Credential>;
  id: Scalars['String']['output'];
  inputs: Array<BeamInput>;
  outputs: Array<BeamOutput>;
  passType?: Maybe<PassType>;
  passTypeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type PassCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type PassInputsArgs = {
  cursor?: InputMaybe<BeamInputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};


export type PassOutputsArgs = {
  cursor?: InputMaybe<BeamOutputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamOutputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOutputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type PassPassTypeArgs = {
  where?: InputMaybe<PassTypeWhereInput>;
};

export type PassCount = {
  __typename?: 'PassCount';
  credentials: Scalars['Int']['output'];
  inputs: Scalars['Int']['output'];
  outputs: Scalars['Int']['output'];
};


export type PassCountCredentialsArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type PassCountInputsArgs = {
  where?: InputMaybe<BeamInputWhereInput>;
};


export type PassCountOutputsArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};

export type PassCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutPassInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutPassInput>;
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutPassInput>;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutPassesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutPassesInput;
};

export type PassCreateManyPassTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type PassCreateManyPassTypeInputEnvelope = {
  data: Array<PassCreateManyPassTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PassCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  passTypeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PassCreateManyUserInputEnvelope = {
  data: Array<PassCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PassCreateNestedManyWithoutPassTypeInput = {
  connect?: InputMaybe<Array<PassWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassCreateOrConnectWithoutPassTypeInput>>;
  create?: InputMaybe<Array<PassCreateWithoutPassTypeInput>>;
  createMany?: InputMaybe<PassCreateManyPassTypeInputEnvelope>;
};

export type PassCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PassWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PassCreateWithoutUserInput>>;
  createMany?: InputMaybe<PassCreateManyUserInputEnvelope>;
};

export type PassCreateNestedOneWithoutCredentialsInput = {
  connect?: InputMaybe<PassWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<PassCreateWithoutCredentialsInput>;
};

export type PassCreateNestedOneWithoutInputsInput = {
  connect?: InputMaybe<PassWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassCreateOrConnectWithoutInputsInput>;
  create?: InputMaybe<PassCreateWithoutInputsInput>;
};

export type PassCreateNestedOneWithoutOutputsInput = {
  connect?: InputMaybe<PassWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassCreateOrConnectWithoutOutputsInput>;
  create?: InputMaybe<PassCreateWithoutOutputsInput>;
};

export type PassCreateOrConnectWithoutCredentialsInput = {
  create: PassCreateWithoutCredentialsInput;
  where: PassWhereUniqueInput;
};

export type PassCreateOrConnectWithoutInputsInput = {
  create: PassCreateWithoutInputsInput;
  where: PassWhereUniqueInput;
};

export type PassCreateOrConnectWithoutOutputsInput = {
  create: PassCreateWithoutOutputsInput;
  where: PassWhereUniqueInput;
};

export type PassCreateOrConnectWithoutPassTypeInput = {
  create: PassCreateWithoutPassTypeInput;
  where: PassWhereUniqueInput;
};

export type PassCreateOrConnectWithoutUserInput = {
  create: PassCreateWithoutUserInput;
  where: PassWhereUniqueInput;
};

export type PassCreateWithoutCredentialsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutPassInput>;
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutPassInput>;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutPassesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutPassesInput;
};

export type PassCreateWithoutInputsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutPassInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutPassInput>;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutPassesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutPassesInput;
};

export type PassCreateWithoutOutputsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutPassInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutPassInput>;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutPassesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutPassesInput;
};

export type PassCreateWithoutPassTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutPassInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutPassInput>;
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutPassInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutPassesInput;
};

export type PassCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutPassInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputCreateNestedManyWithoutPassInput>;
  outputs?: InputMaybe<BeamOutputCreateNestedManyWithoutPassInput>;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutPassesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PassListRelationFilter = {
  every?: InputMaybe<PassWhereInput>;
  none?: InputMaybe<PassWhereInput>;
  some?: InputMaybe<PassWhereInput>;
};

export type PassNullableScalarRelationFilter = {
  is?: InputMaybe<PassWhereInput>;
  isNot?: InputMaybe<PassWhereInput>;
};

export type PassOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PassOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  credentials?: InputMaybe<CredentialOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  inputs?: InputMaybe<BeamInputOrderByRelationAggregateInput>;
  outputs?: InputMaybe<BeamOutputOrderByRelationAggregateInput>;
  passType?: InputMaybe<PassTypeOrderByWithRelationInput>;
  passTypeId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum PassScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  PassTypeId = 'passTypeId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type PassScalarWhereInput = {
  AND?: InputMaybe<Array<PassScalarWhereInput>>;
  NOT?: InputMaybe<Array<PassScalarWhereInput>>;
  OR?: InputMaybe<Array<PassScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  passTypeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type PassType = {
  __typename?: 'PassType';
  _count?: Maybe<PassTypeCount>;
  beams: Array<Beam>;
  brandColor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  packageSets: Array<PackageSet>;
  passes: Array<Pass>;
  slug: Scalars['String']['output'];
  vouchers: Array<VidVoucher>;
};


export type PassTypeBeamsArgs = {
  cursor?: InputMaybe<BeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamWhereInput>;
};


export type PassTypePackageSetsArgs = {
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageSetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageSetWhereInput>;
};


export type PassTypePassesArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassWhereInput>;
};


export type PassTypeVouchersArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  distinct?: InputMaybe<Array<VidVoucherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type PassTypeCount = {
  __typename?: 'PassTypeCount';
  beams: Scalars['Int']['output'];
  packageSets: Scalars['Int']['output'];
  passes: Scalars['Int']['output'];
  vouchers: Scalars['Int']['output'];
};


export type PassTypeCountBeamsArgs = {
  where?: InputMaybe<BeamWhereInput>;
};


export type PassTypeCountPackageSetsArgs = {
  where?: InputMaybe<PackageSetWhereInput>;
};


export type PassTypeCountPassesArgs = {
  where?: InputMaybe<PassWhereInput>;
};


export type PassTypeCountVouchersArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type PassTypeCreateInput = {
  beams?: InputMaybe<BeamCreateNestedManyWithoutPassTypesInput>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: OrganizationCreateNestedOneWithoutPassTypesInput;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutPassTypesInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutPassTypeInput>;
  slug: Scalars['String']['input'];
  vouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPassTypeInput>;
};

export type PassTypeCreateManyOrganizationInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type PassTypeCreateManyOrganizationInputEnvelope = {
  data: Array<PassTypeCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PassTypeCreateNestedManyWithoutBeamsInput = {
  connect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassTypeCreateOrConnectWithoutBeamsInput>>;
  create?: InputMaybe<Array<PassTypeCreateWithoutBeamsInput>>;
};

export type PassTypeCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassTypeCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<PassTypeCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<PassTypeCreateManyOrganizationInputEnvelope>;
};

export type PassTypeCreateNestedManyWithoutPackageSetsInput = {
  connect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassTypeCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<PassTypeCreateWithoutPackageSetsInput>>;
};

export type PassTypeCreateNestedOneWithoutPassesInput = {
  connect?: InputMaybe<PassTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassTypeCreateOrConnectWithoutPassesInput>;
  create?: InputMaybe<PassTypeCreateWithoutPassesInput>;
};

export type PassTypeCreateNestedOneWithoutVouchersInput = {
  connect?: InputMaybe<PassTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassTypeCreateOrConnectWithoutVouchersInput>;
  create?: InputMaybe<PassTypeCreateWithoutVouchersInput>;
};

export type PassTypeCreateOrConnectWithoutBeamsInput = {
  create: PassTypeCreateWithoutBeamsInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeCreateOrConnectWithoutOrganizationInput = {
  create: PassTypeCreateWithoutOrganizationInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeCreateOrConnectWithoutPackageSetsInput = {
  create: PassTypeCreateWithoutPackageSetsInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeCreateOrConnectWithoutPassesInput = {
  create: PassTypeCreateWithoutPassesInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeCreateOrConnectWithoutVouchersInput = {
  create: PassTypeCreateWithoutVouchersInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeCreateWithoutBeamsInput = {
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: OrganizationCreateNestedOneWithoutPassTypesInput;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutPassTypesInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutPassTypeInput>;
  slug: Scalars['String']['input'];
  vouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPassTypeInput>;
};

export type PassTypeCreateWithoutOrganizationInput = {
  beams?: InputMaybe<BeamCreateNestedManyWithoutPassTypesInput>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutPassTypesInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutPassTypeInput>;
  slug: Scalars['String']['input'];
  vouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPassTypeInput>;
};

export type PassTypeCreateWithoutPackageSetsInput = {
  beams?: InputMaybe<BeamCreateNestedManyWithoutPassTypesInput>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: OrganizationCreateNestedOneWithoutPassTypesInput;
  passes?: InputMaybe<PassCreateNestedManyWithoutPassTypeInput>;
  slug: Scalars['String']['input'];
  vouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPassTypeInput>;
};

export type PassTypeCreateWithoutPassesInput = {
  beams?: InputMaybe<BeamCreateNestedManyWithoutPassTypesInput>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: OrganizationCreateNestedOneWithoutPassTypesInput;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutPassTypesInput>;
  slug: Scalars['String']['input'];
  vouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutPassTypeInput>;
};

export type PassTypeCreateWithoutVouchersInput = {
  beams?: InputMaybe<BeamCreateNestedManyWithoutPassTypesInput>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization: OrganizationCreateNestedOneWithoutPassTypesInput;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutPassTypesInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutPassTypeInput>;
  slug: Scalars['String']['input'];
};

export type PassTypeListRelationFilter = {
  every?: InputMaybe<PassTypeWhereInput>;
  none?: InputMaybe<PassTypeWhereInput>;
  some?: InputMaybe<PassTypeWhereInput>;
};

export type PassTypeNullableScalarRelationFilter = {
  is?: InputMaybe<PassTypeWhereInput>;
  isNot?: InputMaybe<PassTypeWhereInput>;
};

export type PassTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PassTypeOrderByWithRelationInput = {
  beams?: InputMaybe<BeamOrderByRelationAggregateInput>;
  brandColor?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  packageSets?: InputMaybe<PackageSetOrderByRelationAggregateInput>;
  passes?: InputMaybe<PassOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  vouchers?: InputMaybe<VidVoucherOrderByRelationAggregateInput>;
};

export enum PassTypeScalarFieldEnum {
  BrandColor = 'brandColor',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  OrganizationId = 'organizationId',
  Slug = 'slug'
}

export type PassTypeScalarWhereInput = {
  AND?: InputMaybe<Array<PassTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<PassTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<PassTypeScalarWhereInput>>;
  brandColor?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
};

export type PassTypeUpdateInput = {
  beams?: InputMaybe<BeamUpdateManyWithoutPassTypesNestedInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPassTypesNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutPassTypesNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutPassTypeNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  vouchers?: InputMaybe<VidVoucherUpdateManyWithoutPassTypeNestedInput>;
};

export type PassTypeUpdateManyMutationInput = {
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PassTypeUpdateManyWithWhereWithoutBeamsInput = {
  data: PassTypeUpdateManyMutationInput;
  where: PassTypeScalarWhereInput;
};

export type PassTypeUpdateManyWithWhereWithoutOrganizationInput = {
  data: PassTypeUpdateManyMutationInput;
  where: PassTypeScalarWhereInput;
};

export type PassTypeUpdateManyWithWhereWithoutPackageSetsInput = {
  data: PassTypeUpdateManyMutationInput;
  where: PassTypeScalarWhereInput;
};

export type PassTypeUpdateManyWithoutBeamsNestedInput = {
  connect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassTypeCreateOrConnectWithoutBeamsInput>>;
  create?: InputMaybe<Array<PassTypeCreateWithoutBeamsInput>>;
  delete?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PassTypeUpdateWithWhereUniqueWithoutBeamsInput>>;
  updateMany?: InputMaybe<Array<PassTypeUpdateManyWithWhereWithoutBeamsInput>>;
  upsert?: InputMaybe<Array<PassTypeUpsertWithWhereUniqueWithoutBeamsInput>>;
};

export type PassTypeUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassTypeCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<PassTypeCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<PassTypeCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PassTypeUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<PassTypeUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<PassTypeUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type PassTypeUpdateManyWithoutPackageSetsNestedInput = {
  connect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassTypeCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<PassTypeCreateWithoutPackageSetsInput>>;
  delete?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PassTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PassTypeUpdateWithWhereUniqueWithoutPackageSetsInput>>;
  updateMany?: InputMaybe<Array<PassTypeUpdateManyWithWhereWithoutPackageSetsInput>>;
  upsert?: InputMaybe<Array<PassTypeUpsertWithWhereUniqueWithoutPackageSetsInput>>;
};

export type PassTypeUpdateOneWithoutPassesNestedInput = {
  connect?: InputMaybe<PassTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassTypeCreateOrConnectWithoutPassesInput>;
  create?: InputMaybe<PassTypeCreateWithoutPassesInput>;
  delete?: InputMaybe<PassTypeWhereInput>;
  disconnect?: InputMaybe<PassTypeWhereInput>;
  update?: InputMaybe<PassTypeUpdateToOneWithWhereWithoutPassesInput>;
  upsert?: InputMaybe<PassTypeUpsertWithoutPassesInput>;
};

export type PassTypeUpdateOneWithoutVouchersNestedInput = {
  connect?: InputMaybe<PassTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassTypeCreateOrConnectWithoutVouchersInput>;
  create?: InputMaybe<PassTypeCreateWithoutVouchersInput>;
  delete?: InputMaybe<PassTypeWhereInput>;
  disconnect?: InputMaybe<PassTypeWhereInput>;
  update?: InputMaybe<PassTypeUpdateToOneWithWhereWithoutVouchersInput>;
  upsert?: InputMaybe<PassTypeUpsertWithoutVouchersInput>;
};

export type PassTypeUpdateToOneWithWhereWithoutPassesInput = {
  data: PassTypeUpdateWithoutPassesInput;
  where?: InputMaybe<PassTypeWhereInput>;
};

export type PassTypeUpdateToOneWithWhereWithoutVouchersInput = {
  data: PassTypeUpdateWithoutVouchersInput;
  where?: InputMaybe<PassTypeWhereInput>;
};

export type PassTypeUpdateWithWhereUniqueWithoutBeamsInput = {
  data: PassTypeUpdateWithoutBeamsInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: PassTypeUpdateWithoutOrganizationInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeUpdateWithWhereUniqueWithoutPackageSetsInput = {
  data: PassTypeUpdateWithoutPackageSetsInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeUpdateWithoutBeamsInput = {
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPassTypesNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutPassTypesNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutPassTypeNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  vouchers?: InputMaybe<VidVoucherUpdateManyWithoutPassTypeNestedInput>;
};

export type PassTypeUpdateWithoutOrganizationInput = {
  beams?: InputMaybe<BeamUpdateManyWithoutPassTypesNestedInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutPassTypesNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutPassTypeNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  vouchers?: InputMaybe<VidVoucherUpdateManyWithoutPassTypeNestedInput>;
};

export type PassTypeUpdateWithoutPackageSetsInput = {
  beams?: InputMaybe<BeamUpdateManyWithoutPassTypesNestedInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPassTypesNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutPassTypeNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  vouchers?: InputMaybe<VidVoucherUpdateManyWithoutPassTypeNestedInput>;
};

export type PassTypeUpdateWithoutPassesInput = {
  beams?: InputMaybe<BeamUpdateManyWithoutPassTypesNestedInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPassTypesNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutPassTypesNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  vouchers?: InputMaybe<VidVoucherUpdateManyWithoutPassTypeNestedInput>;
};

export type PassTypeUpdateWithoutVouchersInput = {
  beams?: InputMaybe<BeamUpdateManyWithoutPassTypesNestedInput>;
  brandColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutPassTypesNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutPassTypesNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutPassTypeNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PassTypeUpsertWithWhereUniqueWithoutBeamsInput = {
  create: PassTypeCreateWithoutBeamsInput;
  update: PassTypeUpdateWithoutBeamsInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: PassTypeCreateWithoutOrganizationInput;
  update: PassTypeUpdateWithoutOrganizationInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeUpsertWithWhereUniqueWithoutPackageSetsInput = {
  create: PassTypeCreateWithoutPackageSetsInput;
  update: PassTypeUpdateWithoutPackageSetsInput;
  where: PassTypeWhereUniqueInput;
};

export type PassTypeUpsertWithoutPassesInput = {
  create: PassTypeCreateWithoutPassesInput;
  update: PassTypeUpdateWithoutPassesInput;
  where?: InputMaybe<PassTypeWhereInput>;
};

export type PassTypeUpsertWithoutVouchersInput = {
  create: PassTypeCreateWithoutVouchersInput;
  update: PassTypeUpdateWithoutVouchersInput;
  where?: InputMaybe<PassTypeWhereInput>;
};

export type PassTypeWhereInput = {
  AND?: InputMaybe<Array<PassTypeWhereInput>>;
  NOT?: InputMaybe<Array<PassTypeWhereInput>>;
  OR?: InputMaybe<Array<PassTypeWhereInput>>;
  beams?: InputMaybe<BeamListRelationFilter>;
  brandColor?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  passes?: InputMaybe<PassListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  vouchers?: InputMaybe<VidVoucherListRelationFilter>;
};

export type PassTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<PassTypeWhereInput>>;
  NOT?: InputMaybe<Array<PassTypeWhereInput>>;
  OR?: InputMaybe<Array<PassTypeWhereInput>>;
  beams?: InputMaybe<BeamListRelationFilter>;
  brandColor?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  passes?: InputMaybe<PassListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  vouchers?: InputMaybe<VidVoucherListRelationFilter>;
};

export type PassUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassUpdateManyWithWhereWithoutPassTypeInput = {
  data: PassUpdateManyMutationInput;
  where: PassScalarWhereInput;
};

export type PassUpdateManyWithWhereWithoutUserInput = {
  data: PassUpdateManyMutationInput;
  where: PassScalarWhereInput;
};

export type PassUpdateManyWithoutPassTypeNestedInput = {
  connect?: InputMaybe<Array<PassWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassCreateOrConnectWithoutPassTypeInput>>;
  create?: InputMaybe<Array<PassCreateWithoutPassTypeInput>>;
  createMany?: InputMaybe<PassCreateManyPassTypeInputEnvelope>;
  delete?: InputMaybe<Array<PassWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassWhereUniqueInput>>;
  set?: InputMaybe<Array<PassWhereUniqueInput>>;
  update?: InputMaybe<Array<PassUpdateWithWhereUniqueWithoutPassTypeInput>>;
  updateMany?: InputMaybe<Array<PassUpdateManyWithWhereWithoutPassTypeInput>>;
  upsert?: InputMaybe<Array<PassUpsertWithWhereUniqueWithoutPassTypeInput>>;
};

export type PassUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PassWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PassCreateWithoutUserInput>>;
  createMany?: InputMaybe<PassCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PassWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassWhereUniqueInput>>;
  set?: InputMaybe<Array<PassWhereUniqueInput>>;
  update?: InputMaybe<Array<PassUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PassUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PassUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PassUpdateOneWithoutCredentialsNestedInput = {
  connect?: InputMaybe<PassWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<PassCreateWithoutCredentialsInput>;
  delete?: InputMaybe<PassWhereInput>;
  disconnect?: InputMaybe<PassWhereInput>;
  update?: InputMaybe<PassUpdateToOneWithWhereWithoutCredentialsInput>;
  upsert?: InputMaybe<PassUpsertWithoutCredentialsInput>;
};

export type PassUpdateOneWithoutInputsNestedInput = {
  connect?: InputMaybe<PassWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassCreateOrConnectWithoutInputsInput>;
  create?: InputMaybe<PassCreateWithoutInputsInput>;
  delete?: InputMaybe<PassWhereInput>;
  disconnect?: InputMaybe<PassWhereInput>;
  update?: InputMaybe<PassUpdateToOneWithWhereWithoutInputsInput>;
  upsert?: InputMaybe<PassUpsertWithoutInputsInput>;
};

export type PassUpdateOneWithoutOutputsNestedInput = {
  connect?: InputMaybe<PassWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassCreateOrConnectWithoutOutputsInput>;
  create?: InputMaybe<PassCreateWithoutOutputsInput>;
  delete?: InputMaybe<PassWhereInput>;
  disconnect?: InputMaybe<PassWhereInput>;
  update?: InputMaybe<PassUpdateToOneWithWhereWithoutOutputsInput>;
  upsert?: InputMaybe<PassUpsertWithoutOutputsInput>;
};

export type PassUpdateToOneWithWhereWithoutCredentialsInput = {
  data: PassUpdateWithoutCredentialsInput;
  where?: InputMaybe<PassWhereInput>;
};

export type PassUpdateToOneWithWhereWithoutInputsInput = {
  data: PassUpdateWithoutInputsInput;
  where?: InputMaybe<PassWhereInput>;
};

export type PassUpdateToOneWithWhereWithoutOutputsInput = {
  data: PassUpdateWithoutOutputsInput;
  where?: InputMaybe<PassWhereInput>;
};

export type PassUpdateWithWhereUniqueWithoutPassTypeInput = {
  data: PassUpdateWithoutPassTypeInput;
  where: PassWhereUniqueInput;
};

export type PassUpdateWithWhereUniqueWithoutUserInput = {
  data: PassUpdateWithoutUserInput;
  where: PassWhereUniqueInput;
};

export type PassUpdateWithoutCredentialsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputs?: InputMaybe<BeamInputUpdateManyWithoutPassNestedInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutPassNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutPassesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPassesNestedInput>;
};

export type PassUpdateWithoutInputsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutPassNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutPassNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutPassesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPassesNestedInput>;
};

export type PassUpdateWithoutOutputsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutPassNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputs?: InputMaybe<BeamInputUpdateManyWithoutPassNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutPassesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPassesNestedInput>;
};

export type PassUpdateWithoutPassTypeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutPassNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputs?: InputMaybe<BeamInputUpdateManyWithoutPassNestedInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutPassNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutPassesNestedInput>;
};

export type PassUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutPassNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inputs?: InputMaybe<BeamInputUpdateManyWithoutPassNestedInput>;
  outputs?: InputMaybe<BeamOutputUpdateManyWithoutPassNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutPassesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassUpsertWithWhereUniqueWithoutPassTypeInput = {
  create: PassCreateWithoutPassTypeInput;
  update: PassUpdateWithoutPassTypeInput;
  where: PassWhereUniqueInput;
};

export type PassUpsertWithWhereUniqueWithoutUserInput = {
  create: PassCreateWithoutUserInput;
  update: PassUpdateWithoutUserInput;
  where: PassWhereUniqueInput;
};

export type PassUpsertWithoutCredentialsInput = {
  create: PassCreateWithoutCredentialsInput;
  update: PassUpdateWithoutCredentialsInput;
  where?: InputMaybe<PassWhereInput>;
};

export type PassUpsertWithoutInputsInput = {
  create: PassCreateWithoutInputsInput;
  update: PassUpdateWithoutInputsInput;
  where?: InputMaybe<PassWhereInput>;
};

export type PassUpsertWithoutOutputsInput = {
  create: PassCreateWithoutOutputsInput;
  update: PassUpdateWithoutOutputsInput;
  where?: InputMaybe<PassWhereInput>;
};

export type PassWhereInput = {
  AND?: InputMaybe<Array<PassWhereInput>>;
  NOT?: InputMaybe<Array<PassWhereInput>>;
  OR?: InputMaybe<Array<PassWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  inputs?: InputMaybe<BeamInputListRelationFilter>;
  outputs?: InputMaybe<BeamOutputListRelationFilter>;
  passType?: InputMaybe<PassTypeNullableScalarRelationFilter>;
  passTypeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type PassWhereUniqueInput = {
  AND?: InputMaybe<Array<PassWhereInput>>;
  NOT?: InputMaybe<Array<PassWhereInput>>;
  OR?: InputMaybe<Array<PassWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputs?: InputMaybe<BeamInputListRelationFilter>;
  outputs?: InputMaybe<BeamOutputListRelationFilter>;
  passType?: InputMaybe<PassTypeNullableScalarRelationFilter>;
  passTypeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Passport = {
  __typename?: 'Passport';
  _count?: Maybe<PassportCount>;
  address?: Maybe<Address>;
  applicantData?: Maybe<ApplicantData>;
  applicantDataId?: Maybe<Scalars['String']['output']>;
  backImage?: Maybe<File>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth: Scalars['String']['output'];
  documentType?: Maybe<Scalars['String']['output']>;
  expiryDate: Scalars['String']['output'];
  extractedPhoto?: Maybe<File>;
  frontImage?: Maybe<File>;
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idVerificationResult: Array<IdVerificationResult>;
  issueDate: Scalars['String']['output'];
  name?: Maybe<Name>;
  nationality: Scalars['String']['output'];
  passportNumber: Scalars['String']['output'];
  placeOfBirth: Scalars['String']['output'];
  selfieImage?: Maybe<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type PassportAddressArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type PassportApplicantDataArgs = {
  where?: InputMaybe<ApplicantDataWhereInput>;
};


export type PassportBackImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type PassportExtractedPhotoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type PassportFrontImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type PassportIdVerificationResultArgs = {
  cursor?: InputMaybe<IdVerificationResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<IdVerificationResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IdVerificationResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IdVerificationResultWhereInput>;
};


export type PassportNameArgs = {
  where?: InputMaybe<NameWhereInput>;
};


export type PassportSelfieImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type PassportUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type PassportCount = {
  __typename?: 'PassportCount';
  idVerificationResult: Scalars['Int']['output'];
};


export type PassportCountIdVerificationResultArgs = {
  where?: InputMaybe<IdVerificationResultWhereInput>;
};

export type PassportCreateInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateManyUserInput = {
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PassportCreateManyUserInputEnvelope = {
  data: Array<PassportCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PassportCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PassportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassportCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PassportCreateWithoutUserInput>>;
  createMany?: InputMaybe<PassportCreateManyUserInputEnvelope>;
};

export type PassportCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<PassportCreateWithoutAddressInput>;
};

export type PassportCreateNestedOneWithoutApplicantDataInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<PassportCreateWithoutApplicantDataInput>;
};

export type PassportCreateNestedOneWithoutBackImageInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutBackImageInput>;
  create?: InputMaybe<PassportCreateWithoutBackImageInput>;
};

export type PassportCreateNestedOneWithoutExtractedPhotoInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutExtractedPhotoInput>;
  create?: InputMaybe<PassportCreateWithoutExtractedPhotoInput>;
};

export type PassportCreateNestedOneWithoutFrontImageInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutFrontImageInput>;
  create?: InputMaybe<PassportCreateWithoutFrontImageInput>;
};

export type PassportCreateNestedOneWithoutIdVerificationResultInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutIdVerificationResultInput>;
  create?: InputMaybe<PassportCreateWithoutIdVerificationResultInput>;
};

export type PassportCreateNestedOneWithoutNameInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutNameInput>;
  create?: InputMaybe<PassportCreateWithoutNameInput>;
};

export type PassportCreateNestedOneWithoutSelfieImageInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutSelfieImageInput>;
  create?: InputMaybe<PassportCreateWithoutSelfieImageInput>;
};

export type PassportCreateOrConnectWithoutAddressInput = {
  create: PassportCreateWithoutAddressInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutApplicantDataInput = {
  create: PassportCreateWithoutApplicantDataInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutBackImageInput = {
  create: PassportCreateWithoutBackImageInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutExtractedPhotoInput = {
  create: PassportCreateWithoutExtractedPhotoInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutFrontImageInput = {
  create: PassportCreateWithoutFrontImageInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutIdVerificationResultInput = {
  create: PassportCreateWithoutIdVerificationResultInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutNameInput = {
  create: PassportCreateWithoutNameInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutSelfieImageInput = {
  create: PassportCreateWithoutSelfieImageInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateOrConnectWithoutUserInput = {
  create: PassportCreateWithoutUserInput;
  where: PassportWhereUniqueInput;
};

export type PassportCreateWithoutAddressInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutApplicantDataInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutBackImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutExtractedPhotoInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutFrontImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutIdVerificationResultInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutNameInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutSelfieImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPassportsInput>;
};

export type PassportCreateWithoutUserInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutPassportInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutPassportInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutPassportBackInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutPassportExtractPhotoInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutPassportFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutPassportInput>;
  issueDate: Scalars['String']['input'];
  name?: InputMaybe<NameCreateNestedOneWithoutPassportInput>;
  nationality: Scalars['String']['input'];
  passportNumber: Scalars['String']['input'];
  placeOfBirth: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutPassportCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PassportListRelationFilter = {
  every?: InputMaybe<PassportWhereInput>;
  none?: InputMaybe<PassportWhereInput>;
  some?: InputMaybe<PassportWhereInput>;
};

export type PassportNullableScalarRelationFilter = {
  is?: InputMaybe<PassportWhereInput>;
  isNot?: InputMaybe<PassportWhereInput>;
};

export type PassportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PassportOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantDataId?: InputMaybe<SortOrderInput>;
  backImage?: InputMaybe<FileOrderByWithRelationInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  documentType?: InputMaybe<SortOrderInput>;
  expiryDate?: InputMaybe<SortOrder>;
  extractedPhoto?: InputMaybe<FileOrderByWithRelationInput>;
  frontImage?: InputMaybe<FileOrderByWithRelationInput>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idVerificationResult?: InputMaybe<IdVerificationResultOrderByRelationAggregateInput>;
  issueDate?: InputMaybe<SortOrder>;
  name?: InputMaybe<NameOrderByWithRelationInput>;
  nationality?: InputMaybe<SortOrder>;
  passportNumber?: InputMaybe<SortOrder>;
  placeOfBirth?: InputMaybe<SortOrder>;
  selfieImage?: InputMaybe<FileOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum PassportScalarFieldEnum {
  ApplicantDataId = 'applicantDataId',
  Country = 'country',
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DocumentType = 'documentType',
  ExpiryDate = 'expiryDate',
  Gender = 'gender',
  Id = 'id',
  IssueDate = 'issueDate',
  Nationality = 'nationality',
  PassportNumber = 'passportNumber',
  PlaceOfBirth = 'placeOfBirth',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type PassportScalarWhereInput = {
  AND?: InputMaybe<Array<PassportScalarWhereInput>>;
  NOT?: InputMaybe<Array<PassportScalarWhereInput>>;
  OR?: InputMaybe<Array<PassportScalarWhereInput>>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringNullableFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  issueDate?: InputMaybe<StringFilter>;
  nationality?: InputMaybe<StringFilter>;
  passportNumber?: InputMaybe<StringFilter>;
  placeOfBirth?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type PassportUpdateInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateManyMutationInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassportUpdateManyWithWhereWithoutUserInput = {
  data: PassportUpdateManyMutationInput;
  where: PassportScalarWhereInput;
};

export type PassportUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PassportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassportCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PassportCreateWithoutUserInput>>;
  createMany?: InputMaybe<PassportCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PassportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassportWhereUniqueInput>>;
  set?: InputMaybe<Array<PassportWhereUniqueInput>>;
  update?: InputMaybe<Array<PassportUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PassportUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PassportUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PassportUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<PassportCreateWithoutAddressInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<PassportUpsertWithoutAddressInput>;
};

export type PassportUpdateOneWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<PassportCreateWithoutApplicantDataInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutApplicantDataInput>;
  upsert?: InputMaybe<PassportUpsertWithoutApplicantDataInput>;
};

export type PassportUpdateOneWithoutBackImageNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutBackImageInput>;
  create?: InputMaybe<PassportCreateWithoutBackImageInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutBackImageInput>;
  upsert?: InputMaybe<PassportUpsertWithoutBackImageInput>;
};

export type PassportUpdateOneWithoutExtractedPhotoNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutExtractedPhotoInput>;
  create?: InputMaybe<PassportCreateWithoutExtractedPhotoInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutExtractedPhotoInput>;
  upsert?: InputMaybe<PassportUpsertWithoutExtractedPhotoInput>;
};

export type PassportUpdateOneWithoutFrontImageNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutFrontImageInput>;
  create?: InputMaybe<PassportCreateWithoutFrontImageInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutFrontImageInput>;
  upsert?: InputMaybe<PassportUpsertWithoutFrontImageInput>;
};

export type PassportUpdateOneWithoutIdVerificationResultNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutIdVerificationResultInput>;
  create?: InputMaybe<PassportCreateWithoutIdVerificationResultInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutIdVerificationResultInput>;
  upsert?: InputMaybe<PassportUpsertWithoutIdVerificationResultInput>;
};

export type PassportUpdateOneWithoutNameNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutNameInput>;
  create?: InputMaybe<PassportCreateWithoutNameInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutNameInput>;
  upsert?: InputMaybe<PassportUpsertWithoutNameInput>;
};

export type PassportUpdateOneWithoutSelfieImageNestedInput = {
  connect?: InputMaybe<PassportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PassportCreateOrConnectWithoutSelfieImageInput>;
  create?: InputMaybe<PassportCreateWithoutSelfieImageInput>;
  delete?: InputMaybe<PassportWhereInput>;
  disconnect?: InputMaybe<PassportWhereInput>;
  update?: InputMaybe<PassportUpdateToOneWithWhereWithoutSelfieImageInput>;
  upsert?: InputMaybe<PassportUpsertWithoutSelfieImageInput>;
};

export type PassportUpdateToOneWithWhereWithoutAddressInput = {
  data: PassportUpdateWithoutAddressInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutApplicantDataInput = {
  data: PassportUpdateWithoutApplicantDataInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutBackImageInput = {
  data: PassportUpdateWithoutBackImageInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutExtractedPhotoInput = {
  data: PassportUpdateWithoutExtractedPhotoInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutFrontImageInput = {
  data: PassportUpdateWithoutFrontImageInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutIdVerificationResultInput = {
  data: PassportUpdateWithoutIdVerificationResultInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutNameInput = {
  data: PassportUpdateWithoutNameInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateToOneWithWhereWithoutSelfieImageInput = {
  data: PassportUpdateWithoutSelfieImageInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpdateWithWhereUniqueWithoutUserInput = {
  data: PassportUpdateWithoutUserInput;
  where: PassportWhereUniqueInput;
};

export type PassportUpdateWithoutAddressInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutApplicantDataInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutBackImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutExtractedPhotoInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutFrontImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutIdVerificationResultInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutNameInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutSelfieImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPassportsNestedInput>;
};

export type PassportUpdateWithoutUserInput = {
  address?: InputMaybe<AddressUpdateOneWithoutPassportNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutPassportNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutPassportBackNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutPassportExtractPhotoNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutPassportFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutPassportNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutPassportNestedInput>;
  nationality?: InputMaybe<StringFieldUpdateOperationsInput>;
  passportNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutPassportCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassportUpsertWithWhereUniqueWithoutUserInput = {
  create: PassportCreateWithoutUserInput;
  update: PassportUpdateWithoutUserInput;
  where: PassportWhereUniqueInput;
};

export type PassportUpsertWithoutAddressInput = {
  create: PassportCreateWithoutAddressInput;
  update: PassportUpdateWithoutAddressInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutApplicantDataInput = {
  create: PassportCreateWithoutApplicantDataInput;
  update: PassportUpdateWithoutApplicantDataInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutBackImageInput = {
  create: PassportCreateWithoutBackImageInput;
  update: PassportUpdateWithoutBackImageInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutExtractedPhotoInput = {
  create: PassportCreateWithoutExtractedPhotoInput;
  update: PassportUpdateWithoutExtractedPhotoInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutFrontImageInput = {
  create: PassportCreateWithoutFrontImageInput;
  update: PassportUpdateWithoutFrontImageInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutIdVerificationResultInput = {
  create: PassportCreateWithoutIdVerificationResultInput;
  update: PassportUpdateWithoutIdVerificationResultInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutNameInput = {
  create: PassportCreateWithoutNameInput;
  update: PassportUpdateWithoutNameInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportUpsertWithoutSelfieImageInput = {
  create: PassportCreateWithoutSelfieImageInput;
  update: PassportUpdateWithoutSelfieImageInput;
  where?: InputMaybe<PassportWhereInput>;
};

export type PassportWhereInput = {
  AND?: InputMaybe<Array<PassportWhereInput>>;
  NOT?: InputMaybe<Array<PassportWhereInput>>;
  OR?: InputMaybe<Array<PassportWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  backImage?: InputMaybe<FileNullableScalarRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringNullableFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  extractedPhoto?: InputMaybe<FileNullableScalarRelationFilter>;
  frontImage?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  idVerificationResult?: InputMaybe<IdVerificationResultListRelationFilter>;
  issueDate?: InputMaybe<StringFilter>;
  name?: InputMaybe<NameNullableScalarRelationFilter>;
  nationality?: InputMaybe<StringFilter>;
  passportNumber?: InputMaybe<StringFilter>;
  placeOfBirth?: InputMaybe<StringFilter>;
  selfieImage?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type PassportWhereUniqueInput = {
  AND?: InputMaybe<Array<PassportWhereInput>>;
  NOT?: InputMaybe<Array<PassportWhereInput>>;
  OR?: InputMaybe<Array<PassportWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  backImage?: InputMaybe<FileNullableScalarRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringNullableFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  extractedPhoto?: InputMaybe<FileNullableScalarRelationFilter>;
  frontImage?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultListRelationFilter>;
  issueDate?: InputMaybe<StringFilter>;
  name?: InputMaybe<NameNullableScalarRelationFilter>;
  nationality?: InputMaybe<StringFilter>;
  passportNumber?: InputMaybe<StringFilter>;
  placeOfBirth?: InputMaybe<StringFilter>;
  selfieImage?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export enum PerformerTypes {
  Api = 'API',
  App = 'APP',
  Bot = 'BOT',
  User = 'USER'
}

export enum Platform {
  Cognition = 'COGNITION',
  Cortex = 'CORTEX',
  RapidRequest = 'RAPID_REQUEST',
  Vid = 'VID'
}

export enum ProcessorEnum {
  Auto = 'AUTO',
  Canary = 'CANARY',
  IntegrationTest = 'INTEGRATION_TEST',
  Manual = 'MANUAL',
  Tazworks = 'TAZWORKS'
}

export type Product = {
  __typename?: 'Product';
  _count?: Maybe<ProductCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductCount = {
  __typename?: 'ProductCount';
  roleAssignment: Scalars['Int']['output'];
};


export type ProductCountRoleAssignmentArgs = {
  where?: InputMaybe<RoleAssignmentWhereInput>;
};

export type ProductCreateNestedOneWithoutRoleAssignmentInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutRoleAssignmentInput>;
  create?: InputMaybe<ProductCreateWithoutRoleAssignmentInput>;
};

export type ProductCreateOrConnectWithoutRoleAssignmentInput = {
  create: ProductCreateWithoutRoleAssignmentInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutRoleAssignmentInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProductNullableScalarRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  roleAssignment?: InputMaybe<RoleAssignmentOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type ProductUpdateOneWithoutRoleAssignmentNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutRoleAssignmentInput>;
  create?: InputMaybe<ProductCreateWithoutRoleAssignmentInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<ProductWhereInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutRoleAssignmentInput>;
  upsert?: InputMaybe<ProductUpsertWithoutRoleAssignmentInput>;
};

export type ProductUpdateToOneWithWhereWithoutRoleAssignmentInput = {
  data: ProductUpdateWithoutRoleAssignmentInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithoutRoleAssignmentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductUpsertWithoutRoleAssignmentInput = {
  create: ProductCreateWithoutRoleAssignmentInput;
  update: ProductUpdateWithoutRoleAssignmentInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  roleAssignment?: InputMaybe<RoleAssignmentListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleAssignment?: InputMaybe<RoleAssignmentListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type Query = {
  __typename?: 'Query';
  address?: Maybe<Address>;
  addresses: Array<Address>;
  aggregateAppFeedback: AggregateAppFeedback;
  aggregateAuditLog: AggregateAuditLog;
  aggregateBeamInput: AggregateBeamInput;
  aggregateDisclosure: AggregateDisclosure;
  aggregateDispute: AggregateDispute;
  aggregateJob: AggregateJob;
  aggregateMonitoringConfiguration: AggregateMonitoringConfiguration;
  aggregateMonitoringCycle: AggregateMonitoringCycle;
  aggregateMonitoringDelta: AggregateMonitoringDelta;
  aggregateMonitoringEnrollment: AggregateMonitoringEnrollment;
  aggregateMonitoringReport: AggregateMonitoringReport;
  aggregateOrder: AggregateOrder;
  aggregateOrganization: AggregateOrganization;
  aggregatePackageAccess: AggregatePackageAccess;
  aggregatePackageSet: AggregatePackageSet;
  aggregateUser: AggregateUser;
  aggregateVIDVoucher: AggregateVidVoucher;
  apiKey?: Maybe<ApiKey>;
  apiKeys: Array<ApiKey>;
  appFeedback?: Maybe<AppFeedback>;
  appFeedbacks: Array<AppFeedback>;
  auditLog?: Maybe<AuditLog>;
  auditLogs: Array<AuditLog>;
  beam?: Maybe<Beam>;
  beamInput?: Maybe<BeamInput>;
  beamInputType?: Maybe<BeamInputType>;
  beamInputTypes: Array<BeamInputType>;
  beamInputs: Array<BeamInput>;
  beamRun?: Maybe<BeamRun>;
  beams: Array<Beam>;
  biometricConsentAcceptance?: Maybe<BiometricConsentAcceptance>;
  biometricConsentAcceptances: Array<BiometricConsentAcceptance>;
  checkEmailVerified: CheckEmailVerifiedResponse;
  checkVoucherValidity?: Maybe<VidVoucher>;
  complianceLetter?: Maybe<ComplianceLetter>;
  credential?: Maybe<Credential>;
  credentialStatus?: Maybe<CredentialStatus>;
  credentialType?: Maybe<CredentialType>;
  credentials: Array<Credential>;
  decodeBranchUrl?: Maybe<Response>;
  disclosure?: Maybe<Disclosure>;
  disclosureAcceptance?: Maybe<DisclosureAcceptance>;
  disclosureAcceptances: Array<DisclosureAcceptance>;
  disclosures: Array<Disclosure>;
  dispatchedSearch?: Maybe<DispatchedSearch>;
  dispute?: Maybe<Dispute>;
  disputes: Array<Dispute>;
  file?: Maybe<File>;
  findFirstLegacyCredential?: Maybe<LegacyCredential>;
  findUniqueApplicantData?: Maybe<ApplicantData>;
  generateSignedDisclosurePdf: GenerateSignedDisclosurePdfResponse;
  getInvite?: Maybe<InviteRes>;
  getRegistrationPortalDetails?: Maybe<RegistrationPortalDetails>;
  getSvixAppPortalUrl?: Maybe<SvixAppPortalUrlResponse>;
  getSvixWebhookDeliveryAttempts: Array<SvixWebhookDeliveryAttempt>;
  getVoucherStatus?: Maybe<GetVoucherStatusResponse>;
  groupByJob: Array<JobGroupBy>;
  highlySensitiveIdentifier?: Maybe<HighlySensitiveIdentifier>;
  idVerificationResult?: Maybe<IdVerificationResult>;
  idVerificationResults: Array<IdVerificationResult>;
  identificationDocument?: Maybe<IdentificationDocument>;
  invite?: Maybe<Invite>;
  inviteExports: Array<InviteExport>;
  invites: Array<Invite>;
  job?: Maybe<Job>;
  jobs: Array<Job>;
  legacyCredential?: Maybe<LegacyCredential>;
  legacyCredentials: Array<LegacyCredential>;
  me?: Maybe<User>;
  monitoringConfiguration?: Maybe<MonitoringConfiguration>;
  monitoringConfigurations: Array<MonitoringConfiguration>;
  monitoringCycle?: Maybe<MonitoringCycle>;
  monitoringCycles: Array<MonitoringCycle>;
  monitoringDelta?: Maybe<MonitoringDelta>;
  monitoringDeltas: Array<MonitoringDelta>;
  monitoringEnrollment?: Maybe<MonitoringEnrollment>;
  monitoringEnrollments: Array<MonitoringEnrollment>;
  monitoringReport?: Maybe<MonitoringReport>;
  monitoringReports: Array<MonitoringReport>;
  name?: Maybe<Name>;
  names: Array<Name>;
  order?: Maybe<Order>;
  orderListSearch: OrderListSearchResult;
  orderNote?: Maybe<OrderNote>;
  orderNotes: Array<OrderNote>;
  orders: Array<Order>;
  organization: OrganizationRes;
  organizations: Array<Organization>;
  packageAccess?: Maybe<PackageAccess>;
  packageAccesses: Array<PackageAccess>;
  packageSet?: Maybe<PackageSet>;
  packageSets: Array<PackageSet>;
  pass?: Maybe<Pass>;
  passType?: Maybe<PassType>;
  passTypes: Array<PassType>;
  passes: Array<Pass>;
  passport?: Maybe<Passport>;
  reportableIdVerificationResult?: Maybe<ReportableIdVerificationResult>;
  requestedSearch?: Maybe<RequestedSearch>;
  result?: Maybe<Result>;
  resultRevision?: Maybe<ResultRevision>;
  retrieveBiometricDisclosures: Array<Disclosure>;
  retrieveDisclosures: Array<Disclosure>;
  roleAssignments: Array<RoleAssignment>;
  roleV2s: Array<RoleV2>;
  searchType?: Maybe<SearchType>;
  secret?: Maybe<Secret>;
  secrets: Array<Secret>;
  stateIdentificationCard?: Maybe<StateIdentificationCard>;
  synapseCaseFormation?: Maybe<SynapseCaseFormation>;
  synapseCaseFormations: Array<SynapseCaseFormation>;
  synapseWorkflow?: Maybe<SynapseWorkflow>;
  synapseWorkflows: Array<SynapseWorkflow>;
  user?: Maybe<User>;
  users: Array<User>;
  vIDVoucher?: Maybe<VidVoucher>;
  vIDVouchers: Array<VidVoucher>;
  vendorConfiguration?: Maybe<VendorConfiguration>;
  vendorConfigurations: Array<VendorConfiguration>;
  webhook?: Maybe<Webhook>;
  webhooks: Array<Webhook>;
};


export type QueryAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type QueryAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryAggregateAppFeedbackArgs = {
  cursor?: InputMaybe<AppFeedbackWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AppFeedbackOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AppFeedbackWhereInput>;
};


export type QueryAggregateAuditLogArgs = {
  cursor?: InputMaybe<AuditLogWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type QueryAggregateBeamInputArgs = {
  cursor?: InputMaybe<BeamInputWhereUniqueInput>;
  orderBy?: InputMaybe<Array<BeamInputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};


export type QueryAggregateDisclosureArgs = {
  cursor?: InputMaybe<DisclosureWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DisclosureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureWhereInput>;
};


export type QueryAggregateDisputeArgs = {
  cursor?: InputMaybe<DisputeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DisputeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type QueryAggregateJobArgs = {
  cursor?: InputMaybe<JobWhereUniqueInput>;
  orderBy?: InputMaybe<Array<JobOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobWhereInput>;
};


export type QueryAggregateMonitoringConfigurationArgs = {
  cursor?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MonitoringConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};


export type QueryAggregateMonitoringCycleArgs = {
  cursor?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MonitoringCycleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};


export type QueryAggregateMonitoringDeltaArgs = {
  cursor?: InputMaybe<MonitoringDeltaWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MonitoringDeltaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type QueryAggregateMonitoringEnrollmentArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type QueryAggregateMonitoringReportArgs = {
  cursor?: InputMaybe<MonitoringReportWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MonitoringReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringReportWhereInput>;
};


export type QueryAggregateOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryAggregateOrganizationArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryAggregatePackageAccessArgs = {
  cursor?: InputMaybe<PackageAccessWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PackageAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type QueryAggregatePackageSetArgs = {
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageSetWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryAggregateVidVoucherArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type QueryApiKeyArgs = {
  where: ApiKeyWhereUniqueInput;
};


export type QueryApiKeysArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type QueryAppFeedbackArgs = {
  where: AppFeedbackWhereUniqueInput;
};


export type QueryAppFeedbacksArgs = {
  cursor?: InputMaybe<AppFeedbackWhereUniqueInput>;
  distinct?: InputMaybe<Array<AppFeedbackScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AppFeedbackOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AppFeedbackWhereInput>;
};


export type QueryAuditLogArgs = {
  where: AuditLogWhereUniqueInput;
};


export type QueryAuditLogsArgs = {
  cursor?: InputMaybe<AuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type QueryBeamArgs = {
  where: BeamWhereUniqueInput;
};


export type QueryBeamInputArgs = {
  where: BeamInputWhereUniqueInput;
};


export type QueryBeamInputTypeArgs = {
  where: BeamInputTypeWhereUniqueInput;
};


export type QueryBeamInputTypesArgs = {
  cursor?: InputMaybe<BeamInputTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputTypeWhereInput>;
};


export type QueryBeamInputsArgs = {
  cursor?: InputMaybe<BeamInputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};


export type QueryBeamRunArgs = {
  where: BeamRunWhereUniqueInput;
};


export type QueryBeamsArgs = {
  cursor?: InputMaybe<BeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamWhereInput>;
};


export type QueryBiometricConsentAcceptanceArgs = {
  where: BiometricConsentAcceptanceWhereUniqueInput;
};


export type QueryBiometricConsentAcceptancesArgs = {
  cursor?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<BiometricConsentAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BiometricConsentAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type QueryCheckVoucherValidityArgs = {
  voucherId: Scalars['String']['input'];
};


export type QueryComplianceLetterArgs = {
  where: ComplianceLetterWhereUniqueInput;
};


export type QueryCredentialArgs = {
  where: CredentialWhereUniqueInput;
};


export type QueryCredentialStatusArgs = {
  where: CredentialStatusWhereUniqueInput;
};


export type QueryCredentialTypeArgs = {
  where: CredentialTypeWhereUniqueInput;
};


export type QueryCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryDecodeBranchUrlArgs = {
  branchUrl: Scalars['String']['input'];
};


export type QueryDisclosureArgs = {
  where: DisclosureWhereUniqueInput;
};


export type QueryDisclosureAcceptanceArgs = {
  where: DisclosureAcceptanceWhereUniqueInput;
};


export type QueryDisclosureAcceptancesArgs = {
  cursor?: InputMaybe<DisclosureAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type QueryDisclosuresArgs = {
  cursor?: InputMaybe<DisclosureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureWhereInput>;
};


export type QueryDispatchedSearchArgs = {
  where: DispatchedSearchWhereUniqueInput;
};


export type QueryDisputeArgs = {
  where: DisputeWhereUniqueInput;
};


export type QueryDisputesArgs = {
  cursor?: InputMaybe<DisputeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisputeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisputeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type QueryFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryFindFirstLegacyCredentialArgs = {
  cursor?: InputMaybe<LegacyCredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<LegacyCredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LegacyCredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LegacyCredentialWhereInput>;
};


export type QueryFindUniqueApplicantDataArgs = {
  where: ApplicantDataWhereUniqueInput;
};


export type QueryGenerateSignedDisclosurePdfArgs = {
  disclosureAcceptanceId: Scalars['String']['input'];
};


export type QueryGetInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type QueryGetRegistrationPortalDetailsArgs = {
  packageId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSvixAppPortalUrlArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetSvixWebhookDeliveryAttemptsArgs = {
  orderNoteId: Scalars['String']['input'];
};


export type QueryGetVoucherStatusArgs = {
  voucherId: Scalars['String']['input'];
};


export type QueryGroupByJobArgs = {
  by: Array<JobScalarFieldEnum>;
  having?: InputMaybe<JobScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<JobOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobWhereInput>;
};


export type QueryHighlySensitiveIdentifierArgs = {
  where: HighlySensitiveIdentifierWhereUniqueInput;
};


export type QueryIdVerificationResultArgs = {
  where: IdVerificationResultWhereUniqueInput;
};


export type QueryIdVerificationResultsArgs = {
  cursor?: InputMaybe<IdVerificationResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<IdVerificationResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IdVerificationResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IdVerificationResultWhereInput>;
};


export type QueryIdentificationDocumentArgs = {
  where: IdentificationDocumentWhereUniqueInput;
};


export type QueryInviteArgs = {
  where: InviteWhereUniqueInput;
};


export type QueryInvitesArgs = {
  cursor?: InputMaybe<InviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<InviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type QueryJobArgs = {
  where: JobWhereUniqueInput;
};


export type QueryJobsArgs = {
  cursor?: InputMaybe<JobWhereUniqueInput>;
  distinct?: InputMaybe<Array<JobScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<JobOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobWhereInput>;
};


export type QueryLegacyCredentialArgs = {
  where: LegacyCredentialWhereUniqueInput;
};


export type QueryLegacyCredentialsArgs = {
  cursor?: InputMaybe<LegacyCredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<LegacyCredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LegacyCredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LegacyCredentialWhereInput>;
};


export type QueryMonitoringConfigurationArgs = {
  where: MonitoringConfigurationWhereUniqueInput;
};


export type QueryMonitoringConfigurationsArgs = {
  cursor?: InputMaybe<MonitoringConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringConfigurationWhereInput>;
};


export type QueryMonitoringCycleArgs = {
  where: MonitoringCycleWhereUniqueInput;
};


export type QueryMonitoringCyclesArgs = {
  cursor?: InputMaybe<MonitoringCycleWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringCycleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringCycleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringCycleWhereInput>;
};


export type QueryMonitoringDeltaArgs = {
  where: MonitoringDeltaWhereUniqueInput;
};


export type QueryMonitoringDeltasArgs = {
  cursor?: InputMaybe<MonitoringDeltaWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringDeltaScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringDeltaOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringDeltaWhereInput>;
};


export type QueryMonitoringEnrollmentArgs = {
  where: MonitoringEnrollmentWhereUniqueInput;
};


export type QueryMonitoringEnrollmentsArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringEnrollmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type QueryMonitoringReportArgs = {
  where: MonitoringReportWhereUniqueInput;
};


export type QueryMonitoringReportsArgs = {
  cursor?: InputMaybe<MonitoringReportWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringReportScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringReportWhereInput>;
};


export type QueryNameArgs = {
  where: NameWhereUniqueInput;
};


export type QueryNamesArgs = {
  cursor?: InputMaybe<NameWhereUniqueInput>;
  distinct?: InputMaybe<Array<NameScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NameOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NameWhereInput>;
};


export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryOrderListSearchArgs = {
  filter: OrderListSearchFilterInput;
  includeTotal?: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<Array<OrderListSearchOrderByInput>>;
  skip?: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryOrderNoteArgs = {
  where: OrderNoteWhereUniqueInput;
};


export type QueryOrderNotesArgs = {
  cursor?: InputMaybe<OrderNoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderNoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderNoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderNoteWhereInput>;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryPackageAccessArgs = {
  where: PackageAccessWhereUniqueInput;
};


export type QueryPackageAccessesArgs = {
  cursor?: InputMaybe<PackageAccessWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageAccessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageAccessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageAccessWhereInput>;
};


export type QueryPackageSetArgs = {
  where: PackageSetWhereUniqueInput;
};


export type QueryPackageSetsArgs = {
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  distinct?: InputMaybe<Array<PackageSetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PackageSetWhereInput>;
};


export type QueryPassArgs = {
  where: PassWhereUniqueInput;
};


export type QueryPassTypeArgs = {
  where: PassTypeWhereUniqueInput;
};


export type QueryPassTypesArgs = {
  cursor?: InputMaybe<PassTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassTypeWhereInput>;
};


export type QueryPassesArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassWhereInput>;
};


export type QueryPassportArgs = {
  where: PassportWhereUniqueInput;
};


export type QueryReportableIdVerificationResultArgs = {
  where: ReportableIdVerificationResultWhereUniqueInput;
};


export type QueryRequestedSearchArgs = {
  where: RequestedSearchWhereUniqueInput;
};


export type QueryResultArgs = {
  where: ResultWhereUniqueInput;
};


export type QueryResultRevisionArgs = {
  where: ResultRevisionWhereUniqueInput;
};


export type QueryRetrieveBiometricDisclosuresArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
};


export type QueryRetrieveDisclosuresArgs = {
  addresses: Array<DisclosureAddress>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
};


export type QueryRoleAssignmentsArgs = {
  cursor?: InputMaybe<RoleAssignmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleAssignmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleAssignmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleAssignmentWhereInput>;
};


export type QueryRoleV2sArgs = {
  cursor?: InputMaybe<RoleV2WhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleV2ScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleV2OrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleV2WhereInput>;
};


export type QuerySearchTypeArgs = {
  where: SearchTypeWhereUniqueInput;
};


export type QuerySecretArgs = {
  where: SecretWhereUniqueInput;
};


export type QuerySecretsArgs = {
  cursor?: InputMaybe<SecretWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecretScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecretOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SecretWhereInput>;
};


export type QueryStateIdentificationCardArgs = {
  where: StateIdentificationCardWhereUniqueInput;
};


export type QuerySynapseCaseFormationArgs = {
  where: SynapseCaseFormationWhereUniqueInput;
};


export type QuerySynapseCaseFormationsArgs = {
  cursor?: InputMaybe<SynapseCaseFormationWhereUniqueInput>;
  distinct?: InputMaybe<Array<SynapseCaseFormationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SynapseCaseFormationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SynapseCaseFormationWhereInput>;
};


export type QuerySynapseWorkflowArgs = {
  where: SynapseWorkflowWhereUniqueInput;
};


export type QuerySynapseWorkflowsArgs = {
  cursor?: InputMaybe<SynapseWorkflowWhereUniqueInput>;
  distinct?: InputMaybe<Array<SynapseWorkflowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SynapseWorkflowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SynapseWorkflowWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVIdVoucherArgs = {
  where: VidVoucherWhereUniqueInput;
};


export type QueryVIdVouchersArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  distinct?: InputMaybe<Array<VidVoucherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type QueryVendorConfigurationArgs = {
  where: VendorConfigurationWhereUniqueInput;
};


export type QueryVendorConfigurationsArgs = {
  cursor?: InputMaybe<VendorConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VendorConfigurationWhereInput>;
};


export type QueryWebhookArgs = {
  where: WebhookWhereUniqueInput;
};


export type QueryWebhooksArgs = {
  cursor?: InputMaybe<WebhookWhereUniqueInput>;
  distinct?: InputMaybe<Array<WebhookScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WebhookOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WebhookWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RegistrationPortalDetails = {
  __typename?: 'RegistrationPortalDetails';
  organizationId: Scalars['String']['output'];
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  vidWebInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type RegistrationPortalInvite = {
  __typename?: 'RegistrationPortalInvite';
  email: Scalars['String']['output'];
  vIDInviteUrl: Scalars['String']['output'];
  vIDQRCode: Scalars['String']['output'];
  vIDShortCode: Scalars['String']['output'];
  vIDWebInviteUrl: Scalars['String']['output'];
};

export type ReportableIdVerificationResult = {
  __typename?: 'ReportableIdVerificationResult';
  applicantAliasDataId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  idScanBiometricMatch: Scalars['Boolean']['output'];
  idScanData: Scalars['JSON']['output'];
  orderId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ReportableIdVerificationResultCreateInput = {
  applicantAliasData?: InputMaybe<ApplicantDataCreateNestedOneWithoutReportableIdVerificationResultInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idScanBiometricMatch: Scalars['Boolean']['input'];
  idScanData: Scalars['JSON']['input'];
  order: OrderCreateNestedOneWithoutReportableIdVerificationResultInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReportableIdVerificationResultCreateNestedOneWithoutApplicantAliasDataInput = {
  connect?: InputMaybe<ReportableIdVerificationResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReportableIdVerificationResultCreateOrConnectWithoutApplicantAliasDataInput>;
  create?: InputMaybe<ReportableIdVerificationResultCreateWithoutApplicantAliasDataInput>;
};

export type ReportableIdVerificationResultCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<ReportableIdVerificationResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReportableIdVerificationResultCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<ReportableIdVerificationResultCreateWithoutOrderInput>;
};

export type ReportableIdVerificationResultCreateOrConnectWithoutApplicantAliasDataInput = {
  create: ReportableIdVerificationResultCreateWithoutApplicantAliasDataInput;
  where: ReportableIdVerificationResultWhereUniqueInput;
};

export type ReportableIdVerificationResultCreateOrConnectWithoutOrderInput = {
  create: ReportableIdVerificationResultCreateWithoutOrderInput;
  where: ReportableIdVerificationResultWhereUniqueInput;
};

export type ReportableIdVerificationResultCreateWithoutApplicantAliasDataInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idScanBiometricMatch: Scalars['Boolean']['input'];
  idScanData: Scalars['JSON']['input'];
  order: OrderCreateNestedOneWithoutReportableIdVerificationResultInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReportableIdVerificationResultCreateWithoutOrderInput = {
  applicantAliasData?: InputMaybe<ApplicantDataCreateNestedOneWithoutReportableIdVerificationResultInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  idScanBiometricMatch: Scalars['Boolean']['input'];
  idScanData: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ReportableIdVerificationResultNullableScalarRelationFilter = {
  is?: InputMaybe<ReportableIdVerificationResultWhereInput>;
  isNot?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};

export type ReportableIdVerificationResultOrderByWithRelationInput = {
  applicantAliasData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantAliasDataId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idScanBiometricMatch?: InputMaybe<SortOrder>;
  idScanData?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReportableIdVerificationResultUpdateInput = {
  applicantAliasData?: InputMaybe<ApplicantDataUpdateOneWithoutReportableIdVerificationResultNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idScanBiometricMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  idScanData?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutReportableIdVerificationResultNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReportableIdVerificationResultUpdateOneWithoutApplicantAliasDataNestedInput = {
  connect?: InputMaybe<ReportableIdVerificationResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReportableIdVerificationResultCreateOrConnectWithoutApplicantAliasDataInput>;
  create?: InputMaybe<ReportableIdVerificationResultCreateWithoutApplicantAliasDataInput>;
  delete?: InputMaybe<ReportableIdVerificationResultWhereInput>;
  disconnect?: InputMaybe<ReportableIdVerificationResultWhereInput>;
  update?: InputMaybe<ReportableIdVerificationResultUpdateToOneWithWhereWithoutApplicantAliasDataInput>;
  upsert?: InputMaybe<ReportableIdVerificationResultUpsertWithoutApplicantAliasDataInput>;
};

export type ReportableIdVerificationResultUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<ReportableIdVerificationResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReportableIdVerificationResultCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<ReportableIdVerificationResultCreateWithoutOrderInput>;
  delete?: InputMaybe<ReportableIdVerificationResultWhereInput>;
  disconnect?: InputMaybe<ReportableIdVerificationResultWhereInput>;
  update?: InputMaybe<ReportableIdVerificationResultUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<ReportableIdVerificationResultUpsertWithoutOrderInput>;
};

export type ReportableIdVerificationResultUpdateToOneWithWhereWithoutApplicantAliasDataInput = {
  data: ReportableIdVerificationResultUpdateWithoutApplicantAliasDataInput;
  where?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};

export type ReportableIdVerificationResultUpdateToOneWithWhereWithoutOrderInput = {
  data: ReportableIdVerificationResultUpdateWithoutOrderInput;
  where?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};

export type ReportableIdVerificationResultUpdateWithoutApplicantAliasDataInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idScanBiometricMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  idScanData?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutReportableIdVerificationResultNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReportableIdVerificationResultUpdateWithoutOrderInput = {
  applicantAliasData?: InputMaybe<ApplicantDataUpdateOneWithoutReportableIdVerificationResultNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idScanBiometricMatch?: InputMaybe<BoolFieldUpdateOperationsInput>;
  idScanData?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ReportableIdVerificationResultUpsertWithoutApplicantAliasDataInput = {
  create: ReportableIdVerificationResultCreateWithoutApplicantAliasDataInput;
  update: ReportableIdVerificationResultUpdateWithoutApplicantAliasDataInput;
  where?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};

export type ReportableIdVerificationResultUpsertWithoutOrderInput = {
  create: ReportableIdVerificationResultCreateWithoutOrderInput;
  update: ReportableIdVerificationResultUpdateWithoutOrderInput;
  where?: InputMaybe<ReportableIdVerificationResultWhereInput>;
};

export type ReportableIdVerificationResultWhereInput = {
  AND?: InputMaybe<Array<ReportableIdVerificationResultWhereInput>>;
  NOT?: InputMaybe<Array<ReportableIdVerificationResultWhereInput>>;
  OR?: InputMaybe<Array<ReportableIdVerificationResultWhereInput>>;
  applicantAliasData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantAliasDataId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  idScanBiometricMatch?: InputMaybe<BoolFilter>;
  idScanData?: InputMaybe<JsonFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReportableIdVerificationResultWhereUniqueInput = {
  AND?: InputMaybe<Array<ReportableIdVerificationResultWhereInput>>;
  NOT?: InputMaybe<Array<ReportableIdVerificationResultWhereInput>>;
  OR?: InputMaybe<Array<ReportableIdVerificationResultWhereInput>>;
  applicantAliasData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantAliasDataId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idScanBiometricMatch?: InputMaybe<BoolFilter>;
  idScanData?: InputMaybe<JsonFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RequestMonitoringConfirmationReportResponse = {
  __typename?: 'RequestMonitoringConfirmationReportResponse';
  message: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type RequestedSearch = {
  __typename?: 'RequestedSearch';
  _count?: Maybe<RequestedSearchCount>;
  blob: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  dispatchedSearches: Array<DispatchedSearch>;
  id: Scalars['String']['output'];
  monitoringReport?: Maybe<MonitoringReport>;
  monitoringReportId?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  results: Array<Result>;
  searchType: SearchType;
  searchTypeId: Scalars['String']['output'];
  ssnId?: Maybe<Scalars['String']['output']>;
  status: SearchStatusTypeEnum;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type RequestedSearchDispatchedSearchesArgs = {
  cursor?: InputMaybe<DispatchedSearchWhereUniqueInput>;
  distinct?: InputMaybe<Array<DispatchedSearchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DispatchedSearchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type RequestedSearchMonitoringReportArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};


export type RequestedSearchResultsArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResultWhereInput>;
};

export type RequestedSearchCount = {
  __typename?: 'RequestedSearchCount';
  dispatchedSearches: Scalars['Int']['output'];
  results: Scalars['Int']['output'];
};


export type RequestedSearchCountDispatchedSearchesArgs = {
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type RequestedSearchCountResultsArgs = {
  where?: InputMaybe<ResultWhereInput>;
};

export type RequestedSearchCreateInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutRequestedSearchInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutRequestedSearchesInput>;
  order: OrderCreateNestedOneWithoutRequestedSearchesInput;
  results?: InputMaybe<ResultCreateNestedManyWithoutRequestedSearchInput>;
  searchType: SearchTypeCreateNestedOneWithoutRequestedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateManyMonitoringReportInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  searchTypeId: Scalars['String']['input'];
  ssnId?: InputMaybe<Scalars['String']['input']>;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateManyMonitoringReportInputEnvelope = {
  data: Array<RequestedSearchCreateManyMonitoringReportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestedSearchCreateManyOrderInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  searchTypeId: Scalars['String']['input'];
  ssnId?: InputMaybe<Scalars['String']['input']>;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateManyOrderInputEnvelope = {
  data: Array<RequestedSearchCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestedSearchCreateManySearchTypeInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  ssnId?: InputMaybe<Scalars['String']['input']>;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateManySearchTypeInputEnvelope = {
  data: Array<RequestedSearchCreateManySearchTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestedSearchCreateManySsnInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  searchTypeId: Scalars['String']['input'];
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateManySsnInputEnvelope = {
  data: Array<RequestedSearchCreateManySsnInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestedSearchCreateNestedManyWithoutMonitoringReportInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManyMonitoringReportInputEnvelope>;
};

export type RequestedSearchCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutOrderInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManyOrderInputEnvelope>;
};

export type RequestedSearchCreateNestedManyWithoutSearchTypeInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutSearchTypeInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutSearchTypeInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManySearchTypeInputEnvelope>;
};

export type RequestedSearchCreateNestedManyWithoutSsnInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutSsnInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutSsnInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManySsnInputEnvelope>;
};

export type RequestedSearchCreateNestedOneWithoutDispatchedSearchesInput = {
  connect?: InputMaybe<RequestedSearchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RequestedSearchCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<RequestedSearchCreateWithoutDispatchedSearchesInput>;
};

export type RequestedSearchCreateNestedOneWithoutResultsInput = {
  connect?: InputMaybe<RequestedSearchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RequestedSearchCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<RequestedSearchCreateWithoutResultsInput>;
};

export type RequestedSearchCreateOrConnectWithoutDispatchedSearchesInput = {
  create: RequestedSearchCreateWithoutDispatchedSearchesInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchCreateOrConnectWithoutMonitoringReportInput = {
  create: RequestedSearchCreateWithoutMonitoringReportInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchCreateOrConnectWithoutOrderInput = {
  create: RequestedSearchCreateWithoutOrderInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchCreateOrConnectWithoutResultsInput = {
  create: RequestedSearchCreateWithoutResultsInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchCreateOrConnectWithoutSearchTypeInput = {
  create: RequestedSearchCreateWithoutSearchTypeInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchCreateOrConnectWithoutSsnInput = {
  create: RequestedSearchCreateWithoutSsnInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchCreateWithoutDispatchedSearchesInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutRequestedSearchesInput>;
  order: OrderCreateNestedOneWithoutRequestedSearchesInput;
  results?: InputMaybe<ResultCreateNestedManyWithoutRequestedSearchInput>;
  searchType: SearchTypeCreateNestedOneWithoutRequestedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateWithoutMonitoringReportInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutRequestedSearchInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutRequestedSearchesInput;
  results?: InputMaybe<ResultCreateNestedManyWithoutRequestedSearchInput>;
  searchType: SearchTypeCreateNestedOneWithoutRequestedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateWithoutOrderInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutRequestedSearchInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutRequestedSearchesInput>;
  results?: InputMaybe<ResultCreateNestedManyWithoutRequestedSearchInput>;
  searchType: SearchTypeCreateNestedOneWithoutRequestedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateWithoutResultsInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutRequestedSearchInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutRequestedSearchesInput>;
  order: OrderCreateNestedOneWithoutRequestedSearchesInput;
  searchType: SearchTypeCreateNestedOneWithoutRequestedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateWithoutSearchTypeInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutRequestedSearchInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutRequestedSearchesInput>;
  order: OrderCreateNestedOneWithoutRequestedSearchesInput;
  results?: InputMaybe<ResultCreateNestedManyWithoutRequestedSearchInput>;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchCreateWithoutSsnInput = {
  blob: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutRequestedSearchInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutRequestedSearchesInput>;
  order: OrderCreateNestedOneWithoutRequestedSearchesInput;
  results?: InputMaybe<ResultCreateNestedManyWithoutRequestedSearchInput>;
  searchType: SearchTypeCreateNestedOneWithoutRequestedSearchesInput;
  status: SearchStatusTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RequestedSearchListRelationFilter = {
  every?: InputMaybe<RequestedSearchWhereInput>;
  none?: InputMaybe<RequestedSearchWhereInput>;
  some?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchNullableScalarRelationFilter = {
  is?: InputMaybe<RequestedSearchWhereInput>;
  isNot?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RequestedSearchOrderByWithRelationInput = {
  blob?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dispatchedSearches?: InputMaybe<DispatchedSearchOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  monitoringReport?: InputMaybe<MonitoringReportOrderByWithRelationInput>;
  monitoringReportId?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  results?: InputMaybe<ResultOrderByRelationAggregateInput>;
  searchType?: InputMaybe<SearchTypeOrderByWithRelationInput>;
  searchTypeId?: InputMaybe<SortOrder>;
  ssnId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum RequestedSearchScalarFieldEnum {
  Blob = 'blob',
  CreatedAt = 'createdAt',
  Id = 'id',
  MonitoringReportId = 'monitoringReportId',
  OrderId = 'orderId',
  SearchTypeId = 'searchTypeId',
  SsnId = 'ssnId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type RequestedSearchScalarRelationFilter = {
  is?: InputMaybe<RequestedSearchWhereInput>;
  isNot?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchScalarWhereInput = {
  AND?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  NOT?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  OR?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  blob?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<StringFilter>;
  searchTypeId?: InputMaybe<StringFilter>;
  ssnId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RequestedSearchUpdateManyMutationInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpdateManyWithWhereWithoutMonitoringReportInput = {
  data: RequestedSearchUpdateManyMutationInput;
  where: RequestedSearchScalarWhereInput;
};

export type RequestedSearchUpdateManyWithWhereWithoutOrderInput = {
  data: RequestedSearchUpdateManyMutationInput;
  where: RequestedSearchScalarWhereInput;
};

export type RequestedSearchUpdateManyWithWhereWithoutSearchTypeInput = {
  data: RequestedSearchUpdateManyMutationInput;
  where: RequestedSearchScalarWhereInput;
};

export type RequestedSearchUpdateManyWithWhereWithoutSsnInput = {
  data: RequestedSearchUpdateManyMutationInput;
  where: RequestedSearchScalarWhereInput;
};

export type RequestedSearchUpdateManyWithoutMonitoringReportNestedInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManyMonitoringReportInputEnvelope>;
  delete?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<RequestedSearchUpdateWithWhereUniqueWithoutMonitoringReportInput>>;
  updateMany?: InputMaybe<Array<RequestedSearchUpdateManyWithWhereWithoutMonitoringReportInput>>;
  upsert?: InputMaybe<Array<RequestedSearchUpsertWithWhereUniqueWithoutMonitoringReportInput>>;
};

export type RequestedSearchUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutOrderInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<RequestedSearchUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<RequestedSearchUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<RequestedSearchUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type RequestedSearchUpdateManyWithoutSearchTypeNestedInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutSearchTypeInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutSearchTypeInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManySearchTypeInputEnvelope>;
  delete?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<RequestedSearchUpdateWithWhereUniqueWithoutSearchTypeInput>>;
  updateMany?: InputMaybe<Array<RequestedSearchUpdateManyWithWhereWithoutSearchTypeInput>>;
  upsert?: InputMaybe<Array<RequestedSearchUpsertWithWhereUniqueWithoutSearchTypeInput>>;
};

export type RequestedSearchUpdateManyWithoutSsnNestedInput = {
  connect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequestedSearchCreateOrConnectWithoutSsnInput>>;
  create?: InputMaybe<Array<RequestedSearchCreateWithoutSsnInput>>;
  createMany?: InputMaybe<RequestedSearchCreateManySsnInputEnvelope>;
  delete?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RequestedSearchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  set?: InputMaybe<Array<RequestedSearchWhereUniqueInput>>;
  update?: InputMaybe<Array<RequestedSearchUpdateWithWhereUniqueWithoutSsnInput>>;
  updateMany?: InputMaybe<Array<RequestedSearchUpdateManyWithWhereWithoutSsnInput>>;
  upsert?: InputMaybe<Array<RequestedSearchUpsertWithWhereUniqueWithoutSsnInput>>;
};

export type RequestedSearchUpdateOneRequiredWithoutDispatchedSearchesNestedInput = {
  connect?: InputMaybe<RequestedSearchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RequestedSearchCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<RequestedSearchCreateWithoutDispatchedSearchesInput>;
  update?: InputMaybe<RequestedSearchUpdateToOneWithWhereWithoutDispatchedSearchesInput>;
  upsert?: InputMaybe<RequestedSearchUpsertWithoutDispatchedSearchesInput>;
};

export type RequestedSearchUpdateOneWithoutResultsNestedInput = {
  connect?: InputMaybe<RequestedSearchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RequestedSearchCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<RequestedSearchCreateWithoutResultsInput>;
  delete?: InputMaybe<RequestedSearchWhereInput>;
  disconnect?: InputMaybe<RequestedSearchWhereInput>;
  update?: InputMaybe<RequestedSearchUpdateToOneWithWhereWithoutResultsInput>;
  upsert?: InputMaybe<RequestedSearchUpsertWithoutResultsInput>;
};

export type RequestedSearchUpdateToOneWithWhereWithoutDispatchedSearchesInput = {
  data: RequestedSearchUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchUpdateToOneWithWhereWithoutResultsInput = {
  data: RequestedSearchUpdateWithoutResultsInput;
  where?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchUpdateWithWhereUniqueWithoutMonitoringReportInput = {
  data: RequestedSearchUpdateWithoutMonitoringReportInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpdateWithWhereUniqueWithoutOrderInput = {
  data: RequestedSearchUpdateWithoutOrderInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpdateWithWhereUniqueWithoutSearchTypeInput = {
  data: RequestedSearchUpdateWithoutSearchTypeInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpdateWithWhereUniqueWithoutSsnInput = {
  data: RequestedSearchUpdateWithoutSsnInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpdateWithoutDispatchedSearchesInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutRequestedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutRequestedSearchNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpdateWithoutMonitoringReportInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutRequestedSearchNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutRequestedSearchNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpdateWithoutOrderInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutRequestedSearchNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutRequestedSearchesNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutRequestedSearchNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpdateWithoutResultsInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutRequestedSearchNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutRequestedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpdateWithoutSearchTypeInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutRequestedSearchNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutRequestedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutRequestedSearchNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpdateWithoutSsnInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutRequestedSearchNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutRequestedSearchesNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  results?: InputMaybe<ResultUpdateManyWithoutRequestedSearchNestedInput>;
  searchType?: InputMaybe<SearchTypeUpdateOneRequiredWithoutRequestedSearchesNestedInput>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequestedSearchUpsertWithWhereUniqueWithoutMonitoringReportInput = {
  create: RequestedSearchCreateWithoutMonitoringReportInput;
  update: RequestedSearchUpdateWithoutMonitoringReportInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpsertWithWhereUniqueWithoutOrderInput = {
  create: RequestedSearchCreateWithoutOrderInput;
  update: RequestedSearchUpdateWithoutOrderInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpsertWithWhereUniqueWithoutSearchTypeInput = {
  create: RequestedSearchCreateWithoutSearchTypeInput;
  update: RequestedSearchUpdateWithoutSearchTypeInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpsertWithWhereUniqueWithoutSsnInput = {
  create: RequestedSearchCreateWithoutSsnInput;
  update: RequestedSearchUpdateWithoutSsnInput;
  where: RequestedSearchWhereUniqueInput;
};

export type RequestedSearchUpsertWithoutDispatchedSearchesInput = {
  create: RequestedSearchCreateWithoutDispatchedSearchesInput;
  update: RequestedSearchUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchUpsertWithoutResultsInput = {
  create: RequestedSearchCreateWithoutResultsInput;
  update: RequestedSearchUpdateWithoutResultsInput;
  where?: InputMaybe<RequestedSearchWhereInput>;
};

export type RequestedSearchWhereInput = {
  AND?: InputMaybe<Array<RequestedSearchWhereInput>>;
  NOT?: InputMaybe<Array<RequestedSearchWhereInput>>;
  OR?: InputMaybe<Array<RequestedSearchWhereInput>>;
  blob?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  results?: InputMaybe<ResultListRelationFilter>;
  searchType?: InputMaybe<SearchTypeScalarRelationFilter>;
  searchTypeId?: InputMaybe<StringFilter>;
  ssnId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RequestedSearchWhereUniqueInput = {
  AND?: InputMaybe<Array<RequestedSearchWhereInput>>;
  NOT?: InputMaybe<Array<RequestedSearchWhereInput>>;
  OR?: InputMaybe<Array<RequestedSearchWhereInput>>;
  blob?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  results?: InputMaybe<ResultListRelationFilter>;
  searchType?: InputMaybe<SearchTypeScalarRelationFilter>;
  searchTypeId?: InputMaybe<StringFilter>;
  ssnId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumSearchStatusTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Response = {
  __typename?: 'Response';
  data?: Maybe<Scalars['JSON']['output']>;
};

export type Result = {
  __typename?: 'Result';
  Order?: Maybe<Order>;
  _count?: Maybe<ResultCount>;
  alert?: Maybe<ResultAlertTypeEnum>;
  attachments: Array<File>;
  blob?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  detail: Scalars['String']['output'];
  id: Scalars['String']['output'];
  monitoringReport?: Maybe<MonitoringReport>;
  monitoringReportId?: Maybe<Scalars['String']['output']>;
  normalized?: Maybe<Scalars['JSON']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  requestedSearch?: Maybe<RequestedSearch>;
  requestedSearchId?: Maybe<Scalars['String']['output']>;
  revisions: Array<ResultRevision>;
  searchType?: Maybe<ResultSearchType>;
  sexOffender?: Maybe<Scalars['Boolean']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  status: ResultStatusEnum;
  statusMeta?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  vendor?: Maybe<Vendor>;
  vendorId?: Maybe<Scalars['String']['output']>;
};


export type ResultOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type ResultAttachmentsArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type ResultMonitoringReportArgs = {
  where?: InputMaybe<MonitoringReportWhereInput>;
};


export type ResultRequestedSearchArgs = {
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type ResultRevisionsArgs = {
  cursor?: InputMaybe<ResultRevisionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResultRevisionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResultRevisionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResultRevisionWhereInput>;
};


export type ResultVendorArgs = {
  where?: InputMaybe<VendorWhereInput>;
};

export enum ResultAlertTypeEnum {
  AlertsFound = 'ALERTS_FOUND',
  ComplianceReview = 'COMPLIANCE_REVIEW',
  NoAlertsFound = 'NO_ALERTS_FOUND'
}

export type ResultCount = {
  __typename?: 'ResultCount';
  attachments: Scalars['Int']['output'];
  revisions: Scalars['Int']['output'];
};


export type ResultCountAttachmentsArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type ResultCountRevisionsArgs = {
  where?: InputMaybe<ResultRevisionWhereInput>;
};

export type ResultCreateInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutResultsInput>;
  alert?: InputMaybe<ResultAlertTypeEnum>;
  attachments?: InputMaybe<FileCreateNestedManyWithoutResultInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutResultsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchCreateNestedOneWithoutResultsInput>;
  revisions?: InputMaybe<ResultRevisionCreateNestedManyWithoutResultInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor?: InputMaybe<VendorCreateNestedOneWithoutResultsInput>;
};

export type ResultCreateManyMonitoringReportInput = {
  alert?: InputMaybe<ResultAlertTypeEnum>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  requestedSearchId?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type ResultCreateManyMonitoringReportInputEnvelope = {
  data: Array<ResultCreateManyMonitoringReportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResultCreateManyOrderInput = {
  alert?: InputMaybe<ResultAlertTypeEnum>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearchId?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type ResultCreateManyOrderInputEnvelope = {
  data: Array<ResultCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResultCreateManyRequestedSearchInput = {
  alert?: InputMaybe<ResultAlertTypeEnum>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type ResultCreateManyRequestedSearchInputEnvelope = {
  data: Array<ResultCreateManyRequestedSearchInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResultCreateManyVendorInput = {
  alert?: InputMaybe<ResultAlertTypeEnum>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReportId?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  requestedSearchId?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultCreateManyVendorInputEnvelope = {
  data: Array<ResultCreateManyVendorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResultCreateNestedManyWithoutMonitoringReportInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<ResultCreateManyMonitoringReportInputEnvelope>;
};

export type ResultCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ResultCreateManyOrderInputEnvelope>;
};

export type ResultCreateNestedManyWithoutRequestedSearchInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutRequestedSearchInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutRequestedSearchInput>>;
  createMany?: InputMaybe<ResultCreateManyRequestedSearchInputEnvelope>;
};

export type ResultCreateNestedManyWithoutVendorInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutVendorInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutVendorInput>>;
  createMany?: InputMaybe<ResultCreateManyVendorInputEnvelope>;
};

export type ResultCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<ResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResultCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<ResultCreateWithoutAttachmentsInput>;
};

export type ResultCreateNestedOneWithoutRevisionsInput = {
  connect?: InputMaybe<ResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResultCreateOrConnectWithoutRevisionsInput>;
  create?: InputMaybe<ResultCreateWithoutRevisionsInput>;
};

export type ResultCreateOrConnectWithoutAttachmentsInput = {
  create: ResultCreateWithoutAttachmentsInput;
  where: ResultWhereUniqueInput;
};

export type ResultCreateOrConnectWithoutMonitoringReportInput = {
  create: ResultCreateWithoutMonitoringReportInput;
  where: ResultWhereUniqueInput;
};

export type ResultCreateOrConnectWithoutOrderInput = {
  create: ResultCreateWithoutOrderInput;
  where: ResultWhereUniqueInput;
};

export type ResultCreateOrConnectWithoutRequestedSearchInput = {
  create: ResultCreateWithoutRequestedSearchInput;
  where: ResultWhereUniqueInput;
};

export type ResultCreateOrConnectWithoutRevisionsInput = {
  create: ResultCreateWithoutRevisionsInput;
  where: ResultWhereUniqueInput;
};

export type ResultCreateOrConnectWithoutVendorInput = {
  create: ResultCreateWithoutVendorInput;
  where: ResultWhereUniqueInput;
};

export type ResultCreateWithoutAttachmentsInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutResultsInput>;
  alert?: InputMaybe<ResultAlertTypeEnum>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutResultsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchCreateNestedOneWithoutResultsInput>;
  revisions?: InputMaybe<ResultRevisionCreateNestedManyWithoutResultInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor?: InputMaybe<VendorCreateNestedOneWithoutResultsInput>;
};

export type ResultCreateWithoutMonitoringReportInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutResultsInput>;
  alert?: InputMaybe<ResultAlertTypeEnum>;
  attachments?: InputMaybe<FileCreateNestedManyWithoutResultInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchCreateNestedOneWithoutResultsInput>;
  revisions?: InputMaybe<ResultRevisionCreateNestedManyWithoutResultInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor?: InputMaybe<VendorCreateNestedOneWithoutResultsInput>;
};

export type ResultCreateWithoutOrderInput = {
  alert?: InputMaybe<ResultAlertTypeEnum>;
  attachments?: InputMaybe<FileCreateNestedManyWithoutResultInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutResultsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchCreateNestedOneWithoutResultsInput>;
  revisions?: InputMaybe<ResultRevisionCreateNestedManyWithoutResultInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor?: InputMaybe<VendorCreateNestedOneWithoutResultsInput>;
};

export type ResultCreateWithoutRequestedSearchInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutResultsInput>;
  alert?: InputMaybe<ResultAlertTypeEnum>;
  attachments?: InputMaybe<FileCreateNestedManyWithoutResultInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutResultsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  revisions?: InputMaybe<ResultRevisionCreateNestedManyWithoutResultInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor?: InputMaybe<VendorCreateNestedOneWithoutResultsInput>;
};

export type ResultCreateWithoutRevisionsInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutResultsInput>;
  alert?: InputMaybe<ResultAlertTypeEnum>;
  attachments?: InputMaybe<FileCreateNestedManyWithoutResultInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutResultsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchCreateNestedOneWithoutResultsInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor?: InputMaybe<VendorCreateNestedOneWithoutResultsInput>;
};

export type ResultCreateWithoutVendorInput = {
  Order?: InputMaybe<OrderCreateNestedOneWithoutResultsInput>;
  alert?: InputMaybe<ResultAlertTypeEnum>;
  attachments?: InputMaybe<FileCreateNestedManyWithoutResultInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportCreateNestedOneWithoutResultsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchCreateNestedOneWithoutResultsInput>;
  revisions?: InputMaybe<ResultRevisionCreateNestedManyWithoutResultInput>;
  searchType?: InputMaybe<ResultSearchType>;
  sexOffender?: InputMaybe<Scalars['Boolean']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResultStatusEnum>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultListRelationFilter = {
  every?: InputMaybe<ResultWhereInput>;
  none?: InputMaybe<ResultWhereInput>;
  some?: InputMaybe<ResultWhereInput>;
};

export type ResultNullableScalarRelationFilter = {
  is?: InputMaybe<ResultWhereInput>;
  isNot?: InputMaybe<ResultWhereInput>;
};

export type ResultOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResultOrderByWithRelationInput = {
  Order?: InputMaybe<OrderOrderByWithRelationInput>;
  alert?: InputMaybe<SortOrderInput>;
  attachments?: InputMaybe<FileOrderByRelationAggregateInput>;
  blob?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  detail?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  monitoringReport?: InputMaybe<MonitoringReportOrderByWithRelationInput>;
  monitoringReportId?: InputMaybe<SortOrderInput>;
  normalized?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrderInput>;
  requestedSearch?: InputMaybe<RequestedSearchOrderByWithRelationInput>;
  requestedSearchId?: InputMaybe<SortOrderInput>;
  revisions?: InputMaybe<ResultRevisionOrderByRelationAggregateInput>;
  searchType?: InputMaybe<SortOrderInput>;
  sexOffender?: InputMaybe<SortOrderInput>;
  ssn?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  statusMeta?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<VendorOrderByWithRelationInput>;
  vendorId?: InputMaybe<SortOrderInput>;
};

export type ResultRevision = {
  __typename?: 'ResultRevision';
  Result?: Maybe<Result>;
  blob?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  resultId?: Maybe<Scalars['String']['output']>;
  revisedById: User;
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};


export type ResultRevisionResultArgs = {
  where?: InputMaybe<ResultWhereInput>;
};

export type ResultRevisionCreateInput = {
  Result?: InputMaybe<ResultCreateNestedOneWithoutRevisionsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  revisedById: UserCreateNestedOneWithoutResultRevisionInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultRevisionCreateManyResultInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type ResultRevisionCreateManyResultInputEnvelope = {
  data: Array<ResultRevisionCreateManyResultInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResultRevisionCreateManyRevisedByIdInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultRevisionCreateManyRevisedByIdInputEnvelope = {
  data: Array<ResultRevisionCreateManyRevisedByIdInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResultRevisionCreateNestedManyWithoutResultInput = {
  connect?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultRevisionCreateOrConnectWithoutResultInput>>;
  create?: InputMaybe<Array<ResultRevisionCreateWithoutResultInput>>;
  createMany?: InputMaybe<ResultRevisionCreateManyResultInputEnvelope>;
};

export type ResultRevisionCreateNestedManyWithoutRevisedByIdInput = {
  connect?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultRevisionCreateOrConnectWithoutRevisedByIdInput>>;
  create?: InputMaybe<Array<ResultRevisionCreateWithoutRevisedByIdInput>>;
  createMany?: InputMaybe<ResultRevisionCreateManyRevisedByIdInputEnvelope>;
};

export type ResultRevisionCreateOrConnectWithoutResultInput = {
  create: ResultRevisionCreateWithoutResultInput;
  where: ResultRevisionWhereUniqueInput;
};

export type ResultRevisionCreateOrConnectWithoutRevisedByIdInput = {
  create: ResultRevisionCreateWithoutRevisedByIdInput;
  where: ResultRevisionWhereUniqueInput;
};

export type ResultRevisionCreateWithoutResultInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  revisedById: UserCreateNestedOneWithoutResultRevisionInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultRevisionCreateWithoutRevisedByIdInput = {
  Result?: InputMaybe<ResultCreateNestedOneWithoutRevisionsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultRevisionListRelationFilter = {
  every?: InputMaybe<ResultRevisionWhereInput>;
  none?: InputMaybe<ResultRevisionWhereInput>;
  some?: InputMaybe<ResultRevisionWhereInput>;
};

export type ResultRevisionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResultRevisionOrderByWithRelationInput = {
  Result?: InputMaybe<ResultOrderByWithRelationInput>;
  blob?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resultId?: InputMaybe<SortOrderInput>;
  revisedById?: InputMaybe<UserOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum ResultRevisionScalarFieldEnum {
  Blob = 'blob',
  CreatedAt = 'createdAt',
  Id = 'id',
  ResultId = 'resultId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ResultRevisionScalarWhereInput = {
  AND?: InputMaybe<Array<ResultRevisionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ResultRevisionScalarWhereInput>>;
  OR?: InputMaybe<Array<ResultRevisionScalarWhereInput>>;
  blob?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  resultId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ResultRevisionUpdateManyMutationInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultRevisionUpdateManyWithWhereWithoutResultInput = {
  data: ResultRevisionUpdateManyMutationInput;
  where: ResultRevisionScalarWhereInput;
};

export type ResultRevisionUpdateManyWithWhereWithoutRevisedByIdInput = {
  data: ResultRevisionUpdateManyMutationInput;
  where: ResultRevisionScalarWhereInput;
};

export type ResultRevisionUpdateManyWithoutResultNestedInput = {
  connect?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultRevisionCreateOrConnectWithoutResultInput>>;
  create?: InputMaybe<Array<ResultRevisionCreateWithoutResultInput>>;
  createMany?: InputMaybe<ResultRevisionCreateManyResultInputEnvelope>;
  delete?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultRevisionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultRevisionUpdateWithWhereUniqueWithoutResultInput>>;
  updateMany?: InputMaybe<Array<ResultRevisionUpdateManyWithWhereWithoutResultInput>>;
  upsert?: InputMaybe<Array<ResultRevisionUpsertWithWhereUniqueWithoutResultInput>>;
};

export type ResultRevisionUpdateManyWithoutRevisedByIdNestedInput = {
  connect?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultRevisionCreateOrConnectWithoutRevisedByIdInput>>;
  create?: InputMaybe<Array<ResultRevisionCreateWithoutRevisedByIdInput>>;
  createMany?: InputMaybe<ResultRevisionCreateManyRevisedByIdInputEnvelope>;
  delete?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultRevisionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultRevisionWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultRevisionUpdateWithWhereUniqueWithoutRevisedByIdInput>>;
  updateMany?: InputMaybe<Array<ResultRevisionUpdateManyWithWhereWithoutRevisedByIdInput>>;
  upsert?: InputMaybe<Array<ResultRevisionUpsertWithWhereUniqueWithoutRevisedByIdInput>>;
};

export type ResultRevisionUpdateWithWhereUniqueWithoutResultInput = {
  data: ResultRevisionUpdateWithoutResultInput;
  where: ResultRevisionWhereUniqueInput;
};

export type ResultRevisionUpdateWithWhereUniqueWithoutRevisedByIdInput = {
  data: ResultRevisionUpdateWithoutRevisedByIdInput;
  where: ResultRevisionWhereUniqueInput;
};

export type ResultRevisionUpdateWithoutResultInput = {
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  revisedById?: InputMaybe<UserUpdateOneRequiredWithoutResultRevisionNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultRevisionUpdateWithoutRevisedByIdInput = {
  Result?: InputMaybe<ResultUpdateOneWithoutRevisionsNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultRevisionUpsertWithWhereUniqueWithoutResultInput = {
  create: ResultRevisionCreateWithoutResultInput;
  update: ResultRevisionUpdateWithoutResultInput;
  where: ResultRevisionWhereUniqueInput;
};

export type ResultRevisionUpsertWithWhereUniqueWithoutRevisedByIdInput = {
  create: ResultRevisionCreateWithoutRevisedByIdInput;
  update: ResultRevisionUpdateWithoutRevisedByIdInput;
  where: ResultRevisionWhereUniqueInput;
};

export type ResultRevisionWhereInput = {
  AND?: InputMaybe<Array<ResultRevisionWhereInput>>;
  NOT?: InputMaybe<Array<ResultRevisionWhereInput>>;
  OR?: InputMaybe<Array<ResultRevisionWhereInput>>;
  Result?: InputMaybe<ResultNullableScalarRelationFilter>;
  blob?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  resultId?: InputMaybe<StringNullableFilter>;
  revisedById?: InputMaybe<UserScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ResultRevisionWhereUniqueInput = {
  AND?: InputMaybe<Array<ResultRevisionWhereInput>>;
  NOT?: InputMaybe<Array<ResultRevisionWhereInput>>;
  OR?: InputMaybe<Array<ResultRevisionWhereInput>>;
  Result?: InputMaybe<ResultNullableScalarRelationFilter>;
  blob?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultId?: InputMaybe<StringNullableFilter>;
  revisedById?: InputMaybe<UserScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum ResultScalarFieldEnum {
  Alert = 'alert',
  Blob = 'blob',
  CreatedAt = 'createdAt',
  Detail = 'detail',
  Id = 'id',
  MonitoringReportId = 'monitoringReportId',
  Normalized = 'normalized',
  OrderId = 'orderId',
  RequestedSearchId = 'requestedSearchId',
  SearchType = 'searchType',
  SexOffender = 'sexOffender',
  Ssn = 'ssn',
  Status = 'status',
  StatusMeta = 'statusMeta',
  UpdatedAt = 'updatedAt',
  VendorId = 'vendorId'
}

export type ResultScalarWhereInput = {
  AND?: InputMaybe<Array<ResultScalarWhereInput>>;
  NOT?: InputMaybe<Array<ResultScalarWhereInput>>;
  OR?: InputMaybe<Array<ResultScalarWhereInput>>;
  alert?: InputMaybe<EnumResultAlertTypeEnumNullableFilter>;
  blob?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  detail?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  normalized?: InputMaybe<JsonNullableFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  requestedSearchId?: InputMaybe<StringNullableFilter>;
  searchType?: InputMaybe<EnumResultSearchTypeNullableFilter>;
  sexOffender?: InputMaybe<BoolNullableFilter>;
  ssn?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumResultStatusEnumFilter>;
  statusMeta?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorId?: InputMaybe<StringNullableFilter>;
};

export enum ResultSearchType {
  Aamva = 'aamva',
  County = 'county',
  IdentityRecheck = 'identity_recheck',
  Natcrim = 'natcrim',
  NatcrimAlias = 'natcrim_alias',
  Sanctions = 'sanctions',
  Sexoffender = 'sexoffender',
  SsnAlert = 'ssn_alert',
  SsnAlias = 'ssn_alias',
  SsnValidation = 'ssn_validation',
  StandardIdVerification = 'standard_id_verification',
  Tazworks = 'tazworks',
  Youth = 'youth'
}

export enum ResultStatusEnum {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING'
}

export type ResultTypeCreateNestedManyWithoutSearchTypesInput = {
  connect?: InputMaybe<Array<ResultTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultTypeCreateOrConnectWithoutSearchTypesInput>>;
  create?: InputMaybe<Array<ResultTypeCreateWithoutSearchTypesInput>>;
};

export type ResultTypeCreateOrConnectWithoutSearchTypesInput = {
  create: ResultTypeCreateWithoutSearchTypesInput;
  where: ResultTypeWhereUniqueInput;
};

export type ResultTypeCreateWithoutSearchTypesInput = {
  cra?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataStructure: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ResultTypeListRelationFilter = {
  every?: InputMaybe<ResultTypeWhereInput>;
  none?: InputMaybe<ResultTypeWhereInput>;
  some?: InputMaybe<ResultTypeWhereInput>;
};

export type ResultTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResultTypeScalarWhereInput = {
  AND?: InputMaybe<Array<ResultTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ResultTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<ResultTypeScalarWhereInput>>;
  cra?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataStructure?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ResultTypeUpdateManyMutationInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultTypeUpdateManyWithWhereWithoutSearchTypesInput = {
  data: ResultTypeUpdateManyMutationInput;
  where: ResultTypeScalarWhereInput;
};

export type ResultTypeUpdateManyWithoutSearchTypesNestedInput = {
  connect?: InputMaybe<Array<ResultTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultTypeCreateOrConnectWithoutSearchTypesInput>>;
  create?: InputMaybe<Array<ResultTypeCreateWithoutSearchTypesInput>>;
  delete?: InputMaybe<Array<ResultTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultTypeUpdateWithWhereUniqueWithoutSearchTypesInput>>;
  updateMany?: InputMaybe<Array<ResultTypeUpdateManyWithWhereWithoutSearchTypesInput>>;
  upsert?: InputMaybe<Array<ResultTypeUpsertWithWhereUniqueWithoutSearchTypesInput>>;
};

export type ResultTypeUpdateWithWhereUniqueWithoutSearchTypesInput = {
  data: ResultTypeUpdateWithoutSearchTypesInput;
  where: ResultTypeWhereUniqueInput;
};

export type ResultTypeUpdateWithoutSearchTypesInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultTypeUpsertWithWhereUniqueWithoutSearchTypesInput = {
  create: ResultTypeCreateWithoutSearchTypesInput;
  update: ResultTypeUpdateWithoutSearchTypesInput;
  where: ResultTypeWhereUniqueInput;
};

export type ResultTypeWhereInput = {
  AND?: InputMaybe<Array<ResultTypeWhereInput>>;
  NOT?: InputMaybe<Array<ResultTypeWhereInput>>;
  OR?: InputMaybe<Array<ResultTypeWhereInput>>;
  cra?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataStructure?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  searchTypes?: InputMaybe<SearchTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ResultTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<ResultTypeWhereInput>>;
  NOT?: InputMaybe<Array<ResultTypeWhereInput>>;
  OR?: InputMaybe<Array<ResultTypeWhereInput>>;
  cra?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataStructure?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  searchTypes?: InputMaybe<SearchTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ResultUpdateInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutResultsNestedInput>;
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  attachments?: InputMaybe<FileUpdateManyWithoutResultNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutResultsNestedInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneWithoutResultsNestedInput>;
  revisions?: InputMaybe<ResultRevisionUpdateManyWithoutResultNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneWithoutResultsNestedInput>;
};

export type ResultUpdateManyMutationInput = {
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultUpdateManyWithWhereWithoutMonitoringReportInput = {
  data: ResultUpdateManyMutationInput;
  where: ResultScalarWhereInput;
};

export type ResultUpdateManyWithWhereWithoutOrderInput = {
  data: ResultUpdateManyMutationInput;
  where: ResultScalarWhereInput;
};

export type ResultUpdateManyWithWhereWithoutRequestedSearchInput = {
  data: ResultUpdateManyMutationInput;
  where: ResultScalarWhereInput;
};

export type ResultUpdateManyWithWhereWithoutVendorInput = {
  data: ResultUpdateManyMutationInput;
  where: ResultScalarWhereInput;
};

export type ResultUpdateManyWithoutMonitoringReportNestedInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutMonitoringReportInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutMonitoringReportInput>>;
  createMany?: InputMaybe<ResultCreateManyMonitoringReportInputEnvelope>;
  delete?: InputMaybe<Array<ResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultUpdateWithWhereUniqueWithoutMonitoringReportInput>>;
  updateMany?: InputMaybe<Array<ResultUpdateManyWithWhereWithoutMonitoringReportInput>>;
  upsert?: InputMaybe<Array<ResultUpsertWithWhereUniqueWithoutMonitoringReportInput>>;
};

export type ResultUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ResultCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ResultUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ResultUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ResultUpdateManyWithoutRequestedSearchNestedInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutRequestedSearchInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutRequestedSearchInput>>;
  createMany?: InputMaybe<ResultCreateManyRequestedSearchInputEnvelope>;
  delete?: InputMaybe<Array<ResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultUpdateWithWhereUniqueWithoutRequestedSearchInput>>;
  updateMany?: InputMaybe<Array<ResultUpdateManyWithWhereWithoutRequestedSearchInput>>;
  upsert?: InputMaybe<Array<ResultUpsertWithWhereUniqueWithoutRequestedSearchInput>>;
};

export type ResultUpdateManyWithoutVendorNestedInput = {
  connect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResultCreateOrConnectWithoutVendorInput>>;
  create?: InputMaybe<Array<ResultCreateWithoutVendorInput>>;
  createMany?: InputMaybe<ResultCreateManyVendorInputEnvelope>;
  delete?: InputMaybe<Array<ResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResultWhereUniqueInput>>;
  set?: InputMaybe<Array<ResultWhereUniqueInput>>;
  update?: InputMaybe<Array<ResultUpdateWithWhereUniqueWithoutVendorInput>>;
  updateMany?: InputMaybe<Array<ResultUpdateManyWithWhereWithoutVendorInput>>;
  upsert?: InputMaybe<Array<ResultUpsertWithWhereUniqueWithoutVendorInput>>;
};

export type ResultUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<ResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResultCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<ResultCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<ResultWhereInput>;
  disconnect?: InputMaybe<ResultWhereInput>;
  update?: InputMaybe<ResultUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<ResultUpsertWithoutAttachmentsInput>;
};

export type ResultUpdateOneWithoutRevisionsNestedInput = {
  connect?: InputMaybe<ResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResultCreateOrConnectWithoutRevisionsInput>;
  create?: InputMaybe<ResultCreateWithoutRevisionsInput>;
  delete?: InputMaybe<ResultWhereInput>;
  disconnect?: InputMaybe<ResultWhereInput>;
  update?: InputMaybe<ResultUpdateToOneWithWhereWithoutRevisionsInput>;
  upsert?: InputMaybe<ResultUpsertWithoutRevisionsInput>;
};

export type ResultUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: ResultUpdateWithoutAttachmentsInput;
  where?: InputMaybe<ResultWhereInput>;
};

export type ResultUpdateToOneWithWhereWithoutRevisionsInput = {
  data: ResultUpdateWithoutRevisionsInput;
  where?: InputMaybe<ResultWhereInput>;
};

export type ResultUpdateWithWhereUniqueWithoutMonitoringReportInput = {
  data: ResultUpdateWithoutMonitoringReportInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpdateWithWhereUniqueWithoutOrderInput = {
  data: ResultUpdateWithoutOrderInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpdateWithWhereUniqueWithoutRequestedSearchInput = {
  data: ResultUpdateWithoutRequestedSearchInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpdateWithWhereUniqueWithoutVendorInput = {
  data: ResultUpdateWithoutVendorInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpdateWithoutAttachmentsInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutResultsNestedInput>;
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutResultsNestedInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneWithoutResultsNestedInput>;
  revisions?: InputMaybe<ResultRevisionUpdateManyWithoutResultNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneWithoutResultsNestedInput>;
};

export type ResultUpdateWithoutMonitoringReportInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutResultsNestedInput>;
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  attachments?: InputMaybe<FileUpdateManyWithoutResultNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneWithoutResultsNestedInput>;
  revisions?: InputMaybe<ResultRevisionUpdateManyWithoutResultNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneWithoutResultsNestedInput>;
};

export type ResultUpdateWithoutOrderInput = {
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  attachments?: InputMaybe<FileUpdateManyWithoutResultNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutResultsNestedInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneWithoutResultsNestedInput>;
  revisions?: InputMaybe<ResultRevisionUpdateManyWithoutResultNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneWithoutResultsNestedInput>;
};

export type ResultUpdateWithoutRequestedSearchInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutResultsNestedInput>;
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  attachments?: InputMaybe<FileUpdateManyWithoutResultNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutResultsNestedInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  revisions?: InputMaybe<ResultRevisionUpdateManyWithoutResultNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneWithoutResultsNestedInput>;
};

export type ResultUpdateWithoutRevisionsInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutResultsNestedInput>;
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  attachments?: InputMaybe<FileUpdateManyWithoutResultNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutResultsNestedInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneWithoutResultsNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneWithoutResultsNestedInput>;
};

export type ResultUpdateWithoutVendorInput = {
  Order?: InputMaybe<OrderUpdateOneWithoutResultsNestedInput>;
  alert?: InputMaybe<NullableEnumResultAlertTypeEnumFieldUpdateOperationsInput>;
  attachments?: InputMaybe<FileUpdateManyWithoutResultNestedInput>;
  blob?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  detail?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  monitoringReport?: InputMaybe<MonitoringReportUpdateOneWithoutResultsNestedInput>;
  normalized?: InputMaybe<Scalars['JSON']['input']>;
  requestedSearch?: InputMaybe<RequestedSearchUpdateOneWithoutResultsNestedInput>;
  revisions?: InputMaybe<ResultRevisionUpdateManyWithoutResultNestedInput>;
  searchType?: InputMaybe<NullableEnumResultSearchTypeFieldUpdateOperationsInput>;
  sexOffender?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ssn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumResultStatusEnumFieldUpdateOperationsInput>;
  statusMeta?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultUpsertWithWhereUniqueWithoutMonitoringReportInput = {
  create: ResultCreateWithoutMonitoringReportInput;
  update: ResultUpdateWithoutMonitoringReportInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpsertWithWhereUniqueWithoutOrderInput = {
  create: ResultCreateWithoutOrderInput;
  update: ResultUpdateWithoutOrderInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpsertWithWhereUniqueWithoutRequestedSearchInput = {
  create: ResultCreateWithoutRequestedSearchInput;
  update: ResultUpdateWithoutRequestedSearchInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpsertWithWhereUniqueWithoutVendorInput = {
  create: ResultCreateWithoutVendorInput;
  update: ResultUpdateWithoutVendorInput;
  where: ResultWhereUniqueInput;
};

export type ResultUpsertWithoutAttachmentsInput = {
  create: ResultCreateWithoutAttachmentsInput;
  update: ResultUpdateWithoutAttachmentsInput;
  where?: InputMaybe<ResultWhereInput>;
};

export type ResultUpsertWithoutRevisionsInput = {
  create: ResultCreateWithoutRevisionsInput;
  update: ResultUpdateWithoutRevisionsInput;
  where?: InputMaybe<ResultWhereInput>;
};

export type ResultWhereInput = {
  AND?: InputMaybe<Array<ResultWhereInput>>;
  NOT?: InputMaybe<Array<ResultWhereInput>>;
  OR?: InputMaybe<Array<ResultWhereInput>>;
  Order?: InputMaybe<OrderNullableScalarRelationFilter>;
  alert?: InputMaybe<EnumResultAlertTypeEnumNullableFilter>;
  attachments?: InputMaybe<FileListRelationFilter>;
  blob?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  detail?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  normalized?: InputMaybe<JsonNullableFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  requestedSearch?: InputMaybe<RequestedSearchNullableScalarRelationFilter>;
  requestedSearchId?: InputMaybe<StringNullableFilter>;
  revisions?: InputMaybe<ResultRevisionListRelationFilter>;
  searchType?: InputMaybe<EnumResultSearchTypeNullableFilter>;
  sexOffender?: InputMaybe<BoolNullableFilter>;
  ssn?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumResultStatusEnumFilter>;
  statusMeta?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendor?: InputMaybe<VendorNullableScalarRelationFilter>;
  vendorId?: InputMaybe<StringNullableFilter>;
};

export type ResultWhereUniqueInput = {
  AND?: InputMaybe<Array<ResultWhereInput>>;
  NOT?: InputMaybe<Array<ResultWhereInput>>;
  OR?: InputMaybe<Array<ResultWhereInput>>;
  Order?: InputMaybe<OrderNullableScalarRelationFilter>;
  alert?: InputMaybe<EnumResultAlertTypeEnumNullableFilter>;
  attachments?: InputMaybe<FileListRelationFilter>;
  blob?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  detail?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  monitoringReport?: InputMaybe<MonitoringReportNullableScalarRelationFilter>;
  monitoringReportId?: InputMaybe<StringNullableFilter>;
  normalized?: InputMaybe<JsonNullableFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  requestedSearch?: InputMaybe<RequestedSearchNullableScalarRelationFilter>;
  requestedSearchId?: InputMaybe<StringNullableFilter>;
  revisions?: InputMaybe<ResultRevisionListRelationFilter>;
  searchType?: InputMaybe<EnumResultSearchTypeNullableFilter>;
  sexOffender?: InputMaybe<BoolNullableFilter>;
  ssn?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumResultStatusEnumFilter>;
  statusMeta?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendor?: InputMaybe<VendorNullableScalarRelationFilter>;
  vendorId?: InputMaybe<StringNullableFilter>;
};

export type RoleAssignment = {
  __typename?: 'RoleAssignment';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  roleV2: RoleV2;
  roleV2Id: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};


export type RoleAssignmentOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type RoleAssignmentProductArgs = {
  where?: InputMaybe<ProductWhereInput>;
};

export type RoleAssignmentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutRoleAssignmentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutRoleAssignmentInput>;
  roleV2: RoleV2CreateNestedOneWithoutRoleAssignmentsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutRoleAssignmentInput;
};

export type RoleAssignmentCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  roleV2Id: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type RoleAssignmentCreateManyOrganizationInputEnvelope = {
  data: Array<RoleAssignmentCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleAssignmentCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  roleV2Id: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RoleAssignmentCreateManyUserInputEnvelope = {
  data: Array<RoleAssignmentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleAssignmentCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoleAssignmentCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<RoleAssignmentCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<RoleAssignmentCreateManyOrganizationInputEnvelope>;
};

export type RoleAssignmentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoleAssignmentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<RoleAssignmentCreateWithoutUserInput>>;
  createMany?: InputMaybe<RoleAssignmentCreateManyUserInputEnvelope>;
};

export type RoleAssignmentCreateOrConnectWithoutOrganizationInput = {
  create: RoleAssignmentCreateWithoutOrganizationInput;
  where: RoleAssignmentWhereUniqueInput;
};

export type RoleAssignmentCreateOrConnectWithoutUserInput = {
  create: RoleAssignmentCreateWithoutUserInput;
  where: RoleAssignmentWhereUniqueInput;
};

export type RoleAssignmentCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutRoleAssignmentInput>;
  roleV2: RoleV2CreateNestedOneWithoutRoleAssignmentsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutRoleAssignmentInput;
};

export type RoleAssignmentCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutRoleAssignmentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutRoleAssignmentInput>;
  roleV2: RoleV2CreateNestedOneWithoutRoleAssignmentsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RoleAssignmentListRelationFilter = {
  every?: InputMaybe<RoleAssignmentWhereInput>;
  none?: InputMaybe<RoleAssignmentWhereInput>;
  some?: InputMaybe<RoleAssignmentWhereInput>;
};

export type RoleAssignmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RoleAssignmentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrderInput>;
  roleV2?: InputMaybe<RoleV2OrderByWithRelationInput>;
  roleV2Id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum RoleAssignmentScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  ProductId = 'productId',
  RoleV2Id = 'roleV2Id',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type RoleAssignmentScalarWhereInput = {
  AND?: InputMaybe<Array<RoleAssignmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<RoleAssignmentScalarWhereInput>>;
  OR?: InputMaybe<Array<RoleAssignmentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  roleV2Id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type RoleAssignmentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RoleAssignmentUpdateManyWithWhereWithoutOrganizationInput = {
  data: RoleAssignmentUpdateManyMutationInput;
  where: RoleAssignmentScalarWhereInput;
};

export type RoleAssignmentUpdateManyWithWhereWithoutUserInput = {
  data: RoleAssignmentUpdateManyMutationInput;
  where: RoleAssignmentScalarWhereInput;
};

export type RoleAssignmentUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoleAssignmentCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<RoleAssignmentCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<RoleAssignmentCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RoleAssignmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  set?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  update?: InputMaybe<Array<RoleAssignmentUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<RoleAssignmentUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<RoleAssignmentUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type RoleAssignmentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoleAssignmentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<RoleAssignmentCreateWithoutUserInput>>;
  createMany?: InputMaybe<RoleAssignmentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RoleAssignmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  set?: InputMaybe<Array<RoleAssignmentWhereUniqueInput>>;
  update?: InputMaybe<Array<RoleAssignmentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<RoleAssignmentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<RoleAssignmentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type RoleAssignmentUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: RoleAssignmentUpdateWithoutOrganizationInput;
  where: RoleAssignmentWhereUniqueInput;
};

export type RoleAssignmentUpdateWithWhereUniqueWithoutUserInput = {
  data: RoleAssignmentUpdateWithoutUserInput;
  where: RoleAssignmentWhereUniqueInput;
};

export type RoleAssignmentUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutRoleAssignmentNestedInput>;
  roleV2?: InputMaybe<RoleV2UpdateOneRequiredWithoutRoleAssignmentsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutRoleAssignmentNestedInput>;
};

export type RoleAssignmentUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutRoleAssignmentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutRoleAssignmentNestedInput>;
  roleV2?: InputMaybe<RoleV2UpdateOneRequiredWithoutRoleAssignmentsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RoleAssignmentUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: RoleAssignmentCreateWithoutOrganizationInput;
  update: RoleAssignmentUpdateWithoutOrganizationInput;
  where: RoleAssignmentWhereUniqueInput;
};

export type RoleAssignmentUpsertWithWhereUniqueWithoutUserInput = {
  create: RoleAssignmentCreateWithoutUserInput;
  update: RoleAssignmentUpdateWithoutUserInput;
  where: RoleAssignmentWhereUniqueInput;
};

export type RoleAssignmentWhereInput = {
  AND?: InputMaybe<Array<RoleAssignmentWhereInput>>;
  NOT?: InputMaybe<Array<RoleAssignmentWhereInput>>;
  OR?: InputMaybe<Array<RoleAssignmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductNullableScalarRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  roleV2?: InputMaybe<RoleV2ScalarRelationFilter>;
  roleV2Id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type RoleAssignmentWhereUniqueInput = {
  AND?: InputMaybe<Array<RoleAssignmentWhereInput>>;
  NOT?: InputMaybe<Array<RoleAssignmentWhereInput>>;
  OR?: InputMaybe<Array<RoleAssignmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductNullableScalarRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  roleV2?: InputMaybe<RoleV2ScalarRelationFilter>;
  roleV2Id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export enum RoleEnum {
  CerebrumTeam = 'CEREBRUM_TEAM',
  CraAdmin = 'CRA_ADMIN',
  IntegrationAdmin = 'INTEGRATION_ADMIN',
  LimitedProcessor = 'LIMITED_PROCESSOR',
  OrganizationAdmin = 'ORGANIZATION_ADMIN',
  Processor = 'PROCESSOR',
  SuperAdmin = 'SUPER_ADMIN',
  TazIntegration = 'TAZ_INTEGRATION',
  User = 'USER'
}

export type RoleV2 = {
  __typename?: 'RoleV2';
  _count?: Maybe<RoleV2Count>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type RoleV2Count = {
  __typename?: 'RoleV2Count';
  roleAssignments: Scalars['Int']['output'];
};


export type RoleV2CountRoleAssignmentsArgs = {
  where?: InputMaybe<RoleAssignmentWhereInput>;
};

export type RoleV2CreateNestedOneWithoutRoleAssignmentsInput = {
  connect?: InputMaybe<RoleV2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleV2CreateOrConnectWithoutRoleAssignmentsInput>;
  create?: InputMaybe<RoleV2CreateWithoutRoleAssignmentsInput>;
};

export type RoleV2CreateOrConnectWithoutRoleAssignmentsInput = {
  create: RoleV2CreateWithoutRoleAssignmentsInput;
  where: RoleV2WhereUniqueInput;
};

export type RoleV2CreateWithoutRoleAssignmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type RoleV2OrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  roleAssignments?: InputMaybe<RoleAssignmentOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum RoleV2ScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type RoleV2ScalarRelationFilter = {
  is?: InputMaybe<RoleV2WhereInput>;
  isNot?: InputMaybe<RoleV2WhereInput>;
};

export type RoleV2UpdateOneRequiredWithoutRoleAssignmentsNestedInput = {
  connect?: InputMaybe<RoleV2WhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleV2CreateOrConnectWithoutRoleAssignmentsInput>;
  create?: InputMaybe<RoleV2CreateWithoutRoleAssignmentsInput>;
  update?: InputMaybe<RoleV2UpdateToOneWithWhereWithoutRoleAssignmentsInput>;
  upsert?: InputMaybe<RoleV2UpsertWithoutRoleAssignmentsInput>;
};

export type RoleV2UpdateToOneWithWhereWithoutRoleAssignmentsInput = {
  data: RoleV2UpdateWithoutRoleAssignmentsInput;
  where?: InputMaybe<RoleV2WhereInput>;
};

export type RoleV2UpdateWithoutRoleAssignmentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RoleV2UpsertWithoutRoleAssignmentsInput = {
  create: RoleV2CreateWithoutRoleAssignmentsInput;
  update: RoleV2UpdateWithoutRoleAssignmentsInput;
  where?: InputMaybe<RoleV2WhereInput>;
};

export type RoleV2WhereInput = {
  AND?: InputMaybe<Array<RoleV2WhereInput>>;
  NOT?: InputMaybe<Array<RoleV2WhereInput>>;
  OR?: InputMaybe<Array<RoleV2WhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  roleAssignments?: InputMaybe<RoleAssignmentListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RoleV2WhereUniqueInput = {
  AND?: InputMaybe<Array<RoleV2WhereInput>>;
  NOT?: InputMaybe<Array<RoleV2WhereInput>>;
  OR?: InputMaybe<Array<RoleV2WhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleAssignments?: InputMaybe<RoleAssignmentListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum SearchStatusTypeEnum {
  Deferred = 'DEFERRED',
  Dispatched = 'DISPATCHED',
  Error = 'ERROR',
  Returned = 'RETURNED'
}

export type SearchType = {
  __typename?: 'SearchType';
  _count?: Maybe<SearchTypeCount>;
  cra?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  dataStructure: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  vendorBehaviour?: Maybe<Scalars['String']['output']>;
  vendors?: Maybe<Scalars['String']['output']>;
};

export type SearchTypeCount = {
  __typename?: 'SearchTypeCount';
  dispatchedSearches: Scalars['Int']['output'];
  packageSetTypes: Scalars['Int']['output'];
  packageSets: Scalars['Int']['output'];
  requestedSearches: Scalars['Int']['output'];
  resultTypes: Scalars['Int']['output'];
};


export type SearchTypeCountDispatchedSearchesArgs = {
  where?: InputMaybe<DispatchedSearchWhereInput>;
};


export type SearchTypeCountPackageSetTypesArgs = {
  where?: InputMaybe<PackageSetTypeWhereInput>;
};


export type SearchTypeCountPackageSetsArgs = {
  where?: InputMaybe<PackageSetWhereInput>;
};


export type SearchTypeCountRequestedSearchesArgs = {
  where?: InputMaybe<RequestedSearchWhereInput>;
};


export type SearchTypeCountResultTypesArgs = {
  where?: InputMaybe<ResultTypeWhereInput>;
};

export type SearchTypeCreateNestedManyWithoutPackageSetTypesInput = {
  connect?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SearchTypeCreateOrConnectWithoutPackageSetTypesInput>>;
  create?: InputMaybe<Array<SearchTypeCreateWithoutPackageSetTypesInput>>;
};

export type SearchTypeCreateNestedManyWithoutPackageSetsInput = {
  connect?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SearchTypeCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<SearchTypeCreateWithoutPackageSetsInput>>;
};

export type SearchTypeCreateNestedOneWithoutDispatchedSearchesInput = {
  connect?: InputMaybe<SearchTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SearchTypeCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<SearchTypeCreateWithoutDispatchedSearchesInput>;
};

export type SearchTypeCreateNestedOneWithoutRequestedSearchesInput = {
  connect?: InputMaybe<SearchTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SearchTypeCreateOrConnectWithoutRequestedSearchesInput>;
  create?: InputMaybe<SearchTypeCreateWithoutRequestedSearchesInput>;
};

export type SearchTypeCreateOrConnectWithoutDispatchedSearchesInput = {
  create: SearchTypeCreateWithoutDispatchedSearchesInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeCreateOrConnectWithoutPackageSetTypesInput = {
  create: SearchTypeCreateWithoutPackageSetTypesInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeCreateOrConnectWithoutPackageSetsInput = {
  create: SearchTypeCreateWithoutPackageSetsInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeCreateOrConnectWithoutRequestedSearchesInput = {
  create: SearchTypeCreateWithoutRequestedSearchesInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeCreateWithoutDispatchedSearchesInput = {
  cra?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataStructure: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageSetTypes?: InputMaybe<PackageSetTypeCreateNestedManyWithoutSearchTypesInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutSearchTypesInput>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSearchTypeInput>;
  resultTypes?: InputMaybe<ResultTypeCreateNestedManyWithoutSearchTypesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorBehaviour?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Scalars['String']['input']>;
};

export type SearchTypeCreateWithoutPackageSetTypesInput = {
  cra?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataStructure: Scalars['JSON']['input'];
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutSearchTypeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutSearchTypesInput>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSearchTypeInput>;
  resultTypes?: InputMaybe<ResultTypeCreateNestedManyWithoutSearchTypesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorBehaviour?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Scalars['String']['input']>;
};

export type SearchTypeCreateWithoutPackageSetsInput = {
  cra?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataStructure: Scalars['JSON']['input'];
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutSearchTypeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageSetTypes?: InputMaybe<PackageSetTypeCreateNestedManyWithoutSearchTypesInput>;
  requestedSearches?: InputMaybe<RequestedSearchCreateNestedManyWithoutSearchTypeInput>;
  resultTypes?: InputMaybe<ResultTypeCreateNestedManyWithoutSearchTypesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorBehaviour?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Scalars['String']['input']>;
};

export type SearchTypeCreateWithoutRequestedSearchesInput = {
  cra?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dataStructure: Scalars['JSON']['input'];
  dispatchedSearches?: InputMaybe<DispatchedSearchCreateNestedManyWithoutSearchTypeInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageSetTypes?: InputMaybe<PackageSetTypeCreateNestedManyWithoutSearchTypesInput>;
  packageSets?: InputMaybe<PackageSetCreateNestedManyWithoutSearchTypesInput>;
  resultTypes?: InputMaybe<ResultTypeCreateNestedManyWithoutSearchTypesInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorBehaviour?: InputMaybe<Scalars['String']['input']>;
  vendors?: InputMaybe<Scalars['String']['input']>;
};

export type SearchTypeListRelationFilter = {
  every?: InputMaybe<SearchTypeWhereInput>;
  none?: InputMaybe<SearchTypeWhereInput>;
  some?: InputMaybe<SearchTypeWhereInput>;
};

export type SearchTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SearchTypeOrderByWithRelationInput = {
  cra?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dataStructure?: InputMaybe<SortOrder>;
  dispatchedSearches?: InputMaybe<DispatchedSearchOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  packageSetTypes?: InputMaybe<PackageSetTypeOrderByRelationAggregateInput>;
  packageSets?: InputMaybe<PackageSetOrderByRelationAggregateInput>;
  requestedSearches?: InputMaybe<RequestedSearchOrderByRelationAggregateInput>;
  resultTypes?: InputMaybe<ResultTypeOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendorBehaviour?: InputMaybe<SortOrderInput>;
  vendors?: InputMaybe<SortOrderInput>;
};

export enum SearchTypeScalarFieldEnum {
  Cra = 'cra',
  CreatedAt = 'createdAt',
  DataStructure = 'dataStructure',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  VendorBehaviour = 'vendorBehaviour',
  Vendors = 'vendors'
}

export type SearchTypeScalarRelationFilter = {
  is?: InputMaybe<SearchTypeWhereInput>;
  isNot?: InputMaybe<SearchTypeWhereInput>;
};

export type SearchTypeScalarWhereInput = {
  AND?: InputMaybe<Array<SearchTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<SearchTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<SearchTypeScalarWhereInput>>;
  cra?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataStructure?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorBehaviour?: InputMaybe<StringNullableFilter>;
  vendors?: InputMaybe<StringNullableFilter>;
};

export type SearchTypeUpdateManyMutationInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorBehaviour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SearchTypeUpdateManyWithWhereWithoutPackageSetTypesInput = {
  data: SearchTypeUpdateManyMutationInput;
  where: SearchTypeScalarWhereInput;
};

export type SearchTypeUpdateManyWithWhereWithoutPackageSetsInput = {
  data: SearchTypeUpdateManyMutationInput;
  where: SearchTypeScalarWhereInput;
};

export type SearchTypeUpdateManyWithoutPackageSetTypesNestedInput = {
  connect?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SearchTypeCreateOrConnectWithoutPackageSetTypesInput>>;
  create?: InputMaybe<Array<SearchTypeCreateWithoutPackageSetTypesInput>>;
  delete?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SearchTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<SearchTypeUpdateWithWhereUniqueWithoutPackageSetTypesInput>>;
  updateMany?: InputMaybe<Array<SearchTypeUpdateManyWithWhereWithoutPackageSetTypesInput>>;
  upsert?: InputMaybe<Array<SearchTypeUpsertWithWhereUniqueWithoutPackageSetTypesInput>>;
};

export type SearchTypeUpdateManyWithoutPackageSetsNestedInput = {
  connect?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SearchTypeCreateOrConnectWithoutPackageSetsInput>>;
  create?: InputMaybe<Array<SearchTypeCreateWithoutPackageSetsInput>>;
  delete?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SearchTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<SearchTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<SearchTypeUpdateWithWhereUniqueWithoutPackageSetsInput>>;
  updateMany?: InputMaybe<Array<SearchTypeUpdateManyWithWhereWithoutPackageSetsInput>>;
  upsert?: InputMaybe<Array<SearchTypeUpsertWithWhereUniqueWithoutPackageSetsInput>>;
};

export type SearchTypeUpdateOneRequiredWithoutDispatchedSearchesNestedInput = {
  connect?: InputMaybe<SearchTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SearchTypeCreateOrConnectWithoutDispatchedSearchesInput>;
  create?: InputMaybe<SearchTypeCreateWithoutDispatchedSearchesInput>;
  update?: InputMaybe<SearchTypeUpdateToOneWithWhereWithoutDispatchedSearchesInput>;
  upsert?: InputMaybe<SearchTypeUpsertWithoutDispatchedSearchesInput>;
};

export type SearchTypeUpdateOneRequiredWithoutRequestedSearchesNestedInput = {
  connect?: InputMaybe<SearchTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SearchTypeCreateOrConnectWithoutRequestedSearchesInput>;
  create?: InputMaybe<SearchTypeCreateWithoutRequestedSearchesInput>;
  update?: InputMaybe<SearchTypeUpdateToOneWithWhereWithoutRequestedSearchesInput>;
  upsert?: InputMaybe<SearchTypeUpsertWithoutRequestedSearchesInput>;
};

export type SearchTypeUpdateToOneWithWhereWithoutDispatchedSearchesInput = {
  data: SearchTypeUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<SearchTypeWhereInput>;
};

export type SearchTypeUpdateToOneWithWhereWithoutRequestedSearchesInput = {
  data: SearchTypeUpdateWithoutRequestedSearchesInput;
  where?: InputMaybe<SearchTypeWhereInput>;
};

export type SearchTypeUpdateWithWhereUniqueWithoutPackageSetTypesInput = {
  data: SearchTypeUpdateWithoutPackageSetTypesInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeUpdateWithWhereUniqueWithoutPackageSetsInput = {
  data: SearchTypeUpdateWithoutPackageSetsInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeUpdateWithoutDispatchedSearchesInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSetTypes?: InputMaybe<PackageSetTypeUpdateManyWithoutSearchTypesNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutSearchTypesNestedInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSearchTypeNestedInput>;
  resultTypes?: InputMaybe<ResultTypeUpdateManyWithoutSearchTypesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorBehaviour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SearchTypeUpdateWithoutPackageSetTypesInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutSearchTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutSearchTypesNestedInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSearchTypeNestedInput>;
  resultTypes?: InputMaybe<ResultTypeUpdateManyWithoutSearchTypesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorBehaviour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SearchTypeUpdateWithoutPackageSetsInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutSearchTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSetTypes?: InputMaybe<PackageSetTypeUpdateManyWithoutSearchTypesNestedInput>;
  requestedSearches?: InputMaybe<RequestedSearchUpdateManyWithoutSearchTypeNestedInput>;
  resultTypes?: InputMaybe<ResultTypeUpdateManyWithoutSearchTypesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorBehaviour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SearchTypeUpdateWithoutRequestedSearchesInput = {
  cra?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataStructure?: InputMaybe<Scalars['JSON']['input']>;
  dispatchedSearches?: InputMaybe<DispatchedSearchUpdateManyWithoutSearchTypeNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageSetTypes?: InputMaybe<PackageSetTypeUpdateManyWithoutSearchTypesNestedInput>;
  packageSets?: InputMaybe<PackageSetUpdateManyWithoutSearchTypesNestedInput>;
  resultTypes?: InputMaybe<ResultTypeUpdateManyWithoutSearchTypesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorBehaviour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendors?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SearchTypeUpsertWithWhereUniqueWithoutPackageSetTypesInput = {
  create: SearchTypeCreateWithoutPackageSetTypesInput;
  update: SearchTypeUpdateWithoutPackageSetTypesInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeUpsertWithWhereUniqueWithoutPackageSetsInput = {
  create: SearchTypeCreateWithoutPackageSetsInput;
  update: SearchTypeUpdateWithoutPackageSetsInput;
  where: SearchTypeWhereUniqueInput;
};

export type SearchTypeUpsertWithoutDispatchedSearchesInput = {
  create: SearchTypeCreateWithoutDispatchedSearchesInput;
  update: SearchTypeUpdateWithoutDispatchedSearchesInput;
  where?: InputMaybe<SearchTypeWhereInput>;
};

export type SearchTypeUpsertWithoutRequestedSearchesInput = {
  create: SearchTypeCreateWithoutRequestedSearchesInput;
  update: SearchTypeUpdateWithoutRequestedSearchesInput;
  where?: InputMaybe<SearchTypeWhereInput>;
};

export type SearchTypeWhereInput = {
  AND?: InputMaybe<Array<SearchTypeWhereInput>>;
  NOT?: InputMaybe<Array<SearchTypeWhereInput>>;
  OR?: InputMaybe<Array<SearchTypeWhereInput>>;
  cra?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataStructure?: InputMaybe<JsonFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  packageSetTypes?: InputMaybe<PackageSetTypeListRelationFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  resultTypes?: InputMaybe<ResultTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorBehaviour?: InputMaybe<StringNullableFilter>;
  vendors?: InputMaybe<StringNullableFilter>;
};

export type SearchTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<SearchTypeWhereInput>>;
  NOT?: InputMaybe<Array<SearchTypeWhereInput>>;
  OR?: InputMaybe<Array<SearchTypeWhereInput>>;
  cra?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dataStructure?: InputMaybe<JsonFilter>;
  dispatchedSearches?: InputMaybe<DispatchedSearchListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageSetTypes?: InputMaybe<PackageSetTypeListRelationFilter>;
  packageSets?: InputMaybe<PackageSetListRelationFilter>;
  requestedSearches?: InputMaybe<RequestedSearchListRelationFilter>;
  resultTypes?: InputMaybe<ResultTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorBehaviour?: InputMaybe<StringNullableFilter>;
  vendors?: InputMaybe<StringNullableFilter>;
};

export type Secret = {
  __typename?: 'Secret';
  ciphertext?: Maybe<Scalars['Byte']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  ctxHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  keyId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  value?: Maybe<Scalars['String']['output']>;
  vendorConfiguration?: Maybe<VendorConfiguration>;
  vendorConfigurationId?: Maybe<Scalars['String']['output']>;
};


export type SecretOrganizationArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type SecretVendorConfigurationArgs = {
  where?: InputMaybe<VendorConfigurationWhereInput>;
};

export type SecretCreateInput = {
  ciphertext?: InputMaybe<Scalars['Byte']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  ctxHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutSecretsInput>;
  ownerId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vendorConfiguration?: InputMaybe<VendorConfigurationCreateNestedOneWithoutSecretInput>;
};

export type SecretCreateManyOrganizationInput = {
  ciphertext?: InputMaybe<Scalars['Byte']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  ctxHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vendorConfigurationId?: InputMaybe<Scalars['String']['input']>;
};

export type SecretCreateManyOrganizationInputEnvelope = {
  data: Array<SecretCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SecretCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<SecretWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SecretCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<SecretCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<SecretCreateManyOrganizationInputEnvelope>;
};

export type SecretCreateNestedOneWithoutVendorConfigurationInput = {
  connect?: InputMaybe<SecretWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SecretCreateOrConnectWithoutVendorConfigurationInput>;
  create?: InputMaybe<SecretCreateWithoutVendorConfigurationInput>;
};

export type SecretCreateOrConnectWithoutOrganizationInput = {
  create: SecretCreateWithoutOrganizationInput;
  where: SecretWhereUniqueInput;
};

export type SecretCreateOrConnectWithoutVendorConfigurationInput = {
  create: SecretCreateWithoutVendorConfigurationInput;
  where: SecretWhereUniqueInput;
};

export type SecretCreateWithoutOrganizationInput = {
  ciphertext?: InputMaybe<Scalars['Byte']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  ctxHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  vendorConfiguration?: InputMaybe<VendorConfigurationCreateNestedOneWithoutSecretInput>;
};

export type SecretCreateWithoutVendorConfigurationInput = {
  ciphertext?: InputMaybe<Scalars['Byte']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  ctxHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutSecretsInput>;
  ownerId: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SecretListRelationFilter = {
  every?: InputMaybe<SecretWhereInput>;
  none?: InputMaybe<SecretWhereInput>;
  some?: InputMaybe<SecretWhereInput>;
};

export type SecretNullableScalarRelationFilter = {
  is?: InputMaybe<SecretWhereInput>;
  isNot?: InputMaybe<SecretWhereInput>;
};

export type SecretOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SecretOrderByWithRelationInput = {
  ciphertext?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  ctxHash?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  ownerId?: InputMaybe<SortOrder>;
  provider?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrderInput>;
  vendorConfiguration?: InputMaybe<VendorConfigurationOrderByWithRelationInput>;
  vendorConfigurationId?: InputMaybe<SortOrderInput>;
};

export enum SecretScalarFieldEnum {
  Ciphertext = 'ciphertext',
  CreatedAt = 'createdAt',
  CtxHash = 'ctxHash',
  Id = 'id',
  KeyId = 'keyId',
  Name = 'name',
  OrganizationId = 'organizationId',
  OwnerId = 'ownerId',
  Provider = 'provider',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  VendorConfigurationId = 'vendorConfigurationId'
}

export type SecretScalarWhereInput = {
  AND?: InputMaybe<Array<SecretScalarWhereInput>>;
  NOT?: InputMaybe<Array<SecretScalarWhereInput>>;
  OR?: InputMaybe<Array<SecretScalarWhereInput>>;
  ciphertext?: InputMaybe<BytesNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  ctxHash?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  keyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  ownerId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringNullableFilter>;
  vendorConfigurationId?: InputMaybe<StringNullableFilter>;
};

export type SecretUpdateInput = {
  ciphertext?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctxHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutSecretsNestedInput>;
  ownerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendorConfiguration?: InputMaybe<VendorConfigurationUpdateOneWithoutSecretNestedInput>;
};

export type SecretUpdateManyMutationInput = {
  ciphertext?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctxHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SecretUpdateManyWithWhereWithoutOrganizationInput = {
  data: SecretUpdateManyMutationInput;
  where: SecretScalarWhereInput;
};

export type SecretUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<SecretWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SecretCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<SecretCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<SecretCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<SecretWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SecretScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SecretWhereUniqueInput>>;
  set?: InputMaybe<Array<SecretWhereUniqueInput>>;
  update?: InputMaybe<Array<SecretUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<SecretUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<SecretUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type SecretUpdateOneWithoutVendorConfigurationNestedInput = {
  connect?: InputMaybe<SecretWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SecretCreateOrConnectWithoutVendorConfigurationInput>;
  create?: InputMaybe<SecretCreateWithoutVendorConfigurationInput>;
  delete?: InputMaybe<SecretWhereInput>;
  disconnect?: InputMaybe<SecretWhereInput>;
  update?: InputMaybe<SecretUpdateToOneWithWhereWithoutVendorConfigurationInput>;
  upsert?: InputMaybe<SecretUpsertWithoutVendorConfigurationInput>;
};

export type SecretUpdateToOneWithWhereWithoutVendorConfigurationInput = {
  data: SecretUpdateWithoutVendorConfigurationInput;
  where?: InputMaybe<SecretWhereInput>;
};

export type SecretUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: SecretUpdateWithoutOrganizationInput;
  where: SecretWhereUniqueInput;
};

export type SecretUpdateWithoutOrganizationInput = {
  ciphertext?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctxHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendorConfiguration?: InputMaybe<VendorConfigurationUpdateOneWithoutSecretNestedInput>;
};

export type SecretUpdateWithoutVendorConfigurationInput = {
  ciphertext?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  ctxHash?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutSecretsNestedInput>;
  ownerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SecretUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: SecretCreateWithoutOrganizationInput;
  update: SecretUpdateWithoutOrganizationInput;
  where: SecretWhereUniqueInput;
};

export type SecretUpsertWithoutVendorConfigurationInput = {
  create: SecretCreateWithoutVendorConfigurationInput;
  update: SecretUpdateWithoutVendorConfigurationInput;
  where?: InputMaybe<SecretWhereInput>;
};

export type SecretWhereInput = {
  AND?: InputMaybe<Array<SecretWhereInput>>;
  NOT?: InputMaybe<Array<SecretWhereInput>>;
  OR?: InputMaybe<Array<SecretWhereInput>>;
  ciphertext?: InputMaybe<BytesNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  ctxHash?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  keyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  ownerId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringNullableFilter>;
  vendorConfiguration?: InputMaybe<VendorConfigurationNullableScalarRelationFilter>;
  vendorConfigurationId?: InputMaybe<StringNullableFilter>;
};

export type SecretWhereUniqueInput = {
  AND?: InputMaybe<Array<SecretWhereInput>>;
  NOT?: InputMaybe<Array<SecretWhereInput>>;
  OR?: InputMaybe<Array<SecretWhereInput>>;
  ciphertext?: InputMaybe<BytesNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  ctxHash?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  ownerId?: InputMaybe<StringFilter>;
  provider?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringNullableFilter>;
  vendorConfiguration?: InputMaybe<VendorConfigurationNullableScalarRelationFilter>;
  vendorConfigurationId?: InputMaybe<Scalars['String']['input']>;
};

export type ShortUrl = {
  __typename?: 'ShortUrl';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  originalUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type ShortUrlCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalUrl: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ShortUrlCreateManyUserInputEnvelope = {
  data: Array<ShortUrlCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShortUrlCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ShortUrlWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShortUrlCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ShortUrlCreateWithoutUserInput>>;
  createMany?: InputMaybe<ShortUrlCreateManyUserInputEnvelope>;
};

export type ShortUrlCreateOrConnectWithoutUserInput = {
  create: ShortUrlCreateWithoutUserInput;
  where: ShortUrlWhereUniqueInput;
};

export type ShortUrlCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalUrl: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ShortUrlListRelationFilter = {
  every?: InputMaybe<ShortUrlWhereInput>;
  none?: InputMaybe<ShortUrlWhereInput>;
  some?: InputMaybe<ShortUrlWhereInput>;
};

export type ShortUrlOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShortUrlOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  originalUrl?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum ShortUrlScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OriginalUrl = 'originalUrl',
  Slug = 'slug',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type ShortUrlScalarWhereInput = {
  AND?: InputMaybe<Array<ShortUrlScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShortUrlScalarWhereInput>>;
  OR?: InputMaybe<Array<ShortUrlScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  originalUrl?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ShortUrlUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShortUrlUpdateManyWithWhereWithoutUserInput = {
  data: ShortUrlUpdateManyMutationInput;
  where: ShortUrlScalarWhereInput;
};

export type ShortUrlUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ShortUrlWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShortUrlCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ShortUrlCreateWithoutUserInput>>;
  createMany?: InputMaybe<ShortUrlCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ShortUrlWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShortUrlScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShortUrlWhereUniqueInput>>;
  set?: InputMaybe<Array<ShortUrlWhereUniqueInput>>;
  update?: InputMaybe<Array<ShortUrlUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ShortUrlUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ShortUrlUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ShortUrlUpdateWithWhereUniqueWithoutUserInput = {
  data: ShortUrlUpdateWithoutUserInput;
  where: ShortUrlWhereUniqueInput;
};

export type ShortUrlUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShortUrlUpsertWithWhereUniqueWithoutUserInput = {
  create: ShortUrlCreateWithoutUserInput;
  update: ShortUrlUpdateWithoutUserInput;
  where: ShortUrlWhereUniqueInput;
};

export type ShortUrlWhereInput = {
  AND?: InputMaybe<Array<ShortUrlWhereInput>>;
  NOT?: InputMaybe<Array<ShortUrlWhereInput>>;
  OR?: InputMaybe<Array<ShortUrlWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  originalUrl?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type ShortUrlWhereUniqueInput = {
  AND?: InputMaybe<Array<ShortUrlWhereInput>>;
  NOT?: InputMaybe<Array<ShortUrlWhereInput>>;
  OR?: InputMaybe<Array<ShortUrlWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalUrl?: InputMaybe<StringFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SignedUrlResponseV2 = {
  __typename?: 'SignedURLResponseV2';
  url: Scalars['String']['output'];
};

export type SimpleResponse = {
  __typename?: 'SimpleResponse';
  status: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export enum SourceTypes {
  App = 'APP',
  Product = 'PRODUCT',
  Url = 'URL'
}

export type StateIdentificationCard = {
  __typename?: 'StateIdentificationCard';
  _count?: Maybe<StateIdentificationCardCount>;
  address?: Maybe<Address>;
  applicantData?: Maybe<ApplicantData>;
  applicantDataId?: Maybe<Scalars['String']['output']>;
  backImage?: Maybe<File>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth: Scalars['String']['output'];
  documentType?: Maybe<Scalars['String']['output']>;
  expiryDate: Scalars['String']['output'];
  extractedPhoto?: Maybe<File>;
  frontImage?: Maybe<File>;
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idVerificationResult: Array<IdVerificationResult>;
  issueDate: Scalars['String']['output'];
  manualIdEntry?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  number: Scalars['String']['output'];
  selfieImage?: Maybe<File>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type StateIdentificationCardAddressArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type StateIdentificationCardApplicantDataArgs = {
  where?: InputMaybe<ApplicantDataWhereInput>;
};


export type StateIdentificationCardBackImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type StateIdentificationCardExtractedPhotoArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type StateIdentificationCardFrontImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type StateIdentificationCardIdVerificationResultArgs = {
  cursor?: InputMaybe<IdVerificationResultWhereUniqueInput>;
  distinct?: InputMaybe<Array<IdVerificationResultScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IdVerificationResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IdVerificationResultWhereInput>;
};


export type StateIdentificationCardNameArgs = {
  where?: InputMaybe<NameWhereInput>;
};


export type StateIdentificationCardSelfieImageArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type StateIdentificationCardUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type StateIdentificationCardCount = {
  __typename?: 'StateIdentificationCardCount';
  idVerificationResult: Scalars['Int']['output'];
};


export type StateIdentificationCardCountIdVerificationResultArgs = {
  where?: InputMaybe<IdVerificationResultWhereInput>;
};

export type StateIdentificationCardCreateInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateManyUserInput = {
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type StateIdentificationCardCreateManyUserInputEnvelope = {
  data: Array<StateIdentificationCardCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateIdentificationCardCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<StateIdentificationCardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StateIdentificationCardCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<StateIdentificationCardCreateWithoutUserInput>>;
  createMany?: InputMaybe<StateIdentificationCardCreateManyUserInputEnvelope>;
};

export type StateIdentificationCardCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutAddressInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutApplicantDataInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutApplicantDataInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutBackImageInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutBackImageInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutBackImageInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutExtractedPhotoInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutExtractedPhotoInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutExtractedPhotoInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutFrontImageInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutFrontImageInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutFrontImageInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutIdVerificationResultInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutIdVerificationResultInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutIdVerificationResultInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutNameInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutNameInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutNameInput>;
};

export type StateIdentificationCardCreateNestedOneWithoutSelfieImageInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutSelfieImageInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutSelfieImageInput>;
};

export type StateIdentificationCardCreateOrConnectWithoutAddressInput = {
  create: StateIdentificationCardCreateWithoutAddressInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutApplicantDataInput = {
  create: StateIdentificationCardCreateWithoutApplicantDataInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutBackImageInput = {
  create: StateIdentificationCardCreateWithoutBackImageInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutExtractedPhotoInput = {
  create: StateIdentificationCardCreateWithoutExtractedPhotoInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutFrontImageInput = {
  create: StateIdentificationCardCreateWithoutFrontImageInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutIdVerificationResultInput = {
  create: StateIdentificationCardCreateWithoutIdVerificationResultInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutNameInput = {
  create: StateIdentificationCardCreateWithoutNameInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutSelfieImageInput = {
  create: StateIdentificationCardCreateWithoutSelfieImageInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateOrConnectWithoutUserInput = {
  create: StateIdentificationCardCreateWithoutUserInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardCreateWithoutAddressInput = {
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutApplicantDataInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutBackImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutExtractedPhotoInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutFrontImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutIdVerificationResultInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutNameInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutSelfieImageInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutStateIdentificationCardsInput>;
};

export type StateIdentificationCardCreateWithoutUserInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutStateIdentificationCardInput>;
  applicantData?: InputMaybe<ApplicantDataCreateNestedOneWithoutStateIdentificationCardInput>;
  backImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardBackInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate: Scalars['String']['input'];
  extractedPhoto?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardExtractInput>;
  frontImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardFrontInput>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedManyWithoutStateIdentificationCardInput>;
  issueDate: Scalars['String']['input'];
  manualIdEntry?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameCreateNestedOneWithoutStateIdentificationCardInput>;
  number: Scalars['String']['input'];
  selfieImage?: InputMaybe<FileCreateNestedOneWithoutStateIdentificationCardSelfieInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type StateIdentificationCardListRelationFilter = {
  every?: InputMaybe<StateIdentificationCardWhereInput>;
  none?: InputMaybe<StateIdentificationCardWhereInput>;
  some?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardNullableScalarRelationFilter = {
  is?: InputMaybe<StateIdentificationCardWhereInput>;
  isNot?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StateIdentificationCardOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  applicantData?: InputMaybe<ApplicantDataOrderByWithRelationInput>;
  applicantDataId?: InputMaybe<SortOrderInput>;
  backImage?: InputMaybe<FileOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  documentType?: InputMaybe<SortOrderInput>;
  expiryDate?: InputMaybe<SortOrder>;
  extractedPhoto?: InputMaybe<FileOrderByWithRelationInput>;
  frontImage?: InputMaybe<FileOrderByWithRelationInput>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idVerificationResult?: InputMaybe<IdVerificationResultOrderByRelationAggregateInput>;
  issueDate?: InputMaybe<SortOrder>;
  manualIdEntry?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<NameOrderByWithRelationInput>;
  number?: InputMaybe<SortOrder>;
  selfieImage?: InputMaybe<FileOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum StateIdentificationCardScalarFieldEnum {
  ApplicantDataId = 'applicantDataId',
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DocumentType = 'documentType',
  ExpiryDate = 'expiryDate',
  Gender = 'gender',
  Id = 'id',
  IssueDate = 'issueDate',
  ManualIdEntry = 'manualIdEntry',
  Number = 'number',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type StateIdentificationCardScalarWhereInput = {
  AND?: InputMaybe<Array<StateIdentificationCardScalarWhereInput>>;
  NOT?: InputMaybe<Array<StateIdentificationCardScalarWhereInput>>;
  OR?: InputMaybe<Array<StateIdentificationCardScalarWhereInput>>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringNullableFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  issueDate?: InputMaybe<StringFilter>;
  manualIdEntry?: InputMaybe<BoolNullableFilter>;
  number?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type StateIdentificationCardUpdateInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StateIdentificationCardUpdateManyWithWhereWithoutUserInput = {
  data: StateIdentificationCardUpdateManyMutationInput;
  where: StateIdentificationCardScalarWhereInput;
};

export type StateIdentificationCardUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<StateIdentificationCardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StateIdentificationCardCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<StateIdentificationCardCreateWithoutUserInput>>;
  createMany?: InputMaybe<StateIdentificationCardCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<StateIdentificationCardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StateIdentificationCardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StateIdentificationCardWhereUniqueInput>>;
  set?: InputMaybe<Array<StateIdentificationCardWhereUniqueInput>>;
  update?: InputMaybe<Array<StateIdentificationCardUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<StateIdentificationCardUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<StateIdentificationCardUpsertWithWhereUniqueWithoutUserInput>>;
};

export type StateIdentificationCardUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutAddressInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutAddressInput>;
};

export type StateIdentificationCardUpdateOneWithoutApplicantDataNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutApplicantDataInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutApplicantDataInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutApplicantDataInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutApplicantDataInput>;
};

export type StateIdentificationCardUpdateOneWithoutBackImageNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutBackImageInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutBackImageInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutBackImageInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutBackImageInput>;
};

export type StateIdentificationCardUpdateOneWithoutExtractedPhotoNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutExtractedPhotoInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutExtractedPhotoInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutExtractedPhotoInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutExtractedPhotoInput>;
};

export type StateIdentificationCardUpdateOneWithoutFrontImageNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutFrontImageInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutFrontImageInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutFrontImageInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutFrontImageInput>;
};

export type StateIdentificationCardUpdateOneWithoutIdVerificationResultNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutIdVerificationResultInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutIdVerificationResultInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutIdVerificationResultInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutIdVerificationResultInput>;
};

export type StateIdentificationCardUpdateOneWithoutNameNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutNameInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutNameInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutNameInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutNameInput>;
};

export type StateIdentificationCardUpdateOneWithoutSelfieImageNestedInput = {
  connect?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StateIdentificationCardCreateOrConnectWithoutSelfieImageInput>;
  create?: InputMaybe<StateIdentificationCardCreateWithoutSelfieImageInput>;
  delete?: InputMaybe<StateIdentificationCardWhereInput>;
  disconnect?: InputMaybe<StateIdentificationCardWhereInput>;
  update?: InputMaybe<StateIdentificationCardUpdateToOneWithWhereWithoutSelfieImageInput>;
  upsert?: InputMaybe<StateIdentificationCardUpsertWithoutSelfieImageInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutAddressInput = {
  data: StateIdentificationCardUpdateWithoutAddressInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutApplicantDataInput = {
  data: StateIdentificationCardUpdateWithoutApplicantDataInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutBackImageInput = {
  data: StateIdentificationCardUpdateWithoutBackImageInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutExtractedPhotoInput = {
  data: StateIdentificationCardUpdateWithoutExtractedPhotoInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutFrontImageInput = {
  data: StateIdentificationCardUpdateWithoutFrontImageInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutIdVerificationResultInput = {
  data: StateIdentificationCardUpdateWithoutIdVerificationResultInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutNameInput = {
  data: StateIdentificationCardUpdateWithoutNameInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateToOneWithWhereWithoutSelfieImageInput = {
  data: StateIdentificationCardUpdateWithoutSelfieImageInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpdateWithWhereUniqueWithoutUserInput = {
  data: StateIdentificationCardUpdateWithoutUserInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardUpdateWithoutAddressInput = {
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutApplicantDataInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutBackImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutExtractedPhotoInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutFrontImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutIdVerificationResultInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutNameInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutSelfieImageInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutStateIdentificationCardsNestedInput>;
};

export type StateIdentificationCardUpdateWithoutUserInput = {
  address?: InputMaybe<AddressUpdateOneWithoutStateIdentificationCardNestedInput>;
  applicantData?: InputMaybe<ApplicantDataUpdateOneWithoutStateIdentificationCardNestedInput>;
  backImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardBackNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expiryDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  extractedPhoto?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardExtractNestedInput>;
  frontImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardFrontNestedInput>;
  gender?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateManyWithoutStateIdentificationCardNestedInput>;
  issueDate?: InputMaybe<StringFieldUpdateOperationsInput>;
  manualIdEntry?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NameUpdateOneWithoutStateIdentificationCardNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  selfieImage?: InputMaybe<FileUpdateOneWithoutStateIdentificationCardSelfieNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StateIdentificationCardUpsertWithWhereUniqueWithoutUserInput = {
  create: StateIdentificationCardCreateWithoutUserInput;
  update: StateIdentificationCardUpdateWithoutUserInput;
  where: StateIdentificationCardWhereUniqueInput;
};

export type StateIdentificationCardUpsertWithoutAddressInput = {
  create: StateIdentificationCardCreateWithoutAddressInput;
  update: StateIdentificationCardUpdateWithoutAddressInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutApplicantDataInput = {
  create: StateIdentificationCardCreateWithoutApplicantDataInput;
  update: StateIdentificationCardUpdateWithoutApplicantDataInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutBackImageInput = {
  create: StateIdentificationCardCreateWithoutBackImageInput;
  update: StateIdentificationCardUpdateWithoutBackImageInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutExtractedPhotoInput = {
  create: StateIdentificationCardCreateWithoutExtractedPhotoInput;
  update: StateIdentificationCardUpdateWithoutExtractedPhotoInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutFrontImageInput = {
  create: StateIdentificationCardCreateWithoutFrontImageInput;
  update: StateIdentificationCardUpdateWithoutFrontImageInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutIdVerificationResultInput = {
  create: StateIdentificationCardCreateWithoutIdVerificationResultInput;
  update: StateIdentificationCardUpdateWithoutIdVerificationResultInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutNameInput = {
  create: StateIdentificationCardCreateWithoutNameInput;
  update: StateIdentificationCardUpdateWithoutNameInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardUpsertWithoutSelfieImageInput = {
  create: StateIdentificationCardCreateWithoutSelfieImageInput;
  update: StateIdentificationCardUpdateWithoutSelfieImageInput;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};

export type StateIdentificationCardWhereInput = {
  AND?: InputMaybe<Array<StateIdentificationCardWhereInput>>;
  NOT?: InputMaybe<Array<StateIdentificationCardWhereInput>>;
  OR?: InputMaybe<Array<StateIdentificationCardWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<StringNullableFilter>;
  backImage?: InputMaybe<FileNullableScalarRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringNullableFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  extractedPhoto?: InputMaybe<FileNullableScalarRelationFilter>;
  frontImage?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  idVerificationResult?: InputMaybe<IdVerificationResultListRelationFilter>;
  issueDate?: InputMaybe<StringFilter>;
  manualIdEntry?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<NameNullableScalarRelationFilter>;
  number?: InputMaybe<StringFilter>;
  selfieImage?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type StateIdentificationCardWhereUniqueInput = {
  AND?: InputMaybe<Array<StateIdentificationCardWhereInput>>;
  NOT?: InputMaybe<Array<StateIdentificationCardWhereInput>>;
  OR?: InputMaybe<Array<StateIdentificationCardWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  applicantData?: InputMaybe<ApplicantDataNullableScalarRelationFilter>;
  applicantDataId?: InputMaybe<Scalars['String']['input']>;
  backImage?: InputMaybe<FileNullableScalarRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<StringFilter>;
  documentType?: InputMaybe<StringNullableFilter>;
  expiryDate?: InputMaybe<StringFilter>;
  extractedPhoto?: InputMaybe<FileNullableScalarRelationFilter>;
  frontImage?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idVerificationResult?: InputMaybe<IdVerificationResultListRelationFilter>;
  issueDate?: InputMaybe<StringFilter>;
  manualIdEntry?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<NameNullableScalarRelationFilter>;
  number?: InputMaybe<StringFilter>;
  selfieImage?: InputMaybe<FileNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type StatusResponse = {
  __typename?: 'StatusResponse';
  count?: Maybe<Scalars['Int']['output']>;
  status: Scalars['Boolean']['output'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  deletedOrder: Order;
  newOrder: Order;
  updatedOrder: Order;
};

export enum SupportTicketPurpose {
  BackgroundCheck = 'BACKGROUND_CHECK',
  MyAccount = 'MY_ACCOUNT',
  SomethingElse = 'SOMETHING_ELSE',
  TechnicalIssue = 'TECHNICAL_ISSUE'
}

export type SvixAppPortalUrlResponse = {
  __typename?: 'SvixAppPortalUrlResponse';
  svixAppPortalUrl: Scalars['String']['output'];
};

export type SvixWebhookDeliveryAttempt = {
  __typename?: 'SvixWebhookDeliveryAttempt';
  id: Scalars['String']['output'];
  responseDurationMs: Scalars['Int']['output'];
  responseStatusCode: Scalars['Int']['output'];
  statusText: Scalars['String']['output'];
  timestamp: Scalars['DateTimeISO']['output'];
};

export type SynapseCaseFormation = {
  __typename?: 'SynapseCaseFormation';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  json: Scalars['JSON']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SynapseCaseFormationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  json: Scalars['JSON']['input'];
  organization: OrganizationCreateNestedOneWithoutSynapseCaseFormationInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SynapseCaseFormationCreateNestedOneWithoutOrganizationInput = {
  connect?: InputMaybe<SynapseCaseFormationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SynapseCaseFormationCreateOrConnectWithoutOrganizationInput>;
  create?: InputMaybe<SynapseCaseFormationCreateWithoutOrganizationInput>;
};

export type SynapseCaseFormationCreateOrConnectWithoutOrganizationInput = {
  create: SynapseCaseFormationCreateWithoutOrganizationInput;
  where: SynapseCaseFormationWhereUniqueInput;
};

export type SynapseCaseFormationCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  json: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SynapseCaseFormationNullableScalarRelationFilter = {
  is?: InputMaybe<SynapseCaseFormationWhereInput>;
  isNot?: InputMaybe<SynapseCaseFormationWhereInput>;
};

export type SynapseCaseFormationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  json?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SynapseCaseFormationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Json = 'json',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt'
}

export type SynapseCaseFormationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutSynapseCaseFormationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SynapseCaseFormationUpdateOneWithoutOrganizationNestedInput = {
  connect?: InputMaybe<SynapseCaseFormationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SynapseCaseFormationCreateOrConnectWithoutOrganizationInput>;
  create?: InputMaybe<SynapseCaseFormationCreateWithoutOrganizationInput>;
  delete?: InputMaybe<SynapseCaseFormationWhereInput>;
  disconnect?: InputMaybe<SynapseCaseFormationWhereInput>;
  update?: InputMaybe<SynapseCaseFormationUpdateToOneWithWhereWithoutOrganizationInput>;
  upsert?: InputMaybe<SynapseCaseFormationUpsertWithoutOrganizationInput>;
};

export type SynapseCaseFormationUpdateToOneWithWhereWithoutOrganizationInput = {
  data: SynapseCaseFormationUpdateWithoutOrganizationInput;
  where?: InputMaybe<SynapseCaseFormationWhereInput>;
};

export type SynapseCaseFormationUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SynapseCaseFormationUpsertWithoutOrganizationInput = {
  create: SynapseCaseFormationCreateWithoutOrganizationInput;
  update: SynapseCaseFormationUpdateWithoutOrganizationInput;
  where?: InputMaybe<SynapseCaseFormationWhereInput>;
};

export type SynapseCaseFormationWhereInput = {
  AND?: InputMaybe<Array<SynapseCaseFormationWhereInput>>;
  NOT?: InputMaybe<Array<SynapseCaseFormationWhereInput>>;
  OR?: InputMaybe<Array<SynapseCaseFormationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  json?: InputMaybe<JsonFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SynapseCaseFormationWhereUniqueInput = {
  AND?: InputMaybe<Array<SynapseCaseFormationWhereInput>>;
  NOT?: InputMaybe<Array<SynapseCaseFormationWhereInput>>;
  OR?: InputMaybe<Array<SynapseCaseFormationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<JsonFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SynapseWorkflow = {
  __typename?: 'SynapseWorkflow';
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  json: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SynapseWorkflowCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  json: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  organization: OrganizationCreateNestedOneWithoutSynapseWorkflowInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SynapseWorkflowCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  json: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SynapseWorkflowCreateManyOrganizationInputEnvelope = {
  data: Array<SynapseWorkflowCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SynapseWorkflowCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<SynapseWorkflowWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SynapseWorkflowCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<SynapseWorkflowCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<SynapseWorkflowCreateManyOrganizationInputEnvelope>;
};

export type SynapseWorkflowCreateOrConnectWithoutOrganizationInput = {
  create: SynapseWorkflowCreateWithoutOrganizationInput;
  where: SynapseWorkflowWhereUniqueInput;
};

export type SynapseWorkflowCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  json: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SynapseWorkflowListRelationFilter = {
  every?: InputMaybe<SynapseWorkflowWhereInput>;
  none?: InputMaybe<SynapseWorkflowWhereInput>;
  some?: InputMaybe<SynapseWorkflowWhereInput>;
};

export type SynapseWorkflowOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SynapseWorkflowOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  json?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SynapseWorkflowScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Json = 'json',
  Name = 'name',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt'
}

export type SynapseWorkflowScalarWhereInput = {
  AND?: InputMaybe<Array<SynapseWorkflowScalarWhereInput>>;
  NOT?: InputMaybe<Array<SynapseWorkflowScalarWhereInput>>;
  OR?: InputMaybe<Array<SynapseWorkflowScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  json?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SynapseWorkflowUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutSynapseWorkflowNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SynapseWorkflowUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SynapseWorkflowUpdateManyWithWhereWithoutOrganizationInput = {
  data: SynapseWorkflowUpdateManyMutationInput;
  where: SynapseWorkflowScalarWhereInput;
};

export type SynapseWorkflowUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<SynapseWorkflowWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SynapseWorkflowCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<SynapseWorkflowCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<SynapseWorkflowCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<SynapseWorkflowWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SynapseWorkflowScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SynapseWorkflowWhereUniqueInput>>;
  set?: InputMaybe<Array<SynapseWorkflowWhereUniqueInput>>;
  update?: InputMaybe<Array<SynapseWorkflowUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<SynapseWorkflowUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<SynapseWorkflowUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type SynapseWorkflowUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: SynapseWorkflowUpdateWithoutOrganizationInput;
  where: SynapseWorkflowWhereUniqueInput;
};

export type SynapseWorkflowUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SynapseWorkflowUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: SynapseWorkflowCreateWithoutOrganizationInput;
  update: SynapseWorkflowUpdateWithoutOrganizationInput;
  where: SynapseWorkflowWhereUniqueInput;
};

export type SynapseWorkflowWhereInput = {
  AND?: InputMaybe<Array<SynapseWorkflowWhereInput>>;
  NOT?: InputMaybe<Array<SynapseWorkflowWhereInput>>;
  OR?: InputMaybe<Array<SynapseWorkflowWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  json?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SynapseWorkflowWhereUniqueInput = {
  AND?: InputMaybe<Array<SynapseWorkflowWhereInput>>;
  NOT?: InputMaybe<Array<SynapseWorkflowWhereInput>>;
  OR?: InputMaybe<Array<SynapseWorkflowWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UpdateVoucherEmailRes = {
  __typename?: 'UpdateVoucherEmailRes';
  id: Scalars['String']['output'];
  qrCode: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  ResultRevision: Array<ResultRevision>;
  _count?: Maybe<UserCount>;
  addresses: Array<Address>;
  apiKeyVerifications: Array<ApiKeyVerification>;
  apiKeys: Array<ApiKey>;
  appFeedbacks: Array<AppFeedback>;
  backId?: Maybe<File>;
  beamInput: Array<BeamInput>;
  beamOutputs: Array<BeamOutput>;
  biometricConsentAcceptances: Array<BiometricConsentAcceptance>;
  consumerReportingAgencyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdOrders: Array<Order>;
  createdOrganizations: Array<Organization>;
  createdVIDVouchers: Array<VidVoucher>;
  credentials: Array<Credential>;
  disclosureAcceptances: Array<DisclosureAcceptance>;
  disputes: Array<Dispute>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  firstName?: Maybe<Scalars['String']['output']>;
  frontId?: Maybe<File>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identificationDocuments: Array<IdentificationDocument>;
  identifiers: Array<Identifier>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobs: Array<Job>;
  lastName?: Maybe<Scalars['String']['output']>;
  legacyCredentials: Array<LegacyCredential>;
  legacySSN?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  monitoringEnrollments: Array<MonitoringEnrollment>;
  myOrders: Array<Order>;
  names: Array<Name>;
  noMiddleName: Scalars['Boolean']['output'];
  onboardingStep?: Maybe<Scalars['String']['output']>;
  orderNotes: Array<OrderNote>;
  organizations: Array<Organization>;
  passes: Array<Pass>;
  passports: Array<Passport>;
  permissionEditor: UserPermissionEditor;
  phone?: Maybe<Scalars['String']['output']>;
  pushTokens: Array<Scalars['String']['output']>;
  recentlySelectedOrgIds: Array<Scalars['String']['output']>;
  redeemedInvites: Array<Invite>;
  requestedDisenrollments: Array<MonitoringEnrollment>;
  roleAssignment: Array<RoleAssignment>;
  selectedOrganizationId?: Maybe<Scalars['String']['output']>;
  selfie?: Maybe<File>;
  sentInvites: Array<Invite>;
  shortUrls: Array<ShortUrl>;
  ssn?: Maybe<HighlySensitiveIdentifier>;
  ssnLastFour: Scalars['String']['output'];
  stateIdentificationCards: Array<StateIdentificationCard>;
  updatedAt: Scalars['DateTimeISO']['output'];
  vIDVouchers: Array<VidVoucher>;
  walletShares: Array<WalletShare>;
};


export type UserResultRevisionArgs = {
  cursor?: InputMaybe<ResultRevisionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResultRevisionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResultRevisionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ResultRevisionWhereInput>;
};


export type UserAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type UserApiKeyVerificationsArgs = {
  cursor?: InputMaybe<ApiKeyVerificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyVerificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyVerificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyVerificationWhereInput>;
};


export type UserApiKeysArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type UserAppFeedbacksArgs = {
  cursor?: InputMaybe<AppFeedbackWhereUniqueInput>;
  distinct?: InputMaybe<Array<AppFeedbackScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AppFeedbackOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AppFeedbackWhereInput>;
};


export type UserBackIdArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserBeamInputArgs = {
  cursor?: InputMaybe<BeamInputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamInputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamInputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamInputWhereInput>;
};


export type UserBeamOutputsArgs = {
  cursor?: InputMaybe<BeamOutputWhereUniqueInput>;
  distinct?: InputMaybe<Array<BeamOutputScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BeamOutputOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type UserBiometricConsentAcceptancesArgs = {
  cursor?: InputMaybe<BiometricConsentAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<BiometricConsentAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BiometricConsentAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type UserCreatedOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCreatedOrganizationsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type UserCreatedVidVouchersArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  distinct?: InputMaybe<Array<VidVoucherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type UserCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type UserDisclosureAcceptancesArgs = {
  cursor?: InputMaybe<DisclosureAcceptanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisclosureAcceptanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisclosureAcceptanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type UserDisputesArgs = {
  cursor?: InputMaybe<DisputeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DisputeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DisputeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisputeWhereInput>;
};


export type UserFilesArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type UserFrontIdArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserIdentificationDocumentsArgs = {
  cursor?: InputMaybe<IdentificationDocumentWhereUniqueInput>;
  distinct?: InputMaybe<Array<IdentificationDocumentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IdentificationDocumentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type UserIdentifiersArgs = {
  cursor?: InputMaybe<IdentifierWhereUniqueInput>;
  distinct?: InputMaybe<Array<IdentifierScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<IdentifierOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IdentifierWhereInput>;
};


export type UserJobsArgs = {
  cursor?: InputMaybe<JobWhereUniqueInput>;
  distinct?: InputMaybe<Array<JobScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<JobOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobWhereInput>;
};


export type UserLegacyCredentialsArgs = {
  cursor?: InputMaybe<LegacyCredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<LegacyCredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LegacyCredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LegacyCredentialWhereInput>;
};


export type UserMonitoringEnrollmentsArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringEnrollmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type UserMyOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type UserNamesArgs = {
  cursor?: InputMaybe<NameWhereUniqueInput>;
  distinct?: InputMaybe<Array<NameScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NameOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NameWhereInput>;
};


export type UserOrderNotesArgs = {
  cursor?: InputMaybe<OrderNoteWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderNoteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderNoteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderNoteWhereInput>;
};


export type UserOrganizationsArgs = {
  cursor?: InputMaybe<OrganizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrganizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type UserPassesArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassWhereInput>;
};


export type UserPassportsArgs = {
  cursor?: InputMaybe<PassportWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassportScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PassportWhereInput>;
};


export type UserRedeemedInvitesArgs = {
  cursor?: InputMaybe<InviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<InviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type UserRequestedDisenrollmentsArgs = {
  cursor?: InputMaybe<MonitoringEnrollmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<MonitoringEnrollmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MonitoringEnrollmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type UserRoleAssignmentArgs = {
  cursor?: InputMaybe<RoleAssignmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleAssignmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleAssignmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleAssignmentWhereInput>;
};


export type UserSelfieArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserSentInvitesArgs = {
  cursor?: InputMaybe<InviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<InviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type UserShortUrlsArgs = {
  cursor?: InputMaybe<ShortUrlWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShortUrlScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShortUrlOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShortUrlWhereInput>;
};


export type UserSsnArgs = {
  where?: InputMaybe<HighlySensitiveIdentifierWhereInput>;
};


export type UserStateIdentificationCardsArgs = {
  cursor?: InputMaybe<StateIdentificationCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<StateIdentificationCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StateIdentificationCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};


export type UserVIdVouchersArgs = {
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  distinct?: InputMaybe<Array<VidVoucherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type UserWalletSharesArgs = {
  cursor?: InputMaybe<WalletShareWhereUniqueInput>;
  distinct?: InputMaybe<Array<WalletShareScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WalletShareOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WalletShareWhereInput>;
};

export type UserCount = {
  __typename?: 'UserCount';
  ResultRevision: Scalars['Int']['output'];
  addresses: Scalars['Int']['output'];
  apiKeyVerifications: Scalars['Int']['output'];
  apiKeys: Scalars['Int']['output'];
  appFeedbacks: Scalars['Int']['output'];
  beamInput: Scalars['Int']['output'];
  beamOutputs: Scalars['Int']['output'];
  biometricConsentAcceptances: Scalars['Int']['output'];
  createdOrders: Scalars['Int']['output'];
  createdOrganizations: Scalars['Int']['output'];
  createdVIDVouchers: Scalars['Int']['output'];
  credentials: Scalars['Int']['output'];
  disclosureAcceptances: Scalars['Int']['output'];
  disputes: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  identificationDocuments: Scalars['Int']['output'];
  identifiers: Scalars['Int']['output'];
  jobs: Scalars['Int']['output'];
  legacyCredentials: Scalars['Int']['output'];
  monitoringEnrollments: Scalars['Int']['output'];
  myOrders: Scalars['Int']['output'];
  names: Scalars['Int']['output'];
  orderNotes: Scalars['Int']['output'];
  organizations: Scalars['Int']['output'];
  passes: Scalars['Int']['output'];
  passports: Scalars['Int']['output'];
  redeemedInvites: Scalars['Int']['output'];
  requestedDisenrollments: Scalars['Int']['output'];
  roleAssignment: Scalars['Int']['output'];
  sentInvites: Scalars['Int']['output'];
  shortUrls: Scalars['Int']['output'];
  stateIdentificationCards: Scalars['Int']['output'];
  vIDVouchers: Scalars['Int']['output'];
  walletShares: Scalars['Int']['output'];
};


export type UserCountResultRevisionArgs = {
  where?: InputMaybe<ResultRevisionWhereInput>;
};


export type UserCountAddressesArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type UserCountApiKeyVerificationsArgs = {
  where?: InputMaybe<ApiKeyVerificationWhereInput>;
};


export type UserCountApiKeysArgs = {
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type UserCountAppFeedbacksArgs = {
  where?: InputMaybe<AppFeedbackWhereInput>;
};


export type UserCountBeamInputArgs = {
  where?: InputMaybe<BeamInputWhereInput>;
};


export type UserCountBeamOutputsArgs = {
  where?: InputMaybe<BeamOutputWhereInput>;
};


export type UserCountBiometricConsentAcceptancesArgs = {
  where?: InputMaybe<BiometricConsentAcceptanceWhereInput>;
};


export type UserCountCreatedOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCountCreatedOrganizationsArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type UserCountCreatedVidVouchersArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type UserCountCredentialsArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type UserCountDisclosureAcceptancesArgs = {
  where?: InputMaybe<DisclosureAcceptanceWhereInput>;
};


export type UserCountDisputesArgs = {
  where?: InputMaybe<DisputeWhereInput>;
};


export type UserCountFilesArgs = {
  where?: InputMaybe<FileWhereInput>;
};


export type UserCountIdentificationDocumentsArgs = {
  where?: InputMaybe<IdentificationDocumentWhereInput>;
};


export type UserCountIdentifiersArgs = {
  where?: InputMaybe<IdentifierWhereInput>;
};


export type UserCountJobsArgs = {
  where?: InputMaybe<JobWhereInput>;
};


export type UserCountLegacyCredentialsArgs = {
  where?: InputMaybe<LegacyCredentialWhereInput>;
};


export type UserCountMonitoringEnrollmentsArgs = {
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type UserCountMyOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type UserCountNamesArgs = {
  where?: InputMaybe<NameWhereInput>;
};


export type UserCountOrderNotesArgs = {
  where?: InputMaybe<OrderNoteWhereInput>;
};


export type UserCountOrganizationsArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type UserCountPassesArgs = {
  where?: InputMaybe<PassWhereInput>;
};


export type UserCountPassportsArgs = {
  where?: InputMaybe<PassportWhereInput>;
};


export type UserCountRedeemedInvitesArgs = {
  where?: InputMaybe<InviteWhereInput>;
};


export type UserCountRequestedDisenrollmentsArgs = {
  where?: InputMaybe<MonitoringEnrollmentWhereInput>;
};


export type UserCountRoleAssignmentArgs = {
  where?: InputMaybe<RoleAssignmentWhereInput>;
};


export type UserCountSentInvitesArgs = {
  where?: InputMaybe<InviteWhereInput>;
};


export type UserCountShortUrlsArgs = {
  where?: InputMaybe<ShortUrlWhereInput>;
};


export type UserCountStateIdentificationCardsArgs = {
  where?: InputMaybe<StateIdentificationCardWhereInput>;
};


export type UserCountVIdVouchersArgs = {
  where?: InputMaybe<VidVoucherWhereInput>;
};


export type UserCountWalletSharesArgs = {
  where?: InputMaybe<WalletShareWhereInput>;
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int']['output'];
  consumerReportingAgencyId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dob: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  jobTitle: Scalars['Int']['output'];
  legacySSN: Scalars['Int']['output'];
  onboardingStep: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  pushTokens: Scalars['Int']['output'];
  recentlySelectedOrgIds: Scalars['Int']['output'];
  selectedOrganizationId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type UserCreateNestedManyWithoutOrganizationsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutOrganizationsInput>>;
};

export type UserCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<UserCreateWithoutAddressesInput>;
};

export type UserCreateNestedOneWithoutApiKeyVerificationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutApiKeyVerificationsInput>;
  create?: InputMaybe<UserCreateWithoutApiKeyVerificationsInput>;
};

export type UserCreateNestedOneWithoutApiKeysInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutApiKeysInput>;
  create?: InputMaybe<UserCreateWithoutApiKeysInput>;
};

export type UserCreateNestedOneWithoutAppFeedbacksInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAppFeedbacksInput>;
  create?: InputMaybe<UserCreateWithoutAppFeedbacksInput>;
};

export type UserCreateNestedOneWithoutBackIdInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBackIdInput>;
  create?: InputMaybe<UserCreateWithoutBackIdInput>;
};

export type UserCreateNestedOneWithoutBeamInputInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBeamInputInput>;
  create?: InputMaybe<UserCreateWithoutBeamInputInput>;
};

export type UserCreateNestedOneWithoutBeamOutputsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBeamOutputsInput>;
  create?: InputMaybe<UserCreateWithoutBeamOutputsInput>;
};

export type UserCreateNestedOneWithoutBiometricConsentAcceptancesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBiometricConsentAcceptancesInput>;
  create?: InputMaybe<UserCreateWithoutBiometricConsentAcceptancesInput>;
};

export type UserCreateNestedOneWithoutCreatedOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedOrdersInput>;
  create?: InputMaybe<UserCreateWithoutCreatedOrdersInput>;
};

export type UserCreateNestedOneWithoutCreatedOrganizationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedOrganizationsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedOrganizationsInput>;
};

export type UserCreateNestedOneWithoutCreatedVidVouchersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedVidVouchersInput>;
  create?: InputMaybe<UserCreateWithoutCreatedVidVouchersInput>;
};

export type UserCreateNestedOneWithoutCredentialsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<UserCreateWithoutCredentialsInput>;
};

export type UserCreateNestedOneWithoutDisclosureAcceptancesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDisclosureAcceptancesInput>;
  create?: InputMaybe<UserCreateWithoutDisclosureAcceptancesInput>;
};

export type UserCreateNestedOneWithoutDisputesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<UserCreateWithoutDisputesInput>;
};

export type UserCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserCreateWithoutFilesInput>;
};

export type UserCreateNestedOneWithoutFrontIdInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFrontIdInput>;
  create?: InputMaybe<UserCreateWithoutFrontIdInput>;
};

export type UserCreateNestedOneWithoutIdentificationDocumentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutIdentificationDocumentsInput>;
  create?: InputMaybe<UserCreateWithoutIdentificationDocumentsInput>;
};

export type UserCreateNestedOneWithoutMonitoringEnrollmentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMonitoringEnrollmentsInput>;
  create?: InputMaybe<UserCreateWithoutMonitoringEnrollmentsInput>;
};

export type UserCreateNestedOneWithoutMyOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMyOrdersInput>;
  create?: InputMaybe<UserCreateWithoutMyOrdersInput>;
};

export type UserCreateNestedOneWithoutNamesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNamesInput>;
  create?: InputMaybe<UserCreateWithoutNamesInput>;
};

export type UserCreateNestedOneWithoutOrderNotesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderNotesInput>;
  create?: InputMaybe<UserCreateWithoutOrderNotesInput>;
};

export type UserCreateNestedOneWithoutPassesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPassesInput>;
  create?: InputMaybe<UserCreateWithoutPassesInput>;
};

export type UserCreateNestedOneWithoutPassportsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPassportsInput>;
  create?: InputMaybe<UserCreateWithoutPassportsInput>;
};

export type UserCreateNestedOneWithoutRedeemedInvitesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRedeemedInvitesInput>;
  create?: InputMaybe<UserCreateWithoutRedeemedInvitesInput>;
};

export type UserCreateNestedOneWithoutRequestedDisenrollmentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRequestedDisenrollmentsInput>;
  create?: InputMaybe<UserCreateWithoutRequestedDisenrollmentsInput>;
};

export type UserCreateNestedOneWithoutResultRevisionInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutResultRevisionInput>;
  create?: InputMaybe<UserCreateWithoutResultRevisionInput>;
};

export type UserCreateNestedOneWithoutRoleAssignmentInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRoleAssignmentInput>;
  create?: InputMaybe<UserCreateWithoutRoleAssignmentInput>;
};

export type UserCreateNestedOneWithoutSelfieInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSelfieInput>;
  create?: InputMaybe<UserCreateWithoutSelfieInput>;
};

export type UserCreateNestedOneWithoutSentInvitesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSentInvitesInput>;
  create?: InputMaybe<UserCreateWithoutSentInvitesInput>;
};

export type UserCreateNestedOneWithoutSsnInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSsnInput>;
  create?: InputMaybe<UserCreateWithoutSsnInput>;
};

export type UserCreateNestedOneWithoutStateIdentificationCardsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStateIdentificationCardsInput>;
  create?: InputMaybe<UserCreateWithoutStateIdentificationCardsInput>;
};

export type UserCreateNestedOneWithoutVidVouchersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutVidVouchersInput>;
  create?: InputMaybe<UserCreateWithoutVidVouchersInput>;
};

export type UserCreateNestedOneWithoutWalletSharesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutWalletSharesInput>;
  create?: InputMaybe<UserCreateWithoutWalletSharesInput>;
};

export type UserCreateOrConnectWithoutAddressesInput = {
  create: UserCreateWithoutAddressesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutApiKeyVerificationsInput = {
  create: UserCreateWithoutApiKeyVerificationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutApiKeysInput = {
  create: UserCreateWithoutApiKeysInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAppFeedbacksInput = {
  create: UserCreateWithoutAppFeedbacksInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBackIdInput = {
  create: UserCreateWithoutBackIdInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBeamInputInput = {
  create: UserCreateWithoutBeamInputInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBeamOutputsInput = {
  create: UserCreateWithoutBeamOutputsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutBiometricConsentAcceptancesInput = {
  create: UserCreateWithoutBiometricConsentAcceptancesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedOrdersInput = {
  create: UserCreateWithoutCreatedOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedOrganizationsInput = {
  create: UserCreateWithoutCreatedOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedVidVouchersInput = {
  create: UserCreateWithoutCreatedVidVouchersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCredentialsInput = {
  create: UserCreateWithoutCredentialsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDisclosureAcceptancesInput = {
  create: UserCreateWithoutDisclosureAcceptancesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDisputesInput = {
  create: UserCreateWithoutDisputesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFilesInput = {
  create: UserCreateWithoutFilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFrontIdInput = {
  create: UserCreateWithoutFrontIdInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutIdentificationDocumentsInput = {
  create: UserCreateWithoutIdentificationDocumentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLegacyCredentialsInput = {
  create: UserCreateWithoutLegacyCredentialsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMonitoringEnrollmentsInput = {
  create: UserCreateWithoutMonitoringEnrollmentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMyOrdersInput = {
  create: UserCreateWithoutMyOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNamesInput = {
  create: UserCreateWithoutNamesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrderNotesInput = {
  create: UserCreateWithoutOrderNotesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrganizationsInput = {
  create: UserCreateWithoutOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPassesInput = {
  create: UserCreateWithoutPassesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPassportsInput = {
  create: UserCreateWithoutPassportsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRedeemedInvitesInput = {
  create: UserCreateWithoutRedeemedInvitesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRequestedDisenrollmentsInput = {
  create: UserCreateWithoutRequestedDisenrollmentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutResultRevisionInput = {
  create: UserCreateWithoutResultRevisionInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutRoleAssignmentInput = {
  create: UserCreateWithoutRoleAssignmentInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSelfieInput = {
  create: UserCreateWithoutSelfieInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSentInvitesInput = {
  create: UserCreateWithoutSentInvitesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSsnInput = {
  create: UserCreateWithoutSsnInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutStateIdentificationCardsInput = {
  create: UserCreateWithoutStateIdentificationCardsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutVidVouchersInput = {
  create: UserCreateWithoutVidVouchersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutWalletSharesInput = {
  create: UserCreateWithoutWalletSharesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAddressesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutApiKeyVerificationsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutApiKeysInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutAppFeedbacksInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutBackIdInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutBeamInputInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutBeamOutputsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutBiometricConsentAcceptancesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCreatedOrdersInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCreatedOrganizationsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCreatedVidVouchersInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCredentialsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutDisclosureAcceptancesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutDisputesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutFilesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutFrontIdInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutIdentificationDocumentsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutLegacyCredentialsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMonitoringEnrollmentsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMyOrdersInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutNamesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutOrderNotesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutOrganizationsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutPassesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutPassportsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutRedeemedInvitesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutRequestedDisenrollmentsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutResultRevisionInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutRoleAssignmentInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSelfieInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSentInvitesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSsnInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutStateIdentificationCardsInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutVidVouchersInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  walletShares?: InputMaybe<WalletShareCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutWalletSharesInput = {
  ResultRevision?: InputMaybe<ResultRevisionCreateNestedManyWithoutRevisedByIdInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationCreateNestedManyWithoutUserInput>;
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  appFeedbacks?: InputMaybe<AppFeedbackCreateNestedManyWithoutUserInput>;
  backId?: InputMaybe<FileCreateNestedOneWithoutBackIdUserInput>;
  beamInput?: InputMaybe<BeamInputCreateNestedManyWithoutUserInput>;
  beamOutputs?: InputMaybe<BeamOutputCreateNestedManyWithoutUserInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceCreateNestedManyWithoutUserInput>;
  consumerReportingAgencyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdOrders?: InputMaybe<OrderCreateNestedManyWithoutCreatedByInput>;
  createdOrganizations?: InputMaybe<OrganizationCreateNestedManyWithoutCreatedByInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutCreatedByInput>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceCreateNestedManyWithoutUserInput>;
  disputes?: InputMaybe<DisputeCreateNestedManyWithoutSubmittedByInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  frontId?: InputMaybe<FileCreateNestedOneWithoutFrontIdUserInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentCreateNestedManyWithoutUserInput>;
  identifiers?: InputMaybe<IdentifierCreateNestedManyWithoutUserInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobs?: InputMaybe<JobCreateNestedManyWithoutUserInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialCreateNestedManyWithoutUserInput>;
  legacySSN?: InputMaybe<Scalars['String']['input']>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutUserInput>;
  myOrders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  names?: InputMaybe<NameCreateNestedManyWithoutUserInput>;
  onboardingStep?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<OrderNoteCreateNestedManyWithoutCreatedByInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMembersInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutUserInput>;
  passports?: InputMaybe<PassportCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pushTokens?: InputMaybe<UserCreatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserCreaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteCreateNestedManyWithoutRedeemedByInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentCreateNestedManyWithoutDisenrollmentRequestedByInput>;
  roleAssignment?: InputMaybe<RoleAssignmentCreateNestedManyWithoutUserInput>;
  selectedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  selfie?: InputMaybe<FileCreateNestedOneWithoutSelfieUserInput>;
  sentInvites?: InputMaybe<InviteCreateNestedManyWithoutSenderInput>;
  shortUrls?: InputMaybe<ShortUrlCreateNestedManyWithoutUserInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierCreateNestedOneWithoutUserInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vIDVouchers?: InputMaybe<VidVoucherCreateNestedManyWithoutUserInput>;
};

export type UserCreatepushTokensInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserCreaterecentlySelectedOrgIdsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  consumerReportingAgencyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  legacySSN?: Maybe<Scalars['String']['output']>;
  onboardingStep?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  selectedOrganizationId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  consumerReportingAgencyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  legacySSN?: Maybe<Scalars['String']['output']>;
  onboardingStep?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  selectedOrganizationId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserNullableScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  ResultRevision?: InputMaybe<ResultRevisionOrderByRelationAggregateInput>;
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationOrderByRelationAggregateInput>;
  apiKeys?: InputMaybe<ApiKeyOrderByRelationAggregateInput>;
  appFeedbacks?: InputMaybe<AppFeedbackOrderByRelationAggregateInput>;
  backId?: InputMaybe<FileOrderByWithRelationInput>;
  beamInput?: InputMaybe<BeamInputOrderByRelationAggregateInput>;
  beamOutputs?: InputMaybe<BeamOutputOrderByRelationAggregateInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceOrderByRelationAggregateInput>;
  consumerReportingAgencyId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdOrders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  createdOrganizations?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  createdVIDVouchers?: InputMaybe<VidVoucherOrderByRelationAggregateInput>;
  credentials?: InputMaybe<CredentialOrderByRelationAggregateInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceOrderByRelationAggregateInput>;
  disputes?: InputMaybe<DisputeOrderByRelationAggregateInput>;
  dob?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  frontId?: InputMaybe<FileOrderByWithRelationInput>;
  gender?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identificationDocuments?: InputMaybe<IdentificationDocumentOrderByRelationAggregateInput>;
  identifiers?: InputMaybe<IdentifierOrderByRelationAggregateInput>;
  jobTitle?: InputMaybe<SortOrderInput>;
  jobs?: InputMaybe<JobOrderByRelationAggregateInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialOrderByRelationAggregateInput>;
  legacySSN?: InputMaybe<SortOrderInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentOrderByRelationAggregateInput>;
  myOrders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  names?: InputMaybe<NameOrderByRelationAggregateInput>;
  onboardingStep?: InputMaybe<SortOrderInput>;
  orderNotes?: InputMaybe<OrderNoteOrderByRelationAggregateInput>;
  organizations?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  passes?: InputMaybe<PassOrderByRelationAggregateInput>;
  passports?: InputMaybe<PassportOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrderInput>;
  pushTokens?: InputMaybe<SortOrder>;
  recentlySelectedOrgIds?: InputMaybe<SortOrder>;
  redeemedInvites?: InputMaybe<InviteOrderByRelationAggregateInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentOrderByRelationAggregateInput>;
  roleAssignment?: InputMaybe<RoleAssignmentOrderByRelationAggregateInput>;
  selectedOrganizationId?: InputMaybe<SortOrderInput>;
  selfie?: InputMaybe<FileOrderByWithRelationInput>;
  sentInvites?: InputMaybe<InviteOrderByRelationAggregateInput>;
  shortUrls?: InputMaybe<ShortUrlOrderByRelationAggregateInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierOrderByWithRelationInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vIDVouchers?: InputMaybe<VidVoucherOrderByRelationAggregateInput>;
  walletShares?: InputMaybe<WalletShareOrderByRelationAggregateInput>;
};

export type UserPermissionAssignmentInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  role: RoleEnum;
};

export type UserPermissionEditor = {
  __typename?: 'UserPermissionEditor';
  assignableRoles: Array<RoleEnum>;
  canEditNames: Scalars['Boolean']['output'];
  canManageAllOrganizations: Scalars['Boolean']['output'];
  canManagePermissions: Scalars['Boolean']['output'];
  editableOrganizationIds: Array<Scalars['String']['output']>;
};

export type UserPermissionNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UserPermissionsInput = {
  assignments: Array<UserPermissionAssignmentInput>;
  name?: InputMaybe<UserPermissionNameInput>;
  removeAssignmentIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserPermissionsResult = {
  __typename?: 'UserPermissionsResult';
  userId: Scalars['String']['output'];
};

export enum UserPrimaryContactEnum {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum UserScalarFieldEnum {
  ConsumerReportingAgencyId = 'consumerReportingAgencyId',
  CreatedAt = 'createdAt',
  Dob = 'dob',
  Email = 'email',
  Gender = 'gender',
  Id = 'id',
  JobTitle = 'jobTitle',
  LegacySsn = 'legacySSN',
  OnboardingStep = 'onboardingStep',
  Phone = 'phone',
  PushTokens = 'pushTokens',
  RecentlySelectedOrgIds = 'recentlySelectedOrgIds',
  SelectedOrganizationId = 'selectedOrganizationId',
  UpdatedAt = 'updatedAt'
}

export type UserScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  consumerReportingAgencyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dob?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  jobTitle?: InputMaybe<StringNullableFilter>;
  legacySSN?: InputMaybe<StringNullableFilter>;
  onboardingStep?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pushTokens?: InputMaybe<StringNullableListFilter>;
  recentlySelectedOrgIds?: InputMaybe<StringNullableListFilter>;
  selectedOrganizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserUpdateInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutOrganizationsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutOrganizationsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutOrganizationsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutOrganizationsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutOrganizationsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutOrganizationsInput>>;
};

export type UserUpdateOneRequiredWithoutApiKeyVerificationsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutApiKeyVerificationsInput>;
  create?: InputMaybe<UserCreateWithoutApiKeyVerificationsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutApiKeyVerificationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutApiKeyVerificationsInput>;
};

export type UserUpdateOneRequiredWithoutAppFeedbacksNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAppFeedbacksInput>;
  create?: InputMaybe<UserCreateWithoutAppFeedbacksInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAppFeedbacksInput>;
  upsert?: InputMaybe<UserUpsertWithoutAppFeedbacksInput>;
};

export type UserUpdateOneRequiredWithoutBeamInputNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBeamInputInput>;
  create?: InputMaybe<UserCreateWithoutBeamInputInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutBeamInputInput>;
  upsert?: InputMaybe<UserUpsertWithoutBeamInputInput>;
};

export type UserUpdateOneRequiredWithoutBeamOutputsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBeamOutputsInput>;
  create?: InputMaybe<UserCreateWithoutBeamOutputsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutBeamOutputsInput>;
  upsert?: InputMaybe<UserUpsertWithoutBeamOutputsInput>;
};

export type UserUpdateOneRequiredWithoutBiometricConsentAcceptancesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBiometricConsentAcceptancesInput>;
  create?: InputMaybe<UserCreateWithoutBiometricConsentAcceptancesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutBiometricConsentAcceptancesInput>;
  upsert?: InputMaybe<UserUpsertWithoutBiometricConsentAcceptancesInput>;
};

export type UserUpdateOneRequiredWithoutCredentialsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<UserCreateWithoutCredentialsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCredentialsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCredentialsInput>;
};

export type UserUpdateOneRequiredWithoutDisclosureAcceptancesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDisclosureAcceptancesInput>;
  create?: InputMaybe<UserCreateWithoutDisclosureAcceptancesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutDisclosureAcceptancesInput>;
  upsert?: InputMaybe<UserUpsertWithoutDisclosureAcceptancesInput>;
};

export type UserUpdateOneRequiredWithoutMonitoringEnrollmentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMonitoringEnrollmentsInput>;
  create?: InputMaybe<UserCreateWithoutMonitoringEnrollmentsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutMonitoringEnrollmentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutMonitoringEnrollmentsInput>;
};

export type UserUpdateOneRequiredWithoutPassesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPassesInput>;
  create?: InputMaybe<UserCreateWithoutPassesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPassesInput>;
  upsert?: InputMaybe<UserUpsertWithoutPassesInput>;
};

export type UserUpdateOneRequiredWithoutResultRevisionNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutResultRevisionInput>;
  create?: InputMaybe<UserCreateWithoutResultRevisionInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutResultRevisionInput>;
  upsert?: InputMaybe<UserUpsertWithoutResultRevisionInput>;
};

export type UserUpdateOneRequiredWithoutRoleAssignmentNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRoleAssignmentInput>;
  create?: InputMaybe<UserCreateWithoutRoleAssignmentInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutRoleAssignmentInput>;
  upsert?: InputMaybe<UserUpsertWithoutRoleAssignmentInput>;
};

export type UserUpdateOneRequiredWithoutSentInvitesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSentInvitesInput>;
  create?: InputMaybe<UserCreateWithoutSentInvitesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutSentInvitesInput>;
  upsert?: InputMaybe<UserUpsertWithoutSentInvitesInput>;
};

export type UserUpdateOneRequiredWithoutWalletSharesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutWalletSharesInput>;
  create?: InputMaybe<UserCreateWithoutWalletSharesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutWalletSharesInput>;
  upsert?: InputMaybe<UserUpsertWithoutWalletSharesInput>;
};

export type UserUpdateOneWithoutAddressesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<UserCreateWithoutAddressesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: InputMaybe<UserUpsertWithoutAddressesInput>;
};

export type UserUpdateOneWithoutApiKeysNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutApiKeysInput>;
  create?: InputMaybe<UserCreateWithoutApiKeysInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutApiKeysInput>;
  upsert?: InputMaybe<UserUpsertWithoutApiKeysInput>;
};

export type UserUpdateOneWithoutBackIdNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutBackIdInput>;
  create?: InputMaybe<UserCreateWithoutBackIdInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutBackIdInput>;
  upsert?: InputMaybe<UserUpsertWithoutBackIdInput>;
};

export type UserUpdateOneWithoutCreatedOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedOrdersInput>;
  create?: InputMaybe<UserCreateWithoutCreatedOrdersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedOrdersInput>;
};

export type UserUpdateOneWithoutCreatedOrganizationsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedOrganizationsInput>;
  create?: InputMaybe<UserCreateWithoutCreatedOrganizationsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedOrganizationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedOrganizationsInput>;
};

export type UserUpdateOneWithoutCreatedVidVouchersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedVidVouchersInput>;
  create?: InputMaybe<UserCreateWithoutCreatedVidVouchersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedVidVouchersInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedVidVouchersInput>;
};

export type UserUpdateOneWithoutDisputesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDisputesInput>;
  create?: InputMaybe<UserCreateWithoutDisputesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutDisputesInput>;
  upsert?: InputMaybe<UserUpsertWithoutDisputesInput>;
};

export type UserUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserCreateWithoutFilesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutFilesInput>;
};

export type UserUpdateOneWithoutFrontIdNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFrontIdInput>;
  create?: InputMaybe<UserCreateWithoutFrontIdInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFrontIdInput>;
  upsert?: InputMaybe<UserUpsertWithoutFrontIdInput>;
};

export type UserUpdateOneWithoutIdentificationDocumentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutIdentificationDocumentsInput>;
  create?: InputMaybe<UserCreateWithoutIdentificationDocumentsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutIdentificationDocumentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutIdentificationDocumentsInput>;
};

export type UserUpdateOneWithoutLegacyCredentialsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLegacyCredentialsInput>;
  create?: InputMaybe<UserCreateWithoutLegacyCredentialsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutLegacyCredentialsInput>;
  upsert?: InputMaybe<UserUpsertWithoutLegacyCredentialsInput>;
};

export type UserUpdateOneWithoutMyOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMyOrdersInput>;
  create?: InputMaybe<UserCreateWithoutMyOrdersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutMyOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutMyOrdersInput>;
};

export type UserUpdateOneWithoutNamesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNamesInput>;
  create?: InputMaybe<UserCreateWithoutNamesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNamesInput>;
  upsert?: InputMaybe<UserUpsertWithoutNamesInput>;
};

export type UserUpdateOneWithoutOrderNotesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderNotesInput>;
  create?: InputMaybe<UserCreateWithoutOrderNotesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrderNotesInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrderNotesInput>;
};

export type UserUpdateOneWithoutPassportsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPassportsInput>;
  create?: InputMaybe<UserCreateWithoutPassportsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPassportsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPassportsInput>;
};

export type UserUpdateOneWithoutRedeemedInvitesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRedeemedInvitesInput>;
  create?: InputMaybe<UserCreateWithoutRedeemedInvitesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutRedeemedInvitesInput>;
  upsert?: InputMaybe<UserUpsertWithoutRedeemedInvitesInput>;
};

export type UserUpdateOneWithoutRequestedDisenrollmentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutRequestedDisenrollmentsInput>;
  create?: InputMaybe<UserCreateWithoutRequestedDisenrollmentsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutRequestedDisenrollmentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutRequestedDisenrollmentsInput>;
};

export type UserUpdateOneWithoutSelfieNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSelfieInput>;
  create?: InputMaybe<UserCreateWithoutSelfieInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutSelfieInput>;
  upsert?: InputMaybe<UserUpsertWithoutSelfieInput>;
};

export type UserUpdateOneWithoutSsnNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSsnInput>;
  create?: InputMaybe<UserCreateWithoutSsnInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutSsnInput>;
  upsert?: InputMaybe<UserUpsertWithoutSsnInput>;
};

export type UserUpdateOneWithoutStateIdentificationCardsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStateIdentificationCardsInput>;
  create?: InputMaybe<UserCreateWithoutStateIdentificationCardsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutStateIdentificationCardsInput>;
  upsert?: InputMaybe<UserUpsertWithoutStateIdentificationCardsInput>;
};

export type UserUpdateOneWithoutVidVouchersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutVidVouchersInput>;
  create?: InputMaybe<UserCreateWithoutVidVouchersInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutVidVouchersInput>;
  upsert?: InputMaybe<UserUpsertWithoutVidVouchersInput>;
};

export type UserUpdateToOneWithWhereWithoutAddressesInput = {
  data: UserUpdateWithoutAddressesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutApiKeyVerificationsInput = {
  data: UserUpdateWithoutApiKeyVerificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutApiKeysInput = {
  data: UserUpdateWithoutApiKeysInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutAppFeedbacksInput = {
  data: UserUpdateWithoutAppFeedbacksInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBackIdInput = {
  data: UserUpdateWithoutBackIdInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBeamInputInput = {
  data: UserUpdateWithoutBeamInputInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBeamOutputsInput = {
  data: UserUpdateWithoutBeamOutputsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutBiometricConsentAcceptancesInput = {
  data: UserUpdateWithoutBiometricConsentAcceptancesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedOrdersInput = {
  data: UserUpdateWithoutCreatedOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedOrganizationsInput = {
  data: UserUpdateWithoutCreatedOrganizationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedVidVouchersInput = {
  data: UserUpdateWithoutCreatedVidVouchersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCredentialsInput = {
  data: UserUpdateWithoutCredentialsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutDisclosureAcceptancesInput = {
  data: UserUpdateWithoutDisclosureAcceptancesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutDisputesInput = {
  data: UserUpdateWithoutDisputesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutFilesInput = {
  data: UserUpdateWithoutFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutFrontIdInput = {
  data: UserUpdateWithoutFrontIdInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutIdentificationDocumentsInput = {
  data: UserUpdateWithoutIdentificationDocumentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLegacyCredentialsInput = {
  data: UserUpdateWithoutLegacyCredentialsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMonitoringEnrollmentsInput = {
  data: UserUpdateWithoutMonitoringEnrollmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMyOrdersInput = {
  data: UserUpdateWithoutMyOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNamesInput = {
  data: UserUpdateWithoutNamesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrderNotesInput = {
  data: UserUpdateWithoutOrderNotesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPassesInput = {
  data: UserUpdateWithoutPassesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPassportsInput = {
  data: UserUpdateWithoutPassportsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRedeemedInvitesInput = {
  data: UserUpdateWithoutRedeemedInvitesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRequestedDisenrollmentsInput = {
  data: UserUpdateWithoutRequestedDisenrollmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutResultRevisionInput = {
  data: UserUpdateWithoutResultRevisionInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutRoleAssignmentInput = {
  data: UserUpdateWithoutRoleAssignmentInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSelfieInput = {
  data: UserUpdateWithoutSelfieInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSentInvitesInput = {
  data: UserUpdateWithoutSentInvitesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSsnInput = {
  data: UserUpdateWithoutSsnInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutStateIdentificationCardsInput = {
  data: UserUpdateWithoutStateIdentificationCardsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutVidVouchersInput = {
  data: UserUpdateWithoutVidVouchersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutWalletSharesInput = {
  data: UserUpdateWithoutWalletSharesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutOrganizationsInput = {
  data: UserUpdateWithoutOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAddressesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutApiKeyVerificationsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutApiKeysInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutAppFeedbacksInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutBackIdInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutBeamInputInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutBeamOutputsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutBiometricConsentAcceptancesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedOrdersInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedOrganizationsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCreatedVidVouchersInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCredentialsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutDisclosureAcceptancesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutDisputesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutFilesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutFrontIdInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutIdentificationDocumentsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutLegacyCredentialsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMonitoringEnrollmentsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMyOrdersInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutNamesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutOrderNotesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutOrganizationsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutPassesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutPassportsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutRedeemedInvitesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutRequestedDisenrollmentsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutResultRevisionInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutRoleAssignmentInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSelfieInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSentInvitesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSsnInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutStateIdentificationCardsInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutVidVouchersInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  walletShares?: InputMaybe<WalletShareUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutWalletSharesInput = {
  ResultRevision?: InputMaybe<ResultRevisionUpdateManyWithoutRevisedByIdNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationUpdateManyWithoutUserNestedInput>;
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  appFeedbacks?: InputMaybe<AppFeedbackUpdateManyWithoutUserNestedInput>;
  backId?: InputMaybe<FileUpdateOneWithoutBackIdUserNestedInput>;
  beamInput?: InputMaybe<BeamInputUpdateManyWithoutUserNestedInput>;
  beamOutputs?: InputMaybe<BeamOutputUpdateManyWithoutUserNestedInput>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceUpdateManyWithoutUserNestedInput>;
  consumerReportingAgencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdOrders?: InputMaybe<OrderUpdateManyWithoutCreatedByNestedInput>;
  createdOrganizations?: InputMaybe<OrganizationUpdateManyWithoutCreatedByNestedInput>;
  createdVIDVouchers?: InputMaybe<VIdVoucherUpdateManyWithoutCreatedByNestedInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceUpdateManyWithoutUserNestedInput>;
  disputes?: InputMaybe<DisputeUpdateManyWithoutSubmittedByNestedInput>;
  dob?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  frontId?: InputMaybe<FileUpdateOneWithoutFrontIdUserNestedInput>;
  gender?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identificationDocuments?: InputMaybe<IdentificationDocumentUpdateManyWithoutUserNestedInput>;
  identifiers?: InputMaybe<IdentifierUpdateManyWithoutUserNestedInput>;
  jobTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  jobs?: InputMaybe<JobUpdateManyWithoutUserNestedInput>;
  legacyCredentials?: InputMaybe<LegacyCredentialUpdateManyWithoutUserNestedInput>;
  legacySSN?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutUserNestedInput>;
  myOrders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  names?: InputMaybe<NameUpdateManyWithoutUserNestedInput>;
  onboardingStep?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderNotes?: InputMaybe<OrderNoteUpdateManyWithoutCreatedByNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMembersNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutUserNestedInput>;
  passports?: InputMaybe<PassportUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pushTokens?: InputMaybe<UserUpdatepushTokensInput>;
  recentlySelectedOrgIds?: InputMaybe<UserUpdaterecentlySelectedOrgIdsInput>;
  redeemedInvites?: InputMaybe<InviteUpdateManyWithoutRedeemedByNestedInput>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentUpdateManyWithoutDisenrollmentRequestedByNestedInput>;
  roleAssignment?: InputMaybe<RoleAssignmentUpdateManyWithoutUserNestedInput>;
  selectedOrganizationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfie?: InputMaybe<FileUpdateOneWithoutSelfieUserNestedInput>;
  sentInvites?: InputMaybe<InviteUpdateManyWithoutSenderNestedInput>;
  shortUrls?: InputMaybe<ShortUrlUpdateManyWithoutUserNestedInput>;
  ssn?: InputMaybe<HighlySensitiveIdentifierUpdateOneWithoutUserNestedInput>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vIDVouchers?: InputMaybe<VidVoucherUpdateManyWithoutUserNestedInput>;
};

export type UserUpdatepushTokensInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpdaterecentlySelectedOrgIdsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpsertWithWhereUniqueWithoutOrganizationsInput = {
  create: UserCreateWithoutOrganizationsInput;
  update: UserUpdateWithoutOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAddressesInput = {
  create: UserCreateWithoutAddressesInput;
  update: UserUpdateWithoutAddressesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutApiKeyVerificationsInput = {
  create: UserCreateWithoutApiKeyVerificationsInput;
  update: UserUpdateWithoutApiKeyVerificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutApiKeysInput = {
  create: UserCreateWithoutApiKeysInput;
  update: UserUpdateWithoutApiKeysInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutAppFeedbacksInput = {
  create: UserCreateWithoutAppFeedbacksInput;
  update: UserUpdateWithoutAppFeedbacksInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutBackIdInput = {
  create: UserCreateWithoutBackIdInput;
  update: UserUpdateWithoutBackIdInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutBeamInputInput = {
  create: UserCreateWithoutBeamInputInput;
  update: UserUpdateWithoutBeamInputInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutBeamOutputsInput = {
  create: UserCreateWithoutBeamOutputsInput;
  update: UserUpdateWithoutBeamOutputsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutBiometricConsentAcceptancesInput = {
  create: UserCreateWithoutBiometricConsentAcceptancesInput;
  update: UserUpdateWithoutBiometricConsentAcceptancesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedOrdersInput = {
  create: UserCreateWithoutCreatedOrdersInput;
  update: UserUpdateWithoutCreatedOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedOrganizationsInput = {
  create: UserCreateWithoutCreatedOrganizationsInput;
  update: UserUpdateWithoutCreatedOrganizationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedVidVouchersInput = {
  create: UserCreateWithoutCreatedVidVouchersInput;
  update: UserUpdateWithoutCreatedVidVouchersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCredentialsInput = {
  create: UserCreateWithoutCredentialsInput;
  update: UserUpdateWithoutCredentialsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutDisclosureAcceptancesInput = {
  create: UserCreateWithoutDisclosureAcceptancesInput;
  update: UserUpdateWithoutDisclosureAcceptancesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutDisputesInput = {
  create: UserCreateWithoutDisputesInput;
  update: UserUpdateWithoutDisputesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutFilesInput = {
  create: UserCreateWithoutFilesInput;
  update: UserUpdateWithoutFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutFrontIdInput = {
  create: UserCreateWithoutFrontIdInput;
  update: UserUpdateWithoutFrontIdInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutIdentificationDocumentsInput = {
  create: UserCreateWithoutIdentificationDocumentsInput;
  update: UserUpdateWithoutIdentificationDocumentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutLegacyCredentialsInput = {
  create: UserCreateWithoutLegacyCredentialsInput;
  update: UserUpdateWithoutLegacyCredentialsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMonitoringEnrollmentsInput = {
  create: UserCreateWithoutMonitoringEnrollmentsInput;
  update: UserUpdateWithoutMonitoringEnrollmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMyOrdersInput = {
  create: UserCreateWithoutMyOrdersInput;
  update: UserUpdateWithoutMyOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNamesInput = {
  create: UserCreateWithoutNamesInput;
  update: UserUpdateWithoutNamesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrderNotesInput = {
  create: UserCreateWithoutOrderNotesInput;
  update: UserUpdateWithoutOrderNotesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPassesInput = {
  create: UserCreateWithoutPassesInput;
  update: UserUpdateWithoutPassesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPassportsInput = {
  create: UserCreateWithoutPassportsInput;
  update: UserUpdateWithoutPassportsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutRedeemedInvitesInput = {
  create: UserCreateWithoutRedeemedInvitesInput;
  update: UserUpdateWithoutRedeemedInvitesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutRequestedDisenrollmentsInput = {
  create: UserCreateWithoutRequestedDisenrollmentsInput;
  update: UserUpdateWithoutRequestedDisenrollmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutResultRevisionInput = {
  create: UserCreateWithoutResultRevisionInput;
  update: UserUpdateWithoutResultRevisionInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutRoleAssignmentInput = {
  create: UserCreateWithoutRoleAssignmentInput;
  update: UserUpdateWithoutRoleAssignmentInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutSelfieInput = {
  create: UserCreateWithoutSelfieInput;
  update: UserUpdateWithoutSelfieInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutSentInvitesInput = {
  create: UserCreateWithoutSentInvitesInput;
  update: UserUpdateWithoutSentInvitesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutSsnInput = {
  create: UserCreateWithoutSsnInput;
  update: UserUpdateWithoutSsnInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutStateIdentificationCardsInput = {
  create: UserCreateWithoutStateIdentificationCardsInput;
  update: UserUpdateWithoutStateIdentificationCardsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutVidVouchersInput = {
  create: UserCreateWithoutVidVouchersInput;
  update: UserUpdateWithoutVidVouchersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutWalletSharesInput = {
  create: UserCreateWithoutWalletSharesInput;
  update: UserUpdateWithoutWalletSharesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  ResultRevision?: InputMaybe<ResultRevisionListRelationFilter>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationListRelationFilter>;
  apiKeys?: InputMaybe<ApiKeyListRelationFilter>;
  appFeedbacks?: InputMaybe<AppFeedbackListRelationFilter>;
  backId?: InputMaybe<FileNullableScalarRelationFilter>;
  beamInput?: InputMaybe<BeamInputListRelationFilter>;
  beamOutputs?: InputMaybe<BeamOutputListRelationFilter>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceListRelationFilter>;
  consumerReportingAgencyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdOrders?: InputMaybe<OrderListRelationFilter>;
  createdOrganizations?: InputMaybe<OrganizationListRelationFilter>;
  createdVIDVouchers?: InputMaybe<VidVoucherListRelationFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceListRelationFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  dob?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  frontId?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identificationDocuments?: InputMaybe<IdentificationDocumentListRelationFilter>;
  identifiers?: InputMaybe<IdentifierListRelationFilter>;
  jobTitle?: InputMaybe<StringNullableFilter>;
  jobs?: InputMaybe<JobListRelationFilter>;
  legacyCredentials?: InputMaybe<LegacyCredentialListRelationFilter>;
  legacySSN?: InputMaybe<StringNullableFilter>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  myOrders?: InputMaybe<OrderListRelationFilter>;
  names?: InputMaybe<NameListRelationFilter>;
  onboardingStep?: InputMaybe<StringNullableFilter>;
  orderNotes?: InputMaybe<OrderNoteListRelationFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  passes?: InputMaybe<PassListRelationFilter>;
  passports?: InputMaybe<PassportListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pushTokens?: InputMaybe<StringNullableListFilter>;
  recentlySelectedOrgIds?: InputMaybe<StringNullableListFilter>;
  redeemedInvites?: InputMaybe<InviteListRelationFilter>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  roleAssignment?: InputMaybe<RoleAssignmentListRelationFilter>;
  selectedOrganizationId?: InputMaybe<StringNullableFilter>;
  selfie?: InputMaybe<FileNullableScalarRelationFilter>;
  sentInvites?: InputMaybe<InviteListRelationFilter>;
  shortUrls?: InputMaybe<ShortUrlListRelationFilter>;
  ssn?: InputMaybe<HighlySensitiveIdentifierNullableScalarRelationFilter>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vIDVouchers?: InputMaybe<VidVoucherListRelationFilter>;
  walletShares?: InputMaybe<WalletShareListRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  ResultRevision?: InputMaybe<ResultRevisionListRelationFilter>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  apiKeyVerifications?: InputMaybe<ApiKeyVerificationListRelationFilter>;
  apiKeys?: InputMaybe<ApiKeyListRelationFilter>;
  appFeedbacks?: InputMaybe<AppFeedbackListRelationFilter>;
  backId?: InputMaybe<FileNullableScalarRelationFilter>;
  beamInput?: InputMaybe<BeamInputListRelationFilter>;
  beamOutputs?: InputMaybe<BeamOutputListRelationFilter>;
  biometricConsentAcceptances?: InputMaybe<BiometricConsentAcceptanceListRelationFilter>;
  consumerReportingAgencyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdOrders?: InputMaybe<OrderListRelationFilter>;
  createdOrganizations?: InputMaybe<OrganizationListRelationFilter>;
  createdVIDVouchers?: InputMaybe<VidVoucherListRelationFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  disclosureAcceptances?: InputMaybe<DisclosureAcceptanceListRelationFilter>;
  disputes?: InputMaybe<DisputeListRelationFilter>;
  dob?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileListRelationFilter>;
  frontId?: InputMaybe<FileNullableScalarRelationFilter>;
  gender?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identificationDocuments?: InputMaybe<IdentificationDocumentListRelationFilter>;
  identifiers?: InputMaybe<IdentifierListRelationFilter>;
  jobTitle?: InputMaybe<StringNullableFilter>;
  jobs?: InputMaybe<JobListRelationFilter>;
  legacyCredentials?: InputMaybe<LegacyCredentialListRelationFilter>;
  legacySSN?: InputMaybe<StringNullableFilter>;
  monitoringEnrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  myOrders?: InputMaybe<OrderListRelationFilter>;
  names?: InputMaybe<NameListRelationFilter>;
  onboardingStep?: InputMaybe<StringNullableFilter>;
  orderNotes?: InputMaybe<OrderNoteListRelationFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  passes?: InputMaybe<PassListRelationFilter>;
  passports?: InputMaybe<PassportListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pushTokens?: InputMaybe<StringNullableListFilter>;
  recentlySelectedOrgIds?: InputMaybe<StringNullableListFilter>;
  redeemedInvites?: InputMaybe<InviteListRelationFilter>;
  requestedDisenrollments?: InputMaybe<MonitoringEnrollmentListRelationFilter>;
  roleAssignment?: InputMaybe<RoleAssignmentListRelationFilter>;
  selectedOrganizationId?: InputMaybe<StringNullableFilter>;
  selfie?: InputMaybe<FileNullableScalarRelationFilter>;
  sentInvites?: InputMaybe<InviteListRelationFilter>;
  shortUrls?: InputMaybe<ShortUrlListRelationFilter>;
  ssn?: InputMaybe<HighlySensitiveIdentifierNullableScalarRelationFilter>;
  stateIdentificationCards?: InputMaybe<StateIdentificationCardListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vIDVouchers?: InputMaybe<VidVoucherListRelationFilter>;
  walletShares?: InputMaybe<WalletShareListRelationFilter>;
};

export type VidVoucher = {
  __typename?: 'VIDVoucher';
  _count?: Maybe<VidVoucherCount>;
  apiKeys: Array<ApiKey>;
  branchIOShortCode?: Maybe<Scalars['String']['output']>;
  clientMetadata?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fileNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invite?: Maybe<Invite>;
  inviteId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  onSubmitReturnUrl?: Maybe<Scalars['String']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  origin?: Maybe<VoucherOrigin>;
  packageSet: PackageSet;
  packageSetId: Scalars['String']['output'];
  passType?: Maybe<PassType>;
  passTypeId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postbackUrl?: Maybe<Scalars['String']['output']>;
  primaryContactMethod?: Maybe<UserPrimaryContactEnum>;
  reorderReason?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: VoucherStatusEnum;
  suffix?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type VidVoucherApiKeysArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type VidVoucherCreatedByArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type VidVoucherInviteArgs = {
  where?: InputMaybe<InviteWhereInput>;
};


export type VidVoucherOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type VidVoucherPassTypeArgs = {
  where?: InputMaybe<PassTypeWhereInput>;
};


export type VidVoucherUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type VidVoucherCount = {
  __typename?: 'VIDVoucherCount';
  apiKeys: Scalars['Int']['output'];
};


export type VidVoucherCountApiKeysArgs = {
  where?: InputMaybe<ApiKeyWhereInput>;
};

export type VidVoucherCountAggregate = {
  __typename?: 'VIDVoucherCountAggregate';
  _all: Scalars['Int']['output'];
  branchIOShortCode: Scalars['Int']['output'];
  clientMetadata: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdById: Scalars['Int']['output'];
  dateOfBirth: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  expiresAt: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inviteId: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  middleName: Scalars['Int']['output'];
  onSubmitReturnUrl: Scalars['Int']['output'];
  optOutReason: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  origin: Scalars['Int']['output'];
  packageSetId: Scalars['Int']['output'];
  passTypeId: Scalars['Int']['output'];
  phoneNumber: Scalars['Int']['output'];
  postbackUrl: Scalars['Int']['output'];
  primaryContactMethod: Scalars['Int']['output'];
  reorderReason: Scalars['Int']['output'];
  startedAt: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  suffix: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type VidVoucherCreateManyCreatedByInput = {
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSetId: Scalars['String']['input'];
  passTypeId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VidVoucherCreateManyCreatedByInputEnvelope = {
  data: Array<VidVoucherCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VidVoucherCreateManyInviteInput = {
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSetId: Scalars['String']['input'];
  passTypeId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VidVoucherCreateManyInviteInputEnvelope = {
  data: Array<VidVoucherCreateManyInviteInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VidVoucherCreateManyPackageSetInput = {
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  passTypeId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VidVoucherCreateManyPackageSetInputEnvelope = {
  data: Array<VidVoucherCreateManyPackageSetInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VidVoucherCreateManyPassTypeInput = {
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSetId: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type VidVoucherCreateManyPassTypeInputEnvelope = {
  data: Array<VidVoucherCreateManyPassTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VidVoucherCreateManyUserInput = {
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSetId: Scalars['String']['input'];
  passTypeId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type VidVoucherCreateManyUserInputEnvelope = {
  data: Array<VidVoucherCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VidVoucherCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyCreatedByInputEnvelope>;
};

export type VidVoucherCreateNestedManyWithoutInviteInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutInviteInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutInviteInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyInviteInputEnvelope>;
};

export type VidVoucherCreateNestedManyWithoutPackageSetInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutPackageSetInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutPackageSetInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyPackageSetInputEnvelope>;
};

export type VidVoucherCreateNestedManyWithoutPassTypeInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutPassTypeInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutPassTypeInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyPassTypeInputEnvelope>;
};

export type VidVoucherCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutUserInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyUserInputEnvelope>;
};

export type VidVoucherCreateNestedOneWithoutApiKeysInput = {
  connect?: InputMaybe<VidVoucherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VidVoucherCreateOrConnectWithoutApiKeysInput>;
  create?: InputMaybe<VidVoucherCreateWithoutApiKeysInput>;
};

export type VidVoucherCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<VidVoucherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VidVoucherCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<VidVoucherCreateWithoutOrderInput>;
};

export type VidVoucherCreateOrConnectWithoutApiKeysInput = {
  create: VidVoucherCreateWithoutApiKeysInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateOrConnectWithoutCreatedByInput = {
  create: VidVoucherCreateWithoutCreatedByInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateOrConnectWithoutInviteInput = {
  create: VidVoucherCreateWithoutInviteInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateOrConnectWithoutOrderInput = {
  create: VidVoucherCreateWithoutOrderInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateOrConnectWithoutPackageSetInput = {
  create: VidVoucherCreateWithoutPackageSetInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateOrConnectWithoutPassTypeInput = {
  create: VidVoucherCreateWithoutPassTypeInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateOrConnectWithoutUserInput = {
  create: VidVoucherCreateWithoutUserInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherCreateWithoutApiKeysInput = {
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedVidVouchersInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateNestedOneWithoutVidVouchersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutVidVoucherInput>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSet: PackageSetCreateNestedOneWithoutVidVouchersInput;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutVouchersInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutVidVouchersInput>;
};

export type VidVoucherCreateWithoutCreatedByInput = {
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutVoucherInput>;
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateNestedOneWithoutVidVouchersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutVidVoucherInput>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSet: PackageSetCreateNestedOneWithoutVidVouchersInput;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutVouchersInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutVidVouchersInput>;
};

export type VidVoucherCreateWithoutInviteInput = {
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutVoucherInput>;
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedVidVouchersInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutVidVoucherInput>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSet: PackageSetCreateNestedOneWithoutVidVouchersInput;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutVouchersInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutVidVouchersInput>;
};

export type VidVoucherCreateWithoutOrderInput = {
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutVoucherInput>;
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedVidVouchersInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateNestedOneWithoutVidVouchersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSet: PackageSetCreateNestedOneWithoutVidVouchersInput;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutVouchersInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutVidVouchersInput>;
};

export type VidVoucherCreateWithoutPackageSetInput = {
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutVoucherInput>;
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedVidVouchersInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateNestedOneWithoutVidVouchersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutVidVoucherInput>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutVouchersInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutVidVouchersInput>;
};

export type VidVoucherCreateWithoutPassTypeInput = {
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutVoucherInput>;
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedVidVouchersInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateNestedOneWithoutVidVouchersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutVidVoucherInput>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSet: PackageSetCreateNestedOneWithoutVidVouchersInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutVidVouchersInput>;
};

export type VidVoucherCreateWithoutUserInput = {
  apiKeys?: InputMaybe<ApiKeyCreateNestedManyWithoutVoucherInput>;
  branchIOShortCode?: InputMaybe<Scalars['String']['input']>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedVidVouchersInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteCreateNestedOneWithoutVidVouchersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onSubmitReturnUrl?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutVidVoucherInput>;
  organizationId: Scalars['String']['input'];
  origin?: InputMaybe<VoucherOrigin>;
  packageSet: PackageSetCreateNestedOneWithoutVidVouchersInput;
  passType?: InputMaybe<PassTypeCreateNestedOneWithoutVouchersInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postbackUrl?: InputMaybe<Scalars['String']['input']>;
  primaryContactMethod?: InputMaybe<UserPrimaryContactEnum>;
  reorderReason?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<VoucherStatusEnum>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type VidVoucherListRelationFilter = {
  every?: InputMaybe<VidVoucherWhereInput>;
  none?: InputMaybe<VidVoucherWhereInput>;
  some?: InputMaybe<VidVoucherWhereInput>;
};

export type VidVoucherMaxAggregate = {
  __typename?: 'VIDVoucherMaxAggregate';
  branchIOShortCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inviteId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  onSubmitReturnUrl?: Maybe<Scalars['String']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<VoucherOrigin>;
  packageSetId?: Maybe<Scalars['String']['output']>;
  passTypeId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postbackUrl?: Maybe<Scalars['String']['output']>;
  primaryContactMethod?: Maybe<UserPrimaryContactEnum>;
  reorderReason?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status?: Maybe<VoucherStatusEnum>;
  suffix?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VidVoucherMinAggregate = {
  __typename?: 'VIDVoucherMinAggregate';
  branchIOShortCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inviteId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  onSubmitReturnUrl?: Maybe<Scalars['String']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<VoucherOrigin>;
  packageSetId?: Maybe<Scalars['String']['output']>;
  passTypeId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postbackUrl?: Maybe<Scalars['String']['output']>;
  primaryContactMethod?: Maybe<UserPrimaryContactEnum>;
  reorderReason?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status?: Maybe<VoucherStatusEnum>;
  suffix?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type VidVoucherNullableScalarRelationFilter = {
  is?: InputMaybe<VidVoucherWhereInput>;
  isNot?: InputMaybe<VidVoucherWhereInput>;
};

export type VidVoucherOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VidVoucherOrderByWithRelationInput = {
  apiKeys?: InputMaybe<ApiKeyOrderByRelationAggregateInput>;
  branchIOShortCode?: InputMaybe<SortOrderInput>;
  clientMetadata?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  dateOfBirth?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invite?: InputMaybe<InviteOrderByWithRelationInput>;
  inviteId?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  middleName?: InputMaybe<SortOrderInput>;
  onSubmitReturnUrl?: InputMaybe<SortOrderInput>;
  optOutReason?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  organizationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrderInput>;
  packageSet?: InputMaybe<PackageSetOrderByWithRelationInput>;
  packageSetId?: InputMaybe<SortOrder>;
  passType?: InputMaybe<PassTypeOrderByWithRelationInput>;
  passTypeId?: InputMaybe<SortOrderInput>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  postbackUrl?: InputMaybe<SortOrderInput>;
  primaryContactMethod?: InputMaybe<SortOrderInput>;
  reorderReason?: InputMaybe<SortOrderInput>;
  startedAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  suffix?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum VidVoucherScalarFieldEnum {
  BranchIoShortCode = 'branchIOShortCode',
  ClientMetadata = 'clientMetadata',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  DateOfBirth = 'dateOfBirth',
  Email = 'email',
  ExpiresAt = 'expiresAt',
  FirstName = 'firstName',
  Id = 'id',
  InviteId = 'inviteId',
  LastName = 'lastName',
  MiddleName = 'middleName',
  OnSubmitReturnUrl = 'onSubmitReturnUrl',
  OptOutReason = 'optOutReason',
  OrderId = 'orderId',
  OrganizationId = 'organizationId',
  Origin = 'origin',
  PackageSetId = 'packageSetId',
  PassTypeId = 'passTypeId',
  PhoneNumber = 'phoneNumber',
  PostbackUrl = 'postbackUrl',
  PrimaryContactMethod = 'primaryContactMethod',
  ReorderReason = 'reorderReason',
  StartedAt = 'startedAt',
  Status = 'status',
  Suffix = 'suffix',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type VidVoucherScalarWhereInput = {
  AND?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  NOT?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  OR?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  branchIOShortCode?: InputMaybe<StringNullableFilter>;
  clientMetadata?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  dateOfBirth?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inviteId?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  middleName?: InputMaybe<StringNullableFilter>;
  onSubmitReturnUrl?: InputMaybe<StringNullableFilter>;
  optOutReason?: InputMaybe<StringNullableFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  origin?: InputMaybe<EnumVoucherOriginNullableFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  passTypeId?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  postbackUrl?: InputMaybe<StringNullableFilter>;
  primaryContactMethod?: InputMaybe<EnumUserPrimaryContactEnumNullableFilter>;
  reorderReason?: InputMaybe<StringNullableFilter>;
  startedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumVoucherStatusEnumFilter>;
  suffix?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type VidVoucherUpdateInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VidVoucherUpdateManyMutationInput = {
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VidVoucherUpdateManyWithWhereWithoutInviteInput = {
  data: VidVoucherUpdateManyMutationInput;
  where: VidVoucherScalarWhereInput;
};

export type VidVoucherUpdateManyWithWhereWithoutPackageSetInput = {
  data: VidVoucherUpdateManyMutationInput;
  where: VidVoucherScalarWhereInput;
};

export type VidVoucherUpdateManyWithWhereWithoutPassTypeInput = {
  data: VidVoucherUpdateManyMutationInput;
  where: VidVoucherScalarWhereInput;
};

export type VidVoucherUpdateManyWithWhereWithoutUserInput = {
  data: VidVoucherUpdateManyMutationInput;
  where: VidVoucherScalarWhereInput;
};

export type VidVoucherUpdateManyWithoutInviteNestedInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutInviteInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutInviteInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyInviteInputEnvelope>;
  delete?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  set?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  update?: InputMaybe<Array<VidVoucherUpdateWithWhereUniqueWithoutInviteInput>>;
  updateMany?: InputMaybe<Array<VidVoucherUpdateManyWithWhereWithoutInviteInput>>;
  upsert?: InputMaybe<Array<VidVoucherUpsertWithWhereUniqueWithoutInviteInput>>;
};

export type VidVoucherUpdateManyWithoutPackageSetNestedInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutPackageSetInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutPackageSetInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyPackageSetInputEnvelope>;
  delete?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  set?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  update?: InputMaybe<Array<VidVoucherUpdateWithWhereUniqueWithoutPackageSetInput>>;
  updateMany?: InputMaybe<Array<VidVoucherUpdateManyWithWhereWithoutPackageSetInput>>;
  upsert?: InputMaybe<Array<VidVoucherUpsertWithWhereUniqueWithoutPackageSetInput>>;
};

export type VidVoucherUpdateManyWithoutPassTypeNestedInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutPassTypeInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutPassTypeInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyPassTypeInputEnvelope>;
  delete?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  set?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  update?: InputMaybe<Array<VidVoucherUpdateWithWhereUniqueWithoutPassTypeInput>>;
  updateMany?: InputMaybe<Array<VidVoucherUpdateManyWithWhereWithoutPassTypeInput>>;
  upsert?: InputMaybe<Array<VidVoucherUpsertWithWhereUniqueWithoutPassTypeInput>>;
};

export type VidVoucherUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutUserInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  set?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  update?: InputMaybe<Array<VidVoucherUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<VidVoucherUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<VidVoucherUpsertWithWhereUniqueWithoutUserInput>>;
};

export type VidVoucherUpdateOneWithoutApiKeysNestedInput = {
  connect?: InputMaybe<VidVoucherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VidVoucherCreateOrConnectWithoutApiKeysInput>;
  create?: InputMaybe<VidVoucherCreateWithoutApiKeysInput>;
  delete?: InputMaybe<VidVoucherWhereInput>;
  disconnect?: InputMaybe<VidVoucherWhereInput>;
  update?: InputMaybe<VidVoucherUpdateToOneWithWhereWithoutApiKeysInput>;
  upsert?: InputMaybe<VidVoucherUpsertWithoutApiKeysInput>;
};

export type VidVoucherUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<VidVoucherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VidVoucherCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<VidVoucherCreateWithoutOrderInput>;
  delete?: InputMaybe<VidVoucherWhereInput>;
  disconnect?: InputMaybe<VidVoucherWhereInput>;
  update?: InputMaybe<VidVoucherUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<VidVoucherUpsertWithoutOrderInput>;
};

export type VidVoucherUpdateToOneWithWhereWithoutApiKeysInput = {
  data: VidVoucherUpdateWithoutApiKeysInput;
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type VidVoucherUpdateToOneWithWhereWithoutOrderInput = {
  data: VidVoucherUpdateWithoutOrderInput;
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type VidVoucherUpdateWithWhereUniqueWithoutInviteInput = {
  data: VidVoucherUpdateWithoutInviteInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpdateWithWhereUniqueWithoutPackageSetInput = {
  data: VidVoucherUpdateWithoutPackageSetInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpdateWithWhereUniqueWithoutPassTypeInput = {
  data: VidVoucherUpdateWithoutPassTypeInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpdateWithWhereUniqueWithoutUserInput = {
  data: VidVoucherUpdateWithoutUserInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpdateWithoutApiKeysInput = {
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VidVoucherUpdateWithoutInviteInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VidVoucherUpdateWithoutOrderInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VidVoucherUpdateWithoutPackageSetInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VidVoucherUpdateWithoutPassTypeInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VidVoucherUpdateWithoutUserInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedVidVouchersNestedInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VidVoucherUpsertWithWhereUniqueWithoutInviteInput = {
  create: VidVoucherCreateWithoutInviteInput;
  update: VidVoucherUpdateWithoutInviteInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpsertWithWhereUniqueWithoutPackageSetInput = {
  create: VidVoucherCreateWithoutPackageSetInput;
  update: VidVoucherUpdateWithoutPackageSetInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpsertWithWhereUniqueWithoutPassTypeInput = {
  create: VidVoucherCreateWithoutPassTypeInput;
  update: VidVoucherUpdateWithoutPassTypeInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpsertWithWhereUniqueWithoutUserInput = {
  create: VidVoucherCreateWithoutUserInput;
  update: VidVoucherUpdateWithoutUserInput;
  where: VidVoucherWhereUniqueInput;
};

export type VidVoucherUpsertWithoutApiKeysInput = {
  create: VidVoucherCreateWithoutApiKeysInput;
  update: VidVoucherUpdateWithoutApiKeysInput;
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type VidVoucherUpsertWithoutOrderInput = {
  create: VidVoucherCreateWithoutOrderInput;
  update: VidVoucherUpdateWithoutOrderInput;
  where?: InputMaybe<VidVoucherWhereInput>;
};

export type VidVoucherWhereInput = {
  AND?: InputMaybe<Array<VidVoucherWhereInput>>;
  NOT?: InputMaybe<Array<VidVoucherWhereInput>>;
  OR?: InputMaybe<Array<VidVoucherWhereInput>>;
  apiKeys?: InputMaybe<ApiKeyListRelationFilter>;
  branchIOShortCode?: InputMaybe<StringNullableFilter>;
  clientMetadata?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  dateOfBirth?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invite?: InputMaybe<InviteNullableScalarRelationFilter>;
  inviteId?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  middleName?: InputMaybe<StringNullableFilter>;
  onSubmitReturnUrl?: InputMaybe<StringNullableFilter>;
  optOutReason?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  origin?: InputMaybe<EnumVoucherOriginNullableFilter>;
  packageSet?: InputMaybe<PackageSetScalarRelationFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  passType?: InputMaybe<PassTypeNullableScalarRelationFilter>;
  passTypeId?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  postbackUrl?: InputMaybe<StringNullableFilter>;
  primaryContactMethod?: InputMaybe<EnumUserPrimaryContactEnumNullableFilter>;
  reorderReason?: InputMaybe<StringNullableFilter>;
  startedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumVoucherStatusEnumFilter>;
  suffix?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type VidVoucherWhereUniqueInput = {
  AND?: InputMaybe<Array<VidVoucherWhereInput>>;
  NOT?: InputMaybe<Array<VidVoucherWhereInput>>;
  OR?: InputMaybe<Array<VidVoucherWhereInput>>;
  apiKeys?: InputMaybe<ApiKeyListRelationFilter>;
  branchIOShortCode?: InputMaybe<StringNullableFilter>;
  clientMetadata?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<StringNullableFilter>;
  dateOfBirth?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<InviteNullableScalarRelationFilter>;
  inviteId?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  middleName?: InputMaybe<StringNullableFilter>;
  onSubmitReturnUrl?: InputMaybe<StringNullableFilter>;
  optOutReason?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<StringFilter>;
  origin?: InputMaybe<EnumVoucherOriginNullableFilter>;
  packageSet?: InputMaybe<PackageSetScalarRelationFilter>;
  packageSetId?: InputMaybe<StringFilter>;
  passType?: InputMaybe<PassTypeNullableScalarRelationFilter>;
  passTypeId?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  postbackUrl?: InputMaybe<StringNullableFilter>;
  primaryContactMethod?: InputMaybe<EnumUserPrimaryContactEnumNullableFilter>;
  reorderReason?: InputMaybe<StringNullableFilter>;
  startedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumVoucherStatusEnumFilter>;
  suffix?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type Vendor = {
  __typename?: 'Vendor';
  _count?: Maybe<VendorCount>;
  configSchema?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secretSchema?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type VendorConfiguration = {
  __typename?: 'VendorConfiguration';
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  package: PackageSet;
  packageId: Scalars['String']['output'];
  secret?: Maybe<Secret>;
  updatedAt: Scalars['DateTimeISO']['output'];
  vendor: Vendor;
  vendorId: Scalars['String']['output'];
};


export type VendorConfigurationSecretArgs = {
  where?: InputMaybe<SecretWhereInput>;
};

export type VendorConfigurationCreateInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutVendorConfigurationsInput;
  package: PackageSetCreateNestedOneWithoutVendorConfigurationsInput;
  secret?: InputMaybe<SecretCreateNestedOneWithoutVendorConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor: VendorCreateNestedOneWithoutVendorConfigurationsInput;
};

export type VendorConfigurationCreateManyOrganizationInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorId: Scalars['String']['input'];
};

export type VendorConfigurationCreateManyOrganizationInputEnvelope = {
  data: Array<VendorConfigurationCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorConfigurationCreateManyPackageInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorId: Scalars['String']['input'];
};

export type VendorConfigurationCreateManyPackageInputEnvelope = {
  data: Array<VendorConfigurationCreateManyPackageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorConfigurationCreateManyVendorInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type VendorConfigurationCreateManyVendorInputEnvelope = {
  data: Array<VendorConfigurationCreateManyVendorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorConfigurationCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorConfigurationCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<VendorConfigurationCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<VendorConfigurationCreateManyOrganizationInputEnvelope>;
};

export type VendorConfigurationCreateNestedManyWithoutPackageInput = {
  connect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorConfigurationCreateOrConnectWithoutPackageInput>>;
  create?: InputMaybe<Array<VendorConfigurationCreateWithoutPackageInput>>;
  createMany?: InputMaybe<VendorConfigurationCreateManyPackageInputEnvelope>;
};

export type VendorConfigurationCreateNestedManyWithoutVendorInput = {
  connect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorConfigurationCreateOrConnectWithoutVendorInput>>;
  create?: InputMaybe<Array<VendorConfigurationCreateWithoutVendorInput>>;
  createMany?: InputMaybe<VendorConfigurationCreateManyVendorInputEnvelope>;
};

export type VendorConfigurationCreateNestedOneWithoutSecretInput = {
  connect?: InputMaybe<VendorConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VendorConfigurationCreateOrConnectWithoutSecretInput>;
  create?: InputMaybe<VendorConfigurationCreateWithoutSecretInput>;
};

export type VendorConfigurationCreateOrConnectWithoutOrganizationInput = {
  create: VendorConfigurationCreateWithoutOrganizationInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationCreateOrConnectWithoutPackageInput = {
  create: VendorConfigurationCreateWithoutPackageInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationCreateOrConnectWithoutSecretInput = {
  create: VendorConfigurationCreateWithoutSecretInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationCreateOrConnectWithoutVendorInput = {
  create: VendorConfigurationCreateWithoutVendorInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationCreateWithoutOrganizationInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  package: PackageSetCreateNestedOneWithoutVendorConfigurationsInput;
  secret?: InputMaybe<SecretCreateNestedOneWithoutVendorConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor: VendorCreateNestedOneWithoutVendorConfigurationsInput;
};

export type VendorConfigurationCreateWithoutPackageInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutVendorConfigurationsInput;
  secret?: InputMaybe<SecretCreateNestedOneWithoutVendorConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor: VendorCreateNestedOneWithoutVendorConfigurationsInput;
};

export type VendorConfigurationCreateWithoutSecretInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutVendorConfigurationsInput;
  package: PackageSetCreateNestedOneWithoutVendorConfigurationsInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendor: VendorCreateNestedOneWithoutVendorConfigurationsInput;
};

export type VendorConfigurationCreateWithoutVendorInput = {
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization: OrganizationCreateNestedOneWithoutVendorConfigurationsInput;
  package: PackageSetCreateNestedOneWithoutVendorConfigurationsInput;
  secret?: InputMaybe<SecretCreateNestedOneWithoutVendorConfigurationInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type VendorConfigurationListRelationFilter = {
  every?: InputMaybe<VendorConfigurationWhereInput>;
  none?: InputMaybe<VendorConfigurationWhereInput>;
  some?: InputMaybe<VendorConfigurationWhereInput>;
};

export type VendorConfigurationNullableScalarRelationFilter = {
  is?: InputMaybe<VendorConfigurationWhereInput>;
  isNot?: InputMaybe<VendorConfigurationWhereInput>;
};

export type VendorConfigurationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VendorConfigurationOrderByWithRelationInput = {
  config?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  package?: InputMaybe<PackageSetOrderByWithRelationInput>;
  packageId?: InputMaybe<SortOrder>;
  secret?: InputMaybe<SecretOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<VendorOrderByWithRelationInput>;
  vendorId?: InputMaybe<SortOrder>;
};

export enum VendorConfigurationScalarFieldEnum {
  Config = 'config',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  PackageId = 'packageId',
  UpdatedAt = 'updatedAt',
  VendorId = 'vendorId'
}

export type VendorConfigurationScalarWhereInput = {
  AND?: InputMaybe<Array<VendorConfigurationScalarWhereInput>>;
  NOT?: InputMaybe<Array<VendorConfigurationScalarWhereInput>>;
  OR?: InputMaybe<Array<VendorConfigurationScalarWhereInput>>;
  config?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  packageId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type VendorConfigurationUpdateInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  package?: InputMaybe<PackageSetUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  secret?: InputMaybe<SecretUpdateOneWithoutVendorConfigurationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
};

export type VendorConfigurationUpdateManyMutationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VendorConfigurationUpdateManyWithWhereWithoutOrganizationInput = {
  data: VendorConfigurationUpdateManyMutationInput;
  where: VendorConfigurationScalarWhereInput;
};

export type VendorConfigurationUpdateManyWithWhereWithoutPackageInput = {
  data: VendorConfigurationUpdateManyMutationInput;
  where: VendorConfigurationScalarWhereInput;
};

export type VendorConfigurationUpdateManyWithWhereWithoutVendorInput = {
  data: VendorConfigurationUpdateManyMutationInput;
  where: VendorConfigurationScalarWhereInput;
};

export type VendorConfigurationUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorConfigurationCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<VendorConfigurationCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<VendorConfigurationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VendorConfigurationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  set?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  update?: InputMaybe<Array<VendorConfigurationUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<VendorConfigurationUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<VendorConfigurationUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type VendorConfigurationUpdateManyWithoutPackageNestedInput = {
  connect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorConfigurationCreateOrConnectWithoutPackageInput>>;
  create?: InputMaybe<Array<VendorConfigurationCreateWithoutPackageInput>>;
  createMany?: InputMaybe<VendorConfigurationCreateManyPackageInputEnvelope>;
  delete?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VendorConfigurationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  set?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  update?: InputMaybe<Array<VendorConfigurationUpdateWithWhereUniqueWithoutPackageInput>>;
  updateMany?: InputMaybe<Array<VendorConfigurationUpdateManyWithWhereWithoutPackageInput>>;
  upsert?: InputMaybe<Array<VendorConfigurationUpsertWithWhereUniqueWithoutPackageInput>>;
};

export type VendorConfigurationUpdateManyWithoutVendorNestedInput = {
  connect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorConfigurationCreateOrConnectWithoutVendorInput>>;
  create?: InputMaybe<Array<VendorConfigurationCreateWithoutVendorInput>>;
  createMany?: InputMaybe<VendorConfigurationCreateManyVendorInputEnvelope>;
  delete?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VendorConfigurationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  set?: InputMaybe<Array<VendorConfigurationWhereUniqueInput>>;
  update?: InputMaybe<Array<VendorConfigurationUpdateWithWhereUniqueWithoutVendorInput>>;
  updateMany?: InputMaybe<Array<VendorConfigurationUpdateManyWithWhereWithoutVendorInput>>;
  upsert?: InputMaybe<Array<VendorConfigurationUpsertWithWhereUniqueWithoutVendorInput>>;
};

export type VendorConfigurationUpdateOneWithoutSecretNestedInput = {
  connect?: InputMaybe<VendorConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VendorConfigurationCreateOrConnectWithoutSecretInput>;
  create?: InputMaybe<VendorConfigurationCreateWithoutSecretInput>;
  delete?: InputMaybe<VendorConfigurationWhereInput>;
  disconnect?: InputMaybe<VendorConfigurationWhereInput>;
  update?: InputMaybe<VendorConfigurationUpdateToOneWithWhereWithoutSecretInput>;
  upsert?: InputMaybe<VendorConfigurationUpsertWithoutSecretInput>;
};

export type VendorConfigurationUpdateToOneWithWhereWithoutSecretInput = {
  data: VendorConfigurationUpdateWithoutSecretInput;
  where?: InputMaybe<VendorConfigurationWhereInput>;
};

export type VendorConfigurationUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: VendorConfigurationUpdateWithoutOrganizationInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationUpdateWithWhereUniqueWithoutPackageInput = {
  data: VendorConfigurationUpdateWithoutPackageInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationUpdateWithWhereUniqueWithoutVendorInput = {
  data: VendorConfigurationUpdateWithoutVendorInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationUpdateWithoutOrganizationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  package?: InputMaybe<PackageSetUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  secret?: InputMaybe<SecretUpdateOneWithoutVendorConfigurationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
};

export type VendorConfigurationUpdateWithoutPackageInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  secret?: InputMaybe<SecretUpdateOneWithoutVendorConfigurationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
};

export type VendorConfigurationUpdateWithoutSecretInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  package?: InputMaybe<PackageSetUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<VendorUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
};

export type VendorConfigurationUpdateWithoutVendorInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  package?: InputMaybe<PackageSetUpdateOneRequiredWithoutVendorConfigurationsNestedInput>;
  secret?: InputMaybe<SecretUpdateOneWithoutVendorConfigurationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VendorConfigurationUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: VendorConfigurationCreateWithoutOrganizationInput;
  update: VendorConfigurationUpdateWithoutOrganizationInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationUpsertWithWhereUniqueWithoutPackageInput = {
  create: VendorConfigurationCreateWithoutPackageInput;
  update: VendorConfigurationUpdateWithoutPackageInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationUpsertWithWhereUniqueWithoutVendorInput = {
  create: VendorConfigurationCreateWithoutVendorInput;
  update: VendorConfigurationUpdateWithoutVendorInput;
  where: VendorConfigurationWhereUniqueInput;
};

export type VendorConfigurationUpsertWithoutSecretInput = {
  create: VendorConfigurationCreateWithoutSecretInput;
  update: VendorConfigurationUpdateWithoutSecretInput;
  where?: InputMaybe<VendorConfigurationWhereInput>;
};

export type VendorConfigurationWhereInput = {
  AND?: InputMaybe<Array<VendorConfigurationWhereInput>>;
  NOT?: InputMaybe<Array<VendorConfigurationWhereInput>>;
  OR?: InputMaybe<Array<VendorConfigurationWhereInput>>;
  config?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  package?: InputMaybe<PackageSetScalarRelationFilter>;
  packageId?: InputMaybe<StringFilter>;
  secret?: InputMaybe<SecretNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendor?: InputMaybe<VendorScalarRelationFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type VendorConfigurationWhereUniqueInput = {
  AND?: InputMaybe<Array<VendorConfigurationWhereInput>>;
  NOT?: InputMaybe<Array<VendorConfigurationWhereInput>>;
  OR?: InputMaybe<Array<VendorConfigurationWhereInput>>;
  config?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  package?: InputMaybe<PackageSetScalarRelationFilter>;
  packageId?: InputMaybe<StringFilter>;
  secret?: InputMaybe<SecretNullableScalarRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendor?: InputMaybe<VendorScalarRelationFilter>;
  vendorId?: InputMaybe<StringFilter>;
};

export type VendorCount = {
  __typename?: 'VendorCount';
  Results: Scalars['Int']['output'];
  vendorConfigurations: Scalars['Int']['output'];
};


export type VendorCountResultsArgs = {
  where?: InputMaybe<ResultWhereInput>;
};


export type VendorCountVendorConfigurationsArgs = {
  where?: InputMaybe<VendorConfigurationWhereInput>;
};

export type VendorCreateNestedOneWithoutResultsInput = {
  connect?: InputMaybe<VendorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VendorCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<VendorCreateWithoutResultsInput>;
};

export type VendorCreateNestedOneWithoutVendorConfigurationsInput = {
  connect?: InputMaybe<VendorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VendorCreateOrConnectWithoutVendorConfigurationsInput>;
  create?: InputMaybe<VendorCreateWithoutVendorConfigurationsInput>;
};

export type VendorCreateOrConnectWithoutResultsInput = {
  create: VendorCreateWithoutResultsInput;
  where: VendorWhereUniqueInput;
};

export type VendorCreateOrConnectWithoutVendorConfigurationsInput = {
  create: VendorCreateWithoutVendorConfigurationsInput;
  where: VendorWhereUniqueInput;
};

export type VendorCreateWithoutResultsInput = {
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secretSchema?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  vendorConfigurations?: InputMaybe<VendorConfigurationCreateNestedManyWithoutVendorInput>;
};

export type VendorCreateWithoutVendorConfigurationsInput = {
  Results?: InputMaybe<ResultCreateNestedManyWithoutVendorInput>;
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secretSchema?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type VendorNullableScalarRelationFilter = {
  is?: InputMaybe<VendorWhereInput>;
  isNot?: InputMaybe<VendorWhereInput>;
};

export type VendorOrderByWithRelationInput = {
  Results?: InputMaybe<ResultOrderByRelationAggregateInput>;
  configSchema?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  secretSchema?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendorConfigurations?: InputMaybe<VendorConfigurationOrderByRelationAggregateInput>;
};

export type VendorScalarRelationFilter = {
  is?: InputMaybe<VendorWhereInput>;
  isNot?: InputMaybe<VendorWhereInput>;
};

export type VendorUpdateOneRequiredWithoutVendorConfigurationsNestedInput = {
  connect?: InputMaybe<VendorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VendorCreateOrConnectWithoutVendorConfigurationsInput>;
  create?: InputMaybe<VendorCreateWithoutVendorConfigurationsInput>;
  update?: InputMaybe<VendorUpdateToOneWithWhereWithoutVendorConfigurationsInput>;
  upsert?: InputMaybe<VendorUpsertWithoutVendorConfigurationsInput>;
};

export type VendorUpdateOneWithoutResultsNestedInput = {
  connect?: InputMaybe<VendorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VendorCreateOrConnectWithoutResultsInput>;
  create?: InputMaybe<VendorCreateWithoutResultsInput>;
  delete?: InputMaybe<VendorWhereInput>;
  disconnect?: InputMaybe<VendorWhereInput>;
  update?: InputMaybe<VendorUpdateToOneWithWhereWithoutResultsInput>;
  upsert?: InputMaybe<VendorUpsertWithoutResultsInput>;
};

export type VendorUpdateToOneWithWhereWithoutResultsInput = {
  data: VendorUpdateWithoutResultsInput;
  where?: InputMaybe<VendorWhereInput>;
};

export type VendorUpdateToOneWithWhereWithoutVendorConfigurationsInput = {
  data: VendorUpdateWithoutVendorConfigurationsInput;
  where?: InputMaybe<VendorWhereInput>;
};

export type VendorUpdateWithoutResultsInput = {
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  secretSchema?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorConfigurations?: InputMaybe<VendorConfigurationUpdateManyWithoutVendorNestedInput>;
};

export type VendorUpdateWithoutVendorConfigurationsInput = {
  Results?: InputMaybe<ResultUpdateManyWithoutVendorNestedInput>;
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  secretSchema?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VendorUpsertWithoutResultsInput = {
  create: VendorCreateWithoutResultsInput;
  update: VendorUpdateWithoutResultsInput;
  where?: InputMaybe<VendorWhereInput>;
};

export type VendorUpsertWithoutVendorConfigurationsInput = {
  create: VendorCreateWithoutVendorConfigurationsInput;
  update: VendorUpdateWithoutVendorConfigurationsInput;
  where?: InputMaybe<VendorWhereInput>;
};

export type VendorWhereInput = {
  AND?: InputMaybe<Array<VendorWhereInput>>;
  NOT?: InputMaybe<Array<VendorWhereInput>>;
  OR?: InputMaybe<Array<VendorWhereInput>>;
  Results?: InputMaybe<ResultListRelationFilter>;
  configSchema?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  secretSchema?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorConfigurations?: InputMaybe<VendorConfigurationListRelationFilter>;
};

export type VendorWhereUniqueInput = {
  AND?: InputMaybe<Array<VendorWhereInput>>;
  NOT?: InputMaybe<Array<VendorWhereInput>>;
  OR?: InputMaybe<Array<VendorWhereInput>>;
  Results?: InputMaybe<ResultListRelationFilter>;
  configSchema?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secretSchema?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendorConfigurations?: InputMaybe<VendorConfigurationListRelationFilter>;
};

export enum VoucherOrigin {
  Cognition = 'COGNITION',
  Cortex = 'CORTEX',
  Mycelium = 'MYCELIUM'
}

export enum VoucherStatusEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  OptOut = 'OPT_OUT',
  Pending = 'PENDING',
  Started = 'STARTED'
}

export type WalletShare = {
  __typename?: 'WalletShare';
  createdAt: Scalars['DateTimeISO']['output'];
  credentialId: Scalars['String']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  tokenHash: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type WalletShareCreateManyCredentialInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expiresAt: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tokenHash: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  userId: Scalars['String']['input'];
};

export type WalletShareCreateManyCredentialInputEnvelope = {
  data: Array<WalletShareCreateManyCredentialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WalletShareCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credentialId: Scalars['String']['input'];
  expiresAt: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tokenHash: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type WalletShareCreateManyUserInputEnvelope = {
  data: Array<WalletShareCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WalletShareCreateNestedManyWithoutCredentialInput = {
  connect?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletShareCreateOrConnectWithoutCredentialInput>>;
  create?: InputMaybe<Array<WalletShareCreateWithoutCredentialInput>>;
  createMany?: InputMaybe<WalletShareCreateManyCredentialInputEnvelope>;
};

export type WalletShareCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletShareCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<WalletShareCreateWithoutUserInput>>;
  createMany?: InputMaybe<WalletShareCreateManyUserInputEnvelope>;
};

export type WalletShareCreateOrConnectWithoutCredentialInput = {
  create: WalletShareCreateWithoutCredentialInput;
  where: WalletShareWhereUniqueInput;
};

export type WalletShareCreateOrConnectWithoutUserInput = {
  create: WalletShareCreateWithoutUserInput;
  where: WalletShareWhereUniqueInput;
};

export type WalletShareCreateWithoutCredentialInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  expiresAt: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tokenHash: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  user: UserCreateNestedOneWithoutWalletSharesInput;
};

export type WalletShareCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  credential: CredentialCreateNestedOneWithoutWalletSharesInput;
  expiresAt: Scalars['DateTimeISO']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  revokedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  tokenHash: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type WalletShareListRelationFilter = {
  every?: InputMaybe<WalletShareWhereInput>;
  none?: InputMaybe<WalletShareWhereInput>;
  some?: InputMaybe<WalletShareWhereInput>;
};

export type WalletShareOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WalletShareOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  credentialId?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  revokedAt?: InputMaybe<SortOrderInput>;
  tokenHash?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum WalletShareScalarFieldEnum {
  CreatedAt = 'createdAt',
  CredentialId = 'credentialId',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  RevokedAt = 'revokedAt',
  TokenHash = 'tokenHash',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type WalletShareScalarWhereInput = {
  AND?: InputMaybe<Array<WalletShareScalarWhereInput>>;
  NOT?: InputMaybe<Array<WalletShareScalarWhereInput>>;
  OR?: InputMaybe<Array<WalletShareScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialId?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  revokedAt?: InputMaybe<DateTimeNullableFilter>;
  tokenHash?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type WalletShareUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tokenHash?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WalletShareUpdateManyWithWhereWithoutCredentialInput = {
  data: WalletShareUpdateManyMutationInput;
  where: WalletShareScalarWhereInput;
};

export type WalletShareUpdateManyWithWhereWithoutUserInput = {
  data: WalletShareUpdateManyMutationInput;
  where: WalletShareScalarWhereInput;
};

export type WalletShareUpdateManyWithoutCredentialNestedInput = {
  connect?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletShareCreateOrConnectWithoutCredentialInput>>;
  create?: InputMaybe<Array<WalletShareCreateWithoutCredentialInput>>;
  createMany?: InputMaybe<WalletShareCreateManyCredentialInputEnvelope>;
  delete?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletShareScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletShareUpdateWithWhereUniqueWithoutCredentialInput>>;
  updateMany?: InputMaybe<Array<WalletShareUpdateManyWithWhereWithoutCredentialInput>>;
  upsert?: InputMaybe<Array<WalletShareUpsertWithWhereUniqueWithoutCredentialInput>>;
};

export type WalletShareUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletShareCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<WalletShareCreateWithoutUserInput>>;
  createMany?: InputMaybe<WalletShareCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletShareScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletShareWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletShareUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<WalletShareUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<WalletShareUpsertWithWhereUniqueWithoutUserInput>>;
};

export type WalletShareUpdateWithWhereUniqueWithoutCredentialInput = {
  data: WalletShareUpdateWithoutCredentialInput;
  where: WalletShareWhereUniqueInput;
};

export type WalletShareUpdateWithWhereUniqueWithoutUserInput = {
  data: WalletShareUpdateWithoutUserInput;
  where: WalletShareWhereUniqueInput;
};

export type WalletShareUpdateWithoutCredentialInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tokenHash?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutWalletSharesNestedInput>;
};

export type WalletShareUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneRequiredWithoutWalletSharesNestedInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  revokedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tokenHash?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WalletShareUpsertWithWhereUniqueWithoutCredentialInput = {
  create: WalletShareCreateWithoutCredentialInput;
  update: WalletShareUpdateWithoutCredentialInput;
  where: WalletShareWhereUniqueInput;
};

export type WalletShareUpsertWithWhereUniqueWithoutUserInput = {
  create: WalletShareCreateWithoutUserInput;
  update: WalletShareUpdateWithoutUserInput;
  where: WalletShareWhereUniqueInput;
};

export type WalletShareWhereInput = {
  AND?: InputMaybe<Array<WalletShareWhereInput>>;
  NOT?: InputMaybe<Array<WalletShareWhereInput>>;
  OR?: InputMaybe<Array<WalletShareWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialScalarRelationFilter>;
  credentialId?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  revokedAt?: InputMaybe<DateTimeNullableFilter>;
  tokenHash?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type WalletShareWhereUniqueInput = {
  AND?: InputMaybe<Array<WalletShareWhereInput>>;
  NOT?: InputMaybe<Array<WalletShareWhereInput>>;
  OR?: InputMaybe<Array<WalletShareWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialScalarRelationFilter>;
  credentialId?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  revokedAt?: InputMaybe<DateTimeNullableFilter>;
  tokenHash?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Webhook = {
  __typename?: 'Webhook';
  _count?: Maybe<WebhookCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  global: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  internal: Scalars['Boolean']['output'];
  orders: Array<Order>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  url: Scalars['String']['output'];
};


export type WebhookOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};

export type WebhookCount = {
  __typename?: 'WebhookCount';
  orders: Scalars['Int']['output'];
};


export type WebhookCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};

export type WebhookCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutWebhookInput>;
  organization: OrganizationCreateNestedOneWithoutWebhooksInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type WebhookCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type WebhookCreateManyOrganizationInputEnvelope = {
  data: Array<WebhookCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebhookCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<WebhookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WebhookCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<WebhookCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<WebhookCreateManyOrganizationInputEnvelope>;
};

export type WebhookCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<WebhookWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WebhookCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<WebhookCreateWithoutOrdersInput>;
};

export type WebhookCreateOrConnectWithoutOrdersInput = {
  create: WebhookCreateWithoutOrdersInput;
  where: WebhookWhereUniqueInput;
};

export type WebhookCreateOrConnectWithoutOrganizationInput = {
  create: WebhookCreateWithoutOrganizationInput;
  where: WebhookWhereUniqueInput;
};

export type WebhookCreateWithoutOrdersInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  organization: OrganizationCreateNestedOneWithoutWebhooksInput;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type WebhookCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutWebhookInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type WebhookListRelationFilter = {
  every?: InputMaybe<WebhookWhereInput>;
  none?: InputMaybe<WebhookWhereInput>;
  some?: InputMaybe<WebhookWhereInput>;
};

export type WebhookNullableScalarRelationFilter = {
  is?: InputMaybe<WebhookWhereInput>;
  isNot?: InputMaybe<WebhookWhereInput>;
};

export type WebhookOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WebhookOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  global?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internal?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export enum WebhookScalarFieldEnum {
  CreatedAt = 'createdAt',
  Global = 'global',
  Id = 'id',
  Internal = 'internal',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type WebhookScalarWhereInput = {
  AND?: InputMaybe<Array<WebhookScalarWhereInput>>;
  NOT?: InputMaybe<Array<WebhookScalarWhereInput>>;
  OR?: InputMaybe<Array<WebhookScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  global?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  internal?: InputMaybe<BoolFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type WebhookUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  global?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutWebhookNestedInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutWebhooksNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WebhookUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  global?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WebhookUpdateManyWithWhereWithoutOrganizationInput = {
  data: WebhookUpdateManyMutationInput;
  where: WebhookScalarWhereInput;
};

export type WebhookUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<WebhookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WebhookCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<WebhookCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<WebhookCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<WebhookWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WebhookScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WebhookWhereUniqueInput>>;
  set?: InputMaybe<Array<WebhookWhereUniqueInput>>;
  update?: InputMaybe<Array<WebhookUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<WebhookUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<WebhookUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type WebhookUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<WebhookWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WebhookCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<WebhookCreateWithoutOrdersInput>;
  delete?: InputMaybe<WebhookWhereInput>;
  disconnect?: InputMaybe<WebhookWhereInput>;
  update?: InputMaybe<WebhookUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<WebhookUpsertWithoutOrdersInput>;
};

export type WebhookUpdateToOneWithWhereWithoutOrdersInput = {
  data: WebhookUpdateWithoutOrdersInput;
  where?: InputMaybe<WebhookWhereInput>;
};

export type WebhookUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: WebhookUpdateWithoutOrganizationInput;
  where: WebhookWhereUniqueInput;
};

export type WebhookUpdateWithoutOrdersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  global?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutWebhooksNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WebhookUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  global?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutWebhookNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WebhookUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: WebhookCreateWithoutOrganizationInput;
  update: WebhookUpdateWithoutOrganizationInput;
  where: WebhookWhereUniqueInput;
};

export type WebhookUpsertWithoutOrdersInput = {
  create: WebhookCreateWithoutOrdersInput;
  update: WebhookUpdateWithoutOrdersInput;
  where?: InputMaybe<WebhookWhereInput>;
};

export type WebhookUrlOrganizationIdCompoundUniqueInput = {
  organizationId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type WebhookWhereInput = {
  AND?: InputMaybe<Array<WebhookWhereInput>>;
  NOT?: InputMaybe<Array<WebhookWhereInput>>;
  OR?: InputMaybe<Array<WebhookWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  global?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  internal?: InputMaybe<BoolFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type WebhookWhereUniqueInput = {
  AND?: InputMaybe<Array<WebhookWhereInput>>;
  NOT?: InputMaybe<Array<WebhookWhereInput>>;
  OR?: InputMaybe<Array<WebhookWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  global?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<BoolFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
  url_organizationId?: InputMaybe<WebhookUrlOrganizationIdCompoundUniqueInput>;
};

export enum VIdInviteDeliveryMethodEnum {
  Email = 'EMAIL',
  None = 'NONE'
}

export type VIdVoucherUpdateManyWithWhereWithoutCreatedByInput = {
  data: VidVoucherUpdateManyMutationInput;
  where: VidVoucherScalarWhereInput;
};

export type VIdVoucherUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VidVoucherCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<VidVoucherCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<VidVoucherCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VidVoucherScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  set?: InputMaybe<Array<VidVoucherWhereUniqueInput>>;
  update?: InputMaybe<Array<VIdVoucherUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<VIdVoucherUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<VIdVoucherUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type VIdVoucherUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: VIdVoucherUpdateWithoutCreatedByInput;
  where: VidVoucherWhereUniqueInput;
};

export type VIdVoucherUpdateWithoutCreatedByInput = {
  apiKeys?: InputMaybe<ApiKeyUpdateManyWithoutVoucherNestedInput>;
  branchIOShortCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clientMetadata?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invite?: InputMaybe<InviteUpdateOneWithoutVidVouchersNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  middleName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onSubmitReturnUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  optOutReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutVidVoucherNestedInput>;
  organizationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumVoucherOriginFieldUpdateOperationsInput>;
  packageSet?: InputMaybe<PackageSetUpdateOneRequiredWithoutVidVouchersNestedInput>;
  passType?: InputMaybe<PassTypeUpdateOneWithoutVouchersNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  primaryContactMethod?: InputMaybe<NullableEnumUserPrimaryContactEnumFieldUpdateOperationsInput>;
  reorderReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumVoucherStatusEnumFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutVidVouchersNestedInput>;
};

export type VIdVoucherUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: VidVoucherCreateWithoutCreatedByInput;
  update: VIdVoucherUpdateWithoutCreatedByInput;
  where: VidVoucherWhereUniqueInput;
};

export type ApiKeysQueryVariables = Exact<{
  where?: InputMaybe<ApiKeyWhereInput>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput> | ApiKeyOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApiKeysQuery = { __typename?: 'Query', apiKeys: Array<{ __typename?: 'ApiKey', id: string, name: string, prefix: string, expiryDate?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { __typename?: 'User', email?: string | null, id: string, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, roleAssignment: Array<{ __typename?: 'RoleAssignment', roleV2: { __typename?: 'RoleV2', name: string } }> } | null }> };

export type GenerateApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GenerateApiKeyMutation = { __typename?: 'Mutation', generateApiKey: { __typename?: 'GenerateApiKeyResponse', apiKey: string, id: string, name: string, prefix: string, updatedAt: any, userId?: string | null, createdAt: any, expiryDate?: any | null } };

export type DeleteOneApiKeyMutationVariables = Exact<{
  where: ApiKeyWhereUniqueInput;
}>;


export type DeleteOneApiKeyMutation = { __typename?: 'Mutation', deleteOneApiKey?: { __typename?: 'ApiKey', id: string } | null };

export type SendApiKeyUnlockVerificationEmailMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
}>;


export type SendApiKeyUnlockVerificationEmailMutation = { __typename?: 'Mutation', sendApiKeyUnlockVerificationEmail: { __typename?: 'ApiKeyLockResponse', status?: string | null } };

export type VerifyApiKeyUnlockMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifyApiKeyUnlockMutation = { __typename?: 'Mutation', verifyApiKeyUnlock: { __typename?: 'ApiKeyLockResponse', status?: string | null } };

export type GenerateLimitedApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  expireOnOrder?: InputMaybe<Scalars['Boolean']['input']>;
  voucherId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateLimitedApiKeyMutation = { __typename?: 'Mutation', generateApiKey: { __typename?: 'GenerateApiKeyResponse', apiKey: string, id: string, createdAt: any } };

export type AuditLogsQueryVariables = Exact<{
  where?: InputMaybe<AuditLogWhereInput>;
  orderBy?: InputMaybe<Array<AuditLogOrderByWithRelationInput> | AuditLogOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs: Array<{ __typename?: 'AuditLog', id: string, date: any, performerId: string, actionContent: any }>, aggregateAuditLog: { __typename?: 'AggregateAuditLog', _count?: { __typename?: 'AuditLogCountAggregate', _all: number } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, createdAt: any, updatedAt: any, dob?: string | null, selectedOrganizationId?: string | null, organizations: Array<{ __typename?: 'Organization', id: string, name: string, legalName: string, primaryOrgFor: Array<{ __typename?: 'OrganizationRelation', id: string }> }>, roleAssignment: Array<{ __typename?: 'RoleAssignment', id: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, roleV2: { __typename?: 'RoleV2', id: string, name: string } }>, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, type?: NameTypeEnum | null }>, ssn?: { __typename?: 'HighlySensitiveIdentifier', id: string } | null } | null };

export type CheckEmailVerifiedQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckEmailVerifiedQuery = { __typename?: 'Query', checkEmailVerified: { __typename?: 'CheckEmailVerifiedResponse', email?: string | null, verified: boolean } };

export type BeamQueryVariables = Exact<{
  where: BeamWhereUniqueInput;
}>;


export type BeamQuery = { __typename?: 'Query', beam?: { __typename?: 'Beam', id: string, name: string, description: string, organizationId: string, updatedAt: any, createdAt: any, processor: ProcessorEnum, config?: any | null, processorConfig?: any | null, latestInputType?: { __typename?: 'BeamInputType', id: string, slug: string, beamId: string, schema: any, uiSchema?: any | null, version: string, createdAt: any, organizationId: string } | null } | null };

export type BeamListQueryVariables = Exact<{
  where?: InputMaybe<BeamWhereInput>;
}>;


export type BeamListQuery = { __typename?: 'Query', beams: Array<{ __typename?: 'Beam', id: string, name: string, description: string, organizationId: string, updatedAt: any, createdAt: any, processor: ProcessorEnum, config?: any | null, processorConfig?: any | null, latestInputType?: { __typename?: 'BeamInputType', id: string, slug: string, beamId: string, schema: any, uiSchema?: any | null, version: string, createdAt: any, organizationId: string } | null }> };

export type ExtractBeamDataFromImageMutationVariables = Exact<{
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  beamInputTypeId: Scalars['String']['input'];
  backImageUrl?: InputMaybe<Scalars['String']['input']>;
  fileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ExtractBeamDataFromImageMutation = { __typename?: 'Mutation', extractBeamDataFromImage?: any | null };

export type BeamInputTypeQueryVariables = Exact<{
  where: BeamInputTypeWhereUniqueInput;
}>;


export type BeamInputTypeQuery = { __typename?: 'Query', beamInputType?: { __typename?: 'BeamInputType', id: string, slug: string, beamId: string, schema: any, uiSchema?: any | null, version: string, createdAt: any, organizationId: string } | null };

export type BeamInputTypesListQueryVariables = Exact<{
  where?: InputMaybe<BeamInputTypeWhereInput>;
  orderBy?: InputMaybe<Array<BeamInputTypeOrderByWithRelationInput> | BeamInputTypeOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<BeamInputTypeScalarFieldEnum> | BeamInputTypeScalarFieldEnum>;
}>;


export type BeamInputTypesListQuery = { __typename?: 'Query', beamInputTypes: Array<{ __typename?: 'BeamInputType', id: string, slug: string, beamId: string, schema: any, uiSchema?: any | null, version: string, createdAt: any, organizationId: string }> };

export type CredentialsQueryVariables = Exact<{
  where?: InputMaybe<CredentialWhereInput>;
}>;


export type CredentialsQuery = { __typename?: 'Query', credentials: Array<{ __typename?: 'Credential', id: string, createdAt: any, data: any, status?: { __typename?: 'CredentialStatus', id: string, value: CredentialStatusEnum } | null, input: { __typename?: 'BeamInput', type: { __typename?: 'BeamInputType', beam: { __typename?: 'Beam', name: string } } }, type: { __typename?: 'CredentialType', id: string, name: string }, pass?: { __typename?: 'Pass', passType?: { __typename?: 'PassType', name: string } | null } | null }> };

export type RetrieveDisclosuresQueryVariables = Exact<{
  packageId: Scalars['String']['input'];
  addresses: Array<DisclosureAddress> | DisclosureAddress;
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RetrieveDisclosuresQuery = { __typename?: 'Query', retrieveDisclosures: Array<{ __typename?: 'Disclosure', id: string, location?: string | null, locationType?: LocationTypeEnum | null, name: string, text: string, type: DisclosureTypeEnum }> };

export type RetrieveBiometricDisclosuresQueryVariables = Exact<{
  packageId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RetrieveBiometricDisclosuresQuery = { __typename?: 'Query', retrieveBiometricDisclosures: Array<{ __typename?: 'Disclosure', id: string, location?: string | null, locationType?: LocationTypeEnum | null, name: string, text: string, type: DisclosureTypeEnum }> };

export type CreateDisclosureAcceptanceMutationVariables = Exact<{
  data: DisclosureAcceptanceArgs;
}>;


export type CreateDisclosureAcceptanceMutation = { __typename?: 'Mutation', createDisclosureAcceptance: { __typename?: 'DisclosureAcceptance', userId: string, updatedAt: any, signatureSvg: any, orderId?: string | null, id: string, createdAt: any } };

export type CreateOneBiometricConsentAcceptanceMutationVariables = Exact<{
  data: BiometricConsentAcceptanceCreateInput;
}>;


export type CreateOneBiometricConsentAcceptanceMutation = { __typename?: 'Mutation', createOneBiometricConsentAcceptance: { __typename?: 'BiometricConsentAcceptance', id: string, minorConsentAccepted: boolean, disclosureId: string, orderId?: string | null } };

export type AddBiometricConsentAcceptanceMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  biometricConsentAcceptanceId: Scalars['String']['input'];
}>;


export type AddBiometricConsentAcceptanceMutation = { __typename?: 'Mutation', addBiometricConsentAcceptance: { __typename?: 'AddBiometricConsentAcceptanceResponse', fileId: string, fileUrl: string } };

export type CreateDisputeMutationVariables = Exact<{
  input: DisputeCreateInput;
}>;


export type CreateDisputeMutation = { __typename?: 'Mutation', createOneDispute: { __typename?: 'Dispute', id: string, reason: DisputeReasonEnum, status: DisputeStatusEnum, consumerName: string, consumerEmail?: string | null, consumerPhone?: string | null, last4Ssn?: string | null, dob?: string | null, specificItem?: string | null, description?: string | null, createdAt: any, updatedAt: any } };

export type CreateOneFileMutationVariables = Exact<{
  data: FileCreateInput;
}>;


export type CreateOneFileMutation = { __typename?: 'Mutation', createOneFile: { __typename?: 'File', id: string } };

export type ApplicantDataFragment = { __typename?: 'ApplicantData', id: string, dateOfBirth: string, email?: string | null, phoneNumber?: string | null, createdAt: any, updatedAt: any, orderId: string, ssn?: { __typename?: 'HighlySensitiveIdentifier', value: string } | null, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, type?: NameTypeEnum | null, userId?: string | null }>, addresses: Array<{ __typename?: 'Address', id: string, userId?: string | null, addressLineOne: string, addressLineTwo?: string | null, city: string, state: string, postalCode: string, country: string, type?: AddressTypeEnum | null, createdAt: any, updatedAt: any, organizationId?: string | null }> };

export type DashboardOrderListFragment = { __typename?: 'Order', id: string, fileNumber: string, status?: OrderStatusEnum | null, score?: OrderScoreEnum | null, alert?: OrderAlertEnum | null, deliveryMethod?: OrderDeliveryMethod | null, createdAt: any, applicantData?: { __typename?: 'ApplicantData', id: string, names: Array<{ __typename?: 'Name', firstName?: string | null, middleName?: string | null, lastName?: string | null }> } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, packageSets: Array<{ __typename?: 'PackageSet', name: string }> };

export type OrderFragment = { __typename?: 'Order', id: string, fileNumber: string, deliveryMethod?: OrderDeliveryMethod | null, status?: OrderStatusEnum | null, score?: OrderScoreEnum | null, createdAt: any, reportableResults?: any | null, reportCompletedAt?: any | null, files: Array<{ __typename?: 'File', id: string, createdAt: any, name: string, purpose?: FilePurposeTypeEnum | null }>, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl?: string | null } | null, applicantData?: { __typename?: 'ApplicantData', id: string, dateOfBirth: string, email?: string | null, phoneNumber?: string | null, createdAt: any, updatedAt: any, orderId: string, ssn?: { __typename?: 'HighlySensitiveIdentifier', value: string } | null, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, type?: NameTypeEnum | null, userId?: string | null }>, addresses: Array<{ __typename?: 'Address', id: string, userId?: string | null, addressLineOne: string, addressLineTwo?: string | null, city: string, state: string, postalCode: string, country: string, type?: AddressTypeEnum | null, createdAt: any, updatedAt: any, organizationId?: string | null }> } | null };

export type SearchTypeFragment = { __typename?: 'SearchType', id: string, name: string };

export type PackageSetFragment = { __typename?: 'PackageSet', id: string, name: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, searchTypes: Array<{ __typename?: 'SearchType', id: string, name: string }> };

export type OrganizationResFragment = { __typename?: 'Organization', id: string, name: string, logoUrl?: string | null };

export type BeamFragment = { __typename?: 'Beam', id: string, name: string, description: string, organizationId: string, updatedAt: any, createdAt: any, processor: ProcessorEnum, config?: any | null, processorConfig?: any | null, latestInputType?: { __typename?: 'BeamInputType', id: string, slug: string, beamId: string, schema: any, uiSchema?: any | null, version: string, createdAt: any, organizationId: string } | null };

export type BeamInputTypeFragment = { __typename?: 'BeamInputType', id: string, slug: string, beamId: string, schema: any, uiSchema?: any | null, version: string, createdAt: any, organizationId: string };

export type CreateOneHighlySensitiveIdentifierMutationVariables = Exact<{
  data: HighlySensitiveIdentifierCreateInput;
}>;


export type CreateOneHighlySensitiveIdentifierMutation = { __typename?: 'Mutation', createOneHighlySensitiveIdentifier: { __typename?: 'HighlySensitiveIdentifier', id: string } };

export type CreateIdentityRecheckOrderMutationVariables = Exact<{
  input: CreateIdentityRecheckOrderInput;
}>;


export type CreateIdentityRecheckOrderMutation = { __typename?: 'Mutation', createIdentityRecheckOrder: { __typename?: 'Order', id: string, fileNumber: string } };

export type CreateOneIdentificationDocumentMutationVariables = Exact<{
  data: IdentificationDocumentCreateInput;
}>;


export type CreateOneIdentificationDocumentMutation = { __typename?: 'Mutation', createOneIdentificationDocument: { __typename?: 'IdentificationDocument', id: string, backImage?: { __typename?: 'File', id: string } | null, extractedPhoto?: { __typename?: 'File', id: string } | null, frontImage?: { __typename?: 'File', id: string } | null, selfieImage?: { __typename?: 'File', id: string } | null } };

export type RequestInviteExportMutationVariables = Exact<{
  where: VidVoucherWhereInput;
  orderBy: Array<VidVoucherOrderByWithRelationInput> | VidVoucherOrderByWithRelationInput;
  includeOrganization: Scalars['Boolean']['input'];
  requestId: Scalars['String']['input'];
}>;


export type RequestInviteExportMutation = { __typename?: 'Mutation', requestInviteExport: string };

export type InviteExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteExportsQuery = { __typename?: 'Query', inviteExports: Array<{ __typename?: 'InviteExport', id: string, status: string, rows: number, createdAt: any, expiresAt: any }> };

export type DownloadInviteExportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DownloadInviteExportMutation = { __typename?: 'Mutation', downloadInviteExport: string };

export type CreateOneNameMutationVariables = Exact<{
  data: NameCreateInput;
}>;


export type CreateOneNameMutation = { __typename?: 'Mutation', createOneName: { __typename?: 'Name', id: string } };

export type OrderListQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum> | OrderScalarFieldEnum>;
}>;


export type OrderListQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, fileNumber: string, status?: OrderStatusEnum | null, score?: OrderScoreEnum | null, alert?: OrderAlertEnum | null, deliveryMethod?: OrderDeliveryMethod | null, createdAt: any, applicantData?: { __typename?: 'ApplicantData', id: string, names: Array<{ __typename?: 'Name', firstName?: string | null, middleName?: string | null, lastName?: string | null }> } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null } | null, packageSets: Array<{ __typename?: 'PackageSet', name: string }> }>, aggregateOrder: { __typename?: 'AggregateOrder', _count?: { __typename?: 'OrderCountAggregate', _all: number } | null } };

export type UserOrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
}>;


export type UserOrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', organization?: { __typename?: 'Organization', name: string } | null, beamInputs: Array<{ __typename?: 'BeamInput', id: string, typeId: string, files: Array<{ __typename?: 'File', id: string, name: string, createdAt: any }> }>, results: Array<{ __typename?: 'Result', searchType?: ResultSearchType | null, attachments: Array<{ __typename?: 'File', id: string, name: string, type?: string | null, createdAt: any }> }>, disclosureAcceptances: Array<{ __typename?: 'DisclosureAcceptance', disclosures: Array<{ __typename?: 'Disclosure', id: string, name: string, createdAt: any }>, pdf?: { __typename?: 'File', id: string, name: string } | null }> }> };

export type OrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum> | OrderScalarFieldEnum>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, fileNumber: string, deliveryMethod?: OrderDeliveryMethod | null, status?: OrderStatusEnum | null, score?: OrderScoreEnum | null, createdAt: any, reportableResults?: any | null, reportCompletedAt?: any | null, files: Array<{ __typename?: 'File', id: string, createdAt: any, name: string, purpose?: FilePurposeTypeEnum | null }>, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl?: string | null } | null, applicantData?: { __typename?: 'ApplicantData', id: string, dateOfBirth: string, email?: string | null, phoneNumber?: string | null, createdAt: any, updatedAt: any, orderId: string, ssn?: { __typename?: 'HighlySensitiveIdentifier', value: string } | null, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, type?: NameTypeEnum | null, userId?: string | null }>, addresses: Array<{ __typename?: 'Address', id: string, userId?: string | null, addressLineOne: string, addressLineTwo?: string | null, city: string, state: string, postalCode: string, country: string, type?: AddressTypeEnum | null, createdAt: any, updatedAt: any, organizationId?: string | null }> } | null }> };

export type OrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', status?: OrderStatusEnum | null, score?: OrderScoreEnum | null, userId?: string | null, files: Array<{ __typename?: 'File', id: string, createdAt: any, name: string, purpose?: FilePurposeTypeEnum | null }>, user?: { __typename?: 'User', phone?: string | null, email?: string | null, dob?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null } | null } | null };

export type CreateManyOrderMutationVariables = Exact<{
  applicants: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
  deliveryMethod: OrderDeliveryMethod;
  packageId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  orderFrom?: InputMaybe<Platform>;
}>;


export type CreateManyOrderMutation = { __typename?: 'Mutation', createManyOrder: { __typename?: 'StatusResponse', status: boolean } };

export type UpdateOrderMutationVariables = Exact<{
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string, fileNumber: string, deliveryMethod?: OrderDeliveryMethod | null, status?: OrderStatusEnum | null, score?: OrderScoreEnum | null, createdAt: any, reportableResults?: any | null, reportCompletedAt?: any | null, files: Array<{ __typename?: 'File', id: string, createdAt: any, name: string, purpose?: FilePurposeTypeEnum | null }>, organization?: { __typename?: 'Organization', id: string, name: string, logoUrl?: string | null } | null, applicantData?: { __typename?: 'ApplicantData', id: string, dateOfBirth: string, email?: string | null, phoneNumber?: string | null, createdAt: any, updatedAt: any, orderId: string, ssn?: { __typename?: 'HighlySensitiveIdentifier', value: string } | null, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, type?: NameTypeEnum | null, userId?: string | null }>, addresses: Array<{ __typename?: 'Address', id: string, userId?: string | null, addressLineOne: string, addressLineTwo?: string | null, city: string, state: string, postalCode: string, country: string, type?: AddressTypeEnum | null, createdAt: any, updatedAt: any, organizationId?: string | null }> } | null } };

export type CreateOrderMutationVariables = Exact<{
  data: ExtendedOrderCreateInput;
  orderFrom?: InputMaybe<Platform>;
  stateIdentificationCardId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  documentModel?: InputMaybe<Scalars['String']['input']>;
  captureMethod?: InputMaybe<IdCaptureMethod>;
  biometricConsentAcceptanceId?: InputMaybe<Scalars['String']['input']>;
  beamData?: InputMaybe<Array<OrderBeamData> | OrderBeamData>;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'Order', id: string, fileNumber: string } };

export type CreateOneOrganizationRelationMutationVariables = Exact<{
  data: OrganizationRelationCreateInput;
}>;


export type CreateOneOrganizationRelationMutation = { __typename?: 'Mutation', createOneOrganizationRelation: { __typename?: 'OrganizationRelation', id: string } };

export type DeleteOneOrganizationRelationMutationVariables = Exact<{
  where: OrganizationRelationWhereUniqueInput;
}>;


export type DeleteOneOrganizationRelationMutation = { __typename?: 'Mutation', deleteOneOrganizationRelation?: { __typename?: 'OrganizationRelation', id: string } | null };

export type OrganizationQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationRes', craAccentColor?: string | null, craContactEmail?: string | null, craHorizontalLogoUrl?: string | null, craLogoUrl?: string | null, craName?: string | null, enableSupport?: boolean | null, hexColor?: string | null, horizontalLogoUrl?: string | null, id?: string | null, logoUrl?: string | null, name?: string | null, useCraBranding: boolean } };

export type OrganizationsWithCraQueryVariables = Exact<{
  where?: InputMaybe<OrganizationWhereInput>;
}>;


export type OrganizationsWithCraQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', hexColor?: string | null, horizontalLogoId?: string | null, horizontalLogoUrl?: string | null, id: string, logoId?: string | null, logoUrl?: string | null, metadata?: any | null, name: string, affiliateOrgTo: Array<{ __typename?: 'OrganizationRelation', id: string, primaryOrg: { __typename?: 'Organization', contactEmail?: string | null, horizontalLogoUrl?: string | null, id: string, logoUrl?: string | null, name: string, website?: string | null } }> }> };

export type AffiliateOrgToQueryVariables = Exact<{
  where?: InputMaybe<OrganizationWhereInput>;
}>;


export type AffiliateOrgToQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string }> };

export type OrganizationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput> | OrganizationOrderByWithRelationInput>;
  where?: InputMaybe<OrganizationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, logoUrl?: string | null, name: string, shortName: string }> };

export type OrganizationsWithDetailsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<OrganizationOrderByWithRelationInput> | OrganizationOrderByWithRelationInput>;
  where?: InputMaybe<OrganizationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationsWithDetailsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, createdAt: any, createdById?: string | null, deletedAt?: any | null, delegateWebhooksToCra: boolean, enableCraDisputeOnBehalfOfApplicant: boolean, enableDisputes: boolean, enableSupport?: boolean | null, hexColor?: string | null, horizontalLogoId?: string | null, horizontalLogoUrl?: string | null, id: string, legalName: string, logoId?: string | null, logoUrl?: string | null, metadata?: any | null, name: string, parentOrganizationId?: string | null, shortName: string, staticSiteEnabled: boolean, updatedAt: any, affiliateOrgTo: Array<{ __typename?: 'OrganizationRelation', id: string, type: OrgRelationTypeEnum, affiliateOrgId: string, primaryOrgId: string, primaryOrg: { __typename?: 'Organization', contactPhone?: string | null, hexColor?: string | null, horizontalLogoUrl?: string | null, id: string, logoUrl?: string | null, name: string, address: Array<{ __typename?: 'Address', addressLineOne: string, addressLineTwo?: string | null, city: string, country: string, id: string, postalCode: string, state: string, type?: AddressTypeEnum | null, updatedAt: any }> } }>, address: Array<{ __typename?: 'Address', addressLineOne: string, addressLineTwo?: string | null, city: string, country: string, id: string, postalCode: string, state: string, type?: AddressTypeEnum | null, updatedAt: any }> }>, aggregateOrganization: { __typename?: 'AggregateOrganization', _count?: { __typename?: 'OrganizationCountAggregate', _all: number } | null } };

export type CreateOneOrganizationMutationVariables = Exact<{
  data: OrganizationCreateInput;
}>;


export type CreateOneOrganizationMutation = { __typename?: 'Mutation', createOneOrganization: { __typename?: 'Organization', delegateWebhooksToCra: boolean, horizontalLogoId?: string | null, id: string, logoId?: string | null, name: string, shortName: string } };

export type UpdateOneOrganizationMutationVariables = Exact<{
  data: OrganizationUpdateInput;
  where: OrganizationWhereUniqueInput;
}>;


export type UpdateOneOrganizationMutation = { __typename?: 'Mutation', updateOneOrganization?: { __typename?: 'Organization', delegateWebhooksToCra: boolean, id: string, logoId?: string | null, horizontalLogoId?: string | null } | null };

export type DeleteOneOrganizationMutationVariables = Exact<{
  where: OrganizationWhereUniqueInput;
}>;


export type DeleteOneOrganizationMutation = { __typename?: 'Mutation', deleteOneOrganization?: { __typename?: 'Organization', id: string } | null };

export type PackagesForFiltersQueryVariables = Exact<{
  where?: InputMaybe<PackageSetWhereInput>;
}>;


export type PackagesForFiltersQuery = { __typename?: 'Query', packageSets: Array<{ __typename?: 'PackageSet', id: string, name: string, description?: string | null }> };

export type GetPackageNameQueryVariables = Exact<{
  where: PackageSetWhereUniqueInput;
}>;


export type GetPackageNameQuery = { __typename?: 'Query', packageSet?: { __typename?: 'PackageSet', id: string, name: string } | null };

export type PackageSetQueryVariables = Exact<{
  where: PackageSetWhereUniqueInput;
}>;


export type PackageSetQuery = { __typename?: 'Query', packageSet?: { __typename?: 'PackageSet', id: string, name: string, metadata?: any | null } | null };

export type PackageSetsQueryVariables = Exact<{
  where?: InputMaybe<PackageSetWhereInput>;
  orderBy?: InputMaybe<Array<PackageSetOrderByWithRelationInput> | PackageSetOrderByWithRelationInput>;
  cursor?: InputMaybe<PackageSetWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<PackageSetScalarFieldEnum> | PackageSetScalarFieldEnum>;
}>;


export type PackageSetsQuery = { __typename?: 'Query', packageSets: Array<{ __typename?: 'PackageSet', id: string, name: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, searchTypes: Array<{ __typename?: 'SearchType', id: string, name: string }> }> };

export type PackageAccessesQueryVariables = Exact<{
  where?: InputMaybe<PackageAccessWhereInput>;
}>;


export type PackageAccessesQuery = { __typename?: 'Query', packageAccesses: Array<{ __typename?: 'PackageAccess', id: string, packageSet: { __typename?: 'PackageSet', id: string, name: string, organization?: { __typename?: 'Organization', id: string, name: string } | null, searchTypes: Array<{ __typename?: 'SearchType', id: string, name: string }> } }> };

export type PassTypeQueryVariables = Exact<{
  where: PassTypeWhereUniqueInput;
}>;


export type PassTypeQuery = { __typename?: 'Query', passType?: { __typename?: 'PassType', id: string, slug: string, brandColor?: string | null, organizationId: string, createdAt: any } | null };

export type PassDetailQueryVariables = Exact<{
  where: PassWhereUniqueInput;
}>;


export type PassDetailQuery = { __typename?: 'Query', pass?: { __typename?: 'Pass', id: string, passType?: { __typename?: 'PassType', id: string, name: string, organization: { __typename?: 'Organization', id: string, name: string, legalName: string } } | null, inputs: Array<{ __typename?: 'BeamInput', id: string, createdAt: any, type: { __typename?: 'BeamInputType', beam: { __typename?: 'Beam', id: string, name: string } }, credential?: { __typename?: 'Credential', id: string, status?: { __typename?: 'CredentialStatus', value: CredentialStatusEnum } | null } | null }>, user: { __typename?: 'User', id: string, email?: string | null, names: Array<{ __typename?: 'Name', firstName?: string | null, lastName?: string | null, middleName?: string | null }>, stateIdentificationCards: Array<{ __typename?: 'StateIdentificationCard', selfieImage?: { __typename?: 'File', id: string } | null }>, passports: Array<{ __typename?: 'Passport', selfieImage?: { __typename?: 'File', id: string } | null }> } } | null };

export type PassesQueryVariables = Exact<{
  where?: InputMaybe<PassWhereInput>;
}>;


export type PassesQuery = { __typename?: 'Query', passes: Array<{ __typename?: 'Pass', createdAt: any, id: string, passType?: { __typename?: 'PassType', name: string, organization: { __typename?: 'Organization', name: string } } | null, inputs: Array<{ __typename?: 'BeamInput', credential?: { __typename?: 'Credential', id: string, status?: { __typename?: 'CredentialStatus', value: CredentialStatusEnum } | null } | null }> }> };

export type PassTypesQueryVariables = Exact<{
  where?: InputMaybe<PassTypeWhereInput>;
}>;


export type PassTypesQuery = { __typename?: 'Query', passTypes: Array<{ __typename?: 'PassType', name: string, id: string }> };

export type PassQueryVariables = Exact<{
  where: PassWhereUniqueInput;
}>;


export type PassQuery = { __typename?: 'Query', pass?: { __typename?: 'Pass', updatedAt: any, id: string, passType?: { __typename?: 'PassType', brandColor?: string | null, id: string, name: string, organization: { __typename?: 'Organization', id: string, logoUrl?: string | null, name: string } } | null, inputs: Array<{ __typename?: 'BeamInput', id: string, data: any, type: { __typename?: 'BeamInputType', beam: { __typename?: 'Beam', name: string } }, credential?: { __typename?: 'Credential', id: string, data: any, status?: { __typename?: 'CredentialStatus', createdAt: any, updatedAt: any, value: CredentialStatusEnum } | null, type: { __typename?: 'CredentialType', createdAt: any, name: string, beam: { __typename?: 'Beam', name: string } } } | null, order?: { __typename?: 'Order', createdAt: any } | null }> } | null };

export type VIdReportQueryVariables = Exact<{
  where: VidVoucherWhereInput;
  notesWhere2?: InputMaybe<OrderNoteWhereInput>;
}>;


export type VIdReportQuery = { __typename?: 'Query', vIDVouchers: Array<{ __typename?: 'VIDVoucher', id: string, createdAt: any, order?: { __typename?: 'Order', id: string, createdAt: any, score?: OrderScoreEnum | null, status?: OrderStatusEnum | null, notes: Array<{ __typename?: 'OrderNote', createdAt: any, message: string, id: string }> } | null, invite?: { __typename?: 'Invite', id: string, createdAt: any, redeemedAt?: any | null } | null }> };

export type RolesQueryVariables = Exact<{
  where?: InputMaybe<RoleV2WhereInput>;
}>;


export type RolesQuery = { __typename?: 'Query', roleV2s: Array<{ __typename?: 'RoleV2', createdAt: any, id: string, name: string, updatedAt: any }> };

export type GetSvixAppPortalUrlQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetSvixAppPortalUrlQuery = { __typename?: 'Query', getSvixAppPortalUrl?: { __typename?: 'SvixAppPortalUrlResponse', svixAppPortalUrl: string } | null };

export type UpdateUserMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type UpdateOneUserMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type UpdateOneUserMutation = { __typename?: 'Mutation', updateOneUser?: { __typename?: 'User', id: string, roleAssignment: Array<{ __typename?: 'RoleAssignment', id: string, organizationId?: string | null, roleV2: { __typename?: 'RoleV2', id: string, name: string } }>, organizations: Array<{ __typename?: 'Organization', id: string }> } | null };

export type VidUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type VidUserDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, dob?: string | null, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, type?: NameTypeEnum | null }>, addresses: Array<{ __typename?: 'Address', id: string, addressLineOne: string, addressLineTwo?: string | null, city: string, state: string, postalCode: string, country: string, type?: AddressTypeEnum | null }> } | null };

export type UserCardQueryVariables = Exact<{
  where: UserWhereUniqueInput;
  orderWhere: OrderWhereInput;
}>;


export type UserCardQuery = { __typename?: 'Query', user?: { __typename?: 'User', createdAt: any, dob?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, phone?: string | null, myOrders: Array<{ __typename?: 'Order', score?: OrderScoreEnum | null }>, stateIdentificationCards: Array<{ __typename?: 'StateIdentificationCard', id: string, selfieImage?: { __typename?: 'File', id: string } | null }> } | null };

export type SelfieImageQueryVariables = Exact<{
  where: FileWhereUniqueInput;
}>;


export type SelfieImageQuery = { __typename?: 'Query', selfieImage?: { __typename?: 'File', id: string, url: string } | null };

export type FindUserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type FindUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, createdAt: any, updatedAt: any, selectedOrganizationId?: string | null } | null };

export type UserPermissionsQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type UserPermissionsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null, permissionEditor: { __typename?: 'UserPermissionEditor', canEditNames: boolean, canManagePermissions: boolean, canManageAllOrganizations: boolean, editableOrganizationIds: Array<string>, assignableRoles: Array<RoleEnum> }, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, type?: NameTypeEnum | null }>, roleAssignment: Array<{ __typename?: 'RoleAssignment', id: string, organizationId?: string | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, roleV2: { __typename?: 'RoleV2', id: string, name: string } }> } | null };

export type UpdateUserPermissionsMutationVariables = Exact<{
  input: UserPermissionsInput;
}>;


export type UpdateUserPermissionsMutation = { __typename?: 'Mutation', updateUserPermissions: { __typename?: 'UserPermissionsResult', userId: string } };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  roleWhere?: InputMaybe<RoleAssignmentWhereInput>;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email?: string | null, _count?: { __typename?: 'UserCount', organizations: number } | null, names: Array<{ __typename?: 'Name', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, type?: NameTypeEnum | null }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, roleAssignment: Array<{ __typename?: 'RoleAssignment', organizationId?: string | null, roleV2: { __typename?: 'RoleV2', name: string } }> }>, aggregateUser: { __typename?: 'AggregateUser', _count?: { __typename?: 'UserCountAggregate', _all: number } | null } };

export type CreateSupportTicketMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  purpose?: InputMaybe<SupportTicketPurpose>;
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSupportTicketMutation = { __typename?: 'Mutation', createSupportTicket: { __typename?: 'CreateSupportTicketResponse', success: boolean, ticketId?: string | null } };

export type DoesUserExistMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DoesUserExistMutation = { __typename?: 'Mutation', doesUserExist: boolean };

export type CreateOneAppFeedbackMutationVariables = Exact<{
  data: AppFeedbackCreateInput;
}>;


export type CreateOneAppFeedbackMutation = { __typename?: 'Mutation', createOneAppFeedback: { __typename?: 'AppFeedback', id: string, userId: string } };

export type CreateOneStateIdentificationCardMutationVariables = Exact<{
  data: StateIdentificationCardCreateInput;
}>;


export type CreateOneStateIdentificationCardMutation = { __typename?: 'Mutation', createOneStateIdentificationCard: { __typename?: 'StateIdentificationCard', id: string, selfieImage?: { __typename?: 'File', id: string } | null, extractedPhoto?: { __typename?: 'File', id: string } | null, frontImage?: { __typename?: 'File', id: string } | null, backImage?: { __typename?: 'File', id: string } | null } };

export type UpdateOnePassportMutationVariables = Exact<{
  data: PassportUpdateInput;
  where: PassportWhereUniqueInput;
}>;


export type UpdateOnePassportMutation = { __typename?: 'Mutation', updateOnePassport?: { __typename?: 'Passport', id: string } | null };

export type CreateOnePassportMutationVariables = Exact<{
  data: PassportCreateInput;
}>;


export type CreateOnePassportMutation = { __typename?: 'Mutation', createOnePassport: { __typename?: 'Passport', id: string, selfieImage?: { __typename?: 'File', id: string } | null, extractedPhoto?: { __typename?: 'File', id: string } | null, frontImage?: { __typename?: 'File', id: string } | null, backImage?: { __typename?: 'File', id: string } | null } };

export type UpdateOneStateIdentificationCardMutationVariables = Exact<{
  where: StateIdentificationCardWhereUniqueInput;
  data: StateIdentificationCardUpdateInput;
}>;


export type UpdateOneStateIdentificationCardMutation = { __typename?: 'Mutation', updateOneStateIdentificationCard?: { __typename?: 'StateIdentificationCard', id: string } | null };

export type AcceptInviteMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite?: { __typename?: 'InviteRes', email: string, id: string, organizationId: string, redeemedAt?: string | null, redeemedById?: string | null, senderId: string, vidVoucherId?: string | null } | null };

export type StartVidFlowMutationVariables = Exact<{
  voucherId: Scalars['String']['input'];
}>;


export type StartVidFlowMutation = { __typename?: 'Mutation', startVidFlow: { __typename?: 'VIDVoucher', id: string, status: VoucherStatusEnum, startedAt?: any | null } };

export type VidVoucherQueryVariables = Exact<{
  where: VidVoucherWhereUniqueInput;
}>;


export type VidVoucherQuery = { __typename?: 'Query', vIDVoucher?: { __typename?: 'VIDVoucher', clientMetadata?: any | null, createdAt: any, email: string, id: string, inviteId?: string | null, orderId?: string | null, organizationId: string, packageSetId: string, postbackUrl?: string | null, status: VoucherStatusEnum, startedAt?: any | null, updatedAt: any, passTypeId?: string | null, userId?: string | null, onSubmitReturnUrl?: string | null, expiresAt?: any | null, packageSet: { __typename?: 'PackageSet', id: string, collectSSN?: boolean | null, showDisclosures?: boolean | null, useSampleId?: boolean | null, metadata?: any | null, searchTypes: Array<{ __typename?: 'SearchType', id: string, name: string }> } } | null };

export type VidVouchersQueryVariables = Exact<{
  where: VidVoucherWhereInput;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput> | VidVoucherOrderByWithRelationInput>;
  cursor?: InputMaybe<VidVoucherWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  packageSetsWhere: PackageSetWhereInput;
}>;


export type VidVouchersQuery = { __typename?: 'Query', vIDVouchers: Array<{ __typename?: 'VIDVoucher', branchIOShortCode?: string | null, clientMetadata?: any | null, createdAt: any, dateOfBirth?: string | null, email: string, expiresAt?: any | null, fileNumber?: string | null, firstName?: string | null, id: string, inviteId?: string | null, lastName?: string | null, middleName?: string | null, orderId?: string | null, organizationId: string, packageSetId: string, phoneNumber?: string | null, postbackUrl?: string | null, primaryContactMethod?: UserPrimaryContactEnum | null, status: VoucherStatusEnum, suffix?: string | null, updatedAt: any, userId?: string | null, onSubmitReturnUrl?: string | null, origin?: VoucherOrigin | null }>, packageSets: Array<{ __typename?: 'PackageSet', description?: string | null, id: string, name: string }>, aggregateVIDVoucher: { __typename?: 'AggregateVIDVoucher', _count?: { __typename?: 'VIDVoucherCountAggregate', _all: number } | null } };

export type ResumableVidVouchersQueryVariables = Exact<{
  where: VidVoucherWhereInput;
  orderBy?: InputMaybe<Array<VidVoucherOrderByWithRelationInput> | VidVoucherOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResumableVidVouchersQuery = { __typename?: 'Query', vIDVouchers: Array<{ __typename?: 'VIDVoucher', createdAt: any, expiresAt?: any | null, id: string, orderId?: string | null, status: VoucherStatusEnum }> };

export type GetInviteCountQueryVariables = Exact<{
  where?: InputMaybe<VidVoucherWhereInput>;
}>;


export type GetInviteCountQuery = { __typename?: 'Query', aggregateVIDVoucher: { __typename?: 'AggregateVIDVoucher', _count?: { __typename?: 'VIDVoucherCountAggregate', _all: number } | null } };

export type CheckVoucherValidityQueryVariables = Exact<{
  voucherId: Scalars['String']['input'];
}>;


export type CheckVoucherValidityQuery = { __typename?: 'Query', checkVoucherValidity?: { __typename?: 'VIDVoucher', clientMetadata?: any | null, createdAt: any, email: string, expiresAt?: any | null, id: string, inviteId?: string | null, orderId?: string | null, organizationId: string, packageSetId: string, postbackUrl?: string | null, status: VoucherStatusEnum, startedAt?: any | null, updatedAt: any, passTypeId?: string | null, userId?: string | null, onSubmitReturnUrl?: string | null, packageSet: { __typename?: 'PackageSet', id: string, collectSSN?: boolean | null, showDisclosures?: boolean | null, useSampleId?: boolean | null, metadata?: any | null, searchTypes: Array<{ __typename?: 'SearchType', id: string, name: string }> } } | null };

export type OptOutVoucherMutationVariables = Exact<{
  voucherId: Scalars['String']['input'];
  optOutReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type OptOutVoucherMutation = { __typename?: 'Mutation', optOutVoucher?: { __typename?: 'VIDVoucher', id: string, status: VoucherStatusEnum } | null };

export type GetInviteQueryVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type GetInviteQuery = { __typename?: 'Query', getInvite?: { __typename?: 'InviteRes', redeemedById?: string | null, redeemedAt?: string | null } | null };

export type DeleteOneVidVoucherMutationVariables = Exact<{
  where: VidVoucherWhereUniqueInput;
}>;


export type DeleteOneVidVoucherMutation = { __typename?: 'Mutation', deleteOneVIDVoucher?: { __typename?: 'VIDVoucher', id: string, userId?: string | null, updatedAt: any, status: VoucherStatusEnum, postbackUrl?: string | null, packageSetId: string, organizationId: string, orderId?: string | null, inviteId?: string | null, email: string, createdAt: any } | null };

export type CreateOneVidVoucherMutationVariables = Exact<{
  data: CreateOneVidVoucherInput;
}>;


export type CreateOneVidVoucherMutation = { __typename?: 'Mutation', createOneVIDVoucher?: { __typename?: 'CreateOneVidVoucherRes', inviteExpiry: string, inviteId: string, packageId: string, packageName: string, vIDInviteUrl: string, vIDQRCode: string, vIDShortCode: string, inviteData: { __typename?: 'InviteDataOutputRes', contactInformation: { __typename?: 'ContactInformationOutput', email: string, phoneNumber: string } } } | null };

export type CreateManyVidVoucherMutationVariables = Exact<{
  data: Array<CreateOneVidVoucherInput> | CreateOneVidVoucherInput;
}>;


export type CreateManyVidVoucherMutation = { __typename?: 'Mutation', createManyVIDVoucher?: { __typename?: 'CreateManyVidVoucherRes', data: Array<{ __typename?: 'CreateOneVidVoucherRes', inviteId: string, packageId: string, packageName: string, vIDInviteUrl: string, vIDQRCode: string, vIDShortCode: string }>, errors?: Array<{ __typename?: 'InviteErrorResponse', error: string, email: string }> | null } | null };

export type UpdateOneVidVoucherMutationVariables = Exact<{
  data: VidVoucherUpdateInput;
  where: VidVoucherWhereUniqueInput;
}>;


export type UpdateOneVidVoucherMutation = { __typename?: 'Mutation', updateOneVIDVoucher?: { __typename?: 'VIDVoucher', id: string } | null };

export type GetVoucherStatusQueryVariables = Exact<{
  voucherId: Scalars['String']['input'];
}>;


export type GetVoucherStatusQuery = { __typename?: 'Query', getVoucherStatus?: { __typename?: 'GetVoucherStatusResponse', id?: string | null, onSubmitReturnUrl?: string | null, status?: string | null } | null };

export type JobQueryVariables = Exact<{
  where: JobWhereUniqueInput;
}>;


export type JobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: string, payload: any, result?: any | null, lastError?: string | null } | null };

export const DashboardOrderListFragmentDoc = `
    fragment DashboardOrderList on Order {
  id
  fileNumber
  status
  score
  alert
  deliveryMethod
  createdAt
  applicantData {
    id
    names {
      firstName
      middleName
      lastName
    }
  }
  user {
    id
    firstName
    middleName
    lastName
  }
  packageSets {
    name
  }
}
    `;
export const ApplicantDataFragmentDoc = `
    fragment ApplicantData on ApplicantData {
  id
  dateOfBirth
  ssn {
    value
  }
  email
  phoneNumber
  createdAt
  updatedAt
  orderId
  names {
    id
    firstName
    middleName
    lastName
    type
    userId
  }
  addresses {
    id
    userId
    addressLineOne
    addressLineTwo
    city
    state
    postalCode
    country
    type
    createdAt
    updatedAt
    organizationId
  }
}
    `;
export const OrderFragmentDoc = `
    fragment Order on Order {
  id
  fileNumber
  deliveryMethod
  status
  score
  createdAt
  files {
    id
    createdAt
    name
    purpose
  }
  organization {
    id
    name
    logoUrl
  }
  applicantData {
    ...ApplicantData
  }
  reportableResults
  reportCompletedAt
}
    ${ApplicantDataFragmentDoc}`;
export const SearchTypeFragmentDoc = `
    fragment SearchType on SearchType {
  id
  name
}
    `;
export const PackageSetFragmentDoc = `
    fragment PackageSet on PackageSet {
  id
  name
  organization {
    id
    name
  }
  searchTypes {
    ...SearchType
  }
}
    ${SearchTypeFragmentDoc}`;
export const OrganizationResFragmentDoc = `
    fragment OrganizationRes on Organization {
  id
  name
  logoUrl
}
    `;
export const BeamInputTypeFragmentDoc = `
    fragment BeamInputType on BeamInputType {
  id
  slug
  beamId
  schema
  uiSchema
  version
  createdAt
  organizationId
}
    `;
export const BeamFragmentDoc = `
    fragment Beam on Beam {
  id
  name
  description
  organizationId
  updatedAt
  createdAt
  processor
  config
  processorConfig
  latestInputType {
    ...BeamInputType
  }
}
    ${BeamInputTypeFragmentDoc}`;
export const ApiKeysDocument = `
    query ApiKeys($where: ApiKeyWhereInput, $orderBy: [ApiKeyOrderByWithRelationInput!], $take: Int, $skip: Int) {
  apiKeys(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    name
    prefix
    expiryDate
    createdAt
    updatedAt
    deletedAt
    user {
      email
      id
      organizations {
        id
        name
      }
      roleAssignment {
        roleV2 {
          name
        }
      }
    }
  }
}
    `;
export const useApiKeysQuery = <
      TData = ApiKeysQuery,
      TError = unknown
    >(
      variables?: ApiKeysQueryVariables,
      options?: UseQueryOptions<ApiKeysQuery, TError, TData>
    ) =>
    useQuery<ApiKeysQuery, TError, TData>(
      variables === undefined ? ['ApiKeys'] : ['ApiKeys', variables],
      useFetchData<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument).bind(null, variables),
      options
    );
useApiKeysQuery.document = ApiKeysDocument;


useApiKeysQuery.getKey = (variables?: ApiKeysQueryVariables) => variables === undefined ? ['ApiKeys'] : ['ApiKeys', variables];
;

export const GenerateApiKeyDocument = `
    mutation generateApiKey($name: String!) {
  generateApiKey(name: $name) {
    apiKey
    id
    name
    prefix
    updatedAt
    userId
    createdAt
    expiryDate
  }
}
    `;
export const useGenerateApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateApiKeyMutation, TError, GenerateApiKeyMutationVariables, TContext>) =>
    useMutation<GenerateApiKeyMutation, TError, GenerateApiKeyMutationVariables, TContext>(
      ['generateApiKey'],
      useFetchData<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>(GenerateApiKeyDocument),
      options
    );
export const DeleteOneApiKeyDocument = `
    mutation deleteOneApiKey($where: ApiKeyWhereUniqueInput!) {
  deleteOneApiKey(where: $where) {
    id
  }
}
    `;
export const useDeleteOneApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOneApiKeyMutation, TError, DeleteOneApiKeyMutationVariables, TContext>) =>
    useMutation<DeleteOneApiKeyMutation, TError, DeleteOneApiKeyMutationVariables, TContext>(
      ['deleteOneApiKey'],
      useFetchData<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>(DeleteOneApiKeyDocument),
      options
    );
export const SendApiKeyUnlockVerificationEmailDocument = `
    mutation sendApiKeyUnlockVerificationEmail($apiKey: String!) {
  sendApiKeyUnlockVerificationEmail(apiKey: $apiKey) {
    status
  }
}
    `;
export const useSendApiKeyUnlockVerificationEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendApiKeyUnlockVerificationEmailMutation, TError, SendApiKeyUnlockVerificationEmailMutationVariables, TContext>) =>
    useMutation<SendApiKeyUnlockVerificationEmailMutation, TError, SendApiKeyUnlockVerificationEmailMutationVariables, TContext>(
      ['sendApiKeyUnlockVerificationEmail'],
      useFetchData<SendApiKeyUnlockVerificationEmailMutation, SendApiKeyUnlockVerificationEmailMutationVariables>(SendApiKeyUnlockVerificationEmailDocument),
      options
    );
export const VerifyApiKeyUnlockDocument = `
    mutation verifyApiKeyUnlock($apiKey: String!, $code: String!) {
  verifyApiKeyUnlock(apiKey: $apiKey, code: $code) {
    status
  }
}
    `;
export const useVerifyApiKeyUnlockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<VerifyApiKeyUnlockMutation, TError, VerifyApiKeyUnlockMutationVariables, TContext>) =>
    useMutation<VerifyApiKeyUnlockMutation, TError, VerifyApiKeyUnlockMutationVariables, TContext>(
      ['verifyApiKeyUnlock'],
      useFetchData<VerifyApiKeyUnlockMutation, VerifyApiKeyUnlockMutationVariables>(VerifyApiKeyUnlockDocument),
      options
    );
export const GenerateLimitedApiKeyDocument = `
    mutation generateLimitedApiKey($name: String!, $userId: String, $permissions: JSON, $expireOnOrder: Boolean, $voucherId: String) {
  generateApiKey(
    name: $name
    userId: $userId
    permissions: $permissions
    expireOnOrder: $expireOnOrder
    voucherId: $voucherId
  ) {
    apiKey
    id
    createdAt
  }
}
    `;
export const useGenerateLimitedApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateLimitedApiKeyMutation, TError, GenerateLimitedApiKeyMutationVariables, TContext>) =>
    useMutation<GenerateLimitedApiKeyMutation, TError, GenerateLimitedApiKeyMutationVariables, TContext>(
      ['generateLimitedApiKey'],
      useFetchData<GenerateLimitedApiKeyMutation, GenerateLimitedApiKeyMutationVariables>(GenerateLimitedApiKeyDocument),
      options
    );
export const AuditLogsDocument = `
    query auditLogs($where: AuditLogWhereInput, $orderBy: [AuditLogOrderByWithRelationInput!], $take: Int, $skip: Int) {
  auditLogs(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    date
    performerId
    actionContent
  }
  aggregateAuditLog(where: $where) {
    _count {
      _all
    }
  }
}
    `;
export const useAuditLogsQuery = <
      TData = AuditLogsQuery,
      TError = unknown
    >(
      variables?: AuditLogsQueryVariables,
      options?: UseQueryOptions<AuditLogsQuery, TError, TData>
    ) =>
    useQuery<AuditLogsQuery, TError, TData>(
      variables === undefined ? ['auditLogs'] : ['auditLogs', variables],
      useFetchData<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument).bind(null, variables),
      options
    );
useAuditLogsQuery.document = AuditLogsDocument;


useAuditLogsQuery.getKey = (variables?: AuditLogsQueryVariables) => variables === undefined ? ['auditLogs'] : ['auditLogs', variables];
;

export const MeDocument = `
    query me {
  me {
    id
    email
    firstName
    middleName
    lastName
    createdAt
    updatedAt
    dob
    selectedOrganizationId
    organizations {
      id
      name
      legalName
      primaryOrgFor(where: {type: {equals: CRA}}, take: 1) {
        id
      }
    }
    roleAssignment {
      id
      organization {
        id
        name
      }
      roleV2 {
        id
        name
      }
    }
    names {
      id
      firstName
      lastName
      middleName
      type
    }
    ssn {
      id
    }
  }
}
    `;
export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables?: MeQueryVariables,
      options?: UseQueryOptions<MeQuery, TError, TData>
    ) =>
    useQuery<MeQuery, TError, TData>(
      variables === undefined ? ['me'] : ['me', variables],
      useFetchData<MeQuery, MeQueryVariables>(MeDocument).bind(null, variables),
      options
    );
useMeQuery.document = MeDocument;


useMeQuery.getKey = (variables?: MeQueryVariables) => variables === undefined ? ['me'] : ['me', variables];
;

export const CheckEmailVerifiedDocument = `
    query checkEmailVerified {
  checkEmailVerified {
    email
    verified
  }
}
    `;
export const useCheckEmailVerifiedQuery = <
      TData = CheckEmailVerifiedQuery,
      TError = unknown
    >(
      variables?: CheckEmailVerifiedQueryVariables,
      options?: UseQueryOptions<CheckEmailVerifiedQuery, TError, TData>
    ) =>
    useQuery<CheckEmailVerifiedQuery, TError, TData>(
      variables === undefined ? ['checkEmailVerified'] : ['checkEmailVerified', variables],
      useFetchData<CheckEmailVerifiedQuery, CheckEmailVerifiedQueryVariables>(CheckEmailVerifiedDocument).bind(null, variables),
      options
    );
useCheckEmailVerifiedQuery.document = CheckEmailVerifiedDocument;


useCheckEmailVerifiedQuery.getKey = (variables?: CheckEmailVerifiedQueryVariables) => variables === undefined ? ['checkEmailVerified'] : ['checkEmailVerified', variables];
;

export const BeamDocument = `
    query Beam($where: BeamWhereUniqueInput!) {
  beam(where: $where) {
    ...Beam
  }
}
    ${BeamFragmentDoc}`;
export const useBeamQuery = <
      TData = BeamQuery,
      TError = unknown
    >(
      variables: BeamQueryVariables,
      options?: UseQueryOptions<BeamQuery, TError, TData>
    ) =>
    useQuery<BeamQuery, TError, TData>(
      ['Beam', variables],
      useFetchData<BeamQuery, BeamQueryVariables>(BeamDocument).bind(null, variables),
      options
    );
useBeamQuery.document = BeamDocument;


useBeamQuery.getKey = (variables: BeamQueryVariables) => ['Beam', variables];
;

export const BeamListDocument = `
    query BeamList($where: BeamWhereInput) {
  beams(where: $where) {
    id
    name
    description
    organizationId
    updatedAt
    createdAt
    processor
    config
    processorConfig
    latestInputType {
      ...BeamInputType
    }
  }
}
    ${BeamInputTypeFragmentDoc}`;
export const useBeamListQuery = <
      TData = BeamListQuery,
      TError = unknown
    >(
      variables?: BeamListQueryVariables,
      options?: UseQueryOptions<BeamListQuery, TError, TData>
    ) =>
    useQuery<BeamListQuery, TError, TData>(
      variables === undefined ? ['BeamList'] : ['BeamList', variables],
      useFetchData<BeamListQuery, BeamListQueryVariables>(BeamListDocument).bind(null, variables),
      options
    );
useBeamListQuery.document = BeamListDocument;


useBeamListQuery.getKey = (variables?: BeamListQueryVariables) => variables === undefined ? ['BeamList'] : ['BeamList', variables];
;

export const ExtractBeamDataFromImageDocument = `
    mutation extractBeamDataFromImage($imageUrl: String, $beamInputTypeId: String!, $backImageUrl: String, $fileIds: [String!]) {
  extractBeamDataFromImage(
    imageUrl: $imageUrl
    beamInputTypeId: $beamInputTypeId
    backImageUrl: $backImageUrl
    fileIds: $fileIds
  )
}
    `;
export const useExtractBeamDataFromImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExtractBeamDataFromImageMutation, TError, ExtractBeamDataFromImageMutationVariables, TContext>) =>
    useMutation<ExtractBeamDataFromImageMutation, TError, ExtractBeamDataFromImageMutationVariables, TContext>(
      ['extractBeamDataFromImage'],
      useFetchData<ExtractBeamDataFromImageMutation, ExtractBeamDataFromImageMutationVariables>(ExtractBeamDataFromImageDocument),
      options
    );
export const BeamInputTypeDocument = `
    query BeamInputType($where: BeamInputTypeWhereUniqueInput!) {
  beamInputType(where: $where) {
    ...BeamInputType
  }
}
    ${BeamInputTypeFragmentDoc}`;
export const useBeamInputTypeQuery = <
      TData = BeamInputTypeQuery,
      TError = unknown
    >(
      variables: BeamInputTypeQueryVariables,
      options?: UseQueryOptions<BeamInputTypeQuery, TError, TData>
    ) =>
    useQuery<BeamInputTypeQuery, TError, TData>(
      ['BeamInputType', variables],
      useFetchData<BeamInputTypeQuery, BeamInputTypeQueryVariables>(BeamInputTypeDocument).bind(null, variables),
      options
    );
useBeamInputTypeQuery.document = BeamInputTypeDocument;


useBeamInputTypeQuery.getKey = (variables: BeamInputTypeQueryVariables) => ['BeamInputType', variables];
;

export const BeamInputTypesListDocument = `
    query BeamInputTypesList($where: BeamInputTypeWhereInput, $orderBy: [BeamInputTypeOrderByWithRelationInput!], $take: Int, $skip: Int, $distinct: [BeamInputTypeScalarFieldEnum!]) {
  beamInputTypes(
    where: $where
    orderBy: $orderBy
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...BeamInputType
  }
}
    ${BeamInputTypeFragmentDoc}`;
export const useBeamInputTypesListQuery = <
      TData = BeamInputTypesListQuery,
      TError = unknown
    >(
      variables?: BeamInputTypesListQueryVariables,
      options?: UseQueryOptions<BeamInputTypesListQuery, TError, TData>
    ) =>
    useQuery<BeamInputTypesListQuery, TError, TData>(
      variables === undefined ? ['BeamInputTypesList'] : ['BeamInputTypesList', variables],
      useFetchData<BeamInputTypesListQuery, BeamInputTypesListQueryVariables>(BeamInputTypesListDocument).bind(null, variables),
      options
    );
useBeamInputTypesListQuery.document = BeamInputTypesListDocument;


useBeamInputTypesListQuery.getKey = (variables?: BeamInputTypesListQueryVariables) => variables === undefined ? ['BeamInputTypesList'] : ['BeamInputTypesList', variables];
;

export const CredentialsDocument = `
    query credentials($where: CredentialWhereInput) {
  credentials(where: $where) {
    id
    createdAt
    data
    status {
      id
      value
    }
    input {
      type {
        beam {
          name
        }
      }
    }
    type {
      id
      name
    }
    pass {
      passType {
        name
      }
    }
  }
}
    `;
export const useCredentialsQuery = <
      TData = CredentialsQuery,
      TError = unknown
    >(
      variables?: CredentialsQueryVariables,
      options?: UseQueryOptions<CredentialsQuery, TError, TData>
    ) =>
    useQuery<CredentialsQuery, TError, TData>(
      variables === undefined ? ['credentials'] : ['credentials', variables],
      useFetchData<CredentialsQuery, CredentialsQueryVariables>(CredentialsDocument).bind(null, variables),
      options
    );
useCredentialsQuery.document = CredentialsDocument;


useCredentialsQuery.getKey = (variables?: CredentialsQueryVariables) => variables === undefined ? ['credentials'] : ['credentials', variables];
;

export const RetrieveDisclosuresDocument = `
    query RetrieveDisclosures($packageId: String!, $addresses: [DisclosureAddress!]!, $organizationId: String) {
  retrieveDisclosures(
    packageId: $packageId
    addresses: $addresses
    organizationId: $organizationId
  ) {
    id
    location
    locationType
    name
    text
    type
  }
}
    `;
export const useRetrieveDisclosuresQuery = <
      TData = RetrieveDisclosuresQuery,
      TError = unknown
    >(
      variables: RetrieveDisclosuresQueryVariables,
      options?: UseQueryOptions<RetrieveDisclosuresQuery, TError, TData>
    ) =>
    useQuery<RetrieveDisclosuresQuery, TError, TData>(
      ['RetrieveDisclosures', variables],
      useFetchData<RetrieveDisclosuresQuery, RetrieveDisclosuresQueryVariables>(RetrieveDisclosuresDocument).bind(null, variables),
      options
    );
useRetrieveDisclosuresQuery.document = RetrieveDisclosuresDocument;


useRetrieveDisclosuresQuery.getKey = (variables: RetrieveDisclosuresQueryVariables) => ['RetrieveDisclosures', variables];
;

export const RetrieveBiometricDisclosuresDocument = `
    query RetrieveBiometricDisclosures($packageId: String!, $organizationId: String) {
  retrieveBiometricDisclosures(
    packageId: $packageId
    organizationId: $organizationId
  ) {
    id
    location
    locationType
    name
    text
    type
  }
}
    `;
export const useRetrieveBiometricDisclosuresQuery = <
      TData = RetrieveBiometricDisclosuresQuery,
      TError = unknown
    >(
      variables: RetrieveBiometricDisclosuresQueryVariables,
      options?: UseQueryOptions<RetrieveBiometricDisclosuresQuery, TError, TData>
    ) =>
    useQuery<RetrieveBiometricDisclosuresQuery, TError, TData>(
      ['RetrieveBiometricDisclosures', variables],
      useFetchData<RetrieveBiometricDisclosuresQuery, RetrieveBiometricDisclosuresQueryVariables>(RetrieveBiometricDisclosuresDocument).bind(null, variables),
      options
    );
useRetrieveBiometricDisclosuresQuery.document = RetrieveBiometricDisclosuresDocument;


useRetrieveBiometricDisclosuresQuery.getKey = (variables: RetrieveBiometricDisclosuresQueryVariables) => ['RetrieveBiometricDisclosures', variables];
;

export const CreateDisclosureAcceptanceDocument = `
    mutation createDisclosureAcceptance($data: DisclosureAcceptanceArgs!) {
  createDisclosureAcceptance(data: $data) {
    userId
    updatedAt
    signatureSvg
    orderId
    id
    createdAt
  }
}
    `;
export const useCreateDisclosureAcceptanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDisclosureAcceptanceMutation, TError, CreateDisclosureAcceptanceMutationVariables, TContext>) =>
    useMutation<CreateDisclosureAcceptanceMutation, TError, CreateDisclosureAcceptanceMutationVariables, TContext>(
      ['createDisclosureAcceptance'],
      useFetchData<CreateDisclosureAcceptanceMutation, CreateDisclosureAcceptanceMutationVariables>(CreateDisclosureAcceptanceDocument),
      options
    );
export const CreateOneBiometricConsentAcceptanceDocument = `
    mutation createOneBiometricConsentAcceptance($data: BiometricConsentAcceptanceCreateInput!) {
  createOneBiometricConsentAcceptance(data: $data) {
    id
    minorConsentAccepted
    disclosureId
    orderId
  }
}
    `;
export const useCreateOneBiometricConsentAcceptanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneBiometricConsentAcceptanceMutation, TError, CreateOneBiometricConsentAcceptanceMutationVariables, TContext>) =>
    useMutation<CreateOneBiometricConsentAcceptanceMutation, TError, CreateOneBiometricConsentAcceptanceMutationVariables, TContext>(
      ['createOneBiometricConsentAcceptance'],
      useFetchData<CreateOneBiometricConsentAcceptanceMutation, CreateOneBiometricConsentAcceptanceMutationVariables>(CreateOneBiometricConsentAcceptanceDocument),
      options
    );
export const AddBiometricConsentAcceptanceDocument = `
    mutation addBiometricConsentAcceptance($orderId: String!, $biometricConsentAcceptanceId: String!) {
  addBiometricConsentAcceptance(
    orderId: $orderId
    biometricConsentAcceptanceId: $biometricConsentAcceptanceId
  ) {
    fileId
    fileUrl
  }
}
    `;
export const useAddBiometricConsentAcceptanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddBiometricConsentAcceptanceMutation, TError, AddBiometricConsentAcceptanceMutationVariables, TContext>) =>
    useMutation<AddBiometricConsentAcceptanceMutation, TError, AddBiometricConsentAcceptanceMutationVariables, TContext>(
      ['addBiometricConsentAcceptance'],
      useFetchData<AddBiometricConsentAcceptanceMutation, AddBiometricConsentAcceptanceMutationVariables>(AddBiometricConsentAcceptanceDocument),
      options
    );
export const CreateDisputeDocument = `
    mutation CreateDispute($input: DisputeCreateInput!) {
  createOneDispute(data: $input) {
    id
    reason
    status
    consumerName
    consumerEmail
    consumerPhone
    last4Ssn
    dob
    specificItem
    description
    createdAt
    updatedAt
  }
}
    `;
export const useCreateDisputeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDisputeMutation, TError, CreateDisputeMutationVariables, TContext>) =>
    useMutation<CreateDisputeMutation, TError, CreateDisputeMutationVariables, TContext>(
      ['CreateDispute'],
      useFetchData<CreateDisputeMutation, CreateDisputeMutationVariables>(CreateDisputeDocument),
      options
    );
export const CreateOneFileDocument = `
    mutation CreateOneFile($data: FileCreateInput!) {
  createOneFile(data: $data) {
    id
  }
}
    `;
export const useCreateOneFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneFileMutation, TError, CreateOneFileMutationVariables, TContext>) =>
    useMutation<CreateOneFileMutation, TError, CreateOneFileMutationVariables, TContext>(
      ['CreateOneFile'],
      useFetchData<CreateOneFileMutation, CreateOneFileMutationVariables>(CreateOneFileDocument),
      options
    );
export const CreateOneHighlySensitiveIdentifierDocument = `
    mutation CreateOneHighlySensitiveIdentifier($data: HighlySensitiveIdentifierCreateInput!) {
  createOneHighlySensitiveIdentifier(data: $data) {
    id
  }
}
    `;
export const useCreateOneHighlySensitiveIdentifierMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneHighlySensitiveIdentifierMutation, TError, CreateOneHighlySensitiveIdentifierMutationVariables, TContext>) =>
    useMutation<CreateOneHighlySensitiveIdentifierMutation, TError, CreateOneHighlySensitiveIdentifierMutationVariables, TContext>(
      ['CreateOneHighlySensitiveIdentifier'],
      useFetchData<CreateOneHighlySensitiveIdentifierMutation, CreateOneHighlySensitiveIdentifierMutationVariables>(CreateOneHighlySensitiveIdentifierDocument),
      options
    );
export const CreateIdentityRecheckOrderDocument = `
    mutation CreateIdentityRecheckOrder($input: CreateIdentityRecheckOrderInput!) {
  createIdentityRecheckOrder(input: $input) {
    id
    fileNumber
  }
}
    `;
export const useCreateIdentityRecheckOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateIdentityRecheckOrderMutation, TError, CreateIdentityRecheckOrderMutationVariables, TContext>) =>
    useMutation<CreateIdentityRecheckOrderMutation, TError, CreateIdentityRecheckOrderMutationVariables, TContext>(
      ['CreateIdentityRecheckOrder'],
      useFetchData<CreateIdentityRecheckOrderMutation, CreateIdentityRecheckOrderMutationVariables>(CreateIdentityRecheckOrderDocument),
      options
    );
export const CreateOneIdentificationDocumentDocument = `
    mutation createOneIdentificationDocument($data: IdentificationDocumentCreateInput!) {
  createOneIdentificationDocument(data: $data) {
    backImage {
      id
    }
    extractedPhoto {
      id
    }
    frontImage {
      id
    }
    id
    selfieImage {
      id
    }
  }
}
    `;
export const useCreateOneIdentificationDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneIdentificationDocumentMutation, TError, CreateOneIdentificationDocumentMutationVariables, TContext>) =>
    useMutation<CreateOneIdentificationDocumentMutation, TError, CreateOneIdentificationDocumentMutationVariables, TContext>(
      ['createOneIdentificationDocument'],
      useFetchData<CreateOneIdentificationDocumentMutation, CreateOneIdentificationDocumentMutationVariables>(CreateOneIdentificationDocumentDocument),
      options
    );
export const RequestInviteExportDocument = `
    mutation RequestInviteExport($where: VIDVoucherWhereInput!, $orderBy: [VIDVoucherOrderByWithRelationInput!]!, $includeOrganization: Boolean!, $requestId: String!) {
  requestInviteExport(
    where: $where
    orderBy: $orderBy
    includeOrganization: $includeOrganization
    requestId: $requestId
  )
}
    `;
export const useRequestInviteExportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestInviteExportMutation, TError, RequestInviteExportMutationVariables, TContext>) =>
    useMutation<RequestInviteExportMutation, TError, RequestInviteExportMutationVariables, TContext>(
      ['RequestInviteExport'],
      useFetchData<RequestInviteExportMutation, RequestInviteExportMutationVariables>(RequestInviteExportDocument),
      options
    );
export const InviteExportsDocument = `
    query InviteExports {
  inviteExports {
    id
    status
    rows
    createdAt
    expiresAt
  }
}
    `;
export const useInviteExportsQuery = <
      TData = InviteExportsQuery,
      TError = unknown
    >(
      variables?: InviteExportsQueryVariables,
      options?: UseQueryOptions<InviteExportsQuery, TError, TData>
    ) =>
    useQuery<InviteExportsQuery, TError, TData>(
      variables === undefined ? ['InviteExports'] : ['InviteExports', variables],
      useFetchData<InviteExportsQuery, InviteExportsQueryVariables>(InviteExportsDocument).bind(null, variables),
      options
    );
useInviteExportsQuery.document = InviteExportsDocument;


useInviteExportsQuery.getKey = (variables?: InviteExportsQueryVariables) => variables === undefined ? ['InviteExports'] : ['InviteExports', variables];
;

export const DownloadInviteExportDocument = `
    mutation DownloadInviteExport($id: String!) {
  downloadInviteExport(id: $id)
}
    `;
export const useDownloadInviteExportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DownloadInviteExportMutation, TError, DownloadInviteExportMutationVariables, TContext>) =>
    useMutation<DownloadInviteExportMutation, TError, DownloadInviteExportMutationVariables, TContext>(
      ['DownloadInviteExport'],
      useFetchData<DownloadInviteExportMutation, DownloadInviteExportMutationVariables>(DownloadInviteExportDocument),
      options
    );
export const CreateOneNameDocument = `
    mutation CreateOneName($data: NameCreateInput!) {
  createOneName(data: $data) {
    id
  }
}
    `;
export const useCreateOneNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneNameMutation, TError, CreateOneNameMutationVariables, TContext>) =>
    useMutation<CreateOneNameMutation, TError, CreateOneNameMutationVariables, TContext>(
      ['CreateOneName'],
      useFetchData<CreateOneNameMutation, CreateOneNameMutationVariables>(CreateOneNameDocument),
      options
    );
export const OrderListDocument = `
    query orderList($where: OrderWhereInput, $orderBy: [OrderOrderByWithRelationInput!], $cursor: OrderWhereUniqueInput, $take: Int, $skip: Int, $distinct: [OrderScalarFieldEnum!]) {
  orders(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...DashboardOrderList
  }
  aggregateOrder(where: $where) {
    _count {
      _all
    }
  }
}
    ${DashboardOrderListFragmentDoc}`;
export const useOrderListQuery = <
      TData = OrderListQuery,
      TError = unknown
    >(
      variables?: OrderListQueryVariables,
      options?: UseQueryOptions<OrderListQuery, TError, TData>
    ) =>
    useQuery<OrderListQuery, TError, TData>(
      variables === undefined ? ['orderList'] : ['orderList', variables],
      useFetchData<OrderListQuery, OrderListQueryVariables>(OrderListDocument).bind(null, variables),
      options
    );
useOrderListQuery.document = OrderListDocument;


useOrderListQuery.getKey = (variables?: OrderListQueryVariables) => variables === undefined ? ['orderList'] : ['orderList', variables];
;

export const UserOrdersDocument = `
    query UserOrders($where: OrderWhereInput) {
  orders(where: $where) {
    organization {
      name
    }
    beamInputs {
      id
      typeId
      files {
        id
        name
        createdAt
      }
    }
    results {
      searchType
      attachments {
        id
        name
        type
        createdAt
      }
    }
    disclosureAcceptances {
      disclosures {
        id
        name
        createdAt
      }
      pdf {
        id
        name
      }
    }
  }
}
    `;
export const useUserOrdersQuery = <
      TData = UserOrdersQuery,
      TError = unknown
    >(
      variables?: UserOrdersQueryVariables,
      options?: UseQueryOptions<UserOrdersQuery, TError, TData>
    ) =>
    useQuery<UserOrdersQuery, TError, TData>(
      variables === undefined ? ['UserOrders'] : ['UserOrders', variables],
      useFetchData<UserOrdersQuery, UserOrdersQueryVariables>(UserOrdersDocument).bind(null, variables),
      options
    );
useUserOrdersQuery.document = UserOrdersDocument;


useUserOrdersQuery.getKey = (variables?: UserOrdersQueryVariables) => variables === undefined ? ['UserOrders'] : ['UserOrders', variables];
;

export const OrdersDocument = `
    query orders($where: OrderWhereInput, $orderBy: [OrderOrderByWithRelationInput!], $cursor: OrderWhereUniqueInput, $take: Int, $skip: Int, $distinct: [OrderScalarFieldEnum!]) {
  orders(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export const useOrdersQuery = <
      TData = OrdersQuery,
      TError = unknown
    >(
      variables?: OrdersQueryVariables,
      options?: UseQueryOptions<OrdersQuery, TError, TData>
    ) =>
    useQuery<OrdersQuery, TError, TData>(
      variables === undefined ? ['orders'] : ['orders', variables],
      useFetchData<OrdersQuery, OrdersQueryVariables>(OrdersDocument).bind(null, variables),
      options
    );
useOrdersQuery.document = OrdersDocument;


useOrdersQuery.getKey = (variables?: OrdersQueryVariables) => variables === undefined ? ['orders'] : ['orders', variables];
;

export const OrderDocument = `
    query Order($where: OrderWhereUniqueInput!) {
  order(where: $where) {
    files {
      id
      createdAt
      name
      purpose
    }
    status
    score
    userId
    user {
      phone
      email
      dob
      firstName
      lastName
      middleName
    }
  }
}
    `;
export const useOrderQuery = <
      TData = OrderQuery,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options?: UseQueryOptions<OrderQuery, TError, TData>
    ) =>
    useQuery<OrderQuery, TError, TData>(
      ['Order', variables],
      useFetchData<OrderQuery, OrderQueryVariables>(OrderDocument).bind(null, variables),
      options
    );
useOrderQuery.document = OrderDocument;


useOrderQuery.getKey = (variables: OrderQueryVariables) => ['Order', variables];
;

export const CreateManyOrderDocument = `
    mutation createManyOrder($applicants: [JSON!]!, $deliveryMethod: OrderDeliveryMethod!, $packageId: String!, $organizationId: String!, $orderFrom: Platform) {
  createManyOrder(
    applicants: $applicants
    deliveryMethod: $deliveryMethod
    packageId: $packageId
    organizationId: $organizationId
    orderFrom: $orderFrom
  ) {
    status
  }
}
    `;
export const useCreateManyOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateManyOrderMutation, TError, CreateManyOrderMutationVariables, TContext>) =>
    useMutation<CreateManyOrderMutation, TError, CreateManyOrderMutationVariables, TContext>(
      ['createManyOrder'],
      useFetchData<CreateManyOrderMutation, CreateManyOrderMutationVariables>(CreateManyOrderDocument),
      options
    );
export const UpdateOrderDocument = `
    mutation updateOrder($data: OrderUpdateInput!, $where: OrderWhereUniqueInput!) {
  updateOrder(data: $data, where: $where) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;
export const useUpdateOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrderMutation, TError, UpdateOrderMutationVariables, TContext>) =>
    useMutation<UpdateOrderMutation, TError, UpdateOrderMutationVariables, TContext>(
      ['updateOrder'],
      useFetchData<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument),
      options
    );
export const CreateOrderDocument = `
    mutation CreateOrder($data: ExtendedOrderCreateInput!, $orderFrom: Platform, $stateIdentificationCardId: String, $documentId: String, $documentType: String, $documentModel: String, $captureMethod: IdCaptureMethod, $biometricConsentAcceptanceId: String, $beamData: [OrderBeamData!]) {
  createOrder(
    data: $data
    orderFrom: $orderFrom
    stateIdentificationCardId: $stateIdentificationCardId
    documentId: $documentId
    documentType: $documentType
    documentModel: $documentModel
    captureMethod: $captureMethod
    biometricConsentAcceptanceId: $biometricConsentAcceptanceId
    beamData: $beamData
  ) {
    id
    fileNumber
  }
}
    `;
export const useCreateOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrderMutation, TError, CreateOrderMutationVariables, TContext>) =>
    useMutation<CreateOrderMutation, TError, CreateOrderMutationVariables, TContext>(
      ['CreateOrder'],
      useFetchData<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument),
      options
    );
export const CreateOneOrganizationRelationDocument = `
    mutation CreateOneOrganizationRelation($data: OrganizationRelationCreateInput!) {
  createOneOrganizationRelation(data: $data) {
    id
  }
}
    `;
export const useCreateOneOrganizationRelationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneOrganizationRelationMutation, TError, CreateOneOrganizationRelationMutationVariables, TContext>) =>
    useMutation<CreateOneOrganizationRelationMutation, TError, CreateOneOrganizationRelationMutationVariables, TContext>(
      ['CreateOneOrganizationRelation'],
      useFetchData<CreateOneOrganizationRelationMutation, CreateOneOrganizationRelationMutationVariables>(CreateOneOrganizationRelationDocument),
      options
    );
export const DeleteOneOrganizationRelationDocument = `
    mutation DeleteOneOrganizationRelation($where: OrganizationRelationWhereUniqueInput!) {
  deleteOneOrganizationRelation(where: $where) {
    id
  }
}
    `;
export const useDeleteOneOrganizationRelationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOneOrganizationRelationMutation, TError, DeleteOneOrganizationRelationMutationVariables, TContext>) =>
    useMutation<DeleteOneOrganizationRelationMutation, TError, DeleteOneOrganizationRelationMutationVariables, TContext>(
      ['DeleteOneOrganizationRelation'],
      useFetchData<DeleteOneOrganizationRelationMutation, DeleteOneOrganizationRelationMutationVariables>(DeleteOneOrganizationRelationDocument),
      options
    );
export const OrganizationDocument = `
    query organization($organizationId: String, $shortName: String) {
  organization(id: $organizationId, shortName: $shortName) {
    craAccentColor
    craContactEmail
    craHorizontalLogoUrl
    craLogoUrl
    craName
    enableSupport
    hexColor
    horizontalLogoUrl
    id
    logoUrl
    name
    useCraBranding
  }
}
    `;
export const useOrganizationQuery = <
      TData = OrganizationQuery,
      TError = unknown
    >(
      variables?: OrganizationQueryVariables,
      options?: UseQueryOptions<OrganizationQuery, TError, TData>
    ) =>
    useQuery<OrganizationQuery, TError, TData>(
      variables === undefined ? ['organization'] : ['organization', variables],
      useFetchData<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument).bind(null, variables),
      options
    );
useOrganizationQuery.document = OrganizationDocument;


useOrganizationQuery.getKey = (variables?: OrganizationQueryVariables) => variables === undefined ? ['organization'] : ['organization', variables];
;

export const OrganizationsWithCraDocument = `
    query OrganizationsWithCra($where: OrganizationWhereInput) {
  organizations(where: $where) {
    hexColor
    horizontalLogoId
    horizontalLogoUrl
    id
    logoId
    logoUrl
    metadata
    name
    affiliateOrgTo(where: {type: {equals: CRA}}) {
      id
      primaryOrg {
        contactEmail
        horizontalLogoUrl
        id
        logoUrl
        name
        website
      }
    }
  }
}
    `;
export const useOrganizationsWithCraQuery = <
      TData = OrganizationsWithCraQuery,
      TError = unknown
    >(
      variables?: OrganizationsWithCraQueryVariables,
      options?: UseQueryOptions<OrganizationsWithCraQuery, TError, TData>
    ) =>
    useQuery<OrganizationsWithCraQuery, TError, TData>(
      variables === undefined ? ['OrganizationsWithCra'] : ['OrganizationsWithCra', variables],
      useFetchData<OrganizationsWithCraQuery, OrganizationsWithCraQueryVariables>(OrganizationsWithCraDocument).bind(null, variables),
      options
    );
useOrganizationsWithCraQuery.document = OrganizationsWithCraDocument;


useOrganizationsWithCraQuery.getKey = (variables?: OrganizationsWithCraQueryVariables) => variables === undefined ? ['OrganizationsWithCra'] : ['OrganizationsWithCra', variables];
;

export const AffiliateOrgToDocument = `
    query affiliateOrgTo($where: OrganizationWhereInput) {
  organizations(where: $where) {
    id
    name
  }
}
    `;
export const useAffiliateOrgToQuery = <
      TData = AffiliateOrgToQuery,
      TError = unknown
    >(
      variables?: AffiliateOrgToQueryVariables,
      options?: UseQueryOptions<AffiliateOrgToQuery, TError, TData>
    ) =>
    useQuery<AffiliateOrgToQuery, TError, TData>(
      variables === undefined ? ['affiliateOrgTo'] : ['affiliateOrgTo', variables],
      useFetchData<AffiliateOrgToQuery, AffiliateOrgToQueryVariables>(AffiliateOrgToDocument).bind(null, variables),
      options
    );
useAffiliateOrgToQuery.document = AffiliateOrgToDocument;


useAffiliateOrgToQuery.getKey = (variables?: AffiliateOrgToQueryVariables) => variables === undefined ? ['affiliateOrgTo'] : ['affiliateOrgTo', variables];
;

export const OrganizationsDocument = `
    query Organizations($orderBy: [OrganizationOrderByWithRelationInput!], $where: OrganizationWhereInput, $take: Int, $skip: Int) {
  organizations(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
    id
    logoUrl
    name
    shortName
  }
}
    `;
export const useOrganizationsQuery = <
      TData = OrganizationsQuery,
      TError = unknown
    >(
      variables?: OrganizationsQueryVariables,
      options?: UseQueryOptions<OrganizationsQuery, TError, TData>
    ) =>
    useQuery<OrganizationsQuery, TError, TData>(
      variables === undefined ? ['Organizations'] : ['Organizations', variables],
      useFetchData<OrganizationsQuery, OrganizationsQueryVariables>(OrganizationsDocument).bind(null, variables),
      options
    );
useOrganizationsQuery.document = OrganizationsDocument;


useOrganizationsQuery.getKey = (variables?: OrganizationsQueryVariables) => variables === undefined ? ['Organizations'] : ['Organizations', variables];
;

export const OrganizationsWithDetailsDocument = `
    query OrganizationsWithDetails($orderBy: [OrganizationOrderByWithRelationInput!], $where: OrganizationWhereInput, $take: Int, $skip: Int) {
  organizations(orderBy: $orderBy, where: $where, take: $take, skip: $skip) {
    affiliateOrgTo {
      id
      type
      affiliateOrgId
      primaryOrgId
      primaryOrg {
        address {
          addressLineOne
          addressLineTwo
          city
          country
          id
          postalCode
          state
          type
          updatedAt
        }
        contactPhone
        hexColor
        horizontalLogoUrl
        id
        logoUrl
        name
      }
    }
    address {
      addressLineOne
      addressLineTwo
      city
      country
      id
      postalCode
      state
      type
      updatedAt
    }
    website
    contactEmail
    contactName
    contactPhone
    createdAt
    createdById
    deletedAt
    delegateWebhooksToCra
    enableCraDisputeOnBehalfOfApplicant
    enableDisputes
    enableSupport
    hexColor
    horizontalLogoId
    horizontalLogoUrl
    id
    legalName
    logoId
    logoUrl
    metadata
    name
    parentOrganizationId
    shortName
    staticSiteEnabled
    updatedAt
  }
  aggregateOrganization(where: $where, orderBy: $orderBy) {
    _count {
      _all
    }
  }
}
    `;
export const useOrganizationsWithDetailsQuery = <
      TData = OrganizationsWithDetailsQuery,
      TError = unknown
    >(
      variables?: OrganizationsWithDetailsQueryVariables,
      options?: UseQueryOptions<OrganizationsWithDetailsQuery, TError, TData>
    ) =>
    useQuery<OrganizationsWithDetailsQuery, TError, TData>(
      variables === undefined ? ['OrganizationsWithDetails'] : ['OrganizationsWithDetails', variables],
      useFetchData<OrganizationsWithDetailsQuery, OrganizationsWithDetailsQueryVariables>(OrganizationsWithDetailsDocument).bind(null, variables),
      options
    );
useOrganizationsWithDetailsQuery.document = OrganizationsWithDetailsDocument;


useOrganizationsWithDetailsQuery.getKey = (variables?: OrganizationsWithDetailsQueryVariables) => variables === undefined ? ['OrganizationsWithDetails'] : ['OrganizationsWithDetails', variables];
;

export const CreateOneOrganizationDocument = `
    mutation createOneOrganization($data: OrganizationCreateInput!) {
  createOneOrganization(data: $data) {
    delegateWebhooksToCra
    horizontalLogoId
    id
    logoId
    name
    shortName
  }
}
    `;
export const useCreateOneOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneOrganizationMutation, TError, CreateOneOrganizationMutationVariables, TContext>) =>
    useMutation<CreateOneOrganizationMutation, TError, CreateOneOrganizationMutationVariables, TContext>(
      ['createOneOrganization'],
      useFetchData<CreateOneOrganizationMutation, CreateOneOrganizationMutationVariables>(CreateOneOrganizationDocument),
      options
    );
export const UpdateOneOrganizationDocument = `
    mutation updateOneOrganization($data: OrganizationUpdateInput!, $where: OrganizationWhereUniqueInput!) {
  updateOneOrganization(data: $data, where: $where) {
    delegateWebhooksToCra
    id
    logoId
    horizontalLogoId
  }
}
    `;
export const useUpdateOneOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOneOrganizationMutation, TError, UpdateOneOrganizationMutationVariables, TContext>) =>
    useMutation<UpdateOneOrganizationMutation, TError, UpdateOneOrganizationMutationVariables, TContext>(
      ['updateOneOrganization'],
      useFetchData<UpdateOneOrganizationMutation, UpdateOneOrganizationMutationVariables>(UpdateOneOrganizationDocument),
      options
    );
export const DeleteOneOrganizationDocument = `
    mutation deleteOneOrganization($where: OrganizationWhereUniqueInput!) {
  deleteOneOrganization(where: $where) {
    id
  }
}
    `;
export const useDeleteOneOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOneOrganizationMutation, TError, DeleteOneOrganizationMutationVariables, TContext>) =>
    useMutation<DeleteOneOrganizationMutation, TError, DeleteOneOrganizationMutationVariables, TContext>(
      ['deleteOneOrganization'],
      useFetchData<DeleteOneOrganizationMutation, DeleteOneOrganizationMutationVariables>(DeleteOneOrganizationDocument),
      options
    );
export const PackagesForFiltersDocument = `
    query packagesForFilters($where: PackageSetWhereInput) {
  packageSets(where: $where) {
    id
    name
    description
  }
}
    `;
export const usePackagesForFiltersQuery = <
      TData = PackagesForFiltersQuery,
      TError = unknown
    >(
      variables?: PackagesForFiltersQueryVariables,
      options?: UseQueryOptions<PackagesForFiltersQuery, TError, TData>
    ) =>
    useQuery<PackagesForFiltersQuery, TError, TData>(
      variables === undefined ? ['packagesForFilters'] : ['packagesForFilters', variables],
      useFetchData<PackagesForFiltersQuery, PackagesForFiltersQueryVariables>(PackagesForFiltersDocument).bind(null, variables),
      options
    );
usePackagesForFiltersQuery.document = PackagesForFiltersDocument;


usePackagesForFiltersQuery.getKey = (variables?: PackagesForFiltersQueryVariables) => variables === undefined ? ['packagesForFilters'] : ['packagesForFilters', variables];
;

export const GetPackageNameDocument = `
    query GetPackageName($where: PackageSetWhereUniqueInput!) {
  packageSet(where: $where) {
    id
    name
  }
}
    `;
export const useGetPackageNameQuery = <
      TData = GetPackageNameQuery,
      TError = unknown
    >(
      variables: GetPackageNameQueryVariables,
      options?: UseQueryOptions<GetPackageNameQuery, TError, TData>
    ) =>
    useQuery<GetPackageNameQuery, TError, TData>(
      ['GetPackageName', variables],
      useFetchData<GetPackageNameQuery, GetPackageNameQueryVariables>(GetPackageNameDocument).bind(null, variables),
      options
    );
useGetPackageNameQuery.document = GetPackageNameDocument;


useGetPackageNameQuery.getKey = (variables: GetPackageNameQueryVariables) => ['GetPackageName', variables];
;

export const PackageSetDocument = `
    query packageSet($where: PackageSetWhereUniqueInput!) {
  packageSet(where: $where) {
    id
    name
    metadata
  }
}
    `;
export const usePackageSetQuery = <
      TData = PackageSetQuery,
      TError = unknown
    >(
      variables: PackageSetQueryVariables,
      options?: UseQueryOptions<PackageSetQuery, TError, TData>
    ) =>
    useQuery<PackageSetQuery, TError, TData>(
      ['packageSet', variables],
      useFetchData<PackageSetQuery, PackageSetQueryVariables>(PackageSetDocument).bind(null, variables),
      options
    );
usePackageSetQuery.document = PackageSetDocument;


usePackageSetQuery.getKey = (variables: PackageSetQueryVariables) => ['packageSet', variables];
;

export const PackageSetsDocument = `
    query packageSets($where: PackageSetWhereInput, $orderBy: [PackageSetOrderByWithRelationInput!], $cursor: PackageSetWhereUniqueInput, $take: Int, $skip: Int, $distinct: [PackageSetScalarFieldEnum!]) {
  packageSets(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    ...PackageSet
  }
}
    ${PackageSetFragmentDoc}`;
export const usePackageSetsQuery = <
      TData = PackageSetsQuery,
      TError = unknown
    >(
      variables?: PackageSetsQueryVariables,
      options?: UseQueryOptions<PackageSetsQuery, TError, TData>
    ) =>
    useQuery<PackageSetsQuery, TError, TData>(
      variables === undefined ? ['packageSets'] : ['packageSets', variables],
      useFetchData<PackageSetsQuery, PackageSetsQueryVariables>(PackageSetsDocument).bind(null, variables),
      options
    );
usePackageSetsQuery.document = PackageSetsDocument;


usePackageSetsQuery.getKey = (variables?: PackageSetsQueryVariables) => variables === undefined ? ['packageSets'] : ['packageSets', variables];
;

export const PackageAccessesDocument = `
    query PackageAccesses($where: PackageAccessWhereInput) {
  packageAccesses(where: $where) {
    id
    packageSet {
      id
      name
      organization {
        id
        name
      }
      searchTypes {
        id
        name
      }
    }
  }
}
    `;
export const usePackageAccessesQuery = <
      TData = PackageAccessesQuery,
      TError = unknown
    >(
      variables?: PackageAccessesQueryVariables,
      options?: UseQueryOptions<PackageAccessesQuery, TError, TData>
    ) =>
    useQuery<PackageAccessesQuery, TError, TData>(
      variables === undefined ? ['PackageAccesses'] : ['PackageAccesses', variables],
      useFetchData<PackageAccessesQuery, PackageAccessesQueryVariables>(PackageAccessesDocument).bind(null, variables),
      options
    );
usePackageAccessesQuery.document = PackageAccessesDocument;


usePackageAccessesQuery.getKey = (variables?: PackageAccessesQueryVariables) => variables === undefined ? ['PackageAccesses'] : ['PackageAccesses', variables];
;

export const PassTypeDocument = `
    query PassType($where: PassTypeWhereUniqueInput!) {
  passType(where: $where) {
    id
    slug
    brandColor
    organizationId
    createdAt
  }
}
    `;
export const usePassTypeQuery = <
      TData = PassTypeQuery,
      TError = unknown
    >(
      variables: PassTypeQueryVariables,
      options?: UseQueryOptions<PassTypeQuery, TError, TData>
    ) =>
    useQuery<PassTypeQuery, TError, TData>(
      ['PassType', variables],
      useFetchData<PassTypeQuery, PassTypeQueryVariables>(PassTypeDocument).bind(null, variables),
      options
    );
usePassTypeQuery.document = PassTypeDocument;


usePassTypeQuery.getKey = (variables: PassTypeQueryVariables) => ['PassType', variables];
;

export const PassDetailDocument = `
    query passDetail($where: PassWhereUniqueInput!) {
  pass(where: $where) {
    id
    passType {
      id
      name
      organization {
        id
        name
        legalName
      }
    }
    inputs {
      id
      createdAt
      type {
        beam {
          id
          name
        }
      }
      credential {
        id
        status {
          value
        }
      }
    }
    user {
      id
      email
      names(where: {type: {equals: PRIMARY}}, take: 1) {
        firstName
        lastName
        middleName
      }
      stateIdentificationCards(take: 1, orderBy: {createdAt: desc}) {
        selfieImage {
          id
        }
      }
      passports(take: 1, orderBy: {createdAt: desc}) {
        selfieImage {
          id
        }
      }
    }
  }
}
    `;
export const usePassDetailQuery = <
      TData = PassDetailQuery,
      TError = unknown
    >(
      variables: PassDetailQueryVariables,
      options?: UseQueryOptions<PassDetailQuery, TError, TData>
    ) =>
    useQuery<PassDetailQuery, TError, TData>(
      ['passDetail', variables],
      useFetchData<PassDetailQuery, PassDetailQueryVariables>(PassDetailDocument).bind(null, variables),
      options
    );
usePassDetailQuery.document = PassDetailDocument;


usePassDetailQuery.getKey = (variables: PassDetailQueryVariables) => ['passDetail', variables];
;

export const PassesDocument = `
    query passes($where: PassWhereInput) {
  passes(where: $where) {
    createdAt
    id
    passType {
      name
      organization {
        name
      }
    }
    inputs {
      credential {
        id
        status {
          value
        }
      }
    }
  }
}
    `;
export const usePassesQuery = <
      TData = PassesQuery,
      TError = unknown
    >(
      variables?: PassesQueryVariables,
      options?: UseQueryOptions<PassesQuery, TError, TData>
    ) =>
    useQuery<PassesQuery, TError, TData>(
      variables === undefined ? ['passes'] : ['passes', variables],
      useFetchData<PassesQuery, PassesQueryVariables>(PassesDocument).bind(null, variables),
      options
    );
usePassesQuery.document = PassesDocument;


usePassesQuery.getKey = (variables?: PassesQueryVariables) => variables === undefined ? ['passes'] : ['passes', variables];
;

export const PassTypesDocument = `
    query PassTypes($where: PassTypeWhereInput) {
  passTypes(where: $where) {
    name
    id
  }
}
    `;
export const usePassTypesQuery = <
      TData = PassTypesQuery,
      TError = unknown
    >(
      variables?: PassTypesQueryVariables,
      options?: UseQueryOptions<PassTypesQuery, TError, TData>
    ) =>
    useQuery<PassTypesQuery, TError, TData>(
      variables === undefined ? ['PassTypes'] : ['PassTypes', variables],
      useFetchData<PassTypesQuery, PassTypesQueryVariables>(PassTypesDocument).bind(null, variables),
      options
    );
usePassTypesQuery.document = PassTypesDocument;


usePassTypesQuery.getKey = (variables?: PassTypesQueryVariables) => variables === undefined ? ['PassTypes'] : ['PassTypes', variables];
;

export const PassDocument = `
    query Pass($where: PassWhereUniqueInput!) {
  pass(where: $where) {
    passType {
      brandColor
      id
      name
      organization {
        id
        logoUrl
        name
      }
    }
    inputs {
      id
      data
      type {
        beam {
          name
        }
      }
      credential {
        id
        data
        status {
          createdAt
          updatedAt
          value
        }
        type {
          createdAt
          name
          beam {
            name
          }
        }
      }
      order {
        createdAt
      }
    }
    updatedAt
    id
  }
}
    `;
export const usePassQuery = <
      TData = PassQuery,
      TError = unknown
    >(
      variables: PassQueryVariables,
      options?: UseQueryOptions<PassQuery, TError, TData>
    ) =>
    useQuery<PassQuery, TError, TData>(
      ['Pass', variables],
      useFetchData<PassQuery, PassQueryVariables>(PassDocument).bind(null, variables),
      options
    );
usePassQuery.document = PassDocument;


usePassQuery.getKey = (variables: PassQueryVariables) => ['Pass', variables];
;

export const VIdReportDocument = `
    query vIDReport($where: VIDVoucherWhereInput!, $notesWhere2: OrderNoteWhereInput) {
  vIDVouchers(where: $where) {
    order {
      id
      createdAt
      score
      status
      notes(where: $notesWhere2) {
        createdAt
        message
        id
      }
    }
    id
    createdAt
    invite {
      id
      createdAt
      redeemedAt
    }
  }
}
    `;
export const useVIdReportQuery = <
      TData = VIdReportQuery,
      TError = unknown
    >(
      variables: VIdReportQueryVariables,
      options?: UseQueryOptions<VIdReportQuery, TError, TData>
    ) =>
    useQuery<VIdReportQuery, TError, TData>(
      ['vIDReport', variables],
      useFetchData<VIdReportQuery, VIdReportQueryVariables>(VIdReportDocument).bind(null, variables),
      options
    );
useVIdReportQuery.document = VIdReportDocument;


useVIdReportQuery.getKey = (variables: VIdReportQueryVariables) => ['vIDReport', variables];
;

export const RolesDocument = `
    query roles($where: RoleV2WhereInput) {
  roleV2s(where: $where) {
    createdAt
    id
    name
    updatedAt
  }
}
    `;
export const useRolesQuery = <
      TData = RolesQuery,
      TError = unknown
    >(
      variables?: RolesQueryVariables,
      options?: UseQueryOptions<RolesQuery, TError, TData>
    ) =>
    useQuery<RolesQuery, TError, TData>(
      variables === undefined ? ['roles'] : ['roles', variables],
      useFetchData<RolesQuery, RolesQueryVariables>(RolesDocument).bind(null, variables),
      options
    );
useRolesQuery.document = RolesDocument;


useRolesQuery.getKey = (variables?: RolesQueryVariables) => variables === undefined ? ['roles'] : ['roles', variables];
;

export const GetSvixAppPortalUrlDocument = `
    query getSvixAppPortalUrl($organizationId: String!) {
  getSvixAppPortalUrl(organizationId: $organizationId) {
    svixAppPortalUrl
  }
}
    `;
export const useGetSvixAppPortalUrlQuery = <
      TData = GetSvixAppPortalUrlQuery,
      TError = unknown
    >(
      variables: GetSvixAppPortalUrlQueryVariables,
      options?: UseQueryOptions<GetSvixAppPortalUrlQuery, TError, TData>
    ) =>
    useQuery<GetSvixAppPortalUrlQuery, TError, TData>(
      ['getSvixAppPortalUrl', variables],
      useFetchData<GetSvixAppPortalUrlQuery, GetSvixAppPortalUrlQueryVariables>(GetSvixAppPortalUrlDocument).bind(null, variables),
      options
    );
useGetSvixAppPortalUrlQuery.document = GetSvixAppPortalUrlDocument;


useGetSvixAppPortalUrlQuery.getKey = (variables: GetSvixAppPortalUrlQueryVariables) => ['getSvixAppPortalUrl', variables];
;

export const UpdateUserDocument = `
    mutation UpdateUser($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
  updateUser(data: $data, where: $where) {
    id
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['UpdateUser'],
      useFetchData<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument),
      options
    );
export const UpdateOneUserDocument = `
    mutation UpdateOneUser($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
  updateOneUser(data: $data, where: $where) {
    id
    roleAssignment {
      id
      organizationId
      roleV2 {
        id
        name
      }
    }
    organizations {
      id
    }
  }
}
    `;
export const useUpdateOneUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOneUserMutation, TError, UpdateOneUserMutationVariables, TContext>) =>
    useMutation<UpdateOneUserMutation, TError, UpdateOneUserMutationVariables, TContext>(
      ['UpdateOneUser'],
      useFetchData<UpdateOneUserMutation, UpdateOneUserMutationVariables>(UpdateOneUserDocument),
      options
    );
export const VidUserDetailsDocument = `
    query VidUserDetails {
  me {
    id
    dob
    names {
      id
      firstName
      middleName
      lastName
      type
    }
    addresses {
      id
      addressLineOne
      addressLineTwo
      city
      state
      postalCode
      country
      type
    }
  }
}
    `;
export const useVidUserDetailsQuery = <
      TData = VidUserDetailsQuery,
      TError = unknown
    >(
      variables?: VidUserDetailsQueryVariables,
      options?: UseQueryOptions<VidUserDetailsQuery, TError, TData>
    ) =>
    useQuery<VidUserDetailsQuery, TError, TData>(
      variables === undefined ? ['VidUserDetails'] : ['VidUserDetails', variables],
      useFetchData<VidUserDetailsQuery, VidUserDetailsQueryVariables>(VidUserDetailsDocument).bind(null, variables),
      options
    );
useVidUserDetailsQuery.document = VidUserDetailsDocument;


useVidUserDetailsQuery.getKey = (variables?: VidUserDetailsQueryVariables) => variables === undefined ? ['VidUserDetails'] : ['VidUserDetails', variables];
;

export const UserCardDocument = `
    query UserCard($where: UserWhereUniqueInput!, $orderWhere: OrderWhereInput!) {
  user(where: $where) {
    createdAt
    dob
    email
    firstName
    lastName
    middleName
    phone
    myOrders(where: $orderWhere) {
      score
    }
    stateIdentificationCards {
      id
      selfieImage {
        id
      }
    }
  }
}
    `;
export const useUserCardQuery = <
      TData = UserCardQuery,
      TError = unknown
    >(
      variables: UserCardQueryVariables,
      options?: UseQueryOptions<UserCardQuery, TError, TData>
    ) =>
    useQuery<UserCardQuery, TError, TData>(
      ['UserCard', variables],
      useFetchData<UserCardQuery, UserCardQueryVariables>(UserCardDocument).bind(null, variables),
      options
    );
useUserCardQuery.document = UserCardDocument;


useUserCardQuery.getKey = (variables: UserCardQueryVariables) => ['UserCard', variables];
;

export const SelfieImageDocument = `
    query selfieImage($where: FileWhereUniqueInput!) {
  selfieImage: file(where: $where) {
    id
    url
  }
}
    `;
export const useSelfieImageQuery = <
      TData = SelfieImageQuery,
      TError = unknown
    >(
      variables: SelfieImageQueryVariables,
      options?: UseQueryOptions<SelfieImageQuery, TError, TData>
    ) =>
    useQuery<SelfieImageQuery, TError, TData>(
      ['selfieImage', variables],
      useFetchData<SelfieImageQuery, SelfieImageQueryVariables>(SelfieImageDocument).bind(null, variables),
      options
    );
useSelfieImageQuery.document = SelfieImageDocument;


useSelfieImageQuery.getKey = (variables: SelfieImageQueryVariables) => ['selfieImage', variables];
;

export const FindUserDocument = `
    query findUser($where: UserWhereUniqueInput!) {
  user(where: $where) {
    id
    email
    firstName
    lastName
    middleName
    createdAt
    updatedAt
    selectedOrganizationId
  }
}
    `;
export const useFindUserQuery = <
      TData = FindUserQuery,
      TError = unknown
    >(
      variables: FindUserQueryVariables,
      options?: UseQueryOptions<FindUserQuery, TError, TData>
    ) =>
    useQuery<FindUserQuery, TError, TData>(
      ['findUser', variables],
      useFetchData<FindUserQuery, FindUserQueryVariables>(FindUserDocument).bind(null, variables),
      options
    );
useFindUserQuery.document = FindUserDocument;


useFindUserQuery.getKey = (variables: FindUserQueryVariables) => ['findUser', variables];
;

export const UserPermissionsDocument = `
    query UserPermissions($where: UserWhereUniqueInput!) {
  user(where: $where) {
    id
    email
    permissionEditor {
      canEditNames
      canManagePermissions
      canManageAllOrganizations
      editableOrganizationIds
      assignableRoles
    }
    names {
      id
      firstName
      lastName
      middleName
      type
    }
    roleAssignment {
      id
      organizationId
      organization {
        id
        name
      }
      roleV2 {
        id
        name
      }
    }
  }
}
    `;
export const useUserPermissionsQuery = <
      TData = UserPermissionsQuery,
      TError = unknown
    >(
      variables: UserPermissionsQueryVariables,
      options?: UseQueryOptions<UserPermissionsQuery, TError, TData>
    ) =>
    useQuery<UserPermissionsQuery, TError, TData>(
      ['UserPermissions', variables],
      useFetchData<UserPermissionsQuery, UserPermissionsQueryVariables>(UserPermissionsDocument).bind(null, variables),
      options
    );
useUserPermissionsQuery.document = UserPermissionsDocument;


useUserPermissionsQuery.getKey = (variables: UserPermissionsQueryVariables) => ['UserPermissions', variables];
;

export const UpdateUserPermissionsDocument = `
    mutation UpdateUserPermissions($input: UserPermissionsInput!) {
  updateUserPermissions(input: $input) {
    userId
  }
}
    `;
export const useUpdateUserPermissionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserPermissionsMutation, TError, UpdateUserPermissionsMutationVariables, TContext>) =>
    useMutation<UpdateUserPermissionsMutation, TError, UpdateUserPermissionsMutationVariables, TContext>(
      ['UpdateUserPermissions'],
      useFetchData<UpdateUserPermissionsMutation, UpdateUserPermissionsMutationVariables>(UpdateUserPermissionsDocument),
      options
    );
export const UsersDocument = `
    query Users($where: UserWhereInput, $take: Int, $skip: Int, $orderBy: [UserOrderByWithRelationInput!], $roleWhere: RoleAssignmentWhereInput) {
  users(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    email
    _count {
      organizations
    }
    names {
      id
      firstName
      lastName
      middleName
      type
    }
    organizations(take: 1) {
      id
      name
    }
    roleAssignment(where: $roleWhere, take: 2) {
      organizationId
      roleV2 {
        name
      }
    }
  }
  aggregateUser(where: $where) {
    _count {
      _all
    }
  }
}
    `;
export const useUsersQuery = <
      TData = UsersQuery,
      TError = unknown
    >(
      variables?: UsersQueryVariables,
      options?: UseQueryOptions<UsersQuery, TError, TData>
    ) =>
    useQuery<UsersQuery, TError, TData>(
      variables === undefined ? ['Users'] : ['Users', variables],
      useFetchData<UsersQuery, UsersQueryVariables>(UsersDocument).bind(null, variables),
      options
    );
useUsersQuery.document = UsersDocument;


useUsersQuery.getKey = (variables?: UsersQueryVariables) => variables === undefined ? ['Users'] : ['Users', variables];
;

export const CreateSupportTicketDocument = `
    mutation createSupportTicket($email: String, $description: String!, $purpose: SupportTicketPurpose, $captchaResponse: String) {
  createSupportTicket(
    email: $email
    description: $description
    purpose: $purpose
    captchaResponse: $captchaResponse
  ) {
    success
    ticketId
  }
}
    `;
export const useCreateSupportTicketMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSupportTicketMutation, TError, CreateSupportTicketMutationVariables, TContext>) =>
    useMutation<CreateSupportTicketMutation, TError, CreateSupportTicketMutationVariables, TContext>(
      ['createSupportTicket'],
      useFetchData<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(CreateSupportTicketDocument),
      options
    );
export const DoesUserExistDocument = `
    mutation doesUserExist($email: String!) {
  doesUserExist(email: $email)
}
    `;
export const useDoesUserExistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DoesUserExistMutation, TError, DoesUserExistMutationVariables, TContext>) =>
    useMutation<DoesUserExistMutation, TError, DoesUserExistMutationVariables, TContext>(
      ['doesUserExist'],
      useFetchData<DoesUserExistMutation, DoesUserExistMutationVariables>(DoesUserExistDocument),
      options
    );
export const CreateOneAppFeedbackDocument = `
    mutation createOneAppFeedback($data: AppFeedbackCreateInput!) {
  createOneAppFeedback(data: $data) {
    id
    userId
  }
}
    `;
export const useCreateOneAppFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneAppFeedbackMutation, TError, CreateOneAppFeedbackMutationVariables, TContext>) =>
    useMutation<CreateOneAppFeedbackMutation, TError, CreateOneAppFeedbackMutationVariables, TContext>(
      ['createOneAppFeedback'],
      useFetchData<CreateOneAppFeedbackMutation, CreateOneAppFeedbackMutationVariables>(CreateOneAppFeedbackDocument),
      options
    );
export const CreateOneStateIdentificationCardDocument = `
    mutation CreateOneStateIdentificationCard($data: StateIdentificationCardCreateInput!) {
  createOneStateIdentificationCard(data: $data) {
    id
    selfieImage {
      id
    }
    extractedPhoto {
      id
    }
    frontImage {
      id
    }
    backImage {
      id
    }
  }
}
    `;
export const useCreateOneStateIdentificationCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneStateIdentificationCardMutation, TError, CreateOneStateIdentificationCardMutationVariables, TContext>) =>
    useMutation<CreateOneStateIdentificationCardMutation, TError, CreateOneStateIdentificationCardMutationVariables, TContext>(
      ['CreateOneStateIdentificationCard'],
      useFetchData<CreateOneStateIdentificationCardMutation, CreateOneStateIdentificationCardMutationVariables>(CreateOneStateIdentificationCardDocument),
      options
    );
export const UpdateOnePassportDocument = `
    mutation UpdateOnePassport($data: PassportUpdateInput!, $where: PassportWhereUniqueInput!) {
  updateOnePassport(data: $data, where: $where) {
    id
  }
}
    `;
export const useUpdateOnePassportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOnePassportMutation, TError, UpdateOnePassportMutationVariables, TContext>) =>
    useMutation<UpdateOnePassportMutation, TError, UpdateOnePassportMutationVariables, TContext>(
      ['UpdateOnePassport'],
      useFetchData<UpdateOnePassportMutation, UpdateOnePassportMutationVariables>(UpdateOnePassportDocument),
      options
    );
export const CreateOnePassportDocument = `
    mutation CreateOnePassport($data: PassportCreateInput!) {
  createOnePassport(data: $data) {
    id
    selfieImage {
      id
    }
    extractedPhoto {
      id
    }
    frontImage {
      id
    }
    backImage {
      id
    }
  }
}
    `;
export const useCreateOnePassportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOnePassportMutation, TError, CreateOnePassportMutationVariables, TContext>) =>
    useMutation<CreateOnePassportMutation, TError, CreateOnePassportMutationVariables, TContext>(
      ['CreateOnePassport'],
      useFetchData<CreateOnePassportMutation, CreateOnePassportMutationVariables>(CreateOnePassportDocument),
      options
    );
export const UpdateOneStateIdentificationCardDocument = `
    mutation UpdateOneStateIdentificationCard($where: StateIdentificationCardWhereUniqueInput!, $data: StateIdentificationCardUpdateInput!) {
  updateOneStateIdentificationCard(where: $where, data: $data) {
    id
  }
}
    `;
export const useUpdateOneStateIdentificationCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOneStateIdentificationCardMutation, TError, UpdateOneStateIdentificationCardMutationVariables, TContext>) =>
    useMutation<UpdateOneStateIdentificationCardMutation, TError, UpdateOneStateIdentificationCardMutationVariables, TContext>(
      ['UpdateOneStateIdentificationCard'],
      useFetchData<UpdateOneStateIdentificationCardMutation, UpdateOneStateIdentificationCardMutationVariables>(UpdateOneStateIdentificationCardDocument),
      options
    );
export const AcceptInviteDocument = `
    mutation AcceptInvite($inviteId: String!) {
  acceptInvite(inviteId: $inviteId) {
    email
    id
    organizationId
    redeemedAt
    redeemedById
    senderId
    vidVoucherId
  }
}
    `;
export const useAcceptInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptInviteMutation, TError, AcceptInviteMutationVariables, TContext>) =>
    useMutation<AcceptInviteMutation, TError, AcceptInviteMutationVariables, TContext>(
      ['AcceptInvite'],
      useFetchData<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument),
      options
    );
export const StartVidFlowDocument = `
    mutation StartVidFlow($voucherId: String!) {
  startVidFlow(voucherId: $voucherId) {
    id
    status
    startedAt
  }
}
    `;
export const useStartVidFlowMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartVidFlowMutation, TError, StartVidFlowMutationVariables, TContext>) =>
    useMutation<StartVidFlowMutation, TError, StartVidFlowMutationVariables, TContext>(
      ['StartVidFlow'],
      useFetchData<StartVidFlowMutation, StartVidFlowMutationVariables>(StartVidFlowDocument),
      options
    );
export const VidVoucherDocument = `
    query VIDVoucher($where: VIDVoucherWhereUniqueInput!) {
  vIDVoucher(where: $where) {
    clientMetadata
    createdAt
    email
    id
    inviteId
    orderId
    organizationId
    packageSetId
    postbackUrl
    status
    startedAt
    updatedAt
    passTypeId
    userId
    onSubmitReturnUrl
    expiresAt
    packageSet {
      id
      collectSSN
      showDisclosures
      useSampleId
      searchTypes {
        id
        name
      }
      metadata
    }
  }
}
    `;
export const useVidVoucherQuery = <
      TData = VidVoucherQuery,
      TError = unknown
    >(
      variables: VidVoucherQueryVariables,
      options?: UseQueryOptions<VidVoucherQuery, TError, TData>
    ) =>
    useQuery<VidVoucherQuery, TError, TData>(
      ['VIDVoucher', variables],
      useFetchData<VidVoucherQuery, VidVoucherQueryVariables>(VidVoucherDocument).bind(null, variables),
      options
    );
useVidVoucherQuery.document = VidVoucherDocument;


useVidVoucherQuery.getKey = (variables: VidVoucherQueryVariables) => ['VIDVoucher', variables];
;

export const VidVouchersDocument = `
    query VIDVouchers($where: VIDVoucherWhereInput!, $orderBy: [VIDVoucherOrderByWithRelationInput!], $cursor: VIDVoucherWhereUniqueInput, $take: Int, $skip: Int, $packageSetsWhere: PackageSetWhereInput!) {
  vIDVouchers(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    branchIOShortCode
    clientMetadata
    createdAt
    dateOfBirth
    email
    expiresAt
    fileNumber
    firstName
    id
    inviteId
    lastName
    middleName
    orderId
    organizationId
    packageSetId
    phoneNumber
    postbackUrl
    primaryContactMethod
    status
    suffix
    updatedAt
    userId
    onSubmitReturnUrl
    origin
  }
  packageSets(where: $packageSetsWhere) {
    description
    id
    name
  }
  aggregateVIDVoucher(where: $where, orderBy: $orderBy, cursor: $cursor) {
    _count {
      _all
    }
  }
}
    `;
export const useVidVouchersQuery = <
      TData = VidVouchersQuery,
      TError = unknown
    >(
      variables: VidVouchersQueryVariables,
      options?: UseQueryOptions<VidVouchersQuery, TError, TData>
    ) =>
    useQuery<VidVouchersQuery, TError, TData>(
      ['VIDVouchers', variables],
      useFetchData<VidVouchersQuery, VidVouchersQueryVariables>(VidVouchersDocument).bind(null, variables),
      options
    );
useVidVouchersQuery.document = VidVouchersDocument;


useVidVouchersQuery.getKey = (variables: VidVouchersQueryVariables) => ['VIDVouchers', variables];
;

export const ResumableVidVouchersDocument = `
    query ResumableVIDVouchers($where: VIDVoucherWhereInput!, $orderBy: [VIDVoucherOrderByWithRelationInput!], $take: Int) {
  vIDVouchers(where: $where, orderBy: $orderBy, take: $take) {
    createdAt
    expiresAt
    id
    orderId
    status
  }
}
    `;
export const useResumableVidVouchersQuery = <
      TData = ResumableVidVouchersQuery,
      TError = unknown
    >(
      variables: ResumableVidVouchersQueryVariables,
      options?: UseQueryOptions<ResumableVidVouchersQuery, TError, TData>
    ) =>
    useQuery<ResumableVidVouchersQuery, TError, TData>(
      ['ResumableVIDVouchers', variables],
      useFetchData<ResumableVidVouchersQuery, ResumableVidVouchersQueryVariables>(ResumableVidVouchersDocument).bind(null, variables),
      options
    );
useResumableVidVouchersQuery.document = ResumableVidVouchersDocument;


useResumableVidVouchersQuery.getKey = (variables: ResumableVidVouchersQueryVariables) => ['ResumableVIDVouchers', variables];
;

export const GetInviteCountDocument = `
    query GetInviteCount($where: VIDVoucherWhereInput) {
  aggregateVIDVoucher(where: $where) {
    _count {
      _all
    }
  }
}
    `;
export const useGetInviteCountQuery = <
      TData = GetInviteCountQuery,
      TError = unknown
    >(
      variables?: GetInviteCountQueryVariables,
      options?: UseQueryOptions<GetInviteCountQuery, TError, TData>
    ) =>
    useQuery<GetInviteCountQuery, TError, TData>(
      variables === undefined ? ['GetInviteCount'] : ['GetInviteCount', variables],
      useFetchData<GetInviteCountQuery, GetInviteCountQueryVariables>(GetInviteCountDocument).bind(null, variables),
      options
    );
useGetInviteCountQuery.document = GetInviteCountDocument;


useGetInviteCountQuery.getKey = (variables?: GetInviteCountQueryVariables) => variables === undefined ? ['GetInviteCount'] : ['GetInviteCount', variables];
;

export const CheckVoucherValidityDocument = `
    query CheckVoucherValidity($voucherId: String!) {
  checkVoucherValidity(voucherId: $voucherId) {
    clientMetadata
    createdAt
    email
    expiresAt
    id
    inviteId
    orderId
    organizationId
    packageSet {
      id
      collectSSN
      showDisclosures
      useSampleId
      searchTypes {
        id
        name
      }
      metadata
    }
    packageSetId
    postbackUrl
    status
    startedAt
    updatedAt
    passTypeId
    userId
    onSubmitReturnUrl
  }
}
    `;
export const useCheckVoucherValidityQuery = <
      TData = CheckVoucherValidityQuery,
      TError = unknown
    >(
      variables: CheckVoucherValidityQueryVariables,
      options?: UseQueryOptions<CheckVoucherValidityQuery, TError, TData>
    ) =>
    useQuery<CheckVoucherValidityQuery, TError, TData>(
      ['CheckVoucherValidity', variables],
      useFetchData<CheckVoucherValidityQuery, CheckVoucherValidityQueryVariables>(CheckVoucherValidityDocument).bind(null, variables),
      options
    );
useCheckVoucherValidityQuery.document = CheckVoucherValidityDocument;


useCheckVoucherValidityQuery.getKey = (variables: CheckVoucherValidityQueryVariables) => ['CheckVoucherValidity', variables];
;

export const OptOutVoucherDocument = `
    mutation optOutVoucher($voucherId: String!, $optOutReason: String) {
  optOutVoucher(voucherId: $voucherId, optOutReason: $optOutReason) {
    id
    status
  }
}
    `;
export const useOptOutVoucherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OptOutVoucherMutation, TError, OptOutVoucherMutationVariables, TContext>) =>
    useMutation<OptOutVoucherMutation, TError, OptOutVoucherMutationVariables, TContext>(
      ['optOutVoucher'],
      useFetchData<OptOutVoucherMutation, OptOutVoucherMutationVariables>(OptOutVoucherDocument),
      options
    );
export const GetInviteDocument = `
    query GetInvite($inviteId: String!) {
  getInvite(inviteId: $inviteId) {
    redeemedById
    redeemedAt
  }
}
    `;
export const useGetInviteQuery = <
      TData = GetInviteQuery,
      TError = unknown
    >(
      variables: GetInviteQueryVariables,
      options?: UseQueryOptions<GetInviteQuery, TError, TData>
    ) =>
    useQuery<GetInviteQuery, TError, TData>(
      ['GetInvite', variables],
      useFetchData<GetInviteQuery, GetInviteQueryVariables>(GetInviteDocument).bind(null, variables),
      options
    );
useGetInviteQuery.document = GetInviteDocument;


useGetInviteQuery.getKey = (variables: GetInviteQueryVariables) => ['GetInvite', variables];
;

export const DeleteOneVidVoucherDocument = `
    mutation DeleteOneVidVoucher($where: VIDVoucherWhereUniqueInput!) {
  deleteOneVIDVoucher(where: $where) {
    id
    userId
    updatedAt
    status
    postbackUrl
    packageSetId
    organizationId
    orderId
    inviteId
    email
    createdAt
  }
}
    `;
export const useDeleteOneVidVoucherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOneVidVoucherMutation, TError, DeleteOneVidVoucherMutationVariables, TContext>) =>
    useMutation<DeleteOneVidVoucherMutation, TError, DeleteOneVidVoucherMutationVariables, TContext>(
      ['DeleteOneVidVoucher'],
      useFetchData<DeleteOneVidVoucherMutation, DeleteOneVidVoucherMutationVariables>(DeleteOneVidVoucherDocument),
      options
    );
export const CreateOneVidVoucherDocument = `
    mutation CreateOneVidVoucher($data: CreateOneVidVoucherInput!) {
  createOneVIDVoucher(data: $data) {
    inviteData {
      contactInformation {
        email
        phoneNumber
      }
    }
    inviteExpiry
    inviteId
    packageId
    packageName
    vIDInviteUrl
    vIDQRCode
    vIDShortCode
  }
}
    `;
export const useCreateOneVidVoucherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOneVidVoucherMutation, TError, CreateOneVidVoucherMutationVariables, TContext>) =>
    useMutation<CreateOneVidVoucherMutation, TError, CreateOneVidVoucherMutationVariables, TContext>(
      ['CreateOneVidVoucher'],
      useFetchData<CreateOneVidVoucherMutation, CreateOneVidVoucherMutationVariables>(CreateOneVidVoucherDocument),
      options
    );
export const CreateManyVidVoucherDocument = `
    mutation CreateManyVidVoucher($data: [CreateOneVidVoucherInput!]!) {
  createManyVIDVoucher(data: $data) {
    data {
      inviteId
      packageId
      packageName
      vIDInviteUrl
      vIDQRCode
      vIDShortCode
    }
    errors {
      error
      email
    }
  }
}
    `;
export const useCreateManyVidVoucherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateManyVidVoucherMutation, TError, CreateManyVidVoucherMutationVariables, TContext>) =>
    useMutation<CreateManyVidVoucherMutation, TError, CreateManyVidVoucherMutationVariables, TContext>(
      ['CreateManyVidVoucher'],
      useFetchData<CreateManyVidVoucherMutation, CreateManyVidVoucherMutationVariables>(CreateManyVidVoucherDocument),
      options
    );
export const UpdateOneVidVoucherDocument = `
    mutation UpdateOneVIDVoucher($data: VIDVoucherUpdateInput!, $where: VIDVoucherWhereUniqueInput!) {
  updateOneVIDVoucher(data: $data, where: $where) {
    id
  }
}
    `;
export const useUpdateOneVidVoucherMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOneVidVoucherMutation, TError, UpdateOneVidVoucherMutationVariables, TContext>) =>
    useMutation<UpdateOneVidVoucherMutation, TError, UpdateOneVidVoucherMutationVariables, TContext>(
      ['UpdateOneVIDVoucher'],
      useFetchData<UpdateOneVidVoucherMutation, UpdateOneVidVoucherMutationVariables>(UpdateOneVidVoucherDocument),
      options
    );
export const GetVoucherStatusDocument = `
    query GetVoucherStatus($voucherId: String!) {
  getVoucherStatus(voucherId: $voucherId) {
    id
    onSubmitReturnUrl
    status
  }
}
    `;
export const useGetVoucherStatusQuery = <
      TData = GetVoucherStatusQuery,
      TError = unknown
    >(
      variables: GetVoucherStatusQueryVariables,
      options?: UseQueryOptions<GetVoucherStatusQuery, TError, TData>
    ) =>
    useQuery<GetVoucherStatusQuery, TError, TData>(
      ['GetVoucherStatus', variables],
      useFetchData<GetVoucherStatusQuery, GetVoucherStatusQueryVariables>(GetVoucherStatusDocument).bind(null, variables),
      options
    );
useGetVoucherStatusQuery.document = GetVoucherStatusDocument;


useGetVoucherStatusQuery.getKey = (variables: GetVoucherStatusQueryVariables) => ['GetVoucherStatus', variables];
;

export const JobDocument = `
    query Job($where: JobWhereUniqueInput!) {
  job(where: $where) {
    id
    payload
    result
    lastError
  }
}
    `;
export const useJobQuery = <
      TData = JobQuery,
      TError = unknown
    >(
      variables: JobQueryVariables,
      options?: UseQueryOptions<JobQuery, TError, TData>
    ) =>
    useQuery<JobQuery, TError, TData>(
      ['Job', variables],
      useFetchData<JobQuery, JobQueryVariables>(JobDocument).bind(null, variables),
      options
    );
useJobQuery.document = JobDocument;


useJobQuery.getKey = (variables: JobQueryVariables) => ['Job', variables];
;
